import { Component, OnInit, Inject, ElementRef, Input, ViewChild, HostListener, ViewChildren, QueryList, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { StoredService } from 'src/app/services/stored';
import { AppConfig } from 'src/app/app.config';
// import * as XLSX from "xlsx";
import { AppConstants } from 'src/app/constants/AppConstants';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { CdkDrag, CdkDragDrop, DragDropModule, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Toast, ToastrService } from 'ngx-toastr';
import {MatSelectModule} from '@angular/material/select';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PrintService } from '../services/print.service';
import { VoiceRecognitionService } from '../service/voice-recognition.service';
import { DoCheck, KeyValueDiffers, KeyValueDiffer } from '@angular/core';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Clipboard } from '@angular/cdk/clipboard';
import { jsPDF } from "jspdf";
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import * as html2pdf from 'html2pdf.js';

import Swal from 'sweetalert2'
import { MatSnackBar } from '@angular/material/snack-bar';
import Speech from 'speak-tts';
declare var require: any
const nisPackage = require("../../../package.json");
import { PubNubAngular } from 'pubnub-angular2';
import * as $ from 'jquery';
import * as moment from 'moment';
//import intlTelInput from 'intl-tel-input';
//import 'intl-tel-input/build/css/intlTelInput.css'
import { iif,Observable} from 'rxjs';
import { map,startWith} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common'
import 'round-slider';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { emit } from 'process';
import * as Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
addMore(Highcharts)
declare let helper: any; //declare helper

//vaccination imports

import domtoimage from 'dom-to-image';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { MatTableDataSource } from '@angular/material/table';
import { filter } from 'd3';
// import { timeStamp } from 'console';

declare const onStartClick: any;
declare const onStopClick: any;
declare const onWindowLoad: any;

//onWindowLoad
declare const UIBtnCmdsHandler: any;

///UIBtnCmdsHandler
declare const authKey: any;


export interface DialogDatapara {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDatapara2 {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataAbortion {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataAbortion2 {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDatalmpmissingpopup {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDatariskhistory {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataAddcurrentpregRecords {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataAddscanreport {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataAddfolliclestudy {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataviewarchivedcpRecords {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}
export interface DialogData_bottomobstgnec {
  patientDetails: any,
  openFrom: number
}

export interface DialogDataclearlmpeddaddDeatils {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataviewarchivedcpRisk {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataviewarchivedcpscan {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogDataviewarchivedfollicle {
  name: string,
  mode: number,
  index: number,
  obj,
  id
}

export interface DialogData {
  name: string,
  mode: number,
  index: number,
  obj,
  id,
  muted
}

export interface vitalGlucometeData {
  Vital_history: any;
  key: any;
}

export interface DialogData2 {
  option: number
}

export interface DialogData_upload {
  name: string
}

export interface DialogData_labtest {
  name: string,
  obj: any
}

export interface DialogData_vaccination {
  name: string,
  obj: any,
  nextvaccine: any,
  params_vaccinelist: any,
  token: any
}

export interface DialogData_Print {
  query: object
}

export interface DialogData_template {
  details: object,
  doctor_id,
  patient_email,
  account_email,
  token
}

export interface DialogData_notifier {
  name: String,
}

export interface DialogData_notifyvideocall {
  msg: String,
  notify_details: any;
  open_callType: number
  allow: any
}

export interface DialogData_bottomdatas {
  patientDetails: any,
  abhaDetails: any
}

export interface DialogData_vaccinationdatas {
  vaccineDetails: any,
}

export interface DialogData_labreport {
  patientDetails: any,
  filter_type: any
}

export interface DialogData_payment {
  data: any,
}

export interface DialogData_paymentsheet {
  patient: any,
  dmail: any,
  email: any,
  token: any,
  doc_id: any
}

export interface DialogData_listTemp {
  templates: any,
}
export interface DialogOverviewQRcodeScan_data {
  data: any,
}

export interface DialogData_selectTemp {
  templates: any,
  consultTemplates: any,
  freqConsultTemplates: any,
  catetemplates: any;
  freqprintTemplate: any;
  freqcerificateTemplate: any;
}
export interface DialogData_printTemp {
  printtemplates: any,
}

export interface DialogData_getName {
  block: any,
  text: any
}

export interface DialogData_growth {
  patient: any,
  dmail: any,
  email: any,
  token: any,
  doc_id: any,
  id: any
}

export interface DialogData_invoice {
  data: any,
  name: String,
  mrn: String,
  urlstatus: number
}

export interface DialogData_confirm {
  name: String,
  type: any
}

export interface DialogData_print {
  email: any;
  temps: any;
  status:any;
}

export interface DialogData_slider {
  value: any;
  mode:any;
  status:any;
}

export interface DialogData_frequency {
  value: any
}

export interface DialogData_cartdrugs {
  drugs: any,
}
export interface DialogData_cartitems {
  drugs: any,
  cost:any,
}
export interface DialogData_cartid {
  id: any,
}

export interface DialogData_attachment_edit {
  overview_id: any,
  lab_tests: any,
  date: any,
  obj: any,
  title: any,
  edit: any,
  category: any,
  comments: any,
  description: any,
  filename: any,
  test_taken_on: any
}

export interface DialogData_attachment {
  obj: any,
  title: any,
  edit: any

}

export interface DialogData_attachment2 {
  overview_id: any,
  lab_tests: any,
  date: any,
  obj: any,
  title: any,
  edit: any,
  category: any
}

export interface DialogData_drugType {
  type: any,
  total: any,
  durationAlone: any,
  fullFreq: any,
  showUnits: any
}

export interface DialogData_follow_book {
  type: any,
  balance: any,
  date: any,
  demail: any,
  id: any,
  token: any,
  email: any,
  amount: any,
  paidType: any
}


export interface PatientHistory {
  viewmilestonepatienthistory: Array<Object>
}


export interface DialogData_postvitals {
  id: any,
  token: any,
  allowedLimits: any
}

export interface DialogData_growthdetail {
  chartData: any,
  id: any,

}
export interface DialogData_growthcopyurl {
  copyfileName: any,


}

export interface DialogData_icons2 {
  formulation: any,
  create: any
}
export interface configDrugPopup{
  name:any,
  create: any
}
export interface alertMessagePopup{
  name:any,
  create: any,
  dropDownAlert:any,
  product:any,
}
export interface alertConfirmMessagePopup{
  name:any,
  create: any,
  dropDownAlert:any,
  product:any,
}

export interface vitalListElement {
  time: any;
  position: number;
  weight: number;
  height: number;
  bmi: number;
  head: number;
  temperature: number;
  heart: number;
  respiratory: number;
  bp_systolic: number;
  bp_diastolic: number;
  spo2: number;
  gulcometer: number;
}

let ELEMENT_DATA: vitalListElement[] = [];

//DialogData_frequency DialogData_icons2

@Component({
  selector: 'app-chief-complaint',
  templateUrl: './chief-complaint.component.html',
  styleUrls: ['./chief-complaint.component.scss']
})
export class ChiefComplaintComponent implements OnInit {
  @ViewChild('if1') iframe1: ElementRef;
  @ViewChild('cc_item') cc_item: ElementRef;
  @ViewChild('ex_item') ex_item: ElementRef;
  @ViewChild('diag_item') diag_item: ElementRef;
  @ViewChild('inv_item') inv_item: ElementRef;
  @ViewChild('pres_item') pres_item: ElementRef;
  @ViewChild('adv_item') adv_item: ElementRef;
  @ViewChild('menu_item1') menu_item1: ElementRef;
  @ViewChild('menu_item2') menu_item2: ElementRef;
  @ViewChild('menu_item3') menu_item3: ElementRef;
  @ViewChild('menu_item4') menu_item4: ElementRef;
  @ViewChild('menu_item5') menu_item5: ElementRef;
  @ViewChild('menu_item6') menu_item6: ElementRef;
  @ViewChild('menu_item7') menu_item7: ElementRef;
  @ViewChild('menu_item8') menu_item8: ElementRef;



  @Output() someEvent_full = new EventEmitter<any>();
  @Output() startStatus = new EventEmitter<any>();
  @Output() receivemsg = new EventEmitter<any>();
  @Output() emergencyIndication = new EventEmitter<any>();


  @Input() appindex: any;
  @Input() selecteddate: any;
  @Input() queueList: any;
  @Input() update: any;
  @Output() someEvent_print = new EventEmitter<Boolean>();




  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }

  templates;
  // profileForm;
  obstetricHistory;
  profiledata;
  send_cred;
  imageurl;
  adminster;
  vaccination_list;
  submitted = false;
  files

  pending = 0;

  alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Space', 'Backspace']

  chief_complaints = [];
  examination = []
  diagnosis = [];
  investigations = [];
  prescriptions = [];
  advice = [];
  labtest = [];
  labReportList = [];
  actualdata = [];
  newAttachment = [];
  deffer_vaccine = [];
  defferedlist = [];
  token_name;

  chief_complaints2 = [];

  cc_copy;
  ex_copy;
  diag_copy;
  inv_copy;
  pres_copy;
  adv_copy;
  closedlength;
  eshop_enabled;
  cc_copy1;
  ex_copy1;
  diag_copy1;
  inv_copy1;
  pres_copy1;
  adv_copy1;

  cc_copy2;

  cc_selected = [];
  ex_selected = [];
  diag_selected = [];
  inv_selected = [];
  pres_selected = [];
  adv_selected = [];
  emergency_indication = false;

  cc_selected_copy = [];
  ex_selected_copy = [];
  diag_selected_copy = [];
  inv_selected_copy = [];
  pres_selected_copy = [];
  adv_selected_copy = [];

  pres_selected_soap = [];

  pres_selected_cm = [];

  pres_selected1 = [];

  temp;

  ccForm;
  exForm;
  diagForm;
  invForm;
  presForm;
  advForm;

  senderData;

  show_block;

  cc_toggle = 'tags';
  diag_toggle = 'tags'
  ex_toggle = 'tags'
  inv_toggle = 'tags'
  pres_toggle = 'tags'
  adv_toggle = 'tags'

  cc_keyboard = true;
  diag_keyboard = true;
  ex_keyboard = true;
  inv_keyboard = true;
  pres_keyboard = true;
  adv_keyboard = true;
  labArray = []
  tempOpen = false

  searchModel: string;

  config = AppConfig.settings;
  constants = AppConfig.constants;
  urlPoints: any;
  params;
  tags;
  tags1;
  arrivalStatus = null;

  chars1 = '';
  chars2 = '';
  chars3 = '';
  chars4 = '';
  chars5 = '';
  chars6 = '';

  chars1Arr = []
  chars2Arr = []
  chars3Arr = []
  chars4Arr = []
  chars5Arr = []
  chars6Arr = []


  ids_cc = [];
  ids_ex = [];
  ids_string_cc;
  ids_string_ex;
  ids;
  ids_diag = [];
  timeoutHandler;
  matMenuTimer: any;

  medication;

  current_patient_mr_number;
  current_patient_name;
  current_patient_token;
  estimated_time;
  next_patient_mr_number;
  next_patient_name;
  next_patient_token;
  patients_consulted;
  patients_waiting;
  list: any;
  isDisabled = true;
  vaccinecalendar;
  Labreports;
  patient;
  mrn;
  uploaded_image;

  payment;
  graph1;
  graph2;
  graph3;
  graph4;
  graph5;
  graph6;
  graph7;
  graph8;
  graph9;
  graph10;
  attachments = []
  option;
  sub;
  id;
  doc_id;
  hospital;
  gender;
  vitals;
  vitalsData;
  month;
  hdata = [];
  wdata = [];
  bmidata = [];
  hcdata = [];
  y;
  m;
  actual_image;
  follow_option;
  follow_text = '';
  follow_text1 = '';
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;

  nisVersion = nisPackage.dependencies["ngx-infinite-scroll"];
  isFullListDisplayed: boolean = false;
  mode;

  cc_pages;
  cc_page = 1;
  cc_data = [];

  full = true;

  ex_pages;
  ex_page = 1;
  ex_data = [];

  diag_pages;
  diag_page = 1;
  diag_data = [];

  inv_pages;
  inv_page = 1;
  inv_data = [];

  pres_pages;
  pres_page = 1;
  pres_data = [];

  adv_pages;
  adv_page = 1;
  adv_data = [];

  status;
  appointment_id;
  apptData;
  preview_id;
  docData;
  patientEmail;
  fDate = '';
  fDate2 = ''
  preview = "Update Consultation";
  call;
  token;
  minutes;
  seconds;
  countdown;

  consultation;
  vaccination;
  voice_call;
  video_call;
  settingsData;
  paidType = 'paid';
  cartItems = [];
  eShop;

  prescription_id;
  pres_entries = [];
  pres_count = 0;
  started = false;
  searchTxt;

  imgURL = 'assets/avatar-male.png';
  queueImg = [];
  helVital;
  printDisabled = false;
  dmail;
  callprintprespopup = false;
  currentProjectUrl;

  printArr = [];
  complaint_id;
  cc_issues = [];
  supported;
  order = ['profile', 'milestones', 'lab reports', 'history', 'payments', 'paediatric']

  differ: KeyValueDiffer<string, any>;
  preview_type = 1;

  default_template = true;
  soap_template = false;

  html = '';
  result = '';
  speech: any;
  speechData: any;
  selectedTemplate;
  pres_selected_copy1 = [];

  movies = [{
    name: 'A',
    isDisable: true
  }, {
    name: 'B',
    isDisable: true
  }, {
    name: 'C',
    isDisable: true
  }, {
    name: 'D',
    isDisable: true
  }, {
    name: 'E',
    isDisable: true
  }, {
    name: 'F',
    isDisable: true
  },
  {
    name: 'G',
    isDisable: true
  }
  ];

  sidebar;
  main;

  cc_arr = [];
  ex_arr = [];
  diag_arr = [];
  inv_arr = [];
  pres_arr = [];
  adv_arr = [];

  ex_names = ''
  diag_names = ''

  counter_params;
  failure = false;
  payment_modules = [];
  balance;
  payment_response;
  event;
  add = false;
  cc_user;

  chars1_copy;
  chars2_copy;
  chars3_copy;
  chars4_copy;
  chars5_copy;
  chars6_copy;
  year;
  abc = 3;

  lmp_update = false

  date = moment(new Date()).format("DD-MM-YYYY");
  adv_names;
  inv_names;
  dob2;
  print_temps;
  new_cc_ids = [];
  new_cc_names = [];

  new_ex_ids = [];
  new_ex_names = [];

  new_diag_ids = [];
  new_diag_names = [];

  new_pres_names = [];
  new_pres_ids = [];

  new_inv_ids = [];
  new_inv_names = [];

  new_adv_ids = [];
  new_adv_names = [];
  mobile_access;
  arrived = false;
  docTemplates = [];
  selectedDocTemplate;
  pdfSrc = "https://api.epicare.net/PDF/MR5860_17_05_2021_10_13_06.pdf";
  date3;
  date4;
  pubnub: PubNubAngular;
  end = true
  osName
  //vacc code
  sos;
  vitalchage = false;
  isLoading = false;
  height;
  obslmp;
  obsedd;
  obsactualdelivery;
  obsgravida;
  obspara;
  obsabortion;
  obsgeneralnotes;
  highlightObs: any = true;
  highlightGynec: any;
  obslmp1;
  obsedd1;
  obspregrisk;
  obsgeneralnotes1;
  gyneclmp;
  amount;
  gynecdoe;
  gynecmenstrualhistory;
  gynecologyHistory: FormGroup;
  gynecmenstrualcomplaint;
  gynecnote;
  checkboxvalue = false
  @ViewChildren(CdkDrag) draggables: QueryList<CdkDrag>;
  obstetricHistorydata: any;
  obsresponse: any;
  templmp: any;
  tempactdel: any;
  tempedd: any;
  paradata: any;
  paraDetails: any;
  displaypatientname: any;
  currentpreg: any;
  currentpregdata: any;
  templmp1: any;
  tempedd1: any;
  todayriskdate: any;
  todayriskdatetemp: Date;
  latestcurrentpregDetails: any;
  viewcurrentpregRecords: any;
  viewscanreportfindingdata: any;
  viewfolliclestudydata: any;
  todaygynecentrytemp: Date;
  todaygynecentry: string;
  gynechistorydata: any;
  viewfgynechistorydata: any;
  checklist: any;
  masterSelected: Boolean;
  checkedList: any;
  viewcurrentpregRisk: any;
  masterSelected1: any;
  checkedList1: any[];
  masterSelected2: any;
  checkedList2: any[];
  emptygetscan: boolean;
  masterSelected3: any;
  checkedList3: any;
  setobseddminDate: any;
  eddfirstdate: Date;
  tempobseddminDate: string;
  eddlastdate: Date;
  nextscanfollowup: any;
  scancurrentdate: any;
  scannedondate: any;
  updatescanfindings: any;
  lmpmissing: boolean;
  gyneccomplaint: any;
  showpremenopausalcomp: boolean;
  riskstatusmodified: boolean = false;
  forprofileedd: any;
  obsactualminDate: any;
  obsactualmaxDate: any;
  noteVisible = true
  radioblock;
  radioValue;
  dayUnit = "1"
  muted = true;
  follow_days = '1';
  followRadio;
  held = false
  popupOpen = false
  wasMuted = true;
  frontdesk_pay;
  private dialogRef: MatDialogRef<DialogOverviewExampleDialog>;
  private dialogRef1: MatDialogRef<DialogOverviewExampleDialog>;

  observable;
  subscription;
  muteButton;
  selectedTemp;

  loadConsulprintTemplates = [];
  loadotherConsultTemplate = [];
  loadfreqConsultTemplates;
  loadfreqPrintTemplates = [];
  loadfreqCertificateTemplates = [];

  ICSscreen_load = true;
  custom_template = false;
  selected_temp_categoryId;
  selected_temp_Id;
  selected_temp_name;
  selected_cons_Temp_name;
  getdob = '';
  refletterform;
  mangal_header_Type = 1;

  refer_dr_name = '';
  refer_dr_spec = '';
  refer_dr_address = '';
  refer_hos_name = '';
  pat_diagonsis = '';
  pat_examination = '';
  fit_identification = '';
  fit_place = '';
  medLeave_dises = '';
  medLeave_days = '';
  adult_medLeave_disies = "";
  adult_medLeave_days = '';
  leave_start_date = moment(new Date()).format('YYYY-MM-DD');

  getdrName;
  getdrnum;
  getdrdegree;
  getdrspec;
  fittodayDate = moment(new Date()).format('DD-MM-YYYY');
  fitmaxDate = moment(new Date()).format('YYYY-MM-DD');
  fitminbackDate = moment(new Date()).format('YYYY-MM-DD');
  fitstartDate = moment(new Date()).format('YYYY-MM-DD');
  fitBack_date: any = moment(new Date()).format('YYYY-MM-DD');
  fit_imgURL = 'assets/avatar-male.png';

  follow_text_new = ''
  fullscrImgSrc = 'assets/fullscreen.png';

  fileSrc = 'assets/file.svg';
  fileSrcRed = 'assets/file_red.svg';

  opendstartConsultPopup = false;

  matMenuTimer1: any;
  matMenuTimer2: any;
  matMenuTimer3: any;
  matMenuTimer4: any;
  matMenuTimer5: any;
  matMenuTimer6: any;

  matMenuTimer_soap: any;

  highlight = false
  highlight_cc = false
  highlight_ex = false
  highlight_diag = false
  highlight_inv = false
  highlight_pres = false
  highlight_adv = false

  diameter = 150;
  angle = 45;
  viewmilestonepicdetails: any;
  viewmilestonepatienthistory: any;
  hidetimelinedata: any;

  diagLoaded = false
  invLoaded = false
  presLoaded = false
  advLoaded = false
  clear = false;
  patientListRecordId;
  ccDoubt = false
  exDoubt = false
  diagDoubt = false
  invDoubt = false
  presDoubt = false
  advDoubt = false
  setmilestonetype: any;
  temppush: any;
  type
  drugShowType = 1;
  displayTotal = true;
  attachments1 = []
  newAttachment1 = [];
  labLength;
  updateProfile = false
  durationAlone = false
  fullFreq = true;
  showUnits = false
  heart_rate;
  respiratory_rate;
  spo2;
  blood_pressure;
  weight;
  past_medical_hx = '';
  social_history = '';
  current_medication = '';
  pmhdata;
  shdata;
  cmdata;
  openAllergies = false;

  checkboxValues = [];

  allergyExists1;
  bmi;
  temperature;
  pres_copy_cm = [];

  pres_copy_cm1 = [];

  allergyTable = [];

  hpi = ''
  hpi2 = ''
  allergyClicked = false
  lab_ids = []
  medicineLoaded = false

  isPrinting = false;
  print_file_name;

  isShowfloat = false;

  current_videocall_patientDetails: any = { type: '', participant_connect_status: '', status: '' };
  joinbuttonStatus = false;
  senderDetails;
  sendermail;
  senderImage;
  chat_appt_id;

  changeVitals = false
  vitalOpened = false
  checkQRR = false

  bsa;
  apptStatus = 0;
  follow_text_week;
  speciality = Number(localStorage.getItem('speciality'))
  vitDate: any;
  weightdata: any;
  heightdata: any;
  bsidata: string;
  vitDatechange: any = [];
  storedSessonData: any=[];
  abhaDetails: any = {};
  abha = false;
  isButton1Filled = true;
  isButton2Filled = false;
  prescription_mode: any;
  toggle_alignment: any;


  ngAfterViewInit() {
    const arr = this.draggables.toArray();
    this.sidebar = [arr[0], arr[1], arr[2], arr[3], arr[4], arr[5], arr[6], arr[7]];
    this.main = [arr[3], arr[4]];
  }

  constructor(private fb: FormBuilder, pubnub: PubNubAngular, private appService: AppService, private storedService: StoredService, public dialog: MatDialog, private toastr: ToastrService, private dom: DomSanitizer, private route: ActivatedRoute, private router: Router, public printService: PrintService,
    public service: VoiceRecognitionService, private differs: KeyValueDiffers, public snackBar: MatSnackBar, public datepipe: DatePipe, private elRef: ElementRef, private _bottomSheet: MatBottomSheet) {
    //aug 24
    this.urlPoints = AppConfig.settings.EndPoints;
    this.pubnub = pubnub;

    this.differ = this.differs.find({}).create();
    this.speech = new Speech()

    if (this.speech.hasBrowserSupport()) {
      this.speech.init({
        'volume': 1,
        'lang': 'en-GB',
        'rate': 1,
        'pitch': 1,
        'voice': 'Google UK English Male',
        'splitSentences': true,
        'listeners': {
          'onvoiceschanged': (voices) => {
          }
        }
      }).then((data) => {
        this.speechData = data;
        data.voices.forEach(voice => {
        });
      }).catch(e => {
      })
    }

    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      if (this.getOS() != 'iOS' && this.getOS() != "Mac OS") {
        this.service.init();
        this.supported = true
      }
      else {
        this.supported = false
      }

    } else {
      this.supported = false
    }

    // this.profileForm = this.fb.group({
    //   Image: [""],
    //   Name: ["", [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
    //   DOB: ["", [Validators.required]],
    //   Weight: ["", [Validators.required, Validators.maxLength(4)]],
    //   Height: ["", [Validators.required, Validators.maxLength(4)]],
    //   fathername: ["", [Validators.minLength(3), Validators.maxLength(20)]],
    //   mothername: ["", [Validators.minLength(3), Validators.maxLength(20)]],
    //   gender: ["", [Validators.required]],
    //   fatherdob: [""],
    //   motherdob: [""],
    //   phonenumber: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(15)]],
    //   UHID: [""],
    //   alternatenumber: [""],
    //   Emailaddress: ["", [Validators.email]],
    //   street: [""],
    //   pincode: ["", [Validators.minLength(6), Validators.maxLength(6)]],
    //   city: [""],
    //   state: [""],
    // })

    this.obstetricHistory = this.fb.group({
      obslmps: [""],
      obsedds: [""],
      obsactualdeliverys: [""],
      obsgravidas: [""],
      obsparas: [""],
      obsabortions: [""],
      obsgeneralnotess: [""],
    })

    this.currentpreg = this.fb.group({
      obslmps1: [""],
      obsedds1: [""],
      obspregrisks: [""],
      displaypatientname1: [""],
      obsgeneralnotess1: [""],
    })

    this.gynecologyHistory = this.fb.group({
      gyneclmps: [""],
      gynecdoes: [""],
      gynecmenstrualhistorys: [""],
      gynecmenstrualcomplaints1: [""],
      gynecmenstrualcomplaints2: [""],
      gynecnotes: [""],
    })


    this.ccForm = this.fb.group({
      cc_name: ""
    })

    this.exForm = this.fb.group({
      ex_name: ""
    })

    this.diagForm = this.fb.group({
      diag_name: ""
    })

    this.invForm = this.fb.group({
      inv_name: ""
    })

    this.presForm = this.fb.group({
      pres_name: ""
    })

    this.advForm = this.fb.group({
      adv_name: ""
    })

    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      if (this.getOS() != 'iOS' && this.getOS() != "Mac OS") {
        this.service.init();
        this.supported = true
      }
      else {
        this.supported = false
      }

    } else {
      this.supported = false
    }


  }

  ngOnInit(): void {
    // this.sub = this.route.params.subscribe(params => {
    //   this.patientListRecordId = params['id'];
    // });
    // if (this.patientListRecordId != undefined) {
    //   this.loadICS(this.patientListRecordId);
    // } else {
    //   this.loadICS('');
    // }
    this.checkQRR = this.appService.fromQR;
    if (this.checkQRR){
      let qrData = this.appService.fromQRData;
      this.setArrival(null,qrData)
      this.changeStatus();  
    }
    this.pubnub1();
    this.checkMedicineLoaded();
    this.loadDrTempaltes();

    var payParams = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }


    this.appService.getData(this.urlPoints.getLoadStatus, payParams, this.token).subscribe((response: any) => {
    });

    this.appService.getData(this.urlPoints.getDefaultTemplate, payParams, this.token).subscribe((response: any) => {
      console.log(response)
      // this.doc_id == 5
      // rx483098@rxcarenet.org
      // if(this.doc_id == 1 && (this.dmail == 'rx483098@rxcarenet.org' || this.dmail == 'rx4@rxcarenet.org')){
       if((this.dmail == 'rx483098@rxcarenet.org' && this.doc_id == 1 ) ||( this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 5)){
        var temp_params = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          doctor_email: this.dmail
        }
    
        this.appService.getData(this.urlPoints.getPrintTemplate, temp_params, this.token).subscribe((response: any) => {
          console.log('getPrintTemplate:::',response)
          // for without header srinivas
          let getTempLocal = response.data.filter(e=>e.template_id == "858397");
          this.selected_temp_Id = getTempLocal[0].template_id;
          console.log("getTempLocal::",getTempLocal)
          this.selected_temp_name = getTempLocal[0].template_name;

        });
      }else if((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '4') || (this.dmail == 'rx389462@rxcarenet.org' && this.doc_id == '1')){
        var temp_params = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          doctor_email: this.dmail
        }
    
        this.appService.getData(this.urlPoints.getPrintTemplate, temp_params, this.token).subscribe((response: any) => {
          console.log('getPrintTemplate:::',response)
          // for without header prashanth
          let getTempLocal = response.data.filter(e=>e.template_id == "858179");
          this.selected_temp_Id = getTempLocal[0].template_id;
          console.log("getTempLocal::",getTempLocal)
          this.selected_temp_name = getTempLocal[0].template_name;

        });
      }else{
        this.selected_temp_Id = response.data[0].template_id;

        this.selected_temp_name = response.data[0].template_name;
      }
    });

    this.appService.getData(this.urlPoints.paymentSetting, payParams, this.token).subscribe((response: any) => {
      this.settingsData = response

      var filter = response.filter(res => res.module === "video_call_appointment_fee" && res.status == 1);
      if (filter.length > 0) {
        this.video_call = true;
        //  this.type = 'video_call'

      }

      var filter = response.filter(res => res.module === "voice_call_appointment_fee" && res.status == 1);
      if (filter.length > 0) {
        this.voice_call = true;
        //  this.type = 'voice_call'
      }

      var filter = response.filter(res => res.module === "vaccination" && res.status == 1);
      if (filter.length > 0) {
        this.vaccination = true;
        //  this.type = 'vaccination'

      }

      var filter = response.filter(res => res.module === "consultation" && res.status == 1);
      if (filter.length > 0) {
        this.consultation = true;
        //  this.type = 'consultation'
      }
    })
    this.callMasterSettings();

  }
callMasterSettings(){
  var params={
    account_email : this.dmail,
    doctor_id : this.doc_id
}
this.appService.getData(this.urlPoints.getMasterSettings, params, this.token).subscribe((masterData: any) =>{
  console.log("masterData::1",masterData)
  this.prescription_mode = masterData.data[0].prescription_mode
  this.toggle_alignment = masterData.data[0].toggle_alignment
})
}
  checkMedicineLoaded() {
    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getLoadStatus, params, this.token).subscribe((response: any) => {

      if (response.data.medicine_loaded == 1) {
        this.medicineLoaded = true
      }
      else {
        this.medicineLoaded = false
      }
    });
  }

  accordiantabs(tabIndex) {
    for (var i = 0; i < 7; i++) {
      const el = document.getElementsByClassName('topmenu')[i] as HTMLElement;
      el.style.borderTop = "0px solid #000000";
      el.style.color = "#2A2A2A";
    }
    document.getElementById('accordid_' + tabIndex).style.borderTop = "3px solid #0063ff";
    document.getElementById('accordid_' + tabIndex).style.color = "#0063ff";
  }

  loadICS(recordID) {

    let getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));

    this.dmail = getauthdetails.account_id;
    this.doc_id = getauthdetails.doctor_id;
    this.mode = 1;
    this.token = getauthdetails.token;
    this.id = recordID;
    this.labLength = undefined

    this.getRecord(this.id);
    //  this.updatevital();

    if (this.mode == 1) {
      this.status = "Walkin"
    }
    sessionStorage.apt_id = ""

    this.date3 = new Date().toISOString().slice(0, 10);

    this.date4 = this.date3;

    this.date3 = moment(new Date(this.date3)).add(1, 'days').format('YYYY-MM-DD');

    this.fDate = this.date3

    this.option = 0;

    // var input = document.querySelector("#phone");
    // intlTelInput(input, {
    //   initialCountry: "auto",
    //   geoIpLookup: function (success, failure) {
    //     $.get("https://ipinfo.io", function () { }, "jsonp").always(function (resp) {
    //       var countryCode = (resp && resp.country) ? resp.country : "in";
    //       success(countryCode);
    //     });
    //   },
    // });

    // var alt_input = document.querySelector("#alt_phone");
    // intlTelInput(alt_input, {
    //   initialCountry: "auto",
    //   geoIpLookup: function (success, failure) {
    //     $.get("https://ipinfo.io", function () { }, "jsonp").always(function (resp) {
    //       var countryCode = (resp && resp.country) ? resp.country : "in";
    //       success(countryCode);
    //     });
    //   },
    // });



    function readURL(input) {
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        var that = input;

        reader.onload = (e) => {
          $('#imagePreview').css('background-image', 'url(' + e.target.result + ')');
          that.actual_image = e.target.result;
          $('#imagePreview').hide();
          $('#imagePreview').fadeIn(650);
        }
        reader.readAsDataURL(input.files[0]);
      }
    }
    $("#imageUpload").change(function () {
      readURL(this);
    });

    this.getTagsList();
    this.getTagsList1();
    var token = this.token;
    this.getQueue(this.urlPoints.getQueue + this.dmail, token);

    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }
    //this.getList(this.urlPoints.getList, params, token)

    this.appService.getData(this.urlPoints.getDoctorProfile, params, token).subscribe((response: any) => {
      this.docData = response.doctors.profile;
      sessionStorage.setItem("hospitalname", response.doctors.profile.hospital_name);
    });

    var temp_params = {
      account_email: this.dmail,
      doctor_id: this.doc_id,
      doctor_email: this.dmail
    }

    this.appService.getData(this.urlPoints.getPrintTemplate, temp_params, token).subscribe((response: any) => {
      console.log('called')
      this.print_temps = response.data
    });

    var param1 = {
      account_email: this.dmail,
      doctor_id: this.doc_id,
      doctor_email: this.dmail,
    }

    this.appService.getData(this.urlPoints.getDocTemplate, param1, token).subscribe((response: any) => {
      this.docTemplates = response.data
    });
    this.muteButton = 'assets/mute.svg'
  }

  pubnub1() {
    var account_id = this.dmail
    var channel = account_id.replace('@', '_').replace('.org', '');
    var uuid = account_id
    var doctor_id = this.doc_id

    this.pubnub.init({
      publishKey: 'pub-c-c3cecd91-62bc-4365-b2d1-a6333576f17f',
      subscribeKey: 'sub-c-60c79014-12d7-11e8-b32f-5ea260837941',
      uuid: uuid
    });


    this.pubnub.subscribe({
      channels: [channel, 'get_banner_' + channel, 'videocall_' + channel + '_' + doctor_id, 'vital_criticalityscore_' + channel, 'voice_' + uuid + '_' + doctor_id, 'room_' + uuid + '_' + doctor_id],
      withPresence: true,
      triggerEvents: ['callback', 'message', 'presence']
    });

    this.pubnub.addListener({
      message: msg => {
        var params = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          status_type: this.appindex,
          in_date: moment(this.selecteddate).format("YYYY-MM-DD")
        }
        if (msg) {

          console.log('p1')

          var split_Channel_Name = msg.channel.split("_");
          if (split_Channel_Name[0] == 'videocall') {

          } else if (split_Channel_Name[0] == 'voice') {
            this.toastr.success(msg.message.message.mr_number + " : " + msg.message.message.status, '', {
              timeOut: 4500,
            });
          }
          else if (split_Channel_Name[0] == 'room') {
            this.toastr.success(msg.message.message, '', {
              timeOut: 4500,
            });
            this.receivemsg.next(true);
          }

          this.getList(this.urlPoints.getqueueList, params, this.token)
        }


      }
    })

    this.pubnub.getMessage([channel, 'get_banner_' + channel, 'videocall_' + channel + '_' + doctor_id, 'vital_criticalityscore_' + channel, 'voice_' + uuid + '_' + doctor_id, 'room_' + uuid + '_' + doctor_id], (msg) => {

    });

    this.pubnub.getStatus([channel, 'get_banner_' + channel, 'videocall_' + channel + '_' + doctor_id, 'vital_criticalityscore_' + channel, 'voice_' + uuid + '_' + doctor_id, 'room_' + uuid + '_' + doctor_id], (msg) => {
    });

    this.pubnub.getPresence([channel, 'get_banner_' + channel, 'videocall_' + channel + '_' + doctor_id, 'vital_criticalityscore_' + channel, 'voice_' + uuid + '_' + doctor_id, 'room_' + uuid + '_' + doctor_id], (msg) => {
    });
  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    this.osName = os

    return os;
  }

  toggleonclick(data) {
    if (data == 'obstetric') {
      this.highlightObs = true
      this.highlightGynec = false
    } else if (data == 'gynecology') {
      this.highlightGynec = true
      this.highlightObs = false
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  obslmpmaxDate = moment(new Date()).format('YYYY-MM-DD')
  obseddminDate = moment(new Date()).format('YYYY-MM-DD')
  obseddmaxDate = moment(new Date()).add(300, 'days').format('YYYY-MM-DD')

  getEdd() {
    this.lmpmissing = false
    this.obstetricHistorydata = this.obstetricHistory.value
    this.setobseddminDate = moment(this.obstetricHistorydata.obslmps).add(280, 'days').format('YYYY-MM-DD')
    this.obseddmaxDate = moment(this.obstetricHistorydata.obslmps).add(300, 'days').format('YYYY-MM-DD')
    this.tempobseddminDate = this.datepipe.transform(this.setobseddminDate, 'yyyy-MM-dd');
    this.obstetricHistory.controls['obsedds'].setValue(this.tempobseddminDate);
    this.obsactualminDate = moment(this.obstetricHistorydata.obslmps).add(280, 'days').subtract(5, 'months')
    this.obsactualmaxDate = moment(this.obstetricHistorydata.obslmps).add(1, 'years').subtract(1, 'days')
  }

  clearallobsgynec() {
    this.obstetricHistory.controls['obslmps'].setValue("");
    this.obstetricHistory.controls['obsedds'].setValue("");
    this.obstetricHistory.controls['obsactualdeliverys'].setValue("");
    this.obstetricHistory.controls['obsgravidas'].setValue("");
    this.obstetricHistory.controls['obsparas'].setValue("")
    this.obstetricHistory.controls['obsabortions'].setValue("");
    this.obstetricHistory.controls['obsgeneralnotess'].setValue("");
    this.currentpreg.controls['obsgeneralnotess1'].setValue("");
    this.gynecologyHistory.controls['gyneclmps'].setValue("");
    this.gynecologyHistory.controls['gynecmenstrualcomplaints1'].setValue("");
    this.gynecologyHistory.controls['gynecmenstrualcomplaints2'].setValue("");
    this.gynecologyHistory.controls['gynecmenstrualhistorys'].setValue("");
    this.gynecologyHistory.controls['gynecnotes'].setValue("");
  }


  changeEdd() {
    this.obstetricHistorydata = this.obstetricHistory.value
    this.eddfirstdate = new Date(this.tempobseddminDate)
    var dd: any = this.eddfirstdate.getDate();
    var mm: any = this.eddfirstdate.getMonth() + 1;
    var yy: any = this.eddfirstdate.getFullYear();
    this.eddlastdate = new Date(this.obstetricHistorydata.obsedds)
    var dd1: any = this.eddlastdate.getDate();
    var mm1: any = this.eddlastdate.getMonth() + 1;
    var yy1: any = this.eddlastdate.getFullYear();
    if (parseInt(yy) <= parseInt(yy1)) {
      if (parseInt(yy) < parseInt(yy1)) {
        this.toastr.error("Date is greater than LMP+280 days")
      } else if (parseInt(yy) == parseInt(yy1)) {
        if (parseInt(mm) <= parseInt(mm1)) {
          if (parseInt(mm) < parseInt(mm1)) {
            this.toastr.error("Date is greater than LMP+280 days")
          } else if (parseInt(mm) == parseInt(mm1)) {
            if (parseInt(dd) < parseInt(dd1)) {
              this.toastr.error("Date is greater than LMP+280 days")
            }
          }
        }
      }
    }
  }

  preventInput(event) {
    let value = this.obspara;
    if (value > 10) {
      if (value <= 99) {
        event.preventDefault()
        this.obspara = parseInt(value.toString().substring(0, 1));
      } else if (value > 99) {
        event.preventDefault()
        this.obspara = parseInt(value.toString().substring(0, 2));
      }
    }
  }

  preventInput1(event) {
    let value = this.obsabortion;
    if (value > 10) {
      if (value <= 99) {
        event.preventDefault()
        this.obsabortion = parseInt(value.toString().substring(0, 1));
      } else if (value > 99) {
        event.preventDefault()
        this.obsabortion = parseInt(value.toString().substring(0, 2));
      }
    }
  }

  updatevital() {
    this.vitalchage = !this.vitalchage;
    this.getVitalData();
  }

  addabortpara() {
    this.obsgravida = this.obspara + this.obsabortion
  }

  openAllergies1() {

    this.allergyClicked = true

    this.openAllergies = !this.openAllergies

  }

  save_obshistory() {
    this.obstetricHistorydata = this.obstetricHistory.value
    let data = {
      "account_email": this.dmail,
      "lmp": this.obstetricHistorydata.obslmps ? this.obstetricHistorydata.obslmps : "",
      "expected_delivery": this.obstetricHistorydata.obsedds ? this.obstetricHistorydata.obsedds : "",
      "actual_delivery": this.obstetricHistorydata.obsactualdeliverys ? this.obstetricHistorydata.obsactualdeliverys : "",
      "gravida": this.obstetricHistorydata.obsgravidas ? this.obstetricHistorydata.obsgravidas : "0",
      "para": this.obstetricHistorydata.obsparas ? this.obstetricHistorydata.obsparas : "0",
      "abortions": this.obstetricHistorydata.obsabortions ? this.obstetricHistorydata.obsabortions : "0",
      "notes": this.obstetricHistorydata.obsgeneralnotess ? this.obstetricHistorydata.obsgeneralnotess : "",
      "patient_email": this.patient.record_info.Record.account_email,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.createobsthistory, data, this.token).subscribe((response: any) => {
      this.toastr.success(response.message)
      this.get_obsthistory()
    });

  }

  get_obsthistory() {
    let data = {
      "account_email": this.dmail,
      "patient_email": this.patient.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.getobsthistory, data, this.token).subscribe((response: any) => {
      if (response.data.length > 0) {
        this.templmp = response.data[0].lmp.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestlmp = this.datepipe.transform(this.templmp, 'yyyy-MM-dd');
        this.obstetricHistory.controls['obslmps'].setValue(latestlmp);

        this.tempedd = response.data[0].expected_delivery.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestedd = this.datepipe.transform(this.tempedd, 'yyyy-MM-dd');
        this.obstetricHistory.controls['obsedds'].setValue(latestedd);
        this.appService.sendObsteddData(response.data[0].expected_delivery);

        this.tempactdel = response.data[0].actual_delivery.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestactdel = this.datepipe.transform(this.tempactdel, 'yyyy-MM-dd');
        this.obstetricHistory.controls['obsactualdeliverys'].setValue(latestactdel);

        this.obstetricHistory.controls['obsgravidas'].setValue(response.data[0].gravida);
        this.obstetricHistory.controls['obsparas'].setValue(response.data[0].para);
        this.obstetricHistory.controls['obsabortions'].setValue(response.data[0].abortions);
        this.obstetricHistory.controls['obsgeneralnotess'].setValue(response.data[0].notes);
      } else {
        this.obstetricHistory.controls['obslmps'].setValue("");
        this.obstetricHistory.controls['obsedds'].setValue("");
        this.obstetricHistory.controls['obsactualdeliverys'].setValue("");
        this.obstetricHistory.controls['obsgravidas'].setValue("");
        this.obstetricHistory.controls['obsparas'].setValue("")
        this.obstetricHistory.controls['obsabortions'].setValue("");
        this.obstetricHistory.controls['obsgeneralnotess'].setValue("");
      }


      this.lmp_update = !this.lmp_update
    });
  }

  validateobst() {
    this.obstetricHistorydata = this.obstetricHistory.value
    this.lmp_update = !this.lmp_update
    if (this.obstetricHistorydata.obslmps) {
      this.save_obshistory()
    } else {
      this.lmpmissing = true
      this.openaddlmpmissingpopup()
    }
  }

  save_currentpregnancydetails() {
    this.currentpregdata = this.currentpreg.value
    let data = {
      "account_email": this.dmail,
      "lmp": this.currentpregdata.obslmps1 ? this.currentpregdata.obslmps1 : "",
      "expected_delivery": this.currentpregdata.obsedds1 ? this.currentpregdata.obsedds1 : "",
      "obst_history": this.currentpregdata.obsgeneralnotess1 ? this.currentpregdata.obsgeneralnotess1 : "",
      "patient_email": this.patient.record_info.Record.account_email,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.createcurrentpregnancy, data, this.token).subscribe((response: any) => {
      if (response.status == 1) {
        this.toastr.success(response.message)
      } else {
        this.toastr.error("Unable to save data")
      }
    });
  }

  get_currentpregnancy() {
    this.displaypatientname = this.patient.record_info.Record.label
    let data = {
      "account_email": this.dmail,
      "patient_email": this.patient.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.getcurrentpregnancy, data, this.token).subscribe((response: any) => {
      if (response.data.length > 0) {
        this.templmp1 = response.data[0].lmp.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestlmp1 = this.datepipe.transform(this.templmp1, 'yyyy-MM-dd');
        this.currentpreg.controls['obslmps1'].setValue(latestlmp1);

        this.tempedd1 = response.data[0].edd.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestedd1 = this.datepipe.transform(this.tempedd1, 'yyyy-MM-dd');
        this.currentpreg.controls['obsedds1'].setValue(latestedd1);

        this.currentpreg.controls['obsgeneralnotess1'].setValue(response.data[0].obst_history);
      } else {
        this.currentpreg.controls['obsgeneralnotess1'].setValue("");
      }

    });
  }

  riskstatusmodifiedfunc() {
    this.riskstatusmodified = true
  }

  save_currentpregnancyRiskdetails() {
    if (this.riskstatusmodified == true) {
      this.todayriskdatetemp = new Date()
      this.todayriskdate = this.datepipe.transform(this.todayriskdatetemp, 'yyyy-MM-dd');
      let data = {
        "account_email": this.dmail,
        "date": this.todayriskdate,
        "risk_from": this.latestcurrentpregDetails ? this.latestcurrentpregDetails : "",
        "risk_to": this.currentpregdata.obspregrisks,
        "patient_email": this.patient.record_info.Record.account_email,
        "doctor_id": this.doc_id
      }
      this.appService.postData(this.urlPoints.createrisk, data, this.token).subscribe((response: any) => {
        if (response.status == 1) {
          this.toastr.success(response.message)
          this.get_currentpregnancyRiskdetails()
        } else if (response.status == 0) {
          this.toastr.error("Pregnancy Risk can be changed just once per day")
        }
      });
      this.riskstatusmodified = false;
    } else {
    }

  }

  get_currentpregnancyRiskdetails() {
    let data = {
      "account_email": this.dmail,
      "patient_email": this.patient.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.getrisk, data, this.token).subscribe((response: any) => {

      this.currentpreg.controls['obspregrisks'].setValue(response.data[0].risk_to);
      this.latestcurrentpregDetails = response.data[0].risk_to
      this.appService.sendCpRiskData(response.data[0].risk_to);
      this.viewcurrentpregRisk = response.data
      this.viewcurrentpregRisk.forEach(function (value) {
        value.isSelected = false
      })
    });
  }

  get_currentpregnancyRecords() {
    let data = {
      "account_email": this.dmail,
      "patient_email": this.patient.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.getpregnancyrecord, data, this.token).subscribe((response: any) => {
      this.viewcurrentpregRecords = response.data
      this.viewcurrentpregRecords.forEach(function (value) {
        value.isSelected = false
      })
      this.getCheckedItemList();
    });

  }

  get_scanreportfindingdata() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "doctor_id": this.doc_id
    }
    this.appService.getData(this.urlPoints.getusscanreport, data, this.token).subscribe((response: any) => {
      this.viewscanreportfindingdata = response.data
      if (response.data == "no scan reports found") {
        this.emptygetscan = true
      } else {
        this.emptygetscan = false
        this.viewscanreportfindingdata = response.data
        this.viewscanreportfindingdata.forEach(function (value) {
          value.isSelected = false
          value.isScanSelected = false
        })
        this.getCheckedItemList2();
      }
    });

  }

  togglescanfollowup(data) {
  }

  enablescandetail(temp) {
    if (parseInt(temp) == parseInt(sessionStorage.createscanid)) {
      return false;
    } else {
      return true;
    }
  }

  setfollowupdate(position, nextscandate, date, scandate, scanfindings, checkboxvalue) {
    this.checkboxvalue = !checkboxvalue
    this.nextscanfollowup = nextscandate.split("-").reverse().join("-")

    this.scancurrentdate = date
    this.scannedondate = scandate
    this.updatescanfindings = scanfindings
  }

  changeChars(event) {

    if (this.show_block == 'cc') {
      this.chars1 = event

      this.chars1Arr = this.chars1.split('')

      this.cc_page = 1
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars1.toUpperCase().trim(),
        "doctor_id": this.doc_id
      }

      this.getCC(this.urlPoints.getCC, params, this.token)

      this.appService.getSample().subscribe((response: any) => {
      });

      if (this.chars1 == '')
        this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)

    }

    if (this.show_block == 'ex') {
      this.chars2 = event
      this.chars2Arr = this.chars2.split('')

      this.ex_page = 1

      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars2.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getEx(this.urlPoints.getEx, params, this.token)

      if (this.chars2 == '')
        this.getExCounter(this.urlPoints.getExCounter, this.counter_params, this.token)


    }

    if (this.show_block == 'diag' && this.diag_toggle == 'alp') {
      this.chars3 = event
      this.chars3Arr = this.chars3.split('')

      this.diag_page = 1

      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars3.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getDiag(this.urlPoints.getDiag, params, this.token)

      if (this.chars3 == '')
        this.getDiagCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)

    }

    if (this.show_block == 'inv' && this.inv_toggle == 'alp') {
      this.chars4 = event
      this.chars4Arr = this.chars4.split('')

      this.inv_page = 1

      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars4.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getInv(this.urlPoints.getInv, params, this.token)

      if (this.chars4 == '')
        this.getInvCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)

    }

    if (this.show_block == 'pres' && this.pres_toggle == 'alp') {
      this.chars5 = event
      this.chars5Arr = this.chars5.split('')

      this.pres_page = 1

      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars5.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getPres(this.urlPoints.getPres, params, this.token)

      if (this.chars5 == '')
        this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

    }

    if (this.show_block == 'adv' && this.adv_toggle == 'alp') {
      this.chars6 = event
      this.chars6Arr = this.chars6.split('')

      this.adv_page = 1

      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars6.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getAdv(this.urlPoints.getAdv, params, this.token)

      if (this.chars6 == '')
        this.getAdvCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)

    }
  }

  updatescanreport() {
    if (this.checkboxvalue == true) {
      if (sessionStorage.apt_id) {

        var scandate = this.scannedondate.split("-").reverse().join("-")
        var nextscandate = this.nextscanfollowup
        this.follow_text = this.nextscanfollowup
        var todayscandate = this.scancurrentdate.split("-").reverse().join("-")

        var data = {
          "patient_email": sessionStorage.patientemail,
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "scan_date": scandate,
          "scan_findings": this.updatescanfindings,
          "next_scan_date": nextscandate,
          "date": todayscandate,
          "appointment_id": sessionStorage.apt_id,
          "follow_up": "1"
        }
        this.save_add()
        this.appService.postData(this.urlPoints.createusscanreport, data, this.token).subscribe((response: any) => {
          if (response.status == 0) {
            this.toastr.error(response.error)
          } else if (response.status == 1) {
            this.toastr.success(response.message)
          }
          this.enablescandetail1()
          sessionStorage.removeItem("createscanid")
          this.get_scanreportfindingdata();
        });

      } else {
        this.openaddalertscanfollowup();
      }
    } else if (this.checkboxvalue == false) {
      return
    }
  }

  enablescandetail1() {
    return true
  }

  togglemenstrualcomplaint() {
    this.gynechistorydata = this.gynecologyHistory.value
    if (this.gynechistorydata.gynecmenstrualhistorys == "premenopausal") {
      this.showpremenopausalcomp = true
    } else if (this.gynechistorydata.gynecmenstrualhistorys == "postmenopausal") {
      this.showpremenopausalcomp = false
    }
  }

  gyneclmpmaxDate = moment(new Date()).format('YYYY-MM-DD')
  save_gynecologyhistory() {
    this.gynechistorydata = this.gynecologyHistory.value
    if (this.gynechistorydata.gynecmenstrualcomplaints1) {
      this.gyneccomplaint = this.gynechistorydata.gynecmenstrualcomplaints1
    }
    if (this.gynechistorydata.gynecmenstrualcomplaints2) {
      this.gyneccomplaint = this.gynechistorydata.gynecmenstrualcomplaints2
    }
    let data = {
      "account_email": this.dmail,
      "complaint": this.gyneccomplaint ? this.gyneccomplaint : "",
      "date": this.gynechistorydata.gynecdoes ? this.gynechistorydata.gynecdoes : "",
      "lmp": this.gynechistorydata.gyneclmps ? this.gynechistorydata.gyneclmps : "",
      "mensural_history": this.gynechistorydata.gynecmenstrualhistorys ? this.gynechistorydata.gynecmenstrualhistorys : "",
      "notes": this.gynechistorydata.gynecnotes ? this.gynechistorydata.gynecnotes : "",
      "patient_email": this.patient.record_info.Record.account_email,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.creategynaehistory, data, this.token).subscribe((response: any) => {
      if (response.status == 1) {
        this.toastr.success(response.message)
      } else {
        this.toastr.error("Unable to save data")
      }
      // this.gynechistorydata = ""
      this.get_gynecologydetails()
    });
  }

  get_gynecologydetails() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
    }
    this.appService.getData(this.urlPoints.getgynaechistory, data, this.token).subscribe((response: any) => {
      this.viewfgynechistorydata = response.data
      this.gynecologyHistory.controls['gyneclmps'].setValue("");
      this.gynecologyHistory.controls['gynecmenstrualcomplaints1'].setValue("");
      this.gynecologyHistory.controls['gynecmenstrualcomplaints2'].setValue("");
      this.gynecologyHistory.controls['gynecmenstrualhistorys'].setValue("");
      this.gynecologyHistory.controls['gynecnotes'].setValue("");
    });
  }

  get_folliclestudydetails() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
    }
    this.appService.getData(this.urlPoints.getfollicular, data, this.token).subscribe((response: any) => {
      this.viewfolliclestudydata = response.data
      this.viewfolliclestudydata.forEach(function (value) {
        value.isSelected = false
      })
      this.getCheckedItemList3();
    });
  }

  checkUncheckAll() {
    for (var i = 0; i < this.viewcurrentpregRecords.length; i++) {
      this.viewcurrentpregRecords[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  isAllSelected() {
    this.masterSelected = this.viewcurrentpregRecords.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.viewcurrentpregRecords.length; i++) {
      if (this.viewcurrentpregRecords[i].isSelected)
        this.checkedList.push({ "id": this.viewcurrentpregRecords[i].id });
    }
  }

  archivecpRecords() {
    this.openclearlmpeddaddDeatils()
    if (this.checkedList.length == 0) {
      if (this.viewcurrentpregRecords.length == 0) {
        this.toastr.error("No records found")
      } else {
        this.toastr.error("Please select any record")
      }
    } else if (this.checkedList.length > 0) {
      let data = {
        "account_email": this.dmail,
        "data": this.checkedList
      }
      this.appService.postData(this.urlPoints.createpregnancyrecord, data, this.token).subscribe((response: any) => {
        this.toastr.success("Archived successfully")
        this.get_currentpregnancyRecords();
        this.masterSelected = false
      });
    }

  }

  checkUncheckAll2() {
    for (var i = 0; i < this.viewscanreportfindingdata.length; i++) {
      this.viewscanreportfindingdata[i].isSelected = this.masterSelected2;
    }
    this.getCheckedItemList2();
  }

  isAllSelected2() {
    this.masterSelected2 = this.viewscanreportfindingdata.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList2();
  }

  getCheckedItemList2() {
    this.checkedList2 = [];
    for (var i = 0; i < this.viewscanreportfindingdata.length; i++) {
      if (this.viewscanreportfindingdata[i].isSelected)
        this.checkedList2.push({ "id": this.viewscanreportfindingdata[i].id });
    }
  }

  archivecpscan() {
    if (this.viewscanreportfindingdata == "no scan reports found") {
      this.toastr.error("No records found")
    } else {
      if (this.checkedList2.length == 0) {

        this.toastr.error("Please select any record")

      } else if (this.checkedList2.length > 0) {
        let data = {
          "account_email": this.dmail,
          "data": this.checkedList2
        }
        this.appService.postData(this.urlPoints.createusscanreport, data, this.token).subscribe((response: any) => {
          this.toastr.success("Archived successfully")
          this.get_scanreportfindingdata();
          this.masterSelected2 = false
        });
      }
    }
  }

  checkUncheckAll3() {
    for (var i = 0; i < this.viewfolliclestudydata.length; i++) {
      this.viewfolliclestudydata[i].isSelected = this.masterSelected3;
    }
    this.getCheckedItemList3();
  }

  isAllSelected3() {
    this.masterSelected3 = this.viewfolliclestudydata.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList3();
  }

  getCheckedItemList3() {
    this.checkedList3 = [];
    for (var i = 0; i < this.viewfolliclestudydata.length; i++) {
      if (this.viewfolliclestudydata[i].isSelected)
        this.checkedList3.push({ "id": this.viewfolliclestudydata[i].id });
    }
  }

  archivefollicle() {
    if (this.checkedList3.length == 0) {
      if (this.viewfolliclestudydata.length == 0) {
        this.toastr.error("No records found")
      } else {
        this.toastr.error("Please select any record")
      }
    } else if (this.checkedList3.length > 0) {
      let data = {
        "account_email": this.dmail,
        "data": this.checkedList3
      }
      this.appService.postData(this.urlPoints.createfollicular, data, this.token).subscribe((response: any) => {
        this.toastr.success("Archived successfully")
        this.get_folliclestudydetails();
        this.masterSelected3 = false
      });
    }
  }

  getmilestonelist() {
    let params = {
      "account_email": this.dmail,
    }
    this.appService.getData(this.urlPoints.getmilestonelist, params, this.token).subscribe((response: any) => {
      if (response) {
        if (response.milestones[0].type == "TDSC") {
          this.setmilestonetype = 1
          sessionStorage.setItem("milestonetype", this.setmilestonetype)
        } else if (response.milestones[0].type == "LEST") {
          this.setmilestonetype = 2
          sessionStorage.setItem("milestonetype", this.setmilestonetype)
        } else if (response.milestones[0].type == "NHS") {
          this.setmilestonetype = 3
          sessionStorage.setItem("milestonetype", this.setmilestonetype)
        } else if (response.milestones[0].type == "CDCA") {
          this.setmilestonetype = 4
          sessionStorage.setItem("milestonetype", this.setmilestonetype)
        }
        this.getmilestonepatienthistory()
      }
    })
  }

  getmilestonepatienthistory() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "type": sessionStorage.getItem("milestonetype")
    }
    this.appService.getData(this.urlPoints.getpatienthistory, data, this.token).subscribe((response: any) => {
      if (response.length > 0) {
        // if (response[0].answer_status == "") {
        //   this.hidetimelinedata = true
        // }
        this.temppush = []
        for (var i = 0; i < response.length; i++) {
          if (response[i].answer_status != "") {
            this.hidetimelinedata = false
            this.temppush.push((response[i]))
          }else{
            this.hidetimelinedata = true
          }

        }
        this.viewmilestonepatienthistory = this.temppush
        // if(response.status !== ""){
        //   this.hidetimelinedata = false
        // this.viewmilestonepatienthistory = response
        // }
      } else {
        this.hidetimelinedata = true
      }
    });
  }

  milestonechangedrstatus(trackerid, id, status) {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "tracker_id": trackerid,
      "milestone": [{
        "id": id,
        "doctor_approval_status": status
      }]
    }
    this.appService.postData(this.urlPoints.updatedoctorapproval, data, this.token).subscribe((response: any) => {
      this.toastr.success("Doctor status changed successfully")
      this.getmilestonepatienthistory()
    });
  }

  startService() {
    if (this.supported) {
      if (this.muted)
        this.service.start()
      this.muted = !this.muted
    }
  }

  stopService() {
    if (this.supported) {
      this.service.stop()
      this.muted = !this.muted
      this.add = false

    }
  }

  drop(event: CdkDragDrop<any[]>) {
    const nodeToMove = event.item.element.nativeElement;
    const { previousContainer, container, previousIndex, currentIndex } = event;

    if (previousContainer === container) {
      moveItemInArray(container.data, previousIndex, currentIndex);

      moveItemInArray(this.order, previousIndex, currentIndex);

      moveWithinContainer(
        container.element.nativeElement,
        previousIndex,
        currentIndex
      );


    } else {
      transferArrayItem(
        previousContainer.data,
        container.data,
        previousIndex,
        currentIndex
      );
      transferNodeToContainer(
        nodeToMove,
        container.element.nativeElement,
        currentIndex
      );

      Promise.resolve().then(() => {
        previousContainer.removeItem(event.item);
        event.item.dropContainer = container;
        event.item._dragRef._withDropContainer(container._dropListRef);
        container.addItem(event.item);
      });
    }
  }

  @HostListener('window:keydown', ['$event'])
  onKeyPress($event: KeyboardEvent) {
    if (($event.altKey || $event.metaKey) && $event.keyCode == 80) {
      this.menu_item1.nativeElement.click();
    }

    if (($event.altKey || $event.metaKey) && $event.keyCode == 86) {
      //  this.menu_item2.nativeElement.click();
    }

    if (($event.altKey || $event.metaKey) && $event.keyCode == 77) {
      //  this.menu_item3.nativeElement.click();
    }

    if (($event.altKey || $event.metaKey) && $event.keyCode == 76) {
      //  this.menu_item4.nativeElement.click();
    }

    if (($event.altKey || $event.metaKey) && $event.keyCode == 72) {
      //  this.menu_item5.nativeElement.click();
    }

    if (($event.altKey || $event.metaKey) && $event.keyCode == 71) {
      //  this.menu_item6.nativeElement.click();
    }

    if (($event.altKey || $event.metaKey) && $event.keyCode == 65) {
      //  this.menu_item7.nativeElement.click();
    }


    if (($event.altKey || $event.metaKey) && $event.keyCode == 79) {
      this.menu_item8.nativeElement.click();
    }
  }

  changeOption() {
    this.option = !this.option;
  }

  notifier() {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_notifier, {
      width: '600px',
      data: { name: 'Please press start consultation' }
    });
  }

  start() {
    this.stopService()
    this.html = '<h1 _ngcontent-serverapp-c13="" class="r ng-star-inserted" style="text-align:center">Sorry, no results found</h1>';

    var temporalDivElement = document.createElement("div");
    temporalDivElement.innerHTML = this.html;
    this.result = temporalDivElement.textContent || temporalDivElement.innerText || "";

    this.speech.speak({
      text: this.result,
    }).then(() => {
    }).catch(e => {
    })

    var that = this;

    setTimeout(function () {
      that.startService()
    }, 3000);
  }

  start1() {

    if (this.show_block == 'cc') {
      this.chars1_copy = this.chars1;
    }

    if (this.show_block == 'ex') {
      this.chars2_copy = this.chars2;
    }

    if (this.show_block == 'diag') {
      this.chars3_copy = this.chars3;
    }

    if (this.show_block == 'inv') {
      this.chars4_copy = this.chars4;
    }

    if (this.show_block == 'pres') {
      this.chars5_copy = this.chars5;
    }

    if (this.show_block == 'adv') {
      this.chars6_copy = this.chars6;
    }

    // this.html = '<h1 _ngcontent-serverapp-c13="" class="r ng-star-inserted" style="text-align:center">Sorry, no results found. Please type.</h1>';

    // var temporalDivElement = document.createElement("div");

    // temporalDivElement.innerHTML = this.html;

    // this.result = temporalDivElement.textContent || temporalDivElement.innerText || "";

    // this.speech.speak({
    //   text: this.result,
    // }).then(() => {
    // }).catch(e => {
    // })

    var that = this;

    // setTimeout(function () {
    //   that.startService()
    // }, 4500);
  }

  pause() {
    this.speech.pause();
  }

  resume() {
    this.speech.resume();
  }

  setLanguage(i) {
    this.speech.setLanguage(this.speechData.voices[i].lang);
    this.speech.setVoice(this.speechData.voices[i].name);
  }

  ngOnChanges(changes: SimpleChanges) {
    //alert("changes")
    this.sub = this.route.params.subscribe(params => {
      this.patientListRecordId = params['id'];
    });

    if (!this.opendstartConsultPopup) {
      if (this.patientListRecordId != undefined) {
        this.loadICS(this.patientListRecordId);
      } else {
        this.loadICS('');
      }
    }
    this.opendstartConsultPopup = true;

    this.list = this.queueList;
    for (var i = 0; i < this.list.length; i++) {

      this.list[i].slot = moment(this.list[i].slot).format("hh:mm a");
      this.list[i].arrivaled_time = moment(this.list[i].arrival_time).format("hh:mm a");
      this.getDP(this.list[i].record_id, i)
    }
    this.selecteddate = moment(this.selecteddate).format("YYYY-MM-DD")
    if (changes.update) {
      this.arrivalStatus = null;
    }
  }

  ngDoCheck() {
    const change = this.differ.diff(this.service);
    if (change) {
      var that = this;
      change.forEachChangedItem(item => {
        if (item.key == 'length') {
          if (this.supported)
            this.navigate('voice')
        }
      });
    }
  }

  navigate(type) {

  }

  leavestartdatechanged(e) {
    this.fitstartDate = moment(e.value).format('YYYY-MM-DD');
  }

  leavbackdatechanged(e) {
    this.fitBack_date = moment(e.value).format('YYYY-MM-DD');
  }

  leaveeffectdatechanged(e) {
    this.leave_start_date = moment(e.value).format('YYYY-MM-DD');
  }

  loadDrTempaltes() {

    var tempalteparam = {
      account_email: this.dmail,
      doctor_id: this.doc_id,
      doctor_email: this.dmail,
      cons_screen: 1
    }

    this.appService.getData(this.urlPoints.getDocTemplate, tempalteparam, this.token).subscribe((response: any) => {

      let getmastertemp = response.master_templates;
      let getcatetemp = response.data;
      let getfreqPrinttemp = response.freq_templates;

      this.loadConsulprintTemplates = [];
      this.loadotherConsultTemplate = [];
      this.loadfreqPrintTemplates = [];
      this.loadfreqCertificateTemplates = [];

      getmastertemp.map(res => {
        if (res.category == 1) {
          this.loadConsulprintTemplates.push(res);
        }
        if (res.category == 4 || res.category == 6 || res.category == 7 || res.category == 8 || res.category == 9) {
          this.loadotherConsultTemplate.push(res);
        }
      });

      getcatetemp.map(res => {
        if (res.category == 1) {
          this.loadConsulprintTemplates.push(res);
        }
        if (res.category == 4 || res.category == 6 || res.category == 7 || res.category == 8 || res.category == 9) {
          this.loadotherConsultTemplate.push(res);
        }
      });

      getfreqPrinttemp.map(res => {
        if (res.category == 1) {
          this.loadfreqPrintTemplates.push(res);
        }
        if (res.category == 4 || res.category == 6 || res.category == 7 || res.category == 8 || res.category == 9) {
          this.loadfreqCertificateTemplates.push(res);
        }
      });
    });

    /** saved templates */
    this.counter_params = {
      doctor_id: this.doc_id,
      account_email: this.dmail
    }

    this.appService.getData(this.urlPoints.getTemplateName, this.counter_params, this.token).subscribe((response: any) => {
      if (response.success == 1) {
        this.templates = response.details;
        this.loadfreqConsultTemplates = response.freq_templates;
      }
    });

  }

  selectTemplate() {

    this.getdob = sessionStorage.getItem("dob");

    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getDoctorProfile, params, this.token).subscribe((response: any) => {
      this.docData = response.doctors.profile;
      this.getdrName = this.docData.name;
      this.getdrnum = this.docData.registration;
      this.getdrdegree = this.docData.degree;
      this.getdrspec = this.docData.speciality;

    });


    if (this.imgURL != 'No profile picture' && this.imgURL != '' && this.imgURL != null && this.imgURL != 'null') {
      this.fit_imgURL = environment.HOST + '/helyxonapi/cloud/image/upload/' + this.imgURL;
    }
    else {
      if (this.patient.demographics.gender == 'male') {
        this.fit_imgURL = 'assets/avatar-male.png'
      }
      else {

        this.fit_imgURL = 'assets/avatar-female.png'
      }

    }
    const dialogRef = this.dialog.open(DialogOverviewselectTemplate, {
      width: '80%',
      data: {
        templates: this.loadConsulprintTemplates, consultTemplates: this.templates,
        freqConsultTemplates: this.loadfreqConsultTemplates, catetemplates: this.loadotherConsultTemplate,
        freqprintTemplate: this.loadfreqPrintTemplates, freqcerificateTemplate: this.loadfreqCertificateTemplates
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        this.selected_temp_categoryId = result.cateId;
        this.selected_temp_Id = result.tempId;
        this.selected_temp_name = result.tempName;
        this.selected_cons_Temp_name = result.consultTempName;

        let selectedsubcateName = result.subcategoryName;
        let soapcatename = selectedsubcateName.split('-')[0];

        if (result.consultTempId == 0) {
          this.selectedTemp = undefined
          // this.resetConsultation()
        }

        /*ICS Template load */
        if (this.selected_temp_categoryId == 1 || this.selected_temp_categoryId == 2 || this.selected_temp_categoryId == 3) {
          this.ICSscreen_load = true;
          this.custom_template = false;
          if (soapcatename == 'Soap') {
            this.preview_type = 2;
          } else {
            this.preview_type = 1;
          }
          if (this.selected_cons_Temp_name != '') {
            this.chooseTemp(this.selected_cons_Temp_name);
            this.selectedTemp = this.selected_cons_Temp_name;
          }
          this.frequecyusedConsultTempalte();
          this.frequecyusedPrintTempalte();
        }

        /*custom templates load */
        if (this.selected_temp_categoryId == 4 || this.selected_temp_categoryId == 6 || this.selected_temp_categoryId == 7 || this.selected_temp_categoryId == 8 || this.selected_temp_categoryId == 9) {
          this.ICSscreen_load = false;
          this.custom_template = true;
          this.frequecyusedPrintTempalte();
        }
      }

    });
  }

  frequecyusedConsultTempalte() {
    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id,
      template_name: this.selected_cons_Temp_name
    }

    this.appService.postData(this.urlPoints.frequencyusedConsultTemplate, params, this.token).subscribe((response: any) => {
      console.log(response);

    });
  }

  frequecyusedPrintTempalte() {
    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id,
      template_id: this.selected_temp_Id
    }

    this.appService.postData(this.urlPoints.frequencyusedPrintTemplate, params, this.token).subscribe((response: any) => {
      console.log(response);

    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '/' || event.key === '@' || event.key === ',' || event.key === '-' || event.key === '.') {
      return;
    } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

  avoid_special_char_only(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '(' || event.key === ')' || event.key === ',') {
      return;
    } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }


  listTemplate() {
    //  this.set('temp')

    const dialogRef = this.dialog.open(DialogOverviewExampleDialogListTemp, {
      width: '600px',
      data: { templates: this.templates, tempOpen: this.tempOpen }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chooseTemp(result.template_name);
        this.selectedTemp = result.template_name
      }
    });
  }

  listCart() {
    var paramsMaster = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getMasterSettings, paramsMaster, this.token).subscribe((masterData: any) =>{
const paymentMode = masterData.data[0].epharmacy_frontdesk_payment;
this.frontdesk_pay = paymentMode ? 1 : 0;
});

    this.appService &&this.appService.cartItems$ &&this.appService.cartItems$.subscribe(items=>{
      
      items.forEach(e=>{
        console.log("quantity::",e)
        const itemExists  = this.cartItems.some(item=>item.product_id === e.product_id)
        if(!itemExists){
          this.cartItems.push(e)
        }
      })
      })
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_cartitems, {
      width: '600px',
      data: { drugs: this.cartItems }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cartItems = result
        var productData = []
        for (var i = 0; i < result.length; i++) {
          var obj = {
            product_id:result[i].product_id ?(result[i].product_id).toString() : (result[i].id).toString(),
            quantity: result[i].quantity
          }
          productData.push(obj);
        }
        var meta_data = [
          {
            id: 1,
            key: "appointment_id",
            value: this.appointment_id
          },
          {
            id: 2,
            key: "token",
            value: this.token_name
          },
          {
            id: 3,
            key: "consultation",
            value: "Consulted with " + this.docData.name + " on " + moment(new Date()).format("DD-MMM-YYYY")
          }
        ]
        var params = {
          account_email: this.dmail,
          epharmacy_frontdesk_payment:this.frontdesk_pay,
          patient_email: this.patient.record_info.Record.account_email,
          note: this.adv_names ? this.adv_names : "",
          products: productData,
          meta_data: meta_data,
          doctor_id: this.doc_id

        }
        this.appService.postData(this.urlPoints.createProdCart, params, this.token).subscribe((response: any) => {
          var id_arr = response.data._links.self[0].href.split('/');
          this.cartItems = [];
          var id = id_arr[id_arr.length - 1];
          const dialogRef = this.dialog.open(DialogOverviewExampleDialog_cartid, {
            width: 'fit-content',
            data: { id: id },
          });
        });
      }
    });
    this.appService.addToCartItems([]);
  }


  getRecord(id) {

    var params = {
      account_email: this.dmail,
      record_id: id
    }

    var token = this.token;

    var getPres = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getPresCustom, getPres, this.token).subscribe((response: any) => {

      if (response.data[0])
        if (response.data[0].status) {
          this.showUnits = response.data[0].status == 1 ? true : false
        }

      if (response.data[1])
        if (response.data[1].status) {
        }

      if (response.data[2])
        if (response.data[2].status) {
          this.durationAlone = response.data[2].status == 1 ? true : false
        }

    });

    var getSettings = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }
    this.appService.getData(this.urlPoints.getDrugSettings, getSettings, this.token).subscribe((response: any) => {

      if (response.data[0]) {
        if (response.data[0].category_id) {
          this.drugShowType = response.data[0].category_id
        }
        else {
          var params_type = {
            account_email: this.dmail,
            category_id: "1",
            category_name: "drug",
            doctor_id: this.doc_id
          }

          this.appService.postData(this.urlPoints.drugSettings, params_type, this.token).subscribe((response: any) => {

          });
        }
      }
      else {
        var params_type = {
          account_email: this.dmail,
          category_id: "1",
          category_name: "drug",
          doctor_id: this.doc_id
        }

        this.appService.postData(this.urlPoints.drugSettings, params_type, this.token).subscribe((response: any) => {

        });
      }

    });



    this.appService.postData(this.urlPoints.getRecord, params, token).subscribe((response: any) => {
      this.patient = response;
      sessionStorage.setItem("gender:",response.demographics.gender)
      this.updateProfile = !this.updateProfile
      // this.profileForm.controls['Name'].setValue(this.patient.record_info.Record.label);
      // this.profileForm.controls['gender'].setValue(this.patient.demographics.gender);
      // this.profileForm.controls['DOB'].setValue(this.patient.demographics.bday);
      // this.profileForm.controls['Weight'].setValue(this.patient.demographics.birth_weight);
      // this.profileForm.controls['Height'].setValue(this.patient.demographics.birth_height);
      // this.profileForm.controls['alternatenumber'].setValue(this.patient.demographics.mother_tel_number);
      // this.profileForm.controls['fathername'].setValue(this.patient.demographics.father_name_given);
      // this.profileForm.controls['mothername'].setValue(this.patient.demographics.mother_name_given);
      // this.profileForm.controls['fatherdob'].setValue(this.patient.demographics.father_bday);
      // this.profileForm.controls['motherdob'].setValue(this.patient.demographics.mother_bday);
      // this.profileForm.controls['phonenumber'].setValue(this.patient.record_info.Record.phone);
      // this.profileForm.controls['UHID'].setValue(this.patient.demographics.uhid);
      // this.profileForm.controls['Emailaddress'].setValue(this.patient.demographics.father_email);
      // this.profileForm.controls['street'].setValue(this.patient.demographics.adr_street);
      // this.profileForm.controls['city'].setValue(this.patient.demographics.adr_city);
      // this.profileForm.controls['pincode'].setValue(this.patient.demographics.adr_postalcode);
      // this.profileForm.controls['state'].setValue(this.patient.demographics.adr_region);
      // this.dob2 = moment(this.patient.demographics.bday).format("DD-MM-YYYY")
      // sessionStorage.setItem('patientemail', this.patient.record_info.Record.account_email)
      if (this.patient) {
        this.imgURL = this.patient.demographics.image;
      }
      // sessionStorage.setItem("patientname", this.patient.demographics.name_given)

      this.checkAllergy();


      this.actual_image = environment.HOST + '/helyxonapi/cloud/image/upload/' + this.patient.image;

      var param1 = {
        account_email: this.dmail,
        mr_number: this.patient.record_info.Record.mr_number,
        date: moment(new Date()).format("YYYY-MM-DD")
      }

      this.appService.getData(this.urlPoints.getVitalData, param1, token).subscribe((response: any) => {
        this.helVital = response;
      });

      var settingsParams = {
        account_email: this.dmail,
        doctor_id: this.doc_id
      }

      this.appService.getData(this.urlPoints.getMasterSettings, settingsParams, this.token).subscribe((response: any) => {
sessionStorage.setItem('E-shop',response.data[0].ics_eshop);
this.eshop_enabled = sessionStorage.getItem('E-shop');
        this.eShop = response.data[0].ics_eshop
      });

      this.getVitalData()


      var params_vaccine = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email,
        user_type: 'doctor',
        dob: this.patient.demographics.bday
      }

      this.vaccinationCalendar(this.urlPoints.vaccinationCalendar, params_vaccine, token)
      var params_labreports = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email,
      }

      this.getUnseen()

      var params1 = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email
      }

      this.getPayment(this.urlPoints.getPayment, params1, token);

      var a = moment(this.patient.demographics.bday).format("YYYY-MM-DD")

      var b = moment(new Date()).format("DD-MM-YYYY");

      var a_arr = a.split('-')
      var b_arr = b.split('-')

      this.month = moment([b_arr[2], Number(b_arr[1]) - 1, b_arr[0]]).diff(moment([a_arr[0], Number(a_arr[1]) - 1, a_arr[2]]), 'months', true)

      this.month = Math.round(this.month)

      var x = moment([b_arr[2], Number(b_arr[1]) - 1, b_arr[0]]);
      var y = moment([a_arr[0], Number(a_arr[1]) - 1, a_arr[2]]);

      this.y = moment(x).diff(moment(y), 'year')
      y.add('years', this.y)

      this.m = moment(x).diff(moment(y), 'months')

      // alert(this.y)

      this.appService.getQueue(this.urlPoints.getVitals + '?' + this.id, token).subscribe((response: any) => {
        this.vitalsData = response;
        this.getVitalsData(this.vitalsData)
      });

      this.getAnswers()

      this.getCurrentMedication()

      this.getAbha()

    });

    // this.getAnswers()

    // this.getCurrentMedication()
  }
  GetFile(e) {

    this.files = Array.from(e.target.files);
    if ((this.files[0].type === 'image/png')
      || (this.files[0].type === 'image/jpg')
      || (this.files[0].type === 'image/jpeg')
    ) {
      this.uploaded_image = this.files[0].name;
      environment.HOST + '/helyxonapi/cloud/image/upload/' + "img_" + this.files[0].name;
    }
  }


  // automate open the start consultation popup

  checkStatus(getfromStatus) {
    console.log("check in checkStatus")

    var token = this.token;

    var today = moment(new Date()).format("YYYY-MM-DD");

    var url = this.urlPoints.appointmentDate + '?' + this.dmail + '&' + today + '&' + today;

    this.appService.getQueue(url, token).subscribe((response: any) => {
      var exists = false;
      this.apptData = response;
      for (var i = 0; i < this.apptData.length; i++) {
        if (this.apptData[i].mr_number == this.patient.record_info.Record.mr_number) {
          //This is come from patient list consultaion(walkin)
          if (this.patientListRecordId == this.apptData[i].record_id) {
            this.appointment_id = this.apptData[i].id;
            
            sessionStorage.setItem("apt_id", this.appointment_id)
          }

          exists = true;
          this.event = this.apptData[i].type;
          if (this.apptData[i].arrival_time != null) {
            this.arrived = true;
            this.arrivalStatus = this.apptData[i].arrival_time;
          }
          else {
            this.arrived = true
          }
          break;
        }
      }

      if (exists) {
        var filterarray = this.apptData.filter(i => i.id == this.appointment_id);
// checkQRR here
        if (filterarray[0].arrival_time != null) {
          this.arrived = true;
        }
        else {
          this.arrived = false
        }


        if (this.arrived) {
          sessionStorage.setItem('consultation','true')
          this.status = "Start Consultation";
          // alert(1)
          console.log('this.appindex',this.appindex);
          //route for call auto open selecttemplate
          // if (getfromStatus == 'onloading' && this.appindex != 3) {
          if (getfromStatus == 'onloading') {
            if (this.current_videocall_patientDetails.type == "video_call" && (this.current_videocall_patientDetails.participant_connect_status == 1)
              && this.joinbuttonStatus) {
              this.changeStatus();
            } else if (this.current_videocall_patientDetails.type != "video_call") {
              this.changeStatus();
            }
            else if (this.current_videocall_patientDetails.type == "video_call" && this.current_videocall_patientDetails.status == 'closed') {
              this.changeStatus();
            }
          }
        }
        else {
          this.status = "Set Arrival & Start Consultation"
        }
      }
    });
  }

  changeStatus() {
    console.log("check in changeStaus")

    if (this.status == "Walkin") {

      this.status = "Start Consultation"

      var token = this.token;

      var today = moment(new Date()).format("YYYY-MM-DD");
      var url = this.urlPoints.appointmentDate + '?' + this.dmail + '&' + today + '&' + today;


      this.appService.getQueue(url, token).subscribe((response: any) => {

        var exists = false;
        this.apptData = response;
        // if(!this.checkQRR){
          //checkQRR here
        for (var i = 0; i < this.apptData.length; i++) {
          if (this.apptData[i].mr_number == this.patient.record_info.Record.mr_number) {
            exists = true;
            this.event = this.apptData[i].type;
          }
        }
        // }
        var params = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          patient_email: this.patient.record_info.Record.account_email
        }

        if (!exists) {
          this.appService.postData(this.urlPoints.walkin, params, token).subscribe((response: any) => {

            this.appointment_id = response.id;
            sessionStorage.setItem("apt_id", this.appointment_id)
            var params1 = {
              account_email: this.dmail,
              doctor_id: this.doc_id,
              patient_account: this.patient.record_info.Record.account_email,
              appointment_id: response.id
            }

            this.appService.postData(this.urlPoints.setArrival, params1, token).subscribe((response: any) => {

              var params = {
                account_email: this.dmail,
                doctor_id: this.doc_id,
                status_type: this.appindex,
                in_date: moment(this.selecteddate).format("YYYY-MM-DD")
              }
              const geturlPoint = this.urlPoints.getqueueList;
              this.getList(geturlPoint, params, token);
              this.getList(this.urlPoints.getList, params, token);

              this.appService.getQueue(this.urlPoints.getArrival + '?' + this.dmail + '/' + this.id, token).subscribe((response: any) => {
                this.arrivalStatus = moment(response.arrival_time).add(5.5, 'hours').format('DD-MM-YYYY hh:mm A');
                sessionStorage.setItem('QRCode','False');
                // QRCode
              });
            });

          });

        }
      });
    }

    else if (this.status == "Set Arrival & Start Consultation" || this.status == "Start Consultation") {
      sessionStorage.setItem('consultation','true')
      console.log("check in else if")

      var today = moment(new Date()).format("YYYY-MM-DD");

      var url = this.urlPoints.appointmentDate + '?' + this.dmail + '&' + today + '&' + today;

      var params = {
        account_email: this.dmail,
        doctor_id: this.doc_id,
        status_type: this.appindex,
        in_date: moment(this.selecteddate).format("YYYY-MM-DD")

      }
      const geturlPoint = this.urlPoints.getqueueList;

      this.appService.getData(geturlPoint, params, this.token).subscribe((response: any) => {
        this.apptData = response;

        for (var i = 0; i < this.apptData.length; i++) {
          if (this.apptData[i].mr_number == this.patient.record_info.Record.mr_number && this.apptData[i].id == this.appointment_id) {
            this.event = this.apptData[i].type;
            if (this.patientListRecordId != undefined) {
              this.appointment_id = this.apptData[i].id;
              sessionStorage.setItem("apt_id", this.appointment_id)
            }
            this.token_name = this.apptData[i].token
            if (this.apptData[i].arrival_time != null) {
              this.arrived = true;
            }
            else {
              this.arrived = false
            }
            break;
          }
        }

        if (this.arrived) {

          //   alert(this.appindex)
          this.resumeConsulation()
          this.getComplaint()

          // if (this.appindex != 3)
            // this.selectTemplate();

            this.status = "End Consultation";
          this.started = true;
          this.startStatus.next(this.started);

          window.parent.window.postMessage({
            "message": "started"
          }, '*')

          var that = this;

          setTimeout(function () {
            var b = document.getElementById("end") as HTMLButtonElement;
            b.classList.remove("btn-primary");
            b.classList.add("btn-danger");

            setTimeout(function () {
              that.toggleColor();
            }, 30000);

          }, 300000);


          var token = this.token;

          var params2 = {
            account_email: this.dmail,
            appointment_id: this.appointment_id,
            patient_account: this.patient.record_info.Record.account_email
          }

          this.appService.postData(this.urlPoints.startCon, params2, this.token).subscribe((response: any) => {
            this.checkQueue()
          });

          this.end = true;
        }
        else {
          console.log('not arrived*****');
          var params_set = {
            account_email: this.dmail,
            doctor_id: this.doc_id,
            patient_account: this.patient.record_info.Record.account_email,
            appointment_id: this.appointment_id
          }

          this.appService.postData(this.urlPoints.setArrival, params_set, this.token).subscribe((response: any) => {

            this.getList(geturlPoint, params, token);
            // change arrived status
            this.appService.getQueue(this.urlPoints.getArrival + '?' + this.dmail + '/' + this.id, this.token).subscribe((response: any) => {
              this.arrivalStatus = moment(response.arrival_time).add(5.5, 'hours').format('DD-MM-YYYY hh:mm A');
            });
            this.selectTemplate();
            this.status = "End Consultation";
            console.log('calll api arrived*****');
            this.started = true;
            this.startStatus.next(this.started);

            window.parent.window.postMessage({
              "message": "started"
            }, '*')


            var token = this.token;

            var params2 = {
              account_email: this.dmail,
              appointment_id: this.appointment_id,
              patient_account: this.patient.record_info.Record.account_email
            }

            this.appService.postData(this.urlPoints.startCon, params2, this.token).subscribe((response: any) => {
            });

            this.resumeConsulation()

            this.counter_params = {
              doctor_id: this.doc_id,
              account_email: this.dmail
            }

            this.appService.getData(this.urlPoints.getTemplateName, this.counter_params, this.token).subscribe((response: any) => {
              if (response.success == 1) {
                this.templates = response.details
              }
            });
            this.end = true;

          });

        }
      });
    }

    else {
      sessionStorage.setItem('consultation','false')
      var par = {
        account_email: this.dmail,
        appointment_id: this.appointment_id,
        patient_account: this.patient.record_info.Record.account_email,
        template_id: this.selected_temp_Id ? this.selected_temp_Id : null
      }

      this.appService.postData(this.urlPoints.endCon, par, this.token).subscribe((response: any) => {

        this.toastr.success("Consultation saved!");

        var params1 = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          overview_id: this.preview_id,
          patient_email: this.patient.record_info.Record.account_email,
          template_id: this.selected_temp_Id,
          template_v4:2,
          sms: 0,
          email: 0
        }
        this.appService.getData(this.urlPoints.getFile, params1, token).subscribe((response: any) => {
          this.someEvent_print.next();
        });


        window.parent.window.postMessage({
          "message": "ended"
        }, '*')

        if (this.patientListRecordId != undefined) {
          this.router.navigate(['epicare/appointment']);
        } else {
          window.location.reload();
        }
      });
    }
  }

  resumeConsulation() {
    var params1 = {
      account_email: this.dmail,
      appointment_id: this.appointment_id
    }

    this.appService.getData(this.urlPoints.getPreview, params1, this.token).subscribe((response: any) => {
      if (response.op_review.appointment_id) {
        this.call = 'update'
        this.preview = 'Update Consultation'
      }
      else {
        this.call = 'add'
      }

      if (response.op_review.notes) {
        this.hpi = response.op_review.notes
        this.hpi2 = response.op_review.notes
      }

      if (response.op_review.prescription_id) {
        this.prescription_id = response.op_review.prescription_id;
        this.pres_selected = response.op_review.prescription;

        this.pres_selected = Object.assign([], response.op_review.prescription);

        var getPres = {
          account_email: this.dmail,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getPresCustom, getPres, this.token).subscribe((response: any) => {

          // if (response.data[0])
            if (response.data[0].status) {
              this.showUnits = response.data[0].status == 1 ? true : false
            }

          for (var k = 0; k < this.pres_selected.length; k++) {
            var brand = this.pres_selected[k].brand
            this.pres_selected[k].brand = this.pres_selected[k].generic
            this.pres_selected[k].generic = brand;
            this.pres_selected[k].generic = this.pres_selected[k].composition
          }

          for (var i = 0; i < this.pres_selected.length; i++) {
            this.pres_count++;
            var obj = {
              drug_id: this.pres_selected[i].id,
              dose: this.pres_selected[i].dose,
              dose_option: this.pres_selected[i].dose_option,
              frequency: this.pres_selected[i].frequency,
              route: this.pres_selected[i].route,
              when: this.pres_selected[i].when,
              duration: this.pres_selected[i].duration.toString(),
              duration_type: this.pres_selected[i].duration_type,
              quantity: this.pres_selected[i].quantity,
              special_instruction: this.pres_selected[i].special_instruction,
              minimum_buyable_qty: this.pres_selected[i].minimum_buyable_qty,
              operation: 'add',
              pres_id: this.pres_count
            }

            var unit = this.pres_selected[i].quantity.split(' ')[1]

            var freq_arr = this.pres_selected[i].frequency.split('-')

            if (freq_arr.length == 4) {
              var morning = freq_arr[0].trim().split(' ')[0]

              var afternoon = freq_arr[1].trim().split(' ')[0]

              var evening = freq_arr[2].trim().split(' ')[0]

              var night = freq_arr[3].trim().split(' ')[0]

              if (this.showUnits) {
                var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }


                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }
                this.pres_selected[i].frequency = freq
                this.pres_selected[i].shortFreq = shortFreq
              }
              else {
                var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                this.pres_selected[i].frequency = freq


                this.pres_selected[i].shortFreq = freq

              }

            }
            else if (freq_arr.length == 2) {

              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }

              if (this.showUnits) {

                var freq1: any = this.pres_selected[i].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[i].frequency.split('-')[1].trim().split(' ')[0].trim()


                this.pres_selected[i].frequency = freq1 + ' ' + unit

                this.pres_selected[i].shortFreq = freq1 + ' ' + shortUnit
              }
              else {
                var freq1: any = this.pres_selected[i].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[i].frequency.split('-')[1].trim().split(' ')[0].trim()

                this.pres_selected[i].shortFreq = freq1
              }
            }

            else {
              var freq1: any = this.pres_selected[i].frequency

              this.pres_selected[i].shortFreq = freq1
            }


            this.pres_selected[i].pres_id = this.pres_count;

            this.pres_entries.push(obj)
          }
        });


      }

      if (response.op_review.complaint.id) {
        this.complaint_id = response.op_review.complaint.id;
        this.cc_issues = response.op_review.complaint.issues;
        var isQuestionArr = []

        var names = [];

        if (this.cc_issues)
          for (var i = 0; i < this.cc_issues.length; i++) {
            names.push(this.cc_issues[i].complaint_category)
            isQuestionArr.push(this.cc_issues[i].is_question)
          }

        for (var i = 0; i < names.length; i++) {
          var params = {
            account_email: this.dmail,
            page_no: 1,
            alphabet: names[i],
            "doctor_id": this.doc_id
          }

          this.getCC3(this.urlPoints.getCC, params, this.token, isQuestionArr[i]);
        }

        if (names.length == 0) {
          //  this.set('cc')
        }


      }
      else {
        //  this.set('cc')
      }

      var names2 = response.op_review.findings.split('\n');

      if (names2.length > 0)
        for (var i = 0; i < names2.length; i++) {

          if (names2[i].startsWith('?')) {
            names2[i] = names2[i].substring(1)
            var question = true
          }
          else {
            var question = false
          }

          var params = {
            account_email: this.dmail,
            page_no: 1,
            alphabet: names2[i],
            doctor_id: this.doc_id
          }

          this.getEx2(this.urlPoints.getEx, params, this.token, question);
        }

      var names3 = response.op_review.lab_tests;

      if (names3 && names3.length > 0) {
        for (var i = 0; i < names3.length; i++) {

          if (names3[i].startsWith('?')) {
            names3[i] = names3[i].substring(1)
            var question = true
          }
          else {
            var question = false
          }

          var params = {
            account_email: this.dmail,
            page_no: 1,
            alphabet: names3[i],
            doctor_id: this.doc_id
          }


          this.getInv2(this.urlPoints.getInv, params, this.token, question);
        }
      }

      var names4 = response.op_review.diagnosis.split('\n')

      for (var i = 0; i < names4.length; i++) {

        if (names4[i].startsWith('?')) {
          names4[i] = names4[i].substring(1)
          var question = true
        }
        else {
          var question = false
        }

        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: names4[i],
          doctor_id: this.doc_id
        }


        this.getDiag2(this.urlPoints.getDiag, params, this.token, question);
      }

      var names5 = response.op_review.advice.split('<br>')


      for (var i = 0; i < names5.length; i++) {

        if (names5[i] != '')
          names5[i] = names5[i].substring(3);

        if (names5[i].startsWith('?')) {
          names5[i] = names5[i].substring(1)
          var question = true
        }
        else {
          var question = false
        }

        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: names5[i],
          doctor_id: this.doc_id
        }

        this.getAdv2(this.urlPoints.getAdv, params, this.token, question);
      }


    });
  }

  checkQueue() {

    var currentIndex;

    var nextIndex;

    //next_queue_patient

    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id,
      status_type: this.appindex,
      in_date: this.selecteddate

    }
    const geturlPoint = this.urlPoints.getqueueList;

    this.appService.getData(geturlPoint, params, this.token).subscribe((response: any) => {
      console.log(response)

      this.list = response

      currentIndex = this.list.findIndex(item => item.id == this.appointment_id);

      nextIndex = this.list.findIndex(item => item.next_queue_patient == 1);

      var arr = this.list.filter(item => item.next_queue_patient == 1);

      console.log(arr[0])

      console.log(currentIndex)

      console.log(nextIndex)

      if (currentIndex > -1 && nextIndex > -1)
        if (currentIndex != nextIndex) {

          console.log('here')

          this.list.splice(nextIndex, 1)

          currentIndex = this.list.findIndex(item => item.id == this.appointment_id);

          this.list.splice(currentIndex + 1, 0, arr[0])

          console.log(currentIndex)

        }

      for (var i = 0; i < this.list.length; i++) {

        this.list[i].slot = moment(this.list[i].slot).format("hh:mm a");
        this.list[i].arrivaled_time = moment(this.list[i].arrival_time).format("hh:mm a");
        this.getDP(this.list[i].record_id, i)
      }

    });
  }

  openPayment1() {

    //  alert('here')

    var par = {
      account_email: this.dmail,
      appointment_id: this.appointment_id,
      patient_account: this.patient.record_info.Record.account_email,
      template_id: this.selected_temp_Id ? this.selected_temp_Id : null

    }

    this.appService.postData(this.urlPoints.endCon, par, this.token).subscribe((response: any) => {

      var params2 = {
        appointment_id: this.appointment_id,
        account_email: this.dmail,
        category: this.event
      }

      this.appService.getData(this.urlPoints.getPaymentStatus, params2, this.token).subscribe((response: any) => {

        this.payment_response = response;

        var params = {
          account_email: this.dmail,
          patient_email: this.patient.record_info.Record.account_email
        }

        this.appService.postData(this.urlPoints.getWalletBalance, params, this.token).subscribe((response: any) => {
          this.balance = response.wallet[0].response[0].total

          var par2 = {
            account_email: this.dmail,
            doctor_id: this.doc_id
          }

          this.appService.getData(this.urlPoints.getPaymentSettings, par2, this.token).subscribe((response: any) => {

            this.payment_modules = [];

            for (var i = 0; i < response.length; i++) {
              if (response[i].status == 1)
                this.payment_modules.push(response[i])
            }

            if (this.payment_response.payment_status == "yes") {
              const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
                width: '600px', disableClose: true,
                data: { name: 'Payment has already been raised for this patient. Do you want to charge the patient again?', type: 0 }
              });

              dialogRef.afterClosed().subscribe(result => {
                if (result) {
                  if (result == 'yes') {
                    this.openPayment()
                  }
                  else {
                    if (this.patientListRecordId != undefined) {
                      this.router.navigate(['epicare/appointment']);
                    } else {
                      window.location.reload();
                    }
                  }
                }
              });
            }

            else {
              this.openPayment()
            }
          });
        });
      });

    });
  }

  getComplaint() {
    var params =
    {
      account_email: this.dmail,
      user_type: "doctor",
      patient_email: this.patient.record_info.Record.account_email,
      appointment_id: "8cb51554-8c36-4b90-85b4-66c71b7a5eaa"
    }



    this.appService.postData(this.urlPoints.getComplaintLatest, params, this.token).subscribe((response: any) => {

      this.cc_user = [];

      for (var i = 0; i < response.complaint.issues.length; i++) {
        this.cc_user.push(response.complaint.issues[i].complaint_category)
      }

    });

  }

  addCC(cc) {
    //  alert(cc)
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: cc,
      "doctor_id": this.doc_id
    }

    this.getCC3(this.urlPoints.getCC, params, this.token, this.ccDoubt);
  }

  get_cc_name() {
    var data = {

    }

    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'cc',
        text: 'Enter new complaint'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        var params = {
          account_email: this.dmail,
          page_no: this.cc_page,
          alphabet: result,
          "doctor_id": this.doc_id
        }

        this.appService.getData(this.urlPoints.getCC, params, this.token).subscribe((response: any) => {

          this.chief_complaints = response.data

          if (this.chief_complaints.length > 0) {
            this.toastr.error(result + " already has data")
          }
          else {
            this.save_cc(result)
          }
        });
      }
    });

  }

  input(event) {
    this.changeChars(event.target.value)
  }

  toggle() {
    this.muted = !this.muted
    if (this.muted) {
      this.muteButton = 'assets/mute.svg'
      //  this.someEvent.next(false);

    }
    else {
      this.muteButton = 'assets/unmute.svg'
      //  this.someEvent.next(true);

    }
  }

  get_ex_name() {
    var data = {

    }

    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'ex',
        text: 'Enter new findings'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        var params = {
          account_email: this.dmail,
          page_no: this.ex_page,
          alphabet: result,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getEx, params, this.token).subscribe((response: any) => {

          this.examination = response.data

          if (this.examination.length > 0) {
            this.toastr.error(result + " already has data")
          }
          else {
            this.save_ex(result)
          }
        });
      }
    });
  }

  get_diag_name() {
    var data = {

    }

    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'cc',
        text: 'Enter new diagnosis'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        var params = {
          account_email: this.dmail,
          page_no: this.diag_page,
          alphabet: result,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getDiag, params, this.token).subscribe((response: any) => {

          this.diagnosis = response.data

          if (this.diagnosis.length > 0) {
            this.toastr.error(result + " already has data")
          }
          else {
            this.save_diag(result)
          }
        });
      }
    });
  }

  get_inv_name() {
    var data = {

    }

    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'cc',
        text: 'Enter new investigation'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        var params = {
          account_email: this.dmail,
          page_no: this.inv_page,
          alphabet: result,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getInv, params, this.token).subscribe((response: any) => {

          this.investigations = response.data

          if (this.investigations.length > 0) {
            this.toastr.error(result + " already has data")
          }
          else {
            this.save_inv(result)
          }
        });
      }
    });
  }

  get_adv_name() {
    var data = {

    }

    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'cc',
        text: 'Enter new advice'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        var params = {
          account_email: this.dmail,
          page_no: this.adv_page,
          alphabet: result,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getAdv, params, this.token).subscribe((response: any) => {

          this.advice = response.data

          if (this.advice.length > 0) {
            this.toastr.error(result + " already has data")
          }
          else {
            this.save_adv(result)
          }
        });
      }
    });
  }

  openPayment() {
    const dialogRef1 = this.dialog.open(DialogOverviewExampleDialog_payment, {
      width: '600px', disableClose: true,
      data: {
        data: {
          name: this.patient.record_info.Record.label,
          mrn: this.patient.record_info.Record.mr_number,
          modules: this.payment_modules,
          category: this.event,
          balance: this.balance
        }
      }
    });

    dialogRef1.afterClosed().subscribe(result => {
      if (result) {

        var payment_type = result.type

        var params = {
          account_email: this.dmail,
          appointment_id: this.appointment_id,
          category: result.category,
          description: result.desc,
          doctor_charges: result.amount,
          doctor_id: this.doc_id,
          patient_email: this.patient.record_info.Record.account_email,
          type: result.type,
          user_type: 'doctor'
        }

        this.appService.postData(this.urlPoints.raiseInvoice, params, this.token).subscribe((response: any) => {
          let patientlistURLStatus;
          if (this.patientListRecordId == undefined) {
            patientlistURLStatus = 0;
          } else {
            patientlistURLStatus = 1;
          }

          const dialogRef = this.dialog.open(DialogOverviewExampleDialog_invoice, {
            width: '600px', disableClose: true,
            data: { data: response, name: this.patient.record_info.Record.label, mrn: this.patient.record_info.Record.mr_number, urlstatus: patientlistURLStatus, payment_type: payment_type }
          });

          dialogRef.afterClosed().subscribe(result => {

            if (this.patientListRecordId != undefined) {
              this.router.navigate(['epicare/appointment']);
            } else {
              window.location.reload();
            }
          });

        });

      }
      else {
        if (this.patientListRecordId != undefined) {
          this.router.navigate(['epicare/appointment']);
        } else {
          window.location.reload();
        }
      }
    });
  }

  openPaymentSheet() {
    const dialogRef = this._bottomSheet.open(paymentsheet, {
      data: { patient: this.patient, dmail: this.dmail, email: this.patient.record_info.Record.account_email, token: this.token, doc_id: this.doc_id },
      disableClose: true
    }).afterDismissed().subscribe((result) => {

    });


  }

  toggleColor() {
    var danger = true;
    setInterval(function () {
      if (danger) {
        var b = document.getElementById("end") as HTMLButtonElement;
        b.classList.remove("btn-danger");
        b.classList.add("btn-primary");
      }
      else {
        var b = document.getElementById("end") as HTMLButtonElement;
        b.classList.remove("btn-primary");
        b.classList.add("btn-danger");
      }
      danger = !danger
    }, 1000);
  }

  chooseTemp(t) {
    this.selectedTemplate = t
    this.tempChange()
  }

  tempChange() {

    console.log('here')

    var params = this.counter_params;

    params.template_name = this.selectedTemplate;

    this.appService.getData(this.urlPoints.getTemplate, params, this.token).subscribe((response: any) => {

      this.toastr.success("Template applied!")
      //  this.set('cc')

      this.cc_selected = [];
      this.cc_issues = [];

      this.chief_complaints = Object.assign([], (response.details[0]).cheif_complaint);
      this.cc_copy1 = Object.assign([], (response.details[0]).cheif_complaint);

      var length = this.cc_copy1.length

      console.log(this.cc_copy1)

      this.cc_selected = [];

      this.cc_selected = this.cc_selected.concat((response.details[0]).cheif_complaint)

      for (var i = 0; i < this.cc_selected.length; i++) {


        this.cc_issues.push({
          "category_id": this.cc_selected[i].id,
          "complaint_category_id": this.cc_selected[i].id,
          "complaint_type": this.cc_selected[i].name,
          "is_question": this.cc_selected[i].is_question ? 1 : 0,

          "details": [
            {
              "questions": "",
              "answers": ""
            },


          ]
        })
      }

      var params_cc = {
        account_email: this.dmail,
        appointment_id: this.appointment_id
      }

      console.log('herecomplaint')

      if (!this.complaint_id) {
        var params = {
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "simple_complaint": {
            "user_type": "doctor",
            "issues": this.cc_issues,
            "days": "",
            "medicine_given": "",
            "temperature": "",
            "unit": "",
            "other_information": "",
            "patient_email": this.patient.record_info.Record.account_email,
            "appointment_id": this.appointment_id
          }
        }

        this.appService.postData(this.urlPoints.simpleComplaint, params, this.token).subscribe((response: any) => {
          this.complaint_id = response.complaint.id;

          this.save_add1()
        });
      }

      else {

        var params_cc = {
          account_email: this.dmail,
          appointment_id: this.appointment_id
        }

        this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {
          this.cc_issues = response.op_review.complaint.issues

          var delete_params = {
            "account_email": this.dmail,
            "doctor_id": this.doc_id,
            "simple_complaint": {
              "user_type": "doctor",
              "issues": [],
              "new_issues": [

              ],
              "delete_issues": response.op_review.complaint.issues,
              "days": "",
              "medicine_given": "",
              "temperature": "",
              "unit": "",
              "other_information": "",
              "patient_email": this.patient.record_info.Record.account_email,
              "appointment_id": this.appointment_id,
              "complaint_id": this.complaint_id
            }
          }

          this.appService.postData(this.urlPoints.updateComplaint, delete_params, this.token).subscribe((response: any) => {

            var new_issues = []

            for (var i = 0; i < this.cc_selected.length; i++) {
              new_issues.push(
                {
                  "category_id": this.cc_selected[i].id,
                  "complaint_category_id": this.cc_selected[i].id,
                  "complaint_type": this.cc_selected[i].name,

                  "is_question": this.cc_selected[i].is_question ? 1 : 0,

                  "details": [
                    {
                      "questions": "",
                      "answers": ""
                    }
                  ]
                }

              )
            }

            var params2 = {
              "account_email": this.dmail,
              "doctor_id": this.doc_id,
              "simple_complaint": {
                "user_type": "doctor",
                "issues": [],
                "new_issues": new_issues,
                "days": "",
                "medicine_given": "",
                "temperature": "",
                "unit": "",
                "other_information": "",
                "patient_email": this.patient.record_info.Record.account_email,
                "appointment_id": this.appointment_id,
                "complaint_id": this.complaint_id
              }
            }

            this.appService.postData(this.urlPoints.updateComplaint, params2, this.token).subscribe((response: any) => {
              this.save_add1()
            });
          });


        });
      }

      // for (var i = 0; i < length; i++) {
      //   if (this.complaint_id)
      //     this.update_cc_freq(0, 0)
      //   else {

      //     var index1 = this.chief_complaints.indexOf(this.cc_copy1[i]);
      //     this.cc_selected.push(this.chief_complaints[index1]);

      //     this.cc_issues.push({
      //       "category_id": this.cc_copy1[i].id,
      //       "complaint_category_id": this.cc_copy1[i].id,
      //       "complaint_type": this.cc_copy1[i].name,
      //       "details": [
      //         {
      //           "questions": "",
      //           "answers": ""
      //         }
      //       ]
      //     })
      //   }
      // }

      // if (!this.complaint_id) {
      //   var params1 = {
      //     "account_email": this.dmail,
      //     "doctor_id": this.doc_id,
      //     "simple_complaint": {
      //       "user_type": "doctor",
      //       "issues": this.cc_issues,
      //       "days": "",
      //       "medicine_given": "",
      //       "temperature": "",
      //       "unit": "",
      //       "other_information": "",
      //       "patient_email": this.patient.record_info.Record.account_email,
      //       "appointment_id": this.appointment_id
      //     }
      //   }

      //   this.appService.postData(this.urlPoints.simpleComplaint, params1, this.token).subscribe((response: any) => {
      //     this.complaint_id = response.complaint.id;
      //     this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)

      //     this.save_add1()
      //   });
      // }

      this.ex_selected = (response.details[0]).examination;
      this.inv_selected = (response.details[0]).investigation;

      var count = 0

      for (var i = 0; i < this.inv_selected.length; i++) {
        var invparams = {
          account_email: this.dmail,
          patient_email: this.patient.record_info.Record.account_email,
          appointment_id: this.appointment_id,
          data: [{
            title: this.inv_selected[i].name
          }]
        }

        // var exists=false

        // console.log(this.lab_ids)

        // for(var j=0;j<this.lab_ids.length;j++)
        // {

        //   console.log(this.inv_selected[i].investigation_id)

        //   console.log(this.lab_ids[j].lab_id)

        //   if(this.lab_ids[j].inv_id==this.inv_selected[i].investigation_id)
        //   {
        //     exists = true
        //   }

        //   console.log(exists)
        // }

        //   if(!exists)
        this.appService.postData(this.urlPoints.createLabDetails, invparams, this.token).subscribe((response: any) => {


          console.log(count)

          console.log(this.inv_selected[count])

          this.lab_ids.push(
            // response.message[0].id
            {
              inv_id: this.inv_selected[count].investigation_id,
              lab_id: response.message[0].id
            }
          )
          count++

          console.log(this.lab_ids)
        });
      }

      console.log(response.details[0].medicine)

      var result1 = response.details[0].medicine

      this.pres_selected_copy1 = Object.assign([], this.pres_selected);

      this.pres_selected = []

      for (var i = 0; i < result1.length; i++) {

        var result = result1[i]


        if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

          if (result.when == 'After Food') {
            result.when = 'AF'
          }

          if (result.when == 'Before Food') {
            result.when = 'BF'
          }

          if (result.when == 'Not Related to Food') {
            result.when = 'NRF'
          }

          if (result.when == 'With Food') {
            result.when = 'WF'
          }
        }


        this.medication = result1[i];

        if (this.prescription_id != undefined) {


          this.pres_count++;

          this.medication.operation = 'add'

          this.medication.pres_id = this.pres_count;

          var unit = this.medication.quantity.split(' ')[1]

          var freq_arr = this.medication.frequency.split('-')

          if (freq_arr.length == 4) {
            var morning = freq_arr[0].trim().split(' ')[0]

            var afternoon = freq_arr[1].trim().split(' ')[0]

            var evening = freq_arr[2].trim().split(' ')[0]

            var night = freq_arr[3].trim().split(' ')[0]

            if (this.showUnits) {
              var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }


              var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

              if (unit == 'mole' || unit == 'millimole') {
                var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                freq = shortFreq
              }

              if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }
              }

            }
            else {
              var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
              var shortFreq = freq
            }
            this.medication.frequency = freq
            this.medication.shortFreq = shortFreq
          }
          else if (freq_arr.length == 2) {
            var shortUnit = ''

            if (unit == 'milliliter') {
              shortUnit = 'ml'
            }

            else if (unit == 'Tablet') {
              shortUnit = 'Tablet'
            }

            else if (unit == 'microgram') {
              shortUnit = 'mcg'
            }

            else if (unit == 'milligram') {
              shortUnit = 'mg'
            }

            else if (unit == 'gram') {
              shortUnit = 'grm'
            }


            else if (unit == 'drops') {
              shortUnit = 'drops'
            }

            else if (unit == 'Sachets/Packets') {
              shortUnit = 'pkt'
            }

            if (this.showUnits) {
              var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

              this.medication.frequency = freq1 + ' ' + unit

              this.medication.shortFreq = freq1 + ' ' + shortUnit
            }
            else {
              var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

              this.medication.shortFreq = freq1

            }

          }

          else {

            console.log('else')

            var freq1: any = this.medication.frequency

            this.medication.shortFreq = freq1
          }

          this.pres_selected.push(this.medication);

          console.log(this.pres_selected)

          var obj = {
            drug_id: this.medication.id,
            dose: this.medication.dose,
            dose_option: this.medication.dose_option,
            frequency: this.medication.frequency,
            route: this.medication.route,
            when: this.medication.when,
            duration: this.medication.duration.toString(),
            duration_type: this.medication.duration_type,
            quantity: this.medication.quantity,
            special_instruction: this.medication.special_instruction,
            minimum_buyable_qty: this.medication.minimum_buyable_qty,
            operation: 'add',
            pres_id: this.pres_count,
            dose_details: this.medication.dose_details
          }

          this.pres_entries.push(obj)

        }
        else {

          console.log(22)

          this.pres_count++;

          this.medication.pres_id = this.pres_count;

          var unit = this.medication.quantity.split(' ')[1]

          var freq_arr = this.medication.frequency.split('-')

          console.log(freq_arr.length)

          if (freq_arr.length == 4) {
            var morning = freq_arr[0].trim().split(' ')[0]

            var afternoon = freq_arr[1].trim().split(' ')[0]

            var evening = freq_arr[2].trim().split(' ')[0]

            var night = freq_arr[3].trim().split(' ')[0]

            if (this.showUnits) {
              var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }


              var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

              if (unit == 'mole' || unit == 'millimole') {
                var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                freq = shortFreq
              }

              if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }
              }

            }
            else {
              var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

              var shortFreq = freq

            }
            this.medication.frequency = freq
            this.medication.shortFreq = shortFreq


          }
          else if (freq_arr.length == 2) {
            var shortUnit = ''

            if (unit == 'milliliter') {
              shortUnit = 'ml'
            }

            else if (unit == 'Tablet') {
              shortUnit = 'Tablet'
            }

            else if (unit == 'microgram') {
              shortUnit = 'mcg'
            }

            else if (unit == 'milligram') {
              shortUnit = 'mg'
            }

            else if (unit == 'gram') {
              shortUnit = 'grm'
            }


            else if (unit == 'drops') {
              shortUnit = 'drops'
            }

            else if (unit == 'Sachets/Packets') {
              shortUnit = 'pkt'
            }

            if (this.showUnits) {
              var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()


              this.medication.frequency = freq1 + ' ' + unit

              this.medication.shortFreq = freq1 + ' ' + shortUnit
            }
            else {
              var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

              this.medication.shortFreq = freq1

            }


          }
          else {
            var freq1: any = this.medication.frequency

            this.medication.shortFreq = freq1

          }


          this.pres_selected.push(this.medication);

          var obj1 = {
            drug_id: this.medication.id,
            dose: this.medication.dose,
            dose_option: this.medication.dose_option,
            frequency: this.medication.frequency,
            route: this.medication.route,
            when: this.medication.when,
            duration: this.medication.duration.toString(),
            duration_type: this.medication.duration_type,
            quantity: this.medication.quantity,
            special_instruction: this.medication.special_instruction,
            minimum_buyable_qty: this.medication.minimum_buyable_qty,
            dose_details: this.medication.dose_details,
            pres_id: this.pres_count,
            operation: 'add',

          }

          this.pres_entries.push(obj1)

          console.log(this.pres_entries)

          //  this.addPres();
        }

        if (i == result1.length - 1) {
          console.log('herelength')
          if (this.prescription_id) {
            console.log('here')
            for (var i = 0; i < this.pres_entries.length; i++) {
              this.pres_entries[i].operation = 'delete'
            }

            var params2 = {
              "account_email": this.dmail, doctor_id: this.doc_id,
              "prescription": {
                "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
                "entries": this.pres_entries
              }
            }

            this.appService.postData(this.urlPoints.updatePres, params2, this.token).subscribe((response: any) => {
              this.preview_id = response.id

              this.pres_entries = []

              for (var i = 0; i < this.pres_selected.length; i++) {
                this.pres_count++;
                var obj = {
                  drug_id: this.pres_selected[i].id,
                  dose: this.pres_selected[i].dose,
                  dose_option: this.pres_selected[i].dose_option,
                  frequency: this.pres_selected[i].frequency,
                  route: this.pres_selected[i].route,
                  when: this.pres_selected[i].when,
                  duration: this.pres_selected[i].duration.toString(),
                  duration_type: this.pres_selected[i].duration_type,
                  quantity: this.pres_selected[i].quantity,
                  special_instruction: this.pres_selected[i].special_instruction,
                  minimum_buyable_qty: this.pres_selected[i].minimum_buyable_qty,
                  operation: 'add',
                  pres_id: this.pres_count
                }

                this.pres_entries.push(obj)
              }

              var params3 = {
                "account_email": this.dmail, doctor_id: this.doc_id,
                "prescription": {
                  "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
                  "entries": this.pres_entries
                }
              }

              this.appService.postData(this.urlPoints.updatePres, params3, this.token).subscribe((response: any) => {
                this.preview_id = response.id
                this.save_add1()

              })
            });

          }
          else {
            this.addPres()
          }
        }


      }


      this.diag_selected = (response.details[0]).diagnosis;
      this.getDiagCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)


      this.adv_selected = (response.details[0]).instruction;

      var adv_names = []

      for (var k = 0; k < this.adv_selected.length; k++) {
        adv_names.push(this.adv_selected[k].instructions)
      }

      this.adv_names = adv_names.join(',');

      var inv_names = []

      for (var k = 0; k < this.inv_selected.length; k++) {
        inv_names.push(this.inv_selected[k].name)
      }

      this.inv_names = inv_names.join(',');


      var diag_names = []

      for (var k = 0; k < this.diag_selected.length; k++) {
        diag_names.push(this.diag_selected[k].name)
      }

      this.diag_names = diag_names.join(',')

      this.save_add1()
    })
  }

  tempChange1() {
  }


  resetConsultation() {
    this.cc_selected = []
    this.ex_selected = []
    this.diag_selected = []
    this.inv_selected = []
    this.pres_selected = []
    this.adv_selected = [];


    if (this.complaint_id) {

      var params_cc = {
        account_email: this.dmail,
        appointment_id: this.appointment_id
      }

      this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {
        this.cc_issues = response.op_review.complaint.issues

        var delete_params = {
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "simple_complaint": {
            "user_type": "doctor",
            "issues": [],
            "new_issues": [

            ],
            "delete_issues": response.op_review.complaint.issues,
            "days": "",
            "medicine_given": "",
            "temperature": "",
            "unit": "",
            "other_information": "",
            "patient_email": this.patient.record_info.Record.account_email,
            "appointment_id": this.appointment_id,
            "complaint_id": this.complaint_id
          }
        }

        this.appService.postData(this.urlPoints.updateComplaint, delete_params, this.token).subscribe((response: any) => {

        });




      });


    }

    if (this.prescription_id) {

      for (var i = 0; i < this.pres_entries.length; i++) {
        this.pres_entries[i].operation = 'delete'
      }

      var paramsPres = {
        "account_email": this.dmail, doctor_id: this.doc_id,
        "prescription": {
          "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
          "entries": this.pres_entries
        }
      }

      this.appService.postData(this.urlPoints.updatePres, paramsPres, this.token).subscribe((response: any) => {
        this.preview_id = response.id

        this.pres_entries = []

        for (var i = 0; i < this.pres_selected.length; i++) {
          this.pres_count++;
          var obj = {
            drug_id: this.pres_selected[i].id,
            dose: this.pres_selected[i].dose,
            dose_option: this.pres_selected[i].dose_option,
            frequency: this.pres_selected[i].frequency,
            route: this.pres_selected[i].route,
            when: this.pres_selected[i].when,
            duration: this.pres_selected[i].duration.toString(),
            duration_type: this.pres_selected[i].duration_type,
            quantity: this.pres_selected[i].quantity,
            special_instruction: this.pres_selected[i].special_instruction,
            minimum_buyable_qty: this.pres_selected[i].minimum_buyable_qty,
            operation: 'add',
            pres_id: this.pres_count
          }

          this.pres_entries.push(obj)
        }

        var params = {
          "account_email": this.dmail, doctor_id: this.doc_id,
          "prescription": {
            "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
            "entries": this.pres_entries
          }
        }

        this.appService.postData(this.urlPoints.updatePres, params, this.token).subscribe((response: any) => {
          this.preview_id = response.id
          this.save_add1()

        })
      });
    }

    this.save_add1()
  }

  getVitalsData(vitalsData, type?) {


    if (this.patient.demographics.gender === "male") {
      this.gender = 0;
    }
    else {
      this.gender = 1;
    }


    if (type != 1)
      this.checkStatus('onloading');

  }

  openWindow(url) {
    window.open(url)
  }

  printGraph() {

    let printContents, popupWin;
    printContents = (document.getElementById('iframes') as HTMLDivElement).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #if1,#if3 {
            width: 100rem;
            height: 100rem;
            -webkit-transform:scale(0.5);
            -moz-transform:scale(0.5);
            -o-transform:scale(0.5);
            transform:scale(0.5);
            top:-20rem;
            left:-20rem;
        
            position: absolute;
          }
        
          #if2,#if4 {
            width: 100rem;
            height: 100rem;
            -webkit-transform:scale(0.5);
            -moz-transform:scale(0.5);
            -o-transform:scale(0.5);
            transform:scale(0.5);
            top:20rem;
            left:-20rem;
            position: absolute;
          }
        
          #if5 {
            width: 100rem;
            height: 100rem;
            -webkit-transform:scale(0.5);
            -moz-transform:scale(0.5);
            -o-transform:scale(0.5);
            transform:scale(0.5);
            top:60rem;
            left:-20rem;
            position: absolute;
          }
        
        .select{
            justify-content: space-between;
        }
        
        .iframes{
            display: flex;
            flex-direction: row;
            justify-content: space-around;
        }
        
        .iframes div{
            height: 25rem;
            width: 25rem;
        }        
        
        #p1{
          position: absolute;
          top: 1rem;
      }
      
      #p2{
          position: absolute;
          top: 1rem;
          left: 34rem;
      }
      
      #p3{
          position: absolute;
          top: 1rem;
          left: 5rem;
      }
      
      #p4{
          position: absolute;
          top: 40rem;
          left: 5rem;
      }
      
      #p5{
          position: absolute;
          top: 79rem;
          left: 5rem;
      }
      p{
        font-family: 'Poppins', sans-serif;
      }
        </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
  }

  getTagsList() {
    this.params = {
      mode: 0
    }

    this.appService.getTags(this.urlPoints.tagsList, this.params).subscribe((response: any) => {
      this.tags = response.smartpres.data;
    });
  }

  onScroll() {

    var token = this.token;
    this.cc_page++;

    var params = {
      account_email: this.dmail,
      page_no: this.cc_page,
      alphabet: this.chars1.toUpperCase(),
      "doctor_id": this.doc_id
    }

    this.getCC(this.urlPoints.getCC, params, token)

  }

  onScroll3() {

    var token = this.token;
    this.diag_page++;
    if (this.diag_toggle == 'alp') {
      var params = {
        account_email: this.dmail,
        page_no: this.diag_page,
        alphabet: this.chars3.toUpperCase(),
        doctor_id: this.doc_id
      }
      this.getDiag(this.urlPoints.getDiag, params, token)

    }
    else {
      var params1 = {
        account_email: this.dmail,
        page_no: this.diag_page,
        symptoms_id: this.ids.toString(),
        doctor_id: this.doc_id
      }

      this.getDiag(this.urlPoints.getDiag, params1, token)
    }
  }

  callvaccination() {
    // http://localhost:4200/#/?id=19db6e56-1d75-4c2f-bce0-7857a282e082&dmail=rx4@rxcarenet.org&did=3&mode=1&token=b2F1dGhfdG9rZW49U1lRVTlNRjNmaG53VGJVbUpIOHEmb2F1dGhfdG9rZW5fc2VjcmV0PXlSblVmYWFUV3ZLYmptWlpVd3VpJmFjY291bnRfaWQ9cng0JTQwcnhjYXJlbmV0Lm9yZw%3D%3D
    this.router.navigate(["/vaccination"], { queryParams: { mode: "1", token: this.token, dmail: this.dmail, patientdob: this.patient.demographics.bday, patientemail: this.patient.record_info.Record.account_email, id: this.id, did: this.doc_id } });
  }

  onScroll4() {
    var token = this.token;
    this.inv_page++;
    if (this.inv_toggle == 'alp') {
      var params = {
        account_email: this.dmail,
        page_no: this.inv_page,
        alphabet: this.chars4.toUpperCase(),
        doctor_id: this.doc_id
      }
      this.getInv(this.urlPoints.getInv, params, token)

    }
    else {
      var params1 = {
        account_email: this.dmail,
        page_no: this.inv_page,
        diagnosis_id: this.ids_diag.toString(),
        doctor_id: this.doc_id
      }

      this.getInv(this.urlPoints.getInv, params1, token)
    }
  }

  onScroll5() {
    var token = this.token;
    this.pres_page++;
    if (this.pres_toggle == 'alp') {
      var params = {
        account_email: this.dmail,
        page_no: this.pres_page,
        alphabet: this.chars5.toUpperCase(),
        doctor_id: this.doc_id
      }

      this.getPres(this.urlPoints.getPres, params, token)

    }
    else {
      var params1 = {
        account_email: this.dmail,
        page_no: this.pres_page,
        diagnosis_id: this.ids_diag.toString(),
        doctor_id: this.doc_id
      }

      this.getPres(this.urlPoints.getPres, params1, token)
    }
  }

  onScroll6() {
    var token = this.token;
    this.adv_page++;
    if (this.adv_toggle == 'alp') {
      var params = {
        account_email: this.dmail,
        page_no: this.adv_page,
        alphabet: this.chars6.toUpperCase(),
        doctor_id: this.doc_id
      }

      this.getAdv(this.urlPoints.getAdv, params, token)

    }
    else {
      var params1 = {
        account_email: this.dmail,
        page_no: this.adv_page,
        diagnosis_id: this.ids_diag.toString(),
        doctor_id: this.doc_id
      }

      this.getAdv(this.urlPoints.getAdv, params1, token)
    }
  }

  onScrollDown(ev) {
  }

  onUp(ev) {
  }

  getPatient() {

  }

  getTagsList1() {
    var params = {
      mode: 0
    }

    this.appService.getTags(this.urlPoints.tagsList1, params).subscribe((response: any) => {
      this.tags1 = response.smartpres.data;
    });
  }

  filter(value) {
    this.temp = this.templates.filter(
      (val) => val.includes(value))
  }

  ccDoubtChange() {
    this.ccDoubt = !this.ccDoubt
  }

  exDoubtChange() {
    this.exDoubt = !this.exDoubt
  }

  diagDoubtChange() {
    this.diagDoubt = !this.diagDoubt
  }

  invDoubtChange() {
    this.invDoubt = !this.invDoubt
  }

  advDoubtChange() {
    this.advDoubt = !this.advDoubt
  }

  update_cc(index, i, voice?) {

    this.end = false;

    this.clear = !this.clear

    var exists = false

    this.chars1Arr = []
    this.chars1 = ''

    for (var j = 0; j < this.cc_selected.length; j++) {
      if (this.cc_selected[j].name.trim().toLowerCase() == this.cc_copy1[index].name.trim().toLowerCase()) {
        exists = true
      }
    }

    if (!exists) {
      this.highlight_cc = true

      var index1 = this.chief_complaints.indexOf(this.cc_copy1[index]);
      this.cc_selected.push(this.cc_copy1[index]);



      if (i == 1) {
        this.new_cc_ids.push(this.cc_copy1[index].symptoms_id)
        this.new_cc_names.push(this.cc_copy1[index].name)
      }

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_copy1[index].name,
          reference_word: this.chars1_copy,
          word_type: 1,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.chief_complaints[index1].name + ' when you type ' + this.chars1_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      this.printArr = [];

      if (!this.complaint_id) {

        this.cc_issues = [
          {
            "category_id": this.chief_complaints[index1].id,
            "complaint_category_id": this.chief_complaints[index1].id,
            "complaint_type": this.chief_complaints[index1].name,

            "is_question": this.ccDoubt ? 1 : 0,


            "details": [
              {
                "questions": "",
                "answers": ""
              }
            ]
          },
        ];

        var params1 = {
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "simple_complaint": {
            "user_type": "doctor",
            "issues": this.cc_issues,
            "days": "",
            "medicine_given": "",
            "temperature": "",
            "unit": "",
            "other_information": "",
            "patient_email": this.patient.record_info.Record.account_email,
            "appointment_id": this.appointment_id
          }
        }

        this.appService.postData(this.urlPoints.simpleComplaint, params1, this.token).subscribe((response: any) => {
          this.complaint_id = response.complaint.id;
          this.save_follow1()
        });
      }
      else {
        var id = this.cc_copy1[index].id
        var name = this.cc_copy1[index].name
        var params_cc = {
          account_email: this.dmail,
          appointment_id: this.appointment_id
        }

        this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {

          this.cc_issues = response.op_review.complaint.issues

          var params2 = {
            "account_email": this.dmail,
            "doctor_id": this.doc_id,
            "simple_complaint": {
              "user_type": "doctor",
              "issues": this.cc_issues,
              "new_issues": [
                {
                  "category_id": id,
                  "complaint_category_id": id,
                  "complaint_type": name,

                  "is_question": this.ccDoubt ? 1 : 0,

                  "details": [
                    {
                      "questions": "",
                      "answers": ""
                    }
                  ]
                }
              ],
              "days": "",
              "medicine_given": "",
              "temperature": "",
              "unit": "",
              "other_information": "",
              "patient_email": this.patient.record_info.Record.account_email,
              "appointment_id": this.appointment_id,
              "complaint_id": this.complaint_id
            }
          }

          this.appService.postData(this.urlPoints.updateComplaint, params2, this.token).subscribe((response: any) => {
            this.save_follow1()
          });
        });



        this.cc_issues.push({
          "category_id": this.cc_copy1[index].id,
          "complaint_category_id": this.cc_copy1[index].id,
          "complaint_type": this.cc_copy1[index].name,
          "details": [
            {
              "questions": "",
              "answers": ""
            }
          ]
        })
      }


      this.cc_copy1.splice(index, 1);
      this.ids_cc = [];
      this.ids_string_cc;

      for (var k = 0; k < this.cc_selected.length; k++) {
        this.ids_cc.push(this.cc_selected[k].symptoms_id)
      }

      this.ids = this.ids_cc.concat(this.ids_ex);
      var ids_string = this.ids.toString();

      this.ids_string_cc = this.ids_cc.toString();

      var params = {
        account_email: this.dmail,
        page_no: 1,
        symptoms_id: ids_string,
        doctor_id: this.doc_id
      }

      this.diag_data = []
      this.getDiag(this.urlPoints.getDiag, params, this.token);

      if (this.ccDoubt)
        this.cc_selected[this.cc_selected.length - 1].name = "?" + this.cc_selected[this.cc_selected.length - 1].name
    }
    else {

      if (!voice) {
        // this.toastr.error(this.cc_copy1[index].name + " has been already added")
      }

    }
  }

  update_cc2(index, i) {

    this.end = false;

    var exists = false
    // alert()

    for (var j = 0; j < this.cc_selected.length; j++) {
      if (this.cc_selected[j].name.trim().toLowerCase() == this.cc_copy2[index].name.trim().toLowerCase()) {
        exists = true
      }
    }

    if (!exists) {

      var index1 = this.chief_complaints2.indexOf(this.cc_copy2[index]);
      this.cc_selected.push(this.chief_complaints2[index1]);

      //  this.set('cc')


      if (i == 1) {
        this.new_cc_ids.push(this.chief_complaints2[index1].symptoms_id)
        this.new_cc_names.push(this.chief_complaints2[index1].name)
      }

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.chief_complaints2[index1].name,
          reference_word: this.chars1_copy,
          word_type: 1,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.chief_complaints2[index1].name + ' when you type ' + this.chars1_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              //  this.add=false
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      this.printArr = [];

      if (!this.complaint_id) {

        this.cc_issues = [
          {
            "category_id": this.chief_complaints2[index1].id,
            "complaint_category_id": this.chief_complaints2[index1].id,
            "complaint_type": this.chief_complaints2[index1].name,
            "details": [
              {
                "questions": "",
                "answers": ""
              }
            ]
          },
        ];

        var params1 = {
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "simple_complaint": {
            "user_type": "doctor",
            "issues": this.cc_issues,
            "days": "",
            "medicine_given": "",
            "temperature": "",
            "unit": "",
            "other_information": "",
            "patient_email": this.patient.record_info.Record.account_email,
            "appointment_id": this.appointment_id
          }
        }

        // this.appService.postData(this.urlPoints.simpleComplaint, params1, this.token).subscribe((response: any) => {
        //   this.complaint_id = response.complaint.id;
        // });
      }
      else {

        var params_cc = {
          account_email: this.dmail,
          appointment_id: this.appointment_id
        }

        this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {

          this.cc_issues = response.op_review.complaint.issues

          var params2 = {
            "account_email": this.dmail,
            "doctor_id": this.doc_id,
            "simple_complaint": {
              "user_type": "doctor",
              "issues": this.cc_issues,
              "new_issues": [
                {
                  "category_id": this.chief_complaints2[index1].id,
                  "complaint_category_id": this.chief_complaints2[index1].id,
                  "complaint_type": this.chief_complaints2[index1].name,
                  "details": [
                    {
                      "questions": "",
                      "answers": ""
                    }
                  ]
                }
              ],
              "days": "",
              "medicine_given": "",
              "temperature": "",
              "unit": "",
              "other_information": "",
              "patient_email": this.patient.record_info.Record.account_email,
              "appointment_id": this.appointment_id,
              "complaint_id": this.complaint_id
            }
          }

          // this.appService.postData(this.urlPoints.updateComplaint, params2, this.token).subscribe((response: any) => {
          // });
        });



        this.cc_issues.push({
          "category_id": this.cc_copy2[index].id,
          "complaint_category_id": this.cc_copy2[index].id,
          "complaint_type": this.cc_copy2[index].name,
          "details": [
            {
              "questions": "",
              "answers": ""
            }
          ]
        })
      }


      this.cc_copy2.splice(index, 1);
      this.ids_cc = [];
      this.ids_string_cc;

      for (var k = 0; k < this.cc_selected.length; k++) {
        this.ids_cc.push(this.cc_selected[k].symptoms_id)
      }

      this.ids = this.ids_cc.concat(this.ids_ex);
      var ids_string = this.ids.toString();

      this.ids_string_cc = this.ids_cc.toString();

      var params = {
        account_email: this.dmail,
        page_no: 1,
        symptoms_id: ids_string,
        doctor_id: this.doc_id
      }

      this.diag_data = []
      this.getDiag(this.urlPoints.getDiag, params, this.token);
    }
    else {
      // this.toastr.error(this.cc_copy2[index].name + " has been already added")
    }
    this.save_follow1()

  }

  update_cc_freq(index, i) {

    this.end = false;

    var exists = false

    for (var j = 0; j < this.cc_selected.length; j++) {
      if (this.cc_selected[j].name.trim().toLowerCase() == this.cc_copy1[index].name.trim().toLowerCase()) {
        exists = true
      }
    }

    if (!exists) {

      var index1 = this.chief_complaints.indexOf(this.cc_copy1[index]);
      this.cc_selected.push(this.chief_complaints[index1]);

      if (i == 1) {
        this.new_cc_ids.push(this.chief_complaints[index1].symptoms_id)
        this.new_cc_names.push(this.chief_complaints[index1].name)
      }

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.chief_complaints[index1].name,
          reference_word: this.chars1_copy,
          word_type: 1,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.chief_complaints[index1].name + ' when you type ' + this.chars1_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              //  this.add=false
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      this.printArr = [];

      if (!this.complaint_id) {

        this.cc_issues = [
          {
            "category_id": this.chief_complaints[index1].id,
            "complaint_category_id": this.chief_complaints[index1].id,
            "complaint_type": this.chief_complaints[index1].name,
            "details": [
              {
                "questions": "",
                "answers": ""
              }
            ]
          },
        ];

        var params1 = {
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "simple_complaint": {
            "user_type": "doctor",
            "issues": this.cc_issues,
            "days": "",
            "medicine_given": "",
            "temperature": "",
            "unit": "",
            "other_information": "",
            "patient_email": this.patient.record_info.Record.account_email,
            "appointment_id": this.appointment_id
          }
        }

        this.appService.postData(this.urlPoints.simpleComplaint, params1, this.token).subscribe((response: any) => {
          this.complaint_id = response.complaint.id;
          this.save_follow1()
        });
      }
      else {

        var params_cc = {
          account_email: this.dmail,
          appointment_id: this.appointment_id
        }

        this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {
          // response.op_review.complaint.issues
          this.cc_issues = response.op_review.complaint.issues

          var params2 = {
            "account_email": this.dmail,
            "doctor_id": this.doc_id,
            "simple_complaint": {
              "user_type": "doctor",
              "issues": this.cc_issues,
              "new_issues": [
                {
                  "category_id": this.chief_complaints[index1].id,
                  "complaint_category_id": this.chief_complaints[index1].id,
                  "complaint_type": this.chief_complaints[index1].name,
                  "details": [
                    {
                      "questions": "",
                      "answers": ""
                    }
                  ]
                }
              ],
              "days": "",
              "medicine_given": "",
              "temperature": "",
              "unit": "",
              "other_information": "",
              "patient_email": this.patient.record_info.Record.account_email,
              "appointment_id": this.appointment_id,
              "complaint_id": this.complaint_id
            }
          }

          this.appService.postData(this.urlPoints.updateComplaint, params2, this.token).subscribe((response: any) => {
            this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)

            this.save_follow1()
          });
        });



        this.cc_issues.push({
          "category_id": this.cc_copy1[index].id,
          "complaint_category_id": this.cc_copy1[index].id,
          "complaint_type": this.cc_copy1[index].name,
          "details": [
            {
              "questions": "",
              "answers": ""
            }
          ]
        })
      }


      this.cc_copy1.splice(index, 1);
      this.ids_cc = [];
      this.ids_string_cc;

      for (var k = 0; k < this.cc_selected.length; k++) {
        this.ids_cc.push(this.cc_selected[k].symptoms_id)
      }

      this.ids = this.ids_cc.concat(this.ids_ex);
      var ids_string = this.ids.toString();

      this.ids_string_cc = this.ids_cc.toString();

      var params = {
        account_email: this.dmail,
        page_no: 1,
        symptoms_id: ids_string,
        doctor_id: this.doc_id
      }

      this.diag_data = []
      this.getDiag(this.urlPoints.getDiag, params, this.token);
    }
    else {
      // this.toastr.error(this.cc_copy1[index].name + " has been already added")

    }
  }

  update_cc_voice(index, i) {

    this.end = false;

    this.clear = !this.clear

    var exists = false

    this.chars1Arr = []
    this.chars1 = ''

    for (var j = 0; j < this.cc_selected.length; j++) {
      if (this.cc_selected[j].name.trim().toLowerCase() == this.cc_copy1[index].name.trim().toLowerCase()) {
        exists = true
      }
    }

    if (!exists) {
      this.highlight_cc = true

      var index1 = this.chief_complaints.indexOf(this.cc_copy1[index]);
      this.cc_selected.push(this.cc_copy1[index]);



      if (i == 1) {
        this.new_cc_ids.push(this.cc_copy1[index].symptoms_id)
        this.new_cc_names.push(this.cc_copy1[index].name)
      }

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_copy1[index].name,
          reference_word: this.chars1_copy,
          word_type: 1,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.chief_complaints[index1].name + ' when you type ' + this.chars1_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      this.printArr = [];

      if (!this.complaint_id) {

        this.cc_issues = [
          {
            "category_id": this.chief_complaints[index1].id,
            "complaint_category_id": this.chief_complaints[index1].id,
            "complaint_type": this.chief_complaints[index1].name,

            "is_question": this.ccDoubt ? 1 : 0,


            "details": [
              {
                "questions": "",
                "answers": ""
              }
            ]
          },
        ];

        var params1 = {
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "simple_complaint": {
            "user_type": "doctor",
            "issues": this.cc_issues,
            "days": "",
            "medicine_given": "",
            "temperature": "",
            "unit": "",
            "other_information": "",
            "patient_email": this.patient.record_info.Record.account_email,
            "appointment_id": this.appointment_id
          }
        }

        this.appService.postData(this.urlPoints.simpleComplaint, params1, this.token).subscribe((response: any) => {
          this.complaint_id = response.complaint.id;
          this.save_follow1()
        });
      }
      else {
        var id = this.cc_copy1[index].id
        var name = this.cc_copy1[index].name
        var params_cc = {
          account_email: this.dmail,
          appointment_id: this.appointment_id
        }

        this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {

          this.cc_issues = response.op_review.complaint.issues

          var params2 = {
            "account_email": this.dmail,
            "doctor_id": this.doc_id,
            "simple_complaint": {
              "user_type": "doctor",
              "issues": this.cc_issues,
              "new_issues": [
                {
                  "category_id": id,
                  "complaint_category_id": id,
                  "complaint_type": name,

                  "is_question": this.ccDoubt ? 1 : 0,

                  "details": [
                    {
                      "questions": "",
                      "answers": ""
                    }
                  ]
                }
              ],
              "days": "",
              "medicine_given": "",
              "temperature": "",
              "unit": "",
              "other_information": "",
              "patient_email": this.patient.record_info.Record.account_email,
              "appointment_id": this.appointment_id,
              "complaint_id": this.complaint_id
            }
          }

          this.appService.postData(this.urlPoints.updateComplaint, params2, this.token).subscribe((response: any) => {
            this.save_follow1()
          });
        });



        this.cc_issues.push({
          "category_id": this.cc_copy1[index].id,
          "complaint_category_id": this.cc_copy1[index].id,
          "complaint_type": this.cc_copy1[index].name,
          "details": [
            {
              "questions": "",
              "answers": ""
            }
          ]
        })
      }


      this.cc_copy1.splice(index, 1);
      this.ids_cc = [];
      this.ids_string_cc;

      for (var k = 0; k < this.cc_selected.length; k++) {
        this.ids_cc.push(this.cc_selected[k].symptoms_id)
      }

      this.ids = this.ids_cc.concat(this.ids_ex);
      var ids_string = this.ids.toString();

      this.ids_string_cc = this.ids_cc.toString();

      var params = {
        account_email: this.dmail,
        page_no: 1,
        symptoms_id: ids_string,
        doctor_id: this.doc_id
      }

      this.diag_data = []
      this.getDiag(this.urlPoints.getDiag, params, this.token);

      if (this.ccDoubt)
        this.cc_selected[this.cc_selected.length - 1].name = "?" + this.cc_selected[this.cc_selected.length - 1].name
    }
    // else {
    // //  this.toastr.error(this.cc_copy1[index].name + " has been already added")

    // }
  }

  update_ex(index, i) {
    this.end = false

    this.clear = !this.clear

    this.chars2 = ''

    this.chars2Arr = []

    var exists

    for (var j = 0; j < this.ex_selected.length; j++) {
      if (this.ex_selected[j].name.trim().toLowerCase() == this.ex_copy1[index].name.trim().toLowerCase()) {
        exists = true
      }
    }

    if (!exists) {
      this.highlight_ex = true

      var index1 = this.examination.indexOf(this.ex_copy1[index]);
      this.ex_selected.push(this.examination[index1]);

      if (this.exDoubt) {
        this.ex_selected[this.ex_selected.length - 1].name = '?' + this.ex_selected[this.ex_selected.length - 1].name
        this.ex_selected[this.ex_selected.length - 1].question = true
      }
      else {
        this.ex_selected[this.ex_selected.length - 1].question = false
      }

      if (i == 1) {
        this.new_ex_ids.push(this.examination[index1].symptoms_id)
        this.new_ex_names.push(this.examination[index1].name)
      }

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.examination[index1].name,
          reference_word: this.chars2_copy,
          word_type: 2,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.examination[index1].name + ' when you type ' + this.chars2_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {

              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      this.ex_copy1.splice(index, 1);

      var ex_names = []

      this.ids_ex = [];

      for (var k = 0; k < this.ex_selected.length; k++) {
        this.ids_ex.push(this.ex_selected[k].symptoms_id)
      }
      var ex_names = []
      for (var k = 0; k < this.ex_selected.length; k++) {
        ex_names.push(this.ex_selected[k].name)
      }

      this.ex_names = ex_names.join(',')

      this.ids = this.ids_ex.concat(this.ids_cc);
      var ids_string = this.ids.toString();

      var params = {
        account_email: this.dmail,
        page_no: 1,
        symptoms_id: ids_string,
        doctor_id: this.doc_id
      }

      this.diag_data = []

      this.getDiag(this.urlPoints.getDiag, params, this.token)

    }
    else {
      // this.toastr.error(this.ex_copy1[index].name + " has been already added")
    }
    this.save_follow1()


  }

  update_diag(index, i) {
    this.end = false

    var exists;

    this.chars3 = ''

    this.chars3Arr = []

    this.clear = !this.clear

    for (var j = 0; j < this.diag_selected.length; j++) {
      if (this.diag_selected[j].name.trim().toLowerCase() == this.diag_copy1[index].name.trim().toLowerCase()) {
        exists = true
      }
    }

    if (!exists) {

      this.highlight_diag = true

      var index1 = this.diagnosis.indexOf(this.diag_copy1[index]);
      this.diag_selected.push(this.diagnosis[index1]);

      if (this.diagDoubt) {
        this.diag_selected[this.diag_selected.length - 1].name = '?' + this.diag_selected[this.diag_selected.length - 1].name
        this.diag_selected[this.diag_selected.length - 1].question = true
      }
      else {
        this.diag_selected[this.diag_selected.length - 1].question = false
      }

      if (i == 1) {
        this.new_diag_ids.push(this.diagnosis[index1].diagnosis_id)
        this.new_diag_names.push(this.diagnosis[index1].name)
      }

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.diagnosis[index1].name,
          reference_word: this.chars3_copy,
          word_type: 3,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.diagnosis[index1].name + ' when you type ' + this.chars3_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {

              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      this.diag_copy1.splice(index, 1)

      this.ids_diag = [];

      for (var k = 0; k < this.diag_selected.length; k++) {
        this.ids_diag.push(this.diag_selected[k].diagnosis_id)
      }

      var diag_names = []

      for (var k = 0; k < this.diag_selected.length; k++) {
        diag_names.push(this.diag_selected[k].name)
      }

      this.diag_names = diag_names.join(',')

      var string = this.ids_diag.toString();

      var params = {
        account_email: this.dmail,
        page_no: this.diag_page,
        diagnosis_id: string
      }

      var new_names = this.new_cc_names.concat(this.new_ex_names);
      if (new_names.length > 0) {
        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Map ' + new_names.join(',') + ' to ' + this.diagnosis[index1].name + ' ?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {

              var new_params = {
                account_email: this.dmail,
                diagnosis_id: this.diagnosis[index1].diagnosis_id,
                symptoms_id: this.new_cc_ids.concat(this.new_ex_ids)
              }

              this.appService.postData(this.urlPoints.mapDiag, new_params, this.token).subscribe((response: any) => {
              });
            }
            else {
            }
          }
        });
      }
    }
    else {
      // this.toastr.error(this.diag_copy1[index].name + " has been already added")
    }

    this.save_follow1()

  }

  update_inv(index, i, start?) {

    var exists;

    this.clear = !this.clear;

    this.chars4 = ''

    this.chars4Arr = []

    for (var j = 0; j < this.inv_selected.length; j++) {
      if (this.inv_selected[j].name.trim().toLowerCase() == this.inv_copy1[index].name.trim().toLowerCase()) {
        exists = true
      }
    }

    this.end = false
    if (!exists) {

      this.highlight_inv = true


      var index1 = this.investigations.indexOf(this.inv_copy1[index]);
      this.inv_selected.push(this.investigations[index1])
      this.inv_copy1.splice(index, 1);

      if (this.invDoubt) {
        this.inv_selected[this.inv_selected.length - 1].name = '?' + this.inv_selected[this.inv_selected.length - 1].name
        this.inv_selected[this.inv_selected.length - 1].question = true
      }
      else {
        this.inv_selected[this.inv_selected.length - 1].question = false
      }

      if (i == 1) {
        this.new_inv_ids.push(this.investigations[index1].investigation_id)
        this.new_inv_names.push(this.investigations[index1].name)
      }

      var inv_names = []

      for (var k = 0; k < this.inv_selected.length; k++) {
        inv_names.push(this.inv_selected[k].name)
      }

      if (!start) {
        // var invparams = {
        //   account_email: this.dmail,
        //   patient_email: this.patient.record_info.Record.account_email,
        //   appointment_id: this.appointment_id,
        //   data: [{
        //     title: this.investigations[index1].name
        //   }]
        // }

        // this.appService.postData(this.urlPoints.createLabDetails, invparams, this.token).subscribe((response: any) => {
        //   this.lab_ids.push(response.message[0].id)
        // });
      }

      if (start) {
        var params_labreports = {
          account_email: this.dmail,
          patient_email: this.patient.record_info.Record.account_email,
        }

        this.appService.getData(this.urlPoints.labReports, params_labreports, this.token).subscribe((response: any) => {

          for (var i = 0; i < response[0].data.length; i++) {
            if (response[0].data[i].title == this.investigations[index1].name) {
              this.lab_ids.push(response[0].data[i].lab_id)
            }
          }
        });
      }


      this.inv_names = inv_names.join(',')

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.investigations[index1].name,
          reference_word: this.chars4_copy,
          word_type: 4,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.investigations[index1].name + ' when you type ' + this.chars4_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {

              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      if (this.new_diag_names.length > 0) {
        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Map ' + this.new_diag_names.join(',') + ' to ' + this.investigations[index1].name + ' ?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {

              var new_params = {
                account_email: this.dmail,
                investigation_id: this.investigations[index1].investigation_id,
                diagnosis_id: this.new_diag_ids
              }

              this.appService.postData(this.urlPoints.mapInv, new_params, this.token).subscribe((response: any) => {
              });
            }
            else {
            }
          }
        });
      }
    }

    else {
      // this.toastr.error(this.inv_copy1[index].name + " has been already added")
    }

    this.save_follow1();

    var params_labreports = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email,
    }

    this.labreports(this.urlPoints.labReports, params_labreports, this.token)

  }

  update_pres(index, i) {
    this.end = false
    this.highlight_pres = true


    var index1 = this.prescriptions.indexOf(this.pres_copy1[index]);

    if (i == 1) {
      this.new_pres_ids.push(this.prescriptions[index1].medicine_id)
      this.new_pres_names.push(this.prescriptions[index1].name)
    }

    if (!this.popupOpen) {

      this.dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        width: 'fit-content',

        data: { name: this.prescriptions[index1].name, id: this.prescriptions[index1].id, mode: 0, obj: this.prescriptions[index1], text: '', pres_selected: this.pres_selected }
      });

      const sub = this.dialogRef.componentInstance.onRemove.subscribe(() => {

        this.remove_pres(sessionStorage.getItem("removeindex"), sessionStorage.getItem("removeindex"));
      });

      this.popupOpen = true;

      this.chars5Arr = []
      this.chars5 = ''
      this.clear = !this.clear


    }
  }




  update_pres2(result) {

    this.medication = result;

    if (this.prescription_id != undefined) {

      this.pres_count++;

      this.medication.operation = 'add'

      this.medication.pres_id = this.pres_count;

      this.pres_selected.push(this.medication);

      var obj = {
        drug_id: this.medication.id,
        dose: this.medication.dose,
        dose_option: this.medication.dose_option,
        frequency: this.medication.frequency,
        route: this.medication.route,
        when: this.medication.when,
        duration: this.medication.duration.toString(),
        duration_type: this.medication.duration_type,
        quantity: this.medication.quantity,
        special_instruction: this.medication.special_instruction,
        minimum_buyable_qty: this.medication.minimum_buyable_qty,
        operation: 'add',
        pres_id: this.pres_count
      }

      this.pres_entries.push(obj)
      this.updatePres()
    }
    else {

      this.pres_count++;

      this.medication.pres_id = this.pres_count;

      this.pres_selected.push(this.medication);

      var obj1 = {
        drug_id: this.medication.id,
        dose: this.medication.dose,
        dose_option: this.medication.dose_option,
        frequency: this.medication.frequency,
        route: this.medication.route,
        when: this.medication.when,
        duration: this.medication.duration.toString(),
        duration_type: this.medication.duration_type,
        quantity: this.medication.quantity,
        special_instruction: this.medication.special_instruction,
        minimum_buyable_qty: this.medication.minimum_buyable_qty,
        pres_id: this.pres_count
      }

      this.pres_entries.push(obj1)

      this.addPres();
    }
  }

  update_pres3() {

    if (this.prescription_id != undefined) {

      this.updatePres()
    }
    else {
      this.printArr = [];

      var params = {
        "account_email": this.dmail, doctor_id: this.doc_id,
        "prescription": {
          "patient_email": this.patient.record_info.Record.account_email,
          "prescription_id": this.prescription_id,
          "entries": this.pres_entries
        }
      }

      this.appService.postData(this.urlPoints.addPres, params, this.token).subscribe((response: any) => {

        this.prescription_id = response.prescription.id;

        this.save_add()

      });
    }
  }

  update_pres4(result) {
    this.medication = result;

    if (this.prescription_id != undefined) {
      this.pres_selected.push(this.medication);
    }
    else {
      this.pres_selected.push(this.medication);
    }
  }

  update_pres_soap(index, i) {

    this.end = false

    var index1 = this.prescriptions.indexOf(this.pres_copy1[index]);

    if (i == 1) {
      this.new_pres_ids.push(this.prescriptions[index1].medicine_id)
      this.new_pres_names.push(this.prescriptions[index1].name)
    }

    if (!this.popupOpen) {

      this.dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        width: 'fit-content',

        data: { name: this.prescriptions[index1].name, id: this.prescriptions[index1].id, mode: 0, obj: this.prescriptions[index1], text: '', pres_selected: this.pres_selected_soap, addPres: 1 }
      });

      const sub = this.dialogRef.componentInstance.onRemove.subscribe(() => {

        this.pres_selected_soap.splice(Number(sessionStorage.getItem("removeindex")), 1)
      });

      this.popupOpen = true;

      this.chars5Arr = []
      this.chars5 = ''
      this.clear = !this.clear

      this.dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false
        this.chars5Arr = []
        this.chars5 = ''
        this.clear = !this.clear

        if (result.type == 1 || result.type == 3) {
          this.pres_selected_soap.push(result)

          if (result.addPres) {

            this.medication = result;

            if (this.prescription_id != undefined) {

              this.pres_count++;

              this.medication.operation = 'add'

              this.medication.pres_id = this.pres_count;

              var obj = {
                drug_id: this.medication.id,
                dose: this.medication.dose,
                dose_option: this.medication.dose_option,
                frequency: this.medication.frequency,
                route: this.medication.route,
                when: this.medication.when,
                duration: this.medication.duration.toString(),
                duration_type: this.medication.duration_type,
                quantity: this.medication.quantity,
                special_instruction: this.medication.special_instruction,
                minimum_buyable_qty: this.medication.minimum_buyable_qty,
                operation: 'add',
                pres_id: this.pres_count,
                dose_details: this.medication.dose_details
              }

              this.pres_entries.push(obj)
              this.updatePres()

            }
            else {

              this.pres_count++;

              this.medication.pres_id = this.pres_count;

              this.pres_selected.push(this.medication);

              this.pres_selected_soap.push(this.medication);

              var obj1 = {
                drug_id: this.medication.id,
                dose: this.medication.dose,
                dose_option: this.medication.dose_option,
                frequency: this.medication.frequency,
                route: this.medication.route,
                when: this.medication.when,
                duration: this.medication.duration.toString(),
                duration_type: this.medication.duration_type,
                quantity: this.medication.quantity,
                special_instruction: this.medication.special_instruction,
                minimum_buyable_qty: this.medication.minimum_buyable_qty,
                dose_details: this.medication.dose_details,
                pres_id: this.pres_count
              }

              this.pres_entries.push(obj1)

              this.addPres();
            }
          }
        }
      });
    }
  }

  update_pres_cm(index, i) {

    if (!this.popupOpen) {

      this.dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        width: 'fit-content',

        data: { name: this.pres_copy_cm[index].name, id: this.pres_copy_cm[index].id, mode: 0, obj: this.pres_copy_cm[index], text: '', pres_selected: this.pres_selected }
      });

      const sub = this.dialogRef.componentInstance.onRemove.subscribe(() => {

        this.pres_selected.splice(Number(sessionStorage.getItem("removeindex")), 1)
      });

      this.popupOpen = true;

      this.chars5Arr = []
      this.chars5 = ''
      this.clear = !this.clear

      this.dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false
        this.chars5Arr = []
        this.chars5 = ''
        this.clear = !this.clear

        if (result.type == 1 || result.type == 3) {

          this.medication = result


          if (this.prescription_id != undefined) {

            this.pres_count++;

            this.medication.operation = 'add'

            this.medication.pres_id = this.pres_count;

            this.pres_selected.push(this.medication);

            var obj = {
              drug_id: this.medication.id,
              dose: this.medication.dose,
              dose_option: this.medication.dose_option,
              frequency: this.medication.frequency,
              route: this.medication.route,
              when: this.medication.when,
              duration: this.medication.duration.toString(),
              duration_type: this.medication.duration_type,
              quantity: this.medication.quantity,
              special_instruction: this.medication.special_instruction,
              minimum_buyable_qty: this.medication.minimum_buyable_qty,
              operation: 'add',
              pres_id: this.pres_count,
              dose_details: this.medication.dose_details
            }

            this.pres_entries.push(obj)
            this.updatePres()

          }
          else {

            this.pres_count++;

            this.medication.pres_id = this.pres_count;

            this.pres_selected.push(this.medication);

            this.pres_selected_soap.push(this.medication);

            var obj1 = {
              drug_id: this.medication.id,
              dose: this.medication.dose,
              dose_option: this.medication.dose_option,
              frequency: this.medication.frequency,
              route: this.medication.route,
              when: this.medication.when,
              duration: this.medication.duration.toString(),
              duration_type: this.medication.duration_type,
              quantity: this.medication.quantity,
              special_instruction: this.medication.special_instruction,
              minimum_buyable_qty: this.medication.minimum_buyable_qty,
              dose_details: this.medication.dose_details,
              pres_id: this.pres_count
            }

            this.pres_entries.push(obj1)

            this.addPres();
          }
        }
      });
    }
  }

  update_pres_cm1(index, i) {

    if (!this.popupOpen) {

      this.dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        width: 'fit-content',

        data: { name: this.pres_copy_cm1[index].name, id: this.pres_copy_cm1[index].id, mode: 0, obj: this.pres_copy_cm1[index], text: '', pres_selected: this.pres_selected_soap, addPres: 1 }
      });

      const sub = this.dialogRef.componentInstance.onRemove.subscribe(() => {

        this.pres_selected_soap.splice(Number(sessionStorage.getItem("removeindex")), 1)
      });

      this.popupOpen = true;

      this.chars5Arr = []
      this.chars5 = ''
      this.clear = !this.clear

      this.dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false
        this.chars5Arr = []
        this.chars5 = ''
        this.clear = !this.clear

        if (result.type == 1 || result.type == 3) {

          this.medication = result

          this.pres_selected_soap.push(this.medication);

          if (result.addPres) {

            if (this.prescription_id != undefined) {

              this.pres_count++;

              this.medication.operation = 'add'

              this.medication.pres_id = this.pres_count;

              var unit = this.medication.quantity.split(' ')[1]

              var freq_arr = this.medication.frequency.split('-')

              if (freq_arr.length == 4) {
                var morning = freq_arr[0].trim().split(' ')[0]

                var afternoon = freq_arr[1].trim().split(' ')[0]

                var evening = freq_arr[2].trim().split(' ')[0]

                var night = freq_arr[3].trim().split(' ')[0]

                if (this.showUnits) {
                  var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                  var shortUnit = ''

                  if (unit == 'milliliter') {
                    shortUnit = 'ml'
                  }

                  else if (unit == 'Tablet') {
                    shortUnit = 'Tablet'
                  }

                  else if (unit == 'microgram') {
                    shortUnit = 'mcg'
                  }

                  else if (unit == 'milligram') {
                    shortUnit = 'mg'
                  }

                  else if (unit == 'gram') {
                    shortUnit = 'grm'
                  }


                  else if (unit == 'drops') {
                    shortUnit = 'drops'
                  }

                  else if (unit == 'Sachets/Packets') {
                    shortUnit = 'pkt'
                  }


                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }

                }
                else {
                  var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  var shortFreq = freq
                }
                this.medication.frequency = freq
                this.medication.shortFreq = shortFreq
              }
              else {
                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }

                if (this.showUnits) {
                  var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.medication.frequency = freq1 + ' ' + unit

                  this.medication.shortFreq = freq1 + ' ' + shortUnit
                }
                else {
                  var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.medication.shortFreq = freq1

                }

                //  this.medication.shortFreq = this.medication.frequency

              }

              this.pres_selected.push(this.medication);

              var obj = {
                drug_id: this.medication.id,
                dose: this.medication.dose,
                dose_option: this.medication.dose_option,
                frequency: this.medication.frequency,
                route: this.medication.route,
                when: this.medication.when,
                duration: this.medication.duration.toString(),
                duration_type: this.medication.duration_type,
                quantity: this.medication.quantity,
                special_instruction: this.medication.special_instruction,
                minimum_buyable_qty: this.medication.minimum_buyable_qty,
                operation: 'add',
                pres_id: this.pres_count,
                dose_details: this.medication.dose_details
              }

              this.pres_entries.push(obj)
              this.updatePres()

            }
            else {

              this.pres_count++;

              this.medication.pres_id = this.pres_count;

              var unit = this.medication.quantity.split(' ')[1]

              var freq_arr = this.medication.frequency.split('-')

              if (freq_arr.length == 4) {
                var morning = freq_arr[0].trim().split(' ')[0]

                var afternoon = freq_arr[1].trim().split(' ')[0]

                var evening = freq_arr[2].trim().split(' ')[0]

                var night = freq_arr[3].trim().split(' ')[0]

                if (this.showUnits) {
                  var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                  var shortUnit = ''

                  if (unit == 'milliliter') {
                    shortUnit = 'ml'
                  }

                  else if (unit == 'Tablet') {
                    shortUnit = 'Tablet'
                  }

                  else if (unit == 'microgram') {
                    shortUnit = 'mcg'
                  }

                  else if (unit == 'milligram') {
                    shortUnit = 'mg'
                  }

                  else if (unit == 'gram') {
                    shortUnit = 'grm'
                  }


                  else if (unit == 'drops') {
                    shortUnit = 'drops'
                  }

                  else if (unit == 'Sachets/Packets') {
                    shortUnit = 'pkt'
                  }


                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }

                }
                else {
                  var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                  var shortFreq = freq

                }
                this.medication.frequency = freq
                this.medication.shortFreq = shortFreq


              }
              else {
                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }

                if (this.showUnits) {
                  var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()


                  this.medication.frequency = freq1 + ' ' + unit

                  this.medication.shortFreq = freq1 + ' ' + shortUnit
                }
                else {
                  var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.medication.shortFreq = freq1

                }

                //  this.medication.shortFreq = this.medication.frequency

              }


              this.pres_selected.push(this.medication);

              var obj1 = {
                drug_id: this.medication.id,
                dose: this.medication.dose,
                dose_option: this.medication.dose_option,
                frequency: this.medication.frequency,
                route: this.medication.route,
                when: this.medication.when,
                duration: this.medication.duration.toString(),
                duration_type: this.medication.duration_type,
                quantity: this.medication.quantity,
                special_instruction: this.medication.special_instruction,
                minimum_buyable_qty: this.medication.minimum_buyable_qty,
                dose_details: this.medication.dose_details,
                pres_id: this.pres_count
              }

              this.pres_entries.push(obj1)

              this.addPres();
            }

          }
        }
      });
    }
  }


  update_adv(index, i) {

    var exists;
    this.highlight_adv = true;

    this.chars6Arr = []

    this.chars6 = ''

    this.clear = !this.clear

    for (var j = 0; j < this.adv_selected.length; j++) {
      if (this.adv_selected[j].instructions.trim().toLowerCase() == this.adv_copy1[index].instructions.trim().toLowerCase()) {
        exists = true
      }
    }

    this.end = false

    if (!exists) {

      var index1 = this.advice.indexOf(this.adv_copy1[index]);
      this.adv_selected.push(this.advice[index1])
      this.adv_copy1.splice(index, 1)

      if (this.advDoubt) {
        this.adv_selected[this.adv_selected.length - 1].instructions = '?' + this.adv_selected[this.adv_selected.length - 1].instructions
        this.adv_selected[this.adv_selected.length - 1].question = true
      }
      else {
        this.adv_selected[this.adv_selected.length - 1].question = false
      }


      if (i == 1) {
        this.new_adv_ids.push(this.advice[index1].instruction_id)
        this.new_adv_names.push(this.advice[index1].instructions)
      }

      var adv_names = []

      for (var k = 0; k < this.adv_selected.length; k++) {
        adv_names.push(this.adv_selected[k].instructions)
      }

      this.adv_names = adv_names.join(',')

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.advice[index1].instructions,
          reference_word: this.chars6_copy,
          word_type: 5,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.advice[index1].instructions + ' when you type ' + this.chars6_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {

              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      if (this.new_diag_names.length > 0) {
        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Map ' + this.new_diag_names.join(',') + ' to ' + this.advice[index1].instructions + ' ?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {

              var new_params = {
                account_email: this.dmail,
                instruction_id: this.advice[index1].instruction_id,
                diagnosis_id: this.new_diag_ids
              }

              this.appService.postData(this.urlPoints.mapAdv, new_params, this.token).subscribe((response: any) => {
              });
            }
            else {
            }
          }
        });
      }
    }

    else {
      // this.toastr.error(this.adv_copy1[index].instructions + " has been already added")
    }

    this.save_follow1()


  }

  remove_cc(index) {
    this.cc_selected.splice(index, 1)

    var params_cc = {
      account_email: this.dmail,
      appointment_id: this.appointment_id
    }

    this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {
      this.cc_issues = response.op_review.complaint.issues

      var delete_params = {
        "account_email": this.dmail,
        "doctor_id": this.doc_id,
        "simple_complaint": {
          "user_type": "doctor",
          "issues": [],
          "new_issues": [

          ],
          "delete_issues": response.op_review.complaint.issues,
          "days": "",
          "medicine_given": "",
          "temperature": "",
          "unit": "",
          "other_information": "",
          "patient_email": this.patient.record_info.Record.account_email,
          "appointment_id": this.appointment_id,
          "complaint_id": this.complaint_id
        }
      }

      this.appService.postData(this.urlPoints.updateComplaint, delete_params, this.token).subscribe((response: any) => {

        var new_issues = []

        for (var i = 0; i < this.cc_selected.length; i++) {
          new_issues.push(
            {
              "category_id": this.cc_selected[i].id,
              "complaint_category_id": this.cc_selected[i].id,
              "complaint_type": this.cc_selected[i].name,

              "is_question": this.cc_selected[i].is_question ? 1 : 0,

              "details": [
                {
                  "questions": "",
                  "answers": ""
                }
              ]
            }

          )
        }

        var params2 = {
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "simple_complaint": {
            "user_type": "doctor",
            "issues": [],
            "new_issues": new_issues,
            "days": "",
            "medicine_given": "",
            "temperature": "",
            "unit": "",
            "other_information": "",
            "patient_email": this.patient.record_info.Record.account_email,
            "appointment_id": this.appointment_id,
            "complaint_id": this.complaint_id
          }
        }

        this.appService.postData(this.urlPoints.updateComplaint, params2, this.token).subscribe((response: any) => {
          this.save_add1()
        });
      });


    });

  }

  remove_ex(index) {
    this.ex_selected.splice(index, 1)
    this.add_update()
  }

  remove_diag(index) {
    this.diag_selected.splice(index, 1)
    this.add_update()
  }

  remove_inv(index) {

    console.log('here')

    var id = this.inv_selected[index].investigation_id

    console.log(id)

    for (var i = 0; i < this.lab_ids.length; i++) {

      console.log(this.lab_ids[i].inv_id)

      if (this.lab_ids[i].inv_id == id) {
        var removeParams = {
          account_email: this.dmail,
          patient_email: this.patient.record_info.Record.account_email,
          data: [
            {
              id: this.lab_ids[i].lab_id,
              status: 0
            }
          ]
        }

        this.appService.postData(this.urlPoints.updateLab, removeParams, this.token).subscribe((response: any) => {

        });

      }
    }

    this.inv_selected.splice(index, 1)
    this.add_update()
  }

  remove_pres(index, id) {
    this.pres_selected.splice(index, 1)


    for (var i = 0; i < this.pres_entries.length; i++) {
      this.pres_entries[i].operation = 'delete'
    }

    var params2 = {
      "account_email": this.dmail, doctor_id: this.doc_id,
      "prescription": {
        "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
        "entries": this.pres_entries
      }
    }

    this.appService.postData(this.urlPoints.updatePres, params2, this.token).subscribe((response: any) => {
      this.preview_id = response.id

      this.pres_entries = []

      for (var i = 0; i < this.pres_selected.length; i++) {
        this.pres_count++;
        var obj = {
          drug_id: this.pres_selected[i].id,
          dose: this.pres_selected[i].dose,
          dose_option: this.pres_selected[i].dose_option,
          frequency: this.pres_selected[i].frequency,
          route: this.pres_selected[i].route,
          when: this.pres_selected[i].when,
          duration: this.pres_selected[i].duration.toString(),
          duration_type: this.pres_selected[i].duration_type,
          quantity: this.pres_selected[i].quantity,
          special_instruction: this.pres_selected[i].special_instruction,
          minimum_buyable_qty: this.pres_selected[i].minimum_buyable_qty,
          operation: 'add',
          pres_id: this.pres_count
        }

        this.pres_entries.push(obj)
      }

      var params3 = {
        "account_email": this.dmail, doctor_id: this.doc_id,
        "prescription": {
          "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
          "entries": this.pres_entries
        }
      }

      this.appService.postData(this.urlPoints.updatePres, params3, this.token).subscribe((response: any) => {
        this.preview_id = response.id
        this.save_add1()

      })
    });


  }

  remove_adv(index) {
    this.adv_selected.splice(index, 1)
    this.add_update()

  }

  addFromMaster(object1) {

    this.medication = object1

    if (this.prescription_id != undefined) {

      this.pres_count++;

      this.medication.operation = 'add'

      this.medication.pres_id = this.pres_count;

      this.medication.shortFreq = this.medication.frequency

      this.pres_selected.push(this.medication);

      var obj = {
        drug_id: this.medication.id,
        dose: this.medication.dose,
        dose_option: this.medication.dose ? this.medication.dose_option : "",
        frequency: this.medication.frequency,
        route: this.medication.route,
        when: this.medication.when,
        duration: this.medication.duration.toString(),
        duration_type: this.medication.duration_type,
        quantity: this.medication.quantity,
        special_instruction: this.medication.special_instruction,
        minimum_buyable_qty: this.medication.minimum_buyable_qty,
        operation: 'add',
        pres_id: this.pres_count,
        dose_details: this.medication.dose_details
      }

      this.pres_entries.push(obj)
      this.updatePres()

    }
    else {

      this.pres_count++;

      this.medication.pres_id = this.pres_count;

      this.medication.shortFreq = this.medication.frequency

      this.pres_selected.push(this.medication);

      var obj1 = {
        drug_id: this.medication.id,
        dose: this.medication.dose,
        dose_option: this.medication.dose_option,
        frequency: this.medication.frequency,
        route: this.medication.route,
        when: this.medication.when,
        duration: this.medication.duration.toString(),
        duration_type: this.medication.duration_type,
        quantity: this.medication.quantity,
        special_instruction: this.medication.special_instruction,
        minimum_buyable_qty: this.medication.minimum_buyable_qty,
        dose_details: this.medication.dose_details,
        pres_id: this.pres_count
      }

      this.pres_entries.push(obj1)

      this.addPres();
    }
  }

  keyPress(event) {
    const pattern = /^\d+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) || event.keyCode == 32) {
      event.preventDefault();
    }
  }

  followChange() {

    if (this.follow_days == null) {
      this.follow_days = ''
    }
  }


  click1(i) {
    this.matMenuTimer1 = setTimeout(() => { this.clickedMe1(); }, 300);
  }

  doubleClick1(i) {
    clearTimeout(this.matMenuTimer1);
    this.matMenuTimer1 = undefined;
    this.remove_cc(i);
  }

  clickedMe1() {
    if (!this.matMenuTimer1) return;
  }


  click2(i) {
    this.matMenuTimer2 = setTimeout(() => { this.clickedMe2(); }, 300);
  }

  doubleClick2(i) {
    clearTimeout(this.matMenuTimer2);
    this.matMenuTimer2 = undefined;
    this.remove_ex(i);
  }

  clickedMe2() {
    if (!this.matMenuTimer2) return;
  }


  click3(i) {
    this.matMenuTimer3 = setTimeout(() => { this.clickedMe3(); }, 300);
  }

  doubleClick3(i) {
    clearTimeout(this.matMenuTimer3);
    this.matMenuTimer3 = undefined;
    this.remove_diag(i);
  }

  clickedMe3() {
    if (!this.matMenuTimer3) return;
  }

  click4(i) {
    this.matMenuTimer4 = setTimeout(() => { this.clickedMe4(); }, 300);
  }

  doubleClick4(i) {
    clearTimeout(this.matMenuTimer4);
    this.matMenuTimer4 = undefined;
    this.remove_inv(i);
  }

  clickedMe4() {
    if (!this.matMenuTimer4) return;
  }

  click5(i) {

    this.matMenuTimer5 = setTimeout(() => { this.clickedMe5(i); }, 300);
  }

  doubleClick5(i) {
    clearTimeout(this.matMenuTimer5);
    this.matMenuTimer5 = undefined;
    this.remove_pres(i, i);
  }

  clickedMe5(i) {
    if (!this.matMenuTimer5) return;
    this.openPrescription()
  }

  click6(i) {
    this.matMenuTimer6 = setTimeout(() => { this.clickedMe6(); }, 300);
  }

  doubleClick6(i) {
    clearTimeout(this.matMenuTimer6);
    this.matMenuTimer6 = undefined;
    this.remove_adv(i);
  }

  clickedMe6() {
    if (!this.matMenuTimer6) return;
  }

  click_soap(i) {
    this.matMenuTimer_soap = setTimeout(() => { this.clickedMe_soap(i); }, 300);
  }

  doubleClick_soap(i) {
    clearTimeout(this.matMenuTimer_soap);
    this.matMenuTimer_soap = undefined;
    this.pres_selected_soap.splice(i, 1)
  }

  clickedMe_soap(i) {
    if (!this.matMenuTimer_soap) return;
    this.edit_soap(i, i)
  }

  edit(index, id) {
    if (!this.popupOpen) {

      this.dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        width: 'fit-content',
        //  height: '90vh',

        data: { name: this.pres_selected[index].brand, id: this.pres_selected[index].id, mode: 1, obj: this.pres_selected[index], text: '', pres_selected: this.pres_selected }
      });

      const sub = this.dialogRef.componentInstance.onRemove.subscribe(() => {
        // do something
        //  alert(sessionStorage.getItem("removeindex"))
        this.remove_pres(sessionStorage.getItem("removeindex"), sessionStorage.getItem("removeindex"));

        if (index > sessionStorage.getItem("removeindex"))
          index--
      });


      this.popupOpen = true

      this.dialogRef.afterClosed().subscribe(result => {

        if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

          if (result.when == 'After Food') {
            result.when = 'AF'
          }

          if (result.when == 'Before Food') {
            result.when = 'BF'
          }

          if (result.when == 'Not Related to Food') {
            result.when = 'NRF'
          }

          if (result.when == 'With Food') {
            result.when = 'WF'
          }

        }

        this.popupOpen = false

        if (result.create) {

          var detailParams = {
            account_email: this.dmail,
            doctor_id: this.doc_id,
            update: 0,
            drug:
            {
              drug_id: result.id,
              formulation: result.formulation,
              name:result.brand
            }
          }

          this.appService.postData(this.urlPoints.updateMedicines, detailParams, this.token).subscribe((response: any) => {

            if (response.data.id)
              result.id = response.data.id

            if (result.type == 1 || result.type == 3) {

              this.pres_selected[index] = result;

              var unit = this.pres_selected[index].quantity.split(' ')[1]

              var freq_arr = this.pres_selected[index].frequency.split('-')

              if (freq_arr.length == 4) {
                var morning = freq_arr[0].trim().split(' ')[0]

                var afternoon = freq_arr[1].trim().split(' ')[0]

                var evening = freq_arr[2].trim().split(' ')[0]

                var night = freq_arr[3].trim().split(' ')[0]

                if (this.showUnits) {
                  var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')
                  var shortUnit = ''

                  if (unit == 'milliliter') {
                    shortUnit = 'ml'
                  }

                  else if (unit == 'Tablet') {
                    shortUnit = 'Tablet'
                  }

                  else if (unit == 'microgram') {
                    shortUnit = 'mcg'
                  }

                  else if (unit == 'milligram') {
                    shortUnit = 'mg'
                  }

                  else if (unit == 'gram') {
                    shortUnit = 'grm'
                  }


                  else if (unit == 'drops') {
                    shortUnit = 'drops'
                  }

                  else if (unit == 'Sachets/Packets') {
                    shortUnit = 'pkt'
                  }


                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }

                  if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                    var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                    var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                    if (unit == 'mole' || unit == 'millimole') {
                      var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                      freq = shortFreq
                    }
                  }

                  this.pres_selected[index].frequency = freq
                  this.pres_selected[index].shortFreq = shortFreq

                  result.freq = freq
                }
                else {
                  var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                  this.pres_selected[index].frequency = freq

                  result.freq = freq

                  this.pres_selected[index].shortFreq = freq

                }

              }
              else {
                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }

                if (this.showUnits) {
                  var freq1: any = this.pres_selected[index].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[index].frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.pres_selected[index].frequency = freq1 + ' ' + unit

                  this.pres_selected[index].shortFreq = freq1 + ' ' + shortUnit
                }
                else {
                  var freq1: any = this.pres_selected[index].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[index].frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.pres_selected[index].shortFreq = freq1

                }
                //   this.pres_selected[index].shortFreq = this.pres_selected[index].frequency
              }

              var obj = {
                drug_id: result.id,
                dose: result.dose,
                dose_option: result.dose_option,
                frequency: result.frequency,
                route: result.route,
                when: result.when,
                duration: result.duration.toString(),
                duration_type: result.duration_type,
                quantity: result.quantity,
                special_instruction: result.special_instruction,
                minimum_buyable_qty: result.minimum_buyable_qty,
                operation: 'add',
                dose_details: result.dose_details,
                pres_id: this.pres_count
              }


              this.pres_entries[index] = obj;

              this.updatePres();

              if (result.type == 3) {
                if (this.supported) {
                  //  this.muted = true
                  //  this.service.stop()
                }

              }
            }
            else if (result.type == 2) {

            }
            else if (result.type == 4) {
              if (this.supported) {

              }

            }
          });
        }

        else {

          var detailParams = {
            account_email: this.dmail,
            doctor_id: this.doc_id,
            update: 1,
            drug:
            {
              drug_id: result.id,
              formulation: result.formulation,
              name:result.brand
            }
          }

          this.appService.postData(this.urlPoints.updateMedicines, detailParams, this.token).subscribe((response: any) => {

            if (result.type == 1 || result.type == 3) {

              this.pres_selected[index] = result;

              var unit = this.pres_selected[index].quantity.split(' ')[1]

              var freq_arr = this.pres_selected[index].frequency.split('-')

              if (freq_arr.length == 4) {
                var morning = freq_arr[0].trim().split(' ')[0]

                var afternoon = freq_arr[1].trim().split(' ')[0]

                var evening = freq_arr[2].trim().split(' ')[0]

                var night = freq_arr[3].trim().split(' ')[0]

                if (this.showUnits) {
                  var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')
                  var shortUnit = ''

                  if (unit == 'milliliter') {
                    shortUnit = 'ml'
                  }

                  else if (unit == 'Tablet') {
                    shortUnit = 'Tablet'
                  }

                  else if (unit == 'microgram') {
                    shortUnit = 'mcg'
                  }

                  else if (unit == 'milligram') {
                    shortUnit = 'mg'
                  }

                  else if (unit == 'gram') {
                    shortUnit = 'grm'
                  }


                  else if (unit == 'drops') {
                    shortUnit = 'drops'
                  }

                  else if (unit == 'Sachets/Packets') {
                    shortUnit = 'pkt'
                  }


                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }

                  if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                    var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                    var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')


                    if (unit == 'mole' || unit == 'millimole') {
                      var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                      freq = shortFreq
                    }
                  }

                  this.pres_selected[index].frequency = freq
                  this.pres_selected[index].shortFreq = shortFreq

                  result.freq = freq
                }
                else {
                  var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                  this.pres_selected[index].frequency = freq

                  result.freq = freq

                  this.pres_selected[index].shortFreq = freq

                }

              }
              else {
                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }

                if (this.showUnits) {
                  var freq1: any = this.pres_selected[index].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[index].frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.pres_selected[index].frequency = freq1 + ' ' + unit

                  this.pres_selected[index].shortFreq = freq1 + ' ' + shortUnit
                }
                else {
                  var freq1: any = this.pres_selected[index].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[index].frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.pres_selected[index].shortFreq = freq1

                }
                //   this.pres_selected[index].shortFreq = this.pres_selected[index].frequency
              }

              var obj = {
                drug_id: result.id,
                dose: result.dose,
                dose_option: result.dose_option,
                frequency: result.frequency,
                route: result.route,
                when: result.when,
                duration: result.duration.toString(),
                duration_type: result.duration_type,
                quantity: result.quantity,
                special_instruction: result.special_instruction,
                minimum_buyable_qty: result.minimum_buyable_qty,
                operation: 'add',
                dose_details: result.dose_details,
                pres_id: this.pres_count
              }


              this.pres_entries[index] = obj;

              this.updatePres();

              if (result.type == 3) {
                if (this.supported) {
                  //  this.muted = true
                  //  this.service.stop()
                }

              }
            }
            else if (result.type == 2) {

            }
            else if (result.type == 4) {
              if (this.supported) {

              }

            }
          });
        }
      });
    }




  }

  edit_soap(index, id) {
    if (!this.popupOpen) {

      this.dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        width: 'fit-content',
        //  height: '90vh',

        data: { name: this.pres_selected_soap[index].brand, id: this.pres_selected_soap[index].id, mode: 1, obj: this.pres_selected_soap[index], text: '', pres_selected: this.pres_selected_soap }
      });

      const sub = this.dialogRef.componentInstance.onRemove.subscribe(() => {

        this.pres_selected_soap.splice(Number(sessionStorage.getItem("removeindex")), 1)

        if (index > sessionStorage.getItem("removeindex"))
          index--
      });


      this.popupOpen = true

      this.dialogRef.afterClosed().subscribe(result => {

        this.popupOpen = false

        if (result.type == 1 || result.type == 3) {
          this.pres_selected_soap[index] = result;
        }

      });
    }
  }

  toggleMute(event) {

    //var helper =  new SimboAlphaHelper({"devId": 'demo-api-000027-intg-gp-helyxon', "authKey": '23d9b76f9393055b7f8491d73aad5faec75cd1352bd4e2b3cf9d95a32030380c', "wssUrl1": 'wss://test.alpha.phit.in/asr'})

    //  onStartClick('demo-api-000027-intg-gp-helyxon','23d9b76f9393055b7f8491d73aad5faec75cd1352bd4e2b3cf9d95a32030380c','wss://test.alpha.phit.in/asr');

    //  helper.onStartClick()

    if (event) {
      //listTemplate  

      this.startService()

    }
    else {

      this.stopService();
      this.service.text1 = ''
    }
  }

  updateCCVoice(name) {


    var cc_name = name

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].name == name) {
        exists = true
      }
    }

    if (!exists) {
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: name,
        "doctor_id": this.doc_id
      }


      this.appService.getData(this.urlPoints.getCC, params, this.token).subscribe((response: any) => {


        this.chief_complaints = response.data;
        this.cc_copy = Object.assign([], this.chief_complaints);
        this.cc_copy1 = Object.assign([], this.chief_complaints);



        this.cc_copy1 = this.cc_copy1.filter(i => i.name.toLowerCase() == cc_name.toLowerCase());




        if (this.cc_copy1.length == 1) {


          this.end = false;

          this.clear = !this.clear

          var exists = false

          this.chars1Arr = []
          this.chars1 = ''

          for (var j = 0; j < this.cc_selected.length; j++) {
            if (this.cc_selected[j].name.trim().toLowerCase() == this.cc_copy1[0].name.trim().toLowerCase()) {
              exists = true
            }
          }

          if (!exists) {
            this.highlight_cc = true

            var index1 = this.chief_complaints.indexOf(this.cc_copy1[0]);
            this.cc_selected.push(this.cc_copy1[0]);



            if (i == 1) {
              this.new_cc_ids.push(this.cc_copy1[0].symptoms_id)
              this.new_cc_names.push(this.cc_copy1[0].name)
            }


            this.printArr = [];

            if (!this.complaint_id) {

              this.cc_issues = [
                {
                  "category_id": this.chief_complaints[index1].id,
                  "complaint_category_id": this.chief_complaints[index1].id,
                  "complaint_type": this.chief_complaints[index1].name,

                  "is_question": this.ccDoubt ? 1 : 0,


                  "details": [
                    {
                      "questions": "",
                      "answers": ""
                    }
                  ]
                },
              ];

              var params1 = {
                "account_email": this.dmail,
                "doctor_id": this.doc_id,
                "simple_complaint": {
                  "user_type": "doctor",
                  "issues": this.cc_issues,
                  "days": "",
                  "medicine_given": "",
                  "temperature": "",
                  "unit": "",
                  "other_information": "",
                  "patient_email": this.patient.record_info.Record.account_email,
                  "appointment_id": this.appointment_id
                }
              }

              this.appService.postData(this.urlPoints.simpleComplaint, params1, this.token).subscribe((response: any) => {
                this.complaint_id = response.complaint.id;
                this.save_follow1()
              });
            }
            else {
              var id = this.cc_copy1[0].id
              var name = this.cc_copy1[0].name
              var params_cc = {
                account_email: this.dmail,
                appointment_id: this.appointment_id
              }

              this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {

                this.cc_issues = response.op_review.complaint.issues

                var params2 = {
                  "account_email": this.dmail,
                  "doctor_id": this.doc_id,
                  "simple_complaint": {
                    "user_type": "doctor",
                    "issues": this.cc_issues,
                    "new_issues": [
                      {
                        "category_id": id,
                        "complaint_category_id": id,
                        "complaint_type": name,

                        "is_question": this.ccDoubt ? 1 : 0,

                        "details": [
                          {
                            "questions": "",
                            "answers": ""
                          }
                        ]
                      }
                    ],
                    "days": "",
                    "medicine_given": "",
                    "temperature": "",
                    "unit": "",
                    "other_information": "",
                    "patient_email": this.patient.record_info.Record.account_email,
                    "appointment_id": this.appointment_id,
                    "complaint_id": this.complaint_id
                  }
                }

                this.appService.postData(this.urlPoints.updateComplaint, params2, this.token).subscribe((response: any) => {
                  this.save_follow1()
                });
              });



              this.cc_issues.push({
                "category_id": this.cc_copy1[0].id,
                "complaint_category_id": this.cc_copy1[0].id,
                "complaint_type": this.cc_copy1[0].name,
                "details": [
                  {
                    "questions": "",
                    "answers": ""
                  }
                ]
              })
            }


            this.cc_copy1.splice(0, 1);
            this.ids_cc = [];
            this.ids_string_cc;

            for (var k = 0; k < this.cc_selected.length; k++) {
              this.ids_cc.push(this.cc_selected[k].symptoms_id)
            }

            this.ids = this.ids_cc.concat(this.ids_ex);
            var ids_string = this.ids.toString();

            this.ids_string_cc = this.ids_cc.toString();

            var params = {
              account_email: this.dmail,
              page_no: 1,
              symptoms_id: ids_string,
              doctor_id: this.doc_id
            }

            this.diag_data = []
            this.getDiag(this.urlPoints.getDiag, params, this.token);

            if (this.ccDoubt)
              this.cc_selected[this.cc_selected.length - 1].name = "?" + this.cc_selected[this.cc_selected.length - 1].name
          }
        }

        if (this.cc_copy1.length == 0) {

          var params_new = {
            account_email: this.dmail,
            word_type: 0,
            new_complaint: [name],
            doctor_id: this.doc_id,
          }

          this.appService.postData(this.urlPoints.newCC, params_new, this.token).subscribe((response: any) => {

            var params2 = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: name,
              "doctor_id": this.doc_id
            }

            this.getCC1(this.urlPoints.getCC, params2, this.token);

          }
          );
        }
      })
    }
  }

  updateDiagVoice(name) {

    var diag_name = name

    var exists = false

    for (var i = 0; i < this.diag_selected.length; i++) {
      if (this.diag_selected[i].name == name) {
        exists = true
      }
    }

    if (!exists) {

      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: name,
        doctor_id: this.doc_id
      }

      this.appService.getData(this.urlPoints.getDiag, params, this.token).subscribe((response: any) => {


        this.diagnosis = response.data;
        this.diag_copy = Object.assign([], this.diagnosis);
        this.diag_copy1 = Object.assign([], this.diagnosis);



        this.diag_copy1 = this.diag_copy1.filter(i => i.name.toLowerCase() == diag_name.toLowerCase());

        if (this.diag_copy1.length == 1) {
          this.end = false

          var exists;

          this.chars3 = ''

          this.chars3Arr = []

          this.clear = !this.clear

          for (var j = 0; j < this.diag_selected.length; j++) {
            if (this.diag_selected[j].name.trim().toLowerCase() == this.diag_copy1[0].name.trim().toLowerCase()) {
              exists = true
            }
          }

          if (!exists) {

            this.highlight_diag = true

            var index1 = this.diagnosis.indexOf(this.diag_copy1[0]);
            this.diag_selected.push(this.diagnosis[index1]);

            // if (this.diagDoubt) {
            //   this.diag_selected[this.diag_selected.length - 1].name = '?' + this.diag_selected[this.diag_selected.length - 1].name
            //   this.diag_selected[this.diag_selected.length - 1].question = true
            // }
            // else {
            //   this.diag_selected[this.diag_selected.length - 1].question = false
            // }

            if (i == 1) {
              this.new_diag_ids.push(this.diagnosis[index1].diagnosis_id)
              this.new_diag_names.push(this.diagnosis[index1].name)
            }

            this.diag_copy1.splice(0, 1)

            this.ids_diag = [];

            for (var k = 0; k < this.diag_selected.length; k++) {
              this.ids_diag.push(this.diag_selected[k].diagnosis_id)
            }

            var diag_names = []

            for (var k = 0; k < this.diag_selected.length; k++) {
              diag_names.push(this.diag_selected[k].name)
            }

            this.diag_names = diag_names.join(',')

            var string = this.ids_diag.toString();

            var params = {
              account_email: this.dmail,
              page_no: this.diag_page,
              diagnosis_id: string
            }


          }


          this.save_follow1()
        }

        if (this.diag_copy1.length == 0) {

          var params_new = {
            account_email: this.dmail,
            new_diagnosis: [name],
            doctor_id: this.doc_id,
          }

          this.appService.postData(this.urlPoints.newDiag, params_new, this.token).subscribe((response: any) => {

            var params2 = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: name,
              doctor_id: this.doc_id
            }

            this.getDiag1(this.urlPoints.getDiag, params2, this.token);

          });

        }

      });

    }


  }

  updateInvVoice(name) {

    var inv_name = name

    var exists = false

    for (var i = 0; i < this.inv_selected.length; i++) {
      if (this.inv_selected[i].name == name) {
        exists = true
      }
    }

    if (!exists) {

      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: name,
        doctor_id: this.doc_id
      }

      this.appService.getData(this.urlPoints.getInv, params, this.token).subscribe((response: any) => {


        this.investigations = response.data;
        this.inv_copy = Object.assign([], this.investigations);
        this.inv_copy1 = Object.assign([], this.investigations);


        this.inv_copy1 = this.inv_copy1.filter(i => i.name.toLowerCase() == inv_name.toLowerCase());

        if (this.inv_copy1.length == 1) {
          var exists;

          this.clear = !this.clear;

          this.chars4 = ''

          this.chars4Arr = []

          for (var j = 0; j < this.inv_selected.length; j++) {
            if (this.inv_selected[j].name.trim().toLowerCase() == this.inv_copy1[0].name.trim().toLowerCase()) {
              exists = true
            }
          }

          this.end = false
          if (!exists) {

            this.highlight_inv = true


            var index1 = this.investigations.indexOf(this.inv_copy1[0]);
            this.inv_selected.push(this.investigations[index1])
            this.inv_copy1.splice(0, 1);


            if (i == 1) {
              this.new_inv_ids.push(this.investigations[index1].investigation_id)
              this.new_inv_names.push(this.investigations[index1].name)
            }

            var inv_names = []

            for (var k = 0; k < this.inv_selected.length; k++) {
              inv_names.push(this.inv_selected[k].name)
            }

            this.inv_names = inv_names.join(',')

          }

          this.save_follow1();

          var params_labreports = {
            account_email: this.dmail,
            patient_email: this.patient.record_info.Record.account_email,
          }

          this.labreports(this.urlPoints.labReports, params_labreports, this.token)

          this.save_follow1();

          var params_labreports = {
            account_email: this.dmail,
            patient_email: this.patient.record_info.Record.account_email,
          }

          this.labreports(this.urlPoints.labReports, params_labreports, this.token)
        }

        if (this.inv_copy1.length == 0) {



          var params_new = {
            account_email: this.dmail,
            new_investigation: [name],
            doctor_id: this.doc_id,
          }

          this.appService.postData(this.urlPoints.newInv, params_new, this.token).subscribe((response: any) => {

            var params2 = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: name,
              doctor_id: this.doc_id
            }

            this.getInv1(this.urlPoints.getInv, params2, this.token);



          });

        }

      });

    }


  }

  updatePresVoice(data) {

    this.pres_count++

    var quantity;

    var time_block = 'times'

    var frequency_type = 'times'

    var morning_dose: any = 0

    var afternoon_dose: any = 0

    var evening_dose: any = 0

    var night_dose: any = 0

    var every_value;

    var freq_quantity = 1;

    var frequency = data.freq

    var unit

    var name = data.drugname

    var dose_option

    var route;

    var when;



    var params2 = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: data.name
    }


    var obj = {
      brand: data.name,
      dose: '',
      dose_option: '',
      duration: data.days,
      duration_type: "Days",
      formulation: '', //
      freq_string: "0 - 0 - 0 - 0",
      frequency: "0 - 0 - 0 - 0",
      generic: '', //
      id: '',
      minimum_buyable_qty: '',
      operation: 'add',
      pres_id: this.pres_count,
      quantity: '', //  
      route: "Oral",
      special_instruction: '',
      strength: "",
      strength_unit: "",
      type: 3,
      when: "After Food",
    }




    // frequency_type = 'times'

    //   time_block = 'times'

    //   morning_dose = 1;
    //   afternoon_dose = 0;
    //   evening_dose = 0;
    //   night_dose = 1;

    if (data.freq == "sos") {
      data.freq = "SOS"
    }

    if (data.freq == "q6h") {
      data.freq = "Every 6 hours - 1 Tablet"
    }

    if (data.freq == "q4h") {
      data.freq = "Every 4 hours - 1 Tablet"
    }

    if (data.freq == "q2h") {
      data.freq = "Every 2 hours - 1 Tablet"
    }

    if (data.freq == "3times") {
      data.freq = "1 - 1 - 0 - 1"
    }

    if (data.freq == "2times" || data.freq == "2times101" || data.freq == "2times011" || data.freq == "2times110") {
      data.freq = "1 - 0 - 0 - 1"
    }

    //4 times daily
    //daily

    if (data.freq == "once" || data.freq == "Morning" || data.freq == "daily") {
      data.freq = "1 - 0 - 0 - 0"
    }

    if (data.freq == "4 times daily") {
      data.freq = "1 - 1 - 1 - 1"
    }

    if (data.freq == "once" || data.freq == "Morning") {
      data.freq = "1 - 0 - 0 - 0"
    }

    if (data.freq == "afternoon") {
      data.freq = "0 - 1 - 0 - 0"
    }

    if (data.freq == "evening") {
      data.freq = "0 - 0 - 1 - 0"
    }

    if (data.freq == "beforesleeping") {
      data.freq = "0 - 0 - 0 - 1"
    }

    var freq_arr = data.freq.split('-')

    if (freq_arr.length == 4) {

      frequency_type = 'times'

      time_block = 'times'

      var morning_dose: any = freq_arr[0].trim().split(' ')[0]

      var afternoon_dose: any = freq_arr[1].trim().split(' ')[0]

      var evening_dose: any = freq_arr[2].trim().split(' ')[0]

      var night_dose: any = freq_arr[3].trim().split(' ')[0]
    }



    if (data.freq == "SOS") {
      frequency_type = 'sos'

      time_block = 'frequency'

      every_value = 2

      freq_quantity = 1

      morning_dose = 0;
      afternoon_dose = 0;
      evening_dose = 0;
      night_dose = 0;
    }

    if (data.freq.startsWith('Every')) {


      frequency_type = 'every';

      time_block = 'frequency';

      every_value = Number(data.freq.split(' ')[1])

      freq_quantity = 1;

      morning_dose = 0;
      afternoon_dose = 0;
      evening_dose = 0;
      night_dose = 0;
    }

    var arr = []
    var freq_string;

    if (frequency_type == 'times') {

      frequency = ''

      arr.push(morning_dose ? morning_dose.toString() : '0')

      arr.push(afternoon_dose ? afternoon_dose.toString() : '0')

      arr.push(evening_dose ? evening_dose.toString() : '0')

      arr.push(night_dose ? night_dose.toString() : '0')

      freq_string = arr.join(' - ')

      frequency = freq_string
      frequency = frequency
    }

    else if (frequency_type == 'every') {
      frequency = 'Every ' + every_value + ' hours'
      frequency = frequency

      frequency = frequency + ' - ' + freq_quantity
      frequency = frequency

    }


    if (frequency_type == 'sos') {
      frequency = 'S.O.S' + ' - ' + freq_quantity
      data.freq = frequency
    }

    obj.frequency = data.freq

    var total;

    if (data.freq.startsWith('Every 2 hours')) {
      quantity = Number(obj.duration) * 12 * Number(freq_quantity)
    }

    else if (data.freq.startsWith('Every 4 hours')) {
      quantity = Number(obj.duration) * 6 * Number(freq_quantity)
    }

    else if (data.freq.startsWith('Every 6 hours')) {
      quantity = Number(obj.duration) * 4 * Number(freq_quantity)
    }

    else if (data.freq.startsWith('Every 8 hours')) {
      quantity = Number(obj.duration) * 3 * Number(freq_quantity)
    }

    else if (data.freq.startsWith('Everyday')) {
      quantity = Number(obj.duration) * Number(freq_quantity)
    }

    else if (data.freq.startsWith('S.O.S')) {
      quantity = Number(obj.duration) * Number(freq_quantity)
    }

    else if (frequency_type == 'times') {



      quantity = (Number(morning_dose ? morning_dose : 0) + Number(afternoon_dose ? afternoon_dose : 0) + Number(evening_dose ? evening_dose : 0) + Number(night_dose ? night_dose : 0)) * Number(obj.duration)


    }

    obj.quantity = quantity

    var params2_ = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: data.name,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getPres, params2_, this.token).subscribe((response: any) => {

      if (response.success !== 0 && !response.message) {

        response.data = response.data.filter(i => i.name.toLowerCase() == data.name.toLowerCase());

        obj.id = response.data[0].id

        obj.formulation = response.data[0].category

        obj.generic = response.data[0].composition_name



        if (response.data[0].category.trim() == 'Tablet' || response.data[0].category.trim() == 'Capsule' || response.data[0].category.trim() == 'Captab' || response.data[0].category.trim() == 'Chewable Tablet' || response.data[0].category.trim() == 'Rotacap') {
          dose_option = 'milligram'
        }

        if (response.data[0].category.trim() == 'Aplicap' || response.data[0].category.trim() == 'Diaper' || response.data[0].category.trim() == 'Dressing') {
          route = "Other"
          when = 'Not Related to Food'
        }

        if (response.data[0].category.trim() == 'Cathetor') {
          route = "Other"
        }


        if (response.data[0].category.trim() == 'Cleansing Gel') {
          route = "Topical"
        }

        if (response.data[0].category.trim() == 'Drops' || response.data[0].category.trim() == 'Liquid' || response.data[0].category.trim() == 'Solution') {
          dose_option = 'milliliter'
        }

        if (response.data[0].category.trim() == 'Ear Drops' || response.data[0].category.trim() == 'Eye Drops') {
          dose_option = 'milliliter'
          route = 'Other'
          when = 'Not Related to Food'
        }

        if (response.data[0].category.trim() == 'Expectorant' || response.data[0].category.trim() == 'Suspension' || response.data[0].category.trim() == 'Syrup') {
          dose_option = 'milliliter'
          route = 'Oral'
        }

        if (response.data[0].category.trim() == 'Ointment' || response.data[0].category.trim() == 'Gel' || response.data[0].category.trim() == 'Paste' || response.data[0].category.trim() == 'Soap' || response.data[0].category.trim() == 'Dusting Powder' || response.data[0].category.trim() == 'Tooth Paste') {
          dose_option = 'gram'
          route = 'Topical'
          when = 'Not Related to Food'
        }

        if (response.data[0].category.trim() == 'Granules' || response.data[0].category.trim() == 'Granule' || response.data[0].category.trim() == 'Sachet') {
          dose_option = 'gram'
          route = 'Oral'
        }

        if (response.data[0].category.trim() == 'Inhaler' || response.data[0].category.trim() == 'Respules' || response.data[0].category.trim() == 'Respule' || response.data[0].category.trim() == 'Transpule' || response.data[0].category.trim() == 'Transpules') {
          route = 'Inhale'
        }

        if (response.data[0].category.trim() == 'Injection') {
        }

        if (response.data[0].category.trim() == 'Lotion' || response.data[0].category.trim() == 'Cream') {
          dose_option = 'gram'
          route = 'Topical'
        }

        if (response.data[0].category.trim() == 'Nasal Drops' || response.data[0].category.trim() == 'Nasal Spray') {
          dose_option = 'milligram'
          route = 'Other'
          when = 'Not Related to Food'

        }

        if (response.data[0].category.trim() == 'Shampoo') {
          dose_option = 'milliliter'
          route = 'Topical'
          when = 'Not Related to Food'

        }

        if (response.data[0].category.trim() == 'Vaccine') {
        }

        obj.quantity = obj.quantity + ' ' + dose_option

        obj.when = data.when

        this.medication = obj

        var unit = this.medication.quantity.split(' ')[1]

        var freq_arr = this.medication.frequency.split('-')

        if (freq_arr.length == 4) {
          var morning = freq_arr[0].trim().split(' ')[0]

          var afternoon = freq_arr[1].trim().split(' ')[0]

          var evening = freq_arr[2].trim().split(' ')[0]

          var night = freq_arr[3].trim().split(' ')[0]

          if (this.showUnits) {
            var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

            var shortUnit = ''

            if (unit == 'milliliter') {
              shortUnit = 'ml'
            }

            else if (unit == 'Tablet') {
              shortUnit = 'Tablet'
            }

            else if (unit == 'microgram') {
              shortUnit = 'mcg'
            }

            else if (unit == 'milligram') {
              shortUnit = 'mg'
            }

            else if (unit == 'gram') {
              shortUnit = 'grm'
            }


            else if (unit == 'drops') {
              shortUnit = 'drops'
            }

            else if (unit == 'Sachets/Packets') {
              shortUnit = 'pkt'
            }


            var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

            if (unit == 'mole' || unit == 'millimole') {
              var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
              freq = shortFreq
            }

          }
          else {
            var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
            var shortFreq = freq
          }
          this.medication.frequency = freq
          this.medication.shortFreq = shortFreq
        }
        else {
          var shortUnit = ''

          if (unit == 'milliliter') {
            shortUnit = 'ml'
          }

          else if (unit == 'Tablet') {
            shortUnit = 'Tablet'
          }

          else if (unit == 'microgram') {
            shortUnit = 'mcg'
          }

          else if (unit == 'milligram') {
            shortUnit = 'mg'
          }

          else if (unit == 'gram') {
            shortUnit = 'grm'
          }


          else if (unit == 'drops') {
            shortUnit = 'drops'
          }

          else if (unit == 'Sachets/Packets') {
            shortUnit = 'pkt'
          }

          if (this.showUnits) {
            var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

            this.medication.frequency = freq1 + ' ' + unit

            this.medication.shortFreq = freq1 + ' ' + shortUnit
          }
          else {
            var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

            this.medication.shortFreq = freq1

          }

          //  this.medication.shortFreq = this.medication.frequency

        }


        if (!data.when) {
          this.medication.when = "After Food"
        }

        if (data.when == 'af' || data.when == 'na') {
          this.medication.when = "After Food"
        }

        if (data.when == 'bf') {
          this.medication.when = "Before Food"
        }



        if (this.prescription_id != undefined) {

          this.pres_selected.push(this.medication);

          var objnew = {
            drug_id: this.medication.id,
            dose: this.medication.dose,
            dose_option: this.medication.dose_option,
            frequency: this.medication.frequency,
            route: this.medication.route,
            when: this.medication.when,
            duration: this.medication.duration.toString(),
            duration_type: this.medication.duration_type,
            quantity: this.medication.quantity,
            special_instruction: this.medication.special_instruction,
            minimum_buyable_qty: this.medication.minimum_buyable_qty,
            operation: 'add',
            pres_id: this.pres_count,
            dose_details: this.medication.dose_details
          }

          this.pres_entries.push(objnew)
          this.updatePres()



        }
        else {

          this.pres_selected.push(this.medication);

          var objnew1 = {
            drug_id: this.medication.id,
            dose: this.medication.dose,
            dose_option: this.medication.dose_option,
            frequency: this.medication.frequency,
            route: this.medication.route,
            when: this.medication.when,
            duration: this.medication.duration.toString(),
            duration_type: this.medication.duration_type,
            quantity: this.medication.quantity,
            special_instruction: this.medication.special_instruction,
            minimum_buyable_qty: this.medication.minimum_buyable_qty,
            dose_details: this.medication.dose_details,
            pres_id: this.pres_count
          }


          this.pres_entries.push(objnew1)
          this.addPres()
        }
      }
    })


  }

  chooseTempVoice(name) {


    var exists = false

    var index = -1

    for (var i = 0; i < this.templates.length; i++) {
      if (this.templates[i].template_name.toLowerCase() == name.toLowerCase()) {
        exists = true
        index = i
      }

      if (this.templates[i].template_name_index) {
        if (this.templates[i].template_name_index.toLowerCase() == name.toLowerCase()) {
          exists = true
          index = i
        }
      }
    }

    if (exists) {
      this.chooseTemp(this.templates[index].template_name)
      this.selectedTemp = this.templates[index].template_name
    }
    // this.chooseTemp(name)
    // this.selectedTemp = name
  }

  loadMedicines() {
    this.isLoading = true

    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.loadMedicines, params, this.token).subscribe((response: any) => {

      this.isLoading = false

      if (this.pres_toggle == 'tags') {
        this.ids_diag = [];

        for (var k = 0; k < this.diag_selected.length; k++) {
          this.ids_diag.push(this.diag_selected[k].diagnosis_id)
        }

        var ids_string1 = this.ids_diag.toString();

        this.prescriptions = [];
        this.pres_copy1 = [];
        this.pres_page = 1;
        this.pres_copy1 = [];

        var params3 = {
          account_email: this.dmail,
          page_no: this.pres_page,
          diagnosis_id: ids_string1,
          doctor_id: this.doc_id
        }

        this.getPres(this.urlPoints.getPres, params3, this.token)
      }
      else {
        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: this.chars5.toUpperCase().trim(),
          doctor_id: this.doc_id
        }

        if (this.chars5 != '')
          this.getPres(this.urlPoints.getPres, params, this.token)

        if (this.chars5 == '')
          this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
      }

      this.checkMedicineLoaded()

    });
  }

  enter(event) {
    // alert()
    this.service.textArray.push(event)
    this.navigate('enter')
  }

  set(block, mode?) {

    var token = this.token;

    this.chars1Arr = []
    this.chars2Arr = []
    this.chars3Arr = []
    this.chars4Arr = []
    this.chars5Arr = []
    this.chars6Arr = []

    this.service.text1 = ''

    this.clear = !this.clear

    this.noteVisible = false
    this.highlight = false

    this.highlight_cc = false
    this.highlight_ex = false
    this.highlight_diag = false
    this.highlight_inv = false
    this.highlight_pres = false
    this.highlight_adv = false


    if (block == 'cc') {
      this.cc_toggle = 'alp'
      this.chief_complaints = [];
      this.cc_copy = Object.assign([], this.chief_complaints);
      this.cc_copy1 = Object.assign([], this.chief_complaints);
      this.cc_data = [];
      this.cc_copy1 = [];

      this.cc_page = 1;

      var token = this.token;
      this.chars1 = ''

      var params1 = {
        account_email: this.dmail,
        page_no: this.cc_page,
        alphabet: this.chars1
      }

      this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, token)


      this.cc_keyboard = true

    }
    if (block == 'ex') {
      this.ex_toggle = 'alp';
      this.examination = [];
      this.ex_copy = Object.assign([], this.examination);
      this.ex_copy1 = Object.assign([], this.examination);
      this.ex_data = []
      this.ex_copy1 = [];
      this.ex_page = 1

      var token = this.token;
      this.chars2 = ''

      var params1 = {
        account_email: this.dmail,
        page_no: this.ex_page,
        alphabet: this.chars2
      }

      this.getExCounter(this.urlPoints.getExCounter, this.counter_params, token)

      this.ex_keyboard = true
    }

    if (block == 'diag') {
      this.ids_cc = [];
      this.ids_string_cc;

      for (var k = 0; k < this.cc_selected.length; k++) {
        this.ids_cc.push(this.cc_selected[k].symptoms_id)
      }

      this.ids_ex = [];

      for (var k = 0; k < this.ex_selected.length; k++) {
        this.ids_ex.push(this.ex_selected[k].symptoms_id)
      }

      this.diag_toggle = 'tags';

      this.ids_diag = [];

      for (var k = 0; k < this.diag_selected.length; k++) {
        this.ids_diag.push(this.diag_selected[k].diagnosis_id)
      }

      this.ids = this.ids_ex.concat(this.ids_cc);
      var ids_string = this.ids.toString();

      this.diag_data = [];
      this.diagnosis = [];
      this.diag_page = 1;
      this.diag_copy1 = []
      this.chars3 = ''

      var params = {
        account_email: this.dmail,
        page_no: this.diag_page,
        symptoms_id: ids_string,
        doctor_id: this.doc_id
      }

      if (!mode)
        this.getDiag(this.urlPoints.getDiag, params, this.token)

      this.diag_keyboard = true

      if (mode == 'alp' || 1 == 1) {
        this.toggle_diag()
      }
    }
    if (block == 'inv') {
      this.inv_toggle = 'tags';

      var ids_string1 = this.ids_diag.toString();

      this.inv_data = [];
      this.investigations = [];
      this.inv_page = 1;
      this.inv_copy1 = []

      var params3 = {
        account_email: this.dmail,
        page_no: this.inv_page,
        diagnosis_id: ids_string1,
        doctor_id: this.doc_id
      }
      this.chars4 = ''

      if (!mode)
        this.getInv(this.urlPoints.getInv, params3, token)

      this.inv_keyboard = true

      if (mode == 'alp' || 1 == 1) {
        this.toggle_inv()
      }
    }
    if (block == 'pres') {
      this.pres_toggle = 'tags';

      this.ids_diag = [];

      for (var k = 0; k < this.diag_selected.length; k++) {
        this.ids_diag.push(this.diag_selected[k].diagnosis_id)
      }

      var ids_string1 = this.ids_diag.toString();

      this.prescriptions = [];
      this.pres_copy1 = [];
      this.pres_page = 1;
      this.pres_copy1 = [];
      this.chars5 = ''

      var params3 = {
        account_email: this.dmail,
        page_no: this.pres_page,
        diagnosis_id: ids_string1,
        doctor_id: this.doc_id
      }

      if (!mode)
        this.getPres(this.urlPoints.getPres, params3, token)

      this.pres_keyboard = true

      if (mode == 'alp' || 1 == 1) {
        this.toggle_pres()
      }

    }
    if (block == 'adv') {
      this.adv_toggle = 'tags';

      this.ids_diag = [];

      for (var k = 0; k < this.diag_selected.length; k++) {
        this.ids_diag.push(this.diag_selected[k].diagnosis_id)
      }

      var ids_string1 = this.ids_diag.toString();

      this.advice = [];
      this.adv_data = [];
      this.adv_page = 1
      this.adv_copy1 = []
      this.chars6 = ''

      var params4 = {
        account_email: this.dmail,
        page_no: this.adv_page,
        diagnosis_id: ids_string1,
        doctor_id: this.doc_id
      }

      if (!mode)
        this.getAdv(this.urlPoints.getAdv, params4, token)

      this.adv_keyboard = true

      if (mode == 'alp' || 1 == 1) {
        this.toggle_adv()
      }
    }

    if (block == 'pmh') {
      var questionParams = {
        patient_email: this.patient.record_info.Record.account_email,
        account_email: this.dmail,
        category: 'past_medical_history'
      }

      this.appService.getData(this.urlPoints.getHealthSurveyPatient, questionParams, this.token).subscribe((response: any) => {

        this.pmhdata = response.data


        for (var i = 0; i < this.pmhdata.length; i++) {

          if (this.pmhdata[i].question_type == 'checkbox') {


            if (typeof (this.pmhdata[i].answer) == 'string')
              this.pmhdata[i].answer = JSON.parse(this.pmhdata[i].answer)

            for (var j = 0; j < this.pmhdata[i].options.length; j++) {

              for (var k = 0; k < this.pmhdata[i].answer.length; k++) {

                if (this.pmhdata[i].options[j].checkbox_title == this.pmhdata[i].answer[k]) {

                  this.pmhdata[i].options[j].checkbox_value = 1

                }
              }
            }
          }
        }

      });
    }

    if (block == 'sh') {
      var questionParams = {
        patient_email: this.patient.record_info.Record.account_email,
        account_email: this.dmail,
        category: 'social_personal_history'
      }

      this.appService.getData(this.urlPoints.getHealthSurveyPatient, questionParams, this.token).subscribe((response: any) => {
        this.shdata = response.data

        for (var i = 0; i < this.shdata.length; i++) {

          if (this.shdata[i].question_type == 'checkbox' || this.shdata[i].question_type == 'checkbox ') {

            for (var j = 0; j < this.shdata[i].options.length; j++) {
              for (var k = 0; k < this.shdata[i].answer.length; k++) {

                if (this.shdata[i].options[j].checkbox_title == this.shdata[i].answer[k]) {
                  this.shdata[i].options[j].checkbox_value = 1
                }
              }
            }
          }

          if (this.shdata[i].question_type == 'checkbox+number') {
            for (var j = 0; j < this.shdata[i].options.length; j++) {
              for (var k = 0; k < this.shdata[i].answer.length; k++) {


                if (this.shdata[i].options[j].checkbox_title == this.shdata[i].answer[k].split(' - ')[0].trim()) {
                  this.shdata[i].options[j].checkbox_value = 1

                  this.shdata[i].options[j].number_value = this.shdata[i].answer[k].split(' - ')[1].trim()

                }

              }
            }
          }

          //checkbox+number
        }

      });
    }

    if (block == 'cm') {
      var questionParams = {
        patient_email: this.patient.record_info.Record.account_email,
        account_email: this.dmail,
        category: 'medication_history'
      }

      this.appService.getData(this.urlPoints.getHealthSurveyPatient, questionParams, this.token).subscribe((response: any) => {
        this.cmdata = response.data

        for (var i = 0; i < this.cmdata.length; i++) {
          if (this.cmdata[i].question_type == 'text+ text') {

            this.prescriptions = [];
            this.pres_copy1 = [];
            this.pres_page = 1;
            this.pres_copy1 = [];
            this.chars5 = ''

            this.pres_selected1 = Object.assign([], this.pres_selected);

            this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

            for (var j = 0; j < this.cmdata[i].options.length; j++) {
              for (var k = 0; k < this.cmdata[i].answer.length; k++) {

                if (this.cmdata[i].options[j].text_title == this.cmdata[i].answer[k].split(' - ')[0].trim()) {

                  this.cmdata[i].options[j].text_value = this.cmdata[i].answer[k].split(' - ')[1].trim()

                }
              }
            }


          }
        }
      });

      this.pres_copy_cm1 = [];

      var pastParams = {
        patient_email: this.patient.record_info.Record.account_email,
        account_email: this.dmail,
        doctor_id: this.doc_id
      }

      this.appService.getData(this.urlPoints.previousMedicines, pastParams, this.token).subscribe((response: any) => {

        for (var i = 0; i < response.data.length; i++) {

          var obj = {
            name: response.data[i].generic.trim(),
            manufacture: response.data[i].brand.trim(),
            category: response.data[i].formulation ? response.data[i].formulation.trim() : '',
            unit: response.data[i].unit ? response.data[i].unit : '',
            id: response.data[i].medicine_master_id,
            formulation: response.data[i].formulation.trim(),
            strength: response.data[i].strength ? response.data[i].strength : '',
            dose: response.data[i].dose ? response.data[i].dose : '',
            dose_option: response.data[i].dose_option ? response.data[i].dose_option : '',
            duration: response.data[i].duration ? response.data[i].duration : '',
            duration_type: response.data[i].duration_type ? response.data[i].duration_type : '',
            frequency: response.data[i].frequency ? response.data[i].frequency : '',
            special_instruction: response.data[i].special_instruction ? response.data[i].special_instruction : '',
            strength_unit: response.data[i].strength_unit ? response.data[i].strength_unit : '',
            minimum_buyable_qty: response.data[i].minimum_buyable_qty ? response.data[i].minimum_buyable_qty : "",
          }

          this.pres_copy_cm1.push(obj)
        }
      });
    }

    var params5 = {
      account_email: this.dmail,
      appointment_id: this.appointment_id
    }

    this.appService.getData(this.urlPoints.getPreview, params5, token).subscribe((response: any) => {
      if (response.op_review.appointment_id) {
        this.call = 'update'
        this.preview = 'Update Consultation'
      }
      else {
        this.call = 'add'
      }

      this.save_add()
    });

    this.show_block = block
  }

  highlight1() {
    //  this.highlight = true
    //  alert()
  }

  radioSubmit(value, i, j) {

    this.shdata[i].answer = value

  }

  radioSubmit1(value, i, j) {

    this.cmdata[i].answer = value
  }


  addPres() {

    console.log('here')

    this.printArr = [];

    var params = {
      "account_email": this.dmail, doctor_id: this.doc_id,
      "prescription": {
        "patient_email": this.patient.record_info.Record.account_email,
        "prescription_id": this.prescription_id,
        "entries": this.pres_entries
      }
    }

    this.appService.postData(this.urlPoints.addPres, params, this.token).subscribe((response: any) => {

      this.prescription_id = response.prescription.id;

      //  this.save_follow1()
      this.save_add1()

    });
  }

  updatePres() {

    console.log('up')


    this.pres_entries = []

    for (var i = 0; i < this.pres_selected_copy1.length; i++) {
      this.pres_count++;
      var obj = {
        drug_id: this.pres_selected_copy1[i].id,
        dose: this.pres_selected_copy1[i].dose,
        dose_option: this.pres_selected_copy1[i].dose_option,
        frequency: this.pres_selected_copy1[i].frequency,
        route: this.pres_selected_copy1[i].route,
        when: this.pres_selected_copy1[i].when,
        duration: this.pres_selected_copy1[i].duration.toString(),
        duration_type: this.pres_selected_copy1[i].duration_type,
        quantity: this.pres_selected_copy1[i].quantity,
        special_instruction: this.pres_selected_copy1[i].special_instruction,
        minimum_buyable_qty: this.pres_selected_copy1[i].minimum_buyable_qty,
        operation: 'delete',
        pres_id: this.pres_count
      }

      this.pres_entries.push(obj)
    }

    for (var i = 0; i < this.pres_entries.length; i++) {
      this.pres_entries[i].operation = 'delete'
    }

    console.log(this.pres_entries)

    var params = {
      "account_email": this.dmail, doctor_id: this.doc_id,
      "prescription": {
        "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
        "entries": this.pres_entries
      }
    }

    console.log('here')
    this.appService.postData(this.urlPoints.updatePres, params, this.token).subscribe((response: any) => {

      this.preview_id = response.id


      this.pres_entries = []

      for (var i = 0; i < this.pres_selected.length; i++) {
        this.pres_count++;
        var obj = {
          drug_id: this.pres_selected[i].id,
          dose: this.pres_selected[i].dose,
          dose_option: this.pres_selected[i].dose_option,
          frequency: this.pres_selected[i].frequency,
          route: this.pres_selected[i].route,
          when: this.pres_selected[i].when,
          duration: this.pres_selected[i].duration.toString(),
          duration_type: this.pres_selected[i].duration_type,
          quantity: this.pres_selected[i].quantity,
          special_instruction: this.pres_selected[i].special_instruction,
          minimum_buyable_qty: this.pres_selected[i].minimum_buyable_qty,
          operation: 'add',
          pres_id: this.pres_count
        }

        this.pres_entries.push(obj)
      }

      console.log(this.pres_entries)

      var params = {
        "account_email": this.dmail, doctor_id: this.doc_id,
        "prescription": {
          "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
          "entries": this.pres_entries
        }
      }

      this.appService.postData(this.urlPoints.updatePres, params, this.token).subscribe((response: any) => {
        this.preview_id = response.id
        this.save_add1()

      })
    });

  }

  save_cc(result1?) {

    if (this.chief_complaints.length == 0) {

      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
        width: '600px', disableClose: true,
        data: { name: 'Add ' + result1 + ' to Chief Complaints?', type: 1 }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result == 'yes') {

            var params = {
              account_email: this.dmail,
              word_type: 0,
              new_complaint: [result1],
              doctor_id: this.doc_id,
            }

            this.appService.postData(this.urlPoints.newCC, params, this.token).subscribe((response: any) => {

              var params2 = {
                account_email: this.dmail,
                page_no: 1,
                alphabet: result1,
                "doctor_id": this.doc_id
              }

              this.getCC1(this.urlPoints.getCC, params2, this.token);

            }
            );
          }
          else {
          }
        }
      });
    }
  }

  save_cc1(result1?) {

    var params = {
      account_email: this.dmail,
      word_type: 0,
      new_complaint: [result1],
      doctor_id: this.doc_id,
    }

    this.appService.postData(this.urlPoints.newCC, params, this.token).subscribe((response: any) => {

      var params2 = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: result1,
        "doctor_id": this.doc_id
      }
      this.getCC1(this.urlPoints.getCC, params2, this.token);
    }
    );
  }

  save_ex(result1?) {
    if (this.examination.length == 0) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
        width: '600px', disableClose: true,
        data: { name: 'Add ' + result1 + ' to Examinations?', type: 1 }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result == 'yes') {
            var params = {
              account_email: this.dmail,
              word_type: 1,
              new_complaint: [result1],
              doctor_id: this.doc_id,
            }

            this.appService.postData(this.urlPoints.newCC, params, this.token).subscribe((response: any) => {

              var params2 = {
                account_email: this.dmail,
                page_no: 1,
                alphabet: result1,
                doctor_id: this.doc_id
              }

              this.getEx1(this.urlPoints.getEx, params2, this.token);

            }
            );
          }
          else {
          }
        }
      });
    }
  }

  save_ex1(result1?) {

    var params = {
      account_email: this.dmail,
      word_type: 1,
      new_complaint: [result1],
      doctor_id: this.doc_id,
    }

    this.appService.postData(this.urlPoints.newCC, params, this.token).subscribe((response: any) => {

      var params2 = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: result1,
        doctor_id: this.doc_id
      }

      this.getEx1(this.urlPoints.getEx, params2, this.token);

    }
    );
  }

  save_diag(result1?) {
    if (this.diagnosis.length == 0) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
        width: '600px', disableClose: true,
        data: { name: 'Add ' + result1 + ' to Diagnosis?', type: 1 }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result == 'yes') {
            var params = {
              account_email: this.dmail,
              new_diagnosis: [result1],
              doctor_id: this.doc_id,
            }

            this.appService.postData(this.urlPoints.newDiag, params, this.token).subscribe((response: any) => {

              var params2 = {
                account_email: this.dmail,
                page_no: 1,
                alphabet: result1
              }

              this.getDiag1(this.urlPoints.getDiag, params2, this.token);

            }
            );
          }
          else {
          }


        }
      });
    }
  }

  save_diag1(result1?) {

    var params = {
      account_email: this.dmail,
      new_diagnosis: [result1],
      doctor_id: this.doc_id,
    }

    this.appService.postData(this.urlPoints.newDiag, params, this.token).subscribe((response: any) => {

      var params2 = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: result1,
        doctor_id: this.doc_id
      }

      this.getDiag1(this.urlPoints.getDiag, params2, this.token);

    }
    );

  }

  save_inv(result1?) {
    if (this.investigations.length == 0) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
        width: '600px', disableClose: true,
        data: { name: 'Add ' + result1 + ' to Investigations?', type: 1 }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result == 'yes') {
            var params = {
              account_email: this.dmail,
              new_investigation: [result1],
              doctor_id: this.doc_id,
            }

            this.appService.postData(this.urlPoints.newInv, params, this.token).subscribe((response: any) => {

              var params2 = {
                account_email: this.dmail,
                page_no: 1,
                alphabet: result1,
                doctor_id: this.doc_id
              }

              this.getInv1(this.urlPoints.getInv, params2, this.token);

            }
            );
          }
          else {
          }


        }
      });
    }
  }


  save_inv1(result1?) {

    var params = {
      account_email: this.dmail,
      new_investigation: [result1],
      doctor_id: this.doc_id,
    }

    this.appService.postData(this.urlPoints.newInv, params, this.token).subscribe((response: any) => {

      var params2 = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: result1,
        doctor_id: this.doc_id
      }

      this.getInv1(this.urlPoints.getInv, params2, this.token);

    }
    );
  }

  save_pres(result?) {
  }

  save_adv(result1?) {
    if (this.advice.length == 0) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
        width: '600px', disableClose: true,
        data: { name: 'Add ' + result1 + ' to Advice?', type: 1 }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result == 'yes') {
            var params = {
              account_email: this.dmail,
              new_instruction: [result1],
              doctor_id: this.doc_id
            }

            this.appService.postData(this.urlPoints.newAdv, params, this.token).subscribe((response: any) => {

              var params2 = {
                account_email: this.dmail,
                page_no: 1,
                alphabet: result1,
                doctor_id: this.doc_id
              }

              this.getAdv1(this.urlPoints.getAdv, params2, this.token);

            }
            );
          }
          else {
          }


        }
      });
    }
  }

  save_adv1(result1?) {

    var params = {
      account_email: this.dmail,
      new_instruction: [result1],
      doctor_id: this.doc_id
    }

    this.appService.postData(this.urlPoints.newAdv, params, this.token).subscribe((response: any) => {

      var params2 = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: result1,
        doctor_id: this.doc_id
      }

      this.getAdv1(this.urlPoints.getAdv, params2, this.token);

    }
    );
  }

  inputClick() {
    if (this.show_block == 'diag') {
      this.diag_toggle = 'alp'
      var params1 = {
        account_email: this.dmail,
        page_no: this.diag_page,
        alphabet: this.chars3,
        doctor_id: this.doc_id
      }
      if (this.chars3 == '')
        this.getDiagCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
      else
        this.getDiag(this.urlPoints.getDiag, params1, this.token)
    }
    if (this.show_block == 'inv') {
      this.inv_toggle = 'alp'
      var params1 = {
        account_email: this.dmail,
        page_no: this.inv_page,
        alphabet: this.chars4,
        doctor_id: this.doc_id
      }
      if (this.chars4 == '')
        this.getInvCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
      else
        this.getInv(this.urlPoints.getInv, params1, this.token)
    }
    if (this.show_block == 'pres') {
      this.pres_toggle = 'alp'
      var params1 = {
        account_email: this.dmail,
        page_no: this.pres_page,
        alphabet: this.chars5,
        doctor_id: this.doc_id
      }
      if (this.chars5 == '')
        this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
      else
        this.getPres(this.urlPoints.getPres, params1, this.token)
    }
    if (this.show_block == 'adv') {
      this.adv_toggle = 'alp'
      var params1 = {
        account_email: this.dmail,
        page_no: this.adv_page,
        alphabet: this.chars6,
        doctor_id: this.doc_id
      }
      if (this.chars6 == '')
        this.getAdvCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
      else
        this.getAdv(this.urlPoints.getAdv, params1, this.token)
    }
  }


  upload_attach(data) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_upload, {
      width: '480px',
      data: { name: data }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.medication=result
        // this.pres_selected.push(this.medication)
      }
    });
  }

  labtest_popup(data) {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_labtest, {
      width: '480px',
      data: {
        obj: data
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.medication=result
        // this.pres_selected.push(this.medication)
      }
    });
  }

  vaccination_popup(data) {
    var token = this.token;
    var dob = moment(this.patient.demographics.bday).format("YYYY-MM-DD");
    var params_vaccinelist = {
      "account_email": this.dmail,
      "patient_email": this.patient.record_info.Record.account_email,
      "sno": data.sno,
      "dob": moment(dob).format("YYYY-MM-DD"),
      "date": moment(new Date()).format("YYYY-MM-DD")
    }

    this.appService.getData(this.urlPoints.getvaccinationlist, params_vaccinelist, token).subscribe((response: any) => {
      this.vaccination_list = response;
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_vaccination, {
        width: '650px',
        disableClose: true,
        data: {
          obj: data,
          nextvaccine: this.vaccination_list,
          params_vaccinelist: params_vaccinelist,
          token: token
        }

      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.adminster = result.formdata;
          this.adminstered(this.adminster, result.actualdata)
          // this.medication=result
          // this.pres_selected.push(this.medication)
        }
      });
    });

  }

  adminstered(data, res) {

    var due_date = moment(data.due_date).format("YYYY-MM-DD");
    var date_given = moment(data.administration).format("YYYY-MM-DD");
    var token = this.token;
    var params = {
      "drug_name": res.drug_name,
      "sno": res.sno,
      "site": data.site,
      "comments": data.textarea,
      "id": res.id,
      "batch_id": data.batch,
      "brand_name": data.brandname,
      "due_date": due_date,
      "date_given": date_given,
      "account_email": this.dmail,
      "patient_email": this.patient.record_info.Record.account_email,
      "user_type": "doctor",
      "status": "Administered"
    }
    this.deffered(this.urlPoints.deffer, params, token)


  }


  demographics_Update(url, params, token) {
    this.appService.postData(url, params, token).subscribe((response: any) => {
    });
  }

  none(i, j) {


    if (this.pmhdata[i].options[j].checkbox_value == 1) {
      for (var k = 0; k < this.pmhdata[i].options.length; k++) {
        if (j != k)
          this.pmhdata[i].options[k].checkbox_value = 0
      }
    }
  }

  notnone1(i, j) {
    this.shdata[i].options[3].checkbox_value = 0
  }


  none1(i, j) {

    if (this.shdata[i].options[j].checkbox_value == 1) {
      for (var k = 0; k < this.shdata[i].options.length; k++) {
        if (j != k)
          this.shdata[i].options[k].checkbox_value = 0
      }
    }
  }

  optionToggle(i, j) {

    this.pmhdata[i].options[j].checkbox_value = this.pmhdata[i].options[j].checkbox_value == 1 ? 0 : 1

  }

  optionToggle1(i, j) {
    this.shdata[i].options[j].checkbox_value = this.shdata[i].options[j].checkbox_value == 1 ? 0 : 1

  }

  optionToggle2(i, j) {
    this.cmdata[i].options[j].checkbox_value = this.cmdata[i].options[j].checkbox_value == 1 ? 0 : 1

  }

  savePMH() {

    for (var i = 0; i < this.pmhdata.length; i++) {
      if (this.pmhdata[i].question_type == 'checkbox') {
        var answers = []

        for (var j = 0; j < this.pmhdata[i].options.length; j++) {

          if (this.pmhdata[i].options[j].checkbox_value == 1) {
            answers.push(this.pmhdata[i].options[j].checkbox_title)
          }
        }

        var params = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.pmhdata[i].question_id,
              category_id: this.pmhdata[i].category_id,
              sub_category_id: this.pmhdata[i].sub_category_id,
              answer: answers
            }]
        }

        this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params, this.token).subscribe((response: any) => {
          this.getAnswers()
        });

      }

      if (this.pmhdata[i].question_type == 'text') {
        var params1 = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.pmhdata[i].question_id,
              category_id: this.pmhdata[i].category_id,
              sub_category_id: this.pmhdata[i].sub_category_id,
              answer: this.pmhdata[i].answer
            }]
        }

        this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params1, this.token).subscribe((response: any) => {
          // this.toastr.success('Data saved!', '', {
          //   timeOut: 3000,
          // });
          this.getAnswers()

        });

      }

    }

    this.toastr.success('Data saved!', '', {
      timeOut: 3000,
    });
  }

  saveSH() {

    for (var i = 0; i < this.shdata.length; i++) {

      if (this.shdata[i].question_type == 'radio_button') {
        var params1 = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.shdata[i].question_id,
              category_id: this.shdata[i].category_id,
              sub_category_id: this.shdata[i].sub_category_id,
              answer: this.shdata[i].answer
            }]
        }

        if (params1.data[0].answer)
          this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params1, this.token).subscribe((response: any) => {
            this.getAnswers()
          });

      }

      if (this.shdata[i].question_type == 'number' || this.shdata[i].question_type == 'text' || this.shdata[i].question_type == 'date') {
        var params1 = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.shdata[i].question_id,
              category_id: this.shdata[i].category_id,
              sub_category_id: this.shdata[i].sub_category_id,
              answer: this.shdata[i].answer
            }]
        }

        if (this.shdata[i].question_type == 'text' || this.shdata[i].question_type == 'number' || this.shdata[i].question_type == 'date')

          this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params1, this.token).subscribe((response: any) => {
            this.getAnswers()

          });

      }

      if (this.shdata[i].question_type == 'checkbox' || this.shdata[i].question_type == 'checkbox ') {
        var answers = []

        for (var j = 0; j < this.shdata[i].options.length; j++) {

          if (this.shdata[i].options[j].checkbox_value == 1) {
            answers.push(this.shdata[i].options[j].checkbox_title)
          }
        }

        var params = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.shdata[i].question_id,
              category_id: this.shdata[i].category_id,
              sub_category_id: this.shdata[i].sub_category_id,
              answer: answers
            }]
        }

        this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params, this.token).subscribe((response: any) => {
          this.getAnswers()

        });

      }

      if (this.shdata[i].question_type == 'checkbox+number') {

        var answer = []
        var temp

        for (var j = 0; j < this.shdata[i].options.length; j++) {

          if (this.shdata[i].options[j].checkbox_value == 1) {
            temp = this.shdata[i].options[j].checkbox_title + ' - ' + this.shdata[i].options[j].number_value

            answer.push(temp)
          }
        }

        var params = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.shdata[i].question_id,
              category_id: this.shdata[i].category_id,
              sub_category_id: this.shdata[i].sub_category_id,
              answer: answer
            }]
        }

        this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params, this.token).subscribe((response: any) => {
          this.getAnswers()

        });

      }
    }

    this.toastr.success('Data saved!', '', {
      timeOut: 3000,
    });
  }

  saveCM() {
    for (var i = 0; i < this.cmdata.length; i++) {
      if (this.cmdata[i].question_type == 'radio_button') {
        var params1 = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.cmdata[i].question_id,
              category_id: this.cmdata[i].category_id,
              sub_category_id: this.cmdata[i].sub_category_id,
              answer: this.cmdata[i].answer
            }]
        }

        if (params1.data[0].answer)
          this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params1, this.token).subscribe((response: any) => {
            this.getAnswers()

          });

      }

      if (this.cmdata[i].question_type == 'text') {
        var params1 = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.cmdata[i].question_id,
              category_id: this.cmdata[i].category_id,
              sub_category_id: this.cmdata[i].sub_category_id,
              answer: this.cmdata[i].answer
            }]
        }

        this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params1, this.token).subscribe((response: any) => {
          // this.toastr.success('Data saved!', '', {
          //   timeOut: 3000,
          // });
          this.getAnswers()

        });

      }

      if (this.cmdata[i].question_type == 'text+ text') {

        var answers = [];

        var drug_details = [];

        var drugs = [];

        for (var j = 0; j < this.cmdata[i].options.length; j++) {

          if (this.cmdata[i].options[j].text_value) {
            answers.push(this.cmdata[i].options[j].text_title + ' - ' + this.cmdata[i].options[j].text_value)
          }
        }

        for (var j = 0; j < this.pres_selected_soap.length; j++) {
          drug_details = []

          drug_details.push(this.pres_selected_soap[j].brand)

          drug_details.push(this.pres_selected_soap[j].frequency)

          answers.push(drug_details)

        }

        var params2 = {
          patient_email: this.patient.record_info.Record.account_email,
          doctor_email: this.dmail,
          account_email: this.dmail,
          data: [
            {
              question_id: this.cmdata[i].question_id,
              category_id: this.cmdata[i].category_id,
              sub_category_id: this.cmdata[i].sub_category_id,
              answer: answers
            }]
        }

        this.appService.postData(this.urlPoints.submitHealthSurveyPatient, params2, this.token).subscribe((response: any) => {
          this.getAnswers()

        });

        for (var j = 0; j < this.pres_selected_soap.length; j++) {
          var obj = {
            drug_name: this.pres_selected_soap[j].brand,
            drug_id: this.pres_selected_soap[j].id,
            frequency: this.pres_selected_soap[j].frequency,
            when: this.pres_selected_soap[j].when,
            dose: this.pres_selected_soap[j].dose,
            dose_option: this.pres_selected_soap[j].dose_option,
            duration: this.pres_selected_soap[j].duration,
            duration_type: this.pres_selected_soap[j].duration_type,
            formulation: this.pres_selected_soap[j].formulation,
            minimum_buyable_qty: this.pres_selected_soap[j].minimum_buyable_qty,
            quantity: this.pres_selected_soap[j].quantity,
            route: this.pres_selected_soap[j].route,
            special_instruction: this.pres_selected_soap[j].special_instruction,
            strength: this.pres_selected_soap[j].strength,
            strength_unit: this.pres_selected_soap[j].strength_unit,
          }

          drugs.push(obj);

        }

        var drugObj = {
          patient_email: this.patient.record_info.Record.account_email,
          account_email: this.dmail,
          data: drugs
        }

        this.appService.postData(this.urlPoints.saveDrugDetails, drugObj, this.token).subscribe((response: any) => {
        });

      }

      if (this.cmdata[i].question_type == 'text+text+text') {
        var food;
        var medication;
        var others;

      }
    }

    this.toastr.success('Data saved!', '', {
      timeOut: 3000,
    });
  }

  filter_alphabet1(alphabet) {
    this.cc_arr = [];
    this.chars1Arr = []

    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars1 = this.chars1 + alphabet;
    }
    else {
      this.chars1 = this.chars1.slice(0, -1)
    }
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars1,
      "doctor_id": this.doc_id
    }
    if (this.chars1 == '')
      this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getCC, params, this.token);
    this.cc_data = [];
    this.cc_page = 1;

    this.service.text1 = this.chars1
  }

  filter_key1() {
    this.cc_arr = []
    this.chars1Arr = []
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars1.toUpperCase().trim(),
      "doctor_id": this.doc_id
    }
    if (this.chars1 == '')
      this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getCC, params, this.token);
    this.cc_data = [];
    this.cc_page = 1;
  }

  filter2_key1(enter?) {
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars1.toUpperCase(),
      "doctor_id": this.doc_id
    }
    if (this.chars1 == '')
      this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)
    else
      this.appService.getData(this.urlPoints.getCC, params, this.token).subscribe((response: any) => {
        if (response.success != 0) {
          this.cc_pages = response.total_page;
          this.cc_data = this.cc_data.concat(response.data)
          this.chief_complaints = this.cc_data;
          this.cc_copy = Object.assign([], this.chief_complaints);
          this.cc_copy1 = Object.assign([], this.chief_complaints);

          var matchedArray = [];

          for (var i = 0; i < this.chief_complaints.length; i++) {
            for (var k = 0; k < this.cc_selected.length; k++) {
              if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {

            this.cc_copy.splice(matchedArray[i], 1);
            this.cc_copy1.splice(matchedArray[i], 1);
          }

          var params2 = {
            doctor_id: this.doc_id,
            word_type: 1,
            reference_word: this.chars1.toLowerCase(),
            account_email: this.dmail
          }

          this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {

            if (!enter)
              this.chief_complaints = this.chief_complaints.concat((response.data));

            var matchedArray = [];

            this.cc_copy = Object.assign([], this.chief_complaints);
            this.cc_copy1 = Object.assign([], this.chief_complaints);

            for (var i = 0; i < this.chief_complaints.length; i++) {
              for (var k = 0; k < this.cc_selected.length; k++) {
                if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
                  matchedArray.push(i);
                }
              }
            }

            for (var i = matchedArray.length - 1; i >= 0; i--) {

              this.cc_copy.splice(matchedArray[i], 1);
              this.cc_copy1.splice(matchedArray[i], 1);
            }

            if (this.cc_copy1.length == 0 && !enter) {
              this.start1()
              this.add = true;
            }
            else {
              this.add = false
            }

            if (this.cc_copy1.length == 1) {
              this.update_cc(0, 0)
              this.chars1 = ''
              this.chars1Arr = []
              //  this.set('cc')
            }

            var cc = this.chief_complaints

            if (enter) {

              if ((this.chief_complaints.length == 0) || (cc.filter(i => i.name.toLowerCase() == this.chars1.toLowerCase()).length) == 0) {
                this.save_cc1(this.chars1)
                this.chars1 = ''
                this.chars1Arr = []
                //  this.set('cc')
              }
            }
          });
        }
      });

    this.cc_data = [];
    this.cc_page = 1;
  }

  filter_alphabet2(alphabet) {
    this.ex_arr = []
    this.chars2Arr = []

    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars2 = this.chars2 + alphabet;
    }
    else {
      this.chars2 = this.chars2.slice(0, -1)
    }

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars2,
      doctor_id: this.doc_id
    }
    if (this.chars2 == '')
      this.getExCounter(this.urlPoints.getExCounter, this.counter_params, this.token)
    else
      this.getEx(this.urlPoints.getEx, params, this.token);
    this.ex_data = [];
    this.ex_page = 1;
    this.service.text1 = this.chars2

  }

  filter_key2() {
    this.ex_arr = []
    this.chars2Arr = []

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars2.toUpperCase().trim(),
      doctor_id: this.doc_id
    }

    if (this.chars2 == '')
      this.getExCounter(this.urlPoints.getExCounter, this.counter_params, this.token)
    else
      this.getEx(this.urlPoints.getEx, params, this.token); this.ex_data = [];
    this.ex_page = 1;
  }

  filter2_key2(enter?) {
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars2.toUpperCase(),
      doctor_id: this.doc_id
    }

    if (this.chars2 == '')
      this.getExCounter(this.urlPoints.getExCounter, this.counter_params, this.token)
    else
      //  this.getEx(this.urlPoints.getEx, params, this.token);    
      this.appService.getData(this.urlPoints.getEx, params, this.token).subscribe((response: any) => {

        if (response.success != 0) {

          this.examination = response.data;
          this.ex_pages = response.total_page;

          this.ex_data = this.ex_data.concat(response.data)

          this.examination = this.ex_data;

          this.ex_copy = Object.assign([], this.examination);
          this.ex_copy1 = Object.assign([], this.examination);

          var matchedArray = [];

          for (var i = 0; i < this.examination.length; i++) {
            for (var k = 0; k < this.ex_selected.length; k++) {
              if (this.examination[i].symptoms_id == this.ex_selected[k].symptoms_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {

            this.ex_copy.splice(matchedArray[i], 1);
            this.ex_copy1.splice(matchedArray[i], 1);
          }
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 2,
          reference_word: this.chars2.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {

          if (!enter)
            this.examination = this.examination.concat((response.data));

          var matchedArray = [];

          this.ex_copy = Object.assign([], this.examination);
          this.ex_copy1 = Object.assign([], this.examination);

          for (var i = 0; i < this.examination.length; i++) {
            for (var k = 0; k < this.ex_selected.length; k++) {
              if (this.examination[i].symptoms_id == this.ex_selected[k].symptoms_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {

            this.ex_copy.splice(matchedArray[i], 1);
            this.ex_copy1.splice(matchedArray[i], 1);
          }

          if (this.ex_copy1.length == 0 && !enter) {
            this.start1()
            this.add = true;
          }
          else {
            this.add = false
          }

          if (this.ex_copy1.length == 1) {
            this.update_ex(0, 0)
            this.chars2 = ''
            this.chars2Arr = []
            this.set('ex')
          }

          var ex = this.examination

          if (enter)
            if ((this.examination.length == 0) || ex.filter(i => i.name.toLowerCase() == this.chars2.toLowerCase()).length == 0) {

              this.save_ex1(this.chars2)
              this.chars2 = ''
              this.chars2Arr = []
              this.set('ex')
            }
        });

      });
    this.ex_data = [];
    this.ex_page = 1;


  }

  filter_alphabet3(alphabet) {
    this.diag_arr = []
    this.chars3Arr = []

    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars3 = this.chars3 + alphabet;
    }
    else {
      this.chars3 = this.chars3.slice(0, -1)
    }

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars3,
      doctor_id: this.doc_id
    }
    if (this.chars3 == '')
      this.getDiagCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
    else
      this.getDiag(this.urlPoints.getDiag, params, this.token);
    this.diag_data = [];
    this.diag_page = 1;
    this.service.text1 = this.chars3

  }

  filter_key3() {
    this.diag_arr = []
    this.chars3Arr = []

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars3.toUpperCase().trim(),
      doctor_id: this.doc_id
    }

    if (this.chars3 == '')
      this.getDiagCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
    else
      this.getDiag(this.urlPoints.getDiag, params, this.token); this.diag_data = [];
    this.diag_page = 1;
  }

  filter2_key3(enter?) {
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars3.toUpperCase(),
      doctor_id: this.doc_id
    }

    if (this.chars3 == '')
      this.getDiagCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
    else
      this.appService.getData(this.urlPoints.getDiag, params, this.token).subscribe((response: any) => {
        if (response.success != 0) {
          this.diagnosis = response.data;
          this.diag_pages = response.total_page;
          this.diag_data = this.diag_data.concat(response.data);
          this.diagnosis = this.diag_data;

          this.diag_copy = Object.assign([], this.diagnosis);
          this.diag_copy1 = Object.assign([], this.diagnosis);

          var matchedArray = [];

          if (response.success == 1) {
            for (var i = 0; i < this.diagnosis.length; i++) {
              for (var k = 0; k < this.diag_selected.length; k++) {
                if (this.diagnosis[i].diagnosis_id == this.diag_selected[k].diagnosis_id) {
                  matchedArray.push(i);
                }
              }
            }
            for (var i = matchedArray.length - 1; i >= 0; i--) {
              this.diag_copy.splice(matchedArray[i], 1);
              this.diag_copy1.splice(matchedArray[i], 1);
            }
          }
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 3,
          reference_word: this.chars3.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {

          if (!enter)
            this.diagnosis = this.diagnosis.concat((response.data));

          var matchedArray = [];


          this.diag_copy = Object.assign([], this.diagnosis);
          this.diag_copy1 = Object.assign([], this.diagnosis);

          for (var i = 0; i < this.diagnosis.length; i++) {
            for (var k = 0; k < this.diag_selected.length; k++) {
              if (this.diagnosis[i].diagnosis_id == this.diag_selected[k].diagnosis_id) {
                matchedArray.push(i);
              }
            }
          }
          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.diag_copy.splice(matchedArray[i], 1);
            this.diag_copy1.splice(matchedArray[i], 1);
          }

          if (this.diag_copy1.length == 0 && !enter) {
            this.start1()
            this.add = true;
          }
          else {
            this.add = false
          }

          if (this.diag_copy1.length == 1) {
            this.update_diag(0, 0)
            this.chars3 = ''
            this.chars3Arr = []
            this.set('diag', 'alp')
          }


          var diag = this.diagnosis

          if (enter)
            if ((this.diagnosis.length == 0) || diag.filter(i => i.name.toLowerCase() == this.chars3.toLowerCase()).length == 0) {
              this.save_diag1(this.chars3)
              this.chars3 = ''
              this.chars3Arr = []
              this.set('diag', 'alp')
            }
        });
      });

    this.diag_data = [];
    this.diag_page = 1;
  }

  filter_alphabet4(alphabet) {
    this.inv_arr = []
    this.chars4Arr = []

    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars4 = this.chars4 + alphabet;
    }
    else {
      this.chars4 = this.chars4.slice(0, -1)
    }
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars4,
      doctor_id: this.doc_id
    }
    if (this.chars4 == '')
      this.getInvCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
    else
      this.getInv(this.urlPoints.getInv, params, this.token);
    this.inv_data = [];
    this.inv_page = 1
    this.service.text1 = this.chars4

  }

  filter_key4() {
    this.inv_arr = []
    this.chars4Arr = []

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars4.toUpperCase().trim(),
      doctor_id: this.doc_id
    }
    if (this.chars4 == '')
      this.getInvCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
    else
      this.getInv(this.urlPoints.getInv, params, this.token); this.inv_data = [];
    this.inv_page = 1
  }

  filter2_key4(enter?) {
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars4.toUpperCase(),
      doctor_id: this.doc_id
    }
    if (this.chars4 == '')
      this.getInvCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
    else
      //this.getInv(this.urlPoints.getInv, params, this.token); 
      this.appService.getData(this.urlPoints.getInv, params, this.token).subscribe((response: any) => {
        if (response.success !== 0) {
          this.investigations = response.data;
          this.inv_pages = response.total_page;
          this.inv_data = this.inv_data.concat(response.data);
          this.investigations = this.inv_data;

          this.inv_copy = Object.assign([], this.investigations);
          this.inv_copy1 = Object.assign([], this.investigations);
          var matchedArray = [];

          if (response.success == 1) {
            for (var i = 0; i < this.investigations.length; i++) {
              for (var k = 0; k < this.inv_selected.length; k++) {
                if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
                  matchedArray.push(i);
                }
              }
            }

            for (var i = matchedArray.length - 1; i >= 0; i--) {
              this.inv_copy.splice(matchedArray[i], 1);
              this.inv_copy1.splice(matchedArray[i], 1);
            }
          }
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 4,
          reference_word: this.chars4.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {

          if (!enter)
            this.investigations = this.investigations.concat((response.data));

          var matchedArray = [];

          this.inv_copy = Object.assign([], this.investigations);
          this.inv_copy1 = Object.assign([], this.investigations);

          for (var i = 0; i < this.investigations.length; i++) {
            for (var k = 0; k < this.inv_selected.length; k++) {
              if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.inv_copy.splice(matchedArray[i], 1);
            this.inv_copy1.splice(matchedArray[i], 1);
          }

          if (this.inv_copy1.length == 0 && !enter) {
            this.start1()
            this.add = true;
          }
          else {
            this.add = false
          }

          if (this.inv_copy1.length == 1) {
            this.update_inv(0, 0)
            this.chars4 = ''
            this.chars4Arr = []
            this.set('inv', 'alp')
          }

          var inv = this.investigations

          if (enter)

            if ((this.investigations.length == 0) || inv.filter(i => i.name.toLowerCase() == this.chars4.toLowerCase()).length == 0) {
              this.save_inv1(this.chars4)

              this.chars4 = ''
              this.chars4Arr = []
              this.set('inv', 'alp')
            }

        });
        //  this.service.text1 = "Sorry, no results found for '" + this.chars4 + "'"
      })
    this.inv_data = [];
    this.inv_page = 1
  }

  filter_alphabet5(alphabet) {
    this.pres_arr = []
    this.chars5Arr = []
    this.chars5Arr = []

    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars5 = this.chars5 + alphabet;
    }
    else {
      this.chars5 = this.chars5.slice(0, -1)
    }
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars5,
      doctor_id: this.doc_id
    }
    if (this.chars5 == '')
      this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
    else
      this.getPres(this.urlPoints.getPres, params, this.token);

    this.pres_data = [];
    this.pres_page = 1;
    this.service.text1 = this.chars5

  }

  filter_key5() {
    this.pres_arr = []
    this.chars5Arr = []

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars5.toUpperCase().trim(),
      doctor_id: this.doc_id
    }
    if (this.chars5 == '')
      this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
    else
      this.getPres(this.urlPoints.getPres, params, this.token);
    this.pres_data = [];
    this.pres_page = 1;
  }

  filter2_key5(enter?) {
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars5.toUpperCase(),
      doctor_id: this.doc_id
    }
    if (this.chars5 == '')
      this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
    else
      this.appService.getData(this.urlPoints.getPres, params, this.token).subscribe((response: any) => {
        if (response.success !== 0) {
          this.prescriptions = response.data;
          this.pres_pages = response.total_page;
          this.pres_data = this.pres_data.concat(response.data);
          this.prescriptions = this.pres_data;

          this.pres_copy = Object.assign([], this.prescriptions);
          this.pres_copy1 = Object.assign([], this.prescriptions);
          var matchedArray = [];

          if (response.success == 1) {
            for (var i = 0; i < this.prescriptions.length; i++) {
              for (var k = 0; k < this.pres_selected.length; k++) {
                if (this.prescriptions[i].medicine_id == this.pres_selected[k].medicine_id) {
                  matchedArray.push(i);
                }
              }
            }

            for (var i = matchedArray.length - 1; i >= 0; i--) {
              this.pres_copy.splice(matchedArray[i], 1);
              this.pres_copy1.splice(matchedArray[i], 1);
            }
          }
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 6,
          reference_word: this.chars5.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {

          if (!enter)
            this.prescriptions = this.prescriptions.concat((response.data));

          var matchedArray = [];

          this.pres_copy = Object.assign([], this.prescriptions);
          this.pres_copy1 = Object.assign([], this.prescriptions);

          for (var i = 0; i < this.prescriptions.length; i++) {
            for (var k = 0; k < this.pres_selected.length; k++) {
              if (this.prescriptions[i].medicine_id == this.pres_selected[k].medicine_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.pres_copy.splice(matchedArray[i], 1);
            this.pres_copy1.splice(matchedArray[i], 1);
          }

          if (this.pres_copy1.length == 0 && !enter) {
            this.start1()
            this.add = true;
          }
          else {
            this.add = false
          }

          if (this.pres_copy1.length == 1) {
            this.update_pres(0, 0)
            this.chars5 = ''
            this.chars5Arr = []
            this.set('pres', 'alp')

          }

        });
      })
    this.pres_data = [];
    this.pres_page = 1;
  }

  filter_alphabet6(alphabet) {
    this.adv_arr = []
    this.chars6Arr = []

    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars6 = this.chars6 + alphabet;
    }
    else {
      this.chars6 = this.chars6.slice(0, -1)
    }
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars6,
      doctor_id: this.doc_id
    }
    if (this.chars6 == '')
      this.getAdvCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
    else
      this.getAdv(this.urlPoints.getAdv, params, this.token);
    this.adv_data = [];
    this.adv_page = 1;
    this.service.text1 = this.chars6

  }

  filter_key6() {
    this.adv_arr = [];
    this.chars6Arr = []

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars6.toUpperCase().trim(),
      doctor_id: this.doc_id
    }
    if (this.chars6 == '')
      this.getAdvCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
    else
      this.getAdv(this.urlPoints.getAdv, params, this.token);
    this.adv_data = [];
    this.adv_page = 1;
  }

  filter2_key6(enter?) {

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars6.toUpperCase(),
      doctor_id: this.doc_id
    }
    if (this.chars6 == '')
      this.getAdvCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
    else
      //this.getAdv(this.urlPoints.getAdv, params, this.token);
      this.appService.getData(this.urlPoints.getAdv, params, this.token).subscribe((response: any) => {
        if (response.success !== 0) {
          this.advice = response.data;
          this.adv_pages = response.total_page;
          this.adv_data = this.adv_data.concat(response.data);
          this.advice = this.adv_data;

          this.adv_copy = Object.assign([], this.advice);
          this.adv_copy1 = Object.assign([], this.advice);
          var matchedArray = [];

          if (response.success == 1) {
            for (var i = 0; i < this.advice.length; i++) {
              for (var k = 0; k < this.adv_selected.length; k++) {
                if (this.advice[i].instruction_id == this.adv_selected[k].instruction_id) {
                  matchedArray.push(i);
                }
              }
            }

            for (var i = matchedArray.length - 1; i >= 0; i--) {
              this.adv_copy.splice(matchedArray[i], 1);
              this.adv_copy1.splice(matchedArray[i], 1);
            }
          }
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 5,
          reference_word: this.chars6.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {

          if (!enter)
            this.advice = this.advice.concat((response.data));

          this.adv_copy = Object.assign([], this.advice);
          this.adv_copy1 = Object.assign([], this.advice);

          var matchedArray = [];

          for (var i = 0; i < this.advice.length; i++) {
            for (var k = 0; k < this.adv_selected.length; k++) {
              if (this.advice[i].instruction_id == this.adv_selected[k].instruction_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.adv_copy.splice(matchedArray[i], 1);
            this.adv_copy1.splice(matchedArray[i], 1);
          }

          if (this.adv_copy1.length == 0 && !enter) {
            this.start1()
            this.add = true;
          }
          else {
            this.add = false
          }

          if (this.adv_copy1.length == 1) {
            this.update_adv(0, 0)
            this.chars6 = ''
            this.chars6Arr = []
            this.set('adv', 'alp')
          }

          var adv = this.advice

          if (enter)
            if ((this.advice.length == 0) || adv.filter(i => i.instructions.toLowerCase() == this.chars6.toLowerCase()).length == 0) {
              this.save_adv1(this.chars6)
              this.chars6 = ''
              this.chars6Arr = []
              this.set('adv', 'alp')
            }

        });

      });
    this.adv_data = [];
    this.adv_page = 1;
  }

  clear_alp1() {
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: ''
    }
    this.cc_page = 1;
    this.cc_data = [];
    this.cc_copy1 = [];
    this.chars1 = ''
    this.clear = !this.clear;
    this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)

  }

  clear_alp2() {
    this.chars2 = '';
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: ''
    }
    this.ex_copy1 = [];

    //   this.getEx(this.urlPoints.getEx, params, this.token);
    this.ex_page = 1;
    this.ex_data = [];
    this.chars2 = ''
    this.clear = !this.clear
    this.getExCounter(this.urlPoints.getExCounter, this.counter_params, this.token)

    // this.appService.getTags(this.urlPoints.tagsList1, params).subscribe((response: any) => {
    //   this.examination = response.smartpres.data;
    //   this.ex_copy = Object.assign([], this.examination);
    //   this.ex_copy1 = Object.assign([], this.examination);
    // });
  }

  clear_alp3() {
    this.chars3 = '';
    this.diag_copy1 = this.diagnosis;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars3
    }

    this.diag_page = 1;
    this.diag_data = [];
    this.diag_copy1 = [];
    this.chars3 = ''
    this.clear = !this.clear
    this.getDiagCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)


  }

  clear_alp4() {
    this.chars4 = '';
    this.inv_copy1 = this.investigations;
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars4
    }

    this.inv_page = 1;
    this.inv_data = [];
    this.inv_copy1 = [];
    this.chars4 = '';
    this.clear = !this.clear
    this.getInvCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)

    //   this.getInv(this.urlPoints.getInv, params,this.token)

  }

  clear_alp5() {
    this.chars5 = '';

    this.pres_copy1 = this.prescriptions;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars5
    }
    this.pres_page = 1;
    this.pres_data = [];
    this.pres_copy1 = [];
    this.chars5 = ''
    this.clear = !this.clear
    this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

    //  this.getPres(this.urlPoints.getPres, params,this.token)

  }

  clear_alp6() {
    this.chars6 = '';

    this.adv_copy1 = this.advice;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars6
    }

    this.adv_page = 1;
    this.adv_data = [];
    this.adv_copy1 = [];
    this.chars6 = ''
    this.clear = !this.clear
    this.getAdvCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)

    //  this.getAdv(this.urlPoints.getAdv, params,this.token)

  }

  openChiefComplaints() {
this.callMasterSettings()
    const dialogRef = this.dialog.open(Dialog_chiefComplaints, {
      width: '75vw',

      data: { selected: this.cc_selected, doc_id: this.doc_id, dmail: this.dmail, token: this.token,toggle_alignment:this.toggle_alignment },
      panelClass: this.toggle_alignment ? 'custom-dialog-container':'dialog-container',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.cc_selected = Object.assign([], result);

        this.cc_issues = []

        for (var i = 0; i < this.cc_selected.length; i++) {


          this.cc_issues.push({
            "category_id": this.cc_selected[i].id,
            "complaint_category_id": this.cc_selected[i].id,
            "complaint_type": this.cc_selected[i].name,
            "is_question": this.cc_selected[i].is_question ? 1 : 0,

            "details": [
              {
                "questions": "",
                "answers": ""
              },


            ]
          })
        }

        var params_cc = {
          account_email: this.dmail,
          appointment_id: this.appointment_id
        }

        if (!this.complaint_id) {
          var params = {
            "account_email": this.dmail,
            "doctor_id": this.doc_id,
            "simple_complaint": {
              "user_type": "doctor",
              "issues": this.cc_issues,
              "days": "",
              "medicine_given": "",
              "temperature": "",
              "unit": "",
              "other_information": "",
              "patient_email": this.patient.record_info.Record.account_email,
              "appointment_id": this.appointment_id
            }
          }

          this.appService.postData(this.urlPoints.simpleComplaint, params, this.token).subscribe((response: any) => {
            this.complaint_id = response.complaint.id;

            this.save_add1()
          });
        }

        else {

          var params_cc = {
            account_email: this.dmail,
            appointment_id: this.appointment_id
          }

          this.appService.getData(this.urlPoints.getPreview, params_cc, this.token).subscribe((response: any) => {
            this.cc_issues = response.op_review.complaint.issues

            var delete_params = {
              "account_email": this.dmail,
              "doctor_id": this.doc_id,
              "simple_complaint": {
                "user_type": "doctor",
                "issues": [],
                "new_issues": [

                ],
                "delete_issues": response.op_review.complaint.issues,
                "days": "",
                "medicine_given": "",
                "temperature": "",
                "unit": "",
                "other_information": "",
                "patient_email": this.patient.record_info.Record.account_email,
                "appointment_id": this.appointment_id,
                "complaint_id": this.complaint_id
              }
            }

            this.appService.postData(this.urlPoints.updateComplaint, delete_params, this.token).subscribe((response: any) => {

              var new_issues = []

              for (var i = 0; i < this.cc_selected.length; i++) {
                new_issues.push(
                  {
                    "category_id": this.cc_selected[i].id,
                    "complaint_category_id": this.cc_selected[i].id,
                    "complaint_type": this.cc_selected[i].name,

                    "is_question": this.cc_selected[i].is_question ? 1 : 0,

                    "details": [
                      {
                        "questions": "",
                        "answers": ""
                      }
                    ]
                  }

                )
              }

              var params2 = {
                "account_email": this.dmail,
                "doctor_id": this.doc_id,
                "simple_complaint": {
                  "user_type": "doctor",
                  "issues": [],
                  "new_issues": new_issues,
                  "days": "",
                  "medicine_given": "",
                  "temperature": "",
                  "unit": "",
                  "other_information": "",
                  "patient_email": this.patient.record_info.Record.account_email,
                  "appointment_id": this.appointment_id,
                  "complaint_id": this.complaint_id
                }
              }

              this.appService.postData(this.urlPoints.updateComplaint, params2, this.token).subscribe((response: any) => {
                this.save_add1()
              });
            });


          });
        }
      }
    });
  }

  openExamination() {

    const dialogRef = this.dialog.open(Dialog_examination, {
      width: '75vw',
      data: { selected: this.ex_selected, doc_id: this.doc_id, dmail: this.dmail, token: this.token,toggle_alignment:this.toggle_alignment },
      panelClass: this.toggle_alignment ? 'custom-dialog-container':'dialog-container',

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.ex_selected = Object.assign([], result);
        this.add_update()
      }
    });
  }

  openDiagnosis() {
    const dialogRef = this.dialog.open(Dialog_diagnosis, {
      width: '75vw',
      data: { selected: this.diag_selected, doc_id: this.doc_id, dmail: this.dmail, token: this.token, cc_selected: this.cc_selected, ex_selected: this.ex_selected, toggle_alignment:this.toggle_alignment },
      panelClass: this.toggle_alignment ? 'custom-dialog-container':'dialog-container',

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        console.log(result)

        this.diag_selected = Object.assign([], result);
        this.add_update()
      }
    });
  }

  openInvestigation() {
    const dialogRef = this.dialog.open(Dialog_investigation, {
      width: '75vw',
      data: { selected: this.inv_selected, doc_id: this.doc_id, dmail: this.dmail, token: this.token, diag_selected: this.diag_selected,toggle_alignment:this.toggle_alignment },
      panelClass: this.toggle_alignment ? 'custom-dialog-container':'dialog-container',

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.inv_selected = Object.assign([], result);

        console.log(this.inv_selected)

        var count = 0
var diaNames = this.diag_selected.map(e=>e.name);
        for (var i = 0; i < this.inv_selected.length; i++) {
          var invparams = {
            account_email: this.dmail,
            patient_email: this.patient.record_info.Record.account_email,
            appointment_id: this.appointment_id,
            doctor_id: this.doc_id,
            data: [{
              title: this.inv_selected[i].name,
              diagnosis:diaNames,
            }]
          }

          this.appService.postData(this.urlPoints.createLabDetails, invparams, this.token).subscribe((response: any) => {


            console.log(count)

            console.log(this.inv_selected[count])

            this.lab_ids.push(
              // response.message[0].id
              {
                inv_id: this.inv_selected[count].investigation_id,
                lab_id: response.message[0].id
              }
            )
            count++

            console.log(this.lab_ids)
          });
        }

        this.add_update()
      }
    });
  }

  openPrescription() {
    const dialogRef = this.dialog.open(Dialog_prescription, {
      width: '75vw',
      data: { selected: this.pres_selected, doc_id: this.doc_id, dmail: this.dmail, token: this.token, diag_selected: this.diag_selected, drugShowType: this.drugShowType, displayTotal: this.displayTotal, durationAlone: this.durationAlone, fullFreq: this.fullFreq, showUnits: this.showUnits, weight: this.weight, age: this.y,toggle_alignment:this.toggle_alignment },
      panelClass: this.toggle_alignment ? 'custom-dialog-container':'dialog-container',

    });
    dialogRef.afterClosed().subscribe(async result2 => {
      if (result2) {
        this.callMasterSettings()
        console.log('this.prescription_mode 11933',this.prescription_mode);
        this.drugShowType = result2.drugShowType
        this.displayTotal = result2.displayTotal
        this.durationAlone = result2.durationAlone
        this.fullFreq = result2.fullFreq
        this.showUnits = result2.showUnits

        var result1 = result2.pres_selected

        this.pres_selected = Object.assign([], result1);

        if (this.prescription_id) {

          for (var i = 0; i < this.pres_entries.length; i++) {
            this.pres_entries[i].operation = 'delete'
          }

          var params2 = {
            "account_email": this.dmail, doctor_id: this.doc_id,
            "prescription": {
              "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
              "entries": this.pres_entries
            }
          }

          this.appService.postData(this.urlPoints.updatePres, params2, this.token).subscribe((response: any) => {
            this.preview_id = response.id

            this.pres_entries = []

            for (var i = 0; i < this.pres_selected.length; i++) {
              this.pres_count++;
              var obj = {
                drug_id: this.pres_selected[i].id,
                dose: this.pres_selected[i].dose,
                dose_option: this.pres_selected[i].dose_option,
                frequency: this.pres_selected[i].frequency,
                route: this.pres_selected[i].route,
                when: this.pres_selected[i].when,
                duration: this.pres_selected[i].duration.toString(),
                duration_type: this.pres_selected[i].duration_type,
                quantity: this.pres_selected[i].quantity,
                special_instruction: this.pres_selected[i].special_instruction,
                minimum_buyable_qty: this.pres_selected[i].minimum_buyable_qty,
                operation: 'add',
                pres_id: this.pres_count
              }

              this.pres_entries.push(obj)
            }

            var params3 = {
              "account_email": this.dmail, doctor_id: this.doc_id,
              "prescription": {
                "patient_email": this.patient.record_info.Record.account_email, "prescription_id": this.prescription_id,
                "entries": this.pres_entries
              }
            }

            this.appService.postData(this.urlPoints.updatePres, params3, this.token).subscribe((response: any) => {
              this.preview_id = response.id
              this.save_add1()

            })
          });

        }
        else {

          this.pres_entries = []

          for (var i = 0; i < this.pres_selected.length; i++) {
            this.pres_count++;
            var obj = {
              drug_id: this.pres_selected[i].id,
              dose: this.pres_selected[i].dose,
              dose_option: this.pres_selected[i].dose_option,
              frequency: this.pres_selected[i].frequency,
              route: this.pres_selected[i].route,
              when: this.pres_selected[i].when,
              duration: this.pres_selected[i].duration.toString(),
              duration_type: this.pres_selected[i].duration_type,
              quantity: this.pres_selected[i].quantity,
              special_instruction: this.pres_selected[i].special_instruction,
              minimum_buyable_qty: this.pres_selected[i].minimum_buyable_qty,
              operation: 'add',
              pres_id: this.pres_count
            }

            this.pres_entries.push(obj)

          }

          this.addPres()

        }

      }
    });
  }

  openAdvice() {
    const dialogRef = this.dialog.open(Dialog_advice, {
      width: '75vw',
      data: { selected: this.adv_selected, doc_id: this.doc_id, dmail: this.dmail, token: this.token, diag_selected: this.diag_selected,toggle_alignment:this.toggle_alignment },
      panelClass: this.toggle_alignment ? 'custom-dialog-container':'dialog-container',

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.adv_selected = Object.assign([], result);
        this.add_update()
      }
    });
  }

  openFollowup() {
    const dialogRef = this.dialog.open(Dialog_followup, {
      width: '75vw',
      data: { selected: this.adv_selected, doc_id: this.doc_id, dmail: this.dmail, token: this.token, patient: this.patient },
      panelClass: this.toggle_alignment ? 'custom-dialog-container':'dialog-container',

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.follow_text = result.follow_text
        this.follow_text_week = result.follow_text_week
        this.add_update()

        if (result.bookDetails) {
          this.appService.postData(this.urlPoints.bookAppt, result.bookDetails, this.token).subscribe((response: any) => {

            this.toastr.success("Appointment Booked Successfully!")

            var updateParams = {
              account_email: this.dmail,
              patient_email: this.patient.record_info.Record.account_email,
              doctor_id: this.doc_id,
              a_id: response[0].id,
              slot: result.bookDetails.appt_datetime,
              token: result.bookDetails.token,
              mode: "CC"
            }

            if (result.bookDetails.appt_type == 'video_call') {
              console.log('here')
              this.appService.postData(this.urlPoints.updateWebToken, updateParams, this.token).subscribe((response: any) => {
              });
            }

            if (result.bookDetails.deduct) {

              var raiseParams = {
                account_email: this.dmail,
                patient_email: this.patient.record_info.Record.account_email,
                category: result.bookDetails.appt_type,
                description: "The amount of Rs." + result.bookDetails.amount + " is debited for follow up appointment booking",
                doctor_charges: result.bookDetails.amount,
                user_type: "doctor",
                type: 3,
                doctor_id: this.doc_id,
                appointment_id: response[0].id,
                slots: result.bookDetails.slots_arr
              }

              this.appService.postData(this.urlPoints.raiseInvoice, raiseParams, this.token).subscribe((response: any) => {
              });
            }


          },

            error => {

              if (error.status == 500)
                this.toastr.error("Slot already booked")
            })
        }


      }
    });
  }

  openHPI() {
    const dialogRef = this.dialog.open(Dialog_hpi, {
      width: '75vw',
      data: { hpi: this.hpi }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.hpi2 = result;

        this.save_add_hpi()

      }
    });
  }

  openPMH() {

    var questionParams = {
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail,
      category: 'past_medical_history'
    }

    const dialogRef = this.dialog.open(Dialog_pmh, {
      width: '75vw',
      data: { token: this.token, questionParams: questionParams }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.pmhdata = result

        this.savePMH()

      }
    });
  }

  openSH() {

    var questionParams = {
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail,
      category: 'social_personal_history'
    }

    const dialogRef = this.dialog.open(Dialog_social, {
      width: '75vw',
      data: { token: this.token, questionParams: questionParams }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.shdata = result

        this.saveSH()

      }
    });
  }

  openCM() {

    var questionParams = {
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail,
      category: 'medication_history'
    }

    var pastParams = {
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail,
      doctor_id: this.doc_id
    }

    const dialogRef = this.dialog.open(Dialog_current, {
      width: '75vw',
      data: { token: this.token, questionParams: questionParams, pastParams: pastParams, counter_params: this.counter_params, pres_seleced: this.pres_selected, pres_selected_soap: this.pres_selected_soap, pres_copy_cm1: this.pres_copy_cm1 }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cmdata = result.cmdata;
        this.pres_selected_soap = result.pres_selected_soap

        this.saveCM()

      }
    });
  }

  toggle_cc() {
    this.cc_copy1 = [];

    var token = this.token;

    if (this.cc_toggle == 'tags') {
      this.cc_toggle = 'alp'
      this.chars1 = ''
      this.chars1 = '';
      var params = {

        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars1,
        "doctor_id": this.doc_id
      }

      this.getCC(this.urlPoints.getCC, params, token)

    }

    else {
      this.cc_toggle = 'tags'
    }
  }

  toggle_ex() {
    this.ex_copy1 = [];
    if (this.ex_toggle == 'tags') {
      this.ex_toggle = 'alp';
      this.chars2 = '';

      this.chars2 = '';


      var token = this.token;

      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars2,
        doctor_id: this.doc_id
      }

      this.getEx(this.urlPoints.getEx, params, token)
    }
    else {
      this.ex_toggle = 'tags'
    }
  }

  toggle_diag() {
    this.diag_copy1 = [];
    this.diag_data = [];
    this.diag_page = 1;
    if (this.diag_toggle == 'tags') {
      this.diag_toggle = 'alp'
      var params1 = {
        account_email: this.dmail,
        page_no: this.diag_page,
        alphabet: this.chars3,
        doctor_id: this.doc_id
      }
      if (this.chars3 == '')
        this.getDiagCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
      else
        this.getDiag(this.urlPoints.getDiag, params1, this.token)
    }
    else {
      this.diag_toggle = 'tags';
      this.ids = this.ids_ex.concat(this.ids_cc);
      var ids_string = this.ids.toString();

      var params = {

        account_email: this.dmail,
        page_no: this.diag_page,
        symptoms_id: ids_string,
        doctor_id: this.doc_id
      }

      this.getDiag(this.urlPoints.getDiag, params, this.token)

    }
  }

  toggle_inv() {
    this.inv_copy1 = [];
    this.inv_data = [];
    this.inv_page = 1;
    if (this.inv_toggle == 'tags') {
      this.inv_toggle = 'alp'

      var ids_string = this.ids_diag.toString();

      var params1 = {

        account_email: this.dmail,
        page_no: this.inv_page,
        alphabet: this.chars4,
        doctor_id: this.doc_id
      }

      //   this.getInv(this.urlPoints.getInv, params1, this.token)
      if (this.chars4 == '')
        this.getInvCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
      else
        this.getInv(this.urlPoints.getInv, params1, this.token)


    }
    else {
      this.inv_toggle = 'tags';
      //     this.ids = this.ids_ex.concat(this.ids_cc);
      var ids_string = this.ids_diag.toString();

      var params = {
        account_email: this.dmail,
        page_no: this.inv_page,
        diagnosis_id: ids_string,
        doctor_id: this.doc_id
      }

      this.getInv(this.urlPoints.getInv, params, this.token)

    }
  }

  toggle_pres() {
    this.pres_copy1 = [];
    this.pres_data = [];
    this.pres_page = 1
    if (this.pres_toggle == 'tags') {
      this.pres_toggle = 'alp'
      var params1 = {
        account_email: this.dmail,
        page_no: this.pres_page,
        alphabet: this.chars5,
        doctor_id: this.doc_id
      }

      //    this.getPres(this.urlPoints.getPres, params1, this.token)
      if (this.chars5 == '')
        this.getPresCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
      else
        this.getPres(this.urlPoints.getPres, params1, this.token)


    }
    else {
      this.pres_toggle = 'tags';
      //     this.ids = this.ids_ex.concat(this.ids_cc);
      var ids_string = this.ids_diag.toString();

      var params = {
        account_email: this.dmail,
        page_no: this.pres_page,
        diagnosis_id: ids_string,
        doctor_id: this.doc_id
      }

      this.getPres(this.urlPoints.getPres, params, this.token)


    }
  }

  toggle_adv() {
    this.adv_copy1 = [];
    this.adv_data = [];
    this.adv_page = 1;
    if (this.adv_toggle == 'tags') {
      this.adv_toggle = 'alp'

      var params1 = {
        account_email: this.dmail,
        page_no: this.adv_page,
        alphabet: this.chars6,
        doctor_id: this.doc_id
      }

      //   this.getAdv(this.urlPoints.getAdv, params1, this.token)
      if (this.chars6 == '')
        this.getAdvCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
      else
        this.getAdv(this.urlPoints.getAdv, params1, this.token)

    }
    else {
      this.adv_toggle = 'tags';
      //     this.ids = this.ids_ex.concat(this.ids_cc);
      var ids_string = this.ids_diag.toString();

      var params = {
        account_email: this.dmail,
        page_no: this.adv_page,
        diagnosis_id: ids_string,
        doctor_id: this.doc_id
      }

      this.getAdv(this.urlPoints.getAdv, params, this.token)

    }
  }

  toggle_cc_keyboard() {
    this.cc_keyboard = !this.cc_keyboard;
  }

  toggle_ex_keyboard() {
    this.ex_keyboard = !this.ex_keyboard;
  }

  toggle_diag_keyboard() {
    this.diag_keyboard = !this.diag_keyboard;
  }

  toggle_inv_keyboard() {
    this.inv_keyboard = !this.inv_keyboard;
  }

  toggle_pres_keyboard() {
    this.pres_keyboard = !this.pres_keyboard;
  }

  toggle_adv_keyboard() {
    this.adv_keyboard = !this.adv_keyboard;
  }

  getPayment(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      this.pending = 0;
      this.payment = response;
      for (var i = 0; i < this.payment.length; i++) {
        this.payment[i].date = moment(this.payment[i].bill_date).format("DD-MMM-YYYY");
        this.payment[i].category = this.payment[i].category.split('_').join(' ')
        this.pending = this.pending + this.payment[i].fee_pending
      }
    });
  }


  setType(i) {
    this.preview_type = i
    //  alert(this.preview_type)
    if (i == 2) {
      //  this.pres_selected_soap=this.pres_selected_cm.concat(this.pres_selected)
    }
  }

  setConsultationType(i) {
    this.event = i


  }

  save_follow_end() {

    this.end = true
    this.printDisabled = true;

    var params5 = {
      account_email: this.dmail,
      appointment_id: this.appointment_id
    }

    this.appService.getData(this.urlPoints.getPreview, params5, this.token).subscribe((response: any) => {
      if (response.op_review.appointment_id) {
        this.call = 'update'
        this.preview = 'Update Consultation'
      }
      else {
        this.call = 'add'
      }

      this.toastr.success('Data saved!', '', {
        timeOut: 3000,
      });

      this.save_add()
    });

    if (this.show_block == 'follow' || 1 == 1) {

      if (this.radioValue == 'date') {
        this.follow_option = "date";
        this.follow_text = this.fDate;
        this.fDate2 = moment(this.fDate).format("YYYY-MM-DD")
        this.follow_text = this.fDate2
        this.follow_text_new = moment(this.follow_text).format("DD-MM-YYYY")
      }

      if (this.radioValue == 'manual') {
        this.follow_option = "manual"
        var num = this.follow_days
        var num2 = this.dayUnit
        var days;
        if (num2 == '1') {
          days = Number(num)
        }

        if (num2 == '2') {
          days = Number(num) * 7
        }

        if (num2 == '3') {
          days = Number(num) * 30
        }


        var new_date: any = moment(new Date()).add('days', days);
        new_date = moment(new_date).format("YYYY-MM-DD")
        this.fDate = moment(new_date).format("YYYY-MM-DD");
        this.fDate2 = moment(this.fDate).format("YYYY-MM-DD")
        this.follow_text = this.fDate2

        this.follow_text_new = moment(this.follow_text).format("DD-MM-YYYY")

      }

      if (this.sos) {
        if (this.radioValue == 'date' || this.radioValue == 'manual') {
          this.follow_text = 'SOS and/or ' + this.follow_text

          this.follow_text_new = 'SOS and/or ' + this.follow_text_new

        }
        else {
          this.follow_text = 'SOS'

          this.follow_text_new = 'SOS'
        }
      }
    }


    this.save_add()
  }

  follow_booking() {

    if (this.radioValue == 'date') {
      this.follow_option = "date";
      this.follow_text = ((document.getElementById('date2') as HTMLInputElement)).value;
      this.fDate = ((document.getElementById('date2') as HTMLInputElement)).value;
      this.fDate2 = moment(this.fDate).format("YYYY-MM-DD")
      this.follow_text = this.fDate2
      this.follow_text_new = moment(this.follow_text).format("DD-MM-YYYY")
    }

    if (this.radioValue == 'manual') {
      this.follow_option = "manual"
      var num = this.follow_days
      var num2 = this.dayUnit
      var days;
      if (num2 == '1') {
        days = Number(num)
      }

      if (num2 == '2') {
        days = Number(num) * 7
      }

      if (num2 == '3') {
        days = Number(num) * 30
      }


      var new_date: any = moment(new Date()).add('days', days);
      new_date = moment(new_date).format("YYYY-MM-DD")
      //   this.follow_text = new_date.toString();
      this.fDate = moment(new_date).format("YYYY-MM-DD");
      this.fDate2 = moment(this.fDate).format("YYYY-MM-DD")
      this.follow_text = this.fDate2

      this.follow_text_new = moment(this.follow_text).format("DD-MM-YYYY")

    }

    if (this.sos) {
      if (this.radioValue == 'date' || this.radioValue == 'manual') {
        this.follow_text = 'SOS and/or ' + this.follow_text

        this.follow_text_new = 'SOS and/or ' + this.follow_text_new

      }
      else {
        this.follow_text = 'SOS'

        this.follow_text_new = 'SOS'
      }
    }

    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email
    }

    this.appService.postData(this.urlPoints.getWalletBalance, params, this.token).subscribe((response: any) => {
      this.balance = response.wallet[0].response[0].total;

      if (this.type == 'consultation' || this.type == 'vaccination') {

        var filter = this.settingsData.filter(res => res.module === "appointment");

      }

      else if (this.type == 'video_call') {

        var filter = this.settingsData.filter(res => res.module === "video_call_appointment_fee");

      }

      else if (this.type == 'voice_call') {

        var filter = this.settingsData.filter(res => res.module === "voice_call_appointment_fee");

      }

      this.amount = filter[0].doctor_charge


      //moment(this.fDate).format("YYYY-MM-DD")

      const dialogRef = this.dialog.open(Dialog_follow_book, {
        width: 'fit-content',
        data: { type: this.type, balance: this.balance, date: moment(this.selecteddate).format("YYYY-MM-DD"), demail: this.dmail, token: this.token, id: this.doc_id, email: this.patient.record_info.Record.account_email, amount: this.amount, paidType: this.paidType }
      });
      dialogRef.afterClosed().subscribe(result => {

      });
    })
  }

  validateNumbers(event) {

    var key = window.event ? event.keyCode : event.which;


    if (event.keyCode >= 48 && event.keyCode <= 57) {
      return true;
    } else {
      return false;
    }
  }

  validateNumberAndForwardSlash(event) {

    var key = window.event ? event.keyCode : event.which;


    if (event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode == 47) {
      return true;
    } else {
      return false;
    }
  }

  checkAllergy() {
    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email
    }


    this.appService.getData(this.urlPoints.getAllergiesReaction, params, this.token).subscribe((response: any) => {

      this.allergyTable = []
      this.allergyTable = this.allergyTable.concat(response.data[0].drug)
      this.allergyTable = this.allergyTable.concat(response.data[0].food)
      this.allergyTable = this.allergyTable.concat(response.data[0].environment)
      this.allergyTable = this.allergyTable.concat(response.data[0].others)
    });
  }

  getVitalData() {

    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email
    }

    this.appService.getData(this.urlPoints.getShortProfile, params, this.token).subscribe((response: any) => {
      console.log(response.data.vitals)

      console.log(response.success)

      if (response.success == 1) {

        console.log(response.data.vitals)

        this.heart_rate = response.data.vitals.heart_rate

        this.respiratory_rate = response.data.vitals.respiratory_rate

        console.log(response.data.vitals.bp_systolic)

        console.log(response.data.vitals.bp_diastolic)

        if (response.data.vitals.bp_systolic && response.data.vitals.bp_diastolic) {
          this.blood_pressure = response.data.vitals.bp_systolic + '/' + response.data.vitals.bp_diastolic;
        }

        console.log(this.blood_pressure)

        this.weight = response.data.vitals.weight
        this.height = response.data.vitals.height * 100
        this.temperature = response.data.vitals.temperature
        this.bmi = response.data.vitals.bmi

      }
    });

    // this.appService.getQueue(this.urlPoints.getVitalsAppt + '?' + this.id, this.token).subscribe((response: any) => {

    //   this.heart_rate = response[0].heart_rate;
    //   this.respiratory_rate = response[0].respiratory_rate;
    //   this.spo2 = response[0].oxygen_saturation;

    //   if (response[0].bp_systolic && response[0].bp_diastolic)
    //     this.blood_pressure = response[0].bp_systolic + '/' + response[0].bp_diastolic;

    //   this.weight = response[0].weight;
    //   this.height = response[0].height;

    //   this.temperature = response[0].temperature

    //   this.bmi = response[0].weight / (response[0].height * response[0].height)

    // });


  }

  openIcons() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_icons, {
      width: '600px',
      data: {}
    });
  }

  getAnswers() {


    var answer1 = {
      category: 'medication_history',
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    this.appService.getData(this.urlPoints.getAnswers, answer1, this.token).subscribe((response: any) => {

      if (response.data)
        this.past_medical_hx = response.data.values['prescribed drugs or over the counter drugs']

    });

    var answer2 = {
      category: 'social_personal_history',
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    this.appService.getData(this.urlPoints.getAnswers, answer2, this.token).subscribe((response: any) => {
      var arr = [];
      var temp;
      var temp1;


      this.social_history = ''

      if (response.data)
        for (var property in response.data.values) {


          temp1 = response.data.values[property]

          property = property[0].toUpperCase() + property.slice(1);

          temp = (property + (temp1 ? ' : ' : '') + temp1)

          arr.push(temp)


          this.social_history = arr.join(', ')

        }
    });

    var answer3 = {
      category: 'past_medical_history',
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    this.appService.getData(this.urlPoints.getAnswers, answer3, this.token).subscribe((response: any) => {

      this.current_medication = ''


      if (response.data)
        this.current_medication = (response.data.values['past medical illnesses'] != '[]' ? String(response.data.values['past medical illnesses']) : '').concat(response.data.values['other medical problems'] ? (response.data.values['past medical illnesses'] != '[]' ? ',' : '') + String(response.data.values['other medical problems']) : '')

      if (this.current_medication == 'undefined') {
        this.current_medication = ''
      }
    });
  }

  getCurrentMedication() {
    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email,
    }

    this.appService.getData(this.urlPoints.getCurrentMedications, params, this.token).subscribe((response: any) => {

      this.pres_copy_cm = response.data;


      this.pres_selected_soap = []

      for (var i = 0; i < this.pres_copy_cm.length; i++) {

        var obj = {
          brand: this.pres_copy_cm[i].name,
          dose: this.pres_copy_cm[i].dose ? this.pres_copy_cm[i].dose : "",
          dose_option: this.pres_copy_cm[i].dose_option ? this.pres_copy_cm[i].dose_option : "",
          duration: this.pres_copy_cm[i].duration ? this.pres_copy_cm[i].duration : "1",
          duration_type: this.pres_copy_cm[i].duration_type ? this.pres_copy_cm[i].duration_type : "Days",
          formulation: this.pres_copy_cm[i].formulation ? this.pres_copy_cm[i].formulation : "",
          freq_string: this.pres_copy_cm[i].freq_string ? this.pres_copy_cm[i].freq_string : "1-0-0-0",
          frequency: this.pres_copy_cm[i].frequency ? this.pres_copy_cm[i].frequency : "1-0-0-0",
          generic: this.pres_copy_cm[i].manufacture ? this.pres_copy_cm[i].manufacture : "",
          id: this.pres_copy_cm[i].id ? this.pres_copy_cm[i].id : "",
          minimum_buyable_qty: this.pres_copy_cm[i].minimum_buyable_qty ? this.pres_copy_cm[i].minimum_buyable_qty : "",
          operation: 'add',
          pres_id: 1,
          quantity: this.pres_copy_cm[i].quantity ? this.pres_copy_cm[i].quantity : (this.pres_copy_cm[i].category != 'Syrup') ? ("1 " + this.pres_copy_cm[i].category) : ("100 ml"),
          route: this.pres_copy_cm[i].route ? this.pres_copy_cm[i].route : "Oral",
          special_instruction: this.pres_copy_cm[i].special_instruction ? this.pres_copy_cm[i].special_instruction : "",
          strength: this.pres_copy_cm[i].strength ? this.pres_copy_cm[i].strength : "",
          strength_unit: this.pres_copy_cm[i].strength_unit ? this.pres_copy_cm[i].strength_unit : "",
          type: "3",
          when: this.pres_copy_cm[i].when ? this.pres_copy_cm[i].when : "Before Food",
        }

        this.pres_selected_soap.push(obj)
      }

    });
  }

  template() {

    var data = {

    }

    const dialogRef = this.dialog.open(Dialog_template, {
      data: {
        details: {
          chief_complaint: this.cc_selected,
          examination: this.ex_selected,
          diagnosis: this.diag_selected,
          prescription: this.pres_selected,
          investigation: this.inv_selected,
          advice: this.adv_selected,

        },
        doctor_id: this.doc_id,
        patient_email: this.patient.record_info.Record.account_email,
        account_email: this.dmail,
        token: this.token
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.appService.getData(this.urlPoints.getTemplateName, this.counter_params, this.token).subscribe((response: any) => {
          if (response.success == 1) {
            this.templates = response.details
          }
        });
      }
    });
  }

  drugType() {

    const dialogRef = this.dialog.open(drugType, {
      width: 'fit-content',
      data: { type: this.drugShowType, total: this.displayTotal, durationAlone: this.durationAlone, fullFreq: this.fullFreq, showUnits: this.showUnits }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.drugShowType = result.type,
          this.displayTotal = result.total
        this.durationAlone = result.durationAlone
        this.showUnits = result.showUnits;
        var params;

        if (this.drugShowType == 1) {
          params = {
            "account_email": this.dmail,
            "category_id": "1",
            "category_name": "drug",
            "doctor_id": this.doc_id
          }
        }

        if (this.drugShowType == 2) {
          params = {
            "account_email": this.dmail,
            "category_id": "2",
            "category_name": "generic",
            "doctor_id": this.doc_id
          }
        }

        if (this.drugShowType == 3) {
          params = {
            "account_email": this.dmail,
            "category_id": "3",
            "category_name": "drug and generic",
            "doctor_id": this.doc_id
          }
        }

        this.appService.postData(this.urlPoints.drugSettings, params, this.token).subscribe((response: any) => {

        });

        for (var i = 0; i < this.pres_selected.length; i++) {

          var unit = this.pres_selected[i].quantity.split(' ')[1]

          var freq_arr = this.pres_selected[i].frequency.split('-')

          if (freq_arr.length == 4) {
            var morning = freq_arr[0].trim().split(' ')[0]

            var afternoon = freq_arr[1].trim().split(' ')[0]

            var evening = freq_arr[2].trim().split(' ')[0]

            var night = freq_arr[3].trim().split(' ')[0]

            if (this.showUnits) {
              var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

              this.pres_selected[i].frequency = freq
              this.pres_entries[i].frequency = freq

              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }


              var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

              if (unit == 'mole' || unit == 'millimole') {
                var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                freq = shortFreq
              }

              if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')


                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }
              }

              this.pres_selected[i].frequency = freq
              this.pres_selected[i].shortFreq = shortFreq

              this.pres_entries[i].frequency = freq
            }
            else {
              var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

              this.pres_selected[i].frequency = freq
              this.pres_selected[i].shortFreq = freq

              this.pres_entries[i].frequency = freq
            }
          }
          else {

            var shortUnit = ''

            if (unit == 'milliliter') {
              shortUnit = 'ml'
            }

            else if (unit == 'Tablet') {
              shortUnit = 'Tablet'
            }

            else if (unit == 'microgram') {
              shortUnit = 'mcg'
            }

            else if (unit == 'milligram') {
              shortUnit = 'mg'
            }

            else if (unit == 'gram') {
              shortUnit = 'grm'
            }


            else if (unit == 'drops') {
              shortUnit = 'drops'
            }

            else if (unit == 'Sachets/Packets') {
              shortUnit = 'pkt'
            }

            if (this.showUnits) {
              var freq1: any = this.pres_selected[i].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[i].frequency.split('-')[1].trim().split(' ')[0].trim()

              this.pres_selected[i].frequency = freq1 + ' ' + unit

              this.pres_selected[i].shortFreq = freq1 + ' ' + shortUnit

              this.pres_entries[i].frequency = this.pres_selected[i].frequency

            }
            else {
              var freq1: any = this.pres_selected[i].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[i].frequency.split('-')[1].trim().split(' ')[0].trim()

              this.pres_selected[i].shortFreq = freq1

              this.pres_entries[i].frequency = freq1
            }
          }
        }

        var customParams = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          data: [
            {
              category_id: 1,
              category_name: "display duration seperately",
              status: this.durationAlone ? 1 : 0
            },
            {
              category_id: 2,
              category_name: "display time fully",
              status: this.fullFreq ? 1 : 0
            },
            {
              category_id: 3,
              category_name: "show unit in frequency",
              status: this.showUnits ? 1 : 0
            }
          ]
        }

        this.appService.postData(this.urlPoints.createPres, customParams, this.token).subscribe((response: any) => {

        });

        this.updatePres()
      }
    });
  }

  chat(patient) {
    this.isShowfloat = true


    var data = {
      dob: '',
      email: patient.email,
      first_name: patient.name_given,
      full_name: patient.name_given + patient.name_family,
      gender: patient.gender,
      image: patient.imgURL,
      last_messaged_on: '',
      last_messaged_on_Local: '',
      last_name: patient.name_family,
      mr_number: patient.mr_number,
      phone: '',
      uhid: ''
    }

    var senderMail = patient.email

    var patientImage = patient.imgURL

    this.chat_appt_id = patient.id

    this.goToChathistory(data, senderMail, patientImage, patient)

  }

  goToChathistory(data, senderMail, patientImage, patient) {
    this.senderDetails = JSON.stringify(data);
    this.sendermail = senderMail;
    this.senderImage = patientImage;
    this.senderData = patient
    localStorage.setItem('sender_details', JSON.stringify(data));
    localStorage.setItem('sender_mail', senderMail);
    localStorage.setItem('sender_image', patientImage);
    localStorage.setItem('sender_data', patient);

    // this.router.navigate(['epicare/chathistory']);
  }

  closeChat() {
    this.isShowfloat = false

  }

  save_add() {
    var token = this.token;

    if (this.prescription_id) {
    }

    var ex_names = []

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var lab_tests = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      lab_tests.push(this.inv_selected[i].name)
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push((i + 1) + '. ' + this.adv_selected[i].instructions)
    }

    var params = {
      "account_email": this.dmail,
      "op_review":
      {
        "patient_email": this.patient.record_info.Record.account_email,
        "appointment_id": this.appointment_id,
        "complaint_id": this.complaint_id ? this.complaint_id : null,
        "prescription_id": this.prescription_id ? this.prescription_id : null,
        "notes": "",
        "findings": ex_names.join("\n"),
        "physical_examination": "",
        "measurement_test": "",
        "provisional_diagnosis": "",
        "investigation": "",
        "lab_tests": lab_tests,
        "diagnosis": diag_names.join("\n"),
        "advice": "<br>" + adv_names.join("<br>"),
        "diet_instructions": "",
        "food_instructions": "",
        "others": "",
        "follow_up_date": '',
        "follow_up_text": this.follow_text
      }
    }
    if (this.call == 'update') {
      this.appService.postData(this.urlPoints.updatePreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.printDisabled = false
      });
    }
    else {
      this.appService.postData(this.urlPoints.addPreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.preview = 'Update Consultation'
        this.printDisabled = false
        this.call = 'update'
      });
    }

    var cc_names = [];

    for (var i = 0; i < this.cc_selected.length; i++) {
      cc_names.push(this.cc_selected[i].name)
    }

    var cc_data = {
      data: cc_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (cc_names.length > 0) {
      this.appService.postData(this.urlPoints.saveCCCounter, cc_data, token).subscribe((response: any) => {
      });
    }

    var ex_names = [];

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var ex_data = {
      data: ex_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (ex_names.length > 0) {
      this.appService.postData(this.urlPoints.saveExCounter, ex_data, token).subscribe((response: any) => {
      });
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var diag_data = {
      data: diag_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (diag_names.length > 0) {
      this.appService.postData(this.urlPoints.saveDiagCounter, diag_data, token).subscribe((response: any) => {
      });
    }

    var inv_names = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      inv_names.push(this.inv_selected[i].name)
    }

    var inv_data = {
      data: inv_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (inv_names.length > 0) {
      this.appService.postData(this.urlPoints.saveInvCounter, inv_data, token).subscribe((response: any) => {
      });
    }

    var pres_names = [];

    for (var i = 0; i < this.pres_selected.length; i++) {
      pres_names.push(this.pres_selected[i].brand)
    }

    var pres_data = {
      data: pres_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (pres_names.length > 0) {
      this.appService.postData(this.urlPoints.savePresCounter, pres_data, token).subscribe((response: any) => {
      });
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push(this.adv_selected[i].instructions)
    }

    var adv_data = {
      data: adv_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (adv_names.length > 0) {
      this.appService.postData(this.urlPoints.saveAdvCounter, adv_data, token).subscribe((response: any) => {
      });
    }

  }

  save_add1() {


    var token = this.token;

    // if (this.prescription_id) {
    //   this.updatePres()
    // }

    var ex_names = []

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var lab_tests = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      lab_tests.push(this.inv_selected[i].name)
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push((i + 1) + '. ' + this.adv_selected[i].instructions)
    }

    var params = {
      "account_email": this.dmail,
      "op_review":
      {
        "patient_email": this.patient.record_info.Record.account_email,
        "appointment_id": this.appointment_id,
        "complaint_id": this.complaint_id ? this.complaint_id : null,
        "prescription_id": this.prescription_id ? this.prescription_id : null,
        "notes": "",
        "findings": ex_names.join("\n"),
        "physical_examination": "",
        "measurement_test": "",
        "provisional_diagnosis": "",
        "investigation": "",
        "lab_tests": lab_tests,
        "diagnosis": diag_names.join("\n"),
        "advice": "<br>" + adv_names.join("<br>"),
        "diet_instructions": "",
        "food_instructions": "",
        "others": "",
        "follow_up_date": '',
        "follow_up_text": this.follow_text
      }
    }

    if (this.call == 'update') {
      this.appService.postData(this.urlPoints.updatePreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.printDisabled = false

        for (var i = 0; i < this.pres_selected.length; i++) {

        }
      });
    }
    else {
      this.appService.postData(this.urlPoints.addPreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.preview = 'Update Consultation'
        this.printDisabled = false
        this.call = 'update'
      });
    }

    var cc_names = [];

    for (var i = 0; i < this.cc_selected.length; i++) {
      cc_names.push(this.cc_selected[i].name)
    }

    var cc_data = {
      data: cc_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (cc_names.length > 0) {
      this.appService.postData(this.urlPoints.saveCCCounter, cc_data, token).subscribe((response: any) => {
      });
    }

    var ex_names = [];

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var ex_data = {
      data: ex_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (ex_names.length > 0) {
      this.appService.postData(this.urlPoints.saveExCounter, ex_data, token).subscribe((response: any) => {
      });
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var diag_data = {
      data: diag_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (diag_names.length > 0) {
      this.appService.postData(this.urlPoints.saveDiagCounter, diag_data, token).subscribe((response: any) => {
      });
    }

    var inv_names = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      inv_names.push(this.inv_selected[i].name)
    }

    var inv_data = {
      data: inv_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (inv_names.length > 0) {
      this.appService.postData(this.urlPoints.saveInvCounter, inv_data, token).subscribe((response: any) => {
      });
    }

    var pres_names = [];

    for (var i = 0; i < this.pres_selected.length; i++) {
      pres_names.push(this.pres_selected[i].brand)
    }

    var pres_data = {
      data: pres_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (pres_names.length > 0) {
      this.appService.postData(this.urlPoints.savePresCounter, pres_data, token).subscribe((response: any) => {
      });
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push(this.adv_selected[i].instructions)
    }

    var adv_data = {
      data: adv_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (adv_names.length > 0) {
      this.appService.postData(this.urlPoints.saveAdvCounter, adv_data, token).subscribe((response: any) => {
      });
    }



  }

  add_update() {
    var token = this.token;

    // if (this.prescription_id) {
    //   this.updatePres()

    // }

    var ex_names = []

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var lab_tests = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      lab_tests.push(this.inv_selected[i].name)
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push((i + 1) + '. ' + this.adv_selected[i].instructions)
    }

    var params = {
      "account_email": this.dmail,
      "op_review":
      {
        "patient_email": this.patient.record_info.Record.account_email,
        "appointment_id": this.appointment_id,
        "complaint_id": this.complaint_id ? this.complaint_id : null,
        "prescription_id": this.prescription_id ? this.prescription_id : null,
        "notes": "",
        "findings": ex_names.join("\n"),
        "physical_examination": "",
        "measurement_test": "",
        "provisional_diagnosis": "",
        "investigation": "",
        "lab_tests": lab_tests,
        "diagnosis": diag_names.join("\n"),
        "advice": "<br>" + adv_names.join("<br>"),
        "diet_instructions": "",
        "food_instructions": "",
        "others": "",
        "follow_up_date": '',
        "follow_up_text": this.follow_text
      }
    }

    if (this.preview_id) {
      this.appService.postData(this.urlPoints.updatePreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.printDisabled = false

        for (var i = 0; i < this.pres_selected.length; i++) {

        }
      });
    }
    else {
      this.appService.postData(this.urlPoints.addPreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.preview = 'Update Consultation'
        this.printDisabled = false
        this.call = 'update'
      });
    }

    var cc_names = [];

    for (var i = 0; i < this.cc_selected.length; i++) {
      cc_names.push(this.cc_selected[i].name)
    }

    var cc_data = {
      data: cc_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (cc_names.length > 0) {
      this.appService.postData(this.urlPoints.saveCCCounter, cc_data, token).subscribe((response: any) => {
      });
    }

    var ex_names = [];

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var ex_data = {
      data: ex_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (ex_names.length > 0) {
      this.appService.postData(this.urlPoints.saveExCounter, ex_data, token).subscribe((response: any) => {
      });
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var diag_data = {
      data: diag_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (diag_names.length > 0) {
      this.appService.postData(this.urlPoints.saveDiagCounter, diag_data, token).subscribe((response: any) => {
      });
    }

    var inv_names = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      inv_names.push(this.inv_selected[i].name)
    }

    var inv_data = {
      data: inv_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (inv_names.length > 0) {
      this.appService.postData(this.urlPoints.saveInvCounter, inv_data, token).subscribe((response: any) => {
      });
    }

    var pres_names = [];

    for (var i = 0; i < this.pres_selected.length; i++) {
      pres_names.push(this.pres_selected[i].brand)
    }

    var pres_data = {
      data: pres_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (pres_names.length > 0) {
      this.appService.postData(this.urlPoints.savePresCounter, pres_data, token).subscribe((response: any) => {
      });
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push(this.adv_selected[i].instructions)
    }

    var adv_data = {
      data: adv_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (adv_names.length > 0) {
      this.appService.postData(this.urlPoints.saveAdvCounter, adv_data, token).subscribe((response: any) => {
      });
    }

  }

  save_add_hpi() {
    var token = this.token;

    this.hpi = this.hpi2

    if (this.prescription_id) {
    }

    var ex_names = []

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var lab_tests = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      lab_tests.push(this.inv_selected[i].name)
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push(this.adv_selected[i].instructions)
    }

    var params = {
      "account_email": this.dmail,
      "op_review":
      {
        "patient_email": this.patient.record_info.Record.account_email,
        "appointment_id": this.appointment_id,
        "complaint_id": this.complaint_id ? this.complaint_id : null,
        "prescription_id": this.prescription_id ? this.prescription_id : null,
        "notes": this.hpi,
        "findings": ex_names.join("\n"),
        "physical_examination": "",
        "measurement_test": "",
        "provisional_diagnosis": "",
        "investigation": "",
        "lab_tests": lab_tests,
        "diagnosis": diag_names.join("\n"),
        "advice": adv_names.join("\n"),
        "diet_instructions": "",
        "food_instructions": "",
        "others": "",
        "follow_up_date": '',
        "follow_up_text": this.follow_text
      }
    }
    if (this.call == 'update') {
      this.appService.postData(this.urlPoints.updatePreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.printDisabled = false

        this.toastr.success('Data saved!', '', {
          timeOut: 3000,
        });

      });
    }
    else {
      this.appService.postData(this.urlPoints.addPreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.preview = 'Update Consultation'
        this.printDisabled = false
        this.call = 'update'

        this.toastr.success('Data saved!', '', {
          timeOut: 3000,
        });
      });
    }

    var cc_names = [];

    for (var i = 0; i < this.cc_selected.length; i++) {
      cc_names.push(this.cc_selected[i].name)
    }

    var cc_data = {
      data: cc_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (cc_names.length > 0) {
      this.appService.postData(this.urlPoints.saveCCCounter, cc_data, token).subscribe((response: any) => {
      });
    }

    var ex_names = [];

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var ex_data = {
      data: ex_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (ex_names.length > 0) {
      this.appService.postData(this.urlPoints.saveExCounter, ex_data, token).subscribe((response: any) => {
      });
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var diag_data = {
      data: diag_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (diag_names.length > 0) {
      this.appService.postData(this.urlPoints.saveDiagCounter, diag_data, token).subscribe((response: any) => {
      });
    }

    var inv_names = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      inv_names.push(this.inv_selected[i].name)
    }

    var inv_data = {
      data: inv_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (inv_names.length > 0) {
      this.appService.postData(this.urlPoints.saveInvCounter, inv_data, token).subscribe((response: any) => {
      });
    }

    var pres_names = [];

    for (var i = 0; i < this.pres_selected.length; i++) {
      pres_names.push(this.pres_selected[i].brand)
    }

    var pres_data = {
      data: pres_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (pres_names.length > 0) {
      this.appService.postData(this.urlPoints.savePresCounter, pres_data, token).subscribe((response: any) => {
      });
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push(this.adv_selected[i].instructions)
    }

    var adv_data = {
      data: adv_names,
      doctor_id: this.doc_id,
      patient_email: this.patient.record_info.Record.account_email,
      account_email: this.dmail
    }

    if (adv_names.length > 0) {
      this.appService.postData(this.urlPoints.saveAdvCounter, adv_data, token).subscribe((response: any) => {
      });
    }

  }

  setFollowDays(event) {
    if (event != 'Backspace') {
      this.follow_days = this.follow_days + event
    }
    else {
      this.follow_days = this.follow_days.substring(0, this.follow_days.length - 1);
    }

  }

  postVitals(url, params, token) {

    this.appService.postData(url, params, token).subscribe((response: any) => {
      this.appService.getQueue(this.urlPoints.getVitals + '?' + this.id, token).subscribe((response: any) => {
        console.log(response,'13683');
        this.vitalsData = response;
        this.getVitalsData(this.vitalsData, 1)
      });
    });
  }


  getByTags(event) {

    var params = {
      mode: 1,
      tags: event
    }

    this.getTags(this.urlPoints.tagsList, params)

  }

  openGrowth() {
    const dialogRef = this._bottomSheet.open(growth, {
      data: { patient: this.patient, dmail: this.dmail, email: this.patient.record_info.Record.account_email, token: this.token, doc_id: this.doc_id, id: this.id },
      disableClose: true
    }).afterDismissed().subscribe((result) => {

    });
  }

  viewVitals() {
    //changeVitals
    this.changeVitals = !this.changeVitals
    //vitalOpened
    this.vitalOpened = true
  }

  getByTags_ex(event) {
    var params = {
      mode: 1,
      tags: event
    }

    this.getTags_ex(this.urlPoints.tagsList1, params)
  }

  getTags(url, params) {

    this.appService.getTags(url, params).subscribe((response: any) => {

      this.chief_complaints = response.smartpres.data;
      this.cc_copy = Object.assign([], this.chief_complaints);
      this.cc_copy1 = Object.assign([], this.chief_complaints);
      //important!!
      var matchedArray = [];

      for (var i = 0; i < this.chief_complaints.length; i++) {
        for (var k = 0; k < this.cc_selected.length; k++) {
          if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
            matchedArray.push(i);
          }
        }
      }

      for (var i = matchedArray.length - 1; i >= 0; i--) {

        this.cc_copy.splice(matchedArray[i], 1);
        this.cc_copy1.splice(matchedArray[i], 1);
      }

    });

  }

  getTags_ex(url, params) {
    this.appService.getTags(url, params).subscribe((response: any) => {

      this.examination = response.smartpres.data;

      //important!!
      this.ex_copy = Object.assign([], this.examination);
      this.ex_copy1 = Object.assign([], this.examination);

      var matchedArray = [];

      for (var i = 0; i < this.examination.length; i++) {
        for (var k = 0; k < this.ex_selected.length; k++) {
          if (this.examination[i].symptoms_id == this.ex_selected[k].symptoms_id) {
            matchedArray.push(i);
          }
        }
      }

      for (var i = matchedArray.length - 1; i >= 0; i--) {

        this.ex_copy.splice(matchedArray[i], 1);
        this.ex_copy1.splice(matchedArray[i], 1);
      }

    });
  }

  followBtn(val, id) {
    (document.getElementById("vacc") as HTMLInputElement).checked = true;

    this.follow_text1 = val;
    for (var i = 1; i <= 12; i++) {
      ((document.getElementById('b' + i) as HTMLButtonElement)).disabled = false;
    }

    ((document.getElementById('b' + id) as HTMLButtonElement)).disabled = true;
  }

  radioChange(num) {
    //  alert(num)
    //  alert(this.radioValue)
    this.radioblock = num
  }

  sms(billno) {
    var token = this.token;

    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email,
      bill_no: billno,
      status: 1,
      doctor_id: this.doc_id
    }

    this.getSMS(this.urlPoints.getPrint, params, token);
    //  this.toastr.success('Receipt sent successfully!');

    this.toastr.success('Receipt sent successfully!', '', {
      timeOut: 3000,
    });
  }

  getSMS(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      //  window.open('https://api.epicare.net/PDF/'+response.data)
    });
  }

  print(billno) {
    var token = this.token;

    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email,
      bill_no: billno,
      status: 0,
      doctor_id: this.doc_id
    }

    this.getPrint(this.urlPoints.getPrint, params, token);

  }

  getPrint(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      window.open(environment.HOST + '/PDF/' + response.data)
    });
  }

  other() {
    window.parent.window.postMessage({
      "message": "other"
    }, '*')
  }

  changeUnit(i) {
    this.dayUnit = i
  }

  save_follow() {
    this.end = true
    this.printDisabled = true;

    var params5 = {
      account_email: this.dmail,
      appointment_id: this.appointment_id
    }

    this.appService.getData(this.urlPoints.getPreview, params5, this.token).subscribe((response: any) => {
      if (response.op_review.appointment_id) {
        this.call = 'update'
        this.preview = 'Update Consultation'
      }
      else {
        this.call = 'add'
      }

      this.toastr.success('Data saved!', '', {
        timeOut: 3000,
      });

      this.save_add()
    });

    if (this.show_block == 'follow' || 1 == 1) {

      if (this.radioValue == 'date') {
        this.follow_option = "date";
        this.follow_text = this.fDate;
        this.fDate2 = moment(this.fDate).format("YYYY-MM-DD")
        this.follow_text = this.fDate2
        this.follow_text_new = moment(this.follow_text).format("DD-MM-YYYY")
      }

      if (this.radioValue == 'manual') {
        this.follow_option = "manual"
        var num = this.follow_days
        var num2 = this.dayUnit
        var days;
        if (num2 == '1') {
          days = Number(num)
        }

        if (num2 == '2') {
          days = Number(num) * 7
        }

        if (num2 == '3') {
          days = Number(num) * 30
        }


        var new_date: any = moment(new Date()).add('days', days);
        new_date = moment(new_date).format("YYYY-MM-DD")
        this.fDate = moment(new_date).format("YYYY-MM-DD");
        this.fDate2 = moment(this.fDate).format("YYYY-MM-DD")
        this.follow_text = this.fDate2

        this.follow_text_new = moment(this.follow_text).format("DD-MM-YYYY")

      }

      if (this.sos) {
        if (this.radioValue == 'date' || this.radioValue == 'manual') {
          this.follow_text = 'SOS and/or ' + this.follow_text

          this.follow_text_new = 'SOS and/or ' + this.follow_text_new

        }
        else {
          this.follow_text = 'SOS'

          this.follow_text_new = 'SOS'
        }
      }
    }


    this.save_add()
  }

  save_follow1() {
    this.end = true
    this.printDisabled = true;

    var params5 = {
      account_email: this.dmail,
      appointment_id: this.appointment_id
    }

    this.appService.getData(this.urlPoints.getPreview, params5, this.token).subscribe((response: any) => {
      if (response.op_review.appointment_id) {
        this.call = 'update'
        this.preview = 'Update Consultation'
      }
      else {
        this.call = 'add'
      }

      // this.toastr.success('Data saved!', '', {
      //   timeOut: 3000,
      // });

      this.save_add()
    });

    if (this.show_block == 'follow') {


      if (this.radioValue == 'sos') {
        this.follow_option = "sos"
        this.follow_text = "SOS (If necessary)"
      }

      if (this.radioValue == 'date') {
        this.follow_option = "date";
        this.follow_text = ((document.getElementById('date2') as HTMLInputElement)).value;
        this.fDate = ((document.getElementById('date2') as HTMLInputElement)).value;
        this.fDate2 = moment(this.fDate).format("YYYY-MM-DD")
        this.follow_text = this.fDate2
      }

      if (this.radioValue == 'manual') {
        this.follow_option = "manual"
        var num = this.follow_days
        var num2 = this.dayUnit
        var days;
        if (num2 == '1') {
          days = Number(num)
        }

        if (num2 == '2') {
          days = Number(num) * 7
        }

        if (num2 == '3') {
          days = Number(num) * 30
        }


        var new_date: any = moment(new Date()).add('days', days);
        new_date = moment(new_date).format("YYYY-MM-DD")
        //   this.follow_text = new_date.toString();
        this.fDate = moment(new_date).format("YYYY-MM-DD");
        this.fDate2 = moment(this.fDate).format("YYYY-MM-DD")
        this.follow_text = this.fDate2
      }
    }

    this.save_add()
  }

  followDate() {
    (document.getElementById("date1") as HTMLInputElement).checked = true;
  }

  followInp() {
    (document.getElementById("manual") as HTMLInputElement).checked = true;
  }

  openMaster() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_master, {
      width: 'fit-content',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.pres_count++

        var quantity;

        var time_block = 'times'

        var frequency_type = 'times'

        var morning_dose = 0

        var afternoon_dose = 0

        var evening_dose = 0

        var night_dose = 0

        var every_value;

        var freq_quantity = 1;

        var frequency

        var name

        var name = result.drugname

        var params = {
          drug: {
            brand: result.drugname,
            composition_name: result.compname,
            generic: result.generic,
            formulation: result.formulation.toUpperCase(),
            strength: result.strength,
            strength_unit: result.unit,
            dose: result.dose,
            dose_option: result.dose_option,
            route: result.route,
            when: result.when,
            special_instruction: '',
            frequency: result.frequency,
            duration: result.duration,
            duration_type: result.duration_type,
            minimum_buyable_qty: result.min_qty,
          },
          account_email: this.dmail,
          doctor_id: this.doc_id
        }

        this.appService.postData(this.urlPoints.addDrug, params, this.token).subscribe((response: any) => {

          var obj = {
            brand: response.drug.brand,
            dose: response.drug.strength,
            dose_option: response.drug.dose_option,
            duration: response.drug.duration,
            duration_type: response.drug.duration_type,
            formulation: response.drug.formulation,
            freq_string: '',
            frequency: response.drug.frequency,
            generic: response.drug.composition_name,
            id: response.drug.id,
            minimum_buyable_qty: response.drug.minimum_buyable_qty,
            operation: 'add',
            pres_id: this.pres_count,
            quantity: quantity,
            route: response.drug.route,
            special_instruction: '',
            strength: response.drug.strength,
            strength_unit: response.drug.strength_unit,
            type: 3,
            when: response.drug.when,
          }

          var arr = []
          var freq_string;

          obj.frequency = response.drug.frequency

          var total;


          if (obj.duration_type == 'Months') {
            quantity = quantity * 30;
          }

          obj.quantity = quantity

          obj.quantity = 1

          var params2 = {
            account_email: this.dmail,
            page_no: 1,
            alphabet: name,
            doctor_id: this.doc_id
          }

          this.appService.getData(this.urlPoints.getPres, params2, this.token).subscribe((response: any) => {

            if (response.success !== 0 && !response.message) {

              response.data = response.data.filter(i => i.name == name);

              obj.id = response.data[0].id
              this.addFromMaster(obj);

            }
          })


          this.toastr.success('Drug Added!', '', {
            timeOut: 3000,
          });
        });
      }
    });
  }

  hasDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }

  getUnseen() {
    var params_labreports2 = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email,
      category: 'Unseen'
    }
    this.labreports_seen(this.urlPoints.getLabReports, params_labreports2, this.token)

  }

  labreports_seen(url, params, token) {


    // var attachments1 = []

    // var flag;

    // var flag1;

    // var obj;

    // this.actualdata = []

    // this.attachments1 = []

    // this.newAttachment1 = []

    // var inv_names = [];

    // var data = []

    // this.appService.getData(url, params, token).subscribe((response: any) => {

    //   for (var i = 0; i < response.length; i++) {
    //     obj = {}

    //     obj.lab_tests = []

    //     obj.image_attachments = []

    //     obj.data = []

    //     var labexists = false

    //     for (var k = 0; k < response[i].data.length; k++) {
    //       flag = 0
    //       flag1 = 0

    //       if (response[i].data[k].image_attachments) {
    //         if (response[i].data[k].image_attachments.length > 0) {
    //           flag1 = 1
    //         }
    //       }

    //       if (flag1 || flag == 1) {

    //         obj.date = response[i].date


    //         if (response[i].data[k].lab_test) {
    //           if (response[i].data[k].lab_test.length > 0) {
    //             //  obj.lab_tests = obj.lab_tests.concat(response[i].data[k].lab_test)
    //           }
    //         }

    //         if (response[i].data[k].image_attachments) {
    //           if (response[i].data[k].image_attachments.length > 0) {
    //             obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
    //           }
    //           if (response[i].data[k].lab_id) {
    //             labexists = true
    //             obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
    //           }
    //         }

    //         if (response[i].data[k].image_attachments) {

    //           obj.data.push(response[i].data[k])
    //           obj.lab_tests.push(response[i].data[k].title)
    //           obj.data.labexists = labexists
    //         }
    //       }
    //     }

    //     //  var day = '2021-10-05'

    //     if (obj.date && obj.data.labexists) {
    //       this.attachments1.push(obj)
    //     }
    //   }

    //   {
    //     for (var i = 0; i < response.length; i++) {
    //       for (var j = 0; j < response[i].data.length; j++) {
    //         this.actualdata.push(response[i].data[j]);
    //         this.labtest.push(response[i].data[j].lab_test);
    //       }
    //     }

    //     for (var i = 0; i < this.actualdata.length; i++) {
    //       if (this.actualdata[i].image_attachments != null) {
    //         for (var j = 0; j < this.actualdata[i].image_attachments.length; j++) {
    //           if (this.actualdata[i].image_attachments[j].startsWith("img_")) {
    //             this.newAttachment1.push({
    //               name: 'View report ',
    //               id: environment.HOST + '/helyxonapi/cloud/image/upload/' + this.actualdata[i].image_attachments[j],
    //               replace: 'Replace Attachment',
    //               overviewid: this.actualdata[i].overview_id,
    //               labid: this.actualdata[i].lab_id,
    //               description: this.actualdata[i].description ? this.actualdata[i].description : '',
    //               comments: this.actualdata[i].comments ? this.actualdata[i].comments : '',
    //               labtest: this.actualdata[i].lab_test,
    //               date: this.actualdata[i].date,
    //               type: 1,
    //               title: this.actualdata[i].title
    //             })
    //           } else {
    //             this.newAttachment1.push({
    //               name: 'View report ',
    //               id: environment.HOST + '/helyxonapi/cloud/pdf/upload/' + this.actualdata[i].image_attachments[j],
    //               replace: 'Replace Attachment',
    //               overviewid: this.actualdata[i].overview_id,
    //               labid: this.actualdata[i].lab_id,
    //               description: this.actualdata[i].description ? this.actualdata[i].description : '',
    //               comments: this.actualdata[i].comments ? this.actualdata[i].comments : '',
    //               labtest: this.actualdata[i].lab_test,
    //               date: this.actualdata[i].date,
    //               type: 2,
    //               title: this.actualdata[i].title

    //             })
    //           }
    //         }
    //       }
    //     }

    //     for (var i = 0; i < this.labtest.length; i++) {
    //       if (this.labtest[i] != null) {
    //         this.labReportList.push(this.labtest[i]);
    //       }
    //     }
    //   }

    //   for (var i = 0; i < this.attachments1.length; i++) {
    //     var exists = 0;

    //     for (var k = 0; k < this.newAttachment1.length; k++) {
    //       if (this.attachments1[i].date == this.newAttachment1[k].date) {
    //         exists = 1
    //       }
    //     }

    //     if (exists == 1) {
    //       this.attachments1[i].exists = 1
    //     }
    //     else {
    //       this.attachments1[i].exists = 0
    //     }
    //   }

    //   for (var i = 0; i < this.newAttachment1.length; i++) {
    //     if (this.newAttachment1[i].labid) {
    //     }
    //   }

    //   if (!this.labLength) {
    //     this.labLength = this.newAttachment1.length
    //   }
    // });

    var attachments = []

    var flag;

    var flag1;

    var obj;

    this.actualdata = []

    this.attachments = []

    this.newAttachment = []

    var inv_names = [];

    var data = []

    this.appService.getData(url, params, token).subscribe((response1: any) => {
      this.labArray = []
      var response = response1.result

      for (var i = 0; i < response.length; i++) {
        obj = {}

        obj.lab_tests = []

        obj.image_attachments = []

        obj.data = []

        obj.impressions = []

        obj.comments = []

        obj.titles = []

        obj.file_names = []

        obj.test_taken_on = []

        obj.lab_attachments = []

        var labexists = false

        for (var k = 0; k < response[i].data.length; k++) {

          this.labArray.push(response[i].data[k])

          obj.impression = response[i].data[k].description

          obj.impressions.push(response[i].data[k].description)

          obj.comments.push(response[i].data[k].comments)

          obj.titles.push(response[i].data[k].title)

          obj.file_names.push(response[i].data[k].file_name)

          obj.test_taken_on.push(response[i].data[k].test_taken_on)

          obj.lab_attachments.push(response[i].data[k].lab_attachments)

          // obj.title = response[i].data[k].title

          // obj.file_name = response[i].data[k].file_name

          // obj.test_taken_on = response[i].data[k].test_taken_on

          flag = 0
          flag1 = 0

          if (response[i].data[k].lab_test) {
            if (response[i].data[k].lab_test.length > 0) {
              flag = 1
            }
          }

          if (response[i].data[k].image_attachments) {

            if (response[i].data[k].image_attachments.length > 0) {
              flag1 = 1
            }
            if (response[i].data[k].image_attachments.length == 0 && response[i].data[k].lab_id) {
              flag1 = 1
            }
          }

          if (flag1 || flag == 1) {

            obj.date = response[i].date


            if (response[i].data[k].lab_test) {
              if (response[i].data[k].lab_test.length > 0) {

                obj.lab_tests = obj.lab_tests.concat(response[i].data[k].lab_test)
              }
            }

            if (response[i].data[k].image_attachments) {
              if (response[i].data[k].image_attachments.length > 0) {
                obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
              }
              if (response[i].data[k].image_attachments.length == 0 && response[i].data[k].lab_id) {
                labexists = true
                obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
              }
            }


            if (response[i].data[k].image_attachments || response[i].data[k].lab_test) {
              obj.data.push(response[i].data[k])

              obj.data.labexists = labexists

            }
          }
        }

        if (obj.date) {
          this.attachments.push(obj)
        }
      }

      {
        for (var i = 0; i < response.length; i++) {
          for (var j = 0; j < response[i].data.length; j++) {
            this.actualdata.push(response[i].data[j]);
            this.labtest.push(response[i].data[j].lab_test);
          }
        }

        for (var i = 0; i < this.actualdata.length; i++) {

          var images = [];

          for (var j = 0; j < this.actualdata[i].image_attachments.length; j++) {
            images = images.concat(this.actualdata[i].image_attachments[j].split(','))
          }

          for (var j = 0; j < images.length; j++) {
            images[j] = images[j].trim()
          }

          this.actualdata[i].image_attachments = images
        }

        console.log(this.actualdata)



        for (var i = 0; i < this.actualdata.length; i++) {
          if (this.actualdata[i].lab_attachments != null) {
            for (var j = 0; j < this.actualdata[i].lab_attachments.length; j++) {
              if (this.actualdata[i].lab_attachments[j].attachment.startsWith("img_")) {
                this.newAttachment.push({
                  name: 'View report ',
                  path: environment.HOST + '/helyxonapi/cloud/image/upload/' + this.actualdata[i].lab_attachments[j].attachment,
                  id: this.actualdata[i].lab_attachments[j].id,
                  file_type: this.actualdata[i].lab_attachments[j].file_type,
                  replace: 'Replace Attachment',
                  overviewid: this.actualdata[i].overview_id,
                  file_name: this.actualdata[i].file_name,
                  test_taken_on: this.actualdata[i].test_taken_on,
                  labid: this.actualdata[i].lab_id,
                  description: this.actualdata[i].description && this.actualdata[i].description != 'null' ? this.actualdata[i].description : '',
                  comments: this.actualdata[i].comments && this.actualdata[i].comments != 'null' ? this.actualdata[i].comments : '',
                  labtest: this.actualdata[i].lab_test,
                  date: this.actualdata[i].date,
                  type: 1,
                  title: this.actualdata[i].title,
                  category: this.actualdata[i].category
                })
              } else {
                this.newAttachment.push({
                  name: 'View report ',
                  path: environment.HOST + '/helyxonapi/cloud/pdf/upload/' + this.actualdata[i].lab_attachments[j].attachment,
                  id: this.actualdata[i].lab_attachments[j].id,
                  file_type: this.actualdata[i].lab_attachments[j].file_type,
                  replace: 'Replace Attachment',
                  overviewid: this.actualdata[i].overview_id,
                  file_name: this.actualdata[i].file_name,
                  test_taken_on: this.actualdata[i].test_taken_on,
                  labid: this.actualdata[i].lab_id,
                  description: this.actualdata[i].description && this.actualdata[i].description != 'null' ? this.actualdata[i].description : '',
                  comments: this.actualdata[i].comments && this.actualdata[i].comments != 'null' ? this.actualdata[i].comments : '',
                  labtest: this.actualdata[i].lab_test,
                  date: this.actualdata[i].date,
                  type: 2,
                  title: this.actualdata[i].title,
                  category: this.actualdata[i].category
                })
              }
            }
          }
        }


        for (var i = 0; i < this.labtest.length; i++) {
          if (this.labtest[i] != null) {
            this.labReportList.push(this.labtest[i]);
          }
        }
      }

      for (var i = 0; i < this.attachments.length; i++) {
        var exists = 0;

        for (var k = 0; k < this.newAttachment.length; k++) {
          if (this.attachments[i].date == this.newAttachment[k].date) {
            exists = 1
          }
        }

        if (exists == 1) {
          this.attachments[i].exists = 1
        }
        else {
          this.attachments[i].exists = 0
        }
      }

      for (var i = 0; i < this.newAttachment.length; i++) {
        if (this.newAttachment[i].labid) {
        }
      }

      console.log(this.attachments)

      console.log(this.newAttachment)

      console.log(this.labArray)

      for (var i = 0; i < response.length; i++) {
        var count = 0
        var test_names = []
        for (var j = 0; j < this.labArray.length; j++) {
          if (response[i].date == this.labArray[j].date) {

            // console.log(this.labArray[j].date)

            count++

            if (this.labArray[j].title && this.labArray[j].title != '')
              test_names.push(this.labArray[j].title)

            for (var k = 0; k < this.labArray.length; k++) {


              if (this.labArray[k].date == response[i].date) {
                this.labArray[k].count = count
                this.labArray[k].test_names = test_names

              }
            }

            // this.labArray[j].count=count

          }


        }

      }

      console.log(this.labArray)

      console.log(params)

      if (params.category == "Unseen") {
        this.labArray = this.labArray.filter((res => res.lab_attachments.length > 0));

        console.log(this.labArray)

        this.labLength = this.labArray.length
      }



    });

  }

  getCC(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;

        if (this.cc_page > 1)
          this.cc_data = this.cc_data.concat(response.data)
        else
          this.cc_data = response.data

        this.chief_complaints = this.cc_data;
        this.cc_copy = Object.assign([], this.chief_complaints);
        this.cc_copy1 = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_copy.splice(matchedArray[i], 1);
          this.cc_copy1.splice(matchedArray[i], 1);
        }

        //  duplicate logic 

        // for(var i=0;i<this.cc_copy1.length;i++)
        // {
        //   this.cc_copy1[i].name = this.cc_copy1[i].name.toLowerCase()
        // }

        // this.cc_copy1.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);

        //duplicate logic

        const lookup = this.cc_copy1.reduce((a, e) => {
          a[e.name.trim().toLowerCase()] = ++a[e.name.trim().toLowerCase()] || 0;
          return a;
        }, {});

        var valueArr = this.cc_copy1.map(function (item) { return item.name });
        var isDuplicate = valueArr.some(function (item, idx) {
          return valueArr.indexOf(item) != idx
        });
      }
    });
  }

  getCC1(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        //   this.cc_pages = response.total_page;
        //   this.cc_data = this.cc_data.concat(response.data)
        this.chief_complaints = response.data;
        this.cc_copy = Object.assign([], this.chief_complaints);
        this.cc_copy1 = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }


        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_copy.splice(matchedArray[i], 1);
          this.cc_copy1.splice(matchedArray[i], 1);
        }

        this.cc_copy1 = this.cc_copy1.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());


        if (this.cc_copy1.length > 0)
          this.update_cc(0, 1)
      }
    });


  }

  getCC2(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;
        this.cc_data = this.cc_data.concat(response.data)
        this.chief_complaints = this.cc_data;
        this.cc_copy = Object.assign([], this.chief_complaints);
        this.cc_copy1 = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_copy.splice(matchedArray[i], 1);
          this.cc_copy1.splice(matchedArray[i], 1);
        }

        this.cc_copy1 = this.cc_copy1.filter(i => i.name == params.alphabet);

        if (this.cc_copy1.length > 0) {
          this.update_cc(0, 0)
        }
      }
    });

  }

  getCC3(url, params, token, question) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;
        this.cc_data = this.cc_data.concat(response.data)
        this.chief_complaints2 = this.cc_data;
        this.cc_copy = Object.assign([], this.chief_complaints2);
        this.cc_copy2 = Object.assign([], this.chief_complaints2);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints2.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints2[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_copy.splice(matchedArray[i], 1);
          this.cc_copy2.splice(matchedArray[i], 1);
        }

        this.cc_copy2 = this.cc_copy2.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());

        if (question) {
          this.cc_copy2[0].name = '?' + this.cc_copy2[0].name
        }

        if (this.cc_copy2.length > 0) {
          this.update_cc2(0, 0)
        }
      }
    });

  }

  getCCCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.chief_complaints = response.details;
        this.cc_copy = Object.assign([], this.chief_complaints);
        this.cc_copy1 = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_copy.splice(matchedArray[i], 1);
          this.cc_copy1.splice(matchedArray[i], 1);
        }
      }
    });
  }

  getEx(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {

      if (response.success != 0 && !response.message) {

        this.examination = response.data;

        this.ex_pages = response.total_page;

        if (this.ex_page > 1)
          this.ex_data = this.ex_data.concat(response.data)
        else
          this.ex_data = response.data


        this.examination = this.ex_data;

        this.ex_copy = Object.assign([], this.examination);
        this.ex_copy1 = Object.assign([], this.examination);

        var matchedArray = [];

        for (var i = 0; i < this.examination.length; i++) {
          for (var k = 0; k < this.ex_selected.length; k++) {
            if (this.examination[i].symptoms_id == this.ex_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.ex_copy.splice(matchedArray[i], 1);
          this.ex_copy1.splice(matchedArray[i], 1);
        }
      }

      //  this.ex_copy1.sort((a,b)=> (a.name > b.name ? 1 : -1))

      const lookup = this.ex_copy1.reduce((a, e) => {
        a[e.name.trim().toLowerCase()] = ++a[e.name.trim().toLowerCase()] || 0;
        return a;
      }, {});


      var valueArr = this.ex_copy1.map(function (item) { return item.name });
      var isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx
      });

    });
  }

  getEx1(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {

      if (response.success != 0 && !response.message) {

        this.examination = response.data;
        //  this.ex_pages = response.total_page;

        //  this.ex_data = this.ex_data.concat(response.data)

        //  this.examination = this.ex_data;

        this.ex_copy = Object.assign([], this.examination);
        this.ex_copy1 = Object.assign([], this.examination);

        var matchedArray = [];

        for (var i = 0; i < this.examination.length; i++) {
          for (var k = 0; k < this.ex_selected.length; k++) {
            if (this.examination[i].symptoms_id == this.ex_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.ex_copy.splice(matchedArray[i], 1);
          this.ex_copy1.splice(matchedArray[i], 1);
        }
      }

      this.ex_copy1 = this.ex_copy1.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());


      if (this.ex_copy1.length > 0)
        this.update_ex(0, 1)

    });
  }

  getEx2(url, params, token, question) {

    this.appService.getData(url, params, token).subscribe((response: any) => {

      if (response.success != 0 && !response.message) {

        this.examination = response.data;
        this.ex_pages = response.total_page;

        this.ex_data = this.ex_data.concat(response.data)

        this.examination = this.ex_data;

        this.ex_copy = Object.assign([], this.examination);
        this.ex_copy1 = Object.assign([], this.examination);

        var matchedArray = [];

        for (var i = 0; i < this.examination.length; i++) {
          for (var k = 0; k < this.ex_selected.length; k++) {
            if (this.examination[i].symptoms_id == this.ex_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.ex_copy.splice(matchedArray[i], 1);
          this.ex_copy1.splice(matchedArray[i], 1);
        }
      }

      this.ex_copy1 = this.ex_copy1.filter(i => i.name == params.alphabet);

      if (question) {
        this.ex_copy1[0].name = '?' + this.ex_copy1[0].name
      }

      if (this.ex_copy1.length > 0)
        this.update_ex(0, 0)

    });
  }

  getExCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.examination = response.details;
        this.ex_copy = Object.assign([], this.examination);
        this.ex_copy1 = Object.assign([], this.examination);

        var matchedArray = [];

        for (var i = 0; i < this.examination.length; i++) {
          for (var k = 0; k < this.ex_selected.length; k++) {
            if (this.examination[i].symptoms_id == this.ex_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.ex_copy.splice(matchedArray[i], 1);
          this.ex_copy1.splice(matchedArray[i], 1);
        }
      }
    });
  }

  getDiag(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.diagnosis = response.data;
        this.diag_pages = response.total_page;

        if (this.diag_page > 1)
          this.diag_data = this.diag_data.concat(response.data);
        else
          this.diag_data = response.data

        this.diagnosis = this.diag_data;

        this.diag_copy = Object.assign([], this.diagnosis);
        this.diag_copy1 = Object.assign([], this.diagnosis);

        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.diagnosis.length; i++) {
            for (var k = 0; k < this.diag_selected.length; k++) {
              if (this.diagnosis[i].diagnosis_id == this.diag_selected[k].diagnosis_id) {
                matchedArray.push(i);
              }
            }
          }
          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.diag_copy.splice(matchedArray[i], 1);
            this.diag_copy1.splice(matchedArray[i], 1);
          }



          const lookup = this.diag_copy1.reduce((a, e) => {
            a[e.name.trim().toLowerCase()] = ++a[e.name.trim().toLowerCase()] || 0;
            return a;
          }, {});


          var valueArr = this.diag_copy1.map(function (item) { return item.name });
          var isDuplicate = valueArr.some(function (item, idx) {
            return valueArr.indexOf(item) != idx
          });
        }
      }
    });
  }

  getDiag1(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.diagnosis = response.data;
        //   this.diag_pages = response.total_page;
        //   this.diag_data = this.diag_data.concat(response.data);
        //   this.diagnosis = this.diag_data;

        //important!!

        this.diag_copy = Object.assign([], this.diagnosis);
        this.diag_copy1 = Object.assign([], this.diagnosis);



        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.diagnosis.length; i++) {
            for (var k = 0; k < this.diag_selected.length; k++) {
              if (this.diagnosis[i].diagnosis_id == this.diag_selected[k].diagnosis_id) {
                matchedArray.push(i);
              }
            }
          }
          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.diag_copy.splice(matchedArray[i], 1);
            this.diag_copy1.splice(matchedArray[i], 1);
          }
        }
      }

      this.diag_copy1 = this.diag_copy1.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());


      if (this.diag_copy1.length > 0)
        this.update_diag(0, 1)

    });
  }

  getDiag2(url, params, token, question) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.diagnosis = response.data;
        this.diag_pages = response.total_page;
        this.diag_data = this.diag_data.concat(response.data);
        this.diagnosis = this.diag_data;

        this.diag_copy = Object.assign([], this.diagnosis);
        this.diag_copy1 = Object.assign([], this.diagnosis);

        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.diagnosis.length; i++) {
            for (var k = 0; k < this.diag_selected.length; k++) {
              if (this.diagnosis[i].diagnosis_id == this.diag_selected[k].diagnosis_id) {
                matchedArray.push(i);
              }
            }
          }
          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.diag_copy.splice(matchedArray[i], 1);
            this.diag_copy1.splice(matchedArray[i], 1);
          }
        }
      }

      this.diag_copy1 = this.diag_copy1.filter(i => i.name == params.alphabet);

      if (question) {
        this.diag_copy1[0].name = '?' + this.diag_copy1[0].name
      }

      if (this.diag_copy1.length > 0)
        this.update_diag(0, 0)

    });
  }

  getDiagCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.diagnosis = response.details;
        this.diag_copy = Object.assign([], this.diagnosis);
        this.diag_copy1 = Object.assign([], this.diagnosis);

        var matchedArray = [];

        for (var i = 0; i < this.diagnosis.length; i++) {
          for (var k = 0; k < this.diag_selected.length; k++) {
            if (this.diagnosis[i].diagnosis_id == this.diag_selected[k].diagnosis_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.diag_copy.splice(matchedArray[i], 1);
          this.diag_copy1.splice(matchedArray[i], 1);
        }
      }
    });
  }

  getInv(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success !== 0 && !response.message) {
        this.invLoaded = true

        this.investigations = response.data;
        this.inv_pages = response.total_page;

        if (this.inv_page > 1)
          this.inv_data = this.inv_data.concat(response.data);
        else
          this.inv_data = response.data

        this.investigations = this.inv_data;

        this.inv_copy = Object.assign([], this.investigations);
        this.inv_copy1 = Object.assign([], this.investigations);
        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.investigations.length; i++) {
            for (var k = 0; k < this.inv_selected.length; k++) {
              if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.inv_copy.splice(matchedArray[i], 1);
            this.inv_copy1.splice(matchedArray[i], 1);
          }

          const lookup = this.inv_copy1.reduce((a, e) => {
            a[e.name.trim().toLowerCase()] = ++a[e.name.trim().toLowerCase()] || 0;
            return a;
          }, {});


          var valueArr = this.inv_copy1.map(function (item) { return item.name });
          var isDuplicate = valueArr.some(function (item, idx) {
            return valueArr.indexOf(item) != idx
          });
        }
      }
    })
  }

  getInv1(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success !== 0 && !response.message) {
        this.investigations = response.data;
        //  this.inv_pages = response.total_page;
        //  this.inv_data = this.inv_data.concat(response.data);
        //  this.investigations = this.inv_data;

        this.inv_copy = Object.assign([], this.investigations);
        this.inv_copy1 = Object.assign([], this.investigations);
        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.investigations.length; i++) {
            for (var k = 0; k < this.inv_selected.length; k++) {
              if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.inv_copy.splice(matchedArray[i], 1);
            this.inv_copy1.splice(matchedArray[i], 1);
          }
        }
      }

      this.inv_copy1 = this.inv_copy1.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());


      if (this.inv_copy1.length > 0)
        this.update_inv(0, 1)

    })
  }

  getInv2(url, params, token, question) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success !== 0 && !response.message) {
        this.investigations = response.data;
        this.inv_pages = response.total_page;
        this.inv_data = this.inv_data.concat(response.data);
        this.investigations = this.inv_data;

        this.inv_copy = Object.assign([], this.investigations);
        this.inv_copy1 = Object.assign([], this.investigations);
        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.investigations.length; i++) {
            for (var k = 0; k < this.inv_selected.length; k++) {
              if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.inv_copy.splice(matchedArray[i], 1);
            this.inv_copy1.splice(matchedArray[i], 1);
          }
        }
      }

      this.inv_copy1 = this.inv_copy1.filter(i => i.name == params.alphabet);

      if (question) {
        this.inv_copy1[0].name = '?' + this.inv_copy1[0].name
      }

      if (this.inv_copy1.length > 0)
        this.update_inv(0, 0)

    })
  }

  getInvCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.investigations = response.details;
        this.inv_copy = Object.assign([], this.investigations);
        this.inv_copy1 = Object.assign([], this.investigations);

        var matchedArray = [];

        for (var i = 0; i < this.investigations.length; i++) {
          for (var k = 0; k < this.inv_selected.length; k++) {
            if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.inv_copy.splice(matchedArray[i], 1);
          this.inv_copy1.splice(matchedArray[i], 1);
        }
      }
    });
  }

  getPres(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {

      if (response.success !== 0 && !response.message) {
        this.presLoaded = true

        this.prescriptions = response.data;
        this.pres_pages = response.total_page;

        if (this.pres_page > 1)
          this.pres_data = this.pres_data.concat(response.data);
        else
          this.pres_data = response.data

        this.prescriptions = this.pres_data;

        this.pres_copy = Object.assign([], this.prescriptions);
        this.pres_copy1 = Object.assign([], this.prescriptions);

        this.pres_copy1 = this.pres_copy1.filter(i => i.name != '');


        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.prescriptions.length; i++) {
            for (var k = 0; k < this.pres_selected.length; k++) {
              if (this.prescriptions[i].medicine_id == this.pres_selected[k].medicine_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.pres_copy.splice(matchedArray[i], 1);
            this.pres_copy1.splice(matchedArray[i], 1);
          }
        }
      }
    })
  }

  getPresCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.prescriptions = response.details;
        this.pres_copy = Object.assign([], this.prescriptions);
        this.pres_copy1 = Object.assign([], this.prescriptions);

        var matchedArray = [];

        for (var i = 0; i < this.prescriptions.length; i++) {
          for (var k = 0; k < this.pres_selected.length; k++) {
            if (this.prescriptions[i].name == this.pres_selected[k].medicine_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.pres_copy.splice(matchedArray[i], 1);
          this.pres_copy1.splice(matchedArray[i], 1);
        }
      }
    });
  }

  getAdv(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success !== 0 && !response.message) {
        this.advLoaded = true

        this.advice = response.data;
        this.adv_pages = response.total_page;

        if (this.adv_page > 1)
          this.adv_data = this.adv_data.concat(response.data);
        else
          this.adv_data = response.data

        this.advice = this.adv_data;

        this.adv_copy = Object.assign([], this.advice);
        this.adv_copy1 = Object.assign([], this.advice);
        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.advice.length; i++) {
            for (var k = 0; k < this.adv_selected.length; k++) {
              if (this.advice[i].instruction_id == this.adv_selected[k].instruction_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.adv_copy.splice(matchedArray[i], 1);
            this.adv_copy1.splice(matchedArray[i], 1);
          }

          const lookup = this.adv_copy1.reduce((a, e) => {
            a[e.instructions.trim().toLowerCase()] = ++a[e.instructions.trim().toLowerCase()] || 0;
            return a;
          }, {});


          var valueArr = this.adv_copy1.map(function (item) { return item.instructions });
          var isDuplicate = valueArr.some(function (item, idx) {
            return valueArr.indexOf(item) != idx
          });
        }
      }
    });
  }

  getAdv1(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success !== 0 && !response.message) {
        this.advice = response.data;
        //  this.adv_pages = response.total_page;
        //  this.adv_data = this.adv_data.concat(response.data);
        //  this.advice = this.adv_data;

        this.adv_copy = Object.assign([], this.advice);
        this.adv_copy1 = Object.assign([], this.advice);
        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.advice.length; i++) {
            for (var k = 0; k < this.adv_selected.length; k++) {
              if (this.advice[i].instruction_id == this.adv_selected[k].instruction_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.adv_copy.splice(matchedArray[i], 1);
            this.adv_copy1.splice(matchedArray[i], 1);
          }
        }
      }

      this.adv_copy1 = this.adv_copy1.filter(i => i.instructions.toLowerCase() == params.alphabet.toLowerCase());

      if (this.adv_copy1.length > 0)
        this.update_adv(0, 1)


    });
  }

  getAdv2(url, params, token, question) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success !== 0 && !response.message) {
        this.advice = response.data;
        this.adv_pages = response.total_page;
        this.adv_data = this.adv_data.concat(response.data);
        this.advice = this.adv_data;

        this.adv_copy = Object.assign([], this.advice);
        this.adv_copy1 = Object.assign([], this.advice);
        var matchedArray = [];

        if (response.success == 1) {
          for (var i = 0; i < this.advice.length; i++) {
            for (var k = 0; k < this.adv_selected.length; k++) {
              if (this.advice[i].instruction_id == this.adv_selected[k].instruction_id) {
                matchedArray.push(i);
              }
            }
          }

          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.adv_copy.splice(matchedArray[i], 1);
            this.adv_copy1.splice(matchedArray[i], 1);
          }
        }
      }

      this.adv_copy1 = this.adv_copy1.filter(i => i.instructions == params.alphabet);


      if (question) {
        this.adv_copy1[0].instructions = '?' + this.adv_copy1[0].instructions
      }

      if (this.adv_copy1.length > 0)
        this.update_adv(0, 0)

    });
  }

  getAdvCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.advice = response.details;
        this.adv_copy = Object.assign([], this.advice);
        this.adv_copy1 = Object.assign([], this.advice);


        var matchedArray = [];

        for (var i = 0; i < this.advice.length; i++) {
          for (var k = 0; k < this.adv_selected.length; k++) {
            if (this.advice[i].instruction_id == this.adv_selected[k].instruction_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.adv_copy.splice(matchedArray[i], 1);
          this.adv_copy1.splice(matchedArray[i], 1);
        }
      }
    });
  }

  getDiagnosis(url, params) {

    this.appService.getTags(url, params).subscribe((response: any) => {

      this.diagnosis = response.smartpres.data;
      //important!!

      this.diag_copy = Object.assign([], this.diagnosis);
      this.diag_copy1 = Object.assign([], this.diagnosis);

      var matchedArray = [];

      if (response.smartpres.success == 1) {
        for (var i = 0; i < this.diagnosis.length; i++) {
          for (var k = 0; k < this.diag_selected.length; k++) {
            if (this.diagnosis[i].diagnosis_id == this.diag_selected[k].diagnosis_id) {
              matchedArray.push(i);
            }
          }
        }
        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.diag_copy.splice(matchedArray[i], 1);
          this.diag_copy1.splice(matchedArray[i], 1);
        }

      }
    });
  }

  getInvestigations(url, params) {
    this.appService.getTags(url, params).subscribe((response: any) => {
      this.investigations = response.smartpres.data;
      this.inv_copy = Object.assign([], this.investigations);
      this.inv_copy1 = Object.assign([], this.investigations);
      var matchedArray = [];

      if (response.smartpres.success == 1) {
        for (var i = 0; i < this.investigations.length; i++) {
          for (var k = 0; k < this.inv_selected.length; k++) {
            if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.inv_copy.splice(matchedArray[i], 1);
          this.inv_copy1.splice(matchedArray[i], 1);
        }
      }

    })
  }

  getPrescription(url, params) {
    this.appService.getTags(url, params).subscribe((response: any) => {
      this.prescriptions = response.smartpres.data;
      this.pres_copy = Object.assign([], this.prescriptions);
      this.pres_copy1 = Object.assign([], this.prescriptions);
      var matchedArray = [];

      if (response.smartpres.success == 1) {
        for (var i = 0; i < this.prescriptions.length; i++) {
          for (var k = 0; k < this.pres_selected.length; k++) {
            if (this.prescriptions[i].medicine_id == this.pres_selected[k].medicine_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.pres_copy.splice(matchedArray[i], 1);
          this.pres_copy1.splice(matchedArray[i], 1);
        }
      }

    })
  }

  getAdvices(url, params) {
    this.appService.getTags(url, params).subscribe((response: any) => {
      this.advice = response.smartpres.data;
      this.adv_copy = Object.assign([], this.advice);
      this.adv_copy1 = Object.assign([], this.advice);
      var matchedArray = [];

      if (response.smartpres.success == 1) {
        for (var i = 0; i < this.advice.length; i++) {
          for (var k = 0; k < this.adv_selected.length; k++) {
            if (this.advice[i].instruction_id == this.adv_selected[k].instruction_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.adv_copy.splice(matchedArray[i], 1);
          this.adv_copy1.splice(matchedArray[i], 1);
        }
      }
    });
  }

  getQueue(url, token) {
    this.appService.getQueue(url, token).subscribe((response: any) => {
      this.current_patient_mr_number = response.current_patient_mr_number;
      this.current_patient_name = response.current_patient_name;
      this.current_patient_token = response.current_patient_token;
      this.estimated_time = response.estimated_time;
      this.next_patient_mr_number = response.next_patient_mr_number;
      this.next_patient_name = response.next_patient_name;
      this.next_patient_token = response.next_patient_token;
      this.patients_consulted = response.patients_consulted;
      this.patients_waiting = response.patients_waiting;
    });
  }

  getList(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      this.list = response;
      this.closedlength = response;

      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].type == "emergency_voice_call" && this.list[i].status == "confirmed") {
          this.emergencyIndication.next(true);
        }

        this.list[i].slot = moment(this.list[i].slot).format("hh:mm a");
        this.list[i].arrivaled_time = moment(this.list[i].arrival_time).format("hh:mm a");
        this.getDP(this.list[i].record_id, i)
      }

    });
  }

  getDP(id, index) {
    var params = {
      account_email: this.dmail,
      record_id: id
    }

    var token = this.token;

    this.list[index].phone = this.list[index].father_tel_number

    if (this.list[index].image == 'No profile picture' || this.list[index].image == '' || this.list[index].image == 'null' || this.list[index].image == null || this.list[index].image == 'None') {
      if (this.list[index].gender == 'male') {
        this.list[index].imgURL = 'assets/avatar-male.png'
      }
      else {
        this.list[index].imgURL = 'assets/avatar-female.png'

      }
    }
    else {
      this.list[index].imgURL = environment.HOST + '/helyxonapi/cloud/image/upload/' + this.list[index].image
    }

    var a = moment(this.list[index].bday).format("YYYY-MM-DD")

    var b = moment(new Date()).format("DD-MM-YYYY");

    var a_arr = a.split('-')
    var b_arr = b.split('-')

    this.month = moment([b_arr[2], Number(b_arr[1]) - 1, b_arr[0]]).diff(moment([a_arr[0], Number(a_arr[1]) - 1, a_arr[2]]), 'months', true)

    this.month = Math.round(this.month)

    var x = moment([b_arr[2], Number(b_arr[1]) - 1, b_arr[0]]);
    var y = moment([a_arr[0], Number(a_arr[1]) - 1, a_arr[2]]);

    this.list[index].age = moment(x).diff(moment(y), 'year')
    y.add('years', this.list[index].age)

    this.list[index].month = moment(x).diff(moment(y), 'months')

  }

  toggleKey() {
    if (this.show_block == 'cc') {
      this.toggle_cc_keyboard()
    }

    if (this.show_block == 'ex') {
      this.toggle_ex_keyboard()
    }

    if (this.show_block == 'diag' && this.diag_toggle == "alp") {
      this.toggle_diag_keyboard()
    }

    if (this.show_block == 'inv' && this.inv_toggle == "alp") {
      this.toggle_inv_keyboard()
    }

    if (this.show_block == 'pres' && this.pres_toggle == "alp") {
      this.toggle_pres_keyboard()
    }

    if (this.show_block == 'adv' && this.adv_toggle == "alp") {
      this.toggle_adv_keyboard()
    }

  }

  vaccinationCalendar(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      this.vaccinecalendar = response;
      for (var i = 0; i < response.length; i++) {
        if (response[i].status == "") {
          this.deffer_vaccine.push(response[i]);
        } else {
          var a = moment(response[i].date_given);//now
          var b = moment(response[i].due_date);
          var delay = a.diff(b, 'days');
          var data = {
            "age_in_days": response[i].age_in_days,
            "batch_id": response[i].batch_id,
            "brand_name": response[i].brand_name,
            "comments": response[i].comments,
            "date_given": response[i].date_given,
            "done_at": response[i].done_at,
            "drug_name": response[i].drug_name,
            "due_date": response[i].due_date,
            "id": response[i].id,
            "site": response[i].site,
            "sno": response[i].sno,
            "status": response[i].status,
            "delay": delay
          }
          this.defferedlist.push(data);
        }
      }
    });
  }

  deferred(data) {

    var due_date = moment(data.due_date).format("YYYY-MM-DD");
    var date_given = moment(new Date()).format("YYYY-MM-DD");
    var token = this.token;
    var params = {
      "id": data.id,
      "drug_name": data.drug_name,
      "age_in_days": '',
      "sno": data.sno,
      "site": data.site,
      "disease": data.disease,
      "due_date": due_date,
      "date_given": date_given,
      "brand_name": data.brand_name,
      "batch_id": data.batch_id,
      "comments": data.comments,
      "status": "Deferred",
      "done_at": data.done_at,
      "account_email": this.dmail,
      "patient_email": this.patient.record_info.Record.account_email,
      "user_type": "doctor"
    }
    this.deffered(this.urlPoints.deffer, params, token)
  }

  deffered(url, params, token) {
    this.appService.postData(url, params, token).subscribe((response: any) => {
      if (response.message == 'data added successfully.') {
      }
    });
  }

  view_source(prescription) {
    if (prescription.startsWith("http:") || prescription.endsWith(".png")) {
      this.upload_attach(prescription)
    } else if (prescription.endsWith(".pdf")) {
      window.open(prescription)
    }
  }

  labreports(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {

      for (var i = 0; i < response.length; i++) {
        for (var j = 0; j < response[i].data.length; j++) {
          this.actualdata.push(response[i].data[j]);
          this.labtest.push(response[i].data[j].lab_test);
        }
      }

      for (var i = 0; i < this.actualdata.length; i++) {
        if (this.actualdata[i].image_attachments != null) {
          for (var j = 0; j < this.actualdata[i].image_attachments.length; j++) {
            if (this.actualdata[i].image_attachments[j].startsWith("img_")) {
              this.newAttachment.push({
                name: 'View report ',
                id: 'https://api.epicare.net/helyxonapi/cloud/image/upload/' + this.actualdata[i].image_attachments,
                replace: 'Replace Attachment',
                overviewid: this.actualdata[i].overview_id,
                labid: this.actualdata[i].lab_id,
                description: this.actualdata[i].description,
                comments: this.actualdata[i].comments,
                labtest: this.actualdata[i].lab_test,
                date: this.actualdata[i].date
              })
            } else {
              this.newAttachment.push({
                name: 'View report ',
                id: 'https://api.epicare.net/helyxonapi/cloud/pdf/upload/' + this.actualdata[i].image_attachments,
                replace: 'Replace Attachment',
                overviewid: this.actualdata[i].overview_id,
                labid: this.actualdata[i].lab_id,
                description: this.actualdata[i].description,
                comments: this.actualdata[i].comments,
                labtest: this.actualdata[i].lab_test,
                date: this.actualdata[i].date
              })
            }
          }
        }
      }

      for (var i = 0; i < this.labtest.length; i++) {
        if (this.labtest[i] != null) {
          this.labReportList.push(this.labtest[i]);
        }
      }

    });
  }

  mouseup() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }

    if (this.held) {
      this.held = false

      if (!this.muted && !this.popupOpen) {

        this.muted = true
        this.service.stop()
      }
    }
  }

  mousedown() {

    console.log('here')

    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;

      this.held = true

      if (this.muted && !this.popupOpen) {
        //  alert()
        this.muted = false
        this.service.start()
      }
    }, 1000);
  }

  detectLeftButton(evt) {
    evt = evt || window.event;
    if ("buttons" in evt) {
      return evt.buttons == 1;
    }
    var button = evt.which || evt.button;
    return button == 1;
  }

  mouseup2() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);

      this.timeoutHandler = null;
      this.set('ex')
    }
  }

  mousedown2() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;
      this.ex_item.nativeElement.focus();
    }, 1000);
  }

  mouseup3() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);

      this.timeoutHandler = null;
      this.set('diag')
    }
  }

  mousedown3() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;
      this.diag_item.nativeElement.focus();
    }, 1000);
  }


  mouseup4() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);

      this.timeoutHandler = null;
      this.set('inv')
    }
  }

  mousedown4() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;
      this.inv_item.nativeElement.focus();
    }, 1000);
  }

  mouseup5() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);

      this.timeoutHandler = null;
      this.set('pres')
    }
  }

  mousedown5() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;
      this.pres_item.nativeElement.focus();
    }, 1000);
  }

  mouseup6() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);

      this.timeoutHandler = null;
      this.set('adv')
    }
  }

  mousedown6() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;
      this.adv_item.nativeElement.focus();
    }, 1000);
  }

  addAll() {
    var length = this.cc_copy1.length;
    for (var i = 0; i < length; i++) {
      this.update_cc(0, 0)
    }
  }

  setArrival(e, pat_detils) {
    if(e){
    e.stopPropagation();
  }
    var params1 = {
      account_email: this.dmail,
      doctor_id: this.doc_id,
      patient_account: pat_detils.email,
      appointment_id: pat_detils.id
    }

    this.appService.postData(this.urlPoints.setArrival, params1, this.token).subscribe((response: any) => {
      var params = {
        account_email: this.dmail,
        doctor_id: this.doc_id,
        status_type: this.appindex,
        in_date: moment(this.selecteddate).format("YYYY-MM-DD")
      }
      const geturlPoint = this.urlPoints.getqueueList;
      this.getList(this.urlPoints.geturlPoint, params, this.token);
      this.checkStatus('queclick');
    });
  }

  //sub menu clicks
  devprocessAlert(subtabs) {

    var vaccinationdata = {
      "mode": "1",
      "token": this.token,
      "dmail": this.dmail,
      "patientdob": this.patient.demographics.bday,
      "patientemail": this.patient.record_info.Record.account_email,
      "id": this.id, did: this.doc_id
    }

    for (var i = 0; i < 6; i++) {
      const el = document.getElementsByClassName('topmenu_sub')[i] as HTMLElement;
      el.style.color = "#2A2A2A";
    }
    document.getElementById('subTab_' + subtabs).style.color = "#0063ff";
    if (subtabs == 1) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_vaccinationwindow, {
        data: { vaccineDetails: vaccinationdata },
        disableClose: true

      }).afterDismissed().subscribe((result) => {
        //  alert('Bottom sheet has been dismissed.');
        this.getRecord(this.id);
        this.lmp_update = !this.lmp_update
      });

    } else {
      alert("Under the Development Process");
    }
  }

  call_vaccination() {
    var params = {
      mode: "1",
      token: this.token,
      dmail: this.dmail,
      patientdob: this.patient.demographics.bday,
      patientemail: this.patient.record_info.Record.account_email,
      id: this.id,
      did: this.doc_id
    }
  }

  getAbha(){
    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email
    }

    this.appService.getData(this.urlPoints.getabharecord, params, this.token).subscribe((response: any) => {
      console.log('response::',response);
      if(response.success==1){
        // alert()
        this.abha = true
        this.abhaDetails = response.message[0]
        console.log('abhaDetails:',this.abhaDetails);
        sessionStorage.setItem('abhaDetails',this.abhaDetails)
      }
    });

  }

  openbottomwindom(subtabs) {

    for (var i = 0; i < 5; i++) {
      const el = document.getElementsByClassName('topmenu_sub')[i] as HTMLElement;
      el.style.color = "#2A2A2A";
    }
    document.getElementById('subTab_' + subtabs).style.color = "#0063ff";
    if (subtabs == 0) {
      this.getAbha()
      console.log('abhaDetails::',this.abhaDetails)
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_bottomwindow, {
        data: { patientDetails: this.patient, abhaDetails: this.abhaDetails },
        disableClose: true
      }).afterDismissed().subscribe((result) => {
        //  alert('Bottom sheet has been dismissed.');
        this.getRecord(this.id);
      });

    } else if (subtabs == 2) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_profileSocialHistory, {
        data: { patientDetails: this.patient },
        disableClose: true
      }).afterDismissed().subscribe((result) => {
        //  alert('Bottom sheet has been dismissed.');
      });
    } else if (subtabs == 4) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_questionareetHistory, {
        data: { patientDetails: this.patient },
        disableClose: true
      }).afterDismissed().subscribe((result) => {
        //  alert('Bottom sheet has been dismissed.');
      });
    } else if (subtabs == 1) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_familyhistory, {
        data: { patientDetails: this.patient },
        disableClose: true
      }).afterDismissed().subscribe((result) => {
        //  alert('Bottom sheet has been dismissed.');
      });
    }
    else if (subtabs == 5) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_threshold, {
        data: { patientDetails: this.patient },
        disableClose: true
      }).afterDismissed().subscribe((result) => {
        //  alert('Bottom sheet has been dismissed.');
      });
    }
    else {
      alert("Under the Development Process");
    }


  }

  openLab() {
    //  alert()
    const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_labreports, {
      data: { patientDetails: this.patient, filter_type: 1 },
      disableClose: true
    }).afterDismissed().subscribe((result) => {
      //   alert('Bottom sheet has been dismissed.');
      this.labLength = undefined

      this.getUnseen()
    });
  }

  openbottomHistory(openHistorytab) {
    for (var i = 0; i < 6; i++) {
      const el = document.getElementsByClassName('histab')[i] as HTMLElement;
      el.style.color = "#2A2A2A";
    }
    document.getElementById('hisTab_' + openHistorytab).style.color = "#0063ff";
    if (openHistorytab == 0) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_consultHistory, {
        data: { patientDetails: this.patient, openFrom: 0, print_temps: this.print_temps, displayTotal: this.displayTotal, durationAlone: this.durationAlone, fullFreq: this.fullFreq, drugShowType: this.drugShowType },
        disableClose: true
      });
    } else if (openHistorytab == 1) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_medicaltHistory, {
        data: { patientDetails: this.patient, openFrom: 0 },
        disableClose: true
      });
    }
    else if (openHistorytab == 2) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_clinicaltHistory, {
        data: { patientDetails: this.patient, openFrom: 0 },
        disableClose: true
      });
    }
    else if (openHistorytab == 3) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_clinicaltHistory, {
        data: { patientDetails: this.patient, openFrom: 0 },
        disableClose: true
      });
    }
    else if (openHistorytab == 5) {
      const dialogRef = this._bottomSheet.open(DailogOverviewExampleDailog_vitalHistory, {
        data: { patientDetails: this.patient, openFrom: 0 },
        disableClose: true
      });
    }
    else if (openHistorytab == 6) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_social, {
        data: { patientDetails: this.patient, openFrom: 0 , token:this.token, email:this.patient.record_info.Record.account_email, dmail:this.dmail},
        disableClose: true
      });
    }

    else if (openHistorytab == 7) {
      // alert()
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_family, {
        data: { patientDetails: this.patient, openFrom: 0 , token:this.token, email:this.patient.record_info.Record.account_email, dmail:this.dmail},
        disableClose: true
      });
    }
  }

  openbottomwPaediatrics(pedtab) {
    for (var i = 0; i < 5; i++) {
      const el = document.getElementsByClassName('pedtab')[i] as HTMLElement;
      el.style.color = "#2A2A2A";
    }
    document.getElementById('pedtab_' + pedtab).style.color = "#0063ff";
    if (pedtab == 1) {
      var vaccinationdata = {
        "mode": "1",
        "token": this.token,
        "dmail": this.dmail,
        "patientdob": this.patient.demographics.bday,
        "patientemail": this.patient.record_info.Record.account_email,
        "id": this.id, did: this.doc_id
      }

      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_vaccinationwindow, {
        data: { vaccineDetails: vaccinationdata },
        disableClose: true

      }).afterDismissed().subscribe((result) => {
        //  alert('Bottom sheet has been dismissed.');
        // this.getRecord(this.id);
      });
    }
    else if (pedtab == 2) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_paediatricsMilestone, {
        data: { patientDetails: this.patient, openFrom: 0 },
        disableClose: true
      });
    } else if (pedtab == 3) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_paediatricsMotherantenatal, {
        data: { patientDetails: this.patient, openFrom: 0 },
        disableClose: true
      });
    } else if (pedtab == 4) {
      const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_paediatricBabyHistory, {
        data: { patientDetails: this.patient, openFrom: 0 },
        disableClose: true
      });
    }
    else {
      alert("Under the Development Process");
    }
  }

  gynecbootomwindow(subtabs) {
    for (var i = 0; i < 2; i++) {
      const el = document.getElementsByClassName('gyncsubtabs')[i] as HTMLElement;
      el.style.color = "#2A2A2A";
    }
    document.getElementById('subGynecTab_' + subtabs).style.color = "#0063ff";

    const dialogRef = this._bottomSheet.open(DialogOverviewExampleDialog_obstGynec, {
      data: { patientDetails: this.patient, openFrom: subtabs },
      disableClose: true
    }).afterDismissed().subscribe((result) => {
      this.lmp_update = !this.lmp_update

      //  alert('Bottom sheet has been dismissed.');
      // this.getRecord(this.id);
    });
  }



  notifyVideoCall(e, pat_detils) {
    e.stopPropagation();

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_notifyvideocall, {
      width: '600px',
      data: { msg: 'Dear Doctor! This will Notify patient that you are available through ivrs call!', notify_details: pat_detils, open_callType: 1, allow_status: pat_detils.allow_status }
    });
  }

  joinVideoCall(e, pat_detils) {
    //e.stopPropagation();
    this.joinbuttonStatus = true;
    let getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = getauthdetails.account_id;
    this.doc_id = getauthdetails.doctor_id;
    this.token = getauthdetails.token;

    var senderId = pat_detils.email.replace('@', '_').replace('.org', '') + '_' + this.doc_id;
    var payload = {
      patient_email: pat_detils.email,
      account_email: this.dmail,
      doctor_id: this.doc_id,
      channel_name: senderId,
      a_type: pat_detils.type,
      a_id: pat_detils.id
    }
    this.appService.postData(this.urlPoints.createvideoroom, payload, this.token).subscribe((response: any) => {
      this.toastr.success(response.message);
      window.open('https://exp.epicare.net:8000/room/' + response.room_name + '/' + response.access_token, "_blank")
    });

  }

  setPatientDetails(e, patient, index) {

    this.appointment_id = patient.id;
    //console.log("patientclickApptID*****"+ this.appointment_id);

    sessionStorage.setItem("apt_id", this.appointment_id)

    for (var i = 0; i < this.list.length; i++) {
      const el = document.getElementsByClassName('selectedQueue')[i] as HTMLElement;
      el.style.border = "1px solid #c4d5ef";
      el.style.boxShadow = "none";
      el.style.backgroundImage = "linear-gradient(#e9f2ff, #e9f2ff)";
    }
    document.getElementById('queue_' + index).style.backgroundImage = "linear-gradient(#cbdbf3, #fff)";
    document.getElementById('queue_' + index).style.border = "3px solid #cbdbf3";
    document.getElementById('queue_' + index).style.boxShadow = "5px 2px #cbdbf3";
    document.getElementById('queue_' + index).style.animation = "none";

    this.opendstartConsultPopup = false;

    this.id = patient.record_id;
    this.loadICS(this.id);

    this.current_videocall_patientDetails = patient;

    if (patient.type == "video_call" && patient.status == 'confirmed' && (patient.participant_connect_status == null || patient.participant_connect_status == 0)) {
      this.notifyVideoCall(event, patient);
    }

    if (patient.type == "voice_call" || patient.type == "emergency_voice_call") {
      if (patient.arrival_time == null) {
        this.setArrival(event, patient);
      }

      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_notifyvideocall, {
        width: '600px',
        data: { msg: 'Dear Doctor! Would you like to initiate the call to patient?', notify_details: patient, open_callType: 0 }
      });
    }

    if (this.status != "End Consultation") {

      window.parent.window.postMessage({
        "message": "patient",
        "patient": patient
      }, '*')
    }

    else {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_notifier, {
        width: '600px',
        data: { name: 'Please end consultation' }
      });
    }
  }

  printTemp() {
    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id,
      overview_id: this.preview_id,
      patient_email: this.patient.record_info.Record.account_email,
      template_id: this.selected_temp_Id,
      template_v4:2
    }

    this.appService.getData(this.urlPoints.getFile, params, this.token).subscribe((response: any) => {

    })
    //alert(this.selected_temp_Id);
    //Mangalbharti presc header type 
    console.log('selected template id',this.selected_temp_Id);
    
    if (this.selected_temp_Id == 441663) {
      this.mangal_header_Type = 1;
      this.printPres();
    } else if (this.selected_temp_Id == 442302) {
      this.mangal_header_Type = 0;
      this.printPres();
    } else if (this.selected_temp_Id == 858179) {
      this.mangal_header_Type = 0;
      this.printPres();
    }
     else if (this.selected_temp_Id == 858397) {
      this.mangal_header_Type = 0; //without header
      this.printPres();
    }
     else if (this.selected_temp_Id == 915089) {
      this.mangal_header_Type = 0; //sky without header
      this.printPres();
    }
     else if (this.selected_temp_Id == 922831) {
      this.mangal_header_Type = 1; //sky with header
      this.printPres();
    }
     else if (this.selected_temp_Id == 1146377) {
      this.mangal_header_Type = 1; //ajay narasimhan
      this.printPres();
    }
     else if (this.selected_temp_Id == 861962) {
      this.mangal_header_Type = 0; //premier medical
      this.printPres();
    }
    else if (this.selected_temp_Id == 248685) {
      this.mangal_header_Type = 0; //varadharajan LPC for test env taken random template and template name is New testing temp 
      this.printPres();
    }
    else if (this.selected_temp_Id == 1049949) {
      this.mangal_header_Type = 0; //varadharajan LPC for prod env template 
      this.printPres();
    }
    else if (this.ICSscreen_load) {
      this.printPres1();
    }
    else if (this.custom_template) {
      this.customTemplateprint();
    } else {
      this.printPres1();
    }

  }

  printPres() {

    this.appService.getQueue(this.urlPoints.getVitals + '?' + this.id, this.token).subscribe((response: any) => {
      console.log(response);
      this.vitalsData = response;
      if(this.vitalsData.length!=0){
        this.sortByDate(this.vitalsData)

        console.log(this.sortByDate(this.vitalsData));

        this.vitDate = this.vitalsData[0].date.split("T")[0]

      }else{

        this.vitDate = moment(new Date()).format('YYYY-MM-DD')
      }
      
      console.log(this.vitDate);
        

        var token = this.token;

        // this.isPrinting = true;

        if (this.prescription_id) {
          //  this.updatePres()
        }

        var ex_names = []

        for (var i = 0; i < this.ex_selected.length; i++) {
          ex_names.push(this.ex_selected[i].name)
        }

        var lab_tests = [];

        for (var i = 0; i < this.inv_selected.length; i++) {
          lab_tests.push(this.inv_selected[i].name)
        }

        var diag_names = [];

        for (var i = 0; i < this.diag_selected.length; i++) {
          diag_names.push(this.diag_selected[i].name)
        }

        var adv_names = [];

        for (var i = 0; i < this.adv_selected.length; i++) {
          adv_names.push(this.adv_selected[i].instructions)
        }

        var params = {
          "account_email": this.dmail,
          "op_review":
          {
            "patient_email": this.patient.record_info.Record.account_email,
            "appointment_id": this.appointment_id,
            "complaint_id": this.complaint_id ? this.complaint_id : null,
            "prescription_id": this.prescription_id ? this.prescription_id : null,
            "notes": "",
            "findings": ex_names.join("\n"),
            "physical_examination": "",
            "measurement_test": "",
            "provisional_diagnosis": "",
            "investigation": "",
            "lab_tests": lab_tests,
            "diagnosis": diag_names.join("\n"),
            "advice": adv_names.join("\n"),
            "diet_instructions": "",
            "food_instructions": "",
            "others": "",
            "follow_up_date": '',
            "follow_up_text": this.follow_text
          }
        }
        if (this.call == 'update') {
          this.appService.postData(this.urlPoints.updatePreview, params, token).subscribe((response: any) => {



            this.preview_id = response.id;
            this.printDisabled = false;

            this.isPrinting = false;

            this.callprintprespopup = true;

            this.printArr.push('1')

            var host = environment.HOST;

            var type;

            if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '2') || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '7')
              || (this.dmail == 'rx138310@rxcarenet.org' && this.doc_id == '1') || (this.dmail == 'rx138310@rxcarenet.org' && this.doc_id == '2')
              || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '8') || (this.dmail == 'rx138824@rxcarenet.org' && this.doc_id == '1')) {
              type = '/briefprescription/#'
            }//mangal presc template && prashanth presc
            else if ((this.dmail == 'rx15@rxcarenet.org' && this.doc_id == '1') || (this.dmail == 'rx122340@rxcarenet.org')) {
              type = '/mangalprescription/#'
            }else if((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '4') || (this.dmail == 'rx389462@rxcarenet.org' && this.doc_id == '1')) {
              type = '/prescription/prashanth/#'
            }
            // pending..... change doc_id accordingly doctor login in test server
            else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '65') || (this.dmail == 'rx483098@rxcarenet.org' && this.doc_id == '1')) {
              type = '/prescription/srinivasan/#'
            }
            // new clinic
            else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '5') || (this.dmail == 'rx545313@rxcarenet.org' && this.doc_id == '2')) {
              type = '/prescription/ajay/#'
            }
             // pending..... change doc_id accordingly doctor login in test server
            else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '65') || (this.dmail == 'rx494693@rxcarenet.org' && this.doc_id == '1')) {
              type = '/prescription/skyclinic/#'
            }
            // pending..... change doc_id accordingly doctor login in test server
            else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '65') || (this.dmail == 'rx370593@rxcarenet.org' && this.doc_id == '1')) {
              type = '/prescription/suhail/#'
            }
            // pending...change doc_id accordingly doctor login in test server
            else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '3') || (this.dmail == 'rx533822@rxcarenet.org' )) {
              type = '/prescription/varadha/#'
            }
            else {
              type = '/prescription/#'
            }

            this.currentProjectUrl = host + type + '/print/?route_path=prescription&account_email=' + this.dmail + '&overview_Id=' + this.preview_id +
              '&doctor_Id=' + this.doc_id + '&mr_num=' + this.patient.record_info.Record.mr_number +
              '&vit_date='+ this.vitDate +'&vacc_date=&vacc_msg=&dr_Name=' + this.docData.name +
              '&dr_regNo=' + this.docData.registration + '&auth_token=' + this.token + '&appoint_Id=' + this.appointment_id +
              '&followup_date= ' + this.follow_text + '&faliculr_status=1&risk_status=1&patient_email=' +
              this.patient.record_info.Record.account_email + '&vital_weight=&vital_height=&vital_temp=&pres_printName='
              + this.patient.record_info.Record.label + '&pres_printGender=' + this.patient.demographics.gender + '&pres_printAge=' + this.y + '&header_status=' + this.mangal_header_Type
            console.log('update******')
            console.log(this.currentProjectUrl)
            this.currentProjectUrl = this.dom.bypassSecurityTrustResourceUrl(this.currentProjectUrl)

          });
        }
        else {
          this.appService.postData(this.urlPoints.addPreview, params, token).subscribe((response: any) => {



            this.preview_id = response.id;
            this.preview = 'Update Consultation'
            this.printDisabled = false;

            this.isPrinting = false;

            this.printArr.push('1')

            this.callprintprespopup = true;
            var host = environment.HOST;

            var type;

            if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '2') || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '7')
              || (this.dmail == 'rx138310@rxcarenet.org' && this.doc_id == '1') || (this.dmail == 'rx138310@rxcarenet.org' && this.doc_id == '2')
              || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '8') || (this.dmail == 'rx138824@rxcarenet.org' && this.doc_id == '1')) {
              type = '/briefprescription/#'
            }
            else {
              type = '/prescription/#'
            }

            this.currentProjectUrl = host + type + '/print/?route_path=prescription&account_email=' + this.dmail + '&overview_Id=' + this.preview_id +
              '&doctor_Id=' + this.doc_id + '&mr_num=' + this.patient.record_info.Record.mr_number +
              '&vit_date='+ this.vitDate +'&vacc_date=&vacc_msg=&dr_Name=' + this.docData.name +
              '&dr_regNo=' + this.docData.registration + '&auth_token=' + this.token + '&appoint_Id=' + this.appointment_id +
              '&followup_date=&faliculr_status=1&risk_status=1&patient_email=' +
              this.patient.record_info.Record.account_email + '&vital_weight=&vital_height=&vital_temp=&pres_printName='
              + this.patient.record_info.Record.label + '&pres_printGender=' + this.patient.demographics.gender + '&pres_printAge=' + this.y
            console.log('else*******')
            console.log(this.currentProjectUrl)
            this.currentProjectUrl = this.dom.bypassSecurityTrustResourceUrl(this.currentProjectUrl)

          });
        }
    })
  }

  customTemplateprint() {

    var medicinearray = [];

    for (var i = 0; i < this.pres_selected.length; i++) {
      var obj = {
        "formulation": this.pres_selected[i].formulation,
        "frequency": this.pres_selected[i].frequency,
        "drug_name": this.pres_selected[i].brand,
        "frequency_in_days": this.pres_selected[i].duration_type
      }
      medicinearray.push(obj);
    }

    var params = {
      "account_email": this.dmail,
      "template_id": this.selected_temp_Id,
      "category_id": this.selected_temp_categoryId,
      "doctor_name": this.getdrName,
      "doctor_number": this.getdrnum,
      "doctor_position": "",
      "doctor_designation": this.getdrdegree,
      "doctor_speciality": this.getdrspec,
      "patient_firstname": this.patient.record_info.Record.label,
      "patient_dob": this.patient.demographics.bday,
      "patient_gender": this.patient.demographics.gender,
      "patient_age_in_yrs": this.getdob,
    }

    //Referal letter
    if (this.selected_temp_Id == 426858) {
      params["patient_furthur_examination"] = this.pat_examination;
      params["medicines"] = medicinearray;
      params["patient_diagnosis"] = this.pat_diagonsis;
      params["referred_hospital_city"] = this.refer_dr_address;
      params["referred_hospital"] = this.refer_hos_name;
      params["referred_doctorname"] = this.refer_dr_name;
      params["referred_doctorspeciality"] = this.refer_dr_spec;
    }
    //Fitness certi
    if (this.selected_temp_Id == 426907) {
      params["patient_identification_marks"] = this.fit_identification;
      params["patient_honorifics"] = "Mr";
      params["patient_fathername"] = this.patient.demographics.father_name_family;
      params["patient_relation"] = "son";
      params["place"] = this.fit_place;
      params["date"] = this.fittodayDate;
      params["patient_image"] = ""
    }

    //medical leave student or child
    if (this.selected_temp_Id == 426946) {
      params["patient_diagnosis"] = this.medLeave_dises;
      params["leave_period_in_days"] = this.medLeave_days;
      params["leave_period_in_words"] = "";
      params["leave_start_date"] = this.fitstartDate;
      params["school_start_date"] = this.fitBack_date;
    }

    //medical leave adult
    if (this.selected_temp_Id == 427017) {
      params["patient_diagnosis"] = this.adult_medLeave_disies;
      params["leave_period_in_days"] = this.adult_medLeave_days;
      params["leave_period_in_words"] = "";
      params["leave_start_date"] = this.leave_start_date;
      params["patient_honorifics"] = "";
    }

    //return to duty
    if (this.selected_temp_Id == 426949) {
      params["patient_honorifics"] = "";
    }

    this.isPrinting = true;

    this.appService.postData(this.urlPoints.getnonconsultationtemplatepdf, params, this.token).subscribe((response: any) => {
      this.isPrinting = false;
      //window.open(environment.HOST + '/PDF/' + response.file_name);
      let getpdfData = environment.HOST + '/PDF/' + response.file_name;
      this.print_file_name = this.dom.bypassSecurityTrustResourceUrl(getpdfData);

      const dialogRef = this.dialog.open(DialogOverviewPrintTemplate, {
        width: '80%',
        height: '90vw',
        data: { printtemplates: this.print_file_name }
      });
    });

  }

  printPres1() {

    this.isPrinting = true;

    var token = this.token;

    if (this.prescription_id) {
      //  this.updatePres()
    }

    var ex_names = []

    for (var i = 0; i < this.ex_selected.length; i++) {
      ex_names.push(this.ex_selected[i].name)
    }

    var lab_tests = [];

    for (var i = 0; i < this.inv_selected.length; i++) {
      lab_tests.push(this.inv_selected[i].name)
    }

    var diag_names = [];

    for (var i = 0; i < this.diag_selected.length; i++) {
      diag_names.push(this.diag_selected[i].name)
    }

    var adv_names = [];

    for (var i = 0; i < this.adv_selected.length; i++) {
      adv_names.push((i + 1) + '. ' + this.adv_selected[i].instructions)
    }

    var params = {
      "account_email": this.dmail,
      "op_review":
      {
        "patient_email": this.patient.record_info.Record.account_email,
        "appointment_id": this.appointment_id,
        "complaint_id": this.complaint_id ? this.complaint_id : null,
        "prescription_id": this.prescription_id ? this.prescription_id : null,
        "notes": "",
        "findings": ex_names.join("\n"),
        "physical_examination": "",
        "measurement_test": "",
        "provisional_diagnosis": "",
        "investigation": "",
        "lab_tests": lab_tests,
        "diagnosis": diag_names.join("\n"),
        "advice": "<br>" + adv_names.join("<br>"),
        "diet_instructions": "",
        "food_instructions": "",
        "others": "",
        "follow_up_date": '',
        "follow_up_text": this.follow_text
      }
    }

    var params_add = {
      account_email: this.dmail,
      appointment_id: this.appointment_id,
      history: '',
      heart_rate: this.heart_rate ? this.heart_rate : '',
      respiratory_rate: this.respiratory_rate ? this.respiratory_rate : '',
      spo2: this.spo2 ? this.spo2 : '',
      blood_pressure: this.blood_pressure ? this.blood_pressure : '',
      weight: this.weight ? this.weight : ''
    }

    this.appService.postData(this.urlPoints.addOns, params_add, this.token).subscribe((response: any) => {
    });

    if (this.call == 'update') {

      this.appService.postData(this.urlPoints.updatePreview, params, token).subscribe((response: any) => {

        this.preview_id = response.id;
        this.printDisabled = false;

        this.appService.postData(this.urlPoints.updatePreview, params, token).subscribe((response: any) => {
          this.preview_id = response.id;

          var params = {
            account_email: this.dmail,
            doctor_id: this.doc_id,
            overview_id: this.preview_id,
            patient_email: this.patient.record_info.Record.account_email,
            template_id: this.selected_temp_Id,
            template_v4:2
          }

          this.appService.getData(this.urlPoints.getFile, params, token).subscribe((response: any) => {
            if(response.data=='unable to generate'){
              this.toastr.error( "Please try again")
            }else{
            this.someEvent_print.next();
            console.log(response.data);
            this.isPrinting = false;

            let getpdfData = environment.HOST + '/PDF/' + response.data;
            this.print_file_name = this.dom.bypassSecurityTrustResourceUrl(getpdfData);
            this.toastr.success("Prescription sent successfully");
            }
          });
        });
      });
    }
    else {
      this.appService.postData(this.urlPoints.addPreview, params, token).subscribe((response: any) => {
        this.preview_id = response.id;
        this.preview = 'Update Consultation'
        this.printDisabled = false;

        var params = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          overview_id: this.preview_id,
          patient_email: this.patient.record_info.Record.account_email,
          template_id: this.selected_temp_Id,
          template_v4:2
        }

        // this.isPrinting = true

        this.appService.getData(this.urlPoints.getFile, params, token).subscribe((response: any) => {
          this.someEvent_print.next();

        });

      });
    }



  }

  printPayment() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_tempchoose1, {
      width: '600px',
      data: { temps: this.print_temps }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  openGraphForm() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog2, {
      width: '600px',
      data: { option: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        result.date = moment.utc(result.date).format();

        this.vitals = result;

        var token = this.token;

        var params = {
          "record_id": this.id,
          "doctor_id": this.doc_id,
          'account_email': this.dmail,
          "patient_email": this.patient.record_info.Record.account_email,
          "type": "Vitals", "data": {
            "Models": {
              "Model": {
                "name": "HelChildVitalSigns",
                "Field": [
                  { "name": "date", "text": this.vitals.date },
                  { "name": "weight", text: this.vitals.weight != (undefined || null) ? this.vitals.weight.toString() : "" },
                  { "name": "bmi", text: this.vitals.weight / (this.vitals.height * this.vitals.height) != (undefined || NaN || null) ? (this.vitals.weight / (this.vitals.height * this.vitals.height)).toString() : "" },
                  { "name": "height", text: this.vitals.height != (undefined || null) ? this.vitals.height.toString() : "" },
                  { "name": "arm_circumference", "text": this.vitals.arm != (undefined || null) ? this.vitals.arm.toString() : "" },
                  { "name": "chest_circumference", "text": this.vitals.chest != (undefined || null) ? this.vitals.chest.toString() : "" },
                  { "name": "head_circumference", "text": this.vitals.chest != (undefined || null) ? this.vitals.chest.toString() : "" }
                ]
              }
            }
          }
        }

        this.postVitals(this.urlPoints.postVitals, params, token)
      }

    });
  }

  openaddpara() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpara, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
  }

  openviewpara() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpara2, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  openaddAbort() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogabortion, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
  }

  openviewAbort() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogabortion2, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  toggle_full() {
    this.full = !this.full;
    this.someEvent_full.next();
    if (!this.full) {
      document.getElementById('appointmnetList').style.width = "0%";
      document.getElementById('appointmnetList').style.zIndex = "0";
      document.getElementById('icsscreen').style.width = "99%";
      document.getElementById('legend').style.display = "none";
      document.getElementById('quesearch').style.display = "none";
      document.getElementById('profileRow').style.height = "2rem";
      document.getElementById('profileRow').style.marginBottom = "4%";
      document.getElementById('inputtop').style.marginTop = "5px";
      this.fullscrImgSrc = 'assets/minimise-view.png';
    } else {
      document.getElementById('appointmnetList').style.width = "20%";
      document.getElementById('appointmnetList').style.zIndex = "1";
      document.getElementById('legend').style.display = "block";
      document.getElementById('quesearch').style.display = "block";
      document.getElementById('icsscreen').style.width = "80%";
      document.getElementById('profileRow').style.height = "5rem";
      document.getElementById('profileRow').style.marginBottom = "0%";
      document.getElementById('inputtop').style.marginTop = "5px";
      this.fullscrImgSrc = 'assets/fullscreen.png';

    }


  }

  openaddlmpmissingpopup() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialoglmpmissingpopup, {
      width: '600px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.lmpok == "1") {
        this.save_obshistory()
      } else if (sessionStorage.lmpok == "0") {
        return
      }

    });
  }

  openviewRiskhistory() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogriskhistory, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  openaddcurrentpregRecords() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogaddcurrentpregRecords, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

      this.get_currentpregnancyRecords();

    });
  }

  openaddscanreport() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogaddscanreport, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.get_scanreportfindingdata();

    });
  }

  openaddalertscanfollowup() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogalertscanfollowup, {
      width: '600px',
      data: { option: 1 }
    });
  }

  openaddfolliclestudy() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogaddfolliclestudy, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.get_folliclestudydetails();

    });
  }

  openviewarchivedcpRecords() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogviewarchivedcpRecords, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  openclearlmpeddaddDeatils() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialoglclearlmpeddaddDeatils, {
      width: '600px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.clearlmpedd == "1") {
        this.obstetricHistorydata = this.obstetricHistory.value
        let data = {
          "account_email": this.dmail,
          "lmp": "",
          "expected_delivery": "",
          "actual_delivery": "",
          "gravida": this.obstetricHistorydata.obsgravidas ? this.obstetricHistorydata.obsgravidas : "0",
          "para": this.obstetricHistorydata.obsparas ? this.obstetricHistorydata.obsparas : "0",
          "abortions": this.obstetricHistorydata.obsabortions ? this.obstetricHistorydata.obsabortions : "0",
          "notes": this.obstetricHistorydata.obsgeneralnotess ? this.obstetricHistorydata.obsgeneralnotess : "",
          "patient_email": this.patient.record_info.Record.account_email,
          "doctor_id": this.doc_id
        }
        this.appService.postData(this.urlPoints.createobsthistory, data, this.token).subscribe((response: any) => {
          this.toastr.success("Updated successfully")
          this.get_obsthistory()
        });
      } else if (sessionStorage.clearlmpedd == "0") {
        return
      }

    });
  }

  openviewarchivedcpRisk() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogviewarchivedcpRisk, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  openviewarchivedcpscan() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogviewarchivedcpscan, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  openviewarchivedfollicle() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogviewarchivedfollicle, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  openviewmilestonepicture(data) {
    sessionStorage.setItem("milestonetimeline", data)
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogmilestonepicture, {
      width: '1400px',
      data: { option: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getmilestonepatienthistory();

    });
  }

  openstatusedit(index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogstatusedit, {
      width: '650px',
      height: '225px',
      data: this.viewmilestonepatienthistory[index]
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getmilestonepatienthistory();

    });
  }




  sortByDate(arr) {
    arr.sort(function(a,b){
      return Number(new Date(a.date)) - Number(new Date(b.date));
    });

    return arr.reverse();
  }

  clearIcs(){
    this.cc_selected = [];
    this.ex_selected = [];
    this.diag_selected = [];
    this.inv_selected = [];
    this.pres_selected = [];
    this.adv_selected = [];
  }

  previousIcs(){
    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email,
      doctor_id: this.doc_id
    }

    this.appService.postData(this.urlPoints.LastConsultation, params, this.token).subscribe((response: any) =>{
      console.log('response',response);
      if(response.success==1){
        var params1 = {
          account_email: this.dmail,
          appointment_id: response.data.appointment_id
        }
    
        this.appService.getData(this.urlPoints.getPreview, params1, this.token).subscribe((response: any) => {
          if (response.op_review.appointment_id) {
            this.call = 'update'
            this.preview = 'Update Consultation'
          }
          else {
            this.call = 'add'
          }
    
          if (response.op_review.notes) {
            this.hpi = response.op_review.notes
            this.hpi2 = response.op_review.notes
          }
    
          if (response.op_review.prescription_id) {
            this.prescription_id = response.op_review.prescription_id;
            this.pres_selected = response.op_review.prescription;
    
            this.pres_selected = Object.assign([], response.op_review.prescription);
    
            var getPres = {
              account_email: this.dmail,
              doctor_id: this.doc_id
            }
    
            this.appService.getData(this.urlPoints.getPresCustom, getPres, this.token).subscribe((response: any) => {
    
              // if (response.data[0])
                if (response.data[0].status) {
                  this.showUnits = response.data[0].status == 1 ? true : false
                }
    
              for (var k = 0; k < this.pres_selected.length; k++) {
                var brand = this.pres_selected[k].brand
                this.pres_selected[k].brand = this.pres_selected[k].generic
                this.pres_selected[k].generic = brand;
                this.pres_selected[k].generic = this.pres_selected[k].composition
              }
    
              for (var i = 0; i < this.pres_selected.length; i++) {
                this.pres_count++;
                var obj = {
                  drug_id: this.pres_selected[i].id,
                  dose: this.pres_selected[i].dose,
                  dose_option: this.pres_selected[i].dose_option,
                  frequency: this.pres_selected[i].frequency,
                  route: this.pres_selected[i].route,
                  when: this.pres_selected[i].when,
                  duration: this.pres_selected[i].duration.toString(),
                  duration_type: this.pres_selected[i].duration_type,
                  quantity: this.pres_selected[i].quantity,
                  special_instruction: this.pres_selected[i].special_instruction,
                  minimum_buyable_qty: this.pres_selected[i].minimum_buyable_qty,
                  operation: 'add',
                  pres_id: this.pres_count
                }
    
                var unit = this.pres_selected[i].quantity.split(' ')[1]
    
                var freq_arr = this.pres_selected[i].frequency.split('-')
    
                if (freq_arr.length == 4) {
                  var morning = freq_arr[0].trim().split(' ')[0]
    
                  var afternoon = freq_arr[1].trim().split(' ')[0]
    
                  var evening = freq_arr[2].trim().split(' ')[0]
    
                  var night = freq_arr[3].trim().split(' ')[0]
    
                  if (this.showUnits) {
                    var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')
    
                    var shortUnit = ''
    
                    if (unit == 'milliliter') {
                      shortUnit = 'ml'
                    }
    
                    else if (unit == 'Tablet') {
                      shortUnit = 'Tablet'
                    }
    
                    else if (unit == 'microgram') {
                      shortUnit = 'mcg'
                    }
    
                    else if (unit == 'milligram') {
                      shortUnit = 'mg'
                    }
    
                    else if (unit == 'gram') {
                      shortUnit = 'grm'
                    }
    
    
                    else if (unit == 'drops') {
                      shortUnit = 'drops'
                    }
    
                    else if (unit == 'Sachets/Packets') {
                      shortUnit = 'pkt'
                    }
    
    
                    var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
    
                    if (unit == 'mole' || unit == 'millimole') {
                      var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                      freq = shortFreq
                    }
                    this.pres_selected[i].frequency = freq
                    this.pres_selected[i].shortFreq = shortFreq
                  }
                  else {
                    var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
    
                    this.pres_selected[i].frequency = freq
    
    
                    this.pres_selected[i].shortFreq = freq
    
                  }
    
                }
                else if (freq_arr.length == 2) {
    
                  var shortUnit = ''
    
                  if (unit == 'milliliter') {
                    shortUnit = 'ml'
                  }
    
                  else if (unit == 'Tablet') {
                    shortUnit = 'Tablet'
                  }
    
                  else if (unit == 'microgram') {
                    shortUnit = 'mcg'
                  }
    
                  else if (unit == 'milligram') {
                    shortUnit = 'mg'
                  }
    
                  else if (unit == 'gram') {
                    shortUnit = 'grm'
                  }
    
    
                  else if (unit == 'drops') {
                    shortUnit = 'drops'
                  }
    
                  else if (unit == 'Sachets/Packets') {
                    shortUnit = 'pkt'
                  }
    
                  if (this.showUnits) {
    
                    var freq1: any = this.pres_selected[i].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[i].frequency.split('-')[1].trim().split(' ')[0].trim()
    
    
                    this.pres_selected[i].frequency = freq1 + ' ' + unit
    
                    this.pres_selected[i].shortFreq = freq1 + ' ' + shortUnit
                  }
                  else {
                    var freq1: any = this.pres_selected[i].frequency.split('-')[0].trim() + ' - ' + this.pres_selected[i].frequency.split('-')[1].trim().split(' ')[0].trim()
    
                    this.pres_selected[i].shortFreq = freq1
                  }
                }
    
                else {
                  var freq1: any = this.pres_selected[i].frequency
    
                  this.pres_selected[i].shortFreq = freq1
                }
    
    
                this.pres_selected[i].pres_id = this.pres_count;
    
                this.pres_entries.push(obj)
              }
            });
    
    
          }
    
          if (response.op_review.complaint.id) {
            this.complaint_id = response.op_review.complaint.id;
            this.cc_issues = response.op_review.complaint.issues;
            var isQuestionArr = []
    
            var names = [];
    
            if (this.cc_issues)
              for (var i = 0; i < this.cc_issues.length; i++) {
                names.push(this.cc_issues[i].complaint_category)
                isQuestionArr.push(this.cc_issues[i].is_question)
              }
    
            for (var i = 0; i < names.length; i++) {
              var params = {
                account_email: this.dmail,
                page_no: 1,
                alphabet: names[i]
              }
    
              this.getCC3(this.urlPoints.getCC, params, this.token, isQuestionArr[i]);
            }
    
            if (names.length == 0) {
              //  this.set('cc')
            }
    
    
          }
          else {
            //  this.set('cc')
          }
    
          var names2 = response.op_review.findings.split('\n');
    
          if (names2.length > 0)
            for (var i = 0; i < names2.length; i++) {
    
              if (names2[i].startsWith('?')) {
                names2[i] = names2[i].substring(1)
                var question = true
              }
              else {
                var question = false
              }
    
              var params = {
                account_email: this.dmail,
                page_no: 1,
                alphabet: names2[i]
              }
    
              this.getEx2(this.urlPoints.getEx, params, this.token, question);
            }
    
          var names3 = response.op_review.lab_tests;
    
          if (names3 && names3.length > 0) {
            for (var i = 0; i < names3.length; i++) {
    
              if (names3[i].startsWith('?')) {
                names3[i] = names3[i].substring(1)
                var question = true
              }
              else {
                var question = false
              }
    
              var params = {
                account_email: this.dmail,
                page_no: 1,
                alphabet: names3[i]
              }
    
    
              this.getInv2(this.urlPoints.getInv, params, this.token, question);
            }
          }
    
          var names4 = response.op_review.diagnosis.split('\n')
    
          for (var i = 0; i < names4.length; i++) {
    
            if (names4[i].startsWith('?')) {
              names4[i] = names4[i].substring(1)
              var question = true
            }
            else {
              var question = false
            }
    
            var params = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: names4[i]
            }
    
    
            this.getDiag2(this.urlPoints.getDiag, params, this.token, question);
          }
    
          var names5 = response.op_review.advice.split('<br>')
    
    
          for (var i = 0; i < names5.length; i++) {
    
            if (names5[i] != '')
              names5[i] = names5[i].substring(3);
    
            if (names5[i].startsWith('?')) {
              names5[i] = names5[i].substring(1)
              var question = true
            }
            else {
              var question = false
            }
    
            var params = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: names5[i]
            }
    
            this.getAdv2(this.urlPoints.getAdv, params, this.token, question);
          }
    
    
        });
      }else if(response.success==2){
        this.toastr.error(response.message)
      }else{
        this.toastr.error(response.message)
      }
    })
  }

  fillButton(buttonNumber: number) {
    if (buttonNumber === 1) {
      this.isButton1Filled = true;
      this.isButton2Filled = false;
    } else if (buttonNumber === 2) {
      this.isButton1Filled = false;
      this.isButton2Filled = true;
    }
  }

}

function moveWithinContainer(container, fromIndex, toIndex) {
  if (fromIndex === toIndex) {
    return;
  }

  const nodeToMove = container.children[fromIndex];
  const targetNode = container.children[toIndex];

  if (fromIndex < toIndex) {
    targetNode.parentNode.insertBefore(nodeToMove, targetNode.nextSibling);
  } else {
    targetNode.parentNode.insertBefore(nodeToMove, targetNode);
  }
}

function transferNodeToContainer(node, container, toIndex) {
  if (toIndex === container.children.length) {
    container.appendChild(node);
  } else {
    const targetItem = container.children[toIndex];
    targetItem.parentNode.insertBefore(node, targetItem);
  }
}

@Component({
  selector: 'prescription-form',
  templateUrl: 'prescription-form.html',
  styleUrls: ['prescription-form.scss']
})

export class DialogOverviewExampleDialog {

  @ViewChild('menu_item1') menu_item1: ElementRef;
  @ViewChild('timeInput') timeInput: ElementRef;

  getStockStatus;
  text;
  name;
  dose;
  duration;
  time;
  quantity: any = 0;
  differ;
  formulation;
  generic;
  frequency = '1 time a day';
  when;
  dose_option;
  duration_type;
  minimum_buyable_qty = '';
  route;
  prescription_mode;
  strength = '';
  special_instruction = '';
  strength_unit = '';
  show_block = 1;
  id;
  freq_arr = ['Once a day', '1 time a day', '2 times a day', '3 times a day', 'Twice a day', 'Three times a day', '4 times a day', 'Stat', 'At night', 'As and when required', 'Every 2 hours', 'Every 4 hours', 'Every 6 hours', 'Every 8 hours', 'Others']
  when_arr = ['After Food', 'Before Food', 'SOS', 'Not related to food']
  route_arr = ['Oral', 'Inhalation', 'Inhalation', 'Intradelmar', 'Subcutaneous', 'Inhale', 'Application', 'IV / Inject',
    'Intravenus', 'Nubliser', 'Eye', 'Ear', 'Nose', 'Skin', 'Anus', 'Genital', 'Others']
  dose_arr = ['ml', 'nos', 'cap', 'tab', 'puff', 'drops', 'mg']
  formulation_arr = ['Injection', 'Lotion', 'Oinment', 'Soap', 'Tablet', 'Suspension', 'Cream', 'Capsules',
    'Drops', 'Oil', 'Gel', 'Powder', 'Syrup', 'Inhalation', 'Sachet', 'Vaccination', 'Others']

  morning = false;
  afternoon = false;
  evening = false;
  night = false;

  morning_dose;
  afternoon_dose;
  evening_dose;
  night_dose;

  timedOutCloser1;
  timedOutCloser2;
  timedOutCloser3
  timedOutCloser4;
  timedOutCloser7;
  timedOutCloser8;
  timedOutCloser10;

  maxcount = 1;
  count = 0;

  diameter = 150;
  angle = 45;
  every_value = 2;

  slider_value;
  slider_value2;
  slider_value3;
  frequency_type;
  popupOpen = false
  freq_quantity: any = '1'
  time_block;
  strengthActive = false
  onRemove = new EventEmitter();
  addPres = false;
  create = false;
  formulation1;
  urlPoints;
  dmail;
  warning = false;
  weightWarning = false
  durationWarning = false;
  doseWarning = false
  durationMessage = '';
  doseMessage = '';
  maxDosage;
  maxDuration;
  url;
  doc_id;
  host;
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>, private differs: KeyValueDiffers, private appService: AppService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.differ = this.differs.find({}).create();
    this.urlPoints = AppConfig.settings.EndPoints;
  }

  ngOnInit(): void {
    this.host = this.data.host;
const auth = sessionStorage.getItem('authDetails');
var getD_ID = JSON.parse(auth)
    this.dmail = this.data.dmail
    this.doc_id = getD_ID.doctor_id;
this.getMasterSettings();

    if (this.data.id) {
      this.id = this.data.id
    }

    if (this.data.mode == 1) {

      this.data.when = 'After Food';
      this.duration_type = 'Days';

      if (this.data.obj) {


        this.getStockStatus = this.data.getStockStatus;
        this.name = this.data.name;
        this.frequency = this.data.obj.frequency;
        this.dose = this.data.obj.dose;
        this.dose_option = this.data.obj.dose_option;
        this.duration = this.data.obj.duration.toString();
        this.duration_type = this.data.obj.duration_type;
        this.formulation = this.data.obj.formulation;
        this.generic = this.data.obj.generic;
        this.minimum_buyable_qty = this.data.obj.minimum_buyable_qty;
        this.quantity = this.data.obj.quantity;
        this.route = this.data.obj.route;
        this.special_instruction = this.data.obj.special_instruction;
        this.strength = this.data.obj.strength;
        this.strength_unit = this.data.obj.strength_unit;
        this.when = this.data.obj.when;
        this.time = this.data.time ? this.data.time : '12:00 AM'
        this.formulation1 = this.formulation

        if (this.when == 'AF') {
          this.when = 'After Food'
        }

        if (this.when == 'BF') {
          this.when = 'Before Food'
        }

        if (this.when == 'NRF') {
          this.when = 'Not Related to Food'
        }

        if (this.when == 'WF') {
          this.when = 'With Food'
        }



        if (this.dose != undefined || this.dose != '') {
          this.strengthActive = true
        }

        if (this.dose == undefined || this.dose == '') {
          this.strengthActive = false
        }


        if (this.frequency.startsWith('Every') && !this.frequency.startsWith('Everyday')) {
          this.frequency_type = 'every'

          this.time_block = 'frequency'

          this.frequency_type = 'every'

          this.every_value = Number(this.frequency.split(' ')[1])

          this.freq_quantity = this.frequency.split(' ')[4]

          this.morning_dose = 0;
          this.afternoon_dose = 0;
          this.evening_dose = 0;
          this.night_dose = 0;
        }

        else if (this.frequency.startsWith('Everyday')) {
          this.frequency_type = 'time'

          this.time_block = 'frequency'

          this.every_value = 2

          this.time = this.frequency.split(' ')[1] + ' ' + this.frequency.split(' ')[2]

          this.freq_quantity = this.frequency.split(' ')[4]

          this.morning_dose = 0;
          this.afternoon_dose = 0;
          this.evening_dose = 0;
          this.night_dose = 0;
        }

        else if (this.frequency.startsWith('S.O.S')) {
          this.frequency_type = 'sos'

          this.time_block = 'frequency'

          this.every_value = 2

          this.freq_quantity = this.frequency.split(' ')[2]

          this.morning_dose = 0;
          this.afternoon_dose = 0;
          this.evening_dose = 0;
          this.night_dose = 0;
        }

        else if ((this.frequency.split("-").length - 1) == 3) {
          this.frequency_type = 'times'

          this.time_block = 'times'

          this.every_value = 2

          this.morning_dose = this.data.obj.frequency.split('-')[0].trim().split(' ')[0]

          this.afternoon_dose = this.data.obj.frequency.split('-')[1].trim().split(' ')[0]

          this.evening_dose = this.data.obj.frequency.split('-')[2].trim().split(' ')[0]

          this.night_dose = this.data.obj.frequency.split('-')[3].trim().split(' ')[0]
        }
        else {
          this.time = '12:00 AM'

          this.time_block = 'times'

          this.frequency_type = 'times'

          this.morning_dose = 0

          this.afternoon_dose = 0

          this.evening_dose = 0

          this.night_dose = 0
        }

        if (this.duration_type == 'Months') {
          this.duration_type = 'Months'
        }

        if (this.dose_option == '') {
          this.dose_option = 'milliliter'

          if (this.data.obj.category.trim() == 'Tablet' || this.data.obj.category.trim() == 'Capsule' || this.data.obj.category.trim() == 'Captab' || this.data.obj.category.trim() == 'Chewable Tablet' || this.data.obj.category.trim() == 'Rotacap') {
            this.dose_option = 'milligram'
          }

          if (this.data.obj.category.trim() == 'Drops' || this.data.obj.category.trim() == 'Liquid' || this.data.obj.category.trim() == 'Solution') {
            this.dose_option = 'milliliter'
          }

          if (this.data.obj.category.trim() == 'Ear Drops' || this.data.obj.category.trim() == 'Eye Drops') {
            this.dose_option = 'milliliter'
          }

          if (this.data.obj.category.trim() == 'Expectorant' || this.data.obj.category.trim() == 'Suspension' || this.data.obj.category.trim() == 'Syrup') {
            this.dose_option = 'milliliter'
          }

          if (this.data.obj.category.trim() == 'Ointment' || this.data.obj.category.trim() == 'Gel' || this.data.obj.category.trim() == 'Paste' || this.data.obj.category.trim() == 'Soap' || this.data.obj.category.trim() == 'Dusting Powder' || this.data.obj.category.trim() == 'Tooth Paste') {
            this.dose_option = 'gram'
          }

          if (this.data.obj.category.trim() == 'Granules' || this.data.obj.category.trim() == 'Granule' || this.data.obj.category.trim() == 'Sachet') {
            this.dose_option = 'gram'
          }

          if (this.data.obj.category.trim() == 'Lotion' || this.data.obj.category.trim() == 'Cream') {
            this.dose_option = 'gram'
          }

          if (this.data.obj.category.trim() == 'Nasal Drops' || this.data.obj.category.trim() == 'Nasal Spray') {
            this.dose_option = 'milligram'
          }

          if (this.data.obj.category.trim() == 'Shampoo') {
            this.dose_option = 'milliliter'
          }
        }

      }
    }

    else {

      console.log(this.data.obj)


      this.name = this.data.name;

      this.dose = '';

      this.dose_option = 'milliliter'

      this.duration = '1';

      this.duration_type = 'Days'

      this.quantity = '1';

      this.formulation = this.data.obj.category;



      this.formulation1 = this.formulation
      this.getStockStatus = this.data.getStockStatus;

      this.generic = this.data.obj.composition_name;

      this.frequency = this.freq_arr[1]

      this.when = 'After Food'

      this.route = this.route_arr[0]

      this.morning = true

      this.afternoon = true

      this.evening = true

      this.night = true

      this.morning_dose = 0

      this.afternoon_dose = 0

      this.evening_dose = 0

      this.night_dose = 0

      this.getCount()

      this.getMaxCount('1 time a day')

      this.slider_value = 0

      this.time = '12:00 AM'

      this.time_block = 'times'

      this.frequency_type = 'times'

      // console.log(this.dmail)
      // console.log(this.doc_id)

      // this.dmail = 'rx122340@rxcarenet.org';

      // this.doc_id = 1

      if (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) {
        this.duration = '5'
      }

      if (this.data.obj.category.trim() == 'Tablet' || this.data.obj.category.trim() == 'Capsule' || this.data.obj.category.trim() == 'Captab' || this.data.obj.category.trim() == 'Chewable Tablet' || this.data.obj.category.trim() == 'Rotacap') {
        this.dose_option = 'milligram'
      }

      if (this.data.obj.category.trim() == 'Aplicap' || this.data.obj.category.trim() == 'Diaper' || this.data.obj.category.trim() == 'Dressing') {
        this.route = "Other"
        this.when = 'Not Related to Food'
      }

      if (this.data.obj.category.trim() == 'Cathetor') {
        this.route = "Other"
      }


      if (this.data.obj.category.trim() == 'Cleansing Gel') {
        this.route = "Topical"
      }



      if (this.data.obj.category.trim() == 'Drops' || this.data.obj.category.trim() == 'Liquid' || this.data.obj.category.trim() == 'Solution') {
        this.dose_option = 'milliliter'
      }

      if (this.data.obj.category.trim() == 'Ear Drops' || this.data.obj.category.trim() == 'Eye Drops') {
        this.dose_option = 'milliliter'
        this.route = 'Other'
        this.when = 'Not Related to Food'
      }

      if (this.data.obj.category.trim() == 'Expectorant' || this.data.obj.category.trim() == 'Suspension' || this.data.obj.category.trim() == 'Syrup') {
        this.dose_option = 'milliliter'
        this.route = 'Oral'
      }

      if (this.data.obj.category.trim() == 'Ointment' || this.data.obj.category.trim() == 'Gel' || this.data.obj.category.trim() == 'Paste' || this.data.obj.category.trim() == 'Soap' || this.data.obj.category.trim() == 'Dusting Powder' || this.data.obj.category.trim() == 'Tooth Paste') {
        this.dose_option = 'gram'
        this.route = 'Topical'
        this.when = 'Not Related to Food'
      }

      if (this.data.obj.category.trim() == 'Granules' || this.data.obj.category.trim() == 'Granule' || this.data.obj.category.trim() == 'Sachet') {
        this.dose_option = 'gram'
        this.route = 'Oral'
      }

      if (this.data.obj.category.trim() == 'Inhaler' || this.data.obj.category.trim() == 'Respules' || this.data.obj.category.trim() == 'Respule' || this.data.obj.category.trim() == 'Transpule' || this.data.obj.category.trim() == 'Transpules') {
        this.route = 'Inhale'
      }

      if (this.data.obj.category.trim() == 'Injection') {
      }

      if (this.data.obj.category.trim() == 'Lotion' || this.data.obj.category.trim() == 'Cream') {
        this.dose_option = 'gram'
        this.route = 'Topical'
      }

      if (this.data.obj.category.trim() == 'Nasal Drops' || this.data.obj.category.trim() == 'Nasal Spray') {
        this.dose_option = 'milligram'
        this.route = 'Other'
        this.when = 'Not Related to Food'

      }

      if (this.data.obj.category.trim() == 'Shampoo') {
        this.dose_option = 'milliliter'
        this.route = 'Topical'
        this.when = 'Not Related to Food'

      }

      if (this.data.obj.category.trim() == 'Vaccine') {
      }

      if (this.data.obj.category.trim() == 'Lozenges') {
        this.route = "Oral"
      }

      if (this.data.obj.duration) {
        this.duration = this.data.obj.duration
      }

      if (this.data.obj.duration_type == "Days" || this.data.obj.duration_type == "Day") {
        this.duration_type = 'Days'
      }

      if (this.data.obj.duration_type == "Months" || this.data.obj.duration_type == "Month") {
        this.duration_type = 'Months'
      }

      if (this.data.obj.dose_option) {
        this.dose_option = this.data.obj.dose_option
      }

      if (this.data.obj.route) {
        this.route = this.data.obj.route
      }

      if (this.data.obj.route == 'Others') {
        this.route = 'Other'
      }

      if (this.data.obj.when) {
        this.when = this.data.obj.when
      }



      if (this.data.obj.strength) {

        this.dose = Number(this.data.obj.strength)

        this.strengthActive = true
      }

      if (this.data.obj.special_instruction) {
        this.special_instruction = this.data.obj.special_instruction

      }

      if (this.data.obj.minimum_buyable_qty) {
        this.minimum_buyable_qty = this.data.obj.minimum_buyable_qty

      }

      if (this.data.obj.frequency == "SOS") {
        this.frequency_type = 'sos'

        this.time_block = 'frequency'

        this.every_value = 2

        this.freq_quantity = 1

        this.morning_dose = 0;
        this.afternoon_dose = 0;
        this.evening_dose = 0;
        this.night_dose = 0;
      }

      if (this.data.obj.frequency.startsWith('Every')) {


        this.frequency_type = 'every'

        this.time_block = 'frequency'

        this.every_value = Number(this.data.obj.frequency.split(' ')[1])

        this.freq_quantity = 1

        this.morning_dose = 0;
        this.afternoon_dose = 0;
        this.evening_dose = 0;
        this.night_dose = 0;
      }

      if (this.data.obj.frequency == "Twice a day") {
        this.frequency_type = 'times'

        this.time_block = 'times'

        this.morning_dose = 1;
        this.afternoon_dose = 0;
        this.evening_dose = 0;
        this.night_dose = 1;

      }

      if (this.data.obj.frequency == "Three times a day") {
        this.frequency_type = 'times'

        this.time_block = 'times'

        this.morning_dose = 1;
        this.afternoon_dose = 1;
        this.evening_dose = 0;
        this.night_dose = 1;

      }

      if (this.data.obj.frequency == "Four times a day") {
        this.frequency_type = 'times'

        this.time_block = 'times'

        this.morning_dose = 1;
        this.afternoon_dose = 1;
        this.evening_dose = 1;
        this.night_dose = 1;
      }

      console.log(this.data.obj)
    }

    if (this.data.obj.strength_unit)
      this.dose_option = this.data.obj.strength_unit

    //  alert(this.dmail)

    //  this.dmail=localStorage.getItem('DOCTOREMAIL')

    var dosageParams = {
      composition_id: this.data.obj.composition_id,
      category: this.data.obj.category,
      p_wt: this.data.weight ? String(this.data.weight) : '',
      p_age: this.data.age != undefined ? String(this.data.age) : '',
      UOM: this.dose_option,
      account_email: this.dmail,
      quantity: 0,
      duration: 1

    }

    this.appService.postData(this.urlPoints.getDosage, dosageParams, this.data.token).subscribe((response: any) => {
      console.log(response)

      if (response.status == 0) {
        this.warning = true

        if (response.message == 'patient_weight_&_age_needed' || response.message == 'patient_weight_needed') {
          this.weightWarning = true
        }
      }
      else {
        this.warning = false
        this.weightWarning = false

        console.log(response.data.max_dosage_per_day_number)

        if (response.data.max_dosage_per_day_number >= 0) {
          console.log('here')
          this.maxDosage = response.data.max_dosage_per_day_number + ' ' + this.dose_option
        }

        // if(response.data.max_dosage_per_day_number=='')
        // this.maxDosage=undefined

        // if(response.data.max_dosage_per_day_number==0)
        // {

        //   console.log('zero')

        //   this.maxDosage = response.data.max_dosage_per_day_number + ' '+ this.dose_option

        // }


        console.log(response.data.max_duration_in_days)

        if (response.data.max_duration_in_days >= 0) {
          this.maxDuration = response.data.max_duration_in_days + ' ' + 'days'
          console.log('2')
        }

        if (response.data.max_duration_in_days == '') {
          this.maxDuration = undefined

          console.log('3')
        }


        // if(Number(response.data.max_duration_in_days)==0)
        // {
        //   this.maxDuration = response.data.max_duration_in_days + ' '+ 'days'

        //   console.log('4')
        // }

        if (response.duration_exceeded) {
          this.durationWarning = true;
          this.durationMessage = 'The drug can be given only for maximum of ' + String(response.max_duration_in_days) + ' days'
        }
        else {
          this.durationWarning = false;
        }

        if (response.dosage_exceeded) {
          this.doseWarning = true;
          this.doseMessage = 'The max dosage of the drug per day is ' + response.max_dosage_per_day_number + ' ' + this.dose_option
        }
        else {
          this.doseWarning = false;
        }

      }

    });

    console.log(dosageParams)

  }

  ngDoCheck() {

    const change = this.differ.diff(this.data);

    if (change) {

      change.forEachChangedItem(item => {

        if (item.key == 'text') {

          if (this.data.text == 'cancel' || this.data.text == 'close') {
            var obj = {
              type: 2
            }
            this.dialogRef.close(obj);
          }

          else if (this.data.text.toLowerCase() == 'save') {
            this.save1('1')
          }

          else if (this.data.text.toLowerCase() == 'before food') {
            this.when = "Before Food"
          }

          else if (this.data.text.toLowerCase() == 'after food') {
            this.when = "After Food"
          }

          else if (this.data.text.toLowerCase() == 'with food') {
            this.when = "With Food"
          }

          else if (this.data.text.toLowerCase() == 'not related to food') {
            this.when = "Not Related to Food"
          }

          else if (this.data.text.toLowerCase() == 'sos') {
            this.time_block = 'frequency'
            this.frequency_type = 'sos'
          }

          else if (this.data.text.toLowerCase().endsWith('a.m.') || this.data.text.toLowerCase().endsWith('p.m.')) {
            if (this.data.text.toLowerCase() == "1 a.m." || this.data.text.toLowerCase() == "1:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '1:00 AM'
            }

            if (this.data.text.toLowerCase() == "2 a.m." || this.data.text.toLowerCase() == "2:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '2:00 AM'
            }

            if (this.data.text.toLowerCase() == "3 a.m." || this.data.text.toLowerCase() == "3:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '3:00 AM'
            }

            if (this.data.text.toLowerCase() == "4 a.m." || this.data.text.toLowerCase() == "4:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '4:00 AM'
            }

            if (this.data.text.toLowerCase() == "5 a.m." || this.data.text.toLowerCase() == "5:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '5:00 AM'
            }

            if (this.data.text.toLowerCase() == "6 a.m." || this.data.text.toLowerCase() == "6:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '6:00 AM'
            }

            if (this.data.text.toLowerCase() == "7 a.m." || this.data.text.toLowerCase() == "7:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '7:00 AM'
            }

            if (this.data.text.toLowerCase() == "8 a.m." || this.data.text.toLowerCase() == "8:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '8:00 AM'
            }

            if (this.data.text.toLowerCase() == "9 a.m." || this.data.text.toLowerCase() == "9:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '9:00 AM'
            }

            if (this.data.text.toLowerCase() == "10 a.m." || this.data.text.toLowerCase() == "10:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '10:00 AM'
            }

            if (this.data.text.toLowerCase() == "11 a.m." || this.data.text.toLowerCase() == "11:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '11:00 AM'
            }

            if (this.data.text.toLowerCase() == "12 a.m." || this.data.text.toLowerCase() == "12:00 a.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '12:00 AM'
            }

            if (this.data.text.toLowerCase() == "1 p.m." || this.data.text.toLowerCase() == "1:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '1:00 PM'
            }

            if (this.data.text.toLowerCase() == "2 p.m." || this.data.text.toLowerCase() == "2:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '2:00 PM'
            }

            if (this.data.text.toLowerCase() == "3 p.m." || this.data.text.toLowerCase() == "3:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '3:00 PM'
            }

            if (this.data.text.toLowerCase() == "4 p.m." || this.data.text.toLowerCase() == "4:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '4:00 PM'
            }

            if (this.data.text.toLowerCase() == "5 p.m." || this.data.text.toLowerCase() == "5:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '5:00 PM'
            }

            if (this.data.text.toLowerCase() == "6 p.m." || this.data.text.toLowerCase() == "6:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '6:00 PM'
            }

            if (this.data.text.toLowerCase() == "7 p.m." || this.data.text.toLowerCase() == "7:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '7:00 PM'
            }

            if (this.data.text.toLowerCase() == "8 p.m." || this.data.text.toLowerCase() == "8:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '8:00 PM'
            }

            if (this.data.text.toLowerCase() == "9 p.m." || this.data.text.toLowerCase() == "9:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '9:00 PM'
            }

            if (this.data.text.toLowerCase() == "10 p.m." || this.data.text.toLowerCase() == "10:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '10:00 PM'
            }

            if (this.data.text.toLowerCase() == "11 p.m." || this.data.text.toLowerCase() == "11:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '11:00 PM'
            }

            if (this.data.text.toLowerCase() == "12 p.m." || this.data.text.toLowerCase() == "12:00 p.m.") {
              this.time_block = 'frequency'
              this.frequency_type = 'time'
              this.time = '12:00 PM'
            }

          }

          else if (this.data.text.toLowerCase().startsWith('every')) {
            this.time_block = 'frequency'
            this.frequency_type = 'every'

            if (this.data.text.split(' ')[1] == '2' || this.data.text.split(' ')[1] == '4' || this.data.text.split(' ')[1] == '6' || this.data.text.split(' ')[1] == '8')
              this.every_value = this.data.text.split(' ')[1]
          }

          else if (this.data.text.toLowerCase().startsWith('morning') || this.data.text.toLowerCase().startsWith('afternoon') || this.data.text.toLowerCase().startsWith('evening') || this.data.text.toLowerCase().startsWith('night')) {
            this.time_block = 'times'
            this.frequency_type = 'times'

            if (this.data.text.toLowerCase().startsWith('morning') && ((this.data.text.split(' ')[1] == '1') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '3') || (this.data.text.split(' ')[1] == '4') || (this.data.text.split(' ')[1] == '5') || (this.data.text.split(' ')[1] == '6') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '7') || (this.data.text.split(' ')[1] == '8') || (this.data.text.split(' ')[1] == '9'))) {
              this.morning_dose = this.data.text.split(' ')[1]
            }

            if (this.data.text.toLowerCase().startsWith('afternoon') && ((this.data.text.split(' ')[1] == '1') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '3') || (this.data.text.split(' ')[1] == '4') || (this.data.text.split(' ')[1] == '5') || (this.data.text.split(' ')[1] == '6') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '7') || (this.data.text.split(' ')[1] == '8') || (this.data.text.split(' ')[1] == '9'))) {
              this.afternoon_dose = this.data.text.split(' ')[1]
            }

            if (this.data.text.toLowerCase().startsWith('evening') && ((this.data.text.split(' ')[1] == '1') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '3') || (this.data.text.split(' ')[1] == '4') || (this.data.text.split(' ')[1] == '5') || (this.data.text.split(' ')[1] == '6') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '7') || (this.data.text.split(' ')[1] == '8') || (this.data.text.split(' ')[1] == '9'))) {
              this.evening_dose = this.data.text.split(' ')[1]
            }

            if (this.data.text.toLowerCase().startsWith('night') && ((this.data.text.split(' ')[1] == '1') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '3') || (this.data.text.split(' ')[1] == '4') || (this.data.text.split(' ')[1] == '5') || (this.data.text.split(' ')[1] == '6') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '7') || (this.data.text.split(' ')[1] == '8') || (this.data.text.split(' ')[1] == '9'))) {
              this.night_dose = this.data.text.split(' ')[1]
            }
          }

          else if (this.data.text.toLowerCase().startsWith('for')) {
            if ((this.data.text.split(' ')[1] == '1') || (this.data.text.split(' ')[1] == '2') || (this.data.text.split(' ')[1] == '3') || (this.data.text.split(' ')[1] == '4') || (this.data.text.split(' ')[1] == '5') || (this.data.text.split(' ')[1] == '6') || (this.data.text.split(' ')[1] == '7') || (this.data.text.split(' ')[1] == '8') || (this.data.text.split(' ')[1] == '9') || (this.data.text.split(' ')[1] == '10') || (this.data.text.split(' ')[1] == '11') || (this.data.text.split(' ')[1] == '12') || (this.data.text.split(' ')[1] == '13') || (this.data.text.split(' ')[1] == '14') || (this.data.text.split(' ')[1] == '15') || (this.data.text.split(' ')[1] == '16') || (this.data.text.split(' ')[1] == '17') || (this.data.text.split(' ')[1] == '18') || (this.data.text.split(' ')[1] == '19') || (this.data.text.split(' ')[1] == '20') || (this.data.text.split(' ')[1] == '21') || (this.data.text.split(' ')[1] == '22') || (this.data.text.split(' ')[1] == '23') || (this.data.text.split(' ')[1] == '24') || (this.data.text.split(' ')[1] == '25') || (this.data.text.split(' ')[1] == '26') || (this.data.text.split(' ')[1] == '27') || (this.data.text.split(' ')[1] == '28') || (this.data.text.split(' ')[1] == '29') || (this.data.text.split(' ')[1] == '30')) {
              this.duration = this.data.text.split(' ')[1]

              if ((this.data.text.split(' ')[2] == 'day') || (this.data.text.split(' ')[2] == 'days')) {
                this.duration_type = 'Days'
              }

              if ((this.data.text.split(' ')[2] == 'month') || (this.data.text.split(' ')[2] == 'months')) {
                this.duration_type = 'Months'
              }

            }


          }

          else if (this.data.text.toLowerCase() == 'oral') {
            this.route = 'Oral'
          }

          else if (this.data.text.toLowerCase() == 'inhale') {
            this.route = 'Inhale'
          }

          else if (this.data.text.toLowerCase() == 'subcutaneous') {
            this.route = 'Subcutaneous'
          }

          else if (this.data.text.toLowerCase() == 'intravenous') {
            this.route = 'Intravenous'
          }

          else if (this.data.text.toLowerCase() == 'perrectal') {
            this.route = 'Perrectal'
          }

          else if (this.data.text.toLowerCase() == 'topical') {
            this.route = 'Topical'
          }

          else if (this.data.text.toLowerCase() == 'pervaginal') {
            this.route = 'Pervaginal'
          }

          else if (this.data.text.toLowerCase() == 'other') {
            this.route = 'Other'
          }
        }
      });
    }
  }
  changeDrugName(){
    Swal.fire({
      title: "Enter the drug name",
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
      inputValue:this.name,
      showCancelButton: true,
      confirmButtonText: "Save",
    }).then((result)=>{
      if (result.isConfirmed) {
        const userInput = result.value;
        this.name = result.value;

        console.log("User input:", userInput);
      }
    })
  }
  openFormulation() {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_icons2, {
      width: '600px',
      data: { formulation: this.formulation }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formulation = result.formulation
        //  this.create=result.create

        if (this.formulation.trim() == 'Tablet' || this.formulation.trim() == 'Capsule' || this.formulation.trim() == 'Captab' || this.formulation.trim() == 'Chewable Tablet' || this.formulation.trim() == 'Rotacap') {
          this.dose_option = 'milligram'
        }

        if (this.formulation.trim() == 'Drops' || this.formulation.trim() == 'Liquid' || this.formulation.trim() == 'Solution') {
          this.dose_option = 'milliliter'
        }

        if (this.formulation.trim() == 'Ear Drops' || this.formulation.trim() == 'Eye Drops') {
          this.dose_option = 'milliliter'
        }

        if (this.formulation.trim() == 'Expectorant' || this.formulation.trim() == 'Suspension' || this.formulation.trim() == 'Syrup') {
          this.dose_option = 'milliliter'
        }

        if (this.formulation.trim() == 'Ointment' || this.formulation.trim() == 'Gel' || this.formulation.trim() == 'Paste' || this.formulation.trim() == 'Soap' || this.formulation.trim() == 'Dusting Powder' || this.formulation.trim() == 'Tooth Paste') {
          this.dose_option = 'gram'
        }

        if (this.formulation.trim() == 'Granules' || this.formulation.trim() == 'Granule' || this.formulation.trim() == 'Sachet') {
          this.dose_option = 'gram'
        }

        if (this.formulation.trim() == 'Lotion' || this.formulation.trim() == 'Cream') {
          this.dose_option = 'gram'
        }

        if (this.formulation.trim() == 'Nasal Drops' || this.formulation.trim() == 'Nasal Spray') {
          this.dose_option = 'milligram'
        }

        if (this.formulation.trim() == 'Shampoo') {
          this.dose_option = 'milliliter'
        }

        if (this.formulation.trim() != this.formulation1.trim()) {
          const dialogRef = this.dialog.open(DialogOverviewExampleDialog_createpopup, {
            width: '600px',
            data: {}
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.create = result
            }
            else {
              this.create = false
            }

          });
        }


      }
    });
  }
getMasterSettings(){
  var params={
  
    account_email : this.dmail,

    doctor_id : this.doc_id

}

this.appService.getData(this.urlPoints.getMasterSettings, params, this.data.token).subscribe((masterData: any) =>{

  console.log("masterData::",masterData)
  this.prescription_mode = masterData.data[0].prescription_mode
  if(this.prescription_mode){
    this.getSavePrescription();
  }

})
}
  remove(i) {
    sessionStorage.setItem('removeindex', i)

    this.onRemove.emit();
  }

  ngAfterViewInit() {

  }

  everyChange() {
    this.frequency_type = 'every'
  }

  activateStrength() {
    this.strengthActive = true;
  }

  onNoClick(): void {

    var obj = {
      type: 4
    }

    this.dialogRef.close();

  }

  changeDurationType() {
    if (this.duration_type == 'Days') {
      this.duration_type = 'Months'
    }
    else {
      this.duration_type = 'Days'
    }

    this.calculate()

    this.calculateDose()
  }

  durationInput() {
    this.duration

    this.calculateDose()
  }

  setKeyboard(event) {
    if (event != 'Backspace') {
      this.duration = this.duration + event
    }
    else {
      this.duration = this.duration.substring(0, this.duration.length - 1);
    }

  }

  openTime() {
    setTimeout(() => {
      this.timeInput.nativeElement.click();
    }, 200);
  }

  mouseEnter1(trigger) {

    if (this.timedOutCloser1) {
      clearTimeout(this.timedOutCloser1);
    }
    trigger.openMenu();
  }

  mouseLeave1(trigger) {

    this.timedOutCloser1 = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  mouseEnter2(trigger) {

    if (this.timedOutCloser2) {
      clearTimeout(this.timedOutCloser2);
    }
    trigger.openMenu();
  }

  mouseLeave2(trigger) {

    this.timedOutCloser2 = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  mouseEnter3(trigger) {
    if (this.timedOutCloser3) {
      clearTimeout(this.timedOutCloser3);
    }
    trigger.openMenu();
  }

  mouseLeave3(trigger) {

    this.timedOutCloser3 = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  mouseEnter7(trigger) {
    if (this.timedOutCloser7) {
      clearTimeout(this.timedOutCloser7);
    }
    trigger.openMenu();
  }

  mouseLeave7(trigger) {
    this.timedOutCloser7 = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  mouseEnter8(trigger) {
    if (this.timedOutCloser8) {
      clearTimeout(this.timedOutCloser8);
    }
    trigger.openMenu();
  }

  mouseLeave8(trigger) {
    this.timedOutCloser8 = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  mouseEnter10(trigger) {
    if (this.timedOutCloser10) {
      clearTimeout(this.timedOutCloser10);
    }
    trigger.openMenu();
  }

  mouseLeave10(trigger) {
    this.timedOutCloser10 = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  mouseEnter4(trigger) {
    if (this.timedOutCloser4) {
      clearTimeout(this.timedOutCloser4);
    }
    trigger.openMenu();
  }

  mouseLeave4(trigger) {
    this.timedOutCloser4 = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  setFreq(i) {
    this.frequency = i

    this.morning = false
    this.afternoon = false
    this.evening = false
    this.night = false

    this.morning_dose = ''
    this.afternoon_dose = ''
    this.evening_dose = ''
    this.night_dose = ''

    this.count = 0

    if (i == '1 time a day') {
      this.maxcount = 1
    }

    else if (i == '2 times a day') {
      this.maxcount = 2
    }

    else if (i == '3 times a day') {
      this.maxcount = 3
    }

    else if (i == '4 times a day') {

      this.morning = true
      this.afternoon = true
      this.evening = true
      this.night = true

      if (!this.morning_dose)
        this.morning_dose = 1

      if (!this.afternoon_dose)
        this.afternoon_dose = 1

      if (!this.evening_dose)
        this.evening_dose = 1

      if (!this.night_dose)
        this.night_dose = 1

      this.getCount()

      this.maxcount = 4
    }

    else {
      this.maxcount = 0
    }

    this.calculate()
  }

  getMaxCount(i) {
    if (i == '1 time a day') {
      this.maxcount = 1
    }

    else if (i == '2 times a day') {
      this.maxcount = 2
    }

    else if (i == '3 times a day') {
      this.maxcount = 3
    }

    else if (i == '4 times a day') {
      this.maxcount = 4
    }

    else {
      this.maxcount = 0
    }
  }

  getCount() {
    this.count = 0;

    if (this.morning)
      this.count++

    if (this.afternoon)
      this.count++

    if (this.evening)
      this.count++

    if (this.night)
      this.count++

  }

  setWhen(i) {
    this.when = i
  }

  setRoute(i) {
    this.route = i
  }

  setDose(i) {
    this.dose_option = i;
  }

  setFormulation(i) {
    this.formulation = i;
  }

  setDoseOption(i) {

    this.dose_option = i

    if (this.morning && (this.dose_option == 'tab' || this.dose_option == 'cap' || this.dose_option == 'nos')) {
      this.morning_dose = 1
    }

    if (this.afternoon && (this.dose_option == 'tab' || this.dose_option == 'cap' || this.dose_option == 'nos')) {
      this.afternoon_dose = 1
    }

    if (this.evening && (this.dose_option == 'tab' || this.dose_option == 'cap' || this.dose_option == 'nos')) {
      this.evening_dose = 1
    }

    if (this.night && (this.dose_option == 'tab' || this.dose_option == 'cap' || this.dose_option == 'nos')) {
      this.night_dose = 1
    }

  }

  test() {
  }

  minusDose() {
    if (this.dose != 1)
      this.dose--;
    this.calculate()
  }

  setMorningDose(i) {
    this.morning_dose = i

  }

  setAfternoonDose(i) {
    this.afternoon_dose = i

  }

  setEveningDose(i) {
    this.evening_dose = i

  }

  setNightDose(i) {
    this.night_dose = i

  }

  plusDose() {
    if (this.dose != 99)
      this.dose++;
    this.calculate()

  }

  minusDays() {
    if (this.duration != 1)
      this.duration--;
    this.calculate()
    this.calculateDose()

  }

  plusDays() {
    if (this.duration != 99)
      this.duration++;
    this.calculate()
    this.calculateDose()
  }

  quanMinus() {
    if (this.freq_quantity != 1)
      this.freq_quantity--;
    this.calculate()
  }

  quanPlus() {
    if (this.freq_quantity != 99)
      this.freq_quantity++;
    this.calculate()
  }

  plusMorningDose() {

    this.frequency_type = 'times'

    if (this.morning_dose > 0) {
      this.morning_dose = Number(this.morning_dose)
      this.morning_dose++
      this.morning_dose = Math.floor(this.morning_dose)

    }
    else if (this.morning_dose == 0) {
      this.morning_dose = Number(this.morning_dose)

      this.morning_dose = this.morning_dose + 0.5
    }

    this.calculateDose()

  }

  plusMorningDose1() {

    this.frequency_type = 'times'

    this.morning_dose = Number(this.morning_dose)
    this.morning_dose = this.morning_dose + 0.1
    this.morning_dose = this.morning_dose.toFixed(1)

    this.calculateDose()

  }

  minusMorningDose() {
    if (this.morning_dose > 0 && this.morning_dose != 0.5 && this.morning_dose != 1) {
      this.morning_dose = Number(this.morning_dose)

      this.morning_dose--;
      this.morning_dose = Math.ceil(this.morning_dose)
    }
    else if (this.morning_dose == 1) {
      this.morning_dose = Number(this.morning_dose)
      this.morning_dose = 0.5
    }
    else if (this.morning_dose == 0.5) {
      this.morning_dose = Number(this.morning_dose)
      this.morning_dose = 0
    }


    this.frequency_type = 'times'

    this.calculateDose()

  }

  minusMorningDose1() {

    if (this.morning_dose > 0) {
      this.morning_dose = Number(this.morning_dose)

      this.morning_dose = this.morning_dose - 0.1;
    }

    this.morning_dose = this.morning_dose.toFixed(1)


    this.frequency_type = 'times'

    this.calculateDose()

  }

  plusAfterNoonDose() {
    this.frequency_type = 'times'

    if (this.afternoon_dose > 0) {
      this.afternoon_dose = Number(this.afternoon_dose)

      this.afternoon_dose++
      this.afternoon_dose = Math.floor(this.afternoon_dose)

    }
    else if (this.afternoon_dose == 0) {
      this.afternoon_dose = Number(this.afternoon_dose)

      this.afternoon_dose = this.afternoon_dose + 0.5
    }

    this.calculateDose()

  }

  plusAfterNoonDose1() {
    this.frequency_type = 'times'

    this.afternoon_dose = Number(this.afternoon_dose)
    this.afternoon_dose = this.afternoon_dose + 0.1


    this.afternoon_dose = this.afternoon_dose.toFixed(1)

    this.calculateDose()

  }

  minusAfterNoonDose() {
    if (this.afternoon_dose > 0 && this.afternoon_dose != 0.5 && this.afternoon_dose != 1) {
      this.afternoon_dose = Number(this.afternoon_dose)

      this.afternoon_dose--;
      this.afternoon_dose = Math.ceil(this.afternoon_dose)
    }
    else if (this.afternoon_dose == 1) {
      this.afternoon_dose = Number(this.afternoon_dose)

      this.afternoon_dose = 0.5
    }
    else if (this.afternoon_dose == 0.5) {
      this.afternoon_dose = Number(this.afternoon_dose)

      this.afternoon_dose = 0
    }

    this.calculateDose()


  }

  minusAfterNoonDose1() {

    if (this.afternoon_dose > 0) {
      this.afternoon_dose = Number(this.afternoon_dose)

      this.afternoon_dose = this.afternoon_dose - 0.1;
    }

    this.afternoon_dose = this.afternoon_dose.toFixed(1)


    this.frequency_type = 'times'

    this.calculateDose()


  }

  plusEveningDose() {
    this.frequency_type = 'times'

    if (this.evening_dose > 0) {
      this.evening_dose = Number(this.evening_dose)

      this.evening_dose++
      this.evening_dose = Math.floor(this.evening_dose)

    }
    else if (this.evening_dose == 0) {
      this.evening_dose = Number(this.evening_dose)

      this.evening_dose = this.evening_dose + 0.5
    }

    this.calculateDose()

  }

  plusEveningDose1() {
    this.frequency_type = 'times'

    this.evening_dose = Number(this.evening_dose)
    this.evening_dose = this.evening_dose + 0.1

    this.evening_dose = this.evening_dose.toFixed(1)

    this.calculateDose()

  }

  minusEveningDose() {
    if (this.evening_dose > 0 && this.evening_dose != 0.5 && this.evening_dose != 1) {
      this.evening_dose = Number(this.evening_dose)

      this.evening_dose--;
      this.evening_dose = Math.ceil(this.evening_dose)
    }
    else if (this.evening_dose == 1) {
      this.evening_dose = Number(this.evening_dose)

      this.evening_dose = 0.5
    }
    else if (this.evening_dose == 0.5) {
      this.evening_dose = Number(this.evening_dose)

      this.evening_dose = 0
    }

    this.calculateDose()

  }

  minusEveningDose1() {

    if (this.evening_dose > 0) {
      this.evening_dose = Number(this.evening_dose)

      this.evening_dose = this.evening_dose - 0.1;
    }

    this.evening_dose = this.evening_dose.toFixed(1)


    this.frequency_type = 'times'

    this.calculateDose()


  }

  plusNightDose() {
    this.frequency_type = 'times'

    if (this.night_dose > 0) {
      this.night_dose = Number(this.night_dose)

      this.night_dose++
      this.night_dose = Math.floor(this.night_dose)

    }
    else if (this.night_dose == 0) {
      this.night_dose = Number(this.night_dose)

      this.night_dose = this.night_dose + 0.5
    }

    this.calculateDose()


  }

  plusNightDose1() {
    this.frequency_type = 'times'

    this.night_dose = Number(this.night_dose)
    this.night_dose = this.night_dose + 0.1

    this.night_dose = this.night_dose.toFixed(1)

    this.calculateDose()


  }

  minusNightDose() {
    if (this.night_dose > 0 && this.night_dose != 0.5 && this.night_dose != 1) {
      this.night_dose = Number(this.night_dose)

      this.night_dose--;
      this.night_dose = Math.ceil(this.night_dose)
    }
    else if (this.night_dose == 1) {
      this.night_dose = Number(this.night_dose)

      this.night_dose = 0.5
    }
    else if (this.night_dose == 0.5) {
      this.night_dose = Number(this.night_dose)

      this.night_dose = 0
    }

    this.calculateDose()


  }

  minusNightDose1() {

    if (this.night_dose > 0) {
      this.night_dose = Number(this.night_dose)

      this.night_dose = this.night_dose - 0.1;
    }

    this.night_dose = this.night_dose.toFixed(1)


    this.frequency_type = 'times'

    this.calculateDose()


  }

  calculateDose() {
    var total = Number(this.morning_dose) + Number(this.afternoon_dose) + Number(this.evening_dose) + Number(this.night_dose)



    var duration = this.duration

    if (this.duration_type == 'Months')
      duration = duration * 30

    var dosageParams = {
      composition_id: this.data.obj.composition_id,
      category: this.data.obj.category,
      p_wt: this.data.weight ? String(this.data.weight) : '',
      p_age: this.data.age != undefined ? String(this.data.age) : '',
      UOM: this.dose_option,
      account_email: this.dmail,
      quantity: Number(total),
      duration: Number(duration)

    }

    console.log(dosageParams)

    this.appService.postData(this.urlPoints.getDosage, dosageParams, this.data.token).subscribe((response: any) => {
      console.log(response)

      if (response.status == 0) {
        this.warning = true

        if (response.message == 'patient_weight_&_age_needed') {
          this.weightWarning = true
        }
      }
      else {
        this.warning = false
        this.weightWarning = false

        if (response.data.duration_exceeded == true) {
          this.durationWarning = true;
          if (response.data.source) {
            this.url = response.data.source
          }
          this.durationMessage = 'The drug can be given only for maximum of ' + String(response.max_duration_in_days) + ' days'
        }
        else {
          this.durationWarning = false;
        }

        if (response.data.dosage_exceeded == true) {
          this.doseWarning = true;

          if (response.data.source) {
            this.url = response.data.source
          }

          this.doseMessage = 'The max dosage of the drug per day is ' + response.max_dosage_per_day_number + ' ' + this.dose_option
        }
        else {
          this.doseWarning = false;
        }

        // if(response.data.max_dosage_per_day_number==0)
        // {
        //   this.doseWarning = true;
        //   this.doseMessage = 'This drug can not be prescribed to patient of this age'
        // }

        console.log(this.durationWarning)
        console.log(this.doseWarning)

      }
    });
  }

  openUrl() {
    window.open(this.url)
  }

  changeToTimes() {
    this.frequency_type = 'times'
  }

  changeToEvery() {
    this.frequency_type = 'every'
  }

  changeFreqType(i) {
    this.frequency_type = i
  }

  radioChange() {
    if (this.time_block == 'times') {
      this.frequency_type = 'times'
    }
    else {
      this.frequency_type = 'every'
    }
  }

  calculate() {
    var total;

    if (this.frequency.startsWith('Every 2 hours')) {
      this.quantity = Number(this.duration) * 12 * Number(this.freq_quantity)
    }

    else if (this.frequency.startsWith('Every 4 hours')) {
      this.quantity = Number(this.duration) * 6 * Number(this.freq_quantity)
    }

    else if (this.frequency.startsWith('Every 6 hours')) {
      this.quantity = Number(this.duration) * 4 * Number(this.freq_quantity)
    }

    else if (this.frequency.startsWith('Every 8 hours')) {
      this.quantity = Number(this.duration) * 3 * Number(this.freq_quantity)
    }

    else if (this.frequency.startsWith('Everyday')) {
      this.quantity = Number(this.duration) * Number(this.freq_quantity)
    }

    else if (this.frequency.startsWith('S.O.S')) {
      this.quantity = Number(this.duration) * Number(this.freq_quantity)
    }

    else if (this.frequency_type == 'times') {
      this.quantity = (Number(this.morning_dose ? this.morning_dose : 0) + Number(this.afternoon_dose ? this.afternoon_dose : 0) + Number(this.evening_dose ? this.evening_dose : 0) + Number(this.night_dose ? this.night_dose : 0)) * Number(this.duration)
    }

    if (this.duration_type == 'Months') {
      this.quantity = this.quantity * 30;
    }

  }

  calculate1(duration) {
    this.duration_type = duration

    if (duration == 'Days')
      this.quantity = Number(this.dose) * Number(this.duration)

    if (duration == 'Weeks')
      this.quantity = Number(this.dose) * Number(this.duration) * 7

    if (duration == 'Months')
      this.quantity = Number(this.dose) * Number(this.duration) * 30
  }
getSavePrescription(){
  var param ={
    account_email : this.dmail,
    "drug_id": this.host.id,
  }
  this.appService.getData(this.urlPoints.getprescriptiondosage, param, this.data.token).subscribe((res: any) =>{
console.log("resp>>>>",res)
if(res.status == 1){
  let data = res.message[0];
  this.when = data.when;
  this.morning_dose = data.morning_dosage;
  this.afternoon_dose = data.afternoon_dosage;
  this.evening_dose = data.evening_dosage;
  this.night_dose = data.night_dosage;
  this.route = data.route;
  this.special_instruction = data.instructions;
  this.duration = data.duration;
  this.dose = data.strength;
  this.time = data.time;
  this.frequency_type = data.sos == true ? 'sos' : 'times';
  this.every_value = data.hours_interval;
  this.freq_quantity = data.quantity;
  this.dose_option = data.unit;
  this.time_block = data.medicine_mode;
}

  });
}
savePrescription(){
  // here>>>
  console.log("this.host>>>",this.host)
  var param={ 
    account_email : this.dmail,
    doctor_id : this.doc_id,
    "drug_id": this.host.id,

    "composition_id": this.host.composition_id, 

    "when": this.when || '', 

    "morning_dosage": this.morning_dose || '', 

    "afternoon_dosage": this.afternoon_dose ||'', 

    "evening_dosage": this.evening_dose || '', 

    "night_dosage": this.night_dose || '', 

    "route": this.route || '', 

    "instructions": this.special_instruction || '', 

    "duration": this.duration || '', 

    "strength": this.dose || '', 

    "time": this.time || '', 

    "sos": this.frequency_type == 'sos' ? true: false, 

    "hours_interval": this.every_value || '', 

    "quantity": this.freq_quantity || '', 

    "unit": this.dose_option ||'', 

    "medicine_mode": this.time_block||''

} 
  this.appService.postData(this.urlPoints.saveprescriptiondosage, param, this.data.token).subscribe((response: any) => {
    console.log("res::",response)
  });
}


  save1(type) {
    this.prescription_mode && this.savePrescription();
    var name = this.name;
    var frequency = this.frequency;
    var when = this.when != 'Time' ? this.when : this.when + " : " + this.time;
    var dose = this.dose;
    var dose_option = dose ? this.dose_option : ''
    var duration = this.duration ? this.duration.toString() : '0';
    var duration_type = this.duration_type;
    var formulation = this.formulation;
    var minimum_buyable_qty = this.minimum_buyable_qty;
    var route = this.route;
    var quantity = this.quantity
    var strength = this.strength;
    var strength_unit = this.strength_unit;
    var getStockStatus = this.getStockStatus;
    var generic = this.generic;
    var special_instruction = this.special_instruction;
    var create = this.create

    var freq_string = '';

    var arr = []

    if (this.frequency_type == 'times') {

      frequency = ''

      arr.push(this.morning_dose ? this.morning_dose.toString() : '0')

      arr.push(this.afternoon_dose ? this.afternoon_dose.toString() : '0')

      arr.push(this.evening_dose ? this.evening_dose.toString() : '0')

      arr.push(this.night_dose ? this.night_dose.toString() : '0')

      freq_string = arr.join(' - ')

      frequency = freq_string
      this.frequency = frequency
    }

    else if (this.frequency_type == 'every') {
      frequency = 'Every ' + this.every_value + ' hours'
      this.frequency = frequency

      this.frequency = this.frequency + ' - ' + this.freq_quantity
      frequency = this.frequency

    }

    if (this.frequency_type == 'time') {
      this.frequency = 'Everyday ' + this.time + ' - ' + this.freq_quantity
      frequency = this.frequency
    }

    if (this.frequency_type == 'sos') {
      this.frequency = 'S.O.S' + ' - ' + this.freq_quantity
      frequency = this.frequency
    }

    this.calculate()

    var add = '';

    var shortFreq = ''

    if (this.dose_option == 'Syrup') {
      add = 'milliliter'
    }
    else if (this.dose_option == 'Drops') {
      add = 'drops'
    }
    else {
      add = this.dose_option
    }

    if (this.formulation.trim() == 'Tablet') {
      add = 'Tablet'
    }

    var details: any = {
      id: this.id,
      brand: name,
      frequency: frequency,
      when: when,
      dose: dose,
      dose_option: dose_option,
      create: create,
      duration: duration.toString(),
      duration_type: duration_type,
      formulation: formulation,
      generic: generic,
      getStockStatus : this.getStockStatus,
      minimum_buyable_qty: minimum_buyable_qty,
      route: route,
      quantity: this.quantity + ' ' + add,
      strength: strength,
      strength_unit: strength_unit,
      special_instruction: special_instruction,
      type: type,
      freq_string: freq_string ? freq_string : '',
    }

    if (this.data.addPres) {
      details.addPres = this.addPres
    }

    this.dialogRef.close(details);

  }

  set(block) {
    this.show_block = block
  }

  morningChange() {
    if (this.morning && !this.morning_dose) {
      this.morning_dose = 1
    }
  }

  afternoonChange() {
    if (this.afternoon && !this.afternoon_dose) {
      this.afternoon_dose = 1
    }
  }

  eveningChange() {
    if (this.evening && !this.evening_dose) {
      this.evening_dose = 1
    }
  }

  nightChange() {
    if (this.night && !this.night_dose) {
      this.night_dose = 1
    }
  }
  callMasterSettings(){

    var params={
  
      account_email : this.dmail,
  
      doctor_id : this.doc_id
  
  }
  
  this.appService.getData(this.urlPoints.getMasterSettings, params, this.data.token).subscribe((masterData: any) =>{
  
    console.log("masterData::",masterData)
    this.prescription_mode = masterData.data[0].prescription_mode
  
  })
  
  }
  openDialog() {
    var params={
  
      account_email : this.dmail,
  
      doctor_id : this.doc_id
  
  }

    var value;
    this.appService.getData(this.urlPoints.getMasterSettings, params, this.data.token).subscribe((masterData: any) =>{
  
      console.log("masterData::",masterData)
      this.prescription_mode = masterData.data[0].prescription_mode
    
 
   if(this.prescription_mode){
    // for srinivas doc
      if (this.route == 'Oral')
      value = 0

    if (this.route == 'Inhale')
      value = 32.7

    if (this.route == 'Subcutaneous')
      value = 65.4

    if (this.route == 'Intravenous')
      value = 98.1

    if (this.route == 'Perrectal')
      value = 130.8

    if (this.route == 'Topical')
      value = 163.5

    if (this.route == 'Pervaginal')
      value = 196.2

    if (this.route == 'Other')
      value = 228.9
    if (this.route == 'Sublingual')
      value = 261.6
    if (this.route == 'Over the tongue')
      value = 294.3
    if (this.route == '-')
      value = 327
    }else{
      if (this.route == 'Oral')
      value = 0

    if (this.route == 'Inhale')
      value = 45

    if (this.route == 'Subcutaneous')
      value = 90

    if (this.route == 'Intravenous')
      value = 135

    if (this.route == 'Perrectal')
      value = 180

    if (this.route == 'Topical')
      value = 225

    if (this.route == 'Pervaginal')
      value = 270

    if (this.route == 'Other')
      value = 315

    }


    sessionStorage.setItem("slidervalue", value)
    if (!this.popupOpen) {
      this.popupOpen = true
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogSlider, {
        width: 'fit-content',
        data: { value: value,mode: this.prescription_mode},

      });

      dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false
        if (result) {
          this.slider_value = result.value

          
if(this.prescription_mode){
  // only for srinivas doc
     if (result.value == 0)
        this.route = 'Oral'

    if (result.value == 32.7)
      this.route = 'Inhale'

    if (result.value == 65.4)
      this.route = 'Subcutaneous'

    if (result.value == 98.1)
      this.route = 'Intravenous'

    if (result.value == 130.8)
      this.route = 'Perrectal'

    if (result.value == 163.5)
      this.route = 'Topical'

    if (result.value == 196.2)
      this.route = 'Pervaginal'

    if (result.value == 228.9)
    this.route = 'Other'
      
    if (result.value == 261.6)
    this.route = 'Sublingual'
      
    if (result.value == 294.3)
    this.route = 'Over the tongue'
   
    if (result.value == 327)
      this.route = '-'

        }else{
          // not srinivas
          if (result.value == 0) {
            this.route = 'Oral'
          }

          if (result.value == 45) {
            this.route = 'Inhale'
          }

          if (result.value == 90) {
            this.route = 'Subcutaneous'
          }

          if (result.value == 135) {
            this.route = 'Intravenous'
          }

          if (result.value == 180) {
            this.route = 'Perrectal'
          }

          if (result.value == 225) {
            this.route = 'Topical'
          }

          if (result.value == 270) {
            this.route = 'Pervaginal'
          }

          if (result.value == 315) {
            this.route = 'Other'
          }
        }
        }
      });
    }
  })
  }

  openSlider2() {
    var value;
if(this.prescription_mode){

    // only for srinivas
      if (this.dose_option == 'Sachets/Packets')
        value = 0

      if (this.dose_option == 'milliliter')
        value = 36

      if (this.dose_option == '-')
        value = 72

    if (this.dose_option == 'microgram')
      value = 108

    if (this.dose_option == 'milligram')
      value = 144

    if (this.dose_option == 'gram')
      value = 180

    if (this.dose_option == 'mole')
      value = 216

    if (this.dose_option == 'millimole')
      value = 252

    if (this.dose_option == 'Syrup')
      value = 288

    if (this.dose_option == 'Drops')
      value = 324



}else{
  if (this.dose_option == 'milliliter')
      value = 50

    if (this.dose_option == 'microgram')
      value = 90

    if (this.dose_option == 'milligram')
      value = 130

    if (this.dose_option == 'gram')
      value = 170

    if (this.dose_option == 'mole')
      value = 210

    if (this.dose_option == 'millimole')
      value = 250

    if (this.dose_option == 'Syrup')
      value = 290

    if (this.dose_option == 'Drops')
      value = 330

    if (this.dose_option == 'Sachets/Packets')
      value = 10

}   
    sessionStorage.setItem("slidervalue2", value)

    if (!this.popupOpen) {
      this.popupOpen = true
      sessionStorage.setItem("status", this.prescription_mode)
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogSlider2, {
        width: 'fit-content',

        data: { value: value},
      });
      dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false

        if (this.prescription_mode && result) {
          this.slider_value2 = result.value

          if (result.value == 36) {
            this.dose_option = 'milliliter'
          }

          if (result.value == 108) {
            this.dose_option = 'microgram'
          }

          if (result.value == 144) {
            this.dose_option = 'milligram'
          }

          if (result.value == 180) {
            this.dose_option = 'gram'
          }

          if (result.value == 216) {
            this.dose_option = 'mole'
          }

          if (result.value == 252) {
            this.dose_option = 'millimole'
          }

          if (result.value == 288) {
            this.dose_option = 'Syrup'
          }

          if (result.value == 324) {
            this.dose_option = 'Drops'
          }

          if (result.value == 0) {
            this.dose_option = 'Sachets/Packets'
          }
          if (result.value == 72) {
            this.dose_option = '-'
          }

        }else{
          if (result.value == 50) {
            this.dose_option = 'milliliter'
          }

          if (result.value == 90) {
            this.dose_option = 'microgram'
          }

          if (result.value == 130) {
            this.dose_option = 'milligram'
          }

          if (result.value == 170) {
            this.dose_option = 'gram'
          }

          if (result.value == 210) {
            this.dose_option = 'mole'
          }

          if (result.value == 250) {
            this.dose_option = 'millimole'
          }

          if (result.value == 290) {
            this.dose_option = 'Syrup'
          }

          if (result.value == 330) {
            this.dose_option = 'Drops'
          }

          if (result.value == 10) {
            this.dose_option = 'Sachets/Packets'
          }

        }
      });
    }
  }


  openSlider3() {
this.callMasterSettings();
var params={
  
  account_email : this.dmail,

  doctor_id : this.doc_id

}

this.appService.getData(this.urlPoints.getMasterSettings, params, this.data.token).subscribe((masterData: any) =>{

console.log("masterData::",masterData)
var prescription_mode = masterData.data[0].prescription_mode

    var value;
if(prescription_mode){
 // for srini
 if (this.when == 'Before Food')
 value = 0

if (this.when == 'After Food')
 value = 72

if (this.when == 'Not Related to Food')
 value = 144

if (this.when == 'With Food')
 value = 216

if (this.when == '-')
 value = 328

}else{
  
  if (this.when == 'Before Food')
  value = 315

if (this.when == 'After Food')
  value = 45

if (this.when == 'Not Related to Food')
  value = 135

if (this.when == 'With Food')
  value = 225
}


    sessionStorage.setItem("slidervalue3", value)
    if (!this.popupOpen) {
      this.popupOpen = true
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogSlider3, {
        width: 'fit-content',
        data: { value: value, mode:prescription_mode },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false

        if (result) {
          this.slider_value3 = result.value
if(prescription_mode){
  // only for srini
 if (result.value == 72) {
  this.when = 'After Food'
}

if (result.value == 144) {
  this.when = 'Not Related to Food'
}

if (result.value == 216) {
  this.when = 'With Food'
}

if (result.value == 0) {
  this.when = 'Before Food'
}
if (result.value == 288) {
  this.when = '-'
}
}else{
          if (result.value == 45) {
            this.when = 'After Food'
          }

          if (result.value == 135) {
            this.when = 'Not Related to Food'
          }

          if (result.value == 225) {
            this.when = 'With Food'
          }

          if (result.value == 315) {
            this.when = 'Before Food'
          }

        }
        }
      });
    }
  })
  }
}

@Component({
  selector: 'notifiyvideocall',
  templateUrl: 'notifyvideocall.html',
  styleUrls: ['notifyvideocall.scss']
})

export class DialogOverviewExampleDialog_notifyvideocall {
  urlPoints;
  getauthdetails;
  dmail;
  doc_id;
  token;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_notifyvideocall>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_notifyvideocall, public router: Router, private appService: AppService, private toastr: ToastrService,) {

    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
  sendNotifyCall() {
    var data = {
      "account_email": this.dmail,
      "patient_email": this.data.notify_details.email,
      "a_type": this.data.notify_details.type,
      "a_id": this.data.notify_details.id,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.notifybyvideoCall, data, this.token).subscribe((response: any) => {
      this.toastr.success(response.message, '', {
        timeOut: 4500,
      });
      this.close();
    });
  }

  sendNotifyVoiceCall() {
    var data = {
      "account_email": this.dmail,
      "patient_email": this.data.notify_details.email,
      "a_id": this.data.notify_details.id,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.notifybyvoiceCall, data, this.token).subscribe((response: any) => {
      this.toastr.success(response.message, '', {
        timeOut: 4500,
      });
      this.close();
    });
  }
}

//vaccinationwindow popover starts here

@Component({
  selector: 'vaccinationwindow',
  templateUrl: 'submenus/vaccinationwindow.html',
  styleUrls: ['submenus/vaccinationwindow.scss']
})

export class DialogOverviewExampleDialog_vaccinationwindow {


  accountemail;
  patientemail;
  patientdob;
  patientgender;
  //  = "1998-05-13";
  token = "b2F1dGhfdG9rZW49aWJrOEpYUXJUbVgzbk9ra2tIb3gmb2F1dGhfdG9rZW5fc2VjcmV0PU1RQnFOenJ3MGNZQzFPZ0huWmNmJmFjY291bnRfaWQ9cng0JTQwcnhjYXJlbmV0Lm9yZw==";
  imageForm;
  count1 = [];
  urlPoints;
  getapi;
  vaccinelist;
  progress_bar = true;
  Reschedule;

  agegroup: any = [];
  agedate: any = [];
  ageinmonths;
  agestatus: any = [];
  agechild: any = [];
  subchild: any = [];
  givenvac: any = [];
  brandlist: any = [];
  batchimage: any = [];
  subvac: any = [];
  closesidebar = false;
  drugname;
  url;
  brand = false;
  branddata: any = [];
  selectedvaccine;
  // minDate = moment().subtract(1, 'year')
  minDate: Date;

  sub;
  vaccineparams;
  brandparams;
  mybrand: any = [];
  dependencyexists;

  uploadedimg;
  progress: any = 0;
  patientheader;
  groupVaccine;
  vacccinedetail: any = [];
  hidepatientheader = false;
  datepick = false;
  brand_name;
  dependency;
  imgenvironment = environment.HOST
  loading = false
  editDate;

  carddeffer;
  cardgiven;
  cardgivenbyother;
  givenid;

  call_pending;
  did;
  hospital;
  id;
  mode;
  patientdata;
  age;
  check;
  verticalarray: any = [[0, 1], [2], [3], [4, 5], [6, 7, 8], [9, 10, 11, 12, 13, 14], [15, 16, 17, 18], [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48], [49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71], [72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120], [121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131], [132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168], [169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179], [180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216]]

  openrescheduleddate;
  batch_image;
  // showtext_field = false;
  reschedules = false;

  mymodel = false;
  mymodel_subvaccine = []
  imagegivensubvaccine_text: any = []

  composite = true;
  hideall = true;
  showdeffer = false;
  groupvaccine: any = [];

  subvaccines: any = [];
  sub_vaccines: any = [];

  deferreddate = false;
  todaydate = new Date();

  currentvaccine
  imageForm2
  vacimg;
  givenvacimg;
  duevacimg;
  category;
  adherence;
  hideaherence = true
  imageandcomment;
  showimageupload = false;
  showimageupload_subvaccine = false
  my_brand;
  serializedDate;

  reschedulevaccine;
  textForm;
  image_Form;

  imagegiven = false;
  textselectbrand = false;
  showcheckbox;
  showcheckboxdeffer;

  batchimageshow = false;
  subvacsno: any = [];

  actualimage;
  maxDate;
  maximumDate = moment(new Date()).format('YYYY-MM-DD');
  duedate;

  showdeferreddata = false;

  givenSaved = false

  apt_id = sessionStorage.getItem("apt_id")

  weekendsDatesFilter = (d: Date): boolean => {
    const day = d.getDay();

    /* Prevent Saturday and Sunday for select. */
    return day !== 0;
  }
  all_subvaccine_data: any = []
  mysubvaccinebrands: any = []
  currentStep: any = []
  url_subvaccine: any = []
  uploadedimg_subvaccine: any = []


  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_vaccinationwindow>, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_vaccinationdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService, private spinner: NgxSpinnerService, public dialog: MatDialog, private dom: DomSanitizer, public printService: PrintService, public service: VoiceRecognitionService, private differs: KeyValueDiffers,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.patientdob = data.vaccineDetails.patientdob
    this.patientemail = data.vaccineDetails.patientemail
    this.token = data.vaccineDetails.token;
    this.accountemail = data.vaccineDetails.dmail
    this.did = data.vaccineDetails.did

    this.id = data.vaccineDetails.id;
    this.mode = data.vaccineDetails.mode

    this.minDate = new Date();
    this.maxDate = new Date();

    var date = new FormControl(new Date());
    this.serializedDate = new FormControl((new Date()).toISOString());

    this.image_Form = this.fb.group({
      imagegivendate: ["", [Validators.required]],
      imagegiven: [""],

    })

    this.textForm = this.fb.group({
      textgivendate: ["", [Validators.required]],
      texthere: ["", [Validators.required]],

    })


    this.imageForm = this.fb.group({
      // image: ["", [Validators.required]],
      selecteddate: ["", []],
      my_brand: ["", []]
    })

    // this.imageForm.controls['image'].setValue("");
    // this.imageForm.controls['selecteddate'].setValue("");

    this.imageForm2 = this.fb.group({
      texthere: ["", []],
      selecteddate2: ["", []]
    })


    this.reschedulevaccine = this.fb.group({
      reschedulevaccinedate: ["", [Validators.required]]
    })

    // this.imageForm2.controls['texthere'].setValue("");
    // this.imageForm2.controls['selecteddate2'].setValue("");

    var patient_data = sessionStorage.getItem("patientprofile");
    this.patientdata = JSON.parse(patient_data)
    this.age = sessionStorage.getItem("dob");



    this.vaccineparams = {
      "account_email": this.accountemail,
      "patient_email": this.patientemail,
      "dob": this.patientdob
    }
    this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token)

  }


  ngOnInit(): void {

    var vacccineadherencedetailsparams = {
      "account_email": this.accountemail,
      "patient_email": this.patientemail
    }

    this.vacccineadherence_details(this.urlPoints.vacccineadherencedetails, vacccineadherencedetailsparams, this.token)
    this.patientdetails_vaccination(this.urlPoints.patientdetailsvaccination, vacccineadherencedetailsparams, this.token)
    //apt_id

    //  alert(this.apt_id)
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss('closed');
  }

  vacccineadherence_details(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success == 1) {
        this.hideaherence = true;
        this.adherence = response
      } else if (response == []) {
        this.hideaherence = false;
      }

    });
  }

  givenChange(event) {

    var params = {
      account_email: this.accountemail,
      appt_date: moment(event.value).format('YYYY-MM-DD'),//this.did
      doctor_id: this.did,
      appt_type: 'consultation'
    }

    this.appService.getData(this.urlPoints.checkappointmenttoken, params, this.token).subscribe((response: any) => {

      if (response.slots == 0) {
        this.image_Form.controls.imagegivendate.setValue('');

        this.toastr.error('Doctor is on holiday');
        //(dateChange)="givenChange($event)" 
      }
    });
  }

  givenChange1(event) {

    var params = {
      account_email: this.accountemail,
      appt_date: moment(event.value).format('YYYY-MM-DD'),//this.did
      doctor_id: this.did,
      appt_type: 'consultation'
    }

    this.appService.getData(this.urlPoints.checkappointmenttoken, params, this.token).subscribe((response: any) => {

      if (response.slots == 0) {
        this.reschedulevaccine.controls.reschedulevaccinedate.setValue('');

        this.toastr.error('Doctor is on holiday');

      }
    });
  }

  onDateChange(e: HTMLInputElement) {
    console.log(moment(e.value).format('YYYY-MM-DD'))
    this.vacccinedetail.master_vaccine[0].date_given = moment(e.value).format('YYYY-MM-DD')

    console.log(this.vacccinedetail.master_vaccine[0])

    var params = {
      account_email: this.accountemail,
      patient_email: this.patientemail,
      vaccine_details: [{
        sno: this.vacccinedetail.master_vaccine[0].sno,
        drug_name: this.vacccinedetail.master_vaccine[0].drug_name,
        date_given: moment(e.value).format('YYYY-MM-DD')
      }]
    }

    this.appService.postData(this.urlPoints.updateVaccineDate, params, this.token).subscribe((response: any) => {
      console.log(response)

      this.toastr.success('Given date changed!');

    });
  }

  givenChange2(event) {
    //  alert()

    var params = {
      account_email: this.accountemail,
      appt_date: moment(event.value).format('YYYY-MM-DD'),//this.did
      doctor_id: this.did,
      appt_type: 'consultation'
    }

    this.appService.getData(this.urlPoints.checkappointmenttoken, params, this.token).subscribe((response: any) => {

      if (response.slots == 0) {
        this.textForm.controls.textgivendate.setValue('');

        this.toastr.error('Doctor is on holiday');

      }
    });
  }

  patientdetails_vaccination(url, params, token) {
    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);
    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success == 1) {
        this.patientheader = "";
        this.hidepatientheader = true;
        this.patientheader = response.details[0];
      } else {
        this.hidepatientheader = false;
      }
    });
  }


  givenbyother(data, data1) {

    console.log(data1)

    this.mybrand = [];
    this.batchimageshow = true;
    this.showimageupload = true;
    this.showimageupload_subvaccine = true
    this.deferreddate = false;
    this.imagegiven = true;
    this.url = "";
    this.datepick = true;
    this.composite = true;
    this.category = data
    this.openrescheduleddate = true;

    this.givenid = data1.id
    let str = data1.brand_name;
    var mybrands = str.split(",");

    for (var i = 0; i < mybrands.length; i++) {
      this.mybrand.push(mybrands[i]);
    }

    if (data1.vaccine_group && data1.vaccine_group != 0) {
      this.showcheckbox = true

      console.log(this.subchild)

      console.log(data1.grouping_list)


      for (var i = 0; i < this.subchild.length; i++) {
        for (var j = 0; j < this.subchild[i].length; j++) {
          // console.log(this.subchild[i][j])
          for (var k = 0; k < data1.grouping_list.length; k++) {
            if (this.subchild[i][j].sno == data1.grouping_list[k] && this.subchild[i][j].sno != data1.sno) {

              console.log(this.subchild[i][j].sno)

              var e = {
                target: {
                  checked: true
                }
              }


              if (this.subchild[i][j].status != 'adminsitrated-1' && this.subchild[i][j].status != 'Deferred' && this.subchild[i][j].status != 'deffered') {

                this.subchild[i][j].checked = true

                this.checkedbox(this.subchild[i][j], this.subchild[i][j].drug_name, e)
                console.log(this.subchild[i][j].sno)
                console.log(data1.sno)

              }
            }
          }
        }
      }
    }
    else {
      this.showcheckbox = true

    }


    var vacccinedetailsparams = {
      "account_email": this.accountemail,
      "patient_email": this.patientemail,
      "sno": data1.sno
    }

    this.vacccine_details(this.urlPoints.vacccinedetails, vacccinedetailsparams, this.token)

  }

  rescheduled(data, status) {
    this.showcheckbox = false;
    this.datepick = false;
    this.imagegiven = false;
    this.batchimageshow = false;
    this.deferreddate = true;
    this.composite = false;
    this.category = status;
    this.showimageupload = false;
    this.showimageupload_subvaccine = false
    this.openrescheduleddate = true;
    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);
  }


  togglebatch() {
    this.batch_image = !this.batch_image
    // this.hideall = !this.batch_image
    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);

    // if(!this.batch_image == false){
    //   this.showtext_field = true;
    // }


  }

  togglesubvaccinebatch(value, index) {
    this.mymodel_subvaccine[index] = value == true ? this.mymodel_subvaccine[index] = true : this.mymodel_subvaccine[index] = false
    if (value == true) {
      this.url_subvaccine.splice(index, 1)
      this.all_subvaccine_data[index].image_url = ""
    } else {
      this.imagegivensubvaccine_text[index] = ""
      // this.all_subvaccine_data[index].comments = ""
    }
  }

  addcompositedeffer() {
    this.showcheckboxdeffer = !this.showcheckboxdeffer
  }

  addcomposite() {
    this.showcheckbox = !this.showcheckbox;

    if (!this.showcheckbox) {
      this.subvaccines = []
    }
    else {
      for (var i = 0; i < this.subchild.length; i++) {
        for (var j = 0; j < this.subchild[i].length; j++) {
          // console.log(this.subchild[i][j])
          for (var k = 0; k < this.selectedvaccine.grouping_list.length; k++) {
            if (this.subchild[i][j].sno == this.selectedvaccine.grouping_list[k] && this.subchild[i][j].sno != this.selectedvaccine.sno) {

              console.log(this.subchild[i][j].sno)

              var e = {
                target: {
                  checked: true
                }
              }


              if (this.subchild[i][j].status != 'adminsitrated-1' && this.subchild[i][j].status != 'Deferred' && this.subchild[i][j].status != 'deffered') {

                this.subchild[i][j].checked = true

                this.checkedbox(this.subchild[i][j], this.subchild[i][j].drug_name, e)
                console.log(this.subchild[i][j].sno)
                console.log(this.selectedvaccine.sno)

              }
            }
          }
        }
      }
    }
  }

  checkedboxdeffer(data, id, e) {

    if (e.target.checked == true) {
      if (data != this.selectedvaccine) {
        this.sub_vaccines.push(data);
      }
    } else {
      for (var i = 0; i < this.sub_vaccines.length; i++) {
        if (this.sub_vaccines[i].drug_name == id) {
          this.sub_vaccines.splice(i, 1);
        }
      }

    }

  }

  checkedbox(data, id, e) {


    if (e.target.checked == true) {

      if (data != this.selectedvaccine) {
        this.subvaccines.push(data);
        this.mymodel_subvaccine.push(false)
        this.all_subvaccine_data.push({
          "sub_vaccine_sno": data.sno,
          "image_url": "",
          "comments": "",
          "brand_name": "",
          "batch_id": ""
        })
        let str = data.brand_name;
        var mysubvaccinebrands = str.split(",");
        this.mysubvaccinebrands[this.subvaccines.length - 1] = []
        for (var i = 0; i < mysubvaccinebrands.length; i++) {
          this.mysubvaccinebrands[this.subvaccines.length - 1].push(mysubvaccinebrands[i]);
        }
      }
    } else {
      for (var i = 0; i < this.subvaccines.length; i++) {
        if (this.subvaccines[i].drug_name == id) {
          this.subvaccines.splice(i, 1);
          this.mymodel_subvaccine.splice(i, 1)
          this.all_subvaccine_data.splice(i, 1)
          this.mysubvaccinebrands.splice(i, 1)
          this.url_subvaccine.splice(i, 1)
          this.uploadedimg_subvaccine.splice(i, 1)
        }
      }

    }

  }

  delete(id) {
    for (var i = 0; i < this.subvaccines.length; i++) {
      if (this.subvaccines[i].drug_name == id) {
        this.subvaccines.splice(i, 1);
        this.mymodel_subvaccine.splice(i, 1)
        this.all_subvaccine_data.splice(i, 1)
        this.mysubvaccinebrands.splice(i, 1)
        this.url_subvaccine.splice(i, 1)
        this.uploadedimg_subvaccine.splice(i, 1)
      }
    }

    for (var i = 0; i < this.subchild.length; i++) {
      for (var j = 0; j < this.subchild[i].length; j++) {
        // console.log(this.subchild[i][j])

        if (this.subchild[i][j].drug_name == id) {
          console.log(this.subchild[i][j].drug_name)
          this.subchild[i][j].checked = false

        }
      }
    }
  }

  removecomposite(data) {
    for (var i = 0; i < this.subvaccines.length; i++) {
      if (this.subvaccines[i].drug_name == data.drug_name) {
        this.subvaccines.splice(i, 1);
      }
    }
  }

  remove_composite(data) {
    for (var i = 0; i < this.sub_vaccines.length; i++) {
      if (this.sub_vaccines[i].drug_name == data.drug_name) {
        this.sub_vaccines.splice(i, 1);
      }
    }
  }

  savecompositebrand(dategiven) {
    let text_arr = []
    // var duedates = [this.selectedvaccine.due_date]
    for (var i = 0; i < this.subvaccines.length; i++) {
      this.subvacsno.push(this.subvaccines[i].sno)
      this.all_subvaccine_data[i].due_date = this.subvaccines[i].due_date
      // duedates.push(this.subvaccines[i].due_date)
      text_arr.push(this.imagegivensubvaccine_text[i])
    }
    for (var i = 0; i < this.all_subvaccine_data.length; i++) {
      this.all_subvaccine_data[i].comments = text_arr[i] == undefined ? "" : text_arr[i]
    }

    var params = {
      "patient_email": this.patientemail,
      "account_email": this.accountemail,
      "master_vaccine_sno": this.selectedvaccine.sno,
      "sub_vaccine_sno": this.subvacsno,
      "date_given": dategiven,
      // "due_date": duedates,
      "sub_vaccine": this.all_subvaccine_data
    }
    // changes
    this.appService.postData(this.urlPoints.addcompositevaccination, params, this.token).subscribe((response: any) => {

      if (response.success == 1) {
        this.spinner.hide();
        this.all_subvaccine_data = []
        this.subvaccines = []
        this.mymodel_subvaccine = []
        this.imagegivensubvaccine_text = []
        this.mysubvaccinebrands = []
        this.currentStep = []
        this.url_subvaccine = []
        this.uploadedimg_subvaccine = []
      } else {
        this.toastr.error(response.message);
      }
    });

  }

  savegivenimage() {

    this.givenSaved = true

    if (this.image_Form.valid && this.uploadedimg != "") {
      if (this.brand_name != undefined) {
        this.textselectbrand = false;
        this.spinner.show()
        if (this.uploadedimg != undefined) {
          this.actualimage = this.uploadedimg.image[0].filename
        } else {
          this.actualimage = ''
        }
        var newdate = moment(new Date(this.image_Form.value.imagegivendate)).format("YYYY-MM-DD");
        this.savecompositebrand(newdate);
        var paramsgiven = {
          "s_no": this.selectedvaccine.sno,
          "status": "adminsitrated-1",
          "patient_email": this.patientemail,
          "account_email": this.accountemail,
          "image_url": this.actualimage,
          "date_given": newdate,
          "brand_name": this.brand_name,
          "due_date": this.selectedvaccine.due_date,
          "appointment_id": this.apt_id ? this.apt_id : ''
        }

        this.appService.postData(this.urlPoints.updatevaccinationstatus, paramsgiven, this.token).subscribe((response: any) => {

          if (response.success == 1) {
            this.spinner.hide();
            this.vaccineparams = {
              "account_email": this.accountemail,
              "patient_email": this.patientemail,
              "dob": this.patientdob
            }
            this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token);
            this.toastr.success(response.message);
            this.close_btn();


            this.showcheckbox = false;
            var patientdetailsvaccinationparams = {
              "account_email": this.accountemail,
              "patient_email": this.patientemail
            }

            this.patientdetails_vaccination(this.urlPoints.patientdetailsvaccination, patientdetailsvaccinationparams, this.token)
            this.vacccineadherence_details(this.urlPoints.vacccineadherencedetails, patientdetailsvaccinationparams, this.token)

          } else {
            this.spinner.hide()
          }
        });


      } else {
        this.textselectbrand = true;
      }
    }
  }

  savegiventext() {

    this.givenSaved = true

    var newdate = moment(new Date(this.textForm.value.textgivendate)).format("YYYY-MM-DD");
    if (this.textForm.valid) {
      if (this.brand_name != undefined) {
        this.textselectbrand = false;
        this.savecompositebrand(newdate);
        var params_given = {
          "s_no": this.selectedvaccine.sno,
          "status": "adminsitrated-1",
          "patient_email": this.patientemail,
          "account_email": this.accountemail,
          "comments": this.textForm.value.texthere,
          "brand_name": this.brand_name,
          "date_given": newdate,
          "due_date": this.selectedvaccine.due_date,
          "appointment_id": this.apt_id ? this.apt_id : ''
        }

        this.appService.postData(this.urlPoints.updatevaccinationstatus, params_given, this.token).subscribe((response: any) => {

          if (response.success == 1) {
            this.spinner.hide()
            this.vaccineparams = {
              "account_email": this.accountemail,
              "patient_email": this.patientemail,
              "dob": this.patientdob
            }
            this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token);
            this.toastr.success(response.message);
            this.close_btn();
            this.showcheckbox = false;

            var patientdetailsvaccinationparams = {
              "account_email": this.accountemail,
              "patient_email": this.patientemail
            }

            this.patientdetails_vaccination(this.urlPoints.patientdetailsvaccination, patientdetailsvaccinationparams, this.token)
            this.vacccineadherence_details(this.urlPoints.vacccineadherencedetails, patientdetailsvaccinationparams, this.token)

          } else {
            this.spinner.hide()
          }
        });

      } else {
        this.textselectbrand = true;
      }
    }
  }

  saverescheduletext() {
    this.addedrelatedvaccine();
    if (this.imageForm2.valid) {
      var newdate = moment(new Date(this.imageForm2.value.selecteddate2)).format("YYYY-MM-DD");

      if (this.category == 'Given') {

        this.cardgivenbyother = true
        if (this.cardgivenbyother == true) {
          this.spinner.show()
          var paramsgiven = {
            "s_no": this.selectedvaccine.sno,
            "status": "adminsitrated-1",
            "patient_email": this.patientemail,
            "account_email": this.accountemail,
            "comments": this.imageForm2.value.texthere,
            "brand_name": this.brand_name,
            "date_given": newdate,
            "appointment_id": this.apt_id ? this.apt_id : ''
          }
          this.appService.postData(this.urlPoints.updatevaccinationstatus, paramsgiven, this.token).subscribe((response: any) => {
            if (response.success == 1) {
              this.spinner.hide()
              this.toastr.success(response.message);

              var patientdetailsvaccinationparams = {
                "account_email": this.accountemail,
                "patient_email": this.patientemail
              }

              this.patientdetails_vaccination(this.urlPoints.patientdetailsvaccination, patientdetailsvaccinationparams, this.token)

              this.close_btn()

            } else {
              this.spinner.hide()
            }
          });
        }
      }

    }
  }

  removedrug(data) {
    for (var i = 0; i < this.groupvaccine.length; i++) {
      if (this.groupvaccine[i].drug_name == data) {
        this.groupvaccine.splice(i, 1)
      }
    }

  }

  selectedgroup(data) {
    if (data == "6 weeks") {
      for (var i = 0; i < this.vaccinelist[1][1].length; i++) {
        this.subvaccines.push(this.vaccinelist[1][1][i]);
        this.subvaccines = [...new Set(this.subvaccines)];
      }
    }

  }

  removeimage() {
    this.url = "";
  }

  removeimage_subvaccine(index) {
    this.url_subvaccine.splice(index, 1)
  }

  savereschedule() {
    if (this.imageForm.valid) {
      if (this.category == ('reschedule' || 'rescheduled')) {
        var newdate = moment(new Date(this.imageForm.value.selecteddate)).format("YYYY-MM-DD");

        if (newdate != "1970-01-01") {
          var params = {
            "account_email": this.accountemail,
            "s_no": this.selectedvaccine.sno,
            "patient_email": this.patientemail,
            "schedule_day": newdate,
          }
          this.appService.postData(this.urlPoints.reschdulevaccinationcalender, params, this.token).subscribe((response: any) => {
            if (response.success == 1) {
              this.vaccineparams = {
                "account_email": this.accountemail,
                "patient_email": this.patientemail,
                "dob": this.patientdob
              }
              this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token);
              this.toastr.success(response.message);
            }
          });

        } else {
          this.toastr.error("Please Input Rescheduled Date")
        }

      }

      if (this.category == 'Given') {
        this.addedrelatedvaccine()
        this.cardgivenbyother = true
        if (this.uploadedimg != "") {
          if (this.cardgivenbyother == true) {
            this.spinner.show()
            var actualimage = this.uploadedimg.image[0].filename
            var newdate = moment(new Date(this.imageForm.value.selecteddate)).format("YYYY-MM-DD");
            var paramsgiven = {
              "s_no": this.selectedvaccine.sno,
              "status": "adminsitrated-1",
              "patient_email": this.patientemail,
              "account_email": this.accountemail,
              "image_url": actualimage,
              "date_given": newdate,
              "brand_name": this.brand_name,
              "appointment_id": this.apt_id ? this.apt_id : ''
            }
            this.appService.postData(this.urlPoints.updatevaccinationstatus, paramsgiven, this.token).subscribe((response: any) => {
              if (response.success == 1) {
                this.spinner.hide()
                this.toastr.success(response.message);

                var patientdetailsvaccinationparams = {
                  "account_email": this.accountemail,
                  "patient_email": this.patientemail
                }

                this.patientdetails_vaccination(this.urlPoints.patientdetailsvaccination, patientdetailsvaccinationparams, this.token)
                this.showcheckbox = false;
                this.close_btn();

              } else {
                this.spinner.hide()
              }
            });
          }
        } else {
          this.toastr.error("Upload Batch Image");
        }
      }


    }
  }


  addedrelatedvaccine() {
    var allsno = []
    for (var i = 0; i < this.groupvaccine.length; i++) {
      allsno.push(this.groupvaccine[i].sno)
    }
    var params = {
      "patient_email": this.patientemail,
      "account_email": this.accountemail,
      "master_vaccine_sno": this.selectedvaccine.sno,
      "sub_vaccine_sno": allsno
    }

    this.appService.postData(this.urlPoints.addcompositevaccination, params, this.token).subscribe((response: any) => {
      this.groupvaccine = []
      if (response.success == 1) {
        this.toastr.success(response.message);

        this.vaccineparams = {
          "account_email": this.accountemail,
          "patient_email": this.patientemail,
          "dob": this.patientdob
        }
        this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token);
        this.close_btn();

      } else {
        this.toastr.error(response.message);
      }
    });

  }

  group_vaccine() {
    this.groupvaccine.push(this.currentvaccine);
    this.groupvaccine = [...new Set(this.groupvaccine)];

  }

  saverescheduledate() {
    var vacarray: any = [];
    for (var i = 0; i < this.sub_vaccines.length; i++) {
      vacarray.push(this.sub_vaccines[i].sno)
    }
    if (this.reschedulevaccine.valid) {

      var newdate = moment(new Date(this.reschedulevaccine.value.reschedulevaccinedate)).format("YYYY-MM-DD");
      var params = {
        "account_email": this.accountemail,
        "s_no": vacarray,
        "master_vaccine_sno": this.selectedvaccine.sno,
        "patient_email": this.patientemail,
        "schedule_day": newdate,
        "due_date": this.selectedvaccine.due_date
      }

      this.appService.postData(this.urlPoints.reschdulevaccinationcalender, params, this.token).subscribe((response: any) => {
        this.showcheckboxdeffer = false;
        if (response.success == 1) {
          this.vaccineparams = {
            "account_email": this.accountemail,
            "patient_email": this.patientemail,
            "dob": this.patientdob
          }
          this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token);
          this.toastr.success(response.message);
          this.close_btn();
        }
      });



    }
  }

  reschedule() {
    this.Reschedule = !this.Reschedule
    if (this.Reschedule == true) {
      this.spinner.show()
      var params = {
        "s_no": this.selectedvaccine.sno,
        "status": 'rescheduled',
        "patient_email": this.patientemail,
        "account_email": this.accountemail,
        "appointment_id": this.apt_id ? this.apt_id : ''
      }
      this.appService.postData(this.urlPoints.updatevaccinationstatus, params, this.token).subscribe((response: any) => {
        if (response.success == 1) {
          this.vaccineparams = {
            "account_email": this.accountemail,
            "patient_email": this.patientemail,
            "dob": this.patientdob
          }
          this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token)
          this.toastr.success(response.message);
          this.spinner.hide()
          this.close_btn();
        } else {
          this.spinner.hide()
        }
      });
    }
  }

  printvac() {
    this.hospital = sessionStorage.getItem("hospitalname");
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_printvaccine, {
      width: '300px',
      data: { option: 1 },
      // disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == 'allvac') {

        var node = document.getElementById('print__vactable');
        document.getElementById('print__vactable').style.display = 'block'
        var options = { quality: 1 };

        domtoimage.toJpeg(node, options).then((dataUrl) => {
          if (dataUrl) {
            setTimeout(() => {
              this._changeDetectorRef.markForCheck();
            }, 500);
            this.vacimg = dataUrl

            document.getElementById('print__vactable').style.display = 'none';
            setTimeout(function () {
              var divToPrint = document.getElementById('print_allimg')
              var popupWin = window.open('', '_blank', 'width=1000,height=1000');
              popupWin.document.open();
              popupWin.document.write('<html><style>body{margin-top:100px;margin-right:200px;} #myimage{margin-top:260px;margin-left:-180px;} #allspan{margin-top:10px;} #hospital{text-align: center !important;font-size: 20px !important;margin-left: 40%;}</style><body onload="window.print()">' + divToPrint.innerHTML + '</html>');
              popupWin.document.close();
            }, 1000);
          }
        })

      } else if (result == 'givenvac') {
        var node = document.getElementById('print_givenvactable');
        document.getElementById('print_givenvactable').style.display = 'block'
        var options = { quality: 1 };
        domtoimage.toJpeg(node, options).then((dataUrl) => {
          setTimeout(() => {
            this._changeDetectorRef.markForCheck();
          }, 500);
          this.duevacimg = dataUrl
          document.getElementById('print_givenvactable').style.display = 'none'
          setTimeout(function () {
            var divToPrint = document.getElementById('printdueimg')
            var popupWin = window.open('', '_blank', 'width=1000,height=1000');
            popupWin.document.open();
            popupWin.document.write('<html><style>body{margin-top:100px;margin-right:200px;} #duemyimage{margin-top:210px;margin-left:-180px;} #allspan{margin-top:10px;} #hospital{text-align: center !important;font-size: 20px !important;margin-left: 40%;}</style><body onload="window.print()">' + divToPrint.innerHTML + '</html>');
            popupWin.document.close();
          }, 1000);
        })

      } else if (result == 'duevac') {

        var node = document.getElementById('print_duevactable');
        document.getElementById('print_duevactable').style.display = 'block'
        var options = { quality: 1 };
        domtoimage.toJpeg(node, options).then((dataUrl) => {
          setTimeout(() => {
            this._changeDetectorRef.markForCheck();
          }, 500);
          this.givenvacimg = dataUrl
          document.getElementById('print_duevactable').style.display = 'none'
          setTimeout(function () {
            var divToPrint = document.getElementById('printgivenimg')
            var popupWin = window.open('', '_blank', 'width=1000,height=1000');
            popupWin.document.open();
            popupWin.document.write('<html><style>body{margin-top:100px;margin-right:200px;} #givenmyimage{margin-top:230px;margin-left:-180px;} #allspan{margin-top:10px;} #hospital{text-align: center !important;font-size: 20px !important;margin-left: 40%;}</style><body onload="window.print()">' + divToPrint.innerHTML + '</html>');
            popupWin.document.close();
          }, 1000);
        })

      }
    });

  }

  givenonduedate() {
    this.openrescheduleddate = false;
    this.cardgiven = true;
    this.deferreddate = false;
    this.imagegiven = false;
    this.batchimageshow = false;

    const dialogRef = this.dialog.open(DialogOverviewExampleDialogaddnotgiven, {
      width: '700px',
      data: { option: 1 },
      // disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.spinner.show()
        this.spinner.show()
        var params = {
          "s_no": this.selectedvaccine.sno,
          "due_date": this.selectedvaccine.due_date,
          "status": '',
          "patient_email": this.patientemail,
          "account_email": this.accountemail,
          "comments": "",
          "appointment_id": this.apt_id ? this.apt_id : ''
        }
        this.appService.postData(this.urlPoints.updatevaccinationstatus, params, this.token).subscribe((response: any) => {
          this.spinner.hide()
          if (response.success == 1) {
            this.vaccineparams = {
              "account_email": this.accountemail,
              "patient_email": this.patientemail,
              "dob": this.patientdob
            }
            this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token)
            this.toastr.success(response.message);
            this.spinner.hide()
          } else {
            this.spinner.hide()
          }
        });

      }
    });



  }

  callpending() {
    this.openrescheduleddate = false;
    this.batchimageshow = false;
    this.call_pending = true;
    this.deferreddate = false;
    this.imagegiven = false;

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_pending, {
      width: '700px',
      data: { option: 1 },
      // disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.spinner.show()
        var params = {
          "s_no": this.selectedvaccine.sno,
          "status": "Pending",
          "patient_email": this.patientemail,
          "account_email": this.accountemail,
          "comments": "",
          "due_date": this.selectedvaccine.due_date,
          "appointment_id": this.apt_id ? this.apt_id : ''
        }
        this.appService.postData(this.urlPoints.updatevaccinationstatus, params, this.token).subscribe((response: any) => {
          this.spinner.hide();
          if (response.success == 1) {
            this.vaccineparams = {
              "account_email": this.accountemail,
              "patient_email": this.patientemail,
              "dob": this.patientdob
            }
            this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token);
            this.toastr.success(response.message);
            this.close_btn();
          } else {
            this.spinner.hide()
          }
        });

      }
    });



  }

  calldefeered() {
    this.openrescheduleddate = false;
    this.batchimageshow = false;
    this.deferreddate = false;
    this.imagegiven = false;
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_deffer, {
      width: '700px',
      data: { option: 1 },
      // disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.spinner.show()
        var params = {
          "s_no": this.selectedvaccine.sno,
          "status": "Deferred",
          "patient_email": this.patientemail,
          "account_email": this.accountemail,
          "comments": "",
          "due_date": this.selectedvaccine.due_date,
          "appointment_id": this.apt_id ? this.apt_id : ''
        }
        this.appService.postData(this.urlPoints.updatevaccinationstatus, params, this.token).subscribe((response: any) => {
          if (response.success == 1) {
            this.vaccineparams = {
              "account_email": this.accountemail,
              "patient_email": this.patientemail,
              "dob": this.patientdob
            }
            this.getall_vacccines(this.urlPoints.vaccinationdruglist, this.vaccineparams, this.token);
            this.spinner.hide()
            this.close_btn();
            this.toastr.success(response.message);
          } else {
            this.spinner.hide()
          }
        });

      }
    });

  }



  getall_vacccines(url, params, token) {
    this.subchild = [];
    this.agegroup = [];
    this.agedate = [];
    this.ageinmonths = [];
    this.agestatus = [];
    this.appService.getData(url, params, token).subscribe((response: any) => {
      this.vaccinelist = response
      for (var i = 0; i < this.vaccinelist.length; i++) {
        this.agegroup.push(this.vaccinelist[i][0][0]);
        this.ageinmonths.push(this.vaccinelist[i][0][4])
        this.agedate.push(this.vaccinelist[i][0][1]);
        this.agestatus.push(this.vaccinelist[i][0][2]);
        for (var j = 0; j < this.vaccinelist[i][1].length; j++) {
          this.agechild.push(this.vaccinelist[i][1][j]);
        }
        this.subchild.push(this.agechild)
        this.agechild = [];
      }

      for (var i = 0; i < 1; i++) {
        this.agegroup.push('');
      }

      console.log(this.subchild)


      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);

    });

  }

  vaccine_brandlist(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success == 1) {
        this.brandlist = response.details;
      }
    });
  }

  vacccine_details(url, params, token) {
    this.loading = true
    this.appService.getData(url, params, token).subscribe((response: any) => {
      this.subvac = [];
      this.vacccinedetail = " ";
      this.vacccinedetail = response;
      this.editDate = this.vacccinedetail.master_vaccine[0].date_given

      console.log(this.vacccinedetail)

      console.log(this.editDate)

      for (var i = 0; i < response.sub_vaccine.length; i++) {
        this.subvac.push(response.sub_vaccine[i].drug_name)
      }
      this.loading = false

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);

    });
  }

  card_related(data) {

    console.log(data)

    for (var i = 0; i < this.subchild.length; i++) {
      for (var j = 0; j < this.subchild[i].length; j++) {
        // console.log(this.subchild[i][j])
        this.subchild[i][j].checked = false


      }
    }


    this.subvaccines = [];
    this.sub_vaccines = [];
    this.subvacsno = [];
    this.showcheckbox = false;
    // this.dependency = data.dependency
    this.datepick = false;
    this.imagegiven = false;
    this.deferreddate = false;
    this.composite = false;
    this.category = status;
    this.showimageupload = false;
    this.showimageupload_subvaccine = false
    this.image_Form.reset();
    this.textForm.reset();
    this.all_subvaccine_data = []
    this.subvaccines = []
    this.mymodel_subvaccine = []
    this.imagegivensubvaccine_text = []
    this.mysubvaccinebrands = []
    this.currentStep = []
    this.url_subvaccine = []
    this.uploadedimg_subvaccine = []

    var datadrug = data.dependency;
    this.dependencyexists = data.dependency
    var mydata = datadrug.split("+");

    if (data.dependency != '') {
      this.dependency = mydata[0] + " In Next " + mydata[1] + " days"
    } else {
      this.dependency = ""
    }
    this.imageandcomment = data;
    if ((data.status == "adminsitrated-1" || data.status == 'Administered')) {
      this.showdeferreddata = false;
      var vacccinedetailsparams = {
        "account_email": this.accountemail,
        "patient_email": this.patientemail,
        "sno": data.sno
      }

      this.vacccine_details(this.urlPoints.vacccinedetails, vacccinedetailsparams, this.token)

      this.hideall = false;
      this.showdeffer = false;
      this.imagegiven = false;
      this.textselectbrand = false;
      this.openrescheduleddate = false;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);

    } else if (data.status == "rescheduled") {
      this.showdeferreddata = true;
      this.showdeffer = true;
      this.reschedules = true;
      this.hideall = true;
      var vacccinedetailsparams = {
        "account_email": this.accountemail,
        "patient_email": this.patientemail,
        "sno": data.sno
      }

      this.vacccine_details(this.urlPoints.vacccinedetails, vacccinedetailsparams, this.token)
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);

    } else {
      this.showdeferreddata = false;
      this.hideall = true;
      this.showdeffer = false;
      this.reschedulevaccine.reset();
      this.reschedulevaccine.reschedulevaccinedate = "";
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    }


    this.imageForm.reset();
    this.imageForm2.reset();
    this.currentvaccine = "";
    this.currentvaccine = data
    this.closesidebar = true;
    this.duedate = data.due_date
    this.selectedvaccine = data;
    this.drugname = data.drug_name;
    this.brandparams = {
      "account_email": this.accountemail,
      "s_no": data.sno,
      "id": data.id
    }
    this.vaccine_brandlist(this.urlPoints.brandlist, this.brandparams, this.token)

  }

  close_btn() {
    this.closesidebar = !this.closesidebar
    this.showcheckbox = false;
  }

  reset_btn() {
  }

  givendate_btn() {
  }

  duedate_btn() {
  }

  add_vaccine(data) {

    this.brand = true
    this.textselectbrand = false
    this.branddata = data

    this.brand_name = data

  }

  add_subvaccine(data, index, j) {
    this.currentStep[index] = j
    this.all_subvaccine_data[index].brand_name = data
    console.log(this.all_subvaccine_data, "this.all_subvaccine_data")
  }

  selectfile(event) {
    this.progress_bar = true
    if (event.target.files) {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0]);
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      reader.onload = (event: any) => {
        this.url = event.target.result;
      }
    }
    const file = (event.target as HTMLInputElement).files[0];
    var uploadFileName = file;

    var dummyurl
    this.appService.postimgData(dummyurl, uploadFileName, this.token).subscribe((response: any) => {

      this.progress = Math.round((response.loaded / response.total) * 100);
      if (this.progress == 100) {
        this.progress = 100
        this.progress_bar = false
      }
      this.uploadedimg = response.body;

    });
  }

  selectfile_demo(index) {
    let input = document.createElement('input');
    input.type = 'file';
    input.onchange = _ => {
      let files = Array.from(input.files);
      console.log(files);
      var reader = new FileReader()
      reader.readAsDataURL(files[0]);
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      reader.onload = (event: any) => {
        this.url_subvaccine[index] = event.target.result;
      }
      const file = files[0];
      var uploadFileName = file;
      console.log(uploadFileName)
      var dummyurl
      this.appService.postimgData(dummyurl, uploadFileName, this.token).subscribe((response: any) => {

        this.progress = Math.round((response.loaded / response.total) * 100);
        if (this.progress == 100) {
          this.progress = 100
          this.progress_bar = false
        }
        if (response.body !== undefined) {
          let image_response = response.body
          this.uploadedimg_subvaccine[index] = image_response.image[0].filename
          this.all_subvaccine_data[index].image_url = image_response.image[0].filename
          console.log(this.all_subvaccine_data, "uploadimgsv")
        }

      });
    };
    input.click();
  }

  upload_batch() {

    if (this.uploadedimg != "") {
      var actualimage = this.uploadedimg.image[0].filename
      var params = {
        "patient_email": this.patientemail,
        "account_email": this.accountemail,
        "schedule_id": this.selectedvaccine.id,
        "image_url": actualimage
      }
      this.appService.postData(this.urlPoints.addvaccinationbrandcode, params, this.token).subscribe((response: any) => {
        this.toastr.success("Batch image Uploaded successfully")
        this.batchimage = [];
      });

    } else {
      this.toastr.error("upload batch image")
    }
  }

}
//vaccinationwindow popover ends here

@Component({
  selector: 'bottomwindow',
  templateUrl: 'submenus/bottomwindow.html',
  styleUrls: ['submenus/bottomwindow.scss']
})

export class DialogOverviewExampleDialog_bottomwindow {
  profileForm;
  files;
  uploaded_image;
  submitted = false;
  profiledata;
  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  imgURL;
  actual_image;
  uploadCoverImageFile;
  uploadCoverDrImage = 'assets/stethoscope1.jpg';
  sendCoverImgFile;
  editStatus = false;
  patientmaxdate = moment(new Date()).format("YYYY-MM-DD");
  patientmindate = moment().subtract(110, 'years').format("YYYY-MM-DD");

  Nme;
  gender;
  DOB
  Weight;
  Height;
  alternatenumber: any;
  fathername;
  mothername;
  fatherdob;
  motherdob;
  fatherlastname;
  motherlastname;

  phonenumber;
  UHID;
  RCHID;
  getGender=sessionStorage.getItem("gender:")
  Emailaddress;
  street;
  city;
  pincode;
  state;
  imageUploadUrl;
  selectedgender;
  success = "Updated !"
  address;
  region;
  country;
  abhanumber: any;
  abhaaddress: any;
  abhaDetails: any = {};

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
    this.imageUploadUrl = environment.HOST + '/helyxonapi/cloud/image/upload/';
  }
  ngOnInit(): void {
    console.log('basic::',this.data)

    this.profileForm = this.fb.group({
      //Image: [""],
      Name: ["", [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
      DOB: ["", [Validators.required]],
      // Weight: ["", [Validators.required, Validators.maxLength(4)]],
      // Height: ["", [Validators.required, Validators.maxLength(4)]],
      fathername: ["", [Validators.minLength(3), Validators.maxLength(20)]],
      fatherlastname: ["", [Validators.minLength(3), Validators.maxLength(20)]],
      mothername: ["", [Validators.minLength(3), Validators.maxLength(20)]],
      motherlastname: ["", [Validators.minLength(3), Validators.maxLength(20)]],
      gender: ["", [Validators.required]],
      fatherdob: [""],
      motherdob: [""],
      phonenumber: ["", [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      UHID: ["", [Validators.pattern("^[a-zA-Z0-9]*$"), Validators.minLength(4), Validators.maxLength(8)]],
      RCHID: ["", [Validators.pattern("^[a-zA-Z0-9]*$"), Validators.minLength(1), Validators.maxLength(20)]],
      alternatenumber: ["", [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      Emailaddress: ["", [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      street: [""],
      pincode: ["", [Validators.minLength(6), Validators.maxLength(6)]],
      city: [""],
      state: [""],
      address: [""],
      region: [""],
      country: [""],
      abhanumber: [""],
      abhaaddress: [""]
    });

    this.get_profile();

    this.abhaDetails = sessionStorage.getItem('abhaDetails')
  }

  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const sanitizedValue = inputElement.value.replace(/[^a-zA-Z0-9]/g, ''); // Allow only alphanumeric characters
    this.profileForm.get('RCHID').setValue(sanitizedValue, { emitEvent: false });
  }
  uploadCoverImage(event: any) {
    const file = (event.target as HTMLInputElement).files[0];
    this.uploadCoverImageFile = file;

    const reader = new FileReader();
    // reader.addEventListener('load', (e: any) => {
    //  this.uploadCoverDrImage = e.target.result;
    // });
    reader.onload = () => {
      this.uploadCoverDrImage = reader.result as string;
    }
    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);
    reader.readAsDataURL(file);
    this.uploadCoverImagee();

  }

  uploadCoverImagee() {
    this.appService
      .postwithoutPortImgFile(AppConfig.settings.EndPoints.uploadImage, this.uploadCoverImageFile, this.token)
      .subscribe((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.Response:
            this.sendCoverImgFile = event.body.image[0].filename;
        }
        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);
      })
  }
  editDetails() {
    this.editStatus = true;
  }

  cancelDetails() {
    this.editStatus = false;
  }

  get_profile() {
    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);

    if (this.data.patientDetails.demographics.adr_city == "") {
      var adr_city = "";
      var adr_state = "";
    } else {
      adr_city = this.data.patientDetails.demographics.adr_city.split(',')[0].trim();
      adr_state = this.data.patientDetails.demographics.adr_city.split(',')[1].trim();
    }


    this.Nme = this.data.patientDetails.record_info.Record.label;
    this.gender = this.data.patientDetails.demographics.gender;
    this.RCHID = this.data.patientDetails.demographics.picme_baby;
    this.selectedgender = this.gender;
    this.DOB = moment(this.data.patientDetails.demographics.bday).format("DD-MM-YYYY");
    this.Weight = this.data.patientDetails.record_info.Record.label;
    this.Height = this.data.patientDetails.record_info.Record.label;
    this.alternatenumber = this.data.patientDetails.demographics.mother_tel_number;
    this.fathername = this.data.patientDetails.demographics.father_name_given;
    this.mothername = this.data.patientDetails.demographics.mother_name_given;
    this.fatherdob = this.data.patientDetails.demographics.father_bday;
    this.motherdob = this.data.patientDetails.demographics.mother_bday;
    this.phonenumber = this.data.patientDetails.record_info.Record.phone;
    this.UHID = this.data.patientDetails.demographics.uhid;
    this.Emailaddress = this.data.patientDetails.demographics.father_email;
    this.street = this.data.patientDetails.demographics.adr_street;
    this.city = adr_city;
    this.pincode = this.data.patientDetails.demographics.adr_postalcode;
    this.state = this.data.patientDetails.demographics.adr_region;
    this.fatherlastname = this.data.patientDetails.demographics.father_name_family;
    this.motherlastname = this.data.patientDetails.demographics.mother_name_family;
    this.address = this.data.patientDetails.demographics.adr_street;
    this.region = this.data.patientDetails.demographics.adr_region;
    this.state = adr_state;
    this.country = this.data.patientDetails.demographics.adr_country;
    this.abhanumber = this.data.abhaDetails.abha_number;
    this.abhaaddress = this.data.abhaDetails.abha_address;

    this.profileForm.controls['Name'].setValue(this.data.patientDetails.record_info.Record.label);
    this.profileForm.controls['gender'].setValue(this.data.patientDetails.demographics.gender);
    this.profileForm.controls['DOB'].setValue(this.data.patientDetails.demographics.bday);
    // this.profileForm.controls['Weight'].setValue(this.data.patientDetails.demographics.birth_weight);
    // this.profileForm.controls['Height'].setValue(this.data.patientDetails.demographics.birth_height);
    this.profileForm.controls['alternatenumber'].setValue(this.data.patientDetails.demographics.mother_tel_number);
    this.profileForm.controls['fathername'].setValue(this.data.patientDetails.demographics.father_name_given);
    this.profileForm.controls['fatherlastname'].setValue(this.data.patientDetails.demographics.father_name_family);
    this.profileForm.controls['motherlastname'].setValue(this.data.patientDetails.demographics.mother_name_family);
    this.profileForm.controls['mothername'].setValue(this.data.patientDetails.demographics.mother_name_given);
    this.profileForm.controls['fatherdob'].setValue(this.data.patientDetails.demographics.father_bday);
    this.profileForm.controls['motherdob'].setValue(this.data.patientDetails.demographics.mother_bday);
    this.profileForm.controls['phonenumber'].setValue(this.data.patientDetails.record_info.Record.phone);
    this.profileForm.controls['UHID'].setValue(this.data.patientDetails.demographics.uhid);
    this.profileForm.controls['RCHID'].setValue(this.data.patientDetails.demographics.picme_baby);
    this.profileForm.controls['Emailaddress'].setValue(this.data.patientDetails.demographics.father_email);
    this.profileForm.controls['street'].setValue(this.data.patientDetails.demographics.adr_street);
    this.profileForm.controls['city'].setValue(adr_city);
    this.profileForm.controls['pincode'].setValue(this.data.patientDetails.demographics.adr_postalcode);
    this.profileForm.controls['state'].setValue(adr_state);
    this.profileForm.controls['address'].setValue(this.data.patientDetails.demographics.adr_street);
    this.profileForm.controls['region'].setValue(this.data.patientDetails.demographics.adr_region);
    this.profileForm.controls['country'].setValue(this.data.patientDetails.demographics.adr_country);
    this.profileForm.controls['abhanumber'].setValue(this.data.abhaDetails.abha_number);
    this.profileForm.controls['abhaaddress'].setValue(this.data.abhaDetails.abha_address);


    this.dob2 = moment(this.data.patientDetails.demographics.bday).format("DD-MM-YYYY")
    this.imgURL = this.data.patientDetails.demographics.image;
    this.uploadCoverDrImage = this.imageUploadUrl + this.data.patientDetails.demographics.image;
    this.sendCoverImgFile = this.data.patientDetails.demographics.image;
    // sessionStorage.setItem("patientname", this.data.patientDetails.demographics.name_given);
    // sessionStorage.setItem('patientemail', this.data.patientDetails.record_info.Record.account_email)

  }

  update_profile() {
    var params = {
      account_email: this.dmail,
      record_id: this.data.patientDetails.record_info.Record.id
    }
    this.appService.postData(this.urlPoints.getRecord, params, this.token).subscribe((response: any) => {
      this.data.patientDetails = response;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.get_profile();
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.profileForm.controls; }

  save_profile() {

    this.submitted = true;

    if (this.profileForm.invalid) {
      return;
    }

    this.profiledata = this.profileForm.value;
    if (this.profiledata.fatherdob == null) {
      var fatherdob = "";
    } else {
      fatherdob = this.profiledata.fatherdob;
    }
    if (this.profiledata.motherdob == null) {
      var motherdob = "";
    } else {
      motherdob = this.profiledata.motherdob;
    }

    var profileData = {
      record_id: this.data.patientDetails.record_info.Record.id,
      mrNumber: this.data.patientDetails.record_info.Record.mr_number,
      patientSince: this.data.patientDetails.demographics.patient_since,
      image: this.sendCoverImgFile,
      cover: "None",
      image_id: null,
      update_image: false,
      
      picme_baby: this.profiledata.RCHID,
      district_id: null,
      block_id: null,
      village_id: null,
      childInfo: {
        gender: this.profiledata.gender,
        dob: this.profiledata.DOB,
        firstName: this.profiledata.Name,
        lastName: "",
        birthWeight: this.profiledata.Weight,
        birthHeight: this.profiledata.Height,
        bloodGroup: "N/A",
        uhid: this.profiledata.UHID
      },
      fatherInfo: {
        firstName: this.profiledata.fathername,
        lastName: this.profiledata.fatherlastname,
        phone: this.profiledata.phonenumber.toString(),
        email: this.profiledata.Emailaddress,
        dob: fatherdob
      },
      motherInfo: {
        firstName: this.profiledata.mothername,
        lastName: this.profiledata.motherlastname,
        dob: motherdob,
        phone: this.profiledata.alternatenumber
      },
      address: {
        country: this.profiledata.country,
        city: this.profiledata.city + ' , ' + this.profiledata.state,
        postalcode: this.profiledata.pincode,
        region: this.profiledata.region,
        street: this.profiledata.address
      },
      patient_email: this.data.patientDetails.record_info.Record.account_email,
      account_email: this.dmail,
    }
    var token = this.token;

    this.appService.postData(this.urlPoints.demographicsUpdate, profileData, token).subscribe((response: any) => {
      if (response) {
        this.editStatus = false;
        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);
        this.update_profile();
        this.openSnackBar();
      }
    });

  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss('closed');
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  disableDate() {
    return false;
  }

  //only number will be add
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '/' || event.key === '@' || event.key === ',' || event.key === '-') {
      return;
    } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

}

@Component({
  selector: 'profileSocialHistory',
  templateUrl: 'submenus/profile/socialHistory/socialHistory.html',
  styleUrls: ['submenus/profile/socialHistory/socialHistory.scss']
})

export class DialogOverviewExampleDialog_profileSocialHistory {

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  add_update_OpenState = false;
  success = "Updated !";

  socialhistory;
  antentaldata;
  typeofHouse: any = 1;
  smokerinHouse: any = 1;
  isMainroad: any = 0;
  proberDrinking: any = 1;
  haveToilet: any = 1;
  editStatus = false;
  getMotherData;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  ngOnInit(): void {
    this.socialhistory = this.fb.group({
      peopleinHouse: [""],
      roomsinHouse: [""],
      typeofStove: [""],
      distance: [""],
      distanceType: [""],
      typeofTrans: [""],
      probPreventing: [],
      waterPollution: [""]

    });
    this.getsocialData();
  }

  getsocialData() {

    var data = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "account_email": this.dmail, "user_type": "doctor"
    }

    this.appService.postData(this.urlPoints.getsocialhistory, data, this.token).subscribe((response: any) => {
      this.getMotherData = response.social_history;
    });
  }

  updateStatus() {
    this.editStatus = true;
    this.socialhistory.controls['peopleinHouse'].setValue(this.getMotherData.number_of_people);
    this.socialhistory.controls['roomsinHouse'].setValue(this.getMotherData.number_of_rooms);
    this.socialhistory.controls['typeofStove'].setValue(this.getMotherData.stove_type);
    this.socialhistory.controls['distance'].setValue(this.getMotherData.distance);
    this.socialhistory.controls['distanceType'].setValue(this.getMotherData.distance_units);
    this.socialhistory.controls['typeofTrans'].setValue(this.getMotherData.transportation);
    this.socialhistory.controls['probPreventing'].setValue(this.getMotherData.problem_coming_to_hospital);
    this.socialhistory.controls['waterPollution'].setValue(this.getMotherData.pollution);


    if (this.getMotherData.house_type == 'kutcha house') {
      this.typeofHouse = 0;
    } else {
      this.typeofHouse = 1;
    }
    if (this.getMotherData.smokers == 'yes') {
      this.smokerinHouse = 0;
    } else if (this.getMotherData.smokers == 'no') {
      this.smokerinHouse = 1;
    } else {
      this.smokerinHouse = 2;
    }
    if (this.getMotherData.house_on_main_road == 'yes') {
      this.isMainroad = 0;
    } else {
      this.isMainroad = 1;
    }
    if (this.getMotherData.drinking_water_available == 'yes') {
      this.proberDrinking = 0;
    } else {
      this.proberDrinking = 1;
    }
    if (this.getMotherData.toilet_available == 'yes') {
      this.haveToilet = 0;
    } else {
      this.haveToilet = 1;
    }
  }

  cancelStatus() {
    this.editStatus = false;

  }

  validatemotherAntel() {
    this.antentaldata = this.socialhistory.value;

    if (this.typeofHouse == 0) {
      var house_type = 'kutcha house'
    } else {
      var house_type = 'pucca house'
    }
    if (this.smokerinHouse == 0) {
      var smokertype = 'yes'
    } else if (this.smokerinHouse == 1) {
      var smokertype = 'no'
    } else {
      var smokertype = 'maybe'
    }
    if (this.isMainroad == 0) {
      var isMainroad_type = 'yes'
    } else {
      var isMainroad_type = 'no'
    }
    if (this.proberDrinking == 0) {
      var proberDrinkingtype = 'yes'
    } else {
      var proberDrinkingtype = 'no'
    }
    if (this.haveToilet == 0) {
      var haveToilettype = 'yes'
    } else {
      var haveToilettype = 'no'
    }

    var socialHisobj = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "house_type": house_type,
      "number_of_people": this.antentaldata.peopleinHouse,
      "number_of_rooms": this.antentaldata.roomsinHouse,
      "smokers": smokertype,
      "stove_type": this.antentaldata.typeofStove,
      "distance": this.antentaldata.distance,
      "distance_units": this.antentaldata.distanceType,
      "transportation": this.antentaldata.typeofTrans,
      "problem_coming_to_hospital": this.antentaldata.probPreventing,
      "house_on_main_road": isMainroad_type,
      "drinking_water_available": proberDrinkingtype,
      "toilet_available": haveToilettype,
      "pollution": this.antentaldata.waterPollution,
      "user_type": "doctor"
    }
    
    if (this.getMotherData != '') {
      socialHisobj["id"] = this.getMotherData.id;
    }
    var data = {
      "social_history": socialHisobj,
      "account_email": this.dmail, "user_type": "doctor"
    }

    // if (this.getMotherData == '') {
    if (Object.keys(this.getMotherData).length == 0) {
      var serviceURL = this.urlPoints.addsocialhistory;
      this.success = "Created successfully !";
    } else {
      var serviceURL = this.urlPoints.updatesocialhistory;
      this.success = "Updated successfully !";
    }
    console.log("this.getMotherData::",this.getMotherData)
    this.appService.postData(serviceURL, data, this.token).subscribe((response: any) => {
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.openSnackBar();
      this.cancelStatus();
      this.getsocialData();
    });

  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '.') {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}

@Component({
  selector: 'consultationHistory',
  templateUrl: 'submenus/history/consultation/consultation.html',
  styleUrls: ['submenus/history/consultation/consultation.scss']
})

export class DialogOverviewExampleDialog_consultHistory {

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  detailViewOpenState = false;
  success = "Updated !"

  invoiceIds: string[];
  invoiceDetails: Promise<any>[];
  pres: any;
  vital: any;
  doct_name: any;
  reg_no: any;
  patient_name: any;
  Dob: any;
  sex: any;
  mrNo: any;
  age: any;
  complaint: any;
  complaintissues: any;
  advice: any;
  prescrDetails: any;
  followupDate: any;
  followuptext: any;
  findings: any;
  diagnosis: any;
  testadvised: any;
  todayDate: any;
  weigth: any;
  Bp: any;
  Mac: any;
  heartRate: any;
  spo2: any;
  heigt: any;
  BMI: any;
  Hc: any;
  temprature: any;
  resRate: any;
  vaccionDate: any;
  todayVaccine: any;
  vaccionmsg: any;
  vacciondata: any;
  accountEmail: any;

  lmpEdd: any;
  lmp: any;
  edd: any;
  precRisk: any;
  riskDate: any;
  riskFrom: any;
  riskTo: any;
  currentPrec: any;
  follicleStudy: any;

  printfollowupDate: any;
  nextscanDate: any;
  consultPrintData = [];
  lmpedd;
  currentPrequency;
  follicleData;
  riskdata;
  followupdate;
  nextscandate;
  visitHistorydetails = [];
  visitdate;
  isPrinting = false
  preview_id;
  selected_temp_Id
  print_file_name;
  displayTotal;
  drugShowType
  fullFreq;
  durationAlone;

  filterDate;
  filterDiagnosis = '';
  maxDate = moment(new Date()).format('YYYY-MM-DD');
  showType = 1
  complaintData;
  prescData;
  defPage = false;
  conHistorydata;
  mangal_header_Type;
  vitalsData: any;
  vitDate: any;
  currentProjectUrl;
  docData: any;
  app_id: any;
  printArr = [];
  callprintprespopup = false;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, private _changeDetectorRef: ChangeDetectorRef, private dom: DomSanitizer,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public dialog: MatDialog, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
    this.displayTotal = this.data.displayTotal
    this.drugShowType = this.data.drugShowType;
    this.fullFreq = this.data.fullFreq
    this.durationAlone = this.data.durationAlone

    console.log(this.durationAlone)
    // this.dmail = 'rx122340@rxcarenet.org';
    // this.doc_id=4;
  }

  ngOnInit(): void {
    this.visitHistory();

    this.listofclinicalHistory();
  }

  visitHistory() {

    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.simplevisithistory, params, this.token).subscribe((response: any) => {

      this.visitHistorydetails = response.visit_history;

      //     this.dmail = 'rx122340@rxcarenet.org';
      // this.doc_id=1;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });

  }

  share(id)
  {
    // alert(id)
    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email,
      doctor_id: this.doc_id,
      id : id
    }

    console.log(params)
  }

  listofclinicalHistory() {
    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email,
      doctor_id: this.doc_id,
      user_type: 'patient'
    }

    this.appService.getData(this.urlPoints.getComplaintAttachment, params, this.token).subscribe((response: any) => {
      if (response) {
        this.complaintData = response.details
        this.prescData = response.prescription

        this.complaintData = this.complaintData.filter((res => res.compliant_img.length > 0));

        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);
      }
    });

  }

  showcompliantData(fileName) {
    if (fileName.endsWith(".pdf")) {
      window.open(environment.HOST + '/helyxonapi/cloud/pdf/upload/' + fileName);
    } else {

      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_openattachment, {
        width: 'fit-content',
        data: { patientDetails: fileName }
      });
    }
  }

  setShowType(i) {
    this.showType = i
  }

  consultHistory(getoverviewId, a_id) {

    var date = new Date();
    var today = date.toString().slice(4, 15).split(" ");
    this.todayDate = today[1] + '-' + today[0] + '-' + today[2];

    this.preview_id = getoverviewId;
    this.app_id = a_id;

    let params = {
      account_email: this.dmail,
      // overview_id: '25f16178-eaa9-4d95-a13e-c1eb7c0febd7',
      overview_id: getoverviewId,
      doctor_id: this.doc_id,
      follicular: 0,
      risk: 0
    }

    this.appService.getData(this.urlPoints.presprint, params, this.token).subscribe((response: any) => {
      let getprintData = response.detailed_prescription;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);

      this.consultPrintData.push(getprintData);

      this.consultPrintData.map(res => {
        this.weigth = res.weight;
        this.Bp = res.bp;
        this.Mac = res.arm_circumference;
        this.heartRate = res.heart_rate;
        this.spo2 = res.spo2;
        this.heigt = res.height;
        this.BMI = res.bmi;
        this.Hc = res.head_circumference;
        this.temprature = res.temperature;
        this.resRate = res.respiratory_rate;
        this.vital = res.vitals;

        this.doct_name = res.doctor_profile.full_name;
        this.reg_no = res.doctor_profile.registration_number;
        this.patient_name = res.patient_demographics.patient_name;
        this.Dob = res.patient_demographics.dob;
        this.sex = res.patient_demographics.gender;
        this.mrNo = res.patient_demographics.mr_number;
        this.age = res.patient_demographics.age;
        this.complaint = res.complaint;
        if (this.complaint != null) {
          this.complaintissues = res.complaint.issues;
        }
        let splitadvice = res.advice.advice;
        this.advice = this.replaceCommaLine(splitadvice);
        this.prescrDetails = res.prescription;
        this.followupDate = res.follow_up_date;
        this.followuptext = res.follow_up_text;
        let splitfindings = res.findings;
        this.findings = this.replaceCommaLine(splitfindings);
        let splitdiagnosis = res.diagnosis;
        this.diagnosis = this.replaceCommaLine(splitdiagnosis);
        this.testadvised = res.lab_tests;

      });

      this.lmpEdd = response.lmpedd;
      this.currentPrec = response.current_pregnancy_data;
      this.follicleStudy = response.follicle_data;
      this.riskdata = response.risk_data;
      this.printfollowupDate = response.follow_up;
      this.nextscanDate = response.next_scan_date;
      if (this.lmpEdd != '')
        this.lmpEdd.map(res => {
          this.lmp = res.lmp;
          this.edd = res.edd;
        });

      //this.riskDate = this.precRisk.date;
      this.riskFrom = this.riskdata.risk_from;
      this.riskTo = this.riskdata.risk_to;

      //   this.dmail = 'rx122340@rxcarenet.org';
      // this.doc_id=1;

    });

  }

  onDateChange(e: HTMLInputElement) {
    console.log(e)
    this.filter()
  }

  removeDate() {
    this.filterDate = undefined
    this.filter()

  }

  removeText() {
    this.filterDiagnosis = ''
    this.filter()

  }

  filter() {


    // alert(this.token)

    var search = false;

    if (this.filterDiagnosis != '') {

      search = true

      var params = {
        account_email: this.dmail,
        patient_email: this.data.patientDetails.record_info.Record.account_email,
        start_dt: moment(new Date()).format('YYYY-MM-DD'),
        end_dt: moment(new Date()).format('YYYY-MM-DD'),
        search_choice: 'diagnosis',
        search_alphabet: this.filterDiagnosis ? this.filterDiagnosis : ''
      }
    }


    if (this.filterDate != undefined) {

      search = true

      var params = {
        account_email: this.dmail,
        patient_email: this.data.patientDetails.record_info.Record.account_email,
        start_dt: moment(this.filterDate).format('YYYY-MM-DD'),
        end_dt: moment(this.filterDate).format('YYYY-MM-DD'),
        search_choice: 'date',
        search_alphabet: this.filterDiagnosis ? this.filterDiagnosis : 'abc'
      }
    }

    if ((this.filterDiagnosis != '') && (this.filterDate != undefined)) {

      search = true

      var params = {
        account_email: this.dmail,
        patient_email: this.data.patientDetails.record_info.Record.account_email,
        start_dt: moment(this.filterDate).format('YYYY-MM-DD'),
        end_dt: moment(this.filterDate).format('YYYY-MM-DD'),
        search_choice: 'both',
        search_alphabet: this.filterDiagnosis
      }
    }

    if (search) {
      this.appService.getData(this.urlPoints.searchSimpleHistory, params, this.token).subscribe((response: any) => {
        console.log(response)

        this.visitHistorydetails = response;

        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);

      });
    }
    else {
      this.visitHistory();

    }


  }

  printPres1(id,App_id) {

    console.log(id,'22730');
    console.log(App_id,'22731');
    
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_tempchoose, {
      width: '600px',
      data: { temps: this.data.print_temps, mode: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {

      console.log('selected template id',result.temp);
    
      // if (result.temp == 441663) {
      //   this.mangal_header_Type = 1;
      //   this.printPres(id,App_id);
      // } else if (result.temp == 442302) {
      //   this.mangal_header_Type = 0;
      //   this.printPres(id,App_id);
      // } else if (result.temp == 858179) {
      //   this.mangal_header_Type = 0;
      //   this.printPres(id,App_id);
      // }
      //  else if (result.temp == 858397) {
      //   this.mangal_header_Type = 0; //without header
      //   this.printPres(id,App_id);
      // }
      //  else if (result.temp == 915089) {
      //   this.mangal_header_Type = 0; //sky without header
      //   this.printPres(id,App_id);
      // }
      //  else if (result.temp == 922831) {
      //   this.mangal_header_Type = 1; //sky with header
      //   this.printPres(id,App_id);
      // }
      //  else if (result.temp == 861962) {
      //   this.mangal_header_Type = 0; //premier medical
      //   this.printPres(id,App_id);
      // }
      // else if (result.temp == 248685) {
      //   this.mangal_header_Type = 0; //varadharajan LPC for test env taken random template and template name is New testing temp 
      //   this.printPres(id,App_id);
      // }
      // else if (result.temp == 1049949) {
      //   this.mangal_header_Type = 0; //varadharajan LPC for prod env template 
      //   this.printPres(id,App_id);
      // }else{

        var params = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          overview_id: id,
          patient_email: this.data.patientDetails.record_info.Record.account_email,
          template_id: result.temp,
          template_v4:2
        }

        this.appService.getData(this.urlPoints.getFile, params, this.token).subscribe((response: any) => {
          console.log(response.data);
          this.isPrinting = false;

          let getpdfData = environment.HOST + '/PDF/' + response.data;
          this.print_file_name = this.dom.bypassSecurityTrustResourceUrl(getpdfData);

          const dialogRef = this.dialog.open(DialogOverviewPrintTemplate, {
            width: '80%',
            height: '90vw',
            data: { printtemplates: this.print_file_name }
          });

        });

      // }

    });



  }

  printPres2(id,type) {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_tempchoose, {
      width: '600px',
      data: { temps: this.data.print_temps, mode: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {

      var params = {
        account_email: this.dmail,
        doctor_id: this.doc_id,
        overview_id: id,
        patient_email: this.data.patientDetails.record_info.Record.account_email,
        template_id: result.temp,
        is_share:type
      }

      this.appService.getData(this.urlPoints.sharePrescription, params, this.token).subscribe((response: any) => {
        console.log(response.data);
        this.isPrinting = false;

        let getpdfData = environment.HOST + '/PDF/' + response.data;
        this.print_file_name = this.dom.bypassSecurityTrustResourceUrl(getpdfData);

        // const dialogRef = this.dialog.open(DialogOverviewPrintTemplate, {
        //   width: '80%',
        //   height: '90vw',
        //   data: { printtemplates: this.print_file_name }
        // });

      });

    });



  }

  opendetailedView() {
    //this.consultHistory();
    this.detailViewOpenState = true;
  }
  goback() {
    this.detailViewOpenState = false;
  }


  replaceCommaLine(data) {
    let dataToArray = data.split('\n').map(item => item.trim());
    //convert array to string replacing comma
    return dataToArray.join(", ");
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '/' || event.key === '@' || event.key === ',') {
      return;
    } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

  getExternalConhistory(){
    this.defPage = true

    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email
    }
    this.appService.postData(this.urlPoints.externalprescriptiondata, params, this.token).subscribe((response: any) => {
      console.log('response::',response);
      if(response.success==1){
        this.conHistorydata = response.message
        console.log(this.conHistorydata);
      }
    });
  }

  printPres(id: any, appoint_id) {

    var params = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getDoctorProfile, params, this.token).subscribe((response: any) => {
      this.docData = response.doctors.profile;

      var p_id:any = JSON.parse(sessionStorage.getItem('patientprofile'))
      console.log(p_id,'22908');

      this.appService.getQueue(this.urlPoints.getVitals + '?' + p_id.record_id, this.token).subscribe((response: any) => {
        console.log(response);
        this.vitalsData = response;
        if(this.vitalsData.length!=0){
          this.sortByDate(this.vitalsData)

          console.log(this.sortByDate(this.vitalsData));

          this.vitDate = this.vitalsData[0].date.split("T")[0]

        }else{

          this.vitDate = moment(new Date()).format('YYYY-MM-DD')
        }
        
        console.log(this.vitDate);
          

          var token = this.token;

          // this.isPrinting = true;

          // if (this.prescription_id) {
            //  this.updatePres()
          // }

          // var ex_names = []

          // for (var i = 0; i < this.ex_selected.length; i++) {
          //   ex_names.push(this.ex_selected[i].name)
          // }

          // var lab_tests = [];

          // for (var i = 0; i < this.inv_selected.length; i++) {
          //   lab_tests.push(this.inv_selected[i].name)
          // }

          // var diag_names = [];

          // for (var i = 0; i < this.diag_selected.length; i++) {
          //   diag_names.push(this.diag_selected[i].name)
          // }

          // var adv_names = [];

          // for (var i = 0; i < this.adv_selected.length; i++) {
          //   adv_names.push(this.adv_selected[i].instructions)
          // }

          // var params = {
          //   "account_email": this.dmail,
          //   "op_review":
          //   {
          //     "patient_email": this.patient.record_info.Record.account_email,
          //     "appointment_id": this.appointment_id,
          //     "complaint_id": this.complaint_id ? this.complaint_id : null,
          //     "prescription_id": this.prescription_id ? this.prescription_id : null,
          //     "notes": "",
          //     "findings": ex_names.join("\n"),
          //     "physical_examination": "",
          //     "measurement_test": "",
          //     "provisional_diagnosis": "",
          //     "investigation": "",
          //     "lab_tests": lab_tests,
          //     "diagnosis": diag_names.join("\n"),
          //     "advice": adv_names.join("\n"),
          //     "diet_instructions": "",
          //     "food_instructions": "",
          //     "others": "",
          //     "follow_up_date": '',
          //     "follow_up_text": this.follow_text
          //   }
          // }
          // if (this.call == 'update') {
            // this.appService.postData(this.urlPoints.updatePreview, params, token).subscribe((response: any) => {



              // this.preview_id = response.id;
              // this.printDisabled = false;

              // this.isPrinting = false;

              this.callprintprespopup = true;

              this.printArr.push('1')

              var host = environment.HOST;

              var type;

              if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '2') || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '7')
                || (this.dmail == 'rx138310@rxcarenet.org' && this.doc_id == '1') || (this.dmail == 'rx138310@rxcarenet.org' && this.doc_id == '2')
                || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '8') || (this.dmail == 'rx138824@rxcarenet.org' && this.doc_id == '1')) {
                type = '/briefprescription/#'
              }//mangal presc template && prashanth presc
              else if ((this.dmail == 'rx15@rxcarenet.org' && this.doc_id == '1') || (this.dmail == 'rx122340@rxcarenet.org')) {
                type = '/mangalprescription/#'
              }else if((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '4') || (this.dmail == 'rx389462@rxcarenet.org' && this.doc_id == '1')) {
                type = '/prescription/prashanth/#'
              }
              // pending..... change doc_id accordingly doctor login in test server
              else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '5') || (this.dmail == 'rx483098@rxcarenet.org' && this.doc_id == '1')) {
                type = '/prescription/srinivasan/#'
              }
              // pending..... change doc_id accordingly doctor login in test server
              else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '65') || (this.dmail == 'rx494693@rxcarenet.org' && this.doc_id == '1')) {
                type = '/prescription/skyclinic/#'
              }
              // pending..... change doc_id accordingly doctor login in test server
              else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '65') || (this.dmail == 'rx370593@rxcarenet.org' && this.doc_id == '1')) {
                type = '/prescription/suhail/#'
              }
              // pending...change doc_id accordingly doctor login in test server
              else if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '3') || (this.dmail == 'rx533822@rxcarenet.org' )) {
                type = '/prescription/varadha/#'
              }
              else {
                type = '/prescription/#'
              }

              this.currentProjectUrl = host + type + '/print/?route_path=prescription&account_email=' + this.dmail + '&overview_Id=' + id +
                '&doctor_Id=' + this.doc_id + '&mr_num=' + this.data.patientDetails.record_info.Record.mr_number +
                '&vit_date='+ this.vitDate +'&vacc_date=&vacc_msg=&dr_Name=' + this.docData.name +
                '&dr_regNo=' + this.docData.registration + '&auth_token=' + this.token + '&appoint_Id=' + appoint_id +
                '&followup_date= ' + '' + '&faliculr_status=1&risk_status=1&patient_email=' +
                this.data.patientDetails.record_info.Record.account_email + '&vital_weight=&vital_height=&vital_temp=&pres_printName='
                + this.data.patientDetails.record_info.Record.label + '&pres_printGender=' + this.data.patientDetails.demographics.gender + '&pres_printAge=' + '' + '&header_status=' + this.mangal_header_Type
              console.log('update******')
              console.log(this.currentProjectUrl)
              this.currentProjectUrl = this.dom.bypassSecurityTrustResourceUrl(this.currentProjectUrl)

              // const dialogRef = this.dialog.open(DialogOverviewPrintTemplate, {
              //   width: '80%',
              //   height: '95vw',
              //   data: { printtemplates: this.currentProjectUrl },
              //   disableClose: true
              // });
            // });
          // }
          // else {
          //   this.appService.postData(this.urlPoints.addPreview, params, token).subscribe((response: any) => {



          //     this.preview_id = response.id;
          //     this.preview = 'Update Consultation'
          //     this.printDisabled = false;

          //     this.isPrinting = false;

          //     this.printArr.push('1')

          //     this.callprintprespopup = true;
          //     var host = environment.HOST;

          //     var type;

          //     if ((this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '2') || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '7')
          //       || (this.dmail == 'rx138310@rxcarenet.org' && this.doc_id == '1') || (this.dmail == 'rx138310@rxcarenet.org' && this.doc_id == '2')
          //       || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == '8') || (this.dmail == 'rx138824@rxcarenet.org' && this.doc_id == '1')) {
          //       type = '/briefprescription/#'
          //     }
          //     else {
          //       type = '/prescription/#'
          //     }

          //     this.currentProjectUrl = host + type + '/print/?route_path=prescription&account_email=' + this.dmail + '&overview_Id=' + this.preview_id +
          //       '&doctor_Id=' + this.doc_id + '&mr_num=' + this.patient.record_info.Record.mr_number +
          //       '&vit_date='+ this.vitDate +'&vacc_date=&vacc_msg=&dr_Name=' + this.docData.name +
          //       '&dr_regNo=' + this.docData.registration + '&auth_token=' + this.token + '&appoint_Id=' + this.appointment_id +
          //       '&followup_date=&faliculr_status=1&risk_status=1&patient_email=' +
          //       this.patient.record_info.Record.account_email + '&vital_weight=&vital_height=&vital_temp=&pres_printName='
          //       + this.patient.record_info.Record.label + '&pres_printGender=' + this.patient.demographics.gender + '&pres_printAge=' + this.y
          //     console.log('else*******')
          //     console.log(this.currentProjectUrl)
          //     this.currentProjectUrl = this.dom.bypassSecurityTrustResourceUrl(this.currentProjectUrl)

          //   });
          // }
      })

    })
  }

  sortByDate(arr) {
    arr.sort(function(a,b){
      return Number(new Date(a.date)) - Number(new Date(b.date));
    });

    return arr.reverse();
  }

}

@Component({
  selector: 'medicalHistory',
  templateUrl: 'submenus/history/medical/medical.html',
  styleUrls: ['submenus/history/medical/medical.scss']
})

export class DialogOverviewExampleDialog_medicaltHistory {

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  add_update_OpenState = false;
  success = "Updated !"

  hosmaxdate = moment(new Date()).format("YYYY-MM-DD");
  hosmindate = moment().subtract(110, 'years').format("YYYY-MM-DD");
  medicalHistory;
  listofmedicalhis;
  medicaldata;
  obsgravida;
  updatedataId;
  formcheckFlag = 'add';


  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  ngOnInit(): void {
    this.medicalHistory = this.fb.group({
      hospitalName: [""],
      drName: [""],
      date: [""],
      type: [""],
      illness: [""],
      admission: [""],
      diagnosis: [""],
      comments: [""]
    })
    this.listofMedicalHistory();
  }

  addUpdateScreenopen(status) {
    if (status == 'add') {
      this.formcheckFlag = 'add';
      this.medicalHistory.reset();
      this.medicalHistory.controls['date'].setValue(moment(new Date()).format('YYYY-MM-DD'));
      this.medicalHistory.controls['drName'].setValue("");
      this.medicalHistory.controls['hospitalName'].setValue("");
      this.medicalHistory.controls['type'].setValue("");
      this.medicalHistory.controls['diagnosis'].setValue("");
      this.medicalHistory.controls['illness'].setValue("");
      this.medicalHistory.controls['admission'].setValue("");
      this.medicalHistory.controls['comments'].setValue("");
    } else {
      this.formcheckFlag = 'update';
    }
    this.add_update_OpenState = true;
  }
  cancelMedicalHistory() {
    this.add_update_OpenState = false;
  }

  listofMedicalHistory() {
    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email
    }

    this.appService.getData(this.urlPoints.listmedicalhistory, params, this.token).subscribe((response: any) => {
      if (response) {
        this.listofmedicalhis = response.medical_history;
        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);
      }
    });

  }

  updateMedicalData(updatedata) {
    this.updatedataId = updatedata.id;
    this.medicalHistory.controls['date'].setValue(updatedata.date);
    this.medicalHistory.controls['drName'].setValue(updatedata.doctor_first_name);
    this.medicalHistory.controls['hospitalName'].setValue(updatedata.hospital_name);
    this.medicalHistory.controls['type'].setValue(updatedata.problem_type);
    this.medicalHistory.controls['diagnosis'].setValue(updatedata.diagnosis);
    this.medicalHistory.controls['illness'].setValue(updatedata.prolonged_illness);
    this.medicalHistory.controls['admission'].setValue(updatedata.admission);
    this.medicalHistory.controls['comments'].setValue(updatedata.comments);

  }

  validatemedicaldata() {

    this.medicaldata = this.medicalHistory.value;

    var hist_data = {
      account_email: this.dmail,
      medical_history: {
        date: this.medicaldata.date,
        doctor_last_name: '',
        doctor_first_name: this.medicaldata.drName,
        hospital_name: this.medicaldata.hospitalName,
        problem_type: this.medicaldata.type,
        diagnosis: this.medicaldata.diagnosis,
        prolonged_illness: this.medicaldata.illness,
        admission: this.medicaldata.admission,
        comments: this.medicaldata.comments,
        patient_email: this.data.patientDetails.record_info.Record.account_email

      }
    }
    if (this.formcheckFlag == 'add') {
      this.success = "Added !"
      this.appService.postData(this.urlPoints.addmedicalhistory, hist_data, this.token).subscribe((response: any) => {
        if (response) {
          setTimeout(() => {
            this._changeDetectorRef.markForCheck();
          }, 500);
          this.openSnackBar();
          this.cancelMedicalHistory();
          this.listofMedicalHistory();
        }
      });
    } else {
      this.success = "Updated !"
      hist_data.medical_history['history_id'] = this.updatedataId;
      this.appService.putData(this.urlPoints.addmedicalhistory, hist_data, this.token).subscribe((response: any) => {
        if (response) {
          setTimeout(() => {
            this._changeDetectorRef.markForCheck();
          }, 500);
          this.openSnackBar();
          this.cancelMedicalHistory();
          this.listofMedicalHistory();
        }
      });
    }

  }

  disableDate() {
    return false;
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '.') {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

}

@Component({
  selector: 'clinicalHistory',
  templateUrl: 'submenus/history/clinical/clinical.html',
  styleUrls: ['submenus/history/clinical/clinical.scss']
})

export class DialogOverviewExampleDialog_clinicaltHistory {
  [x: string]: any;

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  add_update_OpenState = false;
  success = "Updated !"

  prescriptionValue: any;
  complaintData;
  PrescriptionData;
  prescData;
  medicaldata;
  obsgravida;
  updatedataId;
  formcheckFlag = true;
  clinicalType: any = 0;
  defPage = false
  conHistorydata;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  ngOnInit(): void {
    this.listofclinicalHistory();
  }

  typechange(type) {
    if (type == 0) {
      this.formcheckFlag = true;
    } else {
      this.formcheckFlag = false;
    }
  }

  listofclinicalHistory() {
    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email,
      doctor_id: this.doc_id,
      user_type: 'patient'
    }

    this.appService.getData(this.urlPoints.getComplaintAttachment, params, this.token).subscribe((response: any) => {
      if (response) {
        this.complaintData = response.details
        this.prescData = response.prescription

        this.complaintData = this.complaintData.filter((res => res.compliant_img.length > 0));

        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);
      }
    });

  }

  showcompliantData(fileName) {
    if (fileName.endsWith(".pdf")) {
      window.open(environment.HOST + '/helyxonapi/cloud/pdf/upload/' + fileName);
    } else {

      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_openattachment, {
        width: 'fit-content',
        data: { patientDetails: fileName }
      });
    }
  }

  showData(fileName) {
    if (fileName.endsWith(".pdf")) {
      window.open(environment.HOST + '/PDF/' + fileName);
    } else {

      const dialogRef = this.dialog.open(DialogOverviewExampleDialog_openattachment, {
        width: 'fit-content',
        data: { patientDetails: fileName }
      });
    }
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '/' || event.key === '@' || event.key === ',') {
      return;
    } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

  getExternalClinhistory(){
    this.defPage = true

    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email
    }
    this.appService.postData(this.urlPoints.externalclinicaldata, params, this.token).subscribe((response: any) => {
      console.log('response::',response);
      if(response.success==1){
        this.conHistorydata = response.message
        console.log(this.conHistorydata);
      }
    });
  }

}

@Component({
  selector: 'openattachment',
  templateUrl: 'submenus/history/clinical/openattachment.html',
  styleUrls: ['submenus/history/clinical/openattachment.scss']
})
export class DialogOverviewExampleDialog_openattachment {
  imageViewUrl;
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_bottomdatas) {
  }
  ngOnInit(): void {
    this.imageViewUrl = environment.HOST + '/helyxonapi/cloud/image/upload/' + this.data.patientDetails;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'questionareetHistory',
  templateUrl: 'submenus/profile/questionarie/familyhistory.html',
  styleUrls: ['submenus/profile/questionarie/familyhistory.scss']
})

export class DialogOverviewExampleDialog_familyhistory {

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  add_update_OpenState = false;
  success = "Updated !"
  questionData;

  pastmedicalQuest = false;
  persHealth = false;
  pastmedicalHis = false;
  medication = false;
  familymedical = false;
  socialpersonal = false;

  pastmedicalQuest_FileName = '';
  persHealth_FileName = '';
  pastmedicalHis_FileName = '';
  medication_FileName = '';
  familymedical_FileName = '';
  socialpersonal_FileName = '';
  familyhistory;

  familyeditStatus = false;
  mothereditStatus = false;
  siblingeditStatus = false
  anyfatherdailymedication;
  isfatherhospitalized;
  fathermedicationtext;
  fatherhospitalizedtext;
  fatherfoodtype;
  fatherhealthissues;
  relationfather;
  fatherHereditary;
  motherdata;

  enablemedication;
  father_hospitalization;

  //motherdob
  relationmother;
  motherhealthissues;
  anymotherdailymedication: any = 0;
  mothermedicationtext;
  ismotherhospitalized;
  motherhospitalizedtext;
  motherfoodtype;

  enablemothermedication;
  mother_hospitalization;
  motherhereditarydisease;

  //sibling history

  siblinghistory;
  siblingfirstname;
  siblingsecondname;
  siblingdob;
  siblinggender;
  siblingmajorhealthissues;
  siblingdailymedication;
  siblinghospitalization;
  siblingotherissues;
  siblinghospitaltext;
  siblingdaily_medication;
  addStatus = '';
  any_daily_medication = false;
  sibling__hospitalization = false;

  accountsetting;
  siblingupdateStatus = "";
  siblingsId;
  siblingsPatientAcc;
  siblingsDrAcc;



  patientmaxdate = moment(new Date()).format("YYYY-MM-DD");
  patientmindate = moment().subtract(110, 'years').format("YYYY-MM-DD");

  parentshistory: any = [];
  siblingshistory: any = [];

  addsiblings = [];
  doctor_account_id: any;
  patient_account_id: any;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_familyhistory>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;

    this.familyhistory = this.fb.group({
      // peopleinHouse: [""],
      // roomsinHouse: [""],
      // typeofStove:[""],
      // distance:[""],
      // distanceType:[""],
      // typeofTrans:[""],
      // probPreventing:[],
      // waterPollution:[""]

    });

    this.siblinghistory = this.fb.group({
      // peopleinHouse: [""],
      // roomsinHouse: [""],
      // typeofStove:[""],
      // distance:[""],
      // distanceType:[""],
      // typeofTrans:[""],
      // probPreventing:[],
      // waterPollution:[""]
    });
  }

  ngOnInit(): void {

    this.getparentshistoryData()
    this.getsiblingshistoryData()
  }

  fatherupdate() {
    this.familyeditStatus = true;
    this.enablemedication = false;
    this.father_hospitalization = false;
  }

  cancelfatherstatus() {
    this.familyeditStatus = false;
    this.enablemedication = false;
    this.father_hospitalization = false;
  }

  disableDate() {
    return false;
  }


  savefatherstatus() {
    this.fatherfoodtype = this.fatherfoodtype == 0 ? 'Vegetarian' : this.fatherfoodtype == 1 ? 'Non-Veg' : 'Egg + Vegetarian';
    var params = {
      "parent_history": {
        "relation": "Father",
        "mode": "view",
        "health_issues": this.fatherhealthissues,
        "medication": this.enablemedication,
        "medication_text": this.fathermedicationtext,
        "hospitalization": this.father_hospitalization,
        "hospitalization_text": this.fatherhospitalizedtext,
        "food_type": this.fatherfoodtype,
        "hereditary_disease": this.fatherHereditary,
        "patient_email": this.data.patientDetails.record_info.Record.account_email,
        "dob": null
      },
      "account_email": this.dmail,
      "user_type": "doctor"
    }

    if (this.parentshistory != undefined) {
      params.parent_history["id"] = this.parentshistory.id;
      params.parent_history["patient_account"] = this.parentshistory.patient_account;
      params.parent_history["doctor_account"] = this.parentshistory.doctor_account;
    }

    if (this.parentshistory == undefined) {
      var serviceURL = this.urlPoints.addparenthistory;
      this.success = "Created successfully !";
    } else {
      var serviceURL = this.urlPoints.updateparenthistory;
      this.success = "Updated successfully !";
    }

    this.appService.postData(serviceURL, params, this.token).subscribe((response: any) => {

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.getparentshistoryData();
      this.openSnackBar();
      this.cancelfatherstatus();

    });

    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);

  }


  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  dailymedication(data) {
    if (data == 'true') {
      this.enablemedication = true;
    } else if (data == 'false') {
      this.enablemedication = false;
    }
  }

  fatherhospitalization(data) {
    if (data == 'true') {
      this.father_hospitalization = true;
    } else if (data == 'false') {
      this.father_hospitalization = false;
    }
  }

  callmothermedication(data) {

    if (data == 'true') {
      this.enablemothermedication = true;
    } else if (data == 'false') {
      this.enablemothermedication = false;
    }
  }

  motherhospitalization(data) {
    if (data == 'true') {
      this.mother_hospitalization = true;
    } else if (data == 'false') {
      this.mother_hospitalization = false;
    }
  }




  cancelsiblingeditStatus() {
    this.siblingeditStatus = false;
  }

  anydaily_medication(data) {
    if (data == 'Yes') {
      this.any_daily_medication = true;
    } else if (data == 'No') {
      this.any_daily_medication = false;
    }
  }

  sibling_hospitalization(data) {

    if (data == 'Yes') {
      this.sibling__hospitalization = true;
    } else if (data == 'No') {
      this.sibling__hospitalization = false;
    }
  }

  siblingeditStatusupdate(getUpdatedata) {
    this.siblingeditStatus = true;

    this.siblingfirstname = getUpdatedata.first_name;
    this.siblingsecondname = getUpdatedata.last_name;
    this.siblingdob = getUpdatedata.dob;
    this.siblinggender = getUpdatedata.gender == 'Male' ? 0 : getUpdatedata.gender == 'Female' ? 1 : '';
    this.siblingmajorhealthissues = getUpdatedata.health_issues;
    this.siblingdailymedication = getUpdatedata.medication == "True" ? 0 : getUpdatedata.medication == "False" ? 1 : '';
    this.siblingdaily_medication = getUpdatedata.medication_text;
    this.siblinghospitalization = getUpdatedata.hospitalization == "True" ? 0 : getUpdatedata.hospitalization == "False" ? 1 : '';
    this.siblinghospitaltext = getUpdatedata.hospitalization_text;
    this.siblingotherissues = getUpdatedata.other_details;
    this.siblingsId = getUpdatedata.id;
    this.siblingsPatientAcc = getUpdatedata.patient_account;
    this.siblingsDrAcc = getUpdatedata.doctor_account;
    this.siblingupdateStatus = getUpdatedata;

  }
  addSibilings() {
    var newsibDetails = "";
    this.siblingshistory.push(newsibDetails);

  }

  deleteSibilings(data:any) {
    // if (this.siblingshistory[this.siblingshistory.length - 1].id == undefined) {
    //   this.siblingshistory.pop();
    // }
    var param = {
      "patient_account": this.patient_account_id,
      'doctor_account': this.doctor_account_id,
      "account_email": this.dmail,
      "id":data.id
    }
    this.appService.postData(this.urlPoints.deletesiblinghistory,param,this.token).subscribe((res:any)=>{
      console.log(res);
      if(res.success == 1){
             setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.getsiblingshistoryData();
      }else{
      }
    })
  }

  savesiblingeditStatus() {

    var params = {
      "sibling_history": {
        "first_name": this.siblingfirstname,
        "last_name": this.siblingsecondname,
        "opened": false,
        "dob": this.siblingdob,
        "gender": this.siblinggender == 0 ? 'Male' : 'Female',
        "health_issues": this.siblingmajorhealthissues,
        //"medication": this.siblingdailymedication == 0 ? 'Yes' : 'No',
        "medication": this.any_daily_medication,
        "medication_text": this.siblingdaily_medication,
        //"hospitalization": this.siblinghospitalization == 0 ? 'Yes' : 'No',
        "hospitalization": this.sibling__hospitalization,
        "hospitalization_text": this.siblinghospitaltext,
        "other_details": this.siblingotherissues,
        "patient_email": this.data.patientDetails.record_info.Record.account_email,
        "patient_account": this.getauthdetails.account_id,
        'doctor_account': this.doc_id

      },
      "account_email": this.dmail,
      "user_type": "doctor",
      "patient_email": this.data.patientDetails.record_info.Record.account_email
    }

    if (this.siblingupdateStatus != "") {
      params.sibling_history["id"] = this.siblingsId;
      params.sibling_history["patient_account"] = this.siblingsPatientAcc;
      params.sibling_history["doctor_account"] = this.siblingsDrAcc;
    }

    if (this.siblingupdateStatus == "") {
      var serviceURL = this.urlPoints.addsiblinghistory;
      this.success = "Created successfully !";
    } else {
      var serviceURL = this.urlPoints.updatesiblinghistory;
      this.success = "Updated successfully !";
    }


    this.appService.postData(serviceURL, params, this.token).subscribe((response: any) => {

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.getsiblingshistoryData();
      this.cancelsiblingeditStatus();
      this.openSnackBar();
    });

    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);
  }


  motherupdate() {
    this.mothereditStatus = true;
  }
  cancelmotherstatus() {
    this.mothereditStatus = false;
  }
  savemotherstatus() {
    this.motherfoodtype = this.motherfoodtype == 0 ? 'Vegetarian' : this.motherfoodtype == 1 ? 'Non-Veg' : 'Egg + Vegetarian';
    this.ismotherhospitalized = this.ismotherhospitalized == 0 ? true : this.ismotherhospitalized == 1 ? false : '';

    var params = {
      "parent_history": {
        "relation": "Mother",
        "mode": "view",
        "health_issues": this.motherhealthissues,
        "medication": this.enablemothermedication,
        "medication_text": this.mothermedicationtext,
        "hospitalization": this.ismotherhospitalized,
        "hospitalization_text": this.motherhospitalizedtext,
        "food_type": this.motherfoodtype,
        "hereditary_disease": this.motherhereditarydisease,
        "patient_email": this.data.patientDetails.record_info.Record.account_email,
        "dob": null
      },
      "account_email": this.dmail,
      "user_type": "doctor"
    }

    if (this.motherdata != undefined) {
      params.parent_history["id"] = this.motherdata.id;
      params.parent_history["patient_account"] = this.motherdata.patient_account;
      params.parent_history["doctor_account"] = this.motherdata.doctor_account;
    }

    if (this.motherdata == undefined) {
      var serviceURL = this.urlPoints.addparenthistory;
      this.success = "Created successfully !";
    } else {
      var serviceURL = this.urlPoints.updateparenthistory;
      this.success = "Updated successfully !";
    }

    this.appService.postData(serviceURL, params, this.token).subscribe((response: any) => {
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.getparentshistoryData();
      this.cancelmotherstatus();
      this.openSnackBar();
    });

    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);
  }


  getparentshistoryData() {
    var data = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "account_email": this.dmail,
      "user_type": "doctor"
    }

    this.appService.postData(this.urlPoints.getparentshistory, data, this.token).subscribe((response: any) => {
      this.parentshistory = response.parents_history[0];
      //if(this.parentshistory.relation!='Father')
      this.motherdata = response.parents_history[1];

      this.fatherhealthissues = this.parentshistory.health_issues;
      this.anyfatherdailymedication = this.parentshistory.medication == "True" ? 0 : this.parentshistory.medication == "False" ? 1 : '';
      this.fathermedicationtext = this.parentshistory.medication_text;
      this.isfatherhospitalized = this.parentshistory.hospitalization == "True" ? 0 : this.parentshistory.hospitalization == "False" ? 1 : '';
      this.fatherhospitalizedtext = this.parentshistory.hospitalization_text;
      this.fatherfoodtype = this.parentshistory.food_type == 'Vegetarian' ? 0 : this.parentshistory.food_type == 'Non-Veg' ? 1 : 2;
      this.fatherHereditary = this.parentshistory.hereditary_disease;

      this.motherhealthissues = this.motherdata.health_issues;
      this.anymotherdailymedication = this.motherdata.medication == "True" ? 0 : this.motherdata.medication == "False" ? 1 : '';
      this.mothermedicationtext = this.motherdata.medication_text;
      this.ismotherhospitalized = this.motherdata.hospitalization == "True" ? 0 : this.motherdata.hospitalization == "False" ? 1 : '';
      this.motherhospitalizedtext = this.motherdata.hospitalization_text;
      this.motherfoodtype = this.motherdata.food_type == 'Vegetarian' ? 0 : this.motherdata.food_type == 'Non-Veg' ? 1 : 2;
      this.motherhereditarydisease = this.motherdata.hereditary_disease;


      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });
  }

  getsiblingshistoryData() {

    var data = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "account_email": this.dmail,
      "user_type": "doctor"
    }

    this.appService.postData(this.urlPoints.getsiblinghistory, data, this.token).subscribe((response: any) => {
      //this.siblingshistory = response.sibling_history[0];
      this.siblingshistory = response.sibling_history;
      this.doctor_account_id= response.sibling_history[0].doctor_account;
      this.patient_account_id= response.sibling_history[0].patient_account;
      //this.addsiblings.push(this.siblingshistory);

    });
  }



  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }


}

@Component({
  selector: 'questionareetHistory',
  templateUrl: 'submenus/profile/questionarie/questionaire.html',
  styleUrls: ['submenus/profile/questionarie/questionaire.scss']
})

export class DialogOverviewExampleDialog_questionareetHistory {

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  add_update_OpenState = false;
  success = "Updated !"
  questionData;

  pastmedicalQuest = false;
  persHealth = false;
  pastmedicalHis = false;
  medication = false;
  familymedical = false;
  socialpersonal = false;

  pastmedicalQuest_FileName = '';
  persHealth_FileName = '';
  pastmedicalHis_FileName = '';
  medication_FileName = '';
  familymedical_FileName = '';
  socialpersonal_FileName = '';



  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  ngOnInit(): void {
    this.getQuestPdf();
  }

  getQuestPdf() {
    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email
    }

    this.appService.getData(this.urlPoints.getQuestPdf, params, this.token).subscribe((response: any) => {
      if (response) {
        this.questionData = response.data;
        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);
        this.historyattachementShowing();
      }
    });

  }

  historyattachementShowing() {
    for (var i = 0; i < this.questionData.length; i++) {
      if (this.questionData[i].category_name == 'general') {
        this.pastmedicalQuest = true;
        this.pastmedicalQuest_FileName = this.questionData[i].pdf_file;
      }
      if (this.questionData[i].category_name == 'personal_health_history') {
        this.persHealth = true;
        this.persHealth_FileName = this.questionData[i].pdf_file;
      }
      if (this.questionData[i].category_name == 'past_medical_history') {
        this.pastmedicalHis = true;
        this.pastmedicalHis_FileName = this.questionData[i].pdf_file;
      }
      if (this.questionData[i].category_name == 'medication_history') {
        this.medication = true;
        this.medication_FileName = this.questionData[i].pdf_file;
      }
      if (this.questionData[i].category_name == 'family_medical_history') {
        this.familymedical = true;
        this.familymedical_FileName = this.questionData[i].pdf_file;
      }
      if (this.questionData[i].category_name == 'social_personal_history') {
        this.socialpersonal = true;
        this.socialpersonal_FileName = this.questionData[i].pdf_file;
      }
    }
  }

  showattachmentPdf(fileName) {
    window.open(environment.HOST + '/PDF/' + fileName);
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }
}

@Component({
  selector: 'paediatricsMilestone',
  templateUrl: 'submenus/paediatrics/milestone/milestone.html',
  styleUrls: ['submenus/paediatrics/milestone/milestone.scss']
})

export class DialogOverviewExampleDialog_paediatricsMilestone {

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  add_update_OpenState = false;
  success = "Updated !";

  currentage;
  highcharts = Highcharts;
  milestone_color = [];
  milestonedata = [];
  milestone_data = [];
  options;
  setmilestonetype;
  hidetimelinedata;
  temppush = [];
  viewmilestonepatienthistory;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  ngOnInit(): void {
    sessionStorage.setItem("patientemail", this.data.patientDetails.record_info.Record.account_email);
    sessionStorage.setItem("patientname", this.data.patientDetails.demographics.name_given)
    this.milestone();
    this.getmilestonelist();
  }

  milestone() {
    var param = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email,
    }
    var params = {
      account_email: this.dmail
    }

    this.appService.getData(this.urlPoints.milestonechartdetails, param, this.token).subscribe((response: any) => {
      this.currentage = Math.ceil(response.data.age_in_months)
      for (var i = 0; i < response.data.chart.length; i++) {
        if (response.data.chart[i].status == 'Yes') {
          this.milestone_color.push('#03C653')
        } else if (response.data.chart[i].status == 'Not Yet') {
          this.milestone_color.push('#FF5733')
        } else if (response.data.chart[i].status == 'Sometimes') {
          this.milestone_color.push('#FEC617')
        } else if (response.data.chart[i].status == 'Future') {
          this.milestone_color.push('#DB7093')
        } else if (response.data.chart[i].status == 'To be answered') {
          this.milestone_color.push('#B2B2B2')
        } else if (response.data.chart[i].status == 'Rejected') {
          this.milestone_color.push('black')
        }
      }

      this.appService.getData(this.urlPoints.milestonechartdetails, param, this.token).subscribe((response: any) => {

        if (response) {
          this.milestonedata = [];
          this.milestone_data = [];
          for (var i = 0; i < response.data.chart.length; i++) {
            if (response.data.chart[i].active == true) {
              this.milestonedata.push([response.data.chart[i].start, response.data.chart[i].end])
              console.log(response.data.chart[i].item);
              // const numberofData = this.getDynamicNumberOfChunks();
              // this.splitStringEvenly(response.data.chart[i].item, numberofData);
              // this.milestone_data.push(response.data.chart[i].item);
              // this.processString(response.data.chart[i].item)
              this.processStrings1(response.data.chart[i].item);
              console.log(this.milestone_data,'24170');
            }
          }
        }

        this.options = {
          chart: {
            type: 'columnrange',
            inverted: true
          },

          accessibility: {
            description: ''
          },
          credits: {
            enabled: false
          },

          title: {
            text: ''
          },

          xAxis: {
            tickInterval: 0,
            labels: {
              enabled: false,
              
            },
            categories: this.milestone_data.reverse()
          },

          yAxis: {
            tickInterval: 1,
            title: {
              text: 'Age in months'
            },
            plotLines: [{
              color: '#FF0000',
              width: 2,
              value: this.currentage - 1
            }],
          },


          plotOptions: {
            columnrange: {
              dataLabels: {
                enabled: false,
                format: '{x}'
              },
              colorByPoint: true,
              colors: this.milestone_color.reverse()

            }
          },

          legend: {
            enabled: false
          },

          series: [{
            name: 'Age in months',
            data: this.milestonedata.reverse()
          }]

        }

        Highcharts.chart('milestones', this.options)

        console.log(this.options,'highcharts');
        
      });

    });

  }

  // This method should return the dynamic number of chunks
  // getDynamicNumberOfChunks(): any {
  //   // Replace with actual logic to determine the number of chunks
  //   return 2; // Example value, replace with your dynamic logic
  // }

  getDynamicNumberOfChunks(str: any): any {
    // Example logic: you can adjust this based on your requirements
    // For instance, one chunk per 5 characters
    const baseChunkSize = 2;
    return Math.ceil(str.length / baseChunkSize);
  }

  splitStringEven(str: any, numberOfChunks: any): any[] {
    if (numberOfChunks <= 0) {
      console.error('Number of chunks must be greater than 0');
      return [];
    }
  
    const chunkSize = Math.ceil(str.length / numberOfChunks);
    const chunks: string[] = [];
  
    for (let i = 0; i < numberOfChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, str.length);
      chunks.push(str.substring(start, end));
    }
  
    return chunks;
  }

  splitStringEvenly(str: any, numberOfChunks: any) {
    if (numberOfChunks <= 0) {
      console.error('Number of chunks must be greater than 0');
      return;
    }

    // Determine the length of each chunk
    const chunkSize = Math.ceil(str.length / numberOfChunks);
    const chunks: string[] = [];

    for (let i = 0; i < numberOfChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, str.length);
      chunks.push(str.substring(start, end));
    }

    return chunks;
    
    // Log the results for debugging purposes
    // console.log('Chunks:', this.chunks);
  }

  processString(strings: any) {
    const numberOfChunks = this.getDynamicNumberOfChunks(strings);
    const chunks = this.splitStringEvenly(strings, numberOfChunks);
  
    // Log the results for debugging purposes
    console.log('Chunks:', chunks);
  
    return chunks;
  }
  

  processStrings(str: any) {
    // this.milestone_data = strings.map(str => this.splitStringEvenly(str, numberOfChunks));
    
    // // Log the results for debugging purposes
    // console.log('All Chunks:', this.milestone_data);
    const numberOfChunks = this.getDynamicNumberOfChunks(str);
    const chunks = this.splitStringEvenly(str, numberOfChunks);
  
    // Log the results for debugging purposes
    console.log('Chunks:', chunks);
  
    return chunks;
  }

  splitStringByWordCount(str: any): any {
    const words = str.split(' '); // Split the string by spaces to get all words
    const totalWords = words.length;
    const splitPoint = Math.ceil(totalWords / 2); // Calculate the midpoint
  
    const firstChunk = words.slice(0, splitPoint).join(' '); // First half of the words
    const secondChunk = words.slice(splitPoint).join(' ');   // Second half of the words
  
    return [firstChunk, secondChunk];
  }

  processStrings1(input: any) {
    // const allChunks: { originalString: string, chunks: string[] }[] = [];

    // Ensure the input is always an array
    const strings = Array.isArray(input) ? input : [input];

    strings.forEach(str => {
      const chunks = this.splitStringByWordCount(str);
      this.milestone_data.push(chunks);
    });
  
    // Log the results for debugging purposes
    console.log('All Chunks:', this.milestone_data);
  
    return this.milestone_data;
  }
  

  getmilestonelist() {
    let params = {
      "account_email": this.dmail,
    }
    this.appService.getData(this.urlPoints.getmilestonelist, params, this.token).subscribe((response: any) => {
      if (response) {
        if (response.milestones[0].type == "TDSC") {
          this.setmilestonetype = 1
          sessionStorage.setItem("milestonetype", this.setmilestonetype)
        } else if (response.milestones[0].type == "LEST") {
          this.setmilestonetype = 2
          sessionStorage.setItem("milestonetype", this.setmilestonetype)
        } else if (response.milestones[0].type == "NHS") {
          this.setmilestonetype = 3
          sessionStorage.setItem("milestonetype", this.setmilestonetype)
        } else if (response.milestones[0].type == "CDCA") {
          this.setmilestonetype = 4
          sessionStorage.setItem("milestonetype", this.setmilestonetype)
        } 

        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);
        this.getmilestonepatienthistory()
      }
    })
  }

  getmilestonepatienthistory() {
    let data = {
      "account_email": this.dmail,
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "type": this.setmilestonetype
    }
    this.appService.getData(this.urlPoints.getpatienthistory, data, this.token).subscribe((response: any) => {
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      if (response.length > 0) {
        // if (response[0].answer_status == "") {
        //   this.hidetimelinedata = true
        // }
        this.temppush = []
        for (var i = 0; i < response.length; i++) {
          if (response[i].answer_status != "") {
            // this.hidetimelinedata = true
            // if(response[i].answer_status=='Unspecified'){
            //   this.hidetimelinedata = true
            // }else{
              this.hidetimelinedata = false
              // if (response[i].answer_status == "Yes" || response[i].answer_status == "yes" || response[i].answer_status == "Not Yet" || response[i].answer_status == "not yet" || response[i].answer_status == "Sometimes" || response[i].answer_status == "sometimes") {
                this.temppush.push((response[i]))
                // this.hidetimelinedata = false
                // break;
              // }else{
                // this.hidetimelinedata = true
              // }
            // }
          }else{
            this.hidetimelinedata = true
          }

        }
        this.viewmilestonepatienthistory = this.temppush
        // if(response.status !== ""){
        //   this.hidetimelinedata = false
        // this.viewmilestonepatienthistory = response
        // }
      } else {
        this.hidetimelinedata = true
      }
    });
  }

  openviewmilestonepicture(data) {
    sessionStorage.setItem("milestonetimeline", data)
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogmilestonepicture, {
      width: '1200px',
      data: { option: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getmilestonepatienthistory();

    });
  }

  openstatusedit(index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogstatusedit, {
      width: '650px',
      height: '225px',
      data: this.viewmilestonepatienthistory[index]
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getmilestonepatienthistory();
      this.milestone()

    });
  }


  milestonechangedrstatus(trackerid, id, status) {
    let data = {
      "account_email": this.dmail,
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "tracker_id": trackerid,
      "milestone": [{
        "id": id,
        "doctor_approval_status": status
      }]
    }
    this.appService.postData(this.urlPoints.updatedoctorapproval, data, this.token).subscribe((response: any) => {
      this.toastr.success("Doctor status changed successfully")
      this.getmilestonepatienthistory()
      this.milestone()
    });
  }


  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }
}
@Component({
  selector: 'paediatricsMotherAntenatal',
  templateUrl: 'submenus/paediatrics/motherAntenatal/motherAntenatal.html',
  styleUrls: ['submenus/paediatrics/motherAntenatal/motherAntenatal.scss']
})

export class DialogOverviewExampleDialog_paediatricsMotherantenatal {

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  add_update_OpenState = false;
  success = "Updated !";

  motherAntenatal;
  antentaldata;
  diabetes: any = 1;
  hypoThyroidism: any = 1;
  fits: any = 0;
  urinaryInfection: any = 1;
  editStatus = false;
  getMotherData;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  ngOnInit(): void {
    this.motherAntenatal = this.fb.group({
      checkups: [""],
      babydelviery: [""],
    });
    this.getMotherantenatal();
  }

  getMotherantenatal() {

    var data = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "account_email": this.dmail, "user_type": "doctor"
    }

    this.appService.postData(this.urlPoints.doctorgetantenatal, data, this.token).subscribe((response: any) => {
      this.getMotherData = response.antenatal;
    });
  }

  updateStatus() {
    this.editStatus = true;
    this.motherAntenatal.controls['checkups'].setValue(this.getMotherData.check_up);
    this.motherAntenatal.controls['babydelviery'].setValue(this.getMotherData.delivery);
    if (this.getMotherData.diabetes == 'yes') {
      this.diabetes = 0;
    } else {
      this.diabetes = 1;
    }
    if (this.getMotherData.hypo_thyroidism == 'yes') {
      this.hypoThyroidism = 0;
    } else {
      this.hypoThyroidism = 1;
    }
    if (this.getMotherData.fits == 'yes') {
      this.fits = 0;
    } else {
      this.fits = 1;
    }
    if (this.getMotherData.urinary_infection == 'yes') {
      this.urinaryInfection = 0;
    } else {
      this.urinaryInfection = 1;
    }
  }

  cancelStatus() {
    this.editStatus = false;
  }

  validatemotherAntel() {
    this.antentaldata = this.motherAntenatal.value;

    if (this.diabetes == 0) {
      var diabetestype = 'yes'
    } else {
      var diabetestype = 'no'
    }
    if (this.hypoThyroidism == 0) {
      var hypoThyroidismtype = 'yes'
    } else {
      var hypoThyroidismtype = 'no'
    }
    if (this.fits == 0) {
      var fitstype = 'yes'
    } else {
      var fitstype = 'no'
    }
    if (this.urinaryInfection == 0) {
      var urinaryInfectiontype = 'yes'
    } else {
      var urinaryInfectiontype = 'no'
    }

    var motherAntenatalobj = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "check_up": this.antentaldata.checkups,
      "delivery": this.antentaldata.babydelviery,
      "diabetes": diabetestype,
      "hypo_thyroidism": hypoThyroidismtype,
      "fits": fitstype,
      "urinary_infection": urinaryInfectiontype,
    }
    var data = {
      "antenatal": motherAntenatalobj,
      "account_email": this.dmail, "user_type": "doctor"
    }

    if (this.getMotherData == '') {
      var serviceURL = this.urlPoints.doctorcreateantenatal;
      this.success = "Created successfully !";
    } else {
      var serviceURL = this.urlPoints.doctorupdateantenatal;
      this.success = "Updated successfully !";
    }

    this.appService.postData(serviceURL, data, this.token).subscribe((response: any) => {
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.openSnackBar();
      this.cancelStatus();
      this.getMotherantenatal();
    });

  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '.') {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }
}

@Component({
  selector: 'paediatricBabyHistory',
  templateUrl: 'submenus/paediatrics/babyHistory/babyHistory.html',
  styleUrls: ['submenus/paediatrics/babyHistory/babyHistory.scss']
})

export class DialogOverviewExampleDialog_paediatricBabyHistory {

  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  dob2;
  add_update_OpenState = false;
  success = "Updated !";
  apgar;

  babyHistory;
  newbornbabyHistory;
  atBirthdata;
  babycry: any = 1;
  timeDelay: any = 1;
  nicu: any = 1;
  editStatus = false;
  getMotherData;
  dischargechangeval;
  feedingchangeval;
  nofeedingchangeval;

  newbornEditStatus = false;
  getNewBornData;
  newBorndata;
  babyJaundice: any = 1;
  maxLevel: any = 1;
  sugar: any = 1;
  infection: any = 1;
  breathDifficulty: any = 1;
  babyfits: any = 1;
  heartProb: any = 1;
  anyotherprob: any = 1;
  birthNormal: any = 0;
  hearing: any = 1;
  admittedReason: any = 1;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  ngOnInit(): void {
    this.babyHistory = this.fb.group({
      apgarscore: [""],
      delivery: [""],
      passUrine: [""],
      passMotion: [""],
      breastFeeding: [""],
      babyDischarged: [""],
      babyWeight: [""],
      babylenght: [""],
      babyHC: [""],
      babyweightBirth: [""],
      babyheightBirth: [""],
      babyHCBirth: [""],
      feeding: [""],
      reasonForAdmission: [""],
      reasonForDelay: [""],
      nofeeding: [""],
      reasonForMedicalfeed: [""]
    });
    this.newbornbabyHistory = this.fb.group({
      eye: [""],
      maxLevel: [""],
      lowestsugar: [""],
      infectionDes: [""],
      tyroid: [""],
      metabolic: [""],
      hipExam: [""],
      femorals: [""],
      pulseOXY: [""],
      prethDesc: [""],
      fitsDesc: [""],
      heartprobDesc: [""],
      otherprobDesc: [""],
      testiclesDescend: [""],
      yesadmitted: [""]
    });
    this.getAtbirthData();
    this.getNewbornData();
  }

  getAtbirthData() {

    var data = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "account_email": this.dmail, "user_type": "doctor"
    }

    this.appService.postData(this.urlPoints.getbirthhistory, data, this.token).subscribe((response: any) => {
      this.getMotherData = response.birth_history;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      if (Object.keys(this.getMotherData).length === 0) {
        this.getMotherData = '';
      }
    });
  }

  getNewbornData() {

    var data = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "account_email": this.dmail, "user_type": "doctor"
    }

    this.appService.postData(this.urlPoints.getnewbornhistory, data, this.token).subscribe((response: any) => {
      this.getNewBornData = response.new_born_history;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      if (Object.keys(this.getNewBornData).length === 0) {
        this.getNewBornData = '';
      }
    });
  }

  dischargeChange() {
    let formvalue = this.babyHistory.value;
    this.dischargechangeval = formvalue.babyDischarged;
  }

  feedingChange() {
    let formvalue = this.babyHistory.value;
    this.feedingchangeval = formvalue.feeding;
  }
  notfeedingChange() {
    let formvalue = this.babyHistory.value;
    this.nofeedingchangeval = formvalue.nofeeding;
  }

  updateStatus() {
    this.editStatus = true;
    this.babyHistory.controls['apgarscore'].setValue(this.getMotherData.score);
    this.babyHistory.controls['delivery'].setValue(this.getMotherData.delivery);
    this.babyHistory.controls['passUrine'].setValue(this.getMotherData.urine).titlecase();
    this.babyHistory.controls['passMotion'].setValue(this.getMotherData.motion);
    this.babyHistory.controls['breastFeeding'].setValue(this.getMotherData.breast_feeding_start);
    this.babyHistory.controls['reasonForAdmission'].setValue(this.getMotherData.nicu_admit_reason);
    this.babyHistory.controls['babyDischarged'].setValue(this.getMotherData.discharge_duration);
    this.babyHistory.controls['reasonForDelay'].setValue(this.getMotherData.discharge_delay_reason);
    this.babyHistory.controls['babyWeight'].setValue(this.getMotherData.discharge_weight);
    this.babyHistory.controls['babyweightBirth'].setValue(this.getMotherData.birth_weight);
    this.babyHistory.controls['babylenght'].setValue(this.getMotherData.discharge_height);
    this.babyHistory.controls['babyHC'].setValue(this.getMotherData.discharge_head_circumference);
    this.babyHistory.controls['feeding'].setValue(this.getMotherData.feeding);
    this.babyHistory.controls['nofeeding'].setValue(this.getMotherData.supplement_reason);
    this.babyHistory.controls['reasonForMedicalfeed'].setValue(this.getMotherData.medical_reason);
    this.babyHistory.controls['babyHCBirth'].setValue(this.getMotherData.birth_head_circumference);
    this.babyHistory.controls['babyheightBirth'].setValue(this.getMotherData.birth_height);
    this.apgar = this.getMotherData.score;

    if (this.getMotherData.cry == 'yes') {
      this.babycry = 0;
    } else {
      this.babycry = 1;
    }
    if (this.getMotherData.time_delay == 'yes') {
      this.timeDelay = 0;
    } else {
      this.timeDelay = 1;
    }
    if (this.getMotherData.is_nicu_admission == 'yes') {
      this.nicu = 0;
    } else {
      this.nicu = 1;
    }
  }

  cancelStatus() {
    this.editStatus = false;
  }

  validateBabyAtbirth() {
    this.atBirthdata = this.babyHistory.value;

    if (this.babycry == 0) {
      var babycrytype = 'Yes'
    } else {
      var babycrytype = 'No'
    }
    if (this.timeDelay == 0) {
      var timeDelaytype = 'Yes'
    } else {
      var timeDelaytype = 'No'
    }
    if (this.nicu == 0) {
      var nicutype = 'Yes'
    } else {
      var nicutype = 'No'
    }


    var birthobj = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "birth_head_circumference": this.atBirthdata.babyHCBirth,
      "birth_height": this.atBirthdata.babyheightBirth,
      "birth_weight": this.atBirthdata.babyweightBirth,
      "breast_feeding_start": this.atBirthdata.breastFeeding,
      "cry": babycrytype,
      "cry_reason": "",
      "delivery": this.atBirthdata.delivery,
      "discharge_delay_reason": this.atBirthdata.reasonForDelay,
      "discharge_duration": this.atBirthdata.babyDischarged,
      "discharge_head_circumference": this.atBirthdata.babyHC,
      "discharge_height": this.atBirthdata.babylenght,
      "discharge_weight": this.atBirthdata.babyWeight,
      "feeding": this.atBirthdata.feeding,
      "is_nicu_admission": nicutype,
      "is_time_delay": "",
      "medical_reason": this.atBirthdata.reasonForMedicalfeed,
      "motion": this.atBirthdata.passMotion,
      "nicu_admit_reason": this.atBirthdata.reasonForAdmission,
      "score": this.atBirthdata.apgarscore,
      "supplement_reason": this.atBirthdata.nofeeding,
      "time_delay": timeDelaytype,
      "urine": this.atBirthdata.passUrine
    }



    if (this.getMotherData != '') {
      birthobj["modified_at"] = new Date();
      birthobj["id"] = this.getMotherData.id;
      birthobj["doctor_account"] = this.getMotherData.doctor_account;
      birthobj["patient_account"] = this.getMotherData.patient_account;
      birthobj["creator"] = this.getMotherData.creator;
    }

    var data = {
      "birth_history": birthobj,
      "account_email": this.dmail, "user_type": "doctor"
    }


    if (this.getMotherData == '') {
      var serviceURL = this.urlPoints.addbirthhistory;
      this.success = "Created successfully !";
    } else {
      var serviceURL = this.urlPoints.updatebirthhistory;
      this.success = "Updated successfully !";
    }

    if (this.atBirthdata.delivery == '' || this.atBirthdata.feeding == '') {
      this.toastr.error("Please select all mandatory fields");
    } else {
      this.appService.postData(serviceURL, data, this.token).subscribe((response: any) => {
        setTimeout(() => {
          this._changeDetectorRef.markForCheck();
        }, 500);
        this.openSnackBar();
        this.cancelStatus();
        this.getAtbirthData();
      });
    }

  }

  updateNewbornStatus() {
    this.newbornEditStatus = true;
    this.newbornbabyHistory.controls['maxLevel'].setValue(this.getNewBornData.jaundice_level);
    this.newbornbabyHistory.controls['lowestsugar'].setValue(this.getNewBornData.sugar_level);
    this.newbornbabyHistory.controls['infectionDes'].setValue(this.getNewBornData.infection_text);
    this.newbornbabyHistory.controls['prethDesc'].setValue(this.getNewBornData.breadth_difficulty_text);
    this.newbornbabyHistory.controls['fitsDesc'].setValue(this.getNewBornData.fits_text);
    this.newbornbabyHistory.controls['heartprobDesc'].setValue(this.getNewBornData.fits_text);
    this.newbornbabyHistory.controls['otherprobDesc'].setValue(this.getNewBornData.other_problem_text);
    this.newbornbabyHistory.controls['testiclesDescend'].setValue(this.getNewBornData.testicles_descended);
    this.newbornbabyHistory.controls['eye'].setValue(this.getNewBornData.eye);
    this.newbornbabyHistory.controls['tyroid'].setValue(this.getNewBornData.thyroid_screening);
    this.newbornbabyHistory.controls['metabolic'].setValue(this.getNewBornData.other_screening);
    this.newbornbabyHistory.controls['hipExam'].setValue(this.getNewBornData.hip_examination);
    this.newbornbabyHistory.controls['femorals'].setValue(this.getNewBornData.femorals);
    this.newbornbabyHistory.controls['pulseOXY'].setValue(this.getNewBornData.pulse_screening);
    this.newbornbabyHistory.controls['yesadmitted'].setValue(this.getNewBornData.admitted_reason);

    if (this.getNewBornData.jaundice == 'yes') {
      this.babyJaundice = 0;
    } else if (this.getNewBornData.jaundice == 'no') {
      this.babyJaundice = 1
    } else {
      this.babyJaundice = 2
    }

    if (this.getNewBornData.sugar == 'yes') {
      this.sugar = 0;
    } else if (this.getNewBornData.sugar == 'no') {
      this.sugar = 1
    } else {
      this.sugar = 2
    }

    if (this.getNewBornData.infection == 'yes') {
      this.infection = 0;
    } else if (this.getNewBornData.infection == 'no') {
      this.infection = 1
    } else {
      this.infection = 2
    }

    if (this.getNewBornData.breadth_difficulty == 'yes') {
      this.breathDifficulty = 0;
    } else if (this.getNewBornData.breadth_difficulty == 'no') {
      this.breathDifficulty = 1
    } else {
      this.breathDifficulty = 2
    }

    if (this.getNewBornData.fits == 'yes') {
      this.babyfits = 0;
    } else if (this.getNewBornData.fits == 'no') {
      this.babyfits = 1
    } else {
      this.babyfits = 2
    }

    if (this.getNewBornData.heart_problems == 'yes') {
      this.heartProb = 0;
    } else if (this.getNewBornData.fits == 'no') {
      this.heartProb = 1
    } else {
      this.heartProb = 2
    }

    if (this.getNewBornData.other_problem == 'yes') {
      this.anyotherprob = 0;
    } else {
      this.anyotherprob = 1
    }

    if (this.getNewBornData.physical_findings == 'yes') {
      this.birthNormal = 0;
    } else if (this.getNewBornData.fits == 'no') {
      this.birthNormal = 1
    } else {
      this.birthNormal = 2
    }

    if (this.getNewBornData.hearing == 'normal') {
      this.hearing = 0;
    } else {
      this.hearing = 1
    }

    if (this.getNewBornData.admitted == 'yes') {
      this.admittedReason = 0;
    } else {
      this.admittedReason = 1
    }


  }

  validatenewbornBaby() {
    this.newBorndata = this.newbornbabyHistory.value;

    if (this.babyJaundice == 0) {
      var babyJaundicetype = 'Yes'
    } else if (this.babyJaundice == 1) {
      var babyJaundicetype = 'No'
    } else {
      var babyJaundicetype = "Don't know";
    }

    if (this.sugar == 0) {
      var sugar_type = 'Yes'
    } else if (this.sugar == 1) {
      var sugar_type = 'No';
      this.newbornbabyHistory.controls['lowestsugar'].setValue("");
    } else {
      var sugar_type = "Don't know"
      this.newbornbabyHistory.controls['lowestsugar'].setValue("");
    }

    if (this.infection == 0) {
      var infection_type = 'Yes'
    } else if (this.sugar == 1) {
      var infection_type = 'No'
    } else {
      var infection_type = "Don't know"
    }

    if (this.breathDifficulty == 0) {
      var breathDifficulty_type = 'Yes'
    } else if (this.breathDifficulty == 1) {
      var breathDifficulty_type = 'No'
    } else {
      var breathDifficulty_type = "Don't know"
    }

    if (this.babyfits == 0) {
      var babyfits_type = 'Yes'
    } else if (this.babyfits == 1) {
      var babyfits_type = 'No'
    } else {
      var babyfits_type = "Don't know"
    }

    if (this.heartProb == 0) {
      var heartProb_type = 'Yes'
    } else if (this.heartProb == 1) {
      var heartProb_type = 'No'
    } else {
      var heartProb_type = "Don't know"
    }
    if (this.anyotherprob == 0) {
      var anyotherprob_type = 'Yes'
    } else {
      var anyotherprob_type = 'No'
    }

    if (this.birthNormal == 0) {
      var birthNormal_type = 'Yes'
    } else if (this.birthNormal == 1) {
      var birthNormal_type = 'No'
    } else {
      var birthNormal_type = "Don't know"
    }

    if (this.hearing == 0) {
      var hearing_type = 'Normal'
    } else {
      var hearing_type = 'Abnormal'
    }

    if (this.admittedReason == 0) {
      var admittedReason_type = 'Yes'
    } else {
      var admittedReason_type = 'No'
    }


    var newBornobj = {
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "jaundice": babyJaundicetype,
      "jaundice_level": this.newBorndata.maxLevel,
      "sugar": sugar_type,
      "sugar_level": this.newBorndata.lowestsugar,
      "infection": infection_type,
      "infection_text": this.newBorndata.infectionDes,
      "breadth_difficulty": breathDifficulty_type,
      "breadth_difficulty_text": this.newBorndata.prethDesc,
      "fits": babyfits_type, "fits_text": this.newBorndata.fitsDesc,
      "heart_problems": heartProb_type, "heart_problems_text": this.newBorndata.heartprobDesc,
      "other_problem": anyotherprob_type, "other_problem_text": this.newBorndata.otherprobDesc,
      "physical_findings": birthNormal_type,
      "testicles_descended": this.newBorndata.testiclesDescend,
      "hearing": hearing_type,
      "eye": this.newBorndata.eye,
      "thyroid_screening": this.newBorndata.tyroid,
      "other_screening": this.newBorndata.metabolic,
      "hip_examination": this.newBorndata.hipExam,
      "femorals": this.newBorndata.femorals,
      "pulse_screening": this.newBorndata.pulseOXY,
      "admitted": admittedReason_type,
      "admitted_reason": this.newBorndata.yesadmitted,
    }

    if (this.babyJaundice == 1) {
      newBornobj["jaundice_level"] = "0";

    } else if (this.babyJaundice == 2) {
      newBornobj["jaundice_level"] = "0";
    }

    if (this.sugar == 1) {
      newBornobj["sugar_level"] = "0";
    } else if (this.sugar == 2) {
      newBornobj["sugar_level"] = "0";
    }

    if (this.getNewBornData != '') {
      newBornobj["modified_at"] = new Date();
      newBornobj["id"] = this.getNewBornData.id;
      newBornobj["doctor_account"] = this.getNewBornData.doctor_account;
      newBornobj["patient_account"] = this.getNewBornData.patient_account;
      newBornobj["creator"] = this.getNewBornData.creator;
    }

    var data = {
      "new_born_history": newBornobj,
      "account_email": this.dmail, "user_type": "doctor"
    }


    if (this.getNewBornData == '') {
      var serviceURL = this.urlPoints.addnewbornhistory;
      this.success = "Created successfully !";
    } else {
      var serviceURL = this.urlPoints.updatenewbornhistory;
      this.success = "Updated successfully !";
    }

    this.appService.postData(serviceURL, data, this.token).subscribe((response: any) => {
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.openSnackBar();
      this.cancelNewbornStatus();
      this.getNewbornData();
    });
  }

  cancelNewbornStatus() {
    this.newbornEditStatus = false;
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '.') {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (event.key === '.') {
      return;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  preventInput(event) {
    let value = this.apgar;
    if (value > 10) {
      if (value <= 99) {
        event.preventDefault()
        this.apgar = parseInt(value.toString().substring(0, 1));
      } else if (value > 99) {
        event.preventDefault()
        this.apgar = parseInt(value.toString().substring(0, 2));
      }
    }
  }
}


@Component({
  selector: 'view-milestonepicture',
  templateUrl: 'viewmilestonepicture.html',
  styleUrls: ['viewmilestonepicture.scss']
})
export class DialogOverviewExampleDialogmilestonepicture {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  getarchivedfollicle: any;
  viewmilestonepicdetails: any;
  patientprofilename: any;
  viewmilestonepicdetailsnew: any;
  nomilestonepic: any;
  newdata: any[];
  getauthdetails;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }
  ngOnInit(): void {
    this.patientprofilename = sessionStorage.getItem("patientname")
    this.getmilestonepicture()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closepopuppicture() {
    this.dialogRef.close();
  }
  getmilestonepicture() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "type": sessionStorage.getItem("milestonetype"),
      "sno": sessionStorage.milestonetimeline
    }
    // environment.HOST + '/helyxonapi/cloud/image/upload/' + response.demographics.image
    this.appService.getData(this.urlPoints.getmilestonepicture, data, this.token).subscribe((response: any) => {
      if (response.status == 1) {
        if (response.data) {
          this.nomilestonepic = false
          if (response.data.length > 0) {
            this.viewmilestonepicdetails = response.data
            this.newdata = []
            for (var i = 0; i < this.viewmilestonepicdetails.length; i++) {

              if (this.viewmilestonepicdetails[i].image) {
                this.newdata.push({
                  "image1": 'https://api.epicare.net' + '/helyxonapi/cloud/image/upload/' + this.viewmilestonepicdetails[i].image,
                  "date": this.viewmilestonepicdetails[i].date,
                  "id": this.viewmilestonepicdetails[i].id,
                  "sno": this.viewmilestonepicdetails[i].sno,
                  "time": this.viewmilestonepicdetails[i].time,
                  "type": this.viewmilestonepicdetails[i].type
                });
              }

              response.data.newdata = this.newdata
              this.viewmilestonepicdetailsnew = response.data.newdata
            }
          }
        }

      } else if (response.status == 0) {
        this.newdata = []
        this.nomilestonepic = true
      }
    });
  }

  deletebabypic(id) {
    let data = {
      "account_email": this.dmail,
      "id": id
    }
    this.appService.postData(this.urlPoints.deletemilestonepicture, data, this.token).subscribe((response: any) => {
      this.toastr.success("Deleted successfully")
      this.getmilestonepicture()
    });
  }

}

@Component({
  selector: 'statusedit',
  templateUrl: 'statusedit.html',
  styleUrls: ['statusedit.scss']
})
export class DialogOverviewExampleDialogstatusedit {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  patienthistory: any;
  milestoneoption: any
  getauthdetails: any;


  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialogstatusedit>,
    @Inject(MAT_DIALOG_DATA) public data: PatientHistory, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;

    this.patienthistory = this.data
    if (this.patienthistory.status == 'Some times') {
      this.patienthistory.status = 'Sometimes'
    }
    this.milestoneoption = this.patienthistory.status
  }

  savestatus() {
    let ageinmonths = this.patienthistory.age.years * 12 + this.patienthistory.age.months
    let milestoneuploaddate = moment(new Date()).format("YYYY-MM-DD")
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "date": milestoneuploaddate,
      "age": ageinmonths,
      "type": this.patienthistory.type,
      "tracker_id": this.patienthistory.tracker_id,
      "milestone": [{
        "id": this.patienthistory.id,
        "sno": this.patienthistory.sno,
        "milestone": this.patienthistory.item,
        "reported_by_parents": false,
        "comments": this.patienthistory.comments,
        "status": this.milestoneoption
      }]
    }
    this.appService.postData(this.urlPoints.updatesurvey, data, this.token).subscribe((response: any) => {

      this.toastr.success("Saved Successfully")
      this.dialogRef.close();

    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closepopuppicture() {
    this.dialogRef.close();
  }




}




@Component({
  selector: 'labreport',
  templateUrl: 'submenus/labreport.html',
  styleUrls: ['submenus/labreport.scss']
})

export class DialogOverviewExampleDialog_labreports {
  urlPoints;
  getauthdetails;
  dmail;
  doc_id;
  token;
  imageUploadUrl;
  filter_type;
  attachments = [];
  labtest = [];
  labReportList = [];
  actualdata = [];
  newAttachment = [];
  patient;
  uploadedimg;

  attachments1;
  newAttachment1;
  onView = new EventEmitter();
  labArray = []
  pacExists = false
  pacAttachments = []

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_labreport, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService, public dialog: MatDialog,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
    //  this.imageUploadUrl = environment.HOST + '/helyxonapi/cloud/image/upload/';

    this.filter_type = this.data.filter_type
    this.patient = this.data.patientDetails
  }

  ngOnInit(): void {

    this.checkPacs()

    this.setFilterType(1)
  }


  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  setFilterType(i) {
    this.filter_type = i

    if (i == 1) {
      var params_labreports = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email,
      }

      this.labreports(this.urlPoints.getLabReports, params_labreports, this.token)
    }

    if (i == 2) {
      var params_labreports2 = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email,
        category: 'Unseen'
      }

      this.labreports2(this.urlPoints.getLabReports, params_labreports2, this.token)
    }

    if (i == 3) {
      var params_labreports3 = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email,
        category: 'abnormal'
      }

      this.labreports2(this.urlPoints.getLabReports, params_labreports3, this.token)
    }
  }

  checkPacs() {
    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email
    }

    this.appService.getData(this.urlPoints.checkPacs, params, this.token).subscribe((response: any) => {
      console.log(response)
      if (response.success == 1) {
        this.pacExists = true

        setTimeout(() => {
          //  this.loading = false;
          this._changeDetectorRef.markForCheck();
        }, 500);
      }
    });
  }

  getPacsAttachment(lab_id) {
    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email
    }

    this.appService.postData(this.urlPoints.getPacsAttachment, params, this.token).subscribe((response: any) => {
      // console.log(response)

      if (response.success == 1) {
        this.pacAttachments = response.attachments
      }

      console.log(this.pacAttachments)

      const dialogRef = this.dialog.open(Dialog_pac_attachments, {
        width: '900px',
        data: { account_email: this.dmail, token: this.token, patient_email: this.patient.record_info.Record.account_email, pacAttachments: this.pacAttachments, lab_id: lab_id }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('here')
          // console.log(this.refreshData)
        }
        this.refreshData()

      });
    });

  }


  pacs() {
    // alert()

    const dialogRef = this.dialog.open(Dialog_addpacs, {
      width: '480px',
      data: { account_email: this.dmail, token: this.token, patient_email: this.patient.record_info.Record.account_email }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)
        console.log(result.ID)
        console.log(result.MainDicomTags.PatientID)

        var params = {
          account_email: this.dmail,
          patient_email: this.patient.record_info.Record.account_email,
          fl_number: result.MainDicomTags.PatientID,
          pac_server_id: result.ID
        }

        console.log(params)

        this.appService.postData(this.urlPoints.createPac, params, this.token).subscribe((response: any) => {
          this.checkPacs()
        });

      }
    });
  }

  labreports(url, params, token) {


    var attachments = []

    var flag;

    var flag1;

    var obj;

    this.actualdata = []

    this.attachments = []

    this.newAttachment = []

    var inv_names = [];

    var data = []

    this.appService.getData(url, params, token).subscribe((response1: any) => {
      this.labArray = []
      var response = response1.result

      for (var i = 0; i < response.length; i++) {
        obj = {}

        obj.lab_tests = []

        obj.image_attachments = []

        obj.data = []

        obj.impressions = []

        obj.comments = []

        obj.titles = []

        obj.file_names = []

        obj.test_taken_on = []

        obj.lab_attachments = []

        var labexists = false

        for (var k = 0; k < response[i].data.length; k++) {

          this.labArray.push(response[i].data[k])

          obj.impression = response[i].data[k].description

          obj.impressions.push(response[i].data[k].description)

          obj.comments.push(response[i].data[k].comments)

          obj.titles.push(response[i].data[k].title)

          obj.file_names.push(response[i].data[k].file_name)

          obj.test_taken_on.push(response[i].data[k].test_taken_on)

          obj.lab_attachments.push(response[i].data[k].lab_attachments)

          // obj.title = response[i].data[k].title

          // obj.file_name = response[i].data[k].file_name

          // obj.test_taken_on = response[i].data[k].test_taken_on

          flag = 0
          flag1 = 0

          if (response[i].data[k].lab_test) {
            if (response[i].data[k].lab_test.length > 0) {
              flag = 1
            }
          }

          if (response[i].data[k].image_attachments) {

            if (response[i].data[k].image_attachments.length > 0) {
              flag1 = 1
            }
            if (response[i].data[k].image_attachments.length == 0 && response[i].data[k].lab_id) {
              flag1 = 1
            }
          }

          if (flag1 || flag == 1) {

            obj.date = response[i].date


            if (response[i].data[k].lab_test) {
              if (response[i].data[k].lab_test.length > 0) {

                obj.lab_tests = obj.lab_tests.concat(response[i].data[k].lab_test)
              }
            }

            if (response[i].data[k].image_attachments) {
              if (response[i].data[k].image_attachments.length > 0) {
                obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
              }
              if (response[i].data[k].image_attachments.length == 0 && response[i].data[k].lab_id) {
                labexists = true
                obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
              }
            }


            if (response[i].data[k].image_attachments || response[i].data[k].lab_test) {
              obj.data.push(response[i].data[k])

              obj.data.labexists = labexists

            }
          }
        }

        if (obj.date) {
          this.attachments.push(obj)
        }
      }

      {
        for (var i = 0; i < response.length; i++) {
          for (var j = 0; j < response[i].data.length; j++) {
            this.actualdata.push(response[i].data[j]);
            this.labtest.push(response[i].data[j].lab_test);
          }
        }

        for (var i = 0; i < this.actualdata.length; i++) {

          var images = [];

          for (var j = 0; j < this.actualdata[i].image_attachments.length; j++) {
            images = images.concat(this.actualdata[i].image_attachments[j].split(','))
          }

          for (var j = 0; j < images.length; j++) {
            images[j] = images[j].trim()
          }

          this.actualdata[i].image_attachments = images
        }

        // console.log(this.actualdata)



        for (var i = 0; i < this.actualdata.length; i++) {
          if (this.actualdata[i].lab_attachments != null) {
            for (var j = 0; j < this.actualdata[i].lab_attachments.length; j++) {
              if (this.actualdata[i].lab_attachments[j].attachment.startsWith("img_")) {
                this.newAttachment.push({
                  name: 'View report ',
                  path: environment.HOST + '/helyxonapi/cloud/image/upload/' + this.actualdata[i].lab_attachments[j].attachment,
                  id: this.actualdata[i].lab_attachments[j].id,
                  file_type: this.actualdata[i].lab_attachments[j].file_type,
                  replace: 'Replace Attachment',
                  overviewid: this.actualdata[i].overview_id,
                  file_name: this.actualdata[i].file_name,
                  test_taken_on: this.actualdata[i].test_taken_on,
                  labid: this.actualdata[i].lab_id,
                  description: this.actualdata[i].description && this.actualdata[i].description != 'null' ? this.actualdata[i].description : '',
                  comments: this.actualdata[i].comments && this.actualdata[i].comments != 'null' ? this.actualdata[i].comments : '',
                  labtest: this.actualdata[i].lab_test,
                  date: this.actualdata[i].date,
                  type: 1,
                  title: this.actualdata[i].title,
                  category: this.actualdata[i].category
                })
              } else {
                this.newAttachment.push({
                  name: 'View report ',
                  path: environment.HOST + '/helyxonapi/cloud/pdf/upload/' + this.actualdata[i].lab_attachments[j].attachment,
                  id: this.actualdata[i].lab_attachments[j].id,
                  file_type: this.actualdata[i].lab_attachments[j].file_type,
                  replace: 'Replace Attachment',
                  overviewid: this.actualdata[i].overview_id,
                  file_name: this.actualdata[i].file_name,
                  test_taken_on: this.actualdata[i].test_taken_on,
                  labid: this.actualdata[i].lab_id,
                  description: this.actualdata[i].description && this.actualdata[i].description != 'null' ? this.actualdata[i].description : '',
                  comments: this.actualdata[i].comments && this.actualdata[i].comments != 'null' ? this.actualdata[i].comments : '',
                  labtest: this.actualdata[i].lab_test,
                  date: this.actualdata[i].date,
                  type: 2,
                  title: this.actualdata[i].title,
                  category: this.actualdata[i].category
                })
              }
            }
          }
        }


        for (var i = 0; i < this.labtest.length; i++) {
          if (this.labtest[i] != null) {
            this.labReportList.push(this.labtest[i]);
          }
        }
      }

      for (var i = 0; i < this.attachments.length; i++) {
        var exists = 0;

        for (var k = 0; k < this.newAttachment.length; k++) {
          if (this.attachments[i].date == this.newAttachment[k].date) {
            exists = 1
          }
        }

        if (exists == 1) {
          this.attachments[i].exists = 1
        }
        else {
          this.attachments[i].exists = 0
        }
      }

      for (var i = 0; i < this.newAttachment.length; i++) {
        if (this.newAttachment[i].labid) {
        }
      }

      for (var i = 0; i < response.length; i++) {
        var count = 0
        var test_names = []
        for (var j = 0; j < this.labArray.length; j++) {
          if (response[i].date == this.labArray[j].date) {

            // console.log(this.labArray[j].date)

            count++

            if (this.labArray[j].title && this.labArray[j].title != '')
              test_names.push(this.labArray[j].title)

            for (var k = 0; k < this.labArray.length; k++) {


              if (this.labArray[k].date == response[i].date) {
                this.labArray[k].count = count
                this.labArray[k].test_names = test_names

              }
            }

            // this.labArray[j].count=count

          }


        }

      }


      setTimeout(() => {
        //  this.loading = false;
        this._changeDetectorRef.markForCheck();
      }, 500);

    });

  }

  labreports2(url, params, token) {

    var attachments = []

    var flag;

    var flag1;

    var obj;

    this.actualdata = []

    this.attachments = []

    this.newAttachment = []

    var inv_names = [];

    var data = []

    this.appService.getData(url, params, token).subscribe((response1: any) => {
      this.labArray = []
      var response = response1.result

      for (var i = 0; i < response.length; i++) {
        obj = {}

        obj.lab_tests = []

        obj.image_attachments = []

        obj.data = []

        obj.impressions = []

        obj.comments = []

        obj.titles = []

        obj.file_names = []

        obj.test_taken_on = []

        obj.lab_attachments = []

        var labexists = false

        for (var k = 0; k < response[i].data.length; k++) {

          this.labArray.push(response[i].data[k])

          obj.impression = response[i].data[k].description

          obj.impressions.push(response[i].data[k].description)

          obj.comments.push(response[i].data[k].comments)

          obj.titles.push(response[i].data[k].title)

          obj.file_names.push(response[i].data[k].file_name)

          obj.test_taken_on.push(response[i].data[k].test_taken_on)

          obj.lab_attachments.push(response[i].data[k].lab_attachments)

          // obj.title = response[i].data[k].title

          // obj.file_name = response[i].data[k].file_name

          // obj.test_taken_on = response[i].data[k].test_taken_on

          flag = 0
          flag1 = 0

          if (response[i].data[k].lab_test) {
            if (response[i].data[k].lab_test.length > 0) {
              flag = 1
            }
          }

          if (response[i].data[k].image_attachments) {

            if (response[i].data[k].image_attachments.length > 0) {
              flag1 = 1
            }
            if (response[i].data[k].image_attachments.length == 0 && response[i].data[k].lab_id) {
              flag1 = 1
            }
          }

          if (flag1 || flag == 1) {

            obj.date = response[i].date


            if (response[i].data[k].lab_test) {
              if (response[i].data[k].lab_test.length > 0) {

                obj.lab_tests = obj.lab_tests.concat(response[i].data[k].lab_test)
              }
            }

            if (response[i].data[k].image_attachments) {
              if (response[i].data[k].image_attachments.length > 0) {
                obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
              }
              if (response[i].data[k].image_attachments.length == 0 && response[i].data[k].lab_id) {
                labexists = true
                obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
              }
            }


            if (response[i].data[k].image_attachments || response[i].data[k].lab_test) {
              obj.data.push(response[i].data[k])

              obj.data.labexists = labexists

            }
          }
        }

        if (obj.date) {
          this.attachments.push(obj)
        }
      }

      {
        for (var i = 0; i < response.length; i++) {
          for (var j = 0; j < response[i].data.length; j++) {
            this.actualdata.push(response[i].data[j]);
            this.labtest.push(response[i].data[j].lab_test);
          }
        }

        for (var i = 0; i < this.actualdata.length; i++) {

          var images = [];

          for (var j = 0; j < this.actualdata[i].image_attachments.length; j++) {
            images = images.concat(this.actualdata[i].image_attachments[j].split(','))
          }

          for (var j = 0; j < images.length; j++) {
            images[j] = images[j].trim()
          }

          this.actualdata[i].image_attachments = images
        }

        console.log(this.actualdata)



        for (var i = 0; i < this.actualdata.length; i++) {
          if (this.actualdata[i].lab_attachments != null) {
            for (var j = 0; j < this.actualdata[i].lab_attachments.length; j++) {
              if (this.actualdata[i].lab_attachments[j].attachment.startsWith("img_")) {
                this.newAttachment.push({
                  name: 'View report ',
                  path: environment.HOST + '/helyxonapi/cloud/image/upload/' + this.actualdata[i].lab_attachments[j].attachment,
                  id: this.actualdata[i].lab_attachments[j].id,
                  file_type: this.actualdata[i].lab_attachments[j].file_type,
                  replace: 'Replace Attachment',
                  overviewid: this.actualdata[i].overview_id,
                  file_name: this.actualdata[i].file_name,
                  test_taken_on: this.actualdata[i].test_taken_on,
                  labid: this.actualdata[i].lab_id,
                  description: this.actualdata[i].description && this.actualdata[i].description != 'null' ? this.actualdata[i].description : '',
                  comments: this.actualdata[i].comments && this.actualdata[i].comments != 'null' ? this.actualdata[i].comments : '',
                  labtest: this.actualdata[i].lab_test,
                  date: this.actualdata[i].date,
                  type: 1,
                  title: this.actualdata[i].title,
                  category: this.actualdata[i].category
                })
              } else {
                this.newAttachment.push({
                  name: 'View report ',
                  path: environment.HOST + '/helyxonapi/cloud/pdf/upload/' + this.actualdata[i].lab_attachments[j].attachment,
                  id: this.actualdata[i].lab_attachments[j].id,
                  file_type: this.actualdata[i].lab_attachments[j].file_type,
                  replace: 'Replace Attachment',
                  overviewid: this.actualdata[i].overview_id,
                  file_name: this.actualdata[i].file_name,
                  test_taken_on: this.actualdata[i].test_taken_on,
                  labid: this.actualdata[i].lab_id,
                  description: this.actualdata[i].description && this.actualdata[i].description != 'null' ? this.actualdata[i].description : '',
                  comments: this.actualdata[i].comments && this.actualdata[i].comments != 'null' ? this.actualdata[i].comments : '',
                  labtest: this.actualdata[i].lab_test,
                  date: this.actualdata[i].date,
                  type: 2,
                  title: this.actualdata[i].title,
                  category: this.actualdata[i].category
                })
              }
            }
          }
        }


        for (var i = 0; i < this.labtest.length; i++) {
          if (this.labtest[i] != null) {
            this.labReportList.push(this.labtest[i]);
          }
        }
      }

      for (var i = 0; i < this.attachments.length; i++) {
        var exists = 0;

        for (var k = 0; k < this.newAttachment.length; k++) {
          if (this.attachments[i].date == this.newAttachment[k].date) {
            exists = 1
          }
        }

        if (exists == 1) {
          this.attachments[i].exists = 1
        }
        else {
          this.attachments[i].exists = 0
        }
      }

      for (var i = 0; i < this.newAttachment.length; i++) {
        if (this.newAttachment[i].labid) {
        }
      }

      for (var i = 0; i < response.length; i++) {
        var count = 0
        var test_names = []
        for (var j = 0; j < this.labArray.length; j++) {
          if (response[i].date == this.labArray[j].date) {

            // console.log(this.labArray[j].date)

            count++

            if (this.labArray[j].title && this.labArray[j].title != '')
              test_names.push(this.labArray[j].title)

            for (var k = 0; k < this.labArray.length; k++) {


              if (this.labArray[k].date == response[i].date) {
                this.labArray[k].count = count
                this.labArray[k].test_names = test_names

              }
            }

            // this.labArray[j].count=count

          }


        }

      }


      if (params.category == "Unseen") {
        this.labArray = this.labArray.filter((res => res.lab_attachments.length > 0));

      }

      setTimeout(() => {
        //  this.loading = false;
        this._changeDetectorRef.markForCheck();
      }, 500);

    });

  }

  delete(id) {
    var params = {
      account_email: this.dmail,
      id: id
    }

    this.appService.postData(this.urlPoints.deleteAttachment, params, this.token).subscribe((response: any) => {
      console.log(response)

      this.toastr.success("File deleted!", '', {
        timeOut: 3000,
      });
      this.refreshData()
    });
  }

  openUpload() {
    var files = []

    const dialogRef = this.dialog.open(Dialog_upload, {
      width: '600px',

      data: { dmail: this.dmail, token: this.token, id:this.doc_id }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        for (var i = 0; i < result.fileList.length; i++) {

          this.appService.postimgData2(result.fileList[i].type.startsWith('image') ? this.urlPoints.imageUpload : this.urlPoints.pdfUpload, result.fileList[i], this.token, result.fileList[i].type.startsWith('image') ? 1 : 2).subscribe((response: any) => {
            this.uploadedimg = response.body;

            if (this.uploadedimg) {
              if (this.uploadedimg.image)
                files.push(this.uploadedimg.image[0].filename)
              else
                files.push(this.uploadedimg.pdf[0].filename)
            }

            if (files.length == result.fileList.length) {

              var params = {
                report: files,
                description: result.description,
                comments: result.comments,
                lab_test: result.tests.split(','),
                account_email: this.dmail,
                patient_email: this.patient.record_info.Record.account_email,
                title: result.title,
                category: result.abnormal ? 'abnormal' : "seen",
                file_name: result.file_name,
                test_taken_on: result.test_taken_on,
                doctor_id: this.doc_id
              }

              this.appService.postData(this.urlPoints.createLabReport, params, this.token).subscribe((response: any) => {

                this.snackBar.open('Report Uploaded!', '', {
                  duration: 3000,
                  verticalPosition: 'bottom',
                  horizontalPosition: 'right',
                });

                setTimeout(() => {
                  //  this.loading = false;
                  this._changeDetectorRef.markForCheck();
                }, 500);

                if (this.filter_type == 1) {
                  var params_labreports = {
                    account_email: this.dmail,
                    patient_email: this.patient.record_info.Record.account_email,
                  }

                  this.labreports(this.urlPoints.getLabReports, params_labreports, this.token)
                }

                if (this.filter_type == 2) {
                  var params_labreports2 = {
                    account_email: this.dmail,
                    patient_email: this.patient.record_info.Record.account_email,
                    category: 'Unseen'
                  }

                  this.labreports2(this.urlPoints.getLabReports, params_labreports2, this.token)
                }

                if (this.filter_type == 3) {
                  var params_labreports3 = {
                    account_email: this.dmail,
                    patient_email: this.patient.record_info.Record.account_email,
                    category: 'abnormal'
                  }

                  this.labreports2(this.urlPoints.getLabReports, params_labreports3, this.token)
                }
              });
            }

          });
        }
      }
    });
  }

  refreshData() {
    if (this.filter_type == 1) {
      var params_labreports = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email,
      }

      this.labreports(this.urlPoints.getLabReports, params_labreports, this.token)
    }

    if (this.filter_type == 2) {
      var params_labreports2 = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email,
        category: 'Unseen'
      }

      this.labreports2(this.urlPoints.getLabReports, params_labreports2, this.token)
    }

    if (this.filter_type == 3) {
      var params_labreports3 = {
        account_email: this.dmail,
        patient_email: this.patient.record_info.Record.account_email,
        category: 'abnormal'
      }

      this.labreports2(this.urlPoints.getLabReports, params_labreports3, this.token)
    }
  }

  replace(id, tests, date, type, labtest, attachment, attachments, category, filename, test_taken_on, file_id, description, comments) {

    console.log(id)
    console.log(tests)
    console.log(date)
    console.log(type)
    console.log(labtest)
    console.log(attachment)
    console.log(attachments)
    console.log(category)
    console.log(filename)
    console.log(test_taken_on)
    console.log(file_id)
    console.log(description,'d');
    console.log(comments,'c');
    
    // console.log(test_taken_on)


    this.onView.emit();

    // var filter = attachments.filter((res => res.labid == id) || (res => res.overviewid == id));

    // var total_attachments = []

    // for (var i = 0; i < filter.length; i++) {
    //   total_attachments.push(filter[i].id.split('/')[attachment.id.split('/').length - 1])
    // }

    // var index

    // index = total_attachments.indexOf(attachment.id.split('/')[attachment.id.split('/').length - 1])

    // total_attachments.splice(index, 1)

    var files = []

    var filetype = []

    var data = {
      id: id,
      lab_tests: tests,
      date: date
    }

    const dialogRef = this.dialog.open(Dialog_attachment2, {
      width: '600px',

      data: { obj: data, title: tests, category: category, type: type, mode: 'replace' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {


        for (var i = 0; i < result.fileList.length; i++) {

          this.appService.postimgData2(result.fileList[i].type.startsWith('image') ? this.urlPoints.imageUpload : this.urlPoints.pdfUpload, result.fileList[i], this.token, result.fileList[i].type.startsWith('image') ? 1 : 2).subscribe((response: any) => {
            this.uploadedimg = response.body;

            if (this.uploadedimg) {
              if (this.uploadedimg.image) {

                files.push(this.uploadedimg.image[0].filename)
                filetype.push('image')

                var params = {
                  account_email: this.dmail,
                  patient_email: this.patient.record_info.Record.account_email,
                  id: file_id,
                  attachment: this.uploadedimg.image[0].filename,
                  file_type: 'image'
                }


              }
              // files.push(this.uploadedimg.image[0].filename)
              else {

                files.push(this.uploadedimg.pdf[0].filename)

                filetype.push('document')

                var params = {
                  account_email: this.dmail,
                  patient_email: this.patient.record_info.Record.account_email,
                  id: file_id,
                  attachment: this.uploadedimg.pdf[0].filename,
                  file_type: 'document'
                }


              }

              this.appService.postData(this.urlPoints.createLabAttachment, params, this.token).subscribe((response: any) => {
                console.log(response)

                this.toastr.success("File replaced!", '', {
                  timeOut: 3000,
                });
                this.refreshData()
              });

              console.log(files)

              if (files.length == result.fileList.length) {
  
                var params1 = {
                  report: files,
                  description: description? description: '',
                  comments: comments?comments:'',
                  lab_test: labtest,
                  account_email: this.dmail,
                  patient_email: this.patient.record_info.Record.account_email,
                  title: tests.join(','),
                  category: category,
                  file_name: filename? filename: '',
                  test_taken_on: date,
                  lab_id: id,
                  attachment_id: file_id,
                  file_type: filetype,
                  doctor_id: this.doc_id
                }

                console.log(params1,'params125918');
                
                this.appService.postData(this.urlPoints.createLabReport, params1, this.token).subscribe((response: any) => {
                  console.log(response,'response');
                  // this.toastr.success("File replaced!", '', {
                  //   timeOut: 3000,
                  // });
                  // this.refreshData()
                });
              }
  
              // files.push(this.uploadedimg.pdf[0].filename)
            }

            console.log(files)





            // if (files.length == result.fileList.length) {

            //   var params = {
            //     lab_results: {
            //       attachments: total_attachments,
            //       overview_id: type == 1 ? data.id : '',
            //       lab_id: type == 2 ? data.id : '',
            //       comment: "",
            //       category: result.abnormal ? 'abnormal' : "seen"

            //     },
            //     account_email: this.dmail
            //   }

            //   this.appService.postData(this.urlPoints.labresult, params, this.token).subscribe((response: any) => {

            //     setTimeout(() => {

            //       this._changeDetectorRef.markForCheck();
            //     }, 500);

            //     //  this.getUnseen()

            //     var params_labreports = {
            //       account_email: this.dmail,
            //       patient_email: this.patient.record_info.Record.account_email,
            //     }

            //     if (this.filter_type == 1) {
            //       var params_labreports = {
            //         account_email: this.dmail,
            //         patient_email: this.patient.record_info.Record.account_email,
            //       }

            //       this.labreports(this.urlPoints.getLabReports, params_labreports, this.token)
            //     }

            //     if (this.filter_type == 2) {
            //       var params_labreports2 = {
            //         account_email: this.dmail,
            //         patient_email: this.patient.record_info.Record.account_email,
            //         category: 'Unseen'
            //       }

            //       this.labreports2(this.urlPoints.getLabReports, params_labreports2, this.token)
            //     }

            //     if (this.filter_type == 3) {
            //       var params_labreports3 = {
            //         account_email: this.dmail,
            //         patient_email: this.patient.record_info.Record.account_email,
            //         category: 'abnormal'
            //       }

            //       this.labreports2(this.urlPoints.getLabReports, params_labreports3, this.token)
            //     }
            //   });
            // }

          });
        }

      }
    });
  }

  view(attachment, type, labid, category) {

    console.log(attachment)

    var path

    if (type == 'image') {
      path = environment.HOST + '/helyxonapi/cloud/image/upload/' + attachment
    }
    else if (type == 'document') {
      path = environment.HOST + '/helyxonapi/cloud/pdf/upload/' + attachment

    }

    else {
      path = environment.HOST + '/dicomviewer/?file=' + attachment
    }

    console.log(type)
    console.log(labid)
    console.log(category)


    window.open(path)

    if (labid) {
      var params = {
        "account_email": this.dmail,
        "patient_email": this.patient.record_info.Record.account_email,
        "id": labid,
        "status": "seen"
      }

      if (category != 'abnormal') {
        this.appService.postData(this.urlPoints.updateReports, params, this.token).subscribe((response: any) => {

          setTimeout(() => {
            //  this.loading = false;
            this._changeDetectorRef.markForCheck();
          }, 500);

          if (this.filter_type == 1) {
            var params_labreports = {
              account_email: this.dmail,
              patient_email: this.patient.record_info.Record.account_email,
            }


            this.labreports(this.urlPoints.getLabReports, params_labreports, this.token)
          }

          if (this.filter_type == 2) {
            var params_labreports2 = {
              account_email: this.dmail,
              patient_email: this.patient.record_info.Record.account_email,
              category: 'Unseen'
            }

            this.labreports2(this.urlPoints.getLabReports, params_labreports2, this.token)
          }

          if (this.filter_type == 3) {
            var params_labreports3 = {
              account_email: this.dmail,
              patient_email: this.patient.record_info.Record.account_email,
              category: 'abnormal'
            }

            this.labreports2(this.urlPoints.getLabReports, params_labreports3, this.token)
          }
        });
      }
      else {
        if (this.filter_type == 1) {
          var params_labreports = {
            account_email: this.dmail,
            patient_email: this.patient.record_info.Record.account_email,
          }


          this.labreports(this.urlPoints.getLabReports, params_labreports, this.token)
        }

        if (this.filter_type == 2) {
          var params_labreports2 = {
            account_email: this.dmail,
            patient_email: this.patient.record_info.Record.account_email,
            category: 'Unseen'
          }

          this.labreports2(this.urlPoints.getLabReports, params_labreports2, this.token)
        }

        if (this.filter_type == 3) {
          var params_labreports3 = {
            account_email: this.dmail,
            patient_email: this.patient.record_info.Record.account_email,
            category: 'abnormal'
          }

          this.labreports2(this.urlPoints.getLabReports, params_labreports3, this.token)
        }
      }

    }
  }

  openAttachment2(data, id, type, title, description, comments, category, filename, date) {

    console.log(data)

    console.log(id)

    console.log(type)

    console.log(title)

    console.log(description)
    console.log(comments)
    console.log(category)
    console.log(filename)
    console.log(date)


    var files = []

    var filetype = []
    const dialogRef = this.dialog.open(Dialog_attachment, {
      width: '600px',
      data: { obj: data, title: type == 1 ? data.lab_tests.join(',') : title, type: type, mode: 'add' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result.fileList)

        for (var i = 0; i < result.fileList.length; i++) {
          this.appService.postimgData2(result.fileList[i].type.startsWith('image') ? this.urlPoints.imageUpload : this.urlPoints.pdfUpload, result.fileList[i], this.token, result.fileList[i].type.startsWith('image') ? 1 : 2).subscribe((response: any) => {
            this.uploadedimg = response.body;

            if (this.uploadedimg) {
              console.log(this.uploadedimg)
              if (this.uploadedimg.image) {

                files.push(this.uploadedimg.image[0].filename)
                filetype.push('image')

                var params = {
                  account_email: this.dmail,
                  patient_email: this.patient.record_info.Record.account_email,
                  lab_id: id,
                  attachment: this.uploadedimg.image[0].filename,
                  file_type: 'image'
                }
              }
              else {

                files.push(this.uploadedimg.pdf[0].filename)
                filetype.push('document')

                var params = {
                  account_email: this.dmail,
                  patient_email: this.patient.record_info.Record.account_email,
                  lab_id: id,
                  attachment: this.uploadedimg.pdf[0].filename,
                  file_type: 'document'
                }
              }


              this.appService.postData(this.urlPoints.createLabAttachment, params, this.token).subscribe((response: any) => {
                console.log(response)
                this.refreshData()
              });

              if (files.length == result.fileList.length) {
  
                var params1 = {
                  report: files,
                  description: description? description: '',
                  comments: comments?comments:'',
                  lab_test: title,
                  account_email: this.dmail,
                  patient_email: this.patient.record_info.Record.account_email,
                  title: title,
                  category: category,
                  file_name: filename? filename: '',
                  test_taken_on: date,
                  lab_id: id,
                  file_type: filetype,
                  doctor_id: this.doc_id
                }

                console.log(params1,'params125918');
                
                this.appService.postData(this.urlPoints.createLabReport, params1, this.token).subscribe((response: any) => {
                  console.log(response,'response');
                  // this.toastr.success("File replaced!", '', {
                  //   timeOut: 3000,
                  // });
                  // this.refreshData()
                });
              }


            }


          });
        }

      }
    });
  }

  getUnseen() {
    var params_labreports2 = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email,
      category: 'Unseen'
    }
    this.labreports_seen(this.urlPoints.getLabReports, params_labreports2, this.token)

  }

  edit1(id, tests, date, type, labtest, lab_tests, category, description, comments, filename, test_taken_on) {

    console.log(id)
    console.log(tests)
    console.log(date)
    console.log(type)
    console.log(labtest)
    console.log(lab_tests)
    console.log(category)
    console.log(description)
    console.log(comments)

    console.log(filename)
    console.log(test_taken_on)

    var files = []

    var data = {
      id: id,
      lab_tests: tests,
      date: date
    }

    const dialogRef = this.dialog.open(Dialog_attachment_edit, {
      width: '600px',

      data: { obj: data, title: tests, edit: 1, category: category, description: description, comments: comments, filename: filename, test_taken_on: test_taken_on }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        var params = {
          account_email: this.dmail,
          report: lab_tests,
          lab_test: lab_tests,
          description: result.description ? result.description : '',
          comments: result.comments ? result.comments : '',
          title: tests.join(','),
          category: result.abnormal ? 'abnormal' : "seen",
          patient_email: this.patient.record_info.Record.account_email,
          lab_id: type == 2 ? data.id : '',
          file_name: result.filename,
          test_taken_on: result.test_taken_on,
          doctor_id: this.doc_id
        }

        this.appService.postData(this.urlPoints.createLabReport, params, this.token).subscribe((response: any) => {

          setTimeout(() => {
            //  this.loading = false;
            this._changeDetectorRef.markForCheck();
          }, 500);

          this.getUnseen()
          if (this.filter_type == 1) {
            var params_labreports = {
              account_email: this.dmail,
              patient_email: this.patient.record_info.Record.account_email,
            }

            this.labreports(this.urlPoints.getLabReports, params_labreports, this.token)
          }

          if (this.filter_type == 2) {
            var params_labreports2 = {
              account_email: this.dmail,
              patient_email: this.patient.record_info.Record.account_email,
              category: 'Unseen'
            }

            this.labreports2(this.urlPoints.getLabReports, params_labreports2, this.token)
          }

          if (this.filter_type == 3) {
            var params_labreports3 = {
              account_email: this.dmail,
              patient_email: this.patient.record_info.Record.account_email,
              category: 'abnormal'
            }

            this.labreports2(this.urlPoints.getLabReports, params_labreports3, this.token)
          }
        });

      }
    });
  }

  labreports_seen(url, params, token) {

    var attachments1 = []

    var flag;

    var flag1;

    var obj;

    this.actualdata = []

    this.attachments1 = []

    this.newAttachment1 = []

    var inv_names = [];

    var data = []

    this.appService.getData(url, params, token).subscribe((response: any) => {

      for (var i = 0; i < response.length; i++) {
        obj = {}

        obj.lab_tests = []

        obj.image_attachments = []

        obj.data = []

        var labexists = false

        for (var k = 0; k < response[i].data.length; k++) {
          flag = 0
          flag1 = 0

          if (response[i].data[k].image_attachments) {
            if (response[i].data[k].image_attachments.length > 0) {
              flag1 = 1
            }
          }

          if (flag1 || flag == 1) {

            obj.date = response[i].date


            if (response[i].data[k].lab_test) {
              if (response[i].data[k].lab_test.length > 0) {
                //  obj.lab_tests = obj.lab_tests.concat(response[i].data[k].lab_test)
              }
            }

            if (response[i].data[k].image_attachments) {
              if (response[i].data[k].image_attachments.length > 0) {
                obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
              }
              if (response[i].data[k].lab_id) {
                labexists = true
                obj.image_attachments = obj.image_attachments.concat(response[i].data[k].lab_test)
              }
            }

            if (response[i].data[k].image_attachments) {

              obj.data.push(response[i].data[k])
              obj.lab_tests.push(response[i].data[k].title)
              obj.data.labexists = labexists
            }
          }
        }

        //  var day = '2021-10-05'

        if (obj.date && obj.data.labexists) {
          this.attachments1.push(obj)
        }
      }

      {
        for (var i = 0; i < response.length; i++) {
          for (var j = 0; j < response[i].data.length; j++) {
            this.actualdata.push(response[i].data[j]);
            this.labtest.push(response[i].data[j].lab_test);
          }
        }

        for (var i = 0; i < this.actualdata.length; i++) {
          if (this.actualdata[i].image_attachments != null) {
            for (var j = 0; j < this.actualdata[i].image_attachments.length; j++) {
              if (this.actualdata[i].image_attachments[j].startsWith("img_")) {
                this.newAttachment1.push({
                  name: 'View report ',
                  id: environment.HOST + '/helyxonapi/cloud/image/upload/' + this.actualdata[i].image_attachments[j],
                  replace: 'Replace Attachment',
                  overviewid: this.actualdata[i].overview_id,
                  labid: this.actualdata[i].lab_id,
                  description: this.actualdata[i].description ? this.actualdata[i].description : '',
                  comments: this.actualdata[i].comments ? this.actualdata[i].comments : '',
                  labtest: this.actualdata[i].lab_test,
                  date: this.actualdata[i].date,
                  type: 1,
                  title: this.actualdata[i].title
                })
              } else {
                this.newAttachment1.push({
                  name: 'View report ',
                  id: environment.HOST + '/helyxonapi/cloud/pdf/upload/' + this.actualdata[i].image_attachments[j],
                  replace: 'Replace Attachment',
                  overviewid: this.actualdata[i].overview_id,
                  labid: this.actualdata[i].lab_id,
                  description: this.actualdata[i].description ? this.actualdata[i].description : '',
                  comments: this.actualdata[i].comments ? this.actualdata[i].comments : '',
                  labtest: this.actualdata[i].lab_test,
                  date: this.actualdata[i].date,
                  type: 2,
                  title: this.actualdata[i].title

                })
              }
            }
          }
        }

        for (var i = 0; i < this.labtest.length; i++) {
          if (this.labtest[i] != null) {
            this.labReportList.push(this.labtest[i]);
          }
        }
      }

      for (var i = 0; i < this.attachments1.length; i++) {
        var exists = 0;

        for (var k = 0; k < this.newAttachment1.length; k++) {
          if (this.attachments1[i].date == this.newAttachment1[k].date) {
            exists = 1
          }
        }

        if (exists == 1) {
          this.attachments1[i].exists = 1
        }
        else {
          this.attachments1[i].exists = 0
        }
      }

      for (var i = 0; i < this.newAttachment1.length; i++) {
        if (this.newAttachment1[i].labid) {
        }
      }
    });

  }
}

@Component({
  selector: 'obstGynecbottomwindow',
  templateUrl: 'submenus/obstGynec/obstGynec.html',
  styleUrls: ['submenus/obstGynec/obstGynec.scss']
})

export class DialogOverviewExampleDialog_obstGynec {
  obstetricHistory;
  currentpreg: any;
  gynecologyHistory;
  submitted = false;
  patient;
  dmail;
  token;
  urlPoints;
  getauthdetails;
  doc_id;
  lmpmissing: boolean;
  obslmp;
  obsedd;
  obspara;
  obsactualdelivery;
  eddfirstdate: Date;
  eddlastdate: Date;
  obsabortion;
  obsgravida;
  obsgeneralnotes;
  templmp;
  tempedd;
  tempactdel;
  viewObstStatus = true;
  viewgynecStatus = true;
  lmp_update = false;
  preview_id;
  preview = 'Update Consultation'
  printDisabled = false
  call = 'update'
  appointment_id;
  complaint_id;
  viewscanreportfindingdata = [];
  emptygetscan: boolean;
  checkedList2 = [];
  todayriskdatetemp;
  todayriskdate;
  latestcurrentpregDetails;
  viewcurrentpregRisk;
  viewcurrentpregRecords = [];
  checkedList = [];
  masterSelected: Boolean;
  masterSelected2: Boolean;
  showpremenopausalcomp: Boolean;
  obslmpmaxDate = moment(new Date()).format('YYYY-MM-DD');
  obseddminDate = moment(new Date()).format('YYYY-MM-DD');
  obseddmaxDate = moment(new Date()).add(300, 'days').format('YYYY-MM-DD');

  obstetricHistorydata;
  setobseddminDate;
  tempobseddminDate;
  obsactualminDate;
  obsactualmaxDate;

  displaypatientname;
  currentpregdata;
  templmp1;
  tempedd1;
  riskstatusmodified: boolean = false;
  checkboxvalue = false;
  scannedondate: any;
  follow_text = '';
  nextscanfollowup: any;
  scancurrentdate;
  temptodayscandate: Date;
  todayscandate: string;
  updatescanfindings;
  prescription_id;
  cc_copy1;
  ex_copy1;
  diag_copy1;
  inv_copy1;
  pres_copy1;
  adv_copy1;
  obsgeneralnotes1;

  cc_copy2;

  cc_selected = [];
  ex_selected = [];
  diag_selected = [];
  inv_selected = [];
  pres_selected = [];
  adv_selected = [];
  emergency_indication = false;

  cc_selected_copy = [];
  ex_selected_copy = [];
  diag_selected_copy = [];
  inv_selected_copy = [];
  pres_selected_copy = [];
  adv_selected_copy = [];

  editStatus = false;
  patientmaxdate = moment(new Date()).format("YYYY-MM-DD");
  imageUploadUrl;
  success = "Updated !"

  gynechistorydata;
  gyneccomplaint;
  viewfgynechistorydata = [];
  gynecmenstrualhistory;
  gynecdoe;
  gyneclmp;
  gyneclmpmaxDate = moment(new Date()).format('YYYY-MM-DD')
  gynecmenstrualcomplaint;
  gynecnote;
  viewfolliclestudydata = [];
  masterSelected3;
  checkedList3 = [];


  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_obstGynec>, private _changeDetectorRef: ChangeDetectorRef,
    //public dialogRef: MatDialogRef<DialogOverviewExampleDialog_obstGynec>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomobstgnec, public dialog: MatDialog, public router: Router, private appService: AppService, public datepipe: DatePipe, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
    this.imageUploadUrl = environment.HOST + '/helyxonapi/cloud/image/upload/';
  }

  ngOnInit(): void {


    this.obstetricHistory = this.fb.group({
      obslmps: [""],
      obsedds: [""],
      obsactualdeliverys: [""],
      obsgravidas: [""],
      obsparas: [""],
      obsabortions: [""],
      obsgeneralnotess: [""],
    });

    this.currentpreg = this.fb.group({
      obslmps1: [""],
      obsedds1: [""],
      obspregrisks: [""],
      displaypatientname1: [""],
      obsgeneralnotess1: [""],
    })

    this.gynecologyHistory = this.fb.group({
      gyneclmps: [""],
      gynecdoes: [""],
      gynecmenstrualhistorys: [""],
      gynecmenstrualcomplaints1: [""],
      gynecmenstrualcomplaints2: [""],
      gynecnotes: [""],
    });
    sessionStorage.setItem('patientemail', this.data.patientDetails.record_info.Record.account_email);
    this.get_obsthistory();
    this.get_currentpregnancy();
    this.get_currentpregnancyRecords();
    this.get_scanreportfindingdata();
    this.get_gynecologydetails();
    this.get_folliclestudydetails();
    this.viewObstCurrentTab(true, 0, 'default');
    this.viewgynecCurrentTab(true, 0, 'default');
  }

  getEdd() {
    this.lmpmissing = false
    this.obstetricHistorydata = this.obstetricHistory.value
    this.setobseddminDate = moment(this.obstetricHistorydata.obslmps).add(280, 'days').format('YYYY-MM-DD')
    this.obseddmaxDate = moment(this.obstetricHistorydata.obslmps).add(300, 'days').format('YYYY-MM-DD')
    this.tempobseddminDate = this.datepipe.transform(this.setobseddminDate, 'yyyy-MM-dd');
    this.obstetricHistory.controls['obsedds'].setValue(this.tempobseddminDate);
    this.obsactualminDate = moment(this.obstetricHistorydata.obslmps).add(280, 'days').subtract(5, 'months')
    this.obsactualmaxDate = moment(this.obstetricHistorydata.obslmps).add(1, 'years').subtract(1, 'days')
  }

  clearallobsgynec() {
    this.obstetricHistory.controls['obslmps'].setValue("");
    this.obstetricHistory.controls['obsedds'].setValue("");
    this.obstetricHistory.controls['obsactualdeliverys'].setValue("");
    this.obstetricHistory.controls['obsgravidas'].setValue("");
    this.obstetricHistory.controls['obsparas'].setValue("")
    this.obstetricHistory.controls['obsabortions'].setValue("");
    this.obstetricHistory.controls['obsgeneralnotess'].setValue("");
    this.currentpreg.controls['obsgeneralnotess1'].setValue("");
    this.gynecologyHistory.controls['gyneclmps'].setValue("");
    this.gynecologyHistory.controls['gynecmenstrualcomplaints1'].setValue("");
    this.gynecologyHistory.controls['gynecmenstrualcomplaints2'].setValue("");
    this.gynecologyHistory.controls['gynecmenstrualhistorys'].setValue("");
    this.gynecologyHistory.controls['gynecnotes'].setValue("");
  }

  changeEdd() {
    this.obstetricHistorydata = this.obstetricHistory.value
    this.eddfirstdate = new Date(this.tempobseddminDate)
    var dd: any = this.eddfirstdate.getDate();
    var mm: any = this.eddfirstdate.getMonth() + 1;
    var yy: any = this.eddfirstdate.getFullYear();
    this.eddlastdate = new Date(this.obstetricHistorydata.obsedds)
    var dd1: any = this.eddlastdate.getDate();
    var mm1: any = this.eddlastdate.getMonth() + 1;
    var yy1: any = this.eddlastdate.getFullYear();
    if (parseInt(yy) <= parseInt(yy1)) {
      if (parseInt(yy) < parseInt(yy1)) {
        this.toastr.error("Date is greater than LMP+280 days")
      } else if (parseInt(yy) == parseInt(yy1)) {
        if (parseInt(mm) <= parseInt(mm1)) {
          if (parseInt(mm) < parseInt(mm1)) {
            this.toastr.error("Date is greater than LMP+280 days")
          } else if (parseInt(mm) == parseInt(mm1)) {
            if (parseInt(dd) < parseInt(dd1)) {
              this.toastr.error("Date is greater than LMP+280 days")
            }
          }
        }
      }
    }
  }

  preventInput(event) {
    let value = this.obspara;
    if (value > 10) {
      if (value <= 99) {
        event.preventDefault()
        this.obspara = parseInt(value.toString().substring(0, 1));
      } else if (value > 99) {
        event.preventDefault()
        this.obspara = parseInt(value.toString().substring(0, 2));
      }
    }
  }

  preventInput1(event) {
    let value = this.obsabortion;
    if (value > 10) {
      if (value <= 99) {
        event.preventDefault()
        this.obsabortion = parseInt(value.toString().substring(0, 1));
      } else if (value > 99) {
        event.preventDefault()
        this.obsabortion = parseInt(value.toString().substring(0, 2));
      }
    }
  }

  addabortpara() {
    this.obsgravida = this.obspara + this.obsabortion
  }

  validateobst() {
    this.obstetricHistorydata = this.obstetricHistory.value
    this.lmp_update = !this.lmp_update
    if (this.obstetricHistorydata.obslmps) {
      this.save_obshistory()
    } else {
      this.lmpmissing = true
      this.openaddlmpmissingpopup()
    }
  }

  save_obshistory() {
    this.obstetricHistorydata = this.obstetricHistory.value
    let data = {
      "account_email": this.dmail,
      "lmp": this.obstetricHistorydata.obslmps ? this.obstetricHistorydata.obslmps : "",
      "expected_delivery": this.obstetricHistorydata.obsedds ? this.obstetricHistorydata.obsedds : "",
      "actual_delivery": this.obstetricHistorydata.obsactualdeliverys ? this.obstetricHistorydata.obsactualdeliverys : "",
      "gravida": this.obstetricHistorydata.obsgravidas ? this.obstetricHistorydata.obsgravidas : "0",
      "para": this.obstetricHistorydata.obsparas ? this.obstetricHistorydata.obsparas : "0",
      "abortions": this.obstetricHistorydata.obsabortions ? this.obstetricHistorydata.obsabortions : "0",
      "notes": this.obstetricHistorydata.obsgeneralnotess ? this.obstetricHistorydata.obsgeneralnotess : "",
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.createobsthistory, data, this.token).subscribe((response: any) => {
      this.toastr.success(response.message)
      this.get_obsthistory()
    });

  }

  get_obsthistory() {
    let data = {
      "account_email": this.dmail,
      "patient_email": this.data.patientDetails.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.getobsthistory, data, this.token).subscribe((response: any) => {
      if (response.data.length > 0) {
        this.templmp = response.data[0].lmp.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestlmp = this.datepipe.transform(this.templmp, 'yyyy-MM-dd');
        this.obstetricHistory.controls['obslmps'].setValue(latestlmp);

        this.tempedd = response.data[0].expected_delivery.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestedd = this.datepipe.transform(this.tempedd, 'yyyy-MM-dd');
        this.obstetricHistory.controls['obsedds'].setValue(latestedd);
        this.appService.sendObsteddData(response.data[0].expected_delivery);

        this.tempactdel = response.data[0].actual_delivery.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestactdel = this.datepipe.transform(this.tempactdel, 'yyyy-MM-dd');
        this.obstetricHistory.controls['obsactualdeliverys'].setValue(latestactdel);

        this.obstetricHistory.controls['obsgravidas'].setValue(response.data[0].gravida);
        this.obstetricHistory.controls['obsparas'].setValue(response.data[0].para);
        this.obstetricHistory.controls['obsabortions'].setValue(response.data[0].abortions);
        this.obstetricHistory.controls['obsgeneralnotess'].setValue(response.data[0].notes);
      } else {
        this.obstetricHistory.controls['obslmps'].setValue("");
        this.obstetricHistory.controls['obsedds'].setValue("");
        this.obstetricHistory.controls['obsactualdeliverys'].setValue("");
        this.obstetricHistory.controls['obsgravidas'].setValue("");
        this.obstetricHistory.controls['obsparas'].setValue("")
        this.obstetricHistory.controls['obsabortions'].setValue("");
        this.obstetricHistory.controls['obsgeneralnotess'].setValue("");
      }


      this.lmp_update = !this.lmp_update
    });
  }

  openaddlmpmissingpopup() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialoglmpmissingpopup, {
      width: '600px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.lmpok == "1") {
        this.save_obshistory()
      } else if (sessionStorage.lmpok == "0") {
        return
      }

    });
  }

  viewObstCurrentTab(obst, currentTab, checkstatus) {
    if (checkstatus == 'default') {
      setTimeout(() => {
        for (var i = 0; i < 2; i++) {
          const el = document.getElementsByClassName('obstab')[i] as HTMLElement;
          el.style.color = "#0063ff";
          el.style.background = "none";
          el.style.borderRadius = "none";
        }
        document.getElementById('obstab_' + currentTab).style.color = "#fff";
        document.getElementById('obstab_' + currentTab).style.background = "#0063FF";
        document.getElementById('obstab_' + currentTab).style.borderRadius = "6px";
      }, 500);
    } else {
      for (var i = 0; i < 2; i++) {
        const el = document.getElementsByClassName('obstab')[i] as HTMLElement;
        el.style.color = "#0063ff";
        el.style.background = "none";
        el.style.borderRadius = "none";
      }
      document.getElementById('obstab_' + currentTab).style.color = "#fff";
      document.getElementById('obstab_' + currentTab).style.background = "#0063FF";
      document.getElementById('obstab_' + currentTab).style.borderRadius = "6px";
    }
    this.viewObstStatus = obst;
  }

  viewgynecCurrentTab(tabstatus, currentTab, checkstataus) {
    if (checkstataus == 'default') {
      setTimeout(() => {
        for (var i = 0; i < 2; i++) {
          const el = document.getElementsByClassName('gynectab')[i] as HTMLElement;
          el.style.color = "#0063ff";
          el.style.background = "none";
          el.style.borderRadius = "none";
        }
        document.getElementById('gynectab_' + currentTab).style.color = "#fff";
        document.getElementById('gynectab_' + currentTab).style.background = "#0063FF";
        document.getElementById('gynectab_' + currentTab).style.borderRadius = "6px";
      }, 500)
    }
    else {
      for (var i = 0; i < 2; i++) {
        const el = document.getElementsByClassName('gynectab')[i] as HTMLElement;
        el.style.color = "#0063ff";
        el.style.background = "none";
        el.style.borderRadius = "none";
      }
      document.getElementById('gynectab_' + currentTab).style.color = "#fff";
      document.getElementById('gynectab_' + currentTab).style.background = "#0063FF";
      document.getElementById('gynectab_' + currentTab).style.borderRadius = "6px";
    }
    this.viewgynecStatus = tabstatus;
  }

  checkUncheckAll() {
    for (var i = 0; i < this.viewcurrentpregRecords.length; i++) {
      this.viewcurrentpregRecords[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  openaddpara() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpara, {
      width: '1200px',
      data: { option: 1 },
      position: { bottom: '100px' },
      disableClose: true
    });
  }

  openviewpara() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpara2, {
      width: '1200px',
      data: { option: 1 },
      disableClose: false
    });
  }

  openaddAbort() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogabortion, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
  }

  openviewAbort() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogabortion2, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  save_currentpregnancydetails() {
    this.currentpregdata = this.currentpreg.value;

    let data = {
      "account_email": this.dmail,
      "lmp": this.currentpregdata.obslmps1 ? this.currentpregdata.obslmps1 : "",
      "expected_delivery": this.currentpregdata.obsedds1 ? this.currentpregdata.obsedds1 : "",
      "obst_history": this.currentpregdata.obsgeneralnotess1 ? this.currentpregdata.obsgeneralnotess1 : "",
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.createcurrentpregnancy, data, this.token).subscribe((response: any) => {
      if (response.status == 1) {
        this.toastr.success(response.message);
        this.get_currentpregnancy();
      } else {
        this.toastr.error("Unable to save data")
      }
    });
  }

  get_currentpregnancy() {
    // this.displaypatientname = this.data.patientDetails.record_info.Record.label
    let data = {
      "account_email": this.dmail,
      "patient_email": this.data.patientDetails.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.getcurrentpregnancy, data, this.token).subscribe((response: any) => {
      if (response.data.length > 0) {
        this.templmp1 = response.data[0].lmp.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestlmp1 = this.datepipe.transform(this.templmp1, 'yyyy-MM-dd');
        this.currentpreg.controls['obslmps1'].setValue(latestlmp1);

        this.tempedd1 = response.data[0].edd.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        let latestedd1 = this.datepipe.transform(this.tempedd1, 'yyyy-MM-dd');
        this.currentpreg.controls['obsedds1'].setValue(latestedd1);

        this.currentpreg.controls['obsgeneralnotess1'].setValue(response.data[0].obst_history);
      } else {
        this.currentpreg.controls['obsgeneralnotess1'].setValue("");
      }

    });
  }

  updatescanreport() {
    if (this.checkboxvalue == true) {
      if (sessionStorage.apt_id) {

        var scandate = this.scannedondate.split("-").reverse().join("-")
        var nextscandate = this.nextscanfollowup
        this.follow_text = this.nextscanfollowup
        var todayscandate = this.scancurrentdate.split("-").reverse().join("-")

        var data = {
          "patient_email": sessionStorage.patientemail,
          "account_email": this.dmail,
          "doctor_id": this.doc_id,
          "scan_date": scandate,
          "scan_findings": this.updatescanfindings,
          "next_scan_date": nextscandate,
          "date": todayscandate,
          "appointment_id": sessionStorage.apt_id,
          "follow_up": "1"
        }
        //this.save_add()
        this.appService.postData(this.urlPoints.createusscanreport, data, this.token).subscribe((response: any) => {
          if (response.status == 0) {
            this.toastr.error(response.error)
          } else if (response.status == 1) {
            this.toastr.success(response.message)
          }
          this.enablescandetail1()
          sessionStorage.removeItem("createscanid")
          this.get_scanreportfindingdata();
        });

      } else {
        this.openaddalertscanfollowup();
      }
    } else if (this.checkboxvalue == false) {
      return
    }
  }

  save_currentpregnancyRiskdetails() {
    if (this.riskstatusmodified == true) {
      this.todayriskdatetemp = new Date()
      this.todayriskdate = this.datepipe.transform(this.todayriskdatetemp, 'yyyy-MM-dd');
      let data = {
        "account_email": this.dmail,
        "date": this.todayriskdate,
        "risk_from": this.latestcurrentpregDetails ? this.latestcurrentpregDetails : "",
        "risk_to": this.currentpregdata.obspregrisks,
        "patient_email": this.data.patientDetails.record_info.Record.account_email,
        "doctor_id": this.doc_id
      }
      this.appService.postData(this.urlPoints.createrisk, data, this.token).subscribe((response: any) => {
        if (response.status == 1) {
          this.toastr.success(response.message)
          this.get_currentpregnancyRiskdetails()
        } else if (response.status == 0) {
          this.toastr.error("Pregnancy Risk can be changed just once per day")
        }
      });
      this.riskstatusmodified = false;
    } else {
    }

  }

  openviewRiskhistory() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogriskhistory, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  get_currentpregnancyRiskdetails() {
    let data = {
      "account_email": this.dmail,
      "patient_email": this.data.patientDetails.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.getrisk, data, this.token).subscribe((response: any) => {

      this.currentpreg.controls['obspregrisks'].setValue(response.data[0].risk_to);
      this.latestcurrentpregDetails = response.data[0].risk_to
      this.appService.sendCpRiskData(response.data[0].risk_to);
      this.viewcurrentpregRisk = response.data
      this.viewcurrentpregRisk.forEach(function (value) {
        value.isSelected = false
      })
    });
  }

  get_currentpregnancyRecords() {
    let data = {
      "account_email": this.dmail,
      "patient_email": this.data.patientDetails.record_info.Record.account_email
    }
    this.appService.getData(this.urlPoints.getpregnancyrecord, data, this.token).subscribe((response: any) => {
      this.viewcurrentpregRecords = response.data;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.viewcurrentpregRecords.forEach(function (value) {
        value.isSelected = false
      })
      this.getCheckedItemList();
    });

  }

  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.viewcurrentpregRecords.length; i++) {
      if (this.viewcurrentpregRecords[i].isSelected)
        this.checkedList.push({ "id": this.viewcurrentpregRecords[i].id });
    }
  }

  enablescandetail1() {
    return true
  }

  openviewarchivedcpRisk() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogviewarchivedcpRisk, {
      width: '1200px',
      data: { option: 1 }
    });
  }
  get_scanreportfindingdata() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "doctor_id": this.doc_id
    }
    this.appService.getData(this.urlPoints.getusscanreport, data, this.token).subscribe((response: any) => {
      this.viewscanreportfindingdata = response.data;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      if (response.data == "no scan reports found") {
        this.emptygetscan = true
      } else {
        this.emptygetscan = false
        this.viewscanreportfindingdata = response.data
        this.viewscanreportfindingdata.forEach(function (value) {
          value.isSelected = false
          value.isScanSelected = false
        })
        this.getCheckedItemList2();
      }
    });

  }

  getCheckedItemList2() {
    this.checkedList2 = [];
    for (var i = 0; i < this.viewscanreportfindingdata.length; i++) {
      if (this.viewscanreportfindingdata[i].isSelected)
        this.checkedList2.push({ "id": this.viewscanreportfindingdata[i].id });
    }
  }

  checkUncheckAll2() {
    for (var i = 0; i < this.viewscanreportfindingdata.length; i++) {
      this.viewscanreportfindingdata[i].isSelected = this.masterSelected2;
    }
    this.getCheckedItemList2();
  }

  isAllSelected2() {
    this.masterSelected2 = this.viewscanreportfindingdata.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList2();
  }

  togglescanfollowup(data) {

  }

  archivecpscan() {
    // if (this.viewscanreportfindingdata == "no scan reports found") {
    if (this.viewscanreportfindingdata == []) {
      this.toastr.error("No records found")
    } else {
      if (this.checkedList2.length == 0) {

        this.toastr.error("Please select any record")

      } else if (this.checkedList2.length > 0) {
        let data = {
          "account_email": this.dmail,
          "data": this.checkedList2
        }
        this.appService.postData(this.urlPoints.createusscanreport, data, this.token).subscribe((response: any) => {
          this.toastr.success("Archived successfully")
          this.get_scanreportfindingdata();
          this.masterSelected2 = false
        });
      }
    }
  }

  openviewarchivedcpscan() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogviewarchivedcpscan, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  openaddscanreport() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogaddscanreport, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.get_scanreportfindingdata();
    });
  }

  openaddalertscanfollowup() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogalertscanfollowup, {
      width: '600px',
      data: { option: 1 }
    });
  }

  riskstatusmodifiedfunc() {
    this.riskstatusmodified = true
  }

  openviewarchivedcpRecords() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogviewarchivedcpRecords, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  archivecpRecords() {
    this.openclearlmpeddaddDeatils()
    if (this.checkedList.length == 0) {
      if (this.viewcurrentpregRecords.length == 0) {
        this.toastr.error("No records found")
      } else {
        this.toastr.error("Please select any record")
      }
    } else if (this.checkedList.length > 0) {
      let data = {
        "account_email": this.dmail,
        "data": this.checkedList
      }
      this.appService.postData(this.urlPoints.createpregnancyrecord, data, this.token).subscribe((response: any) => {
        this.toastr.success("Archived successfully")
        this.get_currentpregnancyRecords();
        this.masterSelected = false
      });
    }

  }

  openclearlmpeddaddDeatils() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialoglclearlmpeddaddDeatils, {
      width: '600px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.clearlmpedd == "1") {
        this.obstetricHistorydata = this.obstetricHistory.value
        let data = {
          "account_email": this.dmail,
          "lmp": "",
          "expected_delivery": "",
          "actual_delivery": "",
          "gravida": this.obstetricHistorydata.obsgravidas ? this.obstetricHistorydata.obsgravidas : "0",
          "para": this.obstetricHistorydata.obsparas ? this.obstetricHistorydata.obsparas : "0",
          "abortions": this.obstetricHistorydata.obsabortions ? this.obstetricHistorydata.obsabortions : "0",
          "notes": this.obstetricHistorydata.obsgeneralnotess ? this.obstetricHistorydata.obsgeneralnotess : "",
          "patient_email": this.data.patientDetails.record_info.Record.account_email,
          "doctor_id": this.doc_id
        }
        this.appService.postData(this.urlPoints.createobsthistory, data, this.token).subscribe((response: any) => {
          this.toastr.success("Updated successfully")
          this.get_obsthistory()
        });
      } else if (sessionStorage.clearlmpedd == "0") {
        return
      }

    });
  }

  setfollowupdate(position, nextscandate, date, scandate, scanfindings, checkboxvalue) {
    this.checkboxvalue = !checkboxvalue
    this.nextscanfollowup = nextscandate.split("-").reverse().join("-")

    this.scancurrentdate = date
    this.scannedondate = scandate
    this.updatescanfindings = scanfindings
  }

  enablescandetail(temp) {
    if (parseInt(temp) == parseInt(sessionStorage.createscanid)) {
      return false;
    } else {
      return true;
    }
  }

  openaddcurrentpregRecords() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogaddcurrentpregRecords, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.get_currentpregnancyRecords();

    });
  }

  isAllSelected() {
    this.masterSelected = this.viewcurrentpregRecords.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }

  //Gynec

  save_gynecologyhistory() {
    this.gynechistorydata = this.gynecologyHistory.value
    if (this.gynechistorydata.gynecmenstrualcomplaints1) {
      this.gyneccomplaint = this.gynechistorydata.gynecmenstrualcomplaints1
    }
    if (this.gynechistorydata.gynecmenstrualcomplaints2) {
      this.gyneccomplaint = this.gynechistorydata.gynecmenstrualcomplaints2
    }
    let data = {
      "account_email": this.dmail,
      "complaint": this.gyneccomplaint ? this.gyneccomplaint : "",
      "date": this.gynechistorydata.gynecdoes ? this.gynechistorydata.gynecdoes : "",
      "lmp": this.gynechistorydata.gyneclmps ? this.gynechistorydata.gyneclmps : "",
      "mensural_history": this.gynechistorydata.gynecmenstrualhistorys ? this.gynechistorydata.gynecmenstrualhistorys : "",
      "notes": this.gynechistorydata.gynecnotes ? this.gynechistorydata.gynecnotes : "",
      "patient_email": this.data.patientDetails.record_info.Record.account_email,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.creategynaehistory, data, this.token).subscribe((response: any) => {
      if (response.status == 1) {
        this.toastr.success(response.message)
      } else {
        this.toastr.error("Unable to save data")
      }
      // this.gynechistorydata = ""
      this.get_gynecologydetails()
    });
  }

  get_gynecologydetails() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
    }
    this.appService.getData(this.urlPoints.getgynaechistory, data, this.token).subscribe((response: any) => {
      this.viewfgynechistorydata = response.data
      this.gynecologyHistory.controls['gyneclmps'].setValue("");
      this.gynecologyHistory.controls['gynecmenstrualcomplaints1'].setValue("");
      this.gynecologyHistory.controls['gynecmenstrualcomplaints2'].setValue("");
      this.gynecologyHistory.controls['gynecmenstrualhistorys'].setValue("");
      this.gynecologyHistory.controls['gynecnotes'].setValue("");
    });
  }

  togglemenstrualcomplaint() {
    this.gynechistorydata = this.gynecologyHistory.value
    if (this.gynechistorydata.gynecmenstrualhistorys == "premenopausal") {
      this.showpremenopausalcomp = true
    } else if (this.gynechistorydata.gynecmenstrualhistorys == "postmenopausal") {
      this.showpremenopausalcomp = false
    }
  }

  checkUncheckAll3() {
    for (var i = 0; i < this.viewfolliclestudydata.length; i++) {
      this.viewfolliclestudydata[i].isSelected = this.masterSelected3;
    }
    this.getCheckedItemList3();
  }

  isAllSelected3() {
    this.masterSelected3 = this.viewfolliclestudydata.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList3();
  }

  getCheckedItemList3() {
    this.checkedList3 = [];
    for (var i = 0; i < this.viewfolliclestudydata.length; i++) {
      if (this.viewfolliclestudydata[i].isSelected)
        this.checkedList3.push({ "id": this.viewfolliclestudydata[i].id });
    }
  }

  openaddfolliclestudy() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogaddfolliclestudy, {
      width: '1200px',
      data: { option: 1 },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.get_folliclestudydetails();

    });
  }

  get_folliclestudydetails() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
    }
    this.appService.getData(this.urlPoints.getfollicular, data, this.token).subscribe((response: any) => {
      this.viewfolliclestudydata = response.data;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
      this.viewfolliclestudydata.forEach(function (value) {
        value.isSelected = false
      })
      this.getCheckedItemList3();
    });
  }

  openviewarchivedfollicle() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogviewarchivedfollicle, {
      width: '1200px',
      data: { option: 1 }
    });
  }

  archivefollicle() {
    if (this.checkedList3.length == 0) {
      if (this.viewfolliclestudydata.length == 0) {
        this.toastr.error("No records found")
      } else {
        this.toastr.error("Please select any record")
      }
    } else if (this.checkedList3.length > 0) {
      let data = {
        "account_email": this.dmail,
        "data": this.checkedList3
      }
      this.appService.postData(this.urlPoints.createfollicular, data, this.token).subscribe((response: any) => {
        this.toastr.success("Archived successfully")
        this.get_folliclestudydetails();
        this.masterSelected3 = false
      });
    }
  }


  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  openSnackBar() {
    this.snackBar.open(this.success, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    if (event.key === '/' || event.key === '@' || event.key === ',') {
      return;
    } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      return;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}

@Component({
  selector: 'graph-form',
  templateUrl: 'graph-form.html',
  styleUrls: ['graph-form.scss']
})

export class DialogOverviewExampleDialog2 {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog2>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData2) {

  }
  ngOnInit(): void {
    (document.getElementById("date") as HTMLInputElement).value = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0];

    (document.getElementById("date") as HTMLInputElement).max = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0];

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    var vitals = {
      height: (document.getElementById("height") as HTMLInputElement).value,
      weight: (document.getElementById("weight") as HTMLInputElement).value,
      arm: (document.getElementById("arm") as HTMLInputElement).value,
      head: (document.getElementById("head") as HTMLInputElement).value,
      chest: (document.getElementById("chest") as HTMLInputElement).value,
      date: (document.getElementById("date") as HTMLInputElement).value
    }
    this.dialogRef.close(vitals);
  }
}


@Component({
  selector: 'labtest-form',
  templateUrl: 'labtest.html',
  styleUrls: ['labtest.scss']
})

export class DialogOverviewExampleDialog_labtest {

  afuConfig = {
    multiple: false,
    formatsAllowed: ".jpg,.png,.pdf",
    maxSize: "1",
    uploadAPI: {
      url: "https://api.epicare.net/helyxonapi/cloud/image/image.php",
      method: "POST",
      headers: {
        "Content-Type": "text/plain;charset=UTF-8",
        "Authorization": `Bearer ${AppConstants.TOKEN}`
      },
      params: {
      },
      responseType: 'blob',
    },
    hideProgressBar: false,
    hideResetBtn: true,
    name: "photo",
    replaceTexts: {
      selectFileBtn: 'Select Files',
      resetBtn: 'Reset',
      uploadBtn: 'Upload File',
      dragNDropBox: 'Drag N Drop',
      attachPinBtn: 'Attach Files...',
      afterUploadMsg_success: 'Successfully Uploaded !',
      afterUploadMsg_error: 'Upload Failed !',
      sizeLimit: 'Size Limit'
    }

  };




  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

  }
  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'template-app',
  templateUrl: 'template.html',
  styleUrls: ['template.scss']
})

export class Dialog_template {
  name;
  submitted;
  nameForm;
  urlPoints;

  constructor(
    public dialogRef: MatDialogRef<Dialog_template>, private fb: FormBuilder, public dialog: MatDialog, private appService: AppService, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_template) {
    this.nameForm = this.fb.group({
      name: ["", Validators.required],
      tag: [""]

    })

    this.urlPoints = AppConfig.settings.EndPoints;

  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  save() {
    this.submitted = true;



    if (this.nameForm.valid) {
      var params: any = this.data.details;
      params.name = this.nameForm.value.name;
      params.name_index = this.nameForm.value.tag ? this.nameForm.value.tag : null;

      params.doctor_id = this.data.doctor_id,
        params.patient_email = this.data.patient_email,
        params.account_email = this.data.account_email


      this.appService.postData(this.urlPoints.saveTemplate, params, this.data.token).subscribe((response: any) => {
        if (response.message == 'template_name already exists') {
          const dialogRef = this.dialog.open(DialogOverviewExampleDialog_notifier, {
            width: '600px',
            data: { name: 'Template name already exists!' }
          });
        }
        else {
          this.dialogRef.close(response)
        }
      });
    }
  }
  cancel() {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'add-popupexit',
  templateUrl: 'addpopupexit.html',
  styleUrls: ['addpopupexit.scss']
})

export class DialogOverviewExampleDialogpopupexit {
  paraDetails: any;
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any;
  paradata: any;


  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDatapara, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {

  }
  ngOnInit(): void {

  }

  closeone(): void {
    sessionStorage.setItem("close", "0")
    this.dialogRef.close();
  }

  closeall() {
    sessionStorage.setItem("close", "1")
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'add-para',
  templateUrl: 'addpara.html',
  styleUrls: ['addpara.scss']
})

export class DialogOverviewExampleDialogpara {
  paraDetails: any;
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any;
  paradata: any;


  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDatapara, public fb: FormBuilder, public dialog: MatDialog, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.paraDetails = this.fb.group({
      parapregterms: [""],
      paradeliverytypes: [""],
      parababystatuses: [""],
      paradods: [""],
      parageneralnotes: [""]
    })
  }
  ngOnInit(): void {
    // this.sub = this.route.queryParams
    //   .subscribe(params => {
    //     this.id = params['id'];
    //     this.doc_id = params['did']
    //     this.mode = params['mode']
    //     this.token = params['token']
    //     this.dmail = params['dmail']
    //   });
  }

  obsparamaxDate = moment(new Date()).format('YYYY-MM-DD')
  openpopupforexit() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpopupexit, {
      width: '600px',
      data: { option: 1 }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.close == "0") {
        return
      } else if (sessionStorage.close == "1") {
        this.dialogRef.close();
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save_paradetails() {

    let getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));

    this.dmail = getauthdetails.account_id;
    this.doc_id = getauthdetails.doctor_id;
    this.token = getauthdetails.token;

    this.paradata = this.paraDetails.value
    let data1: any = {
      "account_email": this.dmail,
      "delivery_date": this.paradata.paradods,
      "pregnancy_term": this.paradata.parapregterms,
      "delivery_type": this.paradata.paradeliverytypes,
      "baby_status": this.paradata.parababystatuses,
      "notes": this.paradata.parageneralnotes,
      "patient_email": sessionStorage.patientemail,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.createpara, data1, this.token).subscribe((response: any) => {
      if (response.status == 0) {
        this.toastr.error("Unable to add details")
      } else if (response.status == 1) {
        this.toastr.success(response.message)
        this.dialogRef.close();
      }
    });

  }
}

@Component({
  selector: 'view-para',
  templateUrl: 'viewpara.html',
  styleUrls: ['viewpara.scss']
})

export class DialogOverviewExampleDialogpara2 {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any;
  paradataview: any;
  viewparaDetails: any;


  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDatapara2, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {
    this.sub = this.route.queryParams
      .subscribe(params => {
        this.id = params['id'];
        this.doc_id = params['did']
        this.mode = params['mode']
        this.token = params['token']
        this.dmail = params['dmail']
      });
    this.view_paradetails()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  view_paradetails() {
    //  this.paradataview = this.paraDetailsview.value
    let getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));

    this.dmail = getauthdetails.account_id;
    this.doc_id = getauthdetails.doctor_id;
    this.token = getauthdetails.token;
    let data1: any = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail
    }
    this.appService.getData(this.urlPoints.getpara, data1, this.token).subscribe((response: any) => {
      if (response.data.length > 0) {
        this.viewparaDetails = response.data
      } else {
        this.toastr.error("No data found")
      }
    });

  }
}

@Component({
  selector: 'add-abortion',
  templateUrl: 'addabortion.html',
  styleUrls: ['addabortion.scss']
})

export class DialogOverviewExampleDialogabortion {
  abortionDetails: any;
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any;
  abortiondata: any;


  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataAbortion, public fb: FormBuilder, public dialog: MatDialog, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.abortionDetails = this.fb.group({
      abortType: [""],
      abortTerm: [""],
      abortdate: [""],
      abortnotes: [""]
    })
  }

  ngOnInit(): void {
    this.sub = this.route.queryParams
      .subscribe(params => {
        this.id = params['id'];
        this.doc_id = params['did']
        this.mode = params['mode']
        this.token = params['token']
        this.dmail = params['dmail']
      });
  }


  obsabortmaxDate = moment(new Date()).format('YYYY-MM-DD')
  openpopupforexit() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpopupexit, {
      width: '600px',
      data: { option: 1 }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.close == "0") {
        return
      } else if (sessionStorage.close == "1") {
        this.dialogRef.close();
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save_abortiondetails() {
    let getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));

    this.dmail = getauthdetails.account_id;
    this.doc_id = getauthdetails.doctor_id;
    this.token = getauthdetails.token;
    this.abortiondata = this.abortionDetails.value
    let data1: any = {
      "account_email": this.dmail,
      "abortion_date": this.abortiondata.abortdate,
      "abortion_type": this.abortiondata.abortType,
      "mode": this.abortiondata.abortTerm,
      "notes": this.abortiondata.abortnotes,
      "patient_email": sessionStorage.patientemail,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.createabortions, data1, this.token).subscribe((response: any) => {
      if (response.status == 0) {
        this.toastr.error("Unable to add details")
      } else if (response.status == 1) {
        this.toastr.success(response.message)
        this.dialogRef.close();
      }
    });

  }
}

@Component({
  selector: 'view-abortion',
  templateUrl: 'viewabortion.html',
  styleUrls: ['viewabortion.scss']
})

export class DialogOverviewExampleDialogabortion2 {
  viewabortionDetails: any;
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any;


  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataAbortion2, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {
    this.sub = this.route.queryParams
      .subscribe(params => {
        this.id = params['id'];
        this.doc_id = params['did']
        this.mode = params['mode']
        this.token = params['token']
        this.dmail = params['dmail']
      });
    this.view_abortiondetails()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  view_abortiondetails() {
    let getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));

    this.dmail = getauthdetails.account_id;
    this.doc_id = getauthdetails.doctor_id;
    this.token = getauthdetails.token;
    let data1: any = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail
    }
    this.appService.getData(this.urlPoints.getabortions, data1, this.token).subscribe((response: any) => {
      if (response.data.length > 0) {
        this.viewabortionDetails = response.data
      } else {
        this.toastr.error("No data found")
      }
    });

  }
}

@Component({
  selector: 'alert-lmpmissingpopup',
  templateUrl: 'alertlmpmissingpopup.html',
  styleUrls: ['alertlmpmissingpopup.scss']
})

export class DialogOverviewExampleDialoglmpmissingpopup {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDatalmpmissingpopup) {
  }
  ngOnInit(): void { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  finalsaveobsthistoryok(): void {
    sessionStorage.setItem("lmpok", "1")
    this.dialogRef.close();
  }

  finalsaveobsthistoryno() {
    sessionStorage.setItem("lmpok", "0")
    this.dialogRef.close();
  }

}

@Component({
  selector: 'slider',
  templateUrl: 'slider.html',
  styleUrls: ['slider.scss']
})

export class DialogOverviewExampleDialogSlider {
  slider_value;
  imgSrc = "assets/filled1.svg"
  // imgSrc_srini = "assets/filled_1.png"
  imgSrc_srini = "assets/filled1_.png"
  mode;

  constructor(
    public dialogRef: MatDialogRef<DialogData_slider>,
    @Inject(MAT_DIALOG_DATA) public data: DialogOverviewExampleDialogSlider) {
  }
  ngOnInit(): void {
    this.mode = this.data.mode
    this.slider()
    this.slider_value = sessionStorage.getItem('slidervalue')

    this.changeImage()
  }

  changeImage() {
if(this.mode){
  if (this.slider_value >= 0 && this.slider_value < 16.35) {
    this.slider_value = 0
  }

  if (this.slider_value >= 16.35 && this.slider_value < 49.05)
    this.slider_value = 32.7

  if (this.slider_value >= 49.05 && this.slider_value < 81.75)
    this.slider_value = 65.4

  if (this.slider_value >= 81.75 && this.slider_value < 114.45)
    this.slider_value = 98.1

  if (this.slider_value >= 114.45 && this.slider_value < 147.15)
    this.slider_value = 130.8

  if (this.slider_value >= 147.15 && this.slider_value < 179.85)
    this.slider_value = 163.5

  if (this.slider_value >= 179.85 && this.slider_value < 212.55)
    this.slider_value = 196.2

  if (this.slider_value >= 212.55 && this.slider_value < 245.25)
    this.slider_value = 228.9

  if (this.slider_value >= 245.25 && this.slider_value < 277.95)
    this.slider_value = 261.6

  if (this.slider_value >= 277.95 && this.slider_value < 310.65)
    this.slider_value = 294.3

  if (this.slider_value >= 310.65 && this.slider_value < 343.35)
    this.slider_value = 327

  if (this.slider_value >= 343.35 && this.slider_value < 360)
    this.slider_value = 0
  
  if (this.slider_value >= 360)
    this.slider_value = 0
}else{
  
  if (this.slider_value >= 22.5 && this.slider_value < 67.5)
  this.slider_value = 45

if (this.slider_value >= 67.5 && this.slider_value < 112.5)
  this.slider_value = 90

if (this.slider_value >= 112.5 && this.slider_value < 157.5)
  this.slider_value = 135

if (this.slider_value >= 157.5 && this.slider_value < 202.5)
  this.slider_value = 180

if (this.slider_value >= 202.5 && this.slider_value < 247.5)
  this.slider_value = 225

if (this.slider_value >= 247.5 && this.slider_value < 292.5)
  this.slider_value = 270

if (this.slider_value >= 292.5 && this.slider_value < 337.5)
  this.slider_value = 315

if (this.slider_value >= 337.5 && this.slider_value < 360)
  this.slider_value = 0

if (this.slider_value >= 360)
  this.slider_value = 0
}   
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  slider() {
    var that = this
    $("#slider1").roundSlider(
      {
        value: sessionStorage.getItem('slidervalue'),
        animation: false,
        step: 1,
        max: 360,
        startAngle: 90,
        editableTooltip: false,
        showTooltip: false,
        change: function (args) {
          that.slider_value = args.value
if(this.mode){
// only for srinivas
          if (that.slider_value >= 0 && that.slider_value < 16.35) {
            that.slider_value = 0
          }

          if (that.slider_value >= 16.35 && that.slider_value < 49.05)
            that.slider_value = 32.7

          if (that.slider_value >= 49.05 && that.slider_value < 81.75)
            that.slider_value = 65.4

          if (that.slider_value >= 81.75 && that.slider_value < 114.45)
            that.slider_value = 98.1

          if (that.slider_value >= 114.45 && that.slider_value < 147.15)
            that.slider_value = 130.8

          if (that.slider_value >= 147.15 && that.slider_value < 179.85)
            that.slider_value = 163.5

          if (that.slider_value >= 179.85 && that.slider_value < 212.55)
            that.slider_value = 196.2

          if (that.slider_value >= 212.55 && that.slider_value < 245.25)
            that.slider_value = 228.9

          if (that.slider_value >= 245.25 && that.slider_value < 277.95)
            that.slider_value = 261.6

          if (that.slider_value >= 277.95 && that.slider_value < 310.65)
            that.slider_value = 294.3

          if (that.slider_value >= 310.65 && that.slider_value < 343.35)
            that.slider_value = 327

          if (that.slider_value >= 343.35 && that.slider_value < 360)
            that.slider_value = 0

          if (that.slider_value >= 360)
            that.slider_value = 0
        }else{
          if (that.slider_value >= 0 && that.slider_value < 22.5) {
            that.slider_value = 0
          }

          if (that.slider_value >= 22.5 && that.slider_value < 67.5)
            that.slider_value = 45

          if (that.slider_value >= 67.5 && that.slider_value < 112.5)
            that.slider_value = 90

          if (that.slider_value >= 112.5 && that.slider_value < 157.5)
            that.slider_value = 135

          if (that.slider_value >= 157.5 && that.slider_value < 202.5)
            that.slider_value = 180

          if (that.slider_value >= 202.5 && that.slider_value < 247.5)
            that.slider_value = 225

          if (that.slider_value >= 247.5 && that.slider_value < 292.5)
            that.slider_value = 270

          if (that.slider_value >= 292.5 && that.slider_value < 337.5)
            that.slider_value = 315

          if (that.slider_value >= 337.5 && that.slider_value < 360)
            that.slider_value = 0

          if (that.slider_value >= 360)
            that.slider_value = 0
        }

          that.changeSlider()
          $('#range').html(args.value)
        },
        drag: function (args) {
          $('#range').html(args.value)
        }
      }
    );
  }

  changeSlider() {
    var that = this
    this.changeImage()

    $("#slider1").roundSlider(
      {
        value: that.slider_value,
      }
    );

  }

  changeSliderValue(i) {
    this.slider_value = i
    this.changeSlider()
  }

  close() {
    this.dialogRef.close();

  }

  ok() {
    var obj = {
      value: this.slider_value
    }

    this.dialogRef.close(obj)
  }
}

@Component({
  selector: 'slider2',
  templateUrl: 'slider2.html',
  styleUrls: ['slider2.scss']
})

export class DialogOverviewExampleDialogSlider2 {
  slider_value;
mode_;
  constructor(
    public dialogRef: MatDialogRef<DialogData_slider>,
    @Inject(MAT_DIALOG_DATA) public data: DialogOverviewExampleDialogSlider2) {
  }
  ngOnInit(): void {
    let status = sessionStorage.getItem('status')
   this.mode_ = status == 'true' ? true : false; 
   console.log('type>>>',typeof status,":::",status)
    this.slider()
    this.slider_value = sessionStorage.getItem('slidervalue2')
    this.mode_ && this.sliderChangeView();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  sliderChangeView(){
    if (this.slider_value >= 0 && this.slider_value < 36) {
      this.slider_value = 0
    }

    if (this.slider_value >= 36 && this.slider_value < 72) {
      this.slider_value = 36
    }

    if (this.slider_value >= 72 && this.slider_value < 108) {
      this.slider_value = 72
    }

    if (this.slider_value >= 108 && this.slider_value < 144) {
      this.slider_value = 108
    }

    if (this.slider_value >= 144 && this.slider_value < 180) {
      this.slider_value = 144
    }

    if (this.slider_value >= 180 && this.slider_value < 216) {
      this.slider_value = 180
    }

    if (this.slider_value >= 216 && this.slider_value < 252) {
      this.slider_value = 216
    }

    if (this.slider_value >= 252 && this.slider_value < 288) {
      this.slider_value = 252
    }
    if (this.slider_value >= 288 && this.slider_value < 324) {
      this.slider_value = 288
    }
    if (this.slider_value >= 324 && this.slider_value <= 360) {
      this.slider_value = 324
    }
// if(this.slider_value > 360)
// this.slider_value =0

  }

  slider() {
    var that = this

    $("#slider2").roundSlider(
      {
        value: sessionStorage.getItem('slidervalue2'),
        animation: false,
        step: 1,
        max: 360,
        startAngle: 90,
        editableTooltip: false,
        showTooltip: false,
        change: function (args) {
          that.slider_value = args.value
if(this.mode_){
  if (this.slider_value >= 0 && this.slider_value < 36) {
    this.slider_value = 0
  }

  if (this.slider_value >= 36 && this.slider_value < 72) {
    this.slider_value = 36
  }

  if (this.slider_value >= 72 && this.slider_value < 108) {
    this.slider_value = 72
  }

  if (this.slider_value >= 108 && this.slider_value < 144) {
    this.slider_value = 108
  }

  if (this.slider_value >= 144 && this.slider_value < 180) {
    this.slider_value = 144
  }

  if (this.slider_value >= 180 && this.slider_value < 216) {
    this.slider_value = 180
  }

  if (this.slider_value >= 216 && this.slider_value < 252) {
    this.slider_value = 216
  }

  if (this.slider_value >= 252 && this.slider_value < 288) {
    this.slider_value = 252
  }
  if (this.slider_value >= 288 && this.slider_value < 324) {
    this.slider_value = 288
  }
  if (this.slider_value >= 324 && this.slider_value <= 360) {
    this.slider_value = 324
  }
}else{

          if (that.slider_value >= 30 && that.slider_value < 70) {
            that.slider_value = 50
          }

          if (that.slider_value >= 70 && that.slider_value < 110) {
            that.slider_value = 90
          }

          if (that.slider_value >= 110 && that.slider_value < 150) {
            that.slider_value = 130
          }

          if (that.slider_value >= 150 && that.slider_value < 190) {
            that.slider_value = 170
          }

          if (that.slider_value >= 190 && that.slider_value < 230) {
            that.slider_value = 210
          }

          if (that.slider_value >= 230 && that.slider_value < 270) {
            that.slider_value = 250
          }

          if (that.slider_value >= 270 && that.slider_value < 310) {
            that.slider_value = 290
          }

          if (that.slider_value >= 310 && that.slider_value < 350) {
            that.slider_value = 330
          }

          if (that.slider_value >= 350) {
            that.slider_value = 10
          }

          if (that.slider_value < 30) {
            that.slider_value = 10
          }
        }

          that.changeSlider()
          $('#range').html(args.value)
        },
        drag: function (args) {
          $('#range').html(args.value)
        }
      }
    );
  }

  changeSlider() {
    var that = this
    $("#slider2").roundSlider(
      {
        value: that.slider_value,
      }
    );
  }

  changeSliderValue(i) {
    this.slider_value = i
    this.changeSlider()
  }

  close() {
    this.dialogRef.close();

  }

  ok() {
    var obj = {
      value: this.slider_value
    }

    this.dialogRef.close(obj)
  }
}

@Component({
  selector: 'slider3',
  templateUrl: 'slider3.html',
  styleUrls: ['slider3.scss']
})

export class DialogOverviewExampleDialogSlider3 {
  slider_value;
mode;
  constructor(
    public dialogRef: MatDialogRef<DialogData_slider>,
    @Inject(MAT_DIALOG_DATA) public data: DialogOverviewExampleDialogSlider3) {
  }
  ngOnInit(): void {
this.mode = this.data.mode
    this.slider()
    this.slider_value = sessionStorage.getItem('slidervalue3')
    this.changeSlider_view()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
changeSlider_view(){
  if(this.mode){
  if (this.slider_value >= 0 && this.slider_value < 72)
  this.slider_value = 0

if (this.slider_value >= 72 && this.slider_value < 144)
  this.slider_value = 72

if (this.slider_value >= 144 && this.slider_value < 216)
  this.slider_value = 144

if (this.slider_value >= 216 && this.slider_value < 288)
  this.slider_value = 216

if (this.slider_value >= 288 && this.slider_value <= 360)
  this.slider_value = 288
  }
}
  slider() {
    var that = this
    $("#slider3").roundSlider(
      {
        value: sessionStorage.getItem('slidervalue3'),
        animation: false,
        step: 1,
        max: 360,
        startAngle: 90,
        editableTooltip: false,
        showTooltip: false,
        change: function (args) {
          that.slider_value = args.value
if(this.mode){
  if (that.slider_value >= 0 && that.slider_value < 90)
            that.slider_value = 72

          if (that.slider_value >= 90 && that.slider_value < 180)
            that.slider_value = 144

          if (that.slider_value >= 180 && that.slider_value < 270)
            that.slider_value = 256

          if (that.slider_value >= 270 && that.slider_value <= 360)
            that.slider_value = 328
}else{
  if (that.slider_value >= 0 && that.slider_value < 90)
  that.slider_value = 45

if (that.slider_value >= 90 && that.slider_value < 180)
  that.slider_value = 135

if (that.slider_value >= 180 && that.slider_value < 270)
  that.slider_value = 225

if (that.slider_value >= 270 && that.slider_value <= 360)
  that.slider_value = 315
}      

          that.changeSlider()
          $('#range').html(args.value)
        },
        drag: function (args) {
          $('#range').html(args.value)
        }
      }
    );
  }

  changeSlider() {
    var that = this
    $("#slider3").roundSlider(
      {
        value: that.slider_value,
      }
    );
  }

  changeSliderValue(i) {
    this.slider_value = i
    this.changeSlider()
  }

  close() {
    this.dialogRef.close();

  }

  ok() {
    var obj = {
      value: this.slider_value
    }

    this.dialogRef.close(obj)
  }
}





@Component({
  selector: 'slider4',
  templateUrl: 'slider4.html',
  styleUrls: ['slider4.scss']
})

export class DialogOverviewExampleDialogSlider4 {
  slider_value;
  imgSrc = "assets/filled1.svg"

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialogSlider4>,
    @Inject(MAT_DIALOG_DATA) public data: DialogOverviewExampleDialogSlider) {
  }
  ngOnInit(): void {
    this.slider()
    this.slider_value = sessionStorage.getItem('slidervalue4')

    this.changeImage()
  }

  changeImage() {

    if (this.slider_value >= 22.5 && this.slider_value < 67.5)
      this.slider_value = 45

    if (this.slider_value >= 67.5 && this.slider_value < 112.5)
      this.slider_value = 90

    if (this.slider_value >= 112.5 && this.slider_value < 157.5)
      this.slider_value = 135

    if (this.slider_value >= 157.5 && this.slider_value < 202.5)
      this.slider_value = 180

    if (this.slider_value >= 202.5 && this.slider_value < 247.5)
      this.slider_value = 225

    if (this.slider_value >= 247.5 && this.slider_value < 292.5)
      this.slider_value = 270

    if (this.slider_value >= 292.5 && this.slider_value < 337.5)
      this.slider_value = 315

    if (this.slider_value >= 337.5 && this.slider_value < 360)
      this.slider_value = 0

    if (this.slider_value >= 360)
      this.slider_value = 0
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  slider() {
    var that = this
    $("#slider1").roundSlider(
      {
        value: sessionStorage.getItem('slidervalue4'),
        animation: false,
        step: 1,
        max: 360,
        startAngle: 90,
        editableTooltip: false,
        showTooltip: false,
        change: function (args) {
          that.slider_value = args.value

          if (that.slider_value >= 0 && that.slider_value < 22.5) {
            that.slider_value = 0
          }

          if (that.slider_value >= 22.5 && that.slider_value < 67.5)
            that.slider_value = 45

          if (that.slider_value >= 67.5 && that.slider_value < 112.5)
            that.slider_value = 90

          if (that.slider_value >= 112.5 && that.slider_value < 157.5)
            that.slider_value = 135

          if (that.slider_value >= 157.5 && that.slider_value < 202.5)
            that.slider_value = 180

          if (that.slider_value >= 202.5 && that.slider_value < 247.5)
            that.slider_value = 225

          if (that.slider_value >= 247.5 && that.slider_value < 292.5)
            that.slider_value = 270

          if (that.slider_value >= 292.5 && that.slider_value < 337.5)
            that.slider_value = 315

          if (that.slider_value >= 337.5 && that.slider_value < 360)
            that.slider_value = 0

          if (that.slider_value >= 360)
            that.slider_value = 0


          that.changeSlider()
          $('#range').html(args.value)
        },
        drag: function (args) {
          $('#range').html(args.value)
        }
      }
    );
  }

  changeSlider() {
    var that = this
    this.changeImage()

    $("#slider1").roundSlider(
      {
        value: that.slider_value,
      }
    );

  }

  changeSliderValue(i) {
    this.slider_value = i
    this.changeSlider()
  }

  close() {
    this.dialogRef.close();

  }

  ok() {
    var obj = {
      value: this.slider_value
    }

    this.dialogRef.close(obj)
  }
}

@Component({
  selector: 'slider5',
  templateUrl: 'slider5.html',
  styleUrls: ['slider5.scss']
})

export class DialogOverviewExampleDialogSlider5 {
  slider_value;

  constructor(
    public dialogRef: MatDialogRef<DialogData_slider>,
    @Inject(MAT_DIALOG_DATA) public data: DialogOverviewExampleDialogSlider5) {
  }
  ngOnInit(): void {
    this.slider()
    this.slider_value = sessionStorage.getItem('slidervalue5')
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  slider() {
    var that = this
    $("#slider2").roundSlider(
      {
        value: sessionStorage.getItem('slidervalue5'),
        animation: false,
        step: 1,
        max: 360,
        startAngle: 90,
        editableTooltip: false,
        showTooltip: false,
        change: function (args) {
          that.slider_value = args.value

          if (that.slider_value >= 0 && that.slider_value < 60)
            that.slider_value = 30

          if (that.slider_value >= 60 && that.slider_value < 120)
            that.slider_value = 90

          if (that.slider_value >= 120 && that.slider_value < 180)
            that.slider_value = 150

          if (that.slider_value >= 180 && that.slider_value < 240)
            that.slider_value = 210

          if (that.slider_value >= 240 && that.slider_value < 300)
            that.slider_value = 270

          if (that.slider_value >= 300 && that.slider_value <= 360)
            that.slider_value = 330

          that.changeSlider()
          $('#range').html(args.value)
        },
        drag: function (args) {
          $('#range').html(args.value)
        }
      }
    );
  }

  changeSlider() {
    var that = this
    $("#slider2").roundSlider(
      {
        value: that.slider_value,
      }
    );
  }

  changeSliderValue(i) {
    this.slider_value = i
    this.changeSlider()
  }

  close() {
    this.dialogRef.close();

  }

  ok() {
    var obj = {
      value: this.slider_value
    }

    this.dialogRef.close(obj)
  }
}

@Component({
  selector: 'slider6',
  templateUrl: 'slider6.html',
  styleUrls: ['slider6.scss']
})

export class DialogOverviewExampleDialogSlider6 {
  slider_value;

  constructor(
    public dialogRef: MatDialogRef<DialogData_slider>,
    @Inject(MAT_DIALOG_DATA) public data: DialogOverviewExampleDialogSlider6) {
  }
  ngOnInit(): void {
    this.slider()
    this.slider_value = sessionStorage.getItem('slidervalue6')
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  slider() {
    var that = this
    $("#slider3").roundSlider(
      {
        value: sessionStorage.getItem('slidervalue6'),
        animation: false,
        step: 1,
        max: 360,
        startAngle: 90,
        editableTooltip: false,
        showTooltip: false,
        change: function (args) {
          that.slider_value = args.value

          if (that.slider_value >= 0 && that.slider_value < 90)
            that.slider_value = 45

          if (that.slider_value >= 90 && that.slider_value < 180)
            that.slider_value = 135

          if (that.slider_value >= 180 && that.slider_value < 270)
            that.slider_value = 225

          if (that.slider_value >= 270 && that.slider_value <= 360)
            that.slider_value = 315

          that.changeSlider()
          $('#range').html(args.value)
        },
        drag: function (args) {
          $('#range').html(args.value)
        }
      }
    );
  }

  changeSlider() {
    var that = this
    $("#slider3").roundSlider(
      {
        value: that.slider_value,
      }
    );
  }

  changeSliderValue(i) {
    this.slider_value = i
    this.changeSlider()
  }

  close() {
    this.dialogRef.close();

  }

  ok() {
    var obj = {
      value: this.slider_value
    }

    this.dialogRef.close(obj)
  }
}

@Component({
  selector: 'view-riskhistory',
  templateUrl: 'viewriskhistory.html',
  styleUrls: ['viewriskhistory.scss']
})
export class DialogOverviewExampleDialogriskhistory {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any;
  currentpreg: any;
  allcurrentpregDetails: any;
  latestcurrentpregDetails: any;
  viewcurrentpregRisk: any;
  masterSelected1: any;
  checkedList1: any[];
  emptyriskdetail: boolean;
  getauthdetails;


  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDatariskhistory, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
    this.get_currentpregnancyRiskdetails2()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  get_currentpregnancyRiskdetails2() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail
    }
    this.appService.getData(this.urlPoints.getrisk, data, this.token).subscribe((response: any) => {
      if (response.data == "no risk found") {
        this.emptyriskdetail = true
      } else {
        this.emptyriskdetail = false
        this.allcurrentpregDetails = response.data
        this.allcurrentpregDetails.forEach(function (value) {
          value.isSelected = false
        })
        this.getCheckedItemList1();
      }
    })
  }

  checkUncheckAll1() {
    for (var i = 0; i < this.allcurrentpregDetails.length; i++) {
      this.allcurrentpregDetails[i].isSelected = this.masterSelected1;
    }
    this.getCheckedItemList1();
  }
  isAllSelected1() {
    this.masterSelected1 = this.allcurrentpregDetails.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList1();
  }

  getCheckedItemList1() {
    this.checkedList1 = [];
    for (var i = 0; i < this.allcurrentpregDetails.length; i++) {
      if (this.allcurrentpregDetails[i].isSelected)
        this.checkedList1.push({ "id": this.allcurrentpregDetails[i].id });
    }
  }

  archivecpRisk() {
    if (this.checkedList1.length == 0) {
      if (this.allcurrentpregDetails.length == 0) {
        this.toastr.error("No records found")
      } else {
        this.toastr.error("Please select any record")
      }
    } else if (this.checkedList1.length > 0) {
      let data = {
        "account_email": this.dmail,
        "data": this.checkedList1
      }
      this.appService.postData(this.urlPoints.createrisk, data, this.token).subscribe((response: any) => {
        this.toastr.success("Archived successfully")
        this.get_currentpregnancyRiskdetails2()
        this.masterSelected1 = false
      });
    }
  }

}

@Component({
  selector: 'add-currentpregRecords',
  templateUrl: 'addcurrentpregRecords.html',
  styleUrls: ['addcurrentpregRecords.scss']
})
export class DialogOverviewExampleDialogaddcurrentpregRecords {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  currentpregnancyRecords: any;
  currentpregnancyRecordsdata: any;
  currentpregDate;
  currentpregBp;
  currentpregPa;
  currentpregRemark;
  viewcurrentpregRecords: any;
  getauthdetails;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataAddcurrentpregRecords, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.currentpregnancyRecords = this.fb.group({
      currentpregDates: ["", [Validators.required]],
      currentpregBps: ["", [Validators.required]],
      currentpregPas: ["", [Validators.required]],
      currentpregRemarks: [""]
    })
  }
  ngOnInit(): void {
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  obscurrentpregmaxDate = moment(new Date()).format('YYYY-MM-DD')
  openpopupforexit() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpopupexit, {
      width: '600px',
      data: { option: 1 }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.close == "0") {
        return
      } else if (sessionStorage.close == "1") {
        this.dialogRef.close();
      }
    });
  }

  save_currentpregRecords() {
    this.currentpregnancyRecordsdata = this.currentpregnancyRecords.value
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "date": this.currentpregnancyRecordsdata.currentpregDates ? this.currentpregnancyRecordsdata.currentpregDates : "",
      "bp": this.currentpregnancyRecordsdata.currentpregBps ? this.currentpregnancyRecordsdata.currentpregBps : "",
      "pa": this.currentpregnancyRecordsdata.currentpregPas ? this.currentpregnancyRecordsdata.currentpregPas : "",
      "remarks": this.currentpregnancyRecordsdata.currentpregRemarks ? this.currentpregnancyRecordsdata.currentpregRemarks : "",
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.createpregnancyrecord, data, this.token).subscribe((response: any) => {
      if (response.status == 0) {
        this.toastr.error("Unable to add details")
      } else if (response.status == 1) {
        this.toastr.success(response.message)
        this.dialogRef.close();
      }
    });
  }

  get_currentpregnancyRecords() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail
    }
    this.appService.getData(this.urlPoints.getpregnancyrecord, data, this.token).subscribe((response: any) => {
      this.viewcurrentpregRecords = response.data;
      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });
  }
}

@Component({
  selector: 'add-scanreport',
  templateUrl: 'addscanreport.html',
  styleUrls: ['addscanreport.scss']
})
export class DialogOverviewExampleDialogaddscanreport {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  scanreportfindings: FormGroup;
  scanreportdata: any;
  viewscanreportfindingdata: any;
  scanreportnote;
  scanondate;
  nextscandate;
  temptodayscandate: Date;
  todayscandate: string;
  getauthdetails;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataAddscanreport, public dialog: MatDialog, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.scanreportfindings = this.fb.group({
      scanreportnotes: [""],
      scanondates: [""],
      nextscandates: [""]
    })
  }
  ngOnInit(): void {
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openpopupforexit() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpopupexit, {
      width: '600px',
      data: { option: 1 }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.close == "0") {
        return
      } else if (sessionStorage.close == "1") {
        this.dialogRef.close();
      }
    });
  }

  obsnextscanminDate = moment(new Date()).format('YYYY-MM-DD')
  save_scanreportfindingdata() {
    if (sessionStorage.apt_id !== "") {
      this.scanreportdata = this.scanreportfindings.value
      this.temptodayscandate = new Date()
      this.todayscandate = this.datepipe.transform(this.temptodayscandate, 'yyyy-MM-dd');
      let data = {
        "account_email": this.dmail,
        "patient_email": sessionStorage.patientemail,
        "date": this.todayscandate,
        "next_scan_date": this.scanreportdata.nextscandates,
        "appointment_id": sessionStorage.apt_id,
        "scan_date": this.scanreportdata.scanondates,
        "scan_findings": this.scanreportdata.scanreportnotes,
        "doctor_id": this.doc_id
      }
      this.appService.postData(this.urlPoints.createusscanreport, data, this.token).subscribe((response: any) => {
        sessionStorage.setItem("createscanid", response.id)
        if (response.status == "1") {
          this.toastr.success(response.message)
        } else {
          this.toastr.error(response.error)
        }
        this.dialogRef.close();
      });
    } else {
      this.scanreportdata = this.scanreportfindings.value
      this.temptodayscandate = new Date()
      this.todayscandate = this.datepipe.transform(this.temptodayscandate, 'yyyy-MM-dd');
      let data = {
        "account_email": this.dmail,
        "patient_email": sessionStorage.patientemail,
        "date": this.todayscandate,
        "next_scan_date": this.scanreportdata.nextscandates,
        "scan_date": this.scanreportdata.scanondates,
        "scan_findings": this.scanreportdata.scanreportnotes,
        "doctor_id": this.doc_id
      }
      this.appService.postData(this.urlPoints.createusscanreport, data, this.token).subscribe((response: any) => {
        if (response.status == 0) {
          this.toastr.error("Unable to add Scan report info")
        } else if (response.status == 1) {
          sessionStorage.setItem("createscanid", response.id)
          this.toastr.success(response.message)
          this.dialogRef.close();
        }
      });
    }
  }
}

@Component({
  selector: 'alert-scanfollowup',
  templateUrl: 'alertscanfollowup.html',
  styleUrls: ['alertscanfollowup.scss']
})


export class DialogOverviewExampleDialogalertscanfollowup {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

  }
  ngOnInit(): void {

  }
  close() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'selecttemplate',
  templateUrl: 'selecttemplate.html',
  styleUrls: ['selecttemplate.scss']
})

export class DialogOverviewselectTemplate {
  selected: any;
  consultselected: any;
  submitted = false;
  differ;
  templataeData;
  consltTempData;
  cateTempdata;
  cateId;
  templateName;
  consultTempId;
  consultTempName;
  subcategoryName;
  freqconsultData;
  freqprintData;
  freqceritificateData;


  consultTemp_status = false

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewselectTemplate>, private differs: KeyValueDiffers,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_selectTemp) {
    this.differ = this.differs.find({}).create();

  }



  ngOnInit(): void {

    this.templataeData = this.data.templates;
    this.selectTemp(this.templataeData[0].template_id, this.templataeData[0].category, this.templataeData[0].template_name, this.templataeData[0].sub_category)
    this.consltTempData = this.data.consultTemplates;

    this.cateTempdata = this.data.catetemplates;
    this.freqconsultData = this.data.freqConsultTemplates;
    this.freqprintData = this.data.freqprintTemplate;
    this.freqceritificateData = this.data.freqcerificateTemplate;
  }

  close() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectTemp(tempID, categoryId, tempName, subCateName) {
    this.selected = tempID;
    this.cateId = categoryId;
    this.templateName = tempName;
    this.subcategoryName = subCateName;

    if (this.cateId == 1 || this.cateId == 2 || this.cateId == 3) {
      this.consultTemp_status = true;
      this.selectconsultTemp(0, '');
    }

    if (this.cateId == 4 || this.cateId == 6 || this.cateId == 7 || this.cateId == 8 || this.cateId == 9) {
      this.consultTemp_status = false;
      this.submitted = true;
      this.ok();
    }
  }

  selectconsultTemp(tempID, tempname) {
    this.consultselected = tempID;
    this.consultTempId = tempID;
    this.consultTempName = tempname;
    this.submitted = true;
    console.log(this.consultTempName)
  }

  ok() {
    // this.submitted = true

    this.dialogRef.close({
      tempId: this.selected,
      cateId: this.cateId,
      subcategoryName: this.subcategoryName,
      tempName: this.templateName,
      consultTempId: this.consultTempId,
      consultTempName: this.consultTempName
    });
  }


}

@Component({
  selector: 'printTemplate',
  templateUrl: 'printtemplate.html',
  styleUrls: ['printtemplate.scss']
})

export class DialogOverviewPrintTemplate {

  differ;
  templatesrc;
  consultTemp_status = false

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewPrintTemplate>, private differs: KeyValueDiffers,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_printTemp) {
    this.differ = this.differs.find({}).create();

  }

  ngOnInit(): void {
    this.templatesrc = this.data.printtemplates;
  }

  close() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  ok() {
    // this.submitted = true

    this.dialogRef.close({

    });
  }


}

@Component({
  selector: 'loadtemplate',
  templateUrl: 'loadtemplate.html',
  styleUrls: ['loadtemplate.scss']
})

export class DialogOverviewExampleDialogListTemp {
  selected = '';
  submitted = false;
  differ

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialogListTemp>, private differs: KeyValueDiffers,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_listTemp) {
    this.differ = this.differs.find({}).create();

  }



  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  select(t) {
    this.selected = t

    this.ok()
  }

  ok() {
    this.submitted = true

    if (this.selected != '')
      this.dialogRef.close(this.selected);
  }

  ngDoCheck() {

    const change = this.differ.diff(this.data);

    if (change) {

      change.forEachChangedItem(item => {

        alert()
      });
    }
  }
}


@Component({
  selector: 'add-folliclestudy',
  templateUrl: 'addfolliclestudy.html',
  styleUrls: ['addfolliclestudy.scss']
})
export class DialogOverviewExampleDialogaddfolliclestudy {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  folliclestudyform: FormGroup;
  follicledate;
  follicleday;
  folliclertovary;
  follicleltovary;
  follicleendometrium;
  folliclecomment;
  folliclestudydata: any;
  getauthdetails;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataAddfolliclestudy, public dialog: MatDialog, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.folliclestudyform = this.fb.group({
      follicledates: [""],
      follicledays: [""],
      folliclertovarys: [""],
      follicleltovarys: [""],
      follicleendometriums: [""],
      folliclecomments: [""]
    })
  }
  ngOnInit(): void {
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openpopupforexit() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogpopupexit, {
      width: '600px',
      data: { option: 1 }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (sessionStorage.close == "0") {
        return
      } else if (sessionStorage.close == "1") {
        this.dialogRef.close();
      }
    });
  }

  gynecfolliclemaxDate = moment(new Date()).format('YYYY-MM-DD')
  save_folliclestudy() {
    this.folliclestudydata = this.folliclestudyform.value
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "comments": this.folliclestudydata.folliclecomments,
      "date": this.folliclestudydata.follicledates,
      "day": this.folliclestudydata.follicledays,
      "endometrium": this.folliclestudydata.follicleendometriums,
      "lt_ovary": this.folliclestudydata.follicleltovarys,
      "rt_ovary": this.folliclestudydata.folliclertovarys,
      "doctor_id": this.doc_id
    }
    this.appService.postData(this.urlPoints.createfollicular, data, this.token).subscribe((response: any) => {
      if (response.status == 0) {
        this.toastr.error("Unable to add details")
      } else if (response.status == 1) {
        this.toastr.success(response.message)
        this.dialogRef.close();
      }
    });
  }
}

@Component({
  selector: 'view-archivedcprecords',
  templateUrl: 'viewarchivedcprecords.html',
  styleUrls: ['viewarchivedcprecords.scss']
})
export class DialogOverviewExampleDialogviewarchivedcpRecords {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  getarchivedcpRecords: any;
  getauthdetails;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataviewarchivedcpRecords, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
    this.get_archivedcprecords()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  get_archivedcprecords() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "status": "0",
    }
    this.appService.getData(this.urlPoints.getpregnancyrecord, data, this.token).subscribe((response: any) => {
      this.getarchivedcpRecords = response.data
    });
  }
}

@Component({
  selector: 'clear-lmpeddactual',
  templateUrl: 'clearlmpeddactual.html',
  styleUrls: ['clearlmpeddactual.scss']
})
export class DialogOverviewExampleDialoglclearlmpeddaddDeatils {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataclearlmpeddaddDeatils) {

  }
  ngOnInit(): void { }

  onNoClick(): void {
    this.dialogRef.close();
  }
  clearlmpeddok(): void {
    sessionStorage.setItem("clearlmpedd", "1")
    this.dialogRef.close();
  }

  clearlmpeddno() {
    sessionStorage.setItem("clearlmpedd", "0")
    this.dialogRef.close();
  }
}
@Component({
  selector: 'view-archivedcprisk',
  templateUrl: 'viewarchivedcprisk.html',
  styleUrls: ['viewarchivedcprisk.scss']
})
export class DialogOverviewExampleDialogviewarchivedcpRisk {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  getarchivedcpRisk: any;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataviewarchivedcpRisk, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {

    let getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));

    this.dmail = getauthdetails.account_id;
    this.doc_id = getauthdetails.doctor_id;
    this.token = getauthdetails.token;
    this.get_archivedcprisk();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  get_archivedcprisk() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "status": "0",
    }
    this.appService.getData(this.urlPoints.getrisk, data, this.token).subscribe((response: any) => {
      this.getarchivedcpRisk = response.data
    });
  }
}

@Component({
  selector: 'view-archivedcpscan',
  templateUrl: 'viewarchivedcpscan.html',
  styleUrls: ['viewarchivedcpscan.scss']
})
export class DialogOverviewExampleDialogviewarchivedcpscan {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  getarchivedcpscan: any;
  getauthdetails;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataviewarchivedcpscan, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
    this.get_archivedcpscan()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  get_archivedcpscan() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "doctor_id": this.doc_id,
      "status": "0",
    }
    this.appService.getData(this.urlPoints.getusscanreport, data, this.token).subscribe((response: any) => {
      this.getarchivedcpscan = response.data
    });
  }
}

@Component({
  selector: 'view-archivedfollicle',
  templateUrl: 'viewarchivedfollicle.html',
  styleUrls: ['viewarchivedfollicle.scss']
})
export class DialogOverviewExampleDialogviewarchivedfollicle {
  urlPoints: any;
  sub: any;
  id: any;
  doc_id: any;
  mode: any;
  token: any;
  dmail: any
  getarchivedfollicle: any;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataviewarchivedfollicle, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {
    let getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));

    this.dmail = getauthdetails.account_id;
    this.doc_id = getauthdetails.doctor_id;
    this.token = getauthdetails.token;
    this.get_archivedfollicle();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  get_archivedfollicle() {
    let data = {
      "account_email": this.dmail,
      "patient_email": sessionStorage.patientemail,
      "status": "0",
    }
    this.appService.getData(this.urlPoints.getfollicular, data, this.token).subscribe((response: any) => {
      this.getarchivedfollicle = response.data
    });
  }
}

@Component({
  selector: 'vaccination-form',
  templateUrl: 'vaccination.html',
  styleUrls: ['vaccination.scss']
})

export class DialogOverviewExampleDialog_vaccination {
  vaccinationForm;
  vaccinemonthForm;
  urlPoints;
  date_given = [];
  nextvaccine_repeat = [];
  params_vaccinelist;
  token;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_vaccination, private fb: FormBuilder, private appService: AppService) {

    this.urlPoints = AppConfig.settings.EndPoints;

    this.vaccinationForm = this.fb.group({
      administration: [""],
      brandname: [""],
      site: [""],
      batch: [""],
      textarea: [""],
    })

    this.vaccinemonthForm = this.fb.group({
      vaccinename: [""],
      vaccinedate: [""]
    })

    this.params_vaccinelist = this.data.params_vaccinelist
    this.token = this.data.token

  }
  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  update_monthvaccine(data) {
    if (status == 'rescheduled') {
      var update_data = {
        sno: data.sno,
        site: data.site,
        comments: "",
        id: data.id,
        batch_id: "",
        brand_name: data.vaccine_name,
        date_given: moment(data.date_given).format("YYYY-MM-DD"),
        due_date: moment(data.vaccine_date).format("YYYY-MM-DD"),
        drug_name: data.vaccine_name,
        account_email: this.params_vaccinelist.account_email,
        patient_email: this.params_vaccinelist.patient_email,
        user_type: "doctor",
        status: "rescheduled"
      }
      this.appService.postData(this.urlPoints.updatecalendardata, update_data, this.token).subscribe((response: any) => {
        if (response) {
        }
      });
    } else {

      var addrescheduled_data = {
        account_email: this.params_vaccinelist.account_email,
        patient_email: this.params_vaccinelist.patient_email,
        sno: data.sno,
        drug_name: data.vaccine_name,
        status: "rescheduled",
        due_date: moment(data.vaccine_date).format("YYYY-MM-DD"),
        user_type: "doctor",
        site: data.site
      }

      this.appService.postData(this.urlPoints.addrescheduleddata, addrescheduled_data, this.token).subscribe((response: any) => {
        if (response) {
        }
      });

    }
  }

  save_vaccination(data) {
    if (this.vaccinationForm.valid) {
      this.dialogRef.close({
        "formdata": this.vaccinationForm.value,
        "actualdata": data.obj
      });
    }
  }
}

@Component({
  selector: 'uploadattachment-form',
  templateUrl: 'uploadattachment.html',
  styleUrls: ['uploadattachment.scss']
})

export class DialogOverviewExampleDialog_upload {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public router: Router) {

  }
  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'payment-form',
  templateUrl: 'payment.html',
  styleUrls: ['payment.scss']
})

export class DialogOverviewExampleDialog_payment {

  amount;
  category;
  fees;
  desc;
  type;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_payment>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_payment, public router: Router) {

  }
  ngOnInit(): void {

    this.category = this.data.data.category;

    if (this.category == 'video_call') {
      this.category = 'video_call_consultation'
    }
    else if (this.category == 'emergency_video_call') {
      this.category = 'emergency_video_call_consultation'
    }
    else if (this.category == 'appointment') {
      this.category = 'consultation'
    }

    if (this.category == 'emergency_video_call' || this.category == 'emergency_video_call_consultation' || this.category == 'emergency_voice_call' || this.category == 'emergency_voice_call_appointment_fee' || this.category == 'video_call_appointment_fee' || this.category == 'video_call_consultation' || this.category == 'voice_call') {
      this.type = 1
    }
    else {
      this.type = 2
    }

    for (var i = 0; i < this.data.data.modules.length; i++) {
      if (this.data.data.modules[i].module == this.category) {
        this.amount = this.data.data.modules[i].doctor_charge;
      }

      this.desc = ' The Amount of Rs.' + this.amount + ' is Debited for ' + this.category

    }
  }

  categoryChange() {

    for (var i = 0; i < this.data.data.modules.length; i++) {
      if (this.data.data.modules[i].module == this.category) {
        //  this.category = this.data.data.modules[i]
        this.amount = this.data.data.modules[i].doctor_charge;
      }
    }

    this.desc = ' The Amount of Rs.' + this.amount + ' is Debited for ' + this.category

  }

  change() {
    this.desc = ' The Amount of Rs.' + this.amount + ' is Debited for ' + this.category
  }

  waive() {
    this.dialogRef.close({
      type: 'waive',
      desc: this.desc,
      amount: 0,
      category: this.category
    });
  }

  raise(i) {
    this.dialogRef.close({
      type: i,
      desc: this.desc,
      amount: this.amount,
      category: this.category
    }
    );

  }



  close() {
    this.dialogRef.close();

    window.parent.window.postMessage({
      "message": "gotoappointment"
    }, '*')

    // window.location.reload()
  }

  onNoClick(): void {
    this.dialogRef.close();

    window.parent.window.postMessage({
      "message": "gotoappointment"
    }, '*')

    // window.location.reload()
  }
}

@Component({
  selector: 'confirm-form',
  templateUrl: 'confirm.html',
  styleUrls: ['confirm.scss']
})

export class DialogOverviewExampleDialog_confirm {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_confirm>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_confirm, public router: Router) {

  }
  ngOnInit(): void {
  }

  close() {

    if (this.data.type == 0) {
      this.dialogRef.close();

      window.parent.window.postMessage({
        "message": "gotoappointment"
      }, '*')

      window.location.reload()
    }
    else {
      this.dialogRef.close('no')
    }
  }

  yes() {
    this.dialogRef.close('yes')
  }

  no() {
    if (this.data.type == 0) {
      this.dialogRef.close();

      window.parent.window.postMessage({
        "message": "gotoappointment"
      }, '*')

      window.location.reload()
    }
    else {
      this.dialogRef.close('no')
    }
  }

  onNoClick(): void {
    this.dialogRef.close();

    window.parent.window.postMessage({
      "message": "gotoappointment"
    }, '*')

    window.location.reload()
  }
}

@Component({
  selector: 'notifier',
  templateUrl: 'notifier.html',
  styleUrls: ['notifier.scss']
})

export class DialogOverviewExampleDialog_notifier {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_notifier>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_notifier, public router: Router) {

  }
  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'cartdrugs',
  templateUrl: 'cartdrugs.html',
  styleUrls: ['cartdrugs.scss']
})

export class DialogOverviewExampleDialog_cartdrugs {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_cartdrugs>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_cartdrugs, public router: Router) {

  }
  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  addDrug(drug) {
    this.dialogRef.close(drug);

  }

  view(drug) {

    window.open(drug.permalink)

  }

  close() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'cartitems',
  templateUrl: 'cartitems.html',
  styleUrls: ['cartitems.scss']
})

export class DialogOverviewExampleDialog_cartitems {

  getpriceList :any=[];
  getpriceListArr :any=[];
  showPrice;

  constructor(private appService: AppService,
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_cartitems>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_cartitems, public router: Router) {

  }
  ngOnInit(): void {
    for (var i = 0; i < this.data.drugs.length; i++) {
      this.data.drugs[i].quantity = this.data.drugs[i].quantity ? this.data.drugs[i].quantity : 1
    }
  const result = this.data.drugs.map(item => {
    const itemTotal = item.product_price * item.quantity;
    return this.getpriceListArr.push(itemTotal);
  });
  this.getpriceList=this.getpriceListArr.reduce(function(preValue,currentValue){
    return preValue + currentValue;
  },0)
    this.showPrice = this.getpriceList.toFixed(2);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  minus(i) {
    if (this.data.drugs[i].quantity > 1){
      this.getpriceList = this.getpriceList - this.data.drugs[i].product_price;
    this.showPrice = this.getpriceList.toFixed(2);
    this.data.drugs[i].quantity--;
     }
  }
  plus(i) {
    this.getpriceList = this.getpriceList + this.data.drugs[i].product_price;
    this.showPrice = this.getpriceList.toFixed(2)
    this.data.drugs[i].quantity++;
  }

  delete(i) {
    this.getpriceList = this.getpriceList - this.data.drugs[i].product_price  * this.data.drugs[i].quantity;
    this.showPrice = this.getpriceList.toFixed(2)
    this.data.drugs.splice(i, 1)
  }

  save() {
    this.dialogRef.close(this.data.drugs);
  }

  close() {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'id',
  templateUrl: 'id.html',
  styleUrls: ['id.scss']
})

export class DialogOverviewExampleDialog_cartid {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_cartid>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_cartid, public router: Router) {

  }
  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'invoice',
  templateUrl: 'invoice.html',
  styleUrls: ['invoice.scss']
})


export class DialogOverviewExampleDialog_invoice {

  pre;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_invoice>,
    @Inject(MAT_DIALOG_DATA) public data: any, private route: ActivatedRoute, public router: Router) {

  }
  ngOnInit(): void {
    this.pre = Number(this.data.data.wallet) + Number(this.data.data.amount);
  }

  onNoClick(): void {
    this.dialogRef.close();
    //  window.location.reload()
  }

  close(closestatus) {
    this.dialogRef.close();
    if (closestatus == 1) {
      //  this.router.navigate(['epicare/appointment']);
    } else {
      //  window.location.reload();
    }

  }
}

@Component({
  selector: 'print',
  templateUrl: 'print.html',
  styleUrls: ['print.scss']
})

export class Print {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_Print, public router: Router, public route: ActivatedRoute) {

  }
  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'getName',
  templateUrl: 'getName.html',
  styleUrls: ['getName.scss']
})

export class Dialog_getName {
  name;
  submitted;
  nameForm;
  urlPoints;
  record = false
  constructor(
    public dialogRef: MatDialogRef<Dialog_getName>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_getName, public router: Router, private fb: FormBuilder, public route: ActivatedRoute) {
    this.nameForm = this.fb.group({
      name: ["", Validators.required]
    })

  }
  ngOnInit(): void {
  }


  save() {
    this.submitted = true;
    if (this.nameForm.valid) {
      this.dialogRef.close(
        {
          name: this.nameForm.value.name,
          record: this.record
        }

      );

    }
  }
  cancel() {
    this.dialogRef.close();
  }

  recordToggle() {
    this.record = !this.record
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'temp-choose',
  templateUrl: 'temp-choose.html',
  styleUrls: ['temp-choose.scss']
})

export class DialogOverviewExampleDialog_tempchoose {
  selectedPrintTemplate = '';
  selectedPrintTemplateName = 'none'

  submitted = false
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_tempchoose>,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, public route: ActivatedRoute) {

  }
  ngOnInit(): void {

    this.data.temps = this.data.temps.filter(i => i.category == 1);

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  tempChange() {
  }

  set(item) {
    this.selectedPrintTemplate = item.template_id
    this.selectedPrintTemplateName = item.template_name
  }

  save() {
    this.submitted = true;
    if (this.selectedPrintTemplate != '') {
      var result = {
        temp: this.selectedPrintTemplate,
        mode: 0
      }
      this.dialogRef.close(result);
    }
  }

  save1() {
    this.submitted = true

    if (this.selectedPrintTemplate != '') {
      var result = {
        temp: this.selectedPrintTemplate,
        mode: 1
      }
      this.dialogRef.close(result);
    }
  }

  save2() {
    this.submitted = true

    if (this.selectedPrintTemplate != '') {
      var result = {
        temp: this.selectedPrintTemplate,
        mode: 2
      }
      this.dialogRef.close(result);
    }
  }

}

@Component({
  selector: 'temp-choose1',
  templateUrl: 'temp-choose1.html',
  styleUrls: ['temp-choose1.scss']
})

export class DialogOverviewExampleDialog_tempchoose1 {
  selectedPrintTemplate = '';
  selectedPrintTemplateName = 'none'

  submitted = false
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_tempchoose1>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_print, public router: Router, public route: ActivatedRoute) {

  }
  ngOnInit(): void {

    console.log(this.data.temps)

    this.data.temps = this.data.temps.filter(i => i.category == 2);

    console.log(this.data.temps)

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  tempChange() {
  }

  set(item) {
    this.selectedPrintTemplate = item.template_id
    this.selectedPrintTemplateName = item.template_name
  }

  save() {
    this.submitted = true;
    if (this.selectedPrintTemplate != '') {
      var result = {
        temp: this.selectedPrintTemplate,
        mode: 0
      }
      this.dialogRef.close(result);
    }
  }

  save1() {
    this.submitted = true

    if (this.selectedPrintTemplate != '') {
      var result = {
        temp: this.selectedPrintTemplate,
        mode: 1
      }
      this.dialogRef.close(result);
    }
  }

}

@Component({
  selector: 'drugmaster',
  templateUrl: 'drugmaster.html',
  styleUrls: ['drugmaster.scss']
})

export class DialogOverviewExampleDialog_master implements OnInit{
  drugname;
  compname;
  strength = 1;
  unit;
  dose = 1;
  dose_option = 'milliliter';
  route = 'Oral'
  when = 'After Food'
  frequency = 'Once a day'
  duration = 1;
  duration_type = 'Days';
  min_qty = 1;
  formulation;
  instructions;
  generic;
  popupOpen = false
  slider_value;
  slider_value2;
  slider_value3;
status;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_master>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_print, public router: Router) {
      console.log("data::",this.data)
      
  }
ngOnInit(): void {
  this.status = this.data.status
  console.log(this.status,'this.email')
}
  onNoClick(): void {
    this.dialogRef.close();
  }

  strengthPlus() {

    this.strength++;
  }

  save() {
    var obj = {
      // drugname: this.drugname || '',
      drugname: this.drugname ? this.drugname : (this.generic ? this.generic : this.compname),
      compname: this.compname|| '',
      strength: this.strength||'',
      unit: this.dose_option ? this.dose_option : '',
      dose: this.dose ? this.dose : '',
      dose_option: this.dose_option || '',
      route: this.route || '',
      when: this.when||'',
      frequency: this.frequency||'',
      duration: this.duration||'',
      duration_type: this.duration_type||'',
      min_qty: this.min_qty||'',
      formulation: this.formulation,
      generic: this.generic ? this.generic : ''
    }

    this.dialogRef.close(obj)
  }

  strengthMinus() {

    if (this.strength == null)
      this.strength = 1

    if (this.strength != 1)
      this.strength--;
  }

  dosePlus() {
    this.dose++;
  }

  doseMinus() {

    if (this.dose == null)
      this.dose = 1

    if (this.dose != 1)
      this.dose--;
  }

  minPlus() {
    if (this.min_qty == null || this.min_qty == undefined)
      this.min_qty = 0

    this.min_qty++;
  }

  minMinus() {

    if (this.min_qty == null || this.min_qty == undefined)
      this.min_qty = 1

    if (this.min_qty != 1)
      this.min_qty--;
  }

  durationPlus() {
    this.duration++;

  }

  durationMinus() {
    if (this.duration == null || this.duration == undefined)
      this.duration = 1

    if (this.duration != 1)
      this.duration--;
  }

  setDurationType(i) {
    this.duration_type = i
  }

  setFormulation(i) {
    this.formulation = i
  }

  openDialog() {
    var value;

    if (this.route == 'Oral')
      value = 0

    if (this.route == 'Inhale')
      value = 45

    if (this.route == 'Subcutaneous')
      value = 90

    if (this.route == 'Intravenous')
      value = 135

    if (this.route == 'Perrectal')
      value = 180

    if (this.route == 'Topical')
      value = 225

    if (this.route == 'Pervaginal')
      value = 270

    if (this.route == 'Other')
      value = 315

    sessionStorage.setItem("slidervalue4", value)

    if (!this.popupOpen) {
      this.popupOpen = true
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogSlider4, {
        width: 'fit-content',
        data: { value: value },

      });

      dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false
        if (result) {
          this.slider_value = result.value

          if (result.value == 0) {
            this.route = 'Oral'
          }

          if (result.value == 45) {
            this.route = 'Inhale'
          }

          if (result.value == 90) {
            this.route = 'Subcutaneous'
          }

          if (result.value == 135) {
            this.route = 'Intravenous'
          }

          if (result.value == 180) {
            this.route = 'Perrectal'
          }

          if (result.value == 225) {
            this.route = 'Topical'
          }

          if (result.value == 270) {
            this.route = 'Pervaginal'
          }

          if (result.value == 315) {
            this.route = 'Other'
          }

        }
      });
    }
  }

  openSlider2() {
    var value;

    if (this.dose_option == 'milliliter')
      value = 30

    if (this.dose_option == 'microgram')
      value = 90
    //milligram
    if (this.dose_option == 'milligram')
      value = 150

    if (this.dose_option == 'gram')
      value = 210

    if (this.dose_option == 'mole')
      value = 270

    if (this.dose_option == 'millimole')
      value = 330

    sessionStorage.setItem("slidervalue5", value)

    if (!this.popupOpen) {
      this.popupOpen = true
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogSlider5, {
        width: 'fit-content',

        data: { value: value },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false

        if (result) {
          this.slider_value2 = result.value

          if (result.value == 30) {
            this.dose_option = 'milliliter'
          }

          if (result.value == 90) {
            //microgram
            this.dose_option = 'microgram'
          }

          if (result.value == 150) {
            this.dose_option = 'milligram'
          }

          if (result.value == 210) {
            this.dose_option = 'gram'
          }

          if (result.value == 270) {
            this.dose_option = 'mole'
          }

          if (result.value == 330) {
            this.dose_option = 'millimole'
          }

        }
      });
    }
  }

  openSlider3() {

    var value;

    if (this.when == 'Before Food')
      value = 315

    if (this.when == 'After Food')
      value = 45

    if (this.when == 'Not Related to Food')
      value = 135

    if (this.when == 'With Food')
      value = 225

    sessionStorage.setItem("slidervalue6", value)

    if (!this.popupOpen) {
      this.popupOpen = true
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogSlider6, {
        width: 'fit-content',
        data: { value: value },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false

        if (result) {
          this.slider_value3 = result.value

          if (result.value == 45) {
            this.when = 'After Food'
          }

          if (result.value == 135) {
            this.when = 'Not Related to Food'
          }

          if (result.value == 225) {
            this.when = 'With Food'
          }

          if (result.value == 315) {
            this.when = 'Before Food'
          }


        }
      });
    }
  }

  openFrequency() {
    if (!this.popupOpen) {
      this.popupOpen = true
      const dialogRef = this.dialog.open(Dialog_frequency, {
        width: '30rem',
        data: { value: this.frequency },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.popupOpen = false

        if (result) {
          this.frequency = result
        }
      });
    }
  }
}

@Component({
  selector: 'frequency',
  templateUrl: 'frequency.html',
  styleUrls: ['frequency.scss']
})

export class Dialog_frequency {
  value
  urlPoints;
  valueInput;

  freq_arr = ['Once a day', 'Twice a day', 'Three times a day', 'Four times a day', 'Every 2 hours', 'Every 4 hours', 'Every 6 hours', 'Every 8 hours', 'SOS']

  constructor(
    public dialogRef: MatDialogRef<Dialog_frequency>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_frequency, public router: Router, private fb: FormBuilder, public route: ActivatedRoute) {


  }
  ngOnInit(): void {
    this.value = this.data.value

    var exists = false

    for (var i = 0; i < this.freq_arr.length; i++) {
      if (this.freq_arr[i] == this.data.value) {
        exists = true
      }
    }

    if (!exists) {
      this.valueInput = this.data.value
    }
  }


  save() {
    this.dialogRef.close(this.value);

  }
  cancel() {
    this.dialogRef.close();
  }

  set(i) {
    this.value = i
    this.valueInput = ''
    //  this.dialogRef.close(this.value);

  }

  input() {
    this.value = this.valueInput
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'upload',
  templateUrl: 'upload.html',
  styleUrls: ['upload.scss']
})
export class Dialog_upload {
  value;
  urlPoints;
  description = '';
  comments = '';
  files;
  UploadImages = [];
  imgURL = [];
  fileList = [];
  abnormal = false;
  investigations = [];
  inv_pages;
  inv_page = 1;
  inv_data = [];
  inv_copy = [];
  inv_copy1 = [];
  inv_selected = [];
  inv_names;
  chars;
  isFullListDisplayed: boolean = false;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  matMenuTimer4: any;
  fileName = '';
  takenDate = moment(new Date()).format('YYYY-MM-DD');
  date = moment(new Date()).format('YYYY-MM-DD');


  constructor(
    public dialogRef: MatDialogRef<Dialog_upload>,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, public route: ActivatedRoute, private appService: AppService, private toastr: ToastrService) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }
  ngOnInit(): void {
  }
  search(event) {
    this.investigations = [];
    this.inv_copy1 = [];
    this.inv_data = []
    this.chars = event.target.value
    var params = {
      account_email: this.data.dmail,
      page_no: 1,
      alphabet: this.chars.trim(),
      doctor_id: this.data.id
    }
    this.getInv(this.urlPoints.getInv, params, this.data.token)
  }
  getInv(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success !== 0 && !response.message) {
        this.investigations = response.data;
        this.inv_pages = response.total_page;
        if (this.inv_page > 1)
          this.inv_data = this.inv_data.concat(response.data);
        else
          this.inv_data = response.data
        this.investigations = this.inv_data;
        this.inv_copy = Object.assign([], this.investigations);
        this.inv_copy1 = Object.assign([], this.investigations);
        var matchedArray = [];
        if (response.success == 1) {
          for (var i = 0; i < this.investigations.length; i++) {
            for (var k = 0; k < this.inv_selected.length; k++) {
              if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
                matchedArray.push(i);
              }
            }
          }
          for (var i = matchedArray.length - 1; i >= 0; i--) {
            this.inv_copy.splice(matchedArray[i], 1);
            this.inv_copy1.splice(matchedArray[i], 1);
          }
        }
      }
    })
  }
  update_inv(index, i) {
    var exists;
    for (var j = 0; j < this.inv_selected.length; j++) {
      if (this.inv_selected[j].name.trim().toLowerCase() == this.inv_copy1[index].name.trim().toLowerCase()) {
        exists = true
      }
    }
    if (!exists) {
      var index1 = this.investigations.indexOf(this.inv_copy1[index]);
      this.inv_selected.push(this.investigations[index1])
      this.inv_copy1.splice(index, 1);
      var inv_names = []
      for (var k = 0; k < this.inv_selected.length; k++) {
        inv_names.push(this.inv_selected[k].name)
      }
      this.inv_names = inv_names.join(',')
    }
    else {
      //  this.toastr.error(this.inv_copy1[index].name + " has been already added")
    }
  }
  onScroll4() {
    //  alert()
    var token = this.data.token;
    this.inv_page++;
    var params = {
      account_email: this.data.dmail,
      page_no: this.inv_page,
      alphabet: this.chars.toUpperCase(),
      doctor_id: this.data.id
    }
    this.getInv(this.urlPoints.getInv, params, token)
  }
  click4(i) {
    this.matMenuTimer4 = setTimeout(() => { this.clickedMe4(); }, 300);
  }
  doubleClick4(i) {
    clearTimeout(this.matMenuTimer4);
    this.matMenuTimer4 = undefined;
    this.remove_inv(i);
  }
  remove_inv(index) {
    for (var i = 0; i < this.investigations.length; i++) {
      if (this.investigations[i].investigation_id == this.inv_selected[index].investigation_id) {
        if (this.inv_selected[index].question) {
          this.inv_selected[index].name = this.inv_selected[index].name.substring(1)
        }
        this.inv_copy1.push(this.inv_selected[index]);
        break;
      }
    }
    this.inv_selected.splice(index, 1);
    this.inv_copy1 = Object.assign([], this.investigations);
    var matchedArray = [];
    for (var i = 0; i < this.investigations.length; i++) {
      for (var k = 0; k < this.inv_selected.length; k++) {
        if (this.investigations[i].investigation_id == this.inv_selected[k].investigation_id) {
          matchedArray.push(i);
        }
      }
    }
    for (var i = matchedArray.length - 1; i >= 0; i--) {
      this.inv_copy.splice(matchedArray[i], 1);
      this.inv_copy1.splice(matchedArray[i], 1);
    }
    var inv_names = []
    for (var k = 0; k < this.inv_selected.length; k++) {
      inv_names.push(this.inv_selected[k].name)
    }
    this.inv_names = inv_names.join(',')
  }
  clickedMe4() {
    if (!this.matMenuTimer4) return;
  }
  save() {

    var obj = {
      fileList: this.fileList,
      description: this.description,
      report: '',
      comments: this.comments,
      title: this.inv_names ? this.inv_names : '',
      abnormal: this.abnormal ? 1 : 0,
      tests: this.inv_names ? this.inv_names : '',
      test_taken_on: this.takenDate,
      file_name: this.fileName
    }
    this.dialogRef.close(obj);
  }
  cancel() {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  GetFile(e) {
    this.files = Array.from(e.target.files);
    if ((this.files[0].type === 'image/png')
      || (this.files[0].type === 'image/jpg')
      || (this.files[0].type === 'image/jpeg')
      || (this.files[0].type === 'image/tif')
      || (this.files[0].type === 'application/pdf')) {
      if (this.files[0].size > 10000000) {
      } else {
        this.UploadImages.push(e.target.files)
        for (let i = 0; i < this.files.length; i++) {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.imgURL.push({
              url: event.target.result,
              name: this.files[i].name,
              type: this.files[i].name.split('.')[this.files[i].name.split('.').length - 1]
            })
          }
          reader.readAsDataURL(e.target.files[i]);
          const file = (e.target as HTMLInputElement).files[i];
          this.fileList.push(file)
        }
      }
    } else {
    }
  }
  public removePicture(item, index) {
    this.imgURL.splice(index, 1);
    this.files.splice(index, 1);
    this.UploadImages.splice(index, 1);
    let file = document.getElementById("files") as HTMLInputElement;
    file.value = "";
  }
}

@Component({
  selector: 'attachment',
  templateUrl: 'attachment.html',
  styleUrls: ['attachment.scss']
})

export class Dialog_attachment {
  value
  urlPoints;
  description;
  comments;
  tests_str;
  files;
  UploadImages = [];
  imgURL = [];
  date;
  abnormal = false;
  fileList = [];

  constructor(
    public dialogRef: MatDialogRef<Dialog_attachment>,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, public route: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.tests_str = this.data.obj.lab_tests.join(',')
    this.date = this.data.obj.date
  }

  GetFile(e) {

    this.files = Array.from(e.target.files);

    if ((this.files[0].type === 'image/png')
      || (this.files[0].type === 'image/jpg')
      || (this.files[0].type === 'image/jpeg')
      || (this.files[0].type === 'image/tif')
      || (this.files[0].type === 'application/pdf')) {
      if (this.files[0].size > 10000000) {

      } else {
        this.UploadImages.push(e.target.files)

        for (let i = 0; i < this.files.length; i++) {
          var reader = new FileReader();
          reader.onload = (event: any) => {

            this.imgURL.push({
              url: event.target.result,
              name: this.files[i].name,
              type: this.files[i].name.split('.')[this.files[i].name.split('.').length - 1]
            })
          }
          reader.readAsDataURL(e.target.files[i]);
          const file = (e.target as HTMLInputElement).files[i];
          this.fileList.push(file)

        }
      }
    } else {

    }

  }

  public removePicture(item, index) {
    this.imgURL.splice(index, 1);
    this.files.splice(index, 1);
    this.UploadImages.splice(index, 1);
    this.fileList.splice(index, 1);

    let file = document.getElementById("files") as HTMLInputElement;
    file.value = "";
  }

  save() {
    var obj = {
      fileList: this.fileList,
      abnormal: this.abnormal ? 1 : 0

    }
    this.dialogRef.close(obj);

  }
  cancel() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'attachment2',
  templateUrl: 'attachment.html',
  styleUrls: ['attachment.scss']
})

export class Dialog_attachment2 {
  value
  urlPoints;
  description;
  comments;
  tests_str;
  files;
  UploadImages = [];
  imgURL = [];
  fileList = [];
  date;
  abnormal = false;

  constructor(
    public dialogRef: MatDialogRef<Dialog_attachment2>,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, public route: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.tests_str = this.data.obj.lab_tests.join(',')
    this.date = this.data.obj.date;
    if (this.data.category == 'abnormal') {
      this.abnormal = true
    }
  }

  GetFile(e) {
    this.files = Array.from(e.target.files);

    if ((this.files[0].type === 'image/png')
      || (this.files[0].type === 'image/jpg')
      || (this.files[0].type === 'image/jpeg')
      || (this.files[0].type === 'image/tif')
      || (this.files[0].type === 'application/pdf')) {
      if (this.files[0].size > 10000000) {

      } else {
        this.UploadImages.push(e.target.files)

        for (let i = 0; i < this.files.length; i++) {
          var reader = new FileReader();
          reader.onload = (event: any) => {

            this.imgURL.push({
              url: event.target.result,
              name: this.files[i].name,
              type: this.files[i].name.split('.')[this.files[i].name.split('.').length - 1]
            })
          }
          reader.readAsDataURL(e.target.files[i]);
          const file = (e.target as HTMLInputElement).files[i];
          this.fileList.push(file)

        }
      }
    } else {
    }

  }

  public removePicture(item, index) {
    this.imgURL.splice(index, 1);
    this.files.splice(index, 1);
    this.UploadImages.splice(index, 1);
    this.fileList.splice(index, 1);

    let file = document.getElementById("files") as HTMLInputElement;
    file.value = "";
  }

  save() {
    var obj = {
      fileList: this.fileList,
      abnormal: this.abnormal ? 1 : 0
    }
    this.dialogRef.close(obj);
  }
  cancel() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'attachment_edit',
  templateUrl: 'attachment_edit.html',
  styleUrls: ['attachment_edit.scss']
})

export class Dialog_attachment_edit {
  value
  urlPoints;
  description;
  comments;
  tests_str;
  files;
  UploadImages = [];
  imgURL = [];
  date;
  abnormal = false;
  fileList = [];
  fileName;
  test_taken_on;
  dateMax = moment(new Date()).format("YYYY-MM-DD");

  constructor(
    public dialogRef: MatDialogRef<Dialog_attachment_edit>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_attachment_edit, public router: Router, private fb: FormBuilder, public route: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.tests_str = this.data.obj.lab_tests.join(',')
    this.date = this.data.obj.date

    if (this.data.category == 'abnormal') {
      this.abnormal = true
    }
    if (this.data.comments)
      this.comments = this.data.comments

    if (this.data.description)
      this.description = this.data.description

    if (this.data.filename)
      this.fileName = this.data.filename

    if (this.data.test_taken_on)
      this.test_taken_on = this.data.test_taken_on

  }

  GetFile(e) {

    this.files = Array.from(e.target.files);

    if ((this.files[0].type === 'image/png')
      || (this.files[0].type === 'image/jpg')
      || (this.files[0].type === 'image/jpeg')
      || (this.files[0].type === 'image/tif')
      || (this.files[0].type === 'application/pdf')) {
      if (this.files[0].size > 10000000) {

      } else {
        this.UploadImages.push(e.target.files)

        for (let i = 0; i < this.files.length; i++) {
          var reader = new FileReader();
          reader.onload = (event: any) => {

            this.imgURL.push({
              url: event.target.result,
              name: this.files[i].name,
              type: this.files[i].name.split('.')[this.files[i].name.split('.').length - 1]
            })
          }
          reader.readAsDataURL(e.target.files[i]);
          const file = (e.target as HTMLInputElement).files[i];
          this.fileList.push(file)

        }
      }
    } else {

    }

  }

  public removePicture(item, index) {
    this.imgURL.splice(index, 1);
    this.files.splice(index, 1);
    this.UploadImages.splice(index, 1);
    this.fileList.splice(index, 1);

    let file = document.getElementById("files") as HTMLInputElement;
    file.value = "";
  }

  save() {
    var obj = {
      //  fileList: this.fileList,
      abnormal: this.abnormal ? 1 : 0,
      description: this.description,
      comments: this.comments,
      filename: this.fileName,
      test_taken_on: this.test_taken_on

    }
    this.dialogRef.close(obj);

  }
  cancel() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'follow_book',
  templateUrl: 'follow_book.html',
  styleUrls: ['follow_book.scss']
})

export class Dialog_follow_book {
  value
  urlPoints;
  description: any;
  comments;
  demail;
  slots;
  selectedTokens = [];
  slotArray = [];
  token;
  id;
  type;
  slots_arr = [];
  time;
  state = 1;
  apptTokens;
  date;
  deduct = false;
  disabled = false;
  email;
  subStatus;

  constructor(public dialogRef: MatDialogRef<Dialog_follow_book>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_follow_book, private toastr: ToastrService, public router: Router, public route: ActivatedRoute, private appService: AppService) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.demail = this.data.demail
    this.token = this.data.token;
    this.id = this.data.id;
    this.type = this.data.type;
    this.date = this.data.date;
    this.email = this.data.email

  }

  ngOnInit(): void {
    this.getSlots()

  }

  getSlots() {
    var params = {
      account_email: this.demail,
      appt_date: moment(new Date(this.data.date)).format("YYYY-MM-DD"),
      doctor_id: this.id,
      appt_type: this.type
    }

    this.appService.getData(this.urlPoints.checkApptToken, params, this.token).subscribe((response: any) => {

      this.slots = response.schedule

      if (typeof (this.slots[0]) == 'object') {

        for (var i = 0; i < this.slots.length; i++) {
          this.slots[i].selected = false
          if (moment(this.slots[i].start).add(5.5, 'hours').valueOf() < moment(new Date()).valueOf()) {
            this.slots[i].past = true
          }
          else {
            this.slots[i].past = false
          }
        }

        this.selectedTokens = []

        this.slotArray = this.listToMatrix(this.slots, 10)
      }
      else {
        this.slots = [];
      }
    });
  }

  listToMatrix(list, elementsPerSubArray) {
    var matrix = [], i, k;

    for (i = 0, k = -1; i < list.length; i++) {
      if (i % elementsPerSubArray === 0) {
        k++;
        matrix[k] = [];
      }

      matrix[k].push(list[i]);
    }

    return matrix;
  }

  select(slot) {

    if (this.selectedTokens.length == 0) {
      var index = this.slots.findIndex(s => s == slot);
      this.slots[index].selected = true;
      this.listToMatrix(this.slots, 10);
      this.selectedTokens.push(slot.token)
      var obj = {
        slot_id: slot.id,
        appt_type: this.type
      }

      this.slots_arr.push(obj)
    }
    else if (this.selectedTokens.length == 1) {
      var index = this.slots.findIndex(s => s.token == this.selectedTokens[0]);

      var index1 = this.slots.findIndex(s => s == slot);
      if (this.slots[index1].selected) {
        this.slots[index1].selected = false;
        this.listToMatrix(this.slots, 10);
        this.selectedTokens.splice(0, 1)
      }
      else {
        if ((index - index1 == 1) || (index1 - index) == 1) {
          this.slots[index1].selected = true;
          this.selectedTokens.push(slot.token)

          var obj = {
            slot_id: slot.id,
            appt_type: this.type
          }

          this.slots_arr.push(obj)
        }
        else {
          this.toastr.error("Please select consecutive tokens")
        }
      }
    }
    else if (this.selectedTokens.length == 2) {
      var index = this.slots.findIndex(s => s == slot);
      if (this.slots[index].selected) {
        this.slots[index].selected = false;

        var index1: any = this.selectedTokens.findIndex(s => s == slot.token);

        this.selectedTokens.splice(index1, 1)
      }
      else {

        this.toastr.error("Maximum limit reached")

      }
    }

    this.time = slot.start

  }

  next() {
    if (this.selectedTokens.length == 0) {
      this.toastr.error("Please select a token")
    }
    else {



      if (this.state == 1) {
        this.apptTokens = this.selectedTokens.join(',')
        //  this.state++;

        if (moment(new Date(this.date)).format("YYYY-MM-DD") != moment(new Date()).format("YYYY-MM-DD") && this.subStatus != 1) {
          this.deduct = true
        }

        var result = {
          token: this.selectedTokens,
          appt_datetime: this.time + 'Z',
          patient_account: this.email,
          appt_type: this.type,
          location: null,
          account_email: this.demail,
          doctor_id: this.id,
          deduct: this.deduct,
          slots_arr: this.slots_arr
        }

        this.dialogRef.close(result)

      }


    }


  }

  save() {
    this.dialogRef.close(this.value);
  }

  cancel() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'drugType',
  templateUrl: 'drugType.html',
  styleUrls: ['drugType.scss']
})

export class drugType {

  type;
  total;
  durationAlone;
  fullFreq;
  showUnits;

  constructor(
    public dialogRef: MatDialogRef<drugType>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_drugType, public router: Router, public route: ActivatedRoute) {

  }
  ngOnInit(): void {
    this.type = this.data.type
    this.total = this.data.total
    this.durationAlone = this.data.durationAlone
    this.fullFreq = this.data.fullFreq
    this.showUnits = this.data.showUnits
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    var obj = {
      type: this.type,
      total: this.total,
      durationAlone: this.durationAlone,
      fullFreq: this.fullFreq,
      showUnits: this.showUnits
    }
    this.dialogRef.close(obj);

  }

  radioChange(i) {
    this.type = i
  }
}


@Component({
  selector: 'payment',
  templateUrl: 'submenus/payment.html',
  styleUrls: ['submenus/payment.scss']
})

export class paymentsheet {
  urlPoints;
  payment;
  pending;
  print_temps;
  defPage = false;
  conHistorydata;

  constructor(
    public _bottomSheetRef: MatBottomSheetRef<paymentsheet>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_paymentsheet, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef, private appService: AppService, public router: Router, public route: ActivatedRoute, private toastr: ToastrService) {
    this.urlPoints = AppConfig.settings.EndPoints;
  }

  ngOnInit(): void {
    var params = {
      account_email: this.data.dmail,
      patient_email: this.data.email,
    }

    this.getPayment(this.urlPoints.getPayment, params, this.data.token);

    var temp_params = {
      account_email: this.data.dmail,
      doctor_id: this.data.doc_id,
      doctor_email: this.data.email
    }

    this.appService.getData(this.urlPoints.getPrintTemplate, temp_params, this.data.token).subscribe((response: any) => {
      this.print_temps = response.data.concat(response.master_templates)
      console.log(this.print_temps)
    });
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  getPayment(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      this.payment = response;
      for (var i = 0; i < this.payment.length; i++) {
        this.payment[i].date = moment(this.payment[i].bill_date).format("DD-MMM-YYYY");
        this.payment[i].category = this.payment[i].category.split('_').join(' ')
        this.pending = this.pending + this.payment[i].fee_pending
      }

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });

    setTimeout(() => {
      this._changeDetectorRef.markForCheck();
    }, 500);
  }

  print(billno) {
    var token = this.data.token;

    var params = {
      account_email: this.data.dmail,
      patient_email: this.data.email,
      bill_no: billno,
      status: 0,
      doctor_id: this.data.doc_id
    }

    this.getPrint(this.urlPoints.getPrint, params, this.data.token);

  }

  printPayment(bill_no) {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_tempchoose1, {
      width: '600px',
      data: { temps: this.print_temps }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        var params = {
          account_email: this.data.dmail,
          patient_email: this.data.email,
          bill_no: bill_no,
          doctor_id: this.data.doc_id,
          template_id: result.temp
        }

        this.appService.postData(this.urlPoints.paymentReceipt, params, this.data.token).subscribe((response: any) => {
          window.open(environment.HOST + '/PDF/' + response.data)
        });
      }
    });
  }

  sms(billno) {
    var token = this.data.token;

    var params = {
      account_email: this.data.dmail,
      patient_email: this.data.email,
      bill_no: billno,
      status: 1,
      doctor_id: this.data.doc_id
    }

    this.getSMS(this.urlPoints.getPrint, params, this.data.token);

    this.toastr.success('Receipt sent successfully!', '', {
      timeOut: 3000,
    });
  }

  getPrint(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      window.open(environment.HOST + '/PDF/' + response.data)
    });
  }

  getSMS(url, params, token) {
    this.appService.getData(url, params, token).subscribe((response: any) => {
      //  window.open('https://api.epicare.net/PDF/'+response.data)
    });
  }

  close() {

  }

  getExternalPayhistory(){
    this.defPage = true
    var token = this.data.token;

    let params = {
      account_email: this.data.dmail,
      patient_email: this.data.email
    }
    this.appService.postData(this.urlPoints.externalpaymentsdata, params, token).subscribe((response: any) => {
      console.log('response::',response);
      if(response.success==1){
        this.conHistorydata = response.message
        console.log(this.conHistorydata);
      }
    });
  }


}


//vaccination popup starts

export interface Dialognotgiven {
  deferdata: any
}

@Component({
  selector: 'printvaccine',
  templateUrl: 'submenus/printvaccine.html',
  styleUrls: ['submenus/printvaccine.scss']
})
export class DialogOverviewExampleDialog_printvaccine {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_printvaccine>,
    @Inject(MAT_DIALOG_DATA) public data: Dialognotgiven) {
  }
  ngOnInit(): void {
  }
  Close() {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  selectedvac(data) {
    this.dialogRef.close(data);
  }

}

//pending

export interface Dialogpending {
  deferdata2: any
}


@Component({
  selector: 'pending',
  templateUrl: 'submenus/pending.html',
  styleUrls: ['submenus/pending.scss']
})
export class DialogOverviewExampleDialog_pending {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_pending>,
    @Inject(MAT_DIALOG_DATA) public data: Dialogpending) {
  }
  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  pendingyes(data) {
    if (data == 'yes') {
      this.dialogRef.close(data);
    } else {
      this.dialogRef.close();
    }
  }
}

//Dialog for deffer

export interface Dialogdeffer {
  deferdata1: any
}


@Component({
  selector: 'deffer',
  templateUrl: 'submenus/deffer.html',
  styleUrls: ['submenus/deffer.scss']
})
export class DialogOverviewExampleDialog_deffer {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_deffer>,
    @Inject(MAT_DIALOG_DATA) public data: Dialogdeffer) {
  }
  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  defferyes(data) {
    if (data == 'yes') {
      this.dialogRef.close(data);
    } else {
      this.dialogRef.close();
    }
  }
}


// notgiven popup

export interface Dialognotgiven {
  deferdata: any
}


@Component({
  selector: 'notgiven',
  templateUrl: 'submenus/notgiven.html',
  styleUrls: ['submenus/notgiven.scss']
})
export class DialogOverviewExampleDialogaddnotgiven {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialogaddnotgiven>,
    @Inject(MAT_DIALOG_DATA) public data: Dialognotgiven) {
  }
  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  notgivenyes(data) {
    if (data == 'yes') {
      this.dialogRef.close(data);
    } else {
      this.dialogRef.close();
    }
  }
}

@Component({
  selector: 'growth',
  templateUrl: 'submenus/growth.html',
  styleUrls: ['submenus/growth.scss']
})

export class growth {
  // @ViewChild('contentToConvert', { static: true }) contentToConvert: ElementRef;
  @ViewChild('printSectionId') contentToConvert: ElementRef;

  urlPoints;
  payment;
  pending;
  vitalsDataResponse;
  chartData: any = {};
  record;
  recordAge: any
  allowedLimits;
  userChoice;
  vitalData;
  weightData;
  pretermWeightData;
  weightDa;
  postnatalWeightData;
  postweightData;
  postnataldate;
  heightData;
  pretermHeightData;
  heightDa;
  hcData;
  pretermHcData;
  HCData;
  postnatalHcData;
  PostnatalHcDa;
  ccmData
  bmiData
  bmiDa
  weightheightData
  WeightHeightDa
  whRatioData
  postnatalHeightData
  postHCData
  WHData;
  abnormalData;
  bmiCategory;
  patientData
  age;
  showType;
  showChart = true
  growthPrint = true
  showTable = false
  years; month;
  bmidata; bsidata;
  weightdata; heightdata;
  vitalinterpolData;
  pdfoutput;
  phpresponse;
  loader = false;


  constructor(
    public _bottomSheetRef: MatBottomSheetRef<growth>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_growth, private http: HttpClient, private spinner: NgxSpinnerService, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef, private appService: AppService, public router: Router, public route: ActivatedRoute, private toastr: ToastrService) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.record = this.data.patient.demographics

  }

  ngOnInit(): void {

    this.record = this.data.patient.demographics
    console.log(this.record);

    var a = this.record.bday;
    var b = moment(new Date()).format("YYYY-MM-DD");

    var a_arr = a.split('-')
    var b_arr = b.split('-')

    var x = moment([b_arr[0], Number(b_arr[1]) - 1, b_arr[2]]);
    var y = moment([a_arr[0], Number(a_arr[1]) - 1, a_arr[2]]);

    this.years = moment(x).diff(moment(y), 'year')
    y.add('years', this.years)
    this.month = moment(x).diff(moment(y), 'months')

    this.getChartData();
    this.getTableData();
  }

  getTableData() {
    this.appService.getQueue(this.urlPoints.getVitalsinter + '?account_email=' + this.data.dmail + '&patient_email=' + this.data.email+'&type=1', this.data.token).subscribe((response: any) => {
      console.log(response);
      this.vitalinterpolData = response.data;

      for (var i = 0; i < this.vitalinterpolData.length; i++) {

        var month = moment(this.vitalinterpolData[i].date).diff(moment(this.record.bday), 'month');
        var year = moment(this.vitalinterpolData[i].date).diff(moment(this.record.bday), 'year');
        this.vitalinterpolData[i].m = month;
        this.vitalinterpolData[i].y = year;
      }
    })
  }

  getChartData() {


    this.appService.getQueue(this.urlPoints.getVitals + '?' + this.data.id, this.data.token).subscribe((response: any) => {
      this.vitalsDataResponse = response;

      for (var i = 0; i < this.vitalsDataResponse.length; i++) {

        if (i + 1 === this.vitalsDataResponse.length) {
          console.log("last inexxxxx*****")
          console.log(this.vitalsDataResponse[i]);
          this.weightdata = this.vitalsDataResponse[i].weight;
          this.heightdata = this.vitalsDataResponse[i].height;
          this.bmidata = this.vitalsDataResponse[i].bmi;
          if (this.bmidata == 'nan') {
            this.bmidata = ''
          } else { this.bmidata = this.bmidata }

          this.bsidata = ((0.007184 * Math.pow(Number(this.weightdata), 0.425) * (Math.pow((Number(this.heightdata) / 100), 0.725))).toFixed(3))
        }

        var m = moment(this.vitalsDataResponse[i].date).diff(moment(this.record.bday), 'month');
        var y = moment(this.vitalsDataResponse[i].date).diff(moment(this.record.bday), 'year');

        this.vitalsDataResponse[i].m = m
        this.vitalsDataResponse[i].y = y

        this.vitalsDataResponse[i].height = (this.vitalsDataResponse[i].height * 100).toFixed(1);
      }

      var that = this
      var corrected_bday = that.record.corrected_bday
      var dobMoment = moment(this.record.bday);
      var currentDate = moment(new Date());
      var ageInDays = currentDate.diff(dobMoment, 'days');
      var ageInMonths = currentDate.diff(dobMoment, 'month');

      this.recordAge = {
        years: parseInt(moment().diff(dobMoment, 'year', true) as any),
        months: parseInt((moment().diff(dobMoment, 'month', true) % 12) as any),
        days: parseInt((moment().diff(dobMoment, 'day', true) % 365) as any),
        ageInDays: ageInDays,
        ageInMonths: ageInMonths
      };

      if (this.recordAge.years < 5) {
        this.allowedLimits = { heightMin: 1, heightMax: 120, weightMin: 1, weightMax: 24, headMin: 1, headMax: 54 };
        this.age = 1
        this.showType = 1


      } else if (this.recordAge.years > 5) {
        this.allowedLimits = { heightMin: 44, heightMax: 190, weightMin: 1, weightMax: 190, headMin: 32, headMax: 100 };
        this.age = 2
        this.showType = 2

      }

      var vitalData = this.vitalsDataResponse.map(function (item) {

        return {
          age: {
            years: parseInt(moment(item.date).diff(dobMoment, 'year', true) as any),
            months: parseInt((moment(item.date).diff(dobMoment, 'month', true) % 12) as any),
            days: parseInt((moment(item.date).diff(dobMoment, 'day', true) % 365) as any)
          },
          date: new Date(item.date),
          agemos: parseFloat(moment(new Date(item.date)).diff(dobMoment, 'months').toFixed(2)),
          height: item.height / 100,
          weight: item.weight,
          bmi: item.bmi, //item.bmi_value
          bsa: (0.007184 * Math.pow(item.weight, 0.425) * (Math.pow((item.height), 0.725))).toFixed(3),
          head: item.head_circumference,
          arm: item.arm_circumference,
          chest: item.chest_circumference,
          temperature: item.temperature,
          hr: item.heart_rate,
          rr: item.respiratory_rate,
          bp_diastolic: item.bp_diastolic,
          bp_systolic: item.bp_systolic,
          oxygen_saturation: item.oxygen_saturation,
          id: item.__documentid__,
          newDate: new Date(item.date).toLocaleDateString()
        };
      });

      if (this.recordAge.years >= 5 && !this.userChoice) {
        this.userChoice = "2";
      } else if (this.recordAge.years < 5 && !this.userChoice) {
        this.userChoice = "1";
      }

      this.vitalData = vitalData;

      this.vitalsDataResponse.sort(function (a, b) {
        if (a.date < b.date)
          return -1;
        if (a.date > b.date)
          return 1;
        return 0;
      });

      this.vitalsDataResponse.reverse()


      this.weightData = [];
      this.pretermWeightData = [];

      this.weightDa = this.vitalData.map(function (item) {
        if (item.weight != null) {

          if (corrected_bday != null) {
            var correctedDate = new Date(corrected_bday);
            if (item.date < correctedDate) {
              var dobMoment = moment(item.date);
              var currentDate = moment(correctedDate);
              var diffDays = 280 - currentDate.diff(dobMoment, 'days');
              if (diffDays > 167 && diffDays < 232) {
                that.pretermWeightData.push({ x: diffDays, y: parseFloat(item.weight) });
              }
            }
          }
          that.weightData.push({ x: item.agemos, y: parseFloat(item.weight) });
        }
        return [item.agemos, parseFloat(item.weight)];
      });

      this.postnatalWeightData = [];

      this.postweightData = this.vitalData.map(function (item) {
        if (item.weight != null) {
          if (corrected_bday != null) {
            that.postnataldate = new Date();
            that.postnataldate = new Date(corrected_bday);
            that.postnataldate.addDays(168);
            if (item.date < that.postnataldate) {
              var dobMoment = moment(item.date);
              var currentDate = moment(that.postnataldate);
              var diffDays = 448 - currentDate.diff(dobMoment, 'days');
              if (diffDays > 188 && diffDays < 449) {
                that.postnatalWeightData.push({ x: parseInt((diffDays / 7) as any), y: parseFloat(item.weight).toFixed(2) });
              }
            }
          }
        }
        return [item.agemos, parseFloat(item.weight).toFixed(2)];
      });

      this.heightData = [];
      this.pretermHeightData = [];

      this.heightDa = this.vitalData.map(function (item) {
        if (item.height != null) {
          if (corrected_bday != null) {
            var correctedDate = new Date(corrected_bday);
            if (item.date < correctedDate) {
              var dobMoment = moment(item.date);
              var currentDate = moment(correctedDate);
              var diffDays = 280 - currentDate.diff(dobMoment, 'days');
              if (diffDays > 167 && diffDays < 232) {
                that.pretermHeightData.push({ x: diffDays, y: parseFloat((item.height * 100) as any) });
              }
            }
          }
          that.heightData.push({ x: item.agemos, y: parseFloat((item.height * 100).toFixed(2)) })
        }
        return [item.agemos, parseFloat((item.height * 100).toFixed(2))];
      });

      this.hcData = [];
      this.pretermHcData = [];

      this.HCData = this.vitalData.map(function (item) {
        if (item.head != null) {
          if (corrected_bday != null) {
            var correctedDate = new Date(corrected_bday);
            if (item.date < correctedDate) {
              var dobMoment = moment(item.date);
              var currentDate = moment(correctedDate);
              var diffDays = 280 - currentDate.diff(dobMoment, 'days');
              if (diffDays > 167 && diffDays < 232) {
                this.pretermHcData.push({ x: diffDays, y: parseFloat(item.head) });
              }
            }
          }
          that.hcData.push({ x: item.agemos, y: parseFloat(item.head) });
        }
        return [item.agemos, parseFloat(item.head)];
      });

      this.postnatalHcData = [];
      this.PostnatalHcDa = this.vitalData.map(function (item) {
        if (item.head != null) {
          if (corrected_bday != null) {
            that.postnataldate = new Date();
            that.postnataldate = new Date(corrected_bday);
            that.postnataldate.addDays(168);
            if (item.date < that.postnataldate) {
              var dobMoment = moment(item.date);
              var currentDate = moment(that.postnataldate);
              var diffDays = 448 - currentDate.diff(dobMoment, 'days');
              if (diffDays > 188 && diffDays < 449) {
                that.postnatalHcData.push({ x: parseInt((diffDays / 7) as any), y: parseFloat(item.head) });
              }
            }
          }
        }
        return [item.agemos, parseFloat(item.head)];
      });

      this.postnatalHeightData = [];
      this.postHCData = this.vitalData.map(function (item) {
        if (item.height != null) {
          if (corrected_bday != null) {
            that.postnataldate = new Date();
            that.postnataldate = new Date(corrected_bday);
            that.postnataldate.addDays(168);
            if (item.date < this.postnataldate) {
              var dobMoment = moment(item.date);
              var currentDate = moment(that.postnataldate);
              var diffDays = 448 - currentDate.diff(dobMoment, 'days');
              if (diffDays > 188 && diffDays < 449) {
                that.postnatalHeightData.push({ x: parseInt((diffDays / 7) as any), y: parseFloat((item.height * 100) as any).toFixed(2) });
              }
            }
          }
        }
        return [item.agemos, parseFloat((item.height * 100) as any).toFixed(2)];
      });

      this.bmiData = []
      this.bmiDa = this.vitalData.map(function (item) {
        if (item.bmi != null) {
          that.bmiData.push({ x: item.agemos, y: parseFloat(item.bmi) })
        }
        return [item.agemos, parseFloat(item.bmi)];
      });

      this.weightheightData = []
      this.WeightHeightDa = this.vitalData.map(function (item) {
        if (item.height != null && item.weight != null) {
          that.weightheightData.push({ x: parseFloat((item.height * 100).toFixed(2)), y: item.weight });
        }
        return [parseFloat((item.height * 100).toFixed(2)), item.weight];
      });

      this.whRatioData = [];

      this.WHData = this.vitalData.map(function (item) {
        if (item.weight != null && item.height != null) {
          if (corrected_bday != null) {
            var correctedDate = new Date(corrected_bday);
            if (item.date < correctedDate) {
              var dobMoment = moment(item.date);
              var currentDate = moment(correctedDate);
              var diffDays = 280 - currentDate.diff(dobMoment, 'days');
              if (diffDays > 167 && diffDays < 232) {
                that.whRatioData.push({ x: diffDays, y: parseFloat((item.weight / (item.height)) as any).toFixed(2) });
              }
            }
          }
        }
        return [item.agemos, parseFloat(item.head)];
      });

      this.chartData = {
        weight: this.weightData,
        pretermWeight: this.pretermWeightData,
        postnatalWeight: this.postnatalWeightData,
        height: this.heightData,
        pretermHeight: this.pretermHeightData,
        postnatalHeight: this.postnatalHeightData,
        hc: this.hcData,
        pretermHc: this.pretermHcData,
        postnatalHc: this.postnatalHcData,
        bmi: this.bmiData,
        hwData: this.weightheightData,
        // pretermwhRatio:this.whRatioData
      };

      console.log(this.vitalsDataResponse)

      for (var i = 0; i < this.vitalsDataResponse.length; i++) {
        if (Number(this.vitalsDataResponse[i].height) == 0) {
          this.vitalsDataResponse[i].height = ''
        }

        if (this.vitalsDataResponse[i].bmi == 'nan') {
          this.vitalsDataResponse[i].bmi = ''
        }
      }

      this.showChart = false;

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 100);

      setTimeout(() => {
        this.showChart = true
      }, 100);

      //  this.showChart=true

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);

      this._changeDetectorRef.detectChanges();
    });
  }

  openDetail(i) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_growthdetail, {
      //  width: '600px',
      data: { id: i, chartData: this.chartData }
    });
  }

  share() {
    alert(2)
    var element = document.getElementById('overlay1');
    var opt = {
      margin: 0.1,
      filename: 'BabyGrowthReport.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 1 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
    };
    // New Promise-based usage:
    //html2pdf().from(element).set(opt).save();
    return { options: opt, content: element }
  }

  async printPDF() {
    alert(1)
    let { options, content } = await this.share()
    let worker = html2pdf().set(options).from(content).toPdf().output('blob').then((data: Blob) => {
      console.log(data)
      //return data
      this.pdfoutput = data;
      let params = new HttpParams();
      var fd = new FormData();     // To carry on data
      fd.append('pdf', this.pdfoutput);
      const options: any = {
        dataType: 'JSON',
        processData: false,
        contentType: false,
      }
      this.http.post('https://api.epicare.net/helyxonapi/cloud/pdf/pdf.php', fd, options)
        .subscribe(
          data => {
            this.phpresponse = data
            console.log(this.phpresponse.pdf[0].filename)
            //this.toastr.success('Saved successfully');
            //this.savepatientquestion()
          },
          (err: HttpErrorResponse) => {
            console.log(err.message, JSON.parse(err.error).error.message);
          }
        )
    })
  }

  shareCharts() {
    this.loader = true;
    if (this.showType == 1) {
      var selectedShareID = 'takesnap_0to5';
    } else {
      var selectedShareID = 'takesnap__5to18';
    }
    var node = document.getElementById(selectedShareID);
    document.getElementById(selectedShareID).style.display = 'block';

    var options = { quality: 1 };

    domtoimage.toJpeg(node, options).then((dataUrl) => {
      console.log(dataUrl)
      document.getElementById(selectedShareID).style.display = 'none'
      var mydata = this.base64ImageToBlob(dataUrl);
      var dummyurl = "https://api.epicare.net/helyxonapi/cloud/image/image.php";
      this.appService.postimgData(dummyurl, mydata, this.data.token).subscribe((response: any) => {
        console.log("response", response);
        if (response.type == 4) {
          if (response.body.image[0].success == 1) {
            var imgurl = response.body.image[0].filename;
            var environmentimgurl = 'https://api.epicare.net/helyxonapi/cloud/image/upload/' + imgurl
            console.log(environmentimgurl);
            this.loader = false;
            setTimeout(() => {
              this._changeDetectorRef.markForCheck();
            }, 500);
            this.openCopyUrl(environmentimgurl)
          }
        }

      })
    })
  }

  openCopyUrl(getimgURL) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_copyurl, {
      //  width: '600px',
      data: { copyfileName: getimgURL }
    });
  }

  base64ImageToBlob(str) {
    var pos = str.indexOf(';base64,');
    var type = str.substring(5, pos);
    var b64 = str.substr(pos + 8);
    var imageContent = atob(b64);
    var buffer = new ArrayBuffer(imageContent.length);
    var view = new Uint8Array(buffer);
    for (var n = 0; n < imageContent.length; n++) {
      view[n] = imageContent.charCodeAt(n);
    }
    var blob = new Blob([buffer], { type: type });
    return blob;
  }

  printGraph(id) {
    var innerContents = (document.getElementById(id) as HTMLDivElement).innerHTML
    //var age = ($rootScope.recordAge.years ? $rootScope.recordAge.years + " years " : "") + ($rootScope.recordAge.months ? $rootScope.recordAge.months + " months " : "") + ($rootScope.recordAge.days ? $rootScope.recordAge.days + " days" : "");
    //<h3>Name : ' + $scope.record.name + '/' + age + '/' + $scope.record.gender + '/' + $scope.record.mr_number + '<br>DOB : ' + $filter('date')($scope.record.dob, "dd-MMM-yyyy") + '</h3><br>
    var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();

    if (this.record.gender == 'male') {
      popupWinindow.document.write('<html><head><style>#text{background: #82d1f5 !important; }  .chart { padding: 3px;} .chart svg {margin-top:12%     background: #fff !important;} svg { margin-top:12%;  background: #fff !important;} .tick line {	opacity: 0.2;}.axis path, .axis line {	fill: none;	stroke: black;}div.tooltip {		position: absolute;				text-align: center;				/*width: 60px;						height: 28px;						padding: 2px;*/	font: 12px sans-serif;			background: lightsteelblue;		border: 0px;			border-radius: 8px;				pointer-events: none;	@media print {pre {font-family: Myriad Pro, Myriad, Helvetica Neue;display: -webkit-inline-box;padding: 0px; margin: inherit; font-size: 14px;line-height: 1.428571429; color: 142E3C; word-break: break-all;word-wrap: break-word;background-color: #fff; border: 0px; border-radius: 0px; }td{	border-top: 0px !important;	padding: 2px !important; }.chart {	background: #fff !important;	padding: 3px;}.chart div {width: 0;transition: all 1s ease-out;-moz-transition: all 1s ease-out;-webkit-transition: all 1s ease-out;}.chart div {font: 10px sans-serif;background-color: steelblue;text-align: right;padding: 3px;margin: 5px;color: white !important;box-shadow: 2px 2px 2px #666;}.tick line {	/*opacity: 0.2;*/	opacity: 0.3;	stroke: #000;	stroke-width: 1; }.axis path, .axis line {	fill: none;	stroke: black;}div.tooltip {		position: absolute;				text-align: center;				/*width: 60px;						height: 28px;						padding: 2px;*/	font: 12px sans-serif;			background: lightsteelblue;		border: 0px;			border-radius: 8px;				pointer-events: none;			}}		} </style><link rel="stylesheet" type="text/css" href="temp.css" /><link rel="stylesheet" type="text/css" href="src/app/chief-complaint/submenus/content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="../../../sass/app/_site.scss" /></head><body onload="window.print()">' + innerContents + '</html>');
    }
    else {
      popupWinindow.document.write('<html><head><style>#text{background: #FAD1E6 !important; } .chart { padding: 3px;} .chart svg {margin-top:12%     background: #fff !important;} svg { margin-top:12%; background: #fff !important;} .tick line {	opacity: 0.2;}.axis path, .axis line {	fill: none;	stroke: black;}div.tooltip {		position: absolute;				text-align: center;				/*width: 60px;						height: 28px;						padding: 2px;*/	font: 12px sans-serif;			background: lightsteelblue;		border: 0px;			border-radius: 8px;				pointer-events: none;	@media print {pre {font-family: Myriad Pro, Myriad, Helvetica Neue;display: -webkit-inline-box;padding: 0px; margin: inherit; font-size: 14px;line-height: 1.428571429; color: 142E3C; word-break: break-all;word-wrap: break-word;background-color: #fff; border: 0px; border-radius: 0px; }td{	border-top: 0px !important;	padding: 2px !important; }.chart {	background: #fff !important;	padding: 3px;}.chart div {width: 0;transition: all 1s ease-out;-moz-transition: all 1s ease-out;-webkit-transition: all 1s ease-out;}.chart div {font: 10px sans-serif;background-color: steelblue;text-align: right;padding: 3px;margin: 5px;color: white !important;box-shadow: 2px 2px 2px #666;}.tick line {	/*opacity: 0.2;*/	opacity: 0.3;	stroke: #000;	stroke-width: 1; }.axis path, .axis line {	fill: none;	stroke: black;}div.tooltip {		position: absolute;				text-align: center;				/*width: 60px;						height: 28px;						padding: 2px;*/	font: 12px sans-serif;			background: lightsteelblue;		border: 0px;			border-radius: 8px;				pointer-events: none;			}}		} </style><link rel="stylesheet" type="text/css" href="temp.css" /><link rel="stylesheet" type="text/css" href="src/app/chief-complaint/submenus/content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="../../../sass/app/_site.scss" /></head><body onload="window.print()">' + innerContents + '</html>');

    }

    // popupWinindow.document.write('<html><head><style>#text{background: #FAD1E6 !important; } .chart { background: #fff !important;padding: 3px;} .chart svg {margin-top:12%     background: #fff;} .tick line {	opacity: 0.2;}.axis path, .axis line {	fill: none;	stroke: black;}div.tooltip {		position: absolute;				text-align: center;				/*width: 60px;						height: 28px;						padding: 2px;*/	font: 12px sans-serif;			background: lightsteelblue;		border: 0px;			border-radius: 8px;				pointer-events: none;	@media print {pre {font-family: Myriad Pro, Myriad, Helvetica Neue;display: -webkit-inline-box;padding: 0px; margin: inherit; font-size: 14px;line-height: 1.428571429; color: 142E3C; word-break: break-all;word-wrap: break-word;background-color: #fff; border: 0px; border-radius: 0px; }td{	border-top: 0px !important;	padding: 2px !important; }.chart {	background: #fff !important;	padding: 3px;}.chart div {width: 0;transition: all 1s ease-out;-moz-transition: all 1s ease-out;-webkit-transition: all 1s ease-out;}.chart div {font: 10px sans-serif;background-color: steelblue;text-align: right;padding: 3px;margin: 5px;color: white !important;box-shadow: 2px 2px 2px #666;}.tick line {	/*opacity: 0.2;*/	opacity: 0.3;	stroke: #000;	stroke-width: 1; }.axis path, .axis line {	fill: none;	stroke: black;}div.tooltip {		position: absolute;				text-align: center;				/*width: 60px;						height: 28px;						padding: 2px;*/	font: 12px sans-serif;			background: lightsteelblue;		border: 0px;			border-radius: 8px;				pointer-events: none;			}.male-chart {	background: #82d1f5 !important;}.female-chart {	background: #FAD1E6 !important;}}		} </style><link rel="stylesheet" type="text/css" href="temp.css" /><link rel="stylesheet" type="text/css" href="src/app/chief-complaint/submenus/content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="../../../sass/app/_site.scss" /></head><body onload="window.print()">' + innerContents + '</html>');

    popupWinindow.document.close();
  }

  openForm() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_postvitals, {
      //  width: '600px',
      data: { id: this.data.id, token: this.data.token, allowedLimits: this.allowedLimits, doc_id: this.data.doc_id, email: this.data.email, d_email:this.data.dmail }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.getChartData();
        this.getTableData();

      }
    });
  }

  chartToggle(i) {
    if (i == 1)
      this.showTable = false
    else
      this.showTable = true
  }

  setShowType(i) {
    this.showType = i
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }
}

@Component({
  selector: 'post-vitals',
  templateUrl: 'submenus/post-vitals.html',
  styleUrls: ['submenus/post-vitals.scss']

})

export class DialogOverviewExampleDialog_postvitals {
  vitalForm;
  date = moment(new Date()).format("YYYY-MM-DD");
  urlPoints;
  allowedLimits;
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_postvitals>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder) {
    this.urlPoints = AppConfig.settings.EndPoints;

    this.allowedLimits = this.data.allowedLimits
  }

  ngOnInit(): void {


    this.vitalForm = new FormGroup({
      'date': new FormControl(moment(new Date()).format("YYYY-MM-DD")),
      'weight': new FormControl('', [Validators.min(this.allowedLimits.weightMin), Validators.max(this.allowedLimits.weightMax)]),
      'height': new FormControl('', [Validators.min(this.allowedLimits.heightMin), Validators.max(this.allowedLimits.heightMax)]),
      'arm_circumference': new FormControl('', [Validators.min(1), Validators.max(20)]),
      'chest_circumference': new FormControl('', [Validators.min(1), Validators.max(110)]),
      'head_circumference': new FormControl('', [Validators.min(1), Validators.min(this.allowedLimits.headMin), Validators.max(this.allowedLimits.headMax)]),

    })

  }

  close() {
    this.dialogRef.close()
  }

  save() {

    if (this.vitalForm.valid) {

      console.log(this.vitalForm.value)

      let getbmi = (((this.vitalForm.value.weight / (this.vitalForm.value.height * this.vitalForm.value.height)) * 10000));
      console.log(getbmi);

      var params = {
        "record_id": this.data.id,
        "doctor_id": this.data.doc_id,
        "patient_email": this.data.email,
        "account_email": this.data.d_email,
        "type": "Vitals", "data": {
          "Models": {
            "Model": {
              "name": "HelChildVitalSigns",
              "Field":
                [
                  { "name": "date", "text": this.vitalForm.value.date },
                  { "name": "weight", text: this.vitalForm.value.weight != (undefined || null) ? this.vitalForm.value.weight.toString() : "" },
                  { "name": "bmi", text: getbmi != Infinity && getbmi != NaN && getbmi != null ? getbmi.toString() : "" },
                  { "name": "height", text: this.vitalForm.value.height != (undefined || null) ? (this.vitalForm.value.height / 100).toString() : "" },
                  { "name": "arm_circumference", "text": this.vitalForm.value.arm_circumference != (undefined || null) ? this.vitalForm.value.arm_circumference.toString() : "" },
                  { "name": "chest_circumference", "text": this.vitalForm.value.chest_circumference != (undefined || null) ? this.vitalForm.value.chest_circumference.toString() : "" },
                  { "name": "head_circumference", "text": this.vitalForm.value.head_circumference != (undefined || null) ? this.vitalForm.value.head_circumference.toString() : "" }
                ]
            }
          }
        }
      }

      this.postVitals(this.urlPoints.postVitals, params, this.data.token)
    }

  }

  omit_number(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 47 && k < 58));
  }


  postVitals(url, params, token) {

    this.appService.postData(url, params, token).subscribe((response: any) => {
      this.dialogRef.close('a')

    });
  }

  printGraph(id) {
    var innerContents = (document.getElementById(id) as HTMLDivElement).innerHTML
    //var age = ($rootScope.recordAge.years ? $rootScope.recordAge.years + " years " : "") + ($rootScope.recordAge.months ? $rootScope.recordAge.months + " months " : "") + ($rootScope.recordAge.days ? $rootScope.recordAge.days + " days" : "");
    //<h3>Name : ' + $scope.record.name + '/' + age + '/' + $scope.record.gender + '/' + $scope.record.mr_number + '<br>DOB : ' + $filter('date')($scope.record.dob, "dd-MMM-yyyy") + '</h3><br>
    var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();


    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="/submenus/content/temp.css" /><link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet"><link rel="stylesheet" type="text/css" href="../../../sass/app/_site.scss" /></head><body onload="window.print()">' + innerContents + '</html>');
    popupWinindow.document.close();


  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'growth-detail',
  templateUrl: 'submenus/growth_detail.html',
  styleUrls: ['submenus/growth_detail.scss']

})

export class DialogOverviewExampleDialog_growthdetail {
  chartData;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_postvitals>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_growthdetail, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
    this.chartData = this.data.chartData
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'growth-copyurl',
  templateUrl: 'submenus/copy_url.html',
  styleUrls: ['submenus/copy_url.scss']

})

export class DialogOverviewExampleDialog_copyurl {
  copyURLData;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_copyurl>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_growthcopyurl, public clipboard: Clipboard, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
    this.copyURLData = this.data.copyfileName
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  copy() {
    this.clipboard.copy(this.copyURLData);
    this.toastr.success('URL copied!');
  }
}


@Component({
  selector: 'icons',
  templateUrl: 'icons.html',
  styleUrls: ['icons.scss']

})

export class DialogOverviewExampleDialog_icons {
  chartData;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_icons>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_growthdetail, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'icons2',
  templateUrl: 'icons2.html',
  styleUrls: ['icons2.scss']

})

export class DialogOverviewExampleDialog_icons2 {
  formulation;
  create = false;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_icons2>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_icons2, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
    this.formulation = (this.data.formulation).trim()

  }

  setFormulation(i) {
    this.formulation = i;

    this.create = false
  }

  save() {

    var obj = {
      create: this.create,
      formulation: this.formulation
    }

    this.dialogRef.close(obj)
  }

  createChange() {
    this.create = !this.create

  }

  emptyFormulation() {
    this.formulation = ''
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'createpopup',
  templateUrl: 'createpopup.html',
  styleUrls: ['createpopup.scss']

})

export class DialogOverviewExampleDialog_createpopup {
  formulation;
  create = false;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_createpopup>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_icons2, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
    this.formulation = (this.data.formulation).trim()

  }



  save(i) {

    if (i == 1)
      this.dialogRef.close(false)
    else
      this.dialogRef.close(true)

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'configDrugPopup',
  templateUrl: 'configDrugPopup.html',
  styleUrls: ['configDrugPopup.scss']

})

export class DialogOverviewExampleDialog_configDrugPopup {

  create = false;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_configDrugPopup>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: configDrugPopup, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
  

  }

  save(i) {

    if (i == 1)
      this.dialogRef.close(false)
    else
      this.dialogRef.close(true)

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'alertMessage',
  templateUrl: 'alertMessage.html',
  styleUrls: ['alertMessage.scss']

})

export class DialogOverviewExampleDialog_alertMessage {

  create = false;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_alertMessage>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: alertMessagePopup, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
  

  }

  save(i) {

      this.dialogRef.close(true)
  }
  noSave(i) {

    this.dialogRef.close(false)
}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'alertConfirmMessage',
  templateUrl: 'alertConfirmMessage.html',
  styleUrls: ['alertConfirmMessage.scss']

})

export class DialogOverviewExampleDialog_alertConfirmMessage {

  create = false;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_alertConfirmMessage>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: alertConfirmMessagePopup, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
  

  }

  save(i) {

      this.dialogRef.close(true)
  }
  noSave(i) {

    this.dialogRef.close(false)
}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

//Dialog_chiefComplaints

@Component({
  selector: 'chief',
  templateUrl: 'chief.html',
  styleUrls: ['chief.scss']

})

export class Dialog_chiefComplaints {

  provisional = false;
  counter_params;
  doc_id;
  dmail;
  prescription_mode
  chief_complaints = [];
  cc_selected = [];
  cc_show = [];
  urlPoints;
  token;
  search = ''
  chars = '';
  cc_page;
  cc_data = []
  cc_pages;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  isFullListDisplayed: boolean = false;
  cc_all = [];
  cc_all_page = 1;
  cc_all_data = []
  showKB = false;
  speech: any;
  speechData: any;
  alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Space', 'Backspace']
  supported;
  osName;
  nisVersion = nisPackage.dependencies["ngx-infinite-scroll"];

  differ: KeyValueDiffer<string, any>;
  muted = true;
  timeoutHandler;
  held = false
  add = false
  chars_copy = '';

  constructor(
    public dialogRef: MatDialogRef<Dialog_chiefComplaints>, private differs: KeyValueDiffers, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, public service: VoiceRecognitionService) {
    this.doc_id = this.data.doc_id
    this.dmail = this.data.dmail;
    this.urlPoints = AppConfig.settings.EndPoints;
    this.token = this.data.token

    this.differ = this.differs.find({}).create();
    this.speech = new Speech()

    if (this.speech.hasBrowserSupport()) {
      this.speech.init({
        'volume': 1,
        'lang': 'en-GB',
        'rate': 1,
        'pitch': 1,
        'voice': 'Google UK English Male',
        'splitSentences': true,
        'listeners': {
          'onvoiceschanged': (voices) => {
          }
        }
      }).then((data) => {
        this.speechData = data;
        data.voices.forEach(voice => {
        });
      }).catch(e => {
      })
    }

    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      if (this.getOS() != 'iOS' && this.getOS() != "Mac OS") {
        this.service.init();
        this.supported = true
      }
      else {
        this.supported = false
      }

    } else {
      this.supported = false
    }

    dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.dialogRef.close(this.cc_selected)

    })
  }
  ngOnInit(): void {
this.callMasterSettings();
    this.cc_selected = Object.assign([], this.data.selected);

    var all_params = {
      account_email: this.data.dmail,
      page_no: this.cc_all_page,
      doctor_id: this.doc_id,
      limit: 50
    }

    this.appService.getData(this.urlPoints.getAllComplaints, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = response.data

      this.cc_all = this.cc_all.filter(i => i.name.toLowerCase() != '');

    });

    this.counter_params = {
      doctor_id: this.doc_id,
      account_email: this.dmail
    }

    this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)
  }

  changeProv() {
    this.provisional = !this.provisional
  }

  new_cc() {
    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'cc',
        text: 'Enter new complaint'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.record == false) {

          if (this.provisional) {
            result.name = '?' + result.name
          }

          this.provisional = false;
          this.cc_selected.push(
            {
              name: result.name,
              diagnosis_id: 123
            }
          )
          return;
        }
        var res_arr = []

        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: result.name,
          "doctor_id": this.doc_id
        }

        this.appService.getData(this.urlPoints.getCC, params, this.token).subscribe((response: any) => {
          console.log(response.data)

          res_arr = response.data.filter(i => i.name.toLowerCase() != '');

          console.log(res_arr)

          if (res_arr.length > 0) {
            this.toastr.error(result.name + " already exists")
          }
          else {
            this.save_cc(result.name)
          }


        });

      }
    });
  }

  save_cc(result1) {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
      width: '600px', disableClose: true,
      data: { name: 'Add ' + result1 + ' to Chief Complaints?', type: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result == 'yes') {

          var params = {
            account_email: this.dmail,
            word_type: 0,
            new_complaint: [result1],
            doctor_id: this.doc_id,
          }

          this.appService.postData(this.urlPoints.newCC, params, this.token).subscribe((response: any) => {

            var params2 = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: result1,
              "doctor_id": this.doc_id
            }

            this.getCC1(this.urlPoints.getCC, params2, this.token);

          }
          );
        }
        else {
        }
      }
    });
  }



  getCC1(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        var res_arr = []


        res_arr = response.data.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());

        if (res_arr.length > 0) {

          res_arr[0].is_question = this.provisional ? true : false

          this.provisional = false

          this.cc_selected.push(res_arr[0])
        }

      }
    });


  }


  search1(e) {

    this.chars = e.target.value

    this.cc_page = 1
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars.toUpperCase().trim(),
      "doctor_id": this.doc_id
    }


    if (this.chars != '') {
      this.getCC(this.urlPoints.getCC, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)

  }



  keyboard(alphabet) {


    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars = this.chars + alphabet;
    }
    else {
      this.chars = this.chars.slice(0, -1)
    }

    this.search = this.chars

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      "doctor_id": this.doc_id
    }
    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getCC, params, this.token);
    this.cc_data = [];
    this.cc_page = 1;

  }

  clear() {
    this.search = ''

    this.chars = ''

    this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)

  }

  ngDoCheck() {
    const change = this.differ.diff(this.service);
    if (change) {
      var that = this;
      change.forEachChangedItem(item => {
        if (item.key == 'length') {
          if (this.supported) {
            this.add = false
            this.navigate()

          }
        }
      });
    }
  }

  navigate() {

    this.chars = this.search = this.service.textArray[this.service.textArray.length - 1]

    this.add = false;
    this.chars_copy = this.chars;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      "doctor_id": this.doc_id
    }

    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getCC, params, this.token, 'voice');
    this.cc_data = [];
    this.cc_page = 1;
  }

  toggleMute() {
    this.muted = !this.muted

    if (this.muted) {
      this.stopService()
    }
    else {
      this.startService()
    }
  }

  mouseup() {

    console.log('here')


    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }

    if (this.held) {
      this.held = false

      if (!this.muted) {

        this.muted = true
        this.service.stop()
      }
    }
  }

  mousedown() {


    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;

      this.held = true

      if (this.muted) {
        //  alert()
        this.muted = false
        this.service.start()
      }
    }, 1000);
  }

  startService() {

    console.log('here')

    console.log(this.supported)

    if (this.supported)
      this.service.start()

  }

  stopService() {

    if (this.supported)
      this.service.stop()

  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    this.osName = os

    return os;
  }
  med_des_popup(e:any,idx:any): void {
    if(this.prescription_mode){
    let des_data='';
    let params = {
      symptom_id:idx,
      account_email: this.dmail,
    }
    this.appService.getData(this.urlPoints.getchiefcomplaintdescription, params, this.token).subscribe((response: any) => {
      console.log('Response : ', response);
      des_data = response.status == 1 && response.message[0].description;
      const dialogRef = this.dialog.open(Med_description,{
      width:'fit-content',
      data:{name:e,index:idx,description:des_data}
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var param={
          symptom_id:idx,
          account_email: this.dmail,
          description:result
        }
        this.appService.postData(this.urlPoints.savechiefcomplaintdescription, param, this.token).subscribe((res: any) => {
          console.log("res>>>",res)
        });
        }
    })
  })
}else{
  console.log("Please Login to view the Description")
}
  }
  addCC(index) {
    this.callMasterSettings();
    // console.log(this.add)

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].symptoms_id == this.cc_show[index].symptoms_id) {
        var exists = true
      }
    }


    if (!exists) {  
      this.callMasterSettings();  
this.med_des_popup(this.cc_show[index].name,this.cc_show[index].id)
      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_show[index].name,
          reference_word: this.chars_copy,
          word_type: 1,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_show[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      this.cc_show[index].is_question = this.provisional ? true : false

      this.cc_selected = this.cc_selected.concat(this.cc_show[index])

      this.provisional = false

      this.cc_show.splice(index, 1);

      if (this.chars != '') {
        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: this.chars.toUpperCase().trim(),
          "doctor_id": this.doc_id
        }

        this.getCC(this.urlPoints.getCC, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)

      this.add = false;
    }

    else {
      this.toastr.error(this.cc_show[index].name + ' has been already added!')
    }

  }

  onScroll2() {
    //  alert('here')
    this.cc_all_page++;

    var all_params = {
      account_email: this.data.dmail,
      page_no: this.cc_all_page,
      limit: 50,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getAllComplaints, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = this.cc_all.concat(response.data)

    });
  }
  callMasterSettings(){
    var params={ 
      account_email : this.dmail, 
      doctor_id : this.doc_id
  }
  this.appService.getData(this.urlPoints.getMasterSettings, params, this.token).subscribe((masterData: any) =>{
    console.log("masterData::",masterData)
    this.prescription_mode = masterData.data[0].prescription_mode
  }) 
  }
  addCC1(index) {
this.callMasterSettings();
    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].symptoms_id == this.cc_all[index].symptoms_id) {
        var exists = true
      }
    }

    if (!exists) {
      this.callMasterSettings();
      this.med_des_popup(this.cc_all[index].name,this.cc_all[index].id)
      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_all[index].name,
          reference_word: this.chars_copy,
          word_type: 1,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_all[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      this.cc_all[index].is_question = this.provisional ? true : false

      this.provisional = false

      this.cc_selected = this.cc_selected.concat(this.cc_all[index])
    }
    else {
      this.toastr.error(this.cc_all[index].name + ' has been already added!')
    }

  }

  remove(index) {
    this.cc_data = []

    this.cc_selected.splice(index, 1);

    if (this.chars != '') {
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        "doctor_id": this.doc_id
      }

      this.getCC(this.urlPoints.getCC, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getCCCounter, this.counter_params, this.token)

  }

  openKeyboard() {
    this.showKB = !this.showKB
  }

  save() {

    if (!this.muted) {
      this.stopService()
    }

    this.dialogRef.close(this.cc_selected)
  }

  onScroll() {

    var token = this.token;
    this.cc_page++;

    var params = {
      account_email: this.dmail,
      page_no: this.cc_page,
      alphabet: this.chars.toUpperCase(),
      "doctor_id": this.doc_id
    }

    this.getCC(this.urlPoints.getCC, params, token)

  }

  onNoClick(): void {

    if (!this.muted) {
      this.stopService()
    }

    this.dialogRef.close(this.cc_selected)
  }

  close() {


    if (!this.muted) {
      this.stopService()
    }

    this.dialogRef.close();

  }

  getCCCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.chief_complaints = response.details;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_show.splice(matchedArray[i], 1);
        }

      }
    });
  }

  getCC(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;

        if (this.cc_page > 1)
          this.cc_data = this.cc_data.concat(response.data)
        else
          this.cc_data = response.data

        this.chief_complaints = this.cc_data;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.cc_show.splice(matchedArray[i], 1);
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 1,
          reference_word: this.chars.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {
          console.log(response)
          this.cc_show = this.cc_show.concat(response.data)
        });


        if (this.add == false && voice && this.cc_show.length == 0) {
          this.add = true
          this.chars_copy = this.chars
          console.log('here')
          console.log(this.chars)
        }

      }
    });
  }
}

@Component({
  selector: 'examination',
  templateUrl: 'examination.html',
  styleUrls: ['examination.scss']

})

export class Dialog_examination {

  provisional = false;
  counter_params;
  doc_id;
  dmail;
  chief_complaints = [];
  cc_selected = [];
  cc_show = [];
  urlPoints;
  token;
  search = ''
  chars = '';
  cc_page;
  cc_data = []
  cc_pages;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  isFullListDisplayed: boolean = false;
  cc_all = [];
  cc_all_page = 1
  showKB = false;
  speech: any;
  speechData: any;
  alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Space', 'Backspace']
  supported;
  osName;
  nisVersion = nisPackage.dependencies["ngx-infinite-scroll"];

  differ: KeyValueDiffer<string, any>;
  muted = true;
  timeoutHandler;
  held = false;
  add = false
  chars_copy = ''
  record = false

  constructor(
    public dialogRef: MatDialogRef<Dialog_chiefComplaints>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, private differs: KeyValueDiffers, public service: VoiceRecognitionService) {
    this.doc_id = this.data.doc_id
    this.dmail = this.data.dmail;
    this.urlPoints = AppConfig.settings.EndPoints;
    this.token = this.data.token

    this.differ = this.differs.find({}).create();
    this.speech = new Speech()

    if (this.speech.hasBrowserSupport()) {
      this.speech.init({
        'volume': 1,
        'lang': 'en-GB',
        'rate': 1,
        'pitch': 1,
        'voice': 'Google UK English Male',
        'splitSentences': true,
        'listeners': {
          'onvoiceschanged': (voices) => {
          }
        }
      }).then((data) => {
        this.speechData = data;
        data.voices.forEach(voice => {
        });
      }).catch(e => {
      })
    }

    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      if (this.getOS() != 'iOS' && this.getOS() != "Mac OS") {
        this.service.init();
        this.supported = true
      }
      else {
        this.supported = false
      }

    } else {
      this.supported = false
    }

    dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.dialogRef.close(this.cc_selected)

    })
  }
  ngOnInit(): void {

    this.cc_selected = Object.assign([], this.data.selected);

    console.log('here')

    var all_params = {
      account_email: this.data.dmail,
      page_no: 1,
      limit: 50,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getAllSigns, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = response.data


      this.cc_all = this.cc_all.filter(i => i.name.toLowerCase() != '');

      console.log(this.cc_all)


    });

    this.counter_params = {
      doctor_id: this.doc_id,
      account_email: this.dmail
    }

    this.getCCCounter(this.urlPoints.getExCounter, this.counter_params, this.token)
  }

  changeProv() {
    this.provisional = !this.provisional
  }

  search1(e) {

    this.chars = e.target.value

    this.cc_page = 1
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars.toUpperCase().trim(),
      doctor_id: this.doc_id
    }

    if (this.chars != '') {
      this.getCC(this.urlPoints.getEx, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getExCounter, this.counter_params, this.token)

  }

  new_cc() {
    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'sign',
        text: 'Enter new sign'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //  alert(result)

        if (result.record == false) {

          if (this.provisional) {
            result.name = '?' + result.name
          }

          this.provisional = false;

          this.cc_selected.push(
            {
              name: result.name,
              symptoms_id: 123
            }
          )
          return;
        }

        var res_arr = []

        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: result.name,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getEx, params, this.token).subscribe((response: any) => {
          console.log(response.data)

          res_arr = response.data.filter(i => i.name.toLowerCase() != '');

          console.log(res_arr)

          if (res_arr.length > 0) {
            this.toastr.error(result.name + " already exists")
          }
          else {
            this.save_cc(result.name)
          }


        });

      }
    });
  }

  openKeyboard() {
    this.showKB = !this.showKB
  }

  save_cc(result1) {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
      width: '600px', disableClose: true,
      data: { name: 'Add ' + result1 + ' to Examinations?', type: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result == 'yes') {

          var params = {
            account_email: this.dmail,
            word_type: 1,
            new_complaint: [result1],
            doctor_id: this.doc_id,
          }

          this.appService.postData(this.urlPoints.newCC, params, this.token).subscribe((response: any) => {

            var params2 = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: result1,
              doctor_id: this.doc_id
            }

            this.getCC1(this.urlPoints.getEx, params2, this.token);

          }
          );
        }
        else {
        }
      }
    });
  }

  getCC1(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        var res_arr = []


        res_arr = response.data.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());

        console.log(res_arr)

        if (res_arr.length > 0) {

          if (this.provisional) {
            res_arr[0].name = '?' + res_arr[0].name
          }

          this.provisional = false;

          this.cc_selected.push(res_arr[0])
        }



      }
    });


  }

  keyboard(alphabet) {


    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars = this.chars + alphabet;
    }
    else {
      this.chars = this.chars.slice(0, -1)
    }

    this.search = this.chars

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }
    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getExCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getEx, params, this.token);
    this.cc_data = [];
    this.cc_page = 1;

  }

  clear() {
    this.search = ''

    this.chars = ''

    this.getCCCounter(this.urlPoints.getExCounter, this.counter_params, this.token)

  }

  ngDoCheck() {
    const change = this.differ.diff(this.service);
    if (change) {
      var that = this;
      change.forEachChangedItem(item => {
        if (item.key == 'length') {
          if (this.supported)
            this.navigate()
        }
      });
    }
  }

  navigate() {
    this.chars = this.search = this.service.textArray[this.service.textArray.length - 1]

    this.add = false;
    this.chars_copy = this.chars;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }

    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getExCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getEx, params, this.token, 'voice');
    this.cc_data = [];
    this.cc_page = 1;
  }

  toggleMute() {
    this.muted = !this.muted

    if (this.muted) {
      this.stopService()
    }
    else {
      this.startService()
    }
  }

  mouseup() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }

    if (this.held) {
      this.held = false

      if (!this.muted) {

        this.muted = true
        this.service.stop()
      }
    }
  }

  mousedown() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;

      this.held = true

      if (this.muted) {
        //  alert()
        this.muted = false
        this.service.start()
      }
    }, 1000);
  }

  startService() {

    console.log('here')

    console.log(this.supported)

    if (this.supported)
      this.service.start()

  }

  stopService() {

    if (this.supported)
      this.service.stop()

  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    this.osName = os

    return os;
  }

  addCC(index) {

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].symptoms_id == this.cc_show[index].symptoms_id) {
        var exists = true
      }
    }

    if (!exists) {

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_show[index].name,
          reference_word: this.chars_copy,
          word_type: 2,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_show[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      if (this.provisional) {
        this.cc_show[index].name = '?' + this.cc_show[index].name
      }

      this.cc_selected = this.cc_selected.concat(this.cc_show[index])

      this.cc_show.splice(index, 1);

      this.provisional = false

      if (this.chars != '') {
        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: this.chars.toUpperCase().trim(),
          doctor_id: this.doc_id
        }

        this.getCC(this.urlPoints.getEx, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getExCounter, this.counter_params, this.token)

    }
    else {
      this.toastr.error(this.cc_show[index].name + ' has been already added!')

    }

  }

  addCC1(index) {

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].symptoms_id == this.cc_all[index].symptoms_id) {
        var exists = true
      }
    }

    if (!exists) {



      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_all[index].name,
          reference_word: this.chars_copy,
          word_type: 2,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_all[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      var obj = Object.assign({}, this.cc_all[index]);

      if (this.provisional) {
        obj.name = '?' + obj.name
      }

      this.provisional = false;

      this.cc_selected = this.cc_selected.concat(obj)

    }
    else {
      this.toastr.error(this.cc_all[index].name + ' has been already added!')
    }

  }

  onScroll2() {
    //  alert('here')
    this.cc_all_page++;

    var all_params = {
      account_email: this.data.dmail,
      page_no: this.cc_all_page,
      limit: 50,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getAllSigns, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = this.cc_all.concat(response.data)

    });
  }

  remove(index) {
    this.cc_data = []

    this.cc_selected.splice(index, 1);

    if (this.chars != '') {
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getCC(this.urlPoints.getEx, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getExCounter, this.counter_params, this.token)

  }

  save() {

    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close(this.cc_selected)
  }

  onScroll() {

    var token = this.token;
    this.cc_page++;

    var params = {
      account_email: this.dmail,
      page_no: this.cc_page,
      alphabet: this.chars.toUpperCase(),
      doctor_id: this.doc_id
    }

    this.getCC(this.urlPoints.getEx, params, token)

  }

  onNoClick(): void {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close(this.cc_selected)
  }

  close() {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close();

  }

  getCCCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.chief_complaints = response.details;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_show.splice(matchedArray[i], 1);
        }

      }
    });
  }

  getCC(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;

        if (this.cc_page > 1)
          this.cc_data = this.cc_data.concat(response.data)
        else
          this.cc_data = response.data

        this.chief_complaints = this.cc_data;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.cc_show.splice(matchedArray[i], 1);
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 2,
          reference_word: this.chars.toLowerCase(),
          account_email: this.dmail
        }

        // this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {
        //   console.log(response)
        //   this.cc_show = this.cc_show.concat(response.data)
        // });


        if (this.add == false && voice && this.cc_show.length == 0) {
          this.add = true
          this.chars_copy = this.chars
          console.log('here')
        }

      }
    });
  }
}

@Component({
  selector: 'diagnosis',
  templateUrl: 'diagnosis.html',
  styleUrls: ['diagnosis.scss']

})

export class Dialog_diagnosis {

  provisional = false;
  counter_params;
  doc_id;
  dmail;
  chief_complaints = [];
  cc_selected = [];
  cc_show = [];
  urlPoints;
  token;
  search = ''
  chars = '';
  cc_page;
  cc_data = []
  cc_pages;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  isFullListDisplayed: boolean = false;
  cc_all = [];
  block = 1;
  id_string;
  cc_all_page = 1;
  nisVersion = nisPackage.dependencies["ngx-infinite-scroll"];

  showKB = false;
  speech: any;
  speechData: any;
  alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Space', 'Backspace']
  supported;
  osName;

  differ: KeyValueDiffer<string, any>;
  muted = true
  timeoutHandler;
  held = false
  add = false
  chars_copy = '';
  record = false

  constructor(
    public dialogRef: MatDialogRef<Dialog_chiefComplaints>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, private differs: KeyValueDiffers, public service: VoiceRecognitionService) {
    this.doc_id = this.data.doc_id
    this.dmail = this.data.dmail;
    this.urlPoints = AppConfig.settings.EndPoints;
    this.token = this.data.token

    this.differ = this.differs.find({}).create();
    this.speech = new Speech()

    if (this.speech.hasBrowserSupport()) {
      this.speech.init({
        'volume': 1,
        'lang': 'en-GB',
        'rate': 1,
        'pitch': 1,
        'voice': 'Google UK English Male',
        'splitSentences': true,
        'listeners': {
          'onvoiceschanged': (voices) => {
          }
        }
      }).then((data) => {
        this.speechData = data;
        data.voices.forEach(voice => {
        });
      }).catch(e => {
      })
    }

    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      if (this.getOS() != 'iOS' && this.getOS() != "Mac OS") {
        this.service.init();
        this.supported = true
      }
      else {
        this.supported = false
      }

    } else {
      this.supported = false
    }

    dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.dialogRef.close(this.cc_selected)

    })
  }
  ngOnInit(): void {

    this.cc_selected = Object.assign([], this.data.selected);

    var combined = this.data.cc_selected.concat(this.data.ex_selected)

    console.log(combined)

    var ids = []

    for (var i = 0; i < combined.length; i++) {
      ids.push(combined[i].symptoms_id)
    }

    this.id_string = ids.join(',')

    var all_params = {
      doctor_id: this.doc_id,
      account_email: this.data.dmail,
      page_no: 1,
      limit: 50
    }

    this.appService.getData(this.urlPoints.getAllDiagnosis, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = response.data

      this.cc_all = this.cc_all.filter(i => i.name.toLowerCase() != '');

    });

    this.counter_params = {
      doctor_id: this.doc_id,
      account_email: this.dmail
    }

    this.getCCCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
  }

  changeProv() {
    this.provisional = !this.provisional
  }

  onScroll2() {
    //  alert('here')
    this.cc_all_page++;

    var all_params = {
      doctor_id: this.doc_id,
      account_email: this.data.dmail,
      page_no: this.cc_all_page,
      limit: 50
    }

    this.appService.getData(this.urlPoints.getAllDiagnosis, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = this.cc_all.concat(response.data)

    });
  }

  new_cc() {
    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'diag',
        text: 'Enter new diagnosis'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //  alert(result)

        if (result.record == false) {

          if (this.provisional) {
            result.name = '?' + result.name
          }

          this.provisional = false;
          // this.cc_selected.push(result)
          this.cc_selected.push(
            {
              name: result.name,
              diagnosis_id: 123
            }
          )
          return;
        }

        var res_arr = []

        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: result.name,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getDiag, params, this.token).subscribe((response: any) => {
          console.log(response.data)

          res_arr = response.data.filter(i => i.name.toLowerCase() != '');

          console.log(res_arr)

          if (res_arr.length > 0) {
            this.toastr.error(result.name + " already exists")
          }
          else {
            this.save_cc(result.name)
          }

        });

      }
    });
  }

  openKeyboard() {
    this.showKB = !this.showKB
  }

  save_cc(result1) {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
      width: '600px', disableClose: true,
      data: { name: 'Add ' + result1 + ' to Diagnosis?', type: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result == 'yes') {

          var params = {
            account_email: this.dmail,
            new_diagnosis: [result1],
            doctor_id: this.doc_id,
          }

          this.appService.postData(this.urlPoints.newDiag, params, this.token).subscribe((response: any) => {

            var params2 = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: result1,
              doctor_id: this.doc_id
            }

            this.getCC1(this.urlPoints.getDiag, params2, this.token);

          }
          );
        }
        else {
        }
      }
    });
  }

  getCC1(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        var res_arr = []


        res_arr = response.data.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());

        console.log(res_arr)

        if (res_arr.length > 0) {

          if (this.provisional) {
            res_arr[0].name = '?' + res_arr[0].name
          }

          this.provisional = false;

          this.cc_selected.push(res_arr[0])
        }



      }
    });


  }

  setBlock(i) {
    this.block = i

    if (this.block == 1) {
      this.cc_page = 1
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      if (this.chars != '') {
        this.getCC(this.urlPoints.getDiag, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
    }

    else {
      this.cc_page = 1

      var params1 = {
        account_email: this.dmail,
        page_no: 1,
        symptoms_id: this.id_string.toString(),
        doctor_id: this.doc_id

      }

      this.getCC(this.urlPoints.getDiag, params1, this.token)

      if (this.id_string == '') {
        this.cc_show = []
      }

    }
  }

  search1(e) {

    this.block = 1

    this.chars = e.target.value

    this.cc_page = 1
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars.toUpperCase().trim(),
      doctor_id: this.doc_id
    }

    if (this.chars != '') {
      this.getCC(this.urlPoints.getDiag, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)

  }

  keyboard(alphabet) {


    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars = this.chars + alphabet;
    }
    else {
      this.chars = this.chars.slice(0, -1)
    }

    this.search = this.chars

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }
    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getDiag, params, this.token);
    this.cc_data = [];
    this.cc_page = 1;

  }

  mouseup() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }

    if (this.held) {
      this.held = false

      if (!this.muted) {

        this.muted = true
        this.service.stop()
      }
    }
  }

  mousedown() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;

      this.held = true

      if (this.muted) {
        //  alert()
        this.muted = false
        this.service.start()
      }
    }, 1000);
  }

  clear() {
    this.search = ''

    this.chars = ''

    this.getCCCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)

  }

  ngDoCheck() {
    const change = this.differ.diff(this.service);
    if (change) {
      var that = this;
      change.forEachChangedItem(item => {
        if (item.key == 'length') {
          if (this.supported)
            this.navigate()
        }
      });
    }
  }

  navigate() {
    this.chars = this.search = this.service.textArray[this.service.textArray.length - 1]

    this.add = false;
    this.chars_copy = this.chars;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id,
    }

    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getDiag, params, this.token, 'voice');
    this.cc_data = [];
    this.cc_page = 1;
  }

  toggleMute() {
    this.muted = !this.muted

    if (this.muted) {
      this.stopService()
    }
    else {
      this.startService()
    }
  }

  startService() {

    console.log('here')

    console.log(this.supported)

    if (this.supported)
      this.service.start()

  }

  stopService() {

    if (this.supported)
      this.service.stop()

  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    this.osName = os

    return os;
  }

  addCC(index) {

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].diagnosis_id == this.cc_show[index].diagnosis_id) {
        var exists = true
      }
    }

    if (!exists) {

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_show[index].name,
          reference_word: this.chars_copy,
          word_type: 3,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_show[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      if (this.provisional) {
        this.cc_show[index].name = '?' + this.cc_show[index].name
      }

      this.cc_selected = this.cc_selected.concat(this.cc_show[index])

      this.cc_show.splice(index, 1);

      this.provisional = false

      if (this.chars != '') {
        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: this.chars.toUpperCase().trim(),
          doctor_id: this.doc_id
        }

        this.getCC(this.urlPoints.getDiag, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)

    }

    else {
      this.toastr.error(this.cc_show[index].name + ' has been already added!')

    }

  }

  addCC1(index) {

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].diagnosis_id == this.cc_all[index].diagnosis_id) {
        var exists = true
      }
    }

    if (!exists) {


      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_all[index].name,
          reference_word: this.chars_copy,
          word_type: 3,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_all[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }
      var obj = Object.assign({}, this.cc_all[index]);

      if (this.provisional) {
        obj.name = '?' + obj.name
      }

      this.provisional = false;

      this.cc_selected = this.cc_selected.concat(obj)
    }
    else {
      this.toastr.error(this.cc_all[index].name + ' has been already added!')

    }

  }

  remove(index) {
    this.cc_data = []

    this.cc_selected.splice(index, 1);

    if (this.chars != '') {
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getCC(this.urlPoints.getDiag, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getDiagCounter, this.counter_params, this.token)

  }

  save() {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close(this.cc_selected)
  }

  onScroll() {

    var token = this.token;
    this.cc_page++;

    var params = {
      account_email: this.dmail,
      page_no: this.cc_page,
      alphabet: this.chars.toUpperCase(),
      doctor_id: this.doc_id
    }

    this.getCC(this.urlPoints.getDiag, params, token)

  }

  onNoClick(): void {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close(this.cc_selected)
  }

  close() {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close();

  }

  getCCCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.chief_complaints = response.details;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].diagnosis_id == this.cc_selected[k].diagnosis_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_show.splice(matchedArray[i], 1);
        }

      }
    });
  }

  getCC(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;

        if (this.cc_page > 1)
          this.cc_data = this.cc_data.concat(response.data)
        else
          this.cc_data = response.data

        this.chief_complaints = this.cc_data;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].diagnosis_id == this.cc_selected[k].diagnosis_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.cc_show.splice(matchedArray[i], 1);
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 3,
          reference_word: this.chars.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {
          console.log(response)
          this.cc_show = this.cc_show.concat(response.data)
        });


        if (this.add == false && voice && this.cc_show.length == 0) {
          this.add = true
          this.chars_copy = this.chars
          console.log('here')
        }

      }
    });
  }
}

@Component({
  selector: 'investigation',
  templateUrl: 'investigation.html',
  styleUrls: ['investigation.scss']

})

export class Dialog_investigation {

  provisional = false;
  counter_params;
  doc_id;
  dmail;
  chief_complaints = [];
  cc_selected = [];
  cc_show = [];
  urlPoints;
  token;
  search = ''
  chars = '';
  cc_page;
  cc_data = []
  cc_pages;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  isFullListDisplayed: boolean = false;

  cc_all = [];
  block = 1
  nisVersion = nisPackage.dependencies["ngx-infinite-scroll"];
  id_string;
  cc_all_page = 1;

  showKB = false;
  speech: any;
  speechData: any;
  alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Space', 'Backspace']
  supported;
  osName;

  differ: KeyValueDiffer<string, any>;
  muted = true
  timeoutHandler;
  held = false;
  add = false
  chars_copy = '';
  record = false

  constructor(
    public dialogRef: MatDialogRef<Dialog_chiefComplaints>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, private differs: KeyValueDiffers, public service: VoiceRecognitionService) {
    this.doc_id = this.data.doc_id
    this.dmail = this.data.dmail;
    this.urlPoints = AppConfig.settings.EndPoints;
    this.token = this.data.token

    this.differ = this.differs.find({}).create();
    this.speech = new Speech()

    if (this.speech.hasBrowserSupport()) {
      this.speech.init({
        'volume': 1,
        'lang': 'en-GB',
        'rate': 1,
        'pitch': 1,
        'voice': 'Google UK English Male',
        'splitSentences': true,
        'listeners': {
          'onvoiceschanged': (voices) => {
          }
        }
      }).then((data) => {
        this.speechData = data;
        data.voices.forEach(voice => {
        });
      }).catch(e => {
      })
    }

    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      if (this.getOS() != 'iOS' && this.getOS() != "Mac OS") {
        this.service.init();
        this.supported = true
      }
      else {
        this.supported = false
      }

    } else {
      this.supported = false
    }

    dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.dialogRef.close(this.cc_selected)

    })
  }
  ngOnInit(): void {

    this.cc_selected = Object.assign([], this.data.selected);

    var ids = []

    console.log(this.data.diag_selected)

    for (var i = 0; i < this.data.diag_selected.length; i++) {
      ids.push(this.data.diag_selected[i].diagnosis_id)
    }

    this.id_string = ids.join(',')

    var all_params = {
      account_email: this.data.dmail,
      doctor_id: this.doc_id,
      page_no: 1,
      limit: 50
    }

    this.appService.getData(this.urlPoints.getAllInvestigations, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = response.data

      this.cc_all = this.cc_all.filter(i => i.name.toLowerCase() != '');

    });


    this.counter_params = {
      doctor_id: this.doc_id,
      account_email: this.dmail
    }

    this.getCCCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
  }

  changeProv() {
    this.provisional = !this.provisional
  }

  openKeyboard() {
    this.showKB = !this.showKB
  }

  search1(e) {

    this.block = 1

    this.chars = e.target.value

    this.cc_page = 1
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars.toUpperCase().trim(),
      doctor_id: this.doc_id
    }

    if (this.chars != '') {
      this.getCC(this.urlPoints.getInv, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)

  }

  keyboard(alphabet) {


    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars = this.chars + alphabet;
    }
    else {
      this.chars = this.chars.slice(0, -1)
    }

    this.search = this.chars

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }
    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getInv, params, this.token);
    this.cc_data = [];
    this.cc_page = 1;

  }

  clear() {
    this.search = ''

    this.chars = ''

    this.getCCCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)

  }

  mouseup() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }

    if (this.held) {
      this.held = false

      if (!this.muted) {

        this.muted = true
        this.service.stop()
      }
    }
  }

  mousedown() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;

      this.held = true

      if (this.muted) {
        //  alert()
        this.muted = false
        this.service.start()
      }
    }, 1000);
  }

  ngDoCheck() {
    const change = this.differ.diff(this.service);
    if (change) {
      var that = this;
      change.forEachChangedItem(item => {
        if (item.key == 'length') {
          if (this.supported)
            this.navigate()
        }
      });
    }
  }

  navigate() {
    this.chars = this.search = this.service.textArray[this.service.textArray.length - 1]

    this.add = false;
    this.chars_copy = this.chars;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }

    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getInv, params, this.token, 'voice');
    this.cc_data = [];
    this.cc_page = 1;
  }

  toggleMute() {
    this.muted = !this.muted

    if (this.muted) {
      this.stopService()
    }
    else {
      this.startService()
    }
  }

  startService() {

    console.log('here')

    console.log(this.supported)

    if (this.supported)
      this.service.start()

  }

  stopService() {

    if (this.supported)
      this.service.stop()

  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    this.osName = os

    return os;
  }

  new_cc() {
    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'inv',
        text: 'Enter new investigation'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //  alert(result)

        if (result.record == false) {

          if (this.provisional) {
            result.name = '?' + result.name
          }

          this.provisional = false;

          // this.cc_selected.push(result)
          this.cc_selected.push(
            {
              name: result.name,
              investigation_id: 123
            }
          )
          return;
        }

        var res_arr = []

        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: result.name,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getInv, params, this.token).subscribe((response: any) => {
          console.log(response.data)

          res_arr = response.data.filter(i => i.name.toLowerCase() != '');

          console.log(res_arr)

          if (res_arr.length > 0) {
            this.toastr.error(result.name + " already exists")
          }
          else {
            this.save_cc(result.name)
          }


        });

      }
    });
  }

  save_cc(result1) {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
      width: '600px', disableClose: true,
      data: { name: 'Add ' + result1 + ' to Investigations?', type: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result == 'yes') {

          var params = {
            account_email: this.dmail,
            new_investigation: [result1],
            doctor_id: this.doc_id,
          }

          this.appService.postData(this.urlPoints.newInv, params, this.token).subscribe((response: any) => {

            var params2 = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: result1,
              doctor_id: this.doc_id
            }

            this.getCC1(this.urlPoints.getInv, params2, this.token);

          }
          );
        }
        else {
        }
      }
    });
  }

  getCC1(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        var res_arr = []


        res_arr = response.data.filter(i => i.name.toLowerCase() == params.alphabet.toLowerCase());

        console.log(res_arr)

        if (res_arr.length > 0) {

          if (this.provisional) {
            res_arr[0].name = '?' + res_arr[0].name
          }

          this.provisional = false;

          this.cc_selected.push(res_arr[0])
        }



      }
    });


  }

  addCC(index) {

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].investigation_id == this.cc_show[index].investigation_id) {
        var exists = true
      }
    }

    if (!exists) {

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_show[index].name,
          reference_word: this.chars_copy,
          word_type: 4,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_show[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      if (this.provisional) {
        this.cc_show[index].name = '?' + this.cc_show[index].name
      }

      this.cc_selected = this.cc_selected.concat(this.cc_show[index])

      this.cc_show.splice(index, 1);

      this.provisional = false

      if (this.chars != '') {
        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: this.chars.toUpperCase().trim(),
          doctor_id: this.doc_id
        }

        this.getCC(this.urlPoints.getInv, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
    }

    else {
      this.toastr.error(this.cc_show[index].name + ' has been already added!')

    }

  }

  addCC1(index) {

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].investigation_id == this.cc_all[index].investigation_id) {
        var exists = true
      }
    }

    if (!exists) {
      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_all[index].name,
          reference_word: this.chars_copy,
          word_type: 4,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_all[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      var obj = Object.assign({}, this.cc_all[index]);

      if (this.provisional) {
        obj.name = '?' + obj.name
      }

      this.provisional = false;

      this.cc_selected = this.cc_selected.concat(obj)
    }
    else {
      this.toastr.error(this.cc_all[index].name + ' has been already added!')

    }

  }

  onScroll2() {
    //  alert('here')
    this.cc_all_page++;

    var all_params = {
      account_email: this.data.dmail,
      doctor_id: this.doc_id,
      page_no: this.cc_all_page,
      limit: 50
    }

    this.appService.getData(this.urlPoints.getAllInvestigations, all_params, this.data.token).subscribe((response: any) => {
      this.cc_all = this.cc_all.concat(response.data)

    });
  }

  setBlock(i) {
    this.block = i

    if (this.block == 1) {
      this.cc_page = 1
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      if (this.chars != '') {
        this.getCC(this.urlPoints.getInv, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)
    }

    else {
      this.cc_page = 1

      var params1 = {
        account_email: this.dmail,
        page_no: 1,
        diagnosis_id: this.id_string.toString(),
        doctor_id: this.doc_id

      }

      this.getCC(this.urlPoints.getInv, params1, this.token)

      if (this.id_string == '') {
        this.cc_show = []
      }
    }
  }


  remove(index) {
    this.cc_data = []

    this.cc_selected.splice(index, 1);

    if (this.chars != '') {
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getCC(this.urlPoints.getInv, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getInvCounter, this.counter_params, this.token)

  }

  save() {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close(this.cc_selected)
  }

  onScroll() {

    var token = this.token;
    this.cc_page++;

    var params = {
      account_email: this.dmail,
      page_no: this.cc_page,
      alphabet: this.chars.toUpperCase(),
      doctor_id: this.doc_id
    }

    this.getCC(this.urlPoints.getInv, params, token)

  }

  onNoClick(): void {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close(this.cc_selected)
  }

  close() {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close();

  }

  getCCCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.chief_complaints = response.details;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].investigation_id == this.cc_selected[k].investigation_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_show.splice(matchedArray[i], 1);
        }

      }
    });
  }

  getCC(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;

        if (this.cc_page > 1)
          this.cc_data = this.cc_data.concat(response.data)
        else
          this.cc_data = response.data

        this.chief_complaints = this.cc_data;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].investigation_id == this.cc_selected[k].investigation_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.cc_show.splice(matchedArray[i], 1);
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 4,
          reference_word: this.chars.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {
          console.log(response)
          this.cc_show = this.cc_show.concat(response.data)
        });


        if (this.add == false && voice && this.cc_show.length == 0) {
          this.add = true
          this.chars_copy = this.chars
          console.log('here')
        }


      }
    });
  }
}

@Component({
  selector: 'prescription',
  templateUrl: 'prescription.html',
  styleUrls: ['prescription.scss']

})

export class Dialog_prescription {
  prescriptions=[]
  provisional = false;
  counter_params;
  doc_id;
  dmail;
  prescription_mode;
  chief_complaints = [];
  cc_selected = [];
  cc_show = [];
  urlPoints;
  token;
  search = ''
  search_drug='';
  openSearchOptionPanel: boolean = false;
  chars = '';
  cc_page;
  cc_data = []
  cc_pages;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  isFullListDisplayed: boolean = false;
  cc_all = [];
  id_string;
  block = 1
  nisVersion = nisPackage.dependencies["ngx-infinite-scroll"];

  cc_all_page = 1;

  showKB = false;
  speech: any;
  speechData: any;
  alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Space', 'Backspace']
  supported;
  osName;

  differ: KeyValueDiffer<string, any>;
  muted = true
  drugShowType = 1;
  displayTotal = true;
  durationAlone = false
  fullFreq = true;
  showUnits = false;
  getDrugName;
  medication;
  pres_count = 0;
  getfrontdesk_pay;
  getList;
  timeoutHandler;
  held = false
  add = false
  chars_copy = '';
  dropdownData:string[]=[];
  filteredOptions: any[];
  localStore=[];
  storedData=[];
  localDrugArr=[];
  searchResult=false;
  filteredDrugArr=[];
  inputSearch;
  pageNumber = 1;
  loading=false;
  openSearchOption=false;
  formGp: FormGroup;
  // cartItems= [];
  storedDataDetails: { name: any; id: any; mode: number; obj: any; text: string; pres_selected: any[]; age: any; weight: any; token: any; dmail: any; doc_id: any; };
  getStockStatus: any;
  selectedOption: string;
  selectedDrag;
  eshop_enabled;
  getPatientEmail;
  getIndexDrug;
  getSelectedDrugIndex;
  cc_all_check=false;
  searchText;
  constructor(
    public dialogRef: MatDialogRef<Dialog_chiefComplaints>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, private differs: KeyValueDiffers, public service: VoiceRecognitionService) {
    this.doc_id = this.data.doc_id
    this.dmail = this.data.dmail;
    this.filteredOptions = this.dropdownData;
    this.urlPoints = AppConfig.settings.EndPoints;
    this.token = this.data.token

    this.differ = this.differs.find({}).create();
    this.speech = new Speech()

    this.drugShowType = this.data.drugShowType;
    this.displayTotal = this.data.displayTotal;
    this.durationAlone = this.data.durationAlone;
    this.fullFreq = this.data.fullFreq;
    this.showUnits = this.data.showUnits;
this.formGp = this.fb.group({
  selectedOption: [''],
})
this.formGp.controls.selectedOption.valueChanges.subscribe(selectedValue => {
  console.log('Selected value:', selectedValue);
  this.selectedOption = selectedValue;
  // You can perform any desired actions with the selected value here
});

    //  alert(this.data.age)
    //  alert(this.data.weight)

    if (this.speech.hasBrowserSupport()) {
      this.speech.init({
        'volume': 1,
        'lang': 'en-GB',
        'rate': 1,
        'pitch': 1,
        'voice': 'Google UK English Male',
        'splitSentences': true,
        'listeners': {
          'onvoiceschanged': (voices) => {
          }
        }
      }).then((data) => {
        this.speechData = data;
        data.voices.forEach(voice => {
        });
      }).catch(e => {
      })
    }

    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      if (this.getOS() != 'iOS' && this.getOS() != "Mac OS") {
        this.service.init();
        this.supported = true
      }
      else {
        this.supported = false
      }

    } else {
      this.supported = false
    }

    dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.save()
    })
  }
  ngOnInit(): void {
    var PaymentModeParams={
      account_email : this.dmail,
      doctor_id : this.doc_id
  }
  this.eshop_enabled = sessionStorage.getItem('E-shop');
  console.log('this.eshop_enabled::',this.eshop_enabled)
  this.appService.getData(this.urlPoints.getMasterSettings, PaymentModeParams, this.token).subscribe((masterData: any) =>{
    this.getfrontdesk_pay = masterData.data[0].epharmacy_frontdesk_payment;
  })
this.callMasterSettings();
    this.cc_selected = Object.assign([], this.data.selected);

    var ids = []

    console.log(this.data.diag_selected)

    for (var i = 0; i < this.data.diag_selected.length; i++) {
      ids.push(this.data.diag_selected[i].diagnosis_id)
    }

    this.id_string = ids.join(',')

    var all_params = {
      account_email: this.data.dmail,
      page_no: 1,
      limit: 50,
      doctor_id : this.doc_id
    }

    this.appService.getData(this.urlPoints.getAllDrugs, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = response.data

      this.cc_all = this.cc_all.filter(i => i.name.toLowerCase() != '');

    });


    this.counter_params = {
      doctor_id: this.doc_id,
      account_email: this.dmail
    }

    this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

    var getSettings = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }
    this.appService.getData(this.urlPoints.getDrugSettings, getSettings, this.token).subscribe((response: any) => {

      if (response.data[0].category_id) {
        this.drugShowType = response.data[0].category_id
      }
      else {
        var params_type = {
          account_email: this.dmail,
          category_id: "1",
          category_name: "drug",
          doctor_id: this.doc_id
        }

        this.appService.postData(this.urlPoints.drugSettings, params_type, this.token).subscribe((response: any) => {

        });
      }
    });
  }




// loadMoreEvent(event:MouseEvent) {
//   event.preventDefault();
//   event.stopPropagation();
//   this.pageNumber += 1;
//     this.fetchDropdownData();
//   }

  extractTextAndNumbers(inputString){
    const matches = inputString.match(/(\D+)(\d+)/);
    var lastIdPart;
    var drugName;
    var drugId;
    if(matches){

      lastIdPart = matches.pop();
      drugName = matches.join(' ');
      drugId = parseInt(lastIdPart) || null;
    }
    return null
  }
onDropdownChange(e:any){
  var getIdFromUi = [];
  var drugId; 
  var drugName; 
  this.selectedOption = e.currentTarget.firstElementChild.innerText;
  getIdFromUi.push(this.selectedOption);

  var splitIdArr = getIdFromUi.map((inputString) => {
    const matches = inputString.match(/^(.*?)(\d+)$/);
    if (matches) {
      const [, namePart, numberPart] = matches;
      const formattedName = namePart.trim();
      const number = parseInt(numberPart) || null;
      return { drugName: formattedName, drugId: number };
    }
    return null;
  });
console.log("splitIdArr::",splitIdArr);


//  var splitIdArr= this.extractTextAndNumbers(this.selectedOption);


// var splitIdArr = getIdFromUi.map((e)=>{
//   var parts = e.split(' ');
//   var lastIdPart = parts.pop();
//   drugName = parts.join(' ');
//   drugId = parseInt(lastIdPart) || null;
//   return { drugName: drugName, drugId: drugId };
// })
if(this.selectedOption == "Load More"){
  e.returnValue = false
  event.preventDefault();
  event.stopPropagation();
  this.pageNumber += 1;
    this.fetchDropdownData();
    // this.cdr.detectChanges();
}

else{
  var drugId_=splitIdArr[0].drugId;
 var drugName_ =splitIdArr[0].drugName;
 var iterationNumber = 0;
  for (const innerArray of this.storedData) {
    iterationNumber++;
     const matchingObjects = innerArray.filter(obj =>obj.id === drugId_)
  if(matchingObjects){
    if (iterationNumber==1) {
      iterationNumber++;
    for (const e of matchingObjects) {
      var alertMsg = "Do you want to proceed with configuring the selected drug product ";
      var dialogRef = this.dialog.open(DialogOverviewExampleDialog_alertConfirmMessage, {
        width: '600px',
        data: { name: alertMsg, dropDownAlert: true, product: drugName_ }
      });
  
      dialogRef.afterClosed().subscribe(results => {
        if (results) {
          var params = {
            account_email: this.dmail,
            eceshop_product_name: e.name,
            drug_id: this.selectedDrag && this.selectedDrag.drug_id ? this.selectedDrag.drug_id : null,
            medicine_id: this.selectedDrag.id,
            brand: this.selectedDrag.name,
            eceshop_product_id: e.id,
            drug_name: this.selectedDrag.name
          };
  
          this.appService.postData(this.urlPoints.createEshopProduct, params, this.token).subscribe((response: any) => {
            console.log("responseE-shop", response);
            if (response) {
              var params1 = {
                drug_id: this.selectedDrag.id,
                account_email: this.dmail
              };
  
              this.appService.getData(this.urlPoints.checkDrugStatus, params1, this.token).subscribe((res: any) => {
                this.callBackDialogFun(res, this.getSelectedDrugIndex, this.getSelectedDrugIndex);
              });
            }
          });
        } else {
          console.log("entered else contions")
        }
      });
    }
  }
  }
}
}
this.openSearchOptionPanel = false;
}
  fetchDropdownData() {

    // var params = {
    //   page_number: this.pageNumber.toString(),
    //   account_email: this.dmail
    // };
  
    // this.appService.getData(this.urlPoints.getEshopDrugsVendor, params, this.token).subscribe((response: any) => {
      
    //   if (response.success === 1) {
    //     this.storedData.push(response.products)
        //      response.products.forEach((e: any) => {
        //   this.dropdownData.push({
        //     product_name:e.product_name,
        //     product_id:e.product_id
        //   });
        // });
      //   const newDropdownItems = response.products.map((e) => ({
      //     product_name: e.product_name,
      //     product_id: e.product_id
      // }));
      // this.dropdownData = this.dropdownData.concat(newDropdownItems);
      // }
    // });
  }
  changeProv() {
    this.provisional = !this.provisional
  }

  openIcons() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_icons, {
      width: '600px',
      data: {}
    });
  }

  mouseup() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }

    if (this.held) {
      this.held = false

      if (!this.muted) {

        this.muted = true
        this.service.stop()
      }
    }
  }

  mousedown() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;

      this.held = true

      if (this.muted) {
        //  alert()
        this.muted = false
        this.service.start()
      }
    }, 1000);
  }

  openKeyboard() {
    this.showKB = !this.showKB
  }

  searchDrug(e) {
    this.searchResult = true;
    this.filteredDrugArr = [];
    this.localDrugArr=[];
    this.storedData=[];
    this.chars = e && e.target &&e.target.value ? e.target.value : e.option.value;
    this.inputSearch = this.chars.toLowerCase()
    var params = {
      account_email: this.dmail,
      page_no: this.pageNumber,
      product_name: this.chars
    }
      this.appService.getData(this.urlPoints.searcheEshopProducts, params, this.token).subscribe((response: any)=>{
        this.storedData.push(response.message);
        const localMapFun= response.message.map(e=>e);
          this.localDrugArr = localMapFun.map((e)=>({
            name__ : e.name,
            id__ : e.id
          }))
      })
      // this.localDrugArr.forEach((e)=>{
      //   if(e.name__.substr(0,this.inputSearch.length).toLowerCase() == this.inputSearch){
      //     this.filteredDrugArr.push(e)
      //   }
      // })
      this.search_drug = '';
    }

  search1(e) {

    this.block = 1

    this.chars = e.target.value

    this.cc_page = 1
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars.toUpperCase().trim(),
      doctor_id: this.doc_id
    }

    if (this.chars != '') {
      this.getCC(this.urlPoints.getPres, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

  }

  keyboard(alphabet) {


    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars = this.chars + alphabet;
    }
    else {
      this.chars = this.chars.slice(0, -1)
    }

    this.search = this.chars

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }
    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getPres, params, this.token);
    this.cc_data = [];
    this.cc_page = 1;

  }

  clear() {
    this.search = ''

    this.chars = ''

    this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

  }

  ngDoCheck() {
    const change = this.differ.diff(this.service);
    if (change) {
      var that = this;
      change.forEachChangedItem(item => {
        if (item.key == 'length') {
          if (this.supported)
            this.navigate()
        }
      });
    }
  }

  navigate() {
    this.chars = this.search = this.service.textArray[this.service.textArray.length - 1]

    this.add = false;
    this.chars_copy = this.chars;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }

    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getPres, params, this.token, 'voice');
    this.cc_data = [];
    this.cc_page = 1;
  }

  toggleMute() {
    this.muted = !this.muted

    if (this.muted) {
      this.stopService()
    }
    else {
      this.startService()
    }
  }

  startService() {

    console.log('here')

    console.log(this.supported)

    if (this.supported)
      this.service.start()

  }

  stopService() {

    if (this.supported)
      this.service.stop()

  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    this.osName = os

    return os;
  }
  callBackDialogFun(response,index1,index){

     this.getStockStatus= this.eshop_enabled == 'true' && response.message.stock_status;
    const ccSource = this.cc_all_check ? this.cc_all : this.cc_show;
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: 'fit-content',
      data: {
        host: ccSource[index],
        getStockStatus: this.getStockStatus,
        name: ccSource[index].name,
        id: ccSource[index].id,
        mode: 0,
        obj: ccSource[index],
        text: this.getStockStatus,
        pres_selected: this.cc_selected,
        age: this.data.age,
        weight: this.data.weight,
        token: this.token,
        dmail: this.data.dmail,
        doc_id: this.data.doc_id
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.cc_selected.map(e => e.id).includes(result.id)) {
        this.eshop_enabled == 'true' && response.success === 1 && this.getStockStatus =='instock'&& this.appService.addToCartItems([response.message]);
        // this.appService.addToCartItems([response.message]);
        // this.appService.addToCartItems([result]);

var params = {
medicine_id: this.cc_all_check ? this.cc_all[index1].medicine_id : this.chief_complaints[index1].medicine_id,
product_id: result.id,
account_email: this.dmail,
doctor_id: this.doc_id

}
          this.appService.getData(this.urlPoints.getDoctorProfile, params, this.token).subscribe((response: any) => {
          });
          var params3;

          params3 = {
            doctor_id: this.doc_id,
            actual_word: ccSource[index].name,
            reference_word: this.chars_copy,
            word_type: 6,
            account_email: this.dmail,
            doctor_email: this.dmail,
            patient_email: this.getPatientEmail.email,
          }
          this.appService.postData(this.urlPoints.createCustomer, params3, this.token).subscribe((response: any) => response);
       

        if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

          if (result.when == 'After Food') {
            result.when = 'AF'
          }

          if (result.when == 'Before Food') {
            result.when = 'BF'
          }

          if (result.when == 'Not Related to Food') {
            result.when = 'NRF'
          }

          if (result.when == 'With Food') {
            result.when = 'WF'
          }
        }

        if (result.create) {


          var detailParams = {
            account_email: this.dmail,
            doctor_id: this.doc_id,
            update: 0,
            drug:
            {
              drug_id: result.id,
              formulation: result.formulation,
              name:result.brand
            }
          }

          this.appService.postData(this.urlPoints.updateMedicines, detailParams, this.token).subscribe((response: any) => {

            if (response.data.id)
              result.id = response.data.id

            this.medication = result;

            console.log(this.medication)

            this.pres_count++;

            this.medication.pres_id = this.pres_count;

            var unit = this.medication.quantity.split(' ')[1]

            var freq_arr = this.medication.frequency.split('-')

            if (freq_arr.length == 4) {
              var morning = freq_arr[0].trim().split(' ')[0]

              var afternoon = freq_arr[1].trim().split(' ')[0]

              var evening = freq_arr[2].trim().split(' ')[0]

              var night = freq_arr[3].trim().split(' ')[0]

              if (this.showUnits) {
                var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }


                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }

                if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                  var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }
                }

              }
              else {
                var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                var shortFreq = freq

              }
              this.medication.frequency = freq
              this.medication.shortFreq = shortFreq


            }
            else {
              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }

              if (this.showUnits) {
                var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()


                this.medication.frequency = freq1 + ' ' + unit

                this.medication.shortFreq = freq1 + ' ' + shortUnit
              }
              else {
                var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                this.medication.shortFreq = freq1

              }


            }


            this.cc_selected.push(result)

            console.log(this.cc_selected)

          });
        }
        else {
          var detailParams = {
            account_email: this.dmail,
            doctor_id: this.doc_id,
            update: 1,
            drug:
            {
              drug_id: result.id,
              formulation: result.formulation,
              name:result.brand
            }
          }

          this.appService.postData(this.urlPoints.updateMedicines, detailParams, this.token).subscribe((response: any) => {
            this.medication = result;

            console.log(this.medication)

            this.pres_count++;

            this.medication.pres_id = this.pres_count;

            var unit = this.medication.quantity.split(' ')[1]

            var freq_arr = this.medication.frequency.split('-')

            if (freq_arr.length == 4) {
              var morning = freq_arr[0].trim().split(' ')[0]

              var afternoon = freq_arr[1].trim().split(' ')[0]

              var evening = freq_arr[2].trim().split(' ')[0]

              var night = freq_arr[3].trim().split(' ')[0]

              if (this.showUnits) {
                var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }


                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }

                if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                  var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }
                }

              }
              else {
                var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                var shortFreq = freq

              }
              this.medication.frequency = freq
              this.medication.shortFreq = shortFreq


            }
            else {
              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }

              if (this.showUnits) {
                var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()


                this.medication.frequency = freq1 + ' ' + unit

                this.medication.shortFreq = freq1 + ' ' + shortUnit
              }
              else {
                var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                this.medication.shortFreq = freq1

              }


            }

            this.eshop_enabled == 'true' && this.getStockStatus && this.cc_selected.push(result)

            console.log(this.cc_selected)

          });
        }

        this.eshop_enabled == 'false' && this.cc_selected.push(result)
        console.log(this.cc_selected)

      }else{
        this.toastr.error(result.brand + ' has been already added!')
      }
    }
    });
 }





  addCC(index) {
var updateResp;
this.getSelectedDrugIndex = index;
    if(false){      
var index1 = this.chief_complaints.indexOf(this.cc_show[index])
this.getPatientEmail = JSON.parse(window.sessionStorage.getItem('patientprofile'));
var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].id == this.cc_show[index].id) {
        var exists = true
      }
    }

    if (!exists) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        width: 'fit-content',

        data: {  name: this.cc_show[index].name, id: this.cc_show[index].id, mode: 0, obj: this.cc_show[index], text: '', pres_selected: this.cc_selected, age: this.data.age, weight: this.data.weight, token: this.token, dmail: this.data.dmail, doc_id: this.data.doc_id }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {

var params = {
  medicine_id: this.chief_complaints[index1].medicine_id,
  product_id: result.id,
  account_email: this.dmail,
  doctor_id: this.doc_id

}
          if (!this.add) {
            var eshop_product_id;
            var params = {
              medicine_id: this.chief_complaints[index1].medicine_id,
              product_id: result.id,
              account_email: this.dmail,
              doctor_id: this.doc_id
            
            }
            this.appService.getData(this.urlPoints.getDoctorProfile, params, this.token).subscribe((response: any) => {
            });
            var params3;

            params3 = {
              doctor_id: this.doc_id,
              actual_word: this.cc_show[index].name,
              reference_word: this.chars_copy,
              word_type: 6,
              account_email: this.dmail,
              doctor_email: this.dmail,
              patient_email: this.getPatientEmail.email,
              // patient_email: this.patient.record_info.Record.account_email
            }
          this.appService.postData(this.urlPoints.createCustomer, params3, this.token).subscribe((response: any) => {
              var prodParams = {
                account_email: this.dmail,
                medicine_id: this.chief_complaints[index1].medicine_id,
                medicine_name: this.chief_complaints[index1].name
              }
              this.appService.getData(this.urlPoints.getDocProduct, prodParams, this.token).subscribe((response: any) => {
                var drugs=[];
                drugs =response.products
                const dialogRef = this.dialog.open(DialogOverviewExampleDialog_cartdrugs, {
                  width: '600px', disableClose: true,
                  data: {drugs: drugs}
                });
                dialogRef.afterClosed().subscribe(results => {
                  eshop_product_id = results.id;
                  if (results) {
                    this.getDrugName = results.name;
                    var shopDrugParam ={
                      eshop_product_id:results.id,
                      drug_id:this.medication.id,
                      account_email: this.dmail
                    }
              this.appService.getData(this.urlPoints.checkeShopDrug, shopDrugParam,this.token).subscribe((res:any)=>{
                 var mapedMsg = res.message;
                 if(mapedMsg != 'product not mapped'){
                  return this.appService.addToCartItems([results]);
                }
                 if(res.message == "product not mapped"){
                  var updateParam ={
                    eshop_product_id:eshop_product_id,
                      drug_id:this.medication.id,
                      account_email: this.dmail
                  }

                  const dialogRef = this.dialog.open(DialogOverviewExampleDialog_configDrugPopup, {
                    width: '600px',
                    data: {name:this.getDrugName}
                  });
                  dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                      this.appService.postData(this.urlPoints.updateEshopDrug,updateParam,this.token).subscribe((res:any)=>{
                        updateResp = res.message;
                       if(res.success ==1){
                         return this.appService.addToCartItems([results]);
                       }else{
                        if(updateResp == 'drug id not exist '){
                          this.openSearchOption = true;
                          var alertMsg ="Drug and e-Shop product not mapped please configure."
                          this.dialog.open(DialogOverviewExampleDialog_alertMessage, {
                            width: '600px',
                            data: {name:alertMsg}
                          });
                        }else{
                          var alertMsg = "This product is not approved by doctor."
                          this.dialog.open(DialogOverviewExampleDialog_alertMessage, {
                            width: '600px',
                            data: {name:alertMsg}
                          });
                        }
                         this.cc_selected.splice(-1);
                       }
                     })
                    }
                    else {
                         this.cc_selected.splice(-1);
                    }
                  });
                 }
              });
                    var params = {
                      medicine_id: this.chief_complaints[index1].medicine_id,
                      product_id: result.id,
                      account_email: this.dmail
                    }
                    
                    if (result == 'yes') {
                      this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                        this.add = false
                      });
                    }
                    else {
                      this.add = false
                    }
                  
                    
                  }
                });
              })
        
            })

          }

          if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

            if (result.when == 'After Food') {
              result.when = 'AF'
            }

            if (result.when == 'Before Food') {
              result.when = 'BF'
            }

            if (result.when == 'Not Related to Food') {
              result.when = 'NRF'
            }

            if (result.when == 'With Food') {
              result.when = 'WF'
            }
          }

          if (result.create) {


            var detailParams = {
              account_email: this.dmail,
              doctor_id: this.doc_id,
              update: 0,
              drug:
              {
                drug_id: result.id,
                formulation: result.formulation,
                name:result.brand
              }
            }

            this.appService.postData(this.urlPoints.updateMedicines, detailParams, this.token).subscribe((response: any) => {

              if (response.data.id)
                result.id = response.data.id

              this.medication = result;

              console.log(this.medication)

              this.pres_count++;

              this.medication.pres_id = this.pres_count;

              var unit = this.medication.quantity.split(' ')[1]

              var freq_arr = this.medication.frequency.split('-')

              if (freq_arr.length == 4) {
                var morning = freq_arr[0].trim().split(' ')[0]

                var afternoon = freq_arr[1].trim().split(' ')[0]

                var evening = freq_arr[2].trim().split(' ')[0]

                var night = freq_arr[3].trim().split(' ')[0]

                if (this.showUnits) {
                  var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                  var shortUnit = ''

                  if (unit == 'milliliter') {
                    shortUnit = 'ml'
                  }

                  else if (unit == 'Tablet') {
                    shortUnit = 'Tablet'
                  }

                  else if (unit == 'microgram') {
                    shortUnit = 'mcg'
                  }

                  else if (unit == 'milligram') {
                    shortUnit = 'mg'
                  }

                  else if (unit == 'gram') {
                    shortUnit = 'grm'
                  }


                  else if (unit == 'drops') {
                    shortUnit = 'drops'
                  }

                  else if (unit == 'Sachets/Packets') {
                    shortUnit = 'pkt'
                  }


                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }

                  if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                    var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                    var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                    if (unit == 'mole' || unit == 'millimole') {
                      var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                      freq = shortFreq
                    }
                  }

                }
                else {
                  var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                  var shortFreq = freq

                }
                this.medication.frequency = freq
                this.medication.shortFreq = shortFreq


              }
              else {
                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }

                if (this.showUnits) {
                  var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()


                  this.medication.frequency = freq1 + ' ' + unit

                  this.medication.shortFreq = freq1 + ' ' + shortUnit
                }
                else {
                  var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.medication.shortFreq = freq1

                }


              }


              this.cc_selected.push(result)

              console.log(this.cc_selected)

            });
          }
          else {
            var detailParams = {
              account_email: this.dmail,
              doctor_id: this.doc_id,
              update: 1,
              drug:
              {
                drug_id: result.id,
                formulation: result.formulation,
                name:result.brand
              }
            }

            this.appService.postData(this.urlPoints.updateMedicines, detailParams, this.token).subscribe((response: any) => {
              this.medication = result;

              console.log(this.medication)

              this.pres_count++;

              this.medication.pres_id = this.pres_count;

              var unit = this.medication.quantity.split(' ')[1]

              var freq_arr = this.medication.frequency.split('-')

              if (freq_arr.length == 4) {
                var morning = freq_arr[0].trim().split(' ')[0]

                var afternoon = freq_arr[1].trim().split(' ')[0]

                var evening = freq_arr[2].trim().split(' ')[0]

                var night = freq_arr[3].trim().split(' ')[0]

                if (this.showUnits) {
                  var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                  var shortUnit = ''

                  if (unit == 'milliliter') {
                    shortUnit = 'ml'
                  }

                  else if (unit == 'Tablet') {
                    shortUnit = 'Tablet'
                  }

                  else if (unit == 'microgram') {
                    shortUnit = 'mcg'
                  }

                  else if (unit == 'milligram') {
                    shortUnit = 'mg'
                  }

                  else if (unit == 'gram') {
                    shortUnit = 'grm'
                  }


                  else if (unit == 'drops') {
                    shortUnit = 'drops'
                  }

                  else if (unit == 'Sachets/Packets') {
                    shortUnit = 'pkt'
                  }


                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }

                  if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                    var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                    var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                    if (unit == 'mole' || unit == 'millimole') {
                      var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                      freq = shortFreq
                    }
                  }

                }
                else {
                  var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                  var shortFreq = freq

                }
                this.medication.frequency = freq
                this.medication.shortFreq = shortFreq


              }
              else {
                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }

                if (this.showUnits) {
                  var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()


                  this.medication.frequency = freq1 + ' ' + unit

                  this.medication.shortFreq = freq1 + ' ' + shortUnit
                }
                else {
                  var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                  this.medication.shortFreq = freq1

                }


              }

              this.cc_selected.push(result)

              console.log(this.cc_selected)

            });
          }


          console.log(this.cc_selected)

        }
      });

      if (this.chars != '') {
        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: this.chars.toUpperCase().trim(),
          doctor_id: this.doc_id
        }

        this.getCC(this.urlPoints.getPres, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

    }
    else {
      this.toastr.error(this.cc_show[index].name + ' has been already added!')

    }
  }else{

var index1 = this.chief_complaints.indexOf(this.cc_show[index])
this.getIndexDrug = index1;
this.getPatientEmail = JSON.parse(window.sessionStorage.getItem('patientprofile'));

 this.selectedDrag = this.cc_show[index]

 var getselectedDrag = this.selectedDrag.id;

var params1 = {
  drug_id:getselectedDrag,
  account_email: this.dmail
}

var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].id == this.cc_show[index].id) {
        var exists = true
      }
    }

    if (!exists) {
      var dialogRef;
      this.appService.getData(this.urlPoints.checkDrugStatus,params1, this.token).subscribe((response: any) => {
// old flow of eshop
if(this.eshop_enabled == 'true' && response.success == 0){
        if(response.message == 'product not approved by doctor'){
          this.getStockStatus="out-of-stock";
          var alertMsg = "This product is not approved by doctor."
          this.dialog.open(DialogOverviewExampleDialog_alertMessage, {
            width: '600px',
            data: {name:alertMsg}
          });
        }
          else if(response.message == 'drug id not exist ' || response.message == "product not mapped"){
            var alertMsg ="Drug and e-Shop product not mapped please configure."
            dialogRef = this.dialog.open(DialogOverviewExampleDialog_alertMessage, {
              width: '600px',
              data: {name:alertMsg}
            });
            dialogRef.afterClosed().subscribe(result => {
              this.openSearchOption = true;
              this.fetchDropdownData();

            })
          }
        }
        else{
         this.callBackDialogFun(response,this.getSelectedDrugIndex,index);
        }
        // this.callBackDialogFun(response,this.getSelectedDrugIndex,index);
    });


      if (this.chars != '') {
        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: this.chars.toUpperCase().trim(),
          doctor_id: this.doc_id
        }

        this.getCC(this.urlPoints.getPres, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

    }
    else {
      this.toastr.error(this.cc_show[index].name + ' has been already added!')

    }
  
    }
  }

  edit(index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: 'fit-content',

      data: { host:this.cc_selected,name: this.cc_selected[index].brand, id: this.cc_selected[index].id, mode: 1, obj: this.cc_selected[index], text: '', pres_selected: this.cc_selected, age: this.data.age, weight: this.data.weight, token: this.token, dmail: this.data.dmail }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        if (this.add) {
          var params3;

          params3 = {
            doctor_id: this.doc_id,
            actual_word: this.cc_show[index].name,
            reference_word: this.chars_copy,
            word_type: 6,
            account_email: this.dmail
          }

          const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
            width: '600px', disableClose: true,
            data: { name: 'Show ' + this.cc_show[index].name + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              if (result == 'yes') {
                this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                  this.add = false
                });
              }
              else {
                this.add = false
              }
            }
          });

        }

        if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

          if (result.when == 'After Food') {
            result.when = 'AF'
          }

          if (result.when == 'Before Food') {
            result.when = 'BF'
          }

          if (result.when == 'Not Related to Food') {
            result.when = 'NRF'
          }

          if (result.when == 'With Food') {
            result.when = 'WF'
          }
        }

        if (result.create) {

          var detailParams = {
            account_email: this.dmail,
            doctor_id: this.doc_id,
            update: 0,
            drug:
            {
              drug_id: result.id,
              formulation: result.formulation,
              name:result.brand
            }
          }

          this.appService.postData(this.urlPoints.updateMedicines, detailParams, this.token).subscribe((response: any) => {

            if (response.data.id)
              result.id = response.data.id

            this.medication = result;

            this.pres_count++;

            this.medication.pres_id = this.pres_count;

            var unit = this.medication.quantity.split(' ')[1]

            var freq_arr = this.medication.frequency.split('-')

            if (freq_arr.length == 4) {
              var morning = freq_arr[0].trim().split(' ')[0]

              var afternoon = freq_arr[1].trim().split(' ')[0]

              var evening = freq_arr[2].trim().split(' ')[0]

              var night = freq_arr[3].trim().split(' ')[0]

              if (this.showUnits) {
                var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }


                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }

                if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                  var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }
                }

              }
              else {
                var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                var shortFreq = freq

              }
              this.medication.frequency = freq
              this.medication.shortFreq = shortFreq


            }
            else {
              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }

              if (this.showUnits) {
                var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()


                this.medication.frequency = freq1 + ' ' + unit

                this.medication.shortFreq = freq1 + ' ' + shortUnit
              }
              else {
                var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                this.medication.shortFreq = freq1

              }


            }


            this.cc_selected[index] = result


          });
        }
        else {
          var detailParams = {
            account_email: this.dmail,
            doctor_id: this.doc_id,
            update: 1,
            drug:
            {
              drug_id: result.id,
              formulation: result.formulation,
              name:result.brand
            }
          }

          this.appService.postData(this.urlPoints.updateMedicines, detailParams, this.token).subscribe((response: any) => {
            this.medication = result;

            this.pres_count++;

            this.medication.pres_id = this.pres_count;

            var unit = this.medication.quantity.split(' ')[1]

            var freq_arr = this.medication.frequency.split('-')

            if (freq_arr.length == 4) {
              var morning = freq_arr[0].trim().split(' ')[0]

              var afternoon = freq_arr[1].trim().split(' ')[0]

              var evening = freq_arr[2].trim().split(' ')[0]

              var night = freq_arr[3].trim().split(' ')[0]

              if (this.showUnits) {
                var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

                var shortUnit = ''

                if (unit == 'milliliter') {
                  shortUnit = 'ml'
                }

                else if (unit == 'Tablet') {
                  shortUnit = 'Tablet'
                }

                else if (unit == 'microgram') {
                  shortUnit = 'mcg'
                }

                else if (unit == 'milligram') {
                  shortUnit = 'mg'
                }

                else if (unit == 'gram') {
                  shortUnit = 'grm'
                }


                else if (unit == 'drops') {
                  shortUnit = 'drops'
                }

                else if (unit == 'Sachets/Packets') {
                  shortUnit = 'pkt'
                }


                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }

                if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                  var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                  var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

                  if (unit == 'mole' || unit == 'millimole') {
                    var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                    freq = shortFreq
                  }
                }

              }
              else {
                var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

                var shortFreq = freq

              }
              this.medication.frequency = freq
              this.medication.shortFreq = shortFreq


            }
            else {
              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }

              if (this.showUnits) {
                var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()


                this.medication.frequency = freq1 + ' ' + unit

                this.medication.shortFreq = freq1 + ' ' + shortUnit
              }
              else {
                var freq1: any = this.medication.frequency.split('-')[0].trim() + ' - ' + this.medication.frequency.split('-')[1].trim().split(' ')[0].trim()

                this.medication.shortFreq = freq1

              }


            }

            this.cc_selected[index] = result

          });
        }

      }
    });

    if (this.chars != '') {
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getCC(this.urlPoints.getPres, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

  }

  addCC1(index) {
    this.cc_all_check = true;
this.getSelectedDrugIndex = index;
    var exists = false;
    var index1 = this.cc_all[index]
this.getIndexDrug = index1;
this.selectedDrag = this.cc_all[index]
this.getPatientEmail = JSON.parse(window.sessionStorage.getItem('patientprofile'));
var getselectedDrag = this.cc_all[index] && this.cc_all[index].id ? this.cc_all[index].id : null;

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].id == this.cc_all[index].id) {
        var exists = true
      }
    }
    var params1 = {
      drug_id:getselectedDrag,
      account_email: this.dmail
    }
    if (!exists) {
      this.appService.getData(this.urlPoints.checkDrugStatus,params1, this.token).subscribe((response: any) => {
        if(this.eshop_enabled == 'true' && response.success == 0){
          if(response.message == 'product not approved by doctor'){
            this.getStockStatus="out-of-stock";
            var alertMsg = "This product is not approved by doctor."
            this.dialog.open(DialogOverviewExampleDialog_alertMessage, {
              width: '600px',
              data: {name:alertMsg}
            });
          }
            else if(response.message == 'drug id not exist ' || response.message == "product not mapped"){
              var alertMsg ="Drug and e-Shop product not mapped please configure."
              const dialogRef = this.dialog.open(DialogOverviewExampleDialog_alertMessage, {
                width: '600px',
                data: {name:alertMsg}
              });
              dialogRef.afterClosed().subscribe(result => {
                this.openSearchOption=true;
                this.fetchDropdownData();
  
              })
            }
          }else{
            this.callBackDialogFun(response,this.getSelectedDrugIndex,index);
          }
          // this.callBackDialogFun(response,this.getSelectedDrugIndex,index);
      });

  }
  }
  setBlock(i) {
    this.block = i

    if (this.block == 1) {
      this.cc_page = 1
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      if (this.chars != '') {
        this.getCC(this.urlPoints.getPres, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)
    }

    else {
      this.cc_page = 1

      var params1 = {
        account_email: this.dmail,
        page_no: 1,
        diagnosis_id: this.id_string.toString(),
        doctor_id: this.doc_id

      }

      this.getCC(this.urlPoints.getPres, params1, this.token)

      if (this.id_string == '') {
        this.cc_show = []
      }
    }
  }

  drugType() {

    const dialogRef = this.dialog.open(drugType, {
      width: 'fit-content',
      data: { type: this.drugShowType, total: this.displayTotal, durationAlone: this.durationAlone, fullFreq: this.fullFreq, showUnits: this.showUnits }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.drugShowType = result.type,
          this.displayTotal = result.total
        this.durationAlone = result.durationAlone
        this.showUnits = result.showUnits;
        var params;

        if (this.drugShowType == 1) {
          params = {
            "account_email": this.dmail,
            "category_id": "1",
            "category_name": "drug",
            "doctor_id": this.doc_id
          }
        }

        if (this.drugShowType == 2) {
          params = {
            "account_email": this.dmail,
            "category_id": "2",
            "category_name": "generic",
            "doctor_id": this.doc_id
          }
        }

        if (this.drugShowType == 3) {
          params = {
            "account_email": this.dmail,
            "category_id": "3",
            "category_name": "drug and generic",
            "doctor_id": this.doc_id
          }
        }

        this.appService.postData(this.urlPoints.drugSettings, params, this.token).subscribe((response: any) => {

        });

        var customParams = {
          account_email: this.dmail,
          doctor_id: this.doc_id,
          data: [
            {
              category_id: 1,
              category_name: "display duration seperately",
              status: this.durationAlone ? 1 : 0
            },
            {
              category_id: 2,
              category_name: "display time fully",
              status: this.fullFreq ? 1 : 0
            },
            {
              category_id: 3,
              category_name: "show unit in frequency",
              status: this.showUnits ? 1 : 0
            }
          ]
        }

        this.appService.postData(this.urlPoints.createPres, customParams, this.token).subscribe((response: any) => {

        });

        for (var i = 0; i < this.cc_selected.length; i++) {

          var unit = this.cc_selected[i].quantity.split(' ')[1]

          var freq_arr = this.cc_selected[i].frequency.split('-')

          if (freq_arr.length == 4) {
            var morning = freq_arr[0].trim().split(' ')[0]

            var afternoon = freq_arr[1].trim().split(' ')[0]

            var evening = freq_arr[2].trim().split(' ')[0]

            var night = freq_arr[3].trim().split(' ')[0]

            if (this.showUnits) {
              var freq = morning + (morning != 0 ? (' ' + unit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + unit) : '') + ' - ' + evening + (evening != 0 ? (' ' + unit) : '') + ' - ' + night + (night != 0 ? (' ' + unit) : '')

              this.cc_selected[i].frequency = freq

              var shortUnit = ''

              if (unit == 'milliliter') {
                shortUnit = 'ml'
              }

              else if (unit == 'Tablet') {
                shortUnit = 'Tablet'
              }

              else if (unit == 'microgram') {
                shortUnit = 'mcg'
              }

              else if (unit == 'milligram') {
                shortUnit = 'mg'
              }

              else if (unit == 'gram') {
                shortUnit = 'grm'
              }


              else if (unit == 'drops') {
                shortUnit = 'drops'
              }

              else if (unit == 'Sachets/Packets') {
                shortUnit = 'pkt'
              }


              var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')

              if (unit == 'mole' || unit == 'millimole') {
                var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                freq = shortFreq
              }

              if (this.dmail == 'rx15@rxcarenet.org' || (this.dmail == 'rx122340@rxcarenet.org' && this.doc_id == 1) || (this.dmail == 'rx4@rxcarenet.org' && this.doc_id == 4)) {

                var freq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')
                var shortFreq = morning + (morning != 0 ? (' ' + shortUnit) : '') + ' - ' + afternoon + (afternoon != 0 ? (' ' + shortUnit) : '') + ' - ' + evening + (evening != 0 ? (' ' + shortUnit) : '') + ' - ' + night + (night != 0 ? (' ' + shortUnit) : '')


                if (unit == 'mole' || unit == 'millimole') {
                  var shortFreq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night
                  freq = shortFreq
                }
              }

              this.cc_selected[i].frequency = freq
              this.cc_selected[i].shortFreq = shortFreq

            }
            else {
              var freq = morning + ' - ' + afternoon + ' - ' + evening + ' - ' + night

              this.cc_selected[i].frequency = freq
              this.cc_selected[i].shortFreq = freq

            }
          }
          else {

            var shortUnit = ''

            if (unit == 'milliliter') {
              shortUnit = 'ml'
            }

            else if (unit == 'Tablet') {
              shortUnit = 'Tablet'
            }

            else if (unit == 'microgram') {
              shortUnit = 'mcg'
            }

            else if (unit == 'milligram') {
              shortUnit = 'mg'
            }

            else if (unit == 'gram') {
              shortUnit = 'grm'
            }


            else if (unit == 'drops') {
              shortUnit = 'drops'
            }

            else if (unit == 'Sachets/Packets') {
              shortUnit = 'pkt'
            }

            if (this.showUnits) {
              var freq1: any = this.cc_selected[i].frequency.split('-')[0].trim() + ' - ' + this.cc_selected[i].frequency.split('-')[1].trim().split(' ')[0].trim()

              this.cc_selected[i].frequency = freq1 + ' ' + unit

              this.cc_selected[i].shortFreq = freq1 + ' ' + shortUnit


            }
            else {
              var freq1: any = this.cc_selected[i].frequency.split('-')[0].trim() + ' - ' + this.cc_selected[i].frequency.split('-')[1].trim().split(' ')[0].trim()

              this.cc_selected[i].shortFreq = freq1

            }
          }
        }

      }
    });
  }

  onScroll2() {
    //  alert('here')
    this.cc_all_page++;

    var all_params = {
      account_email: this.data.dmail,
      page_no: this.cc_all_page,
      limit: 50,
      doctor_id : this.doc_id
    }

    this.appService.getData(this.urlPoints.getAllDrugs, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)

      if (response.data)
        this.cc_all = this.cc_all.concat(response.data)

    });
  }
  callMasterSettings(){
    var params={ 
      account_email : this.dmail, 
      doctor_id : this.doc_id
  }
  this.appService.getData(this.urlPoints.getMasterSettings, params, this.token).subscribe((masterData: any) =>{
    console.log("masterData::",masterData)
    this.prescription_mode = masterData.data[0].prescription_mode

  }) 
  }
  new_prescription() {
    this.callMasterSettings()
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_master, {
      width: 'fit-content',
      data: {email:this.data.dmail,doc_ID:this.doc_id,status:this.prescription_mode}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        var quantity;

        var time_block = 'times'

        var frequency_type = 'times'

        var morning_dose = 0

        var afternoon_dose = 0

        var evening_dose = 0

        var night_dose = 0

        var every_value;

        var freq_quantity = 1;

        var frequency

        var name

        var name = result.drugname
        // var name = result.generic 

        var params = {
          drug: {
            brand: result.drugname,
            composition_name: result.compname,
            generic: result.generic,
            formulation: result.formulation.toUpperCase(),
            strength: result.strength,
            strength_unit: result.unit,
            dose: result.dose,
            dose_option: result.dose_option,
            route: result.route,
            when: result.when,
            special_instruction: '',
            frequency: result.frequency,
            duration: result.duration,
            duration_type: result.duration_type,
            minimum_buyable_qty: result.min_qty,
          },
          account_email: this.dmail,
          doctor_id: this.doc_id
        }
        var params1 = {
          drug: {
            brand: result.drugname || '',
            composition_name: result.compname || '',
            generic: result.generic || '',
            formulation: result.formulation.toUpperCase() || '',
            strength: result.strength || '',
            strength_unit: result.unit || '',
            dose: result.dose || '',
            dose_option: result.dose_option || '',
            route: result.route || '',
            when: result.when || '',
            special_instruction: '',
            frequency: result.frequency || '',
            duration: result.duration || '',
            duration_type: result.duration_type || '',
            minimum_buyable_qty: result.min_qty || '',
          },
          account_email: this.dmail
        }
var checkDoc = false;
        this.appService.postData(this.urlPoints.addDrug,params, this.token).subscribe((response: any) => {

          var obj = {
            brand: response.drug.brand,
            dose: response.drug.strength,
            dose_option: response.drug.dose_option,
            duration: response.drug.duration,
            duration_type: response.drug.duration_type,
            formulation: response.drug.formulation,
            freq_string: '',
            frequency: response.drug.frequency,
            generic: response.drug.composition_name,
            id: response.drug.id,
            minimum_buyable_qty: response.drug.minimum_buyable_qty,
            quantity: quantity,
            route: response.drug.route,
            special_instruction: '',
            strength: response.drug.strength,
            strength_unit: response.drug.strength_unit,
            type: 3,
            when: response.drug.when,
            create: false
          }

          var arr = []
          var freq_string;

          obj.frequency = response.drug.frequency

          var total;


          if (obj.duration_type == 'Months') {
            quantity = quantity * 30;
          }

          obj.quantity = quantity

          obj.quantity = 1 + ' ' + response.drug.dose_option

          obj.frequency = obj.frequency + ' - ' + obj.quantity

          var params2 = {
            account_email: this.dmail,
            page_no: 1,
            alphabet: name,
            doctor_id: this.doc_id
          }

          this.appService.getData(this.urlPoints.getPres, params2, this.token).subscribe((response: any) => {

            if (response.success !== 0 && !response.message) {

              response.data = response.data.filter(i => i.name == name);

              obj.id = response.data[0].id

              console.log("this.cc_selected>>",obj)

              this.cc_selected.push(obj)

            }
          })


          this.toastr.success('Drug Added!', '', {
            timeOut: 3000,
          });
        });
      }
    });
  }

  remove(index) {
    this.cc_data = []

    this.cc_selected.splice(index, 1);

    if (this.chars != '') {
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getCC(this.urlPoints.getPres, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getPresCounter, this.counter_params, this.token)

  }

  save() {


    //   drugShowType=1;
    // displayTotal = true;
    // durationAlone=false
    // fullFreq = true;
    // showUnits = false;

    var obj = {
      drugShowType: this.drugShowType,
      displayTotal: this.displayTotal,
      durationAlone: this.durationAlone,
      fullFreq: this.fullFreq,
      showUnits: this.showUnits,
      pres_selected: this.cc_selected
    }

    this.dialogRef.close(obj)
  }

  onScroll() {

    var token = this.token;
    this.cc_page++;

    var params = {
      account_email: this.dmail,
      page_no: this.cc_page,
      alphabet: this.chars.toUpperCase(),
      doctor_id: this.doc_id
    }

    this.getCC(this.urlPoints.getPres, params, token)

  }

  onNoClick(): void {
    this.dialogRef.close(this.cc_selected)
  }

  close() {
    this.dialogRef.close();

  }

  getCCCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.chief_complaints = response.details;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

      }
    });
  }

  getCC(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;

        if (this.cc_page > 1)
          this.cc_data = this.cc_data.concat(response.data)
        else
          this.cc_data = response.data

        this.chief_complaints = this.cc_data;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        // for (var i = 0; i < this.chief_complaints.length; i++) {
        //   for (var k = 0; k < this.cc_selected.length; k++) {
        //     if (this.chief_complaints[i].symptoms_id == this.cc_selected[k].symptoms_id) {
        //       matchedArray.push(i);
        //     }
        //   }
        // }

        // for (var i = matchedArray.length - 1; i >= 0; i--) {
        //   this.cc_show.splice(matchedArray[i], 1);
        // }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 6,
          reference_word: this.chars.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {
          console.log(response)
          this.cc_show = this.cc_show.concat(response.data)
        });


        if (this.add == false && voice && this.cc_show.length == 0) {
          this.add = true
          this.chars_copy = this.chars
          console.log('here')
        }

      }
    });
  }
}

@Component({
  selector: 'advice',
  templateUrl: 'advice.html',
  styleUrls: ['advice.scss']

})

export class Dialog_advice {

  provisional = false;
  counter_params;
  doc_id;
  dmail;
  chief_complaints = [];
  cc_selected = [];
  cc_show = [];
  urlPoints;
  startMicTimeout: any;
  token;
  search = ''
  chars = '';
  cc_page;
  cc_data = []
  cc_pages;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  isFullListDisplayed: boolean = false;
  cc_all = [];
  block = 1
  id_string;
  nisVersion = nisPackage.dependencies["ngx-infinite-scroll"];
  cc_all_page = 1;
  showKB = false;
  speech: any;
  speechData: any;
  alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Space', 'Backspace']
  supported;
  osName;

  differ: KeyValueDiffer<string, any>;
  muted = true
  timeoutHandler;
  held = false;
  add = false
  chars_copy = '';
  record = false
voiceNote = [];
  constructor(
    public dialogRef: MatDialogRef<Dialog_chiefComplaints>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder, private differs: KeyValueDiffers, public service: VoiceRecognitionService) {
    this.doc_id = this.data.doc_id
    this.dmail = this.data.dmail;
    this.urlPoints = AppConfig.settings.EndPoints;
    this.token = this.data.token

    this.differ = this.differs.find({}).create();
    this.speech = new Speech()

    if (this.speech.hasBrowserSupport()) {
      this.speech.init({
        'volume': 1,
        'lang': 'en-GB',
        'rate': 1,
        'pitch': 1,
        'voice': 'Google UK English Male',
        'splitSentences': true,
        'listeners': {
          'onvoiceschanged': (voices) => {
          }
        }
      }).then((data) => {
        this.speechData = data;
        data.voices.forEach(voice => {
        });
      }).catch(e => {
      })
    }

    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      if (this.getOS() != 'iOS' && this.getOS() != "Mac OS") {
        this.service.init();
        this.service.adviceInit();
        this.supported = true
      }
      else {
        this.supported = false
      }

    } else {
      this.supported = false
    }

    dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.dialogRef.close(this.cc_selected)

    })
  }
  ngOnInit(): void {

    this.cc_selected = Object.assign([], this.data.selected);

    var ids = []

    console.log(this.data.diag_selected)

    for (var i = 0; i < this.data.diag_selected.length; i++) {
      ids.push(this.data.diag_selected[i].diagnosis_id)
    }

    this.id_string = ids.join(',')

    var all_params = {
      account_email: this.data.dmail,
      doctor_id: this.doc_id,
      page_no: 1,
      limit: 50
    }

    this.appService.getData(this.urlPoints.getAllAdvice, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = response.data

      this.cc_all = this.cc_all.filter(i => i.instructions.toLowerCase() != '');

    });

    this.counter_params = {
      doctor_id: this.doc_id,
      account_email: this.dmail
    }

    this.getCCCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
  }

  changeProv() {
    this.provisional = !this.provisional
  }

  openKeyboard() {
    this.showKB = !this.showKB
  }

  search1(e) {

    this.block = 1

    this.chars = e.target.value

    this.cc_page = 1
    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars.toUpperCase().trim(),
      doctor_id: this.doc_id
    }

    if (this.chars != '') {
      this.getCC(this.urlPoints.getAdv, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)

  }

  new_cc() {
    const dialogRef = this.dialog.open(Dialog_getName, {
      //  width: '480px',
      data: {
        block: 'adv',
        text: 'Enter Advice'
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //  alert(result)

        if (result.record == false) {

          if (this.provisional) {
            result.name = '?' + result.name
          }

          this.provisional = false;

          // this.cc_selected.push(result)
          this.cc_selected.push(
            {
              instructions: result.name,
              instruction_id: 123
            }
          )

          return;
        }

        var res_arr = []

        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: result.name,
          doctor_id: this.doc_id
        }

        this.appService.getData(this.urlPoints.getAdv, params, this.token).subscribe((response: any) => {
          console.log(response.data)

          res_arr = response.data.filter(i => i.instructions.toLowerCase() != '');

          console.log(res_arr)

          if (res_arr.length > 0) {
            this.toastr.error(result.name + " already exists")
          }
          else {
            this.save_cc(result.name)
          }


        });

      }
    });
  }

  save_cc(result1) {

    const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
      width: '600px', disableClose: true,
      data: { name: 'Add ' + result1 + ' to Advices?', type: 1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result == 'yes') {

          var params = {
            account_email: this.dmail,
            new_instruction: [result1],
            doctor_id: this.doc_id
          }

          this.appService.postData(this.urlPoints.newAdv, params, this.token).subscribe((response: any) => {

            var params2 = {
              account_email: this.dmail,
              page_no: 1,
              alphabet: result1,
              doctor_id: this.doc_id
            }

            this.getCC1(this.urlPoints.getAdv, params2, this.token);

          }
          );
        }
        else {
        }
      }
    });
  }
  startMic() {
    this.startMicTimeout = setTimeout(() => {
        this.openMic();
    }, 500); // Adjust the delay as needed
}
  openMic(){
    
    if(this.muted){
      this.muted = false;
      this.startVoice()
    }else{
    let localArr={
      id:'123',
      instruction_id:'321',
      instructions:this.service.voiceText.replace(/\bundefined\b/g, '').trim(),
      is_question: false,
      question: false
    };
    this.voiceNote.push(localArr);
        console.log("localArr:::",localArr)
        console.log("this.voiceNote:::",this.voiceNote)
      this.muted = true;
    this.stopVoice()
    }
  }
removeText(idx:any){
this.voiceNote.splice(idx,1)
}
stopVoice(){
  this.service.stopVoice()
}
startVoice(){
  this.service.startVoice()
}
  mouseup() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }

    if (this.held) {
      this.held = false

      if (!this.muted) {

        this.muted = true
        this.service.stop()
      }
    }
  }

  mousedown() {
    this.timeoutHandler = setTimeout(() => {
      this.timeoutHandler = null;

      this.held = true

      if (this.muted) {
        //  alert()
        this.muted = false
        this.service.start()
      }
    }, 1000);
  }

  getCC1(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        var res_arr = []


        res_arr = response.data.filter(i => i.instructions.toLowerCase() == params.alphabet.toLowerCase());

        console.log(res_arr)



        if (res_arr.length > 0) {

          if (this.provisional) {
            res_arr[0].instructions = '?' + res_arr[0].instructions
          }

          this.provisional = false;

          this.cc_selected.push(res_arr[0])
        }



      }
    });


  }

  onScroll2() {
    //  alert('here')
    this.cc_all_page++;

    var all_params = {
      account_email: this.data.dmail,
      doctor_id: this.doc_id,
      page_no: this.cc_all_page,
      limit: 50
    }

    this.appService.getData(this.urlPoints.getAllAdvice, all_params, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.cc_all = this.cc_all.concat(response.data)

    });
  }

  keyboard(alphabet) {


    if (alphabet == 'Space') {
      alphabet = ' '
    }
    if (alphabet != 'Backspace') {
      this.chars = this.chars + alphabet;
    }
    else {
      this.chars = this.chars.slice(0, -1)
    }

    this.search = this.chars

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }
    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getAdv, params, this.token);
    this.cc_data = [];
    this.cc_page = 1;

  }

  clear() {
    this.search = ''

    this.chars = ''

    this.getCCCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)

  }

  ngDoCheck() {
    const change = this.differ.diff(this.service);
    if (change) {
      var that = this;
      change.forEachChangedItem(item => {
        if (item.key == 'length') {
          if (this.supported)
            this.navigate()
        }
      });
    }
  }

  navigate() {
    this.chars = this.search = this.service.textArray[this.service.textArray.length - 1]

    this.add = false;
    this.chars_copy = this.chars;

    var params = {
      account_email: this.dmail,
      page_no: 1,
      alphabet: this.chars,
      doctor_id: this.doc_id
    }

    if (this.chars == '')
      this.getCCCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
    else
      this.getCC(this.urlPoints.getAdv, params, this.token, 'voice');
    this.cc_data = [];
    this.cc_page = 1;
  }

  toggleMute() {
    this.muted = !this.muted

    if (this.muted) {
      this.stopService()
    }
    else {
      this.startService()
    }
  }

  startService() {

    if (this.supported)
      this.service.start()

  }

  stopService() {

    if (this.supported)
      this.service.stop()

  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    this.osName = os

    return os;
  }

  addCC(index) {

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].instruction_id == this.cc_show[index].instruction_id) {
        var exists = true
      }
    }

    if (!exists) {

      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_show[index].instructions,
          reference_word: this.chars_copy,
          word_type: 5,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_show[index].instructions + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      if (this.provisional) {
        this.cc_show[index].instructions = '?' + this.cc_show[index].instructions
      }

      this.cc_selected = this.cc_selected.concat(this.cc_show[index])

      this.cc_show.splice(index, 1);

      this.provisional = false

      if (this.chars != '') {
        var params = {
          account_email: this.dmail,
          page_no: 1,
          alphabet: this.chars.toUpperCase().trim(),
          doctor_id: this.doc_id
        }

        this.getCC(this.urlPoints.getAdv, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
    }

    else {
      this.toastr.error(this.cc_show[index].instructions + ' has been already added!')

    }

  }

  addCC1(index) {

    var exists = false

    for (var i = 0; i < this.cc_selected.length; i++) {
      if (this.cc_selected[i].instruction_id == this.cc_all[index].instruction_id) {
        var exists = true
      }
    }

    if (!exists) {
      if (this.add) {
        var params3;

        params3 = {
          doctor_id: this.doc_id,
          actual_word: this.cc_all[index].instructions,
          reference_word: this.chars_copy,
          word_type: 5,
          account_email: this.dmail
        }

        const dialogRef = this.dialog.open(DialogOverviewExampleDialog_confirm, {
          width: '600px', disableClose: true,
          data: { name: 'Show ' + this.cc_all[index].instructions + ' when you say ' + this.chars_copy + ' next time?', type: 1 }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (result == 'yes') {
              this.appService.postData(this.urlPoints.saveVoiceSearch, params3, this.token).subscribe((response: any) => {
                this.add = false
              });
            }
            else {
              this.add = false
            }
          }
        });

      }

      var obj = Object.assign({}, this.cc_all[index]);

      if (this.provisional) {
        obj.instructions = '?' + obj.instructions
      }

      this.provisional = false;

      this.cc_selected = this.cc_selected.concat(obj)
    }
    else {
      this.toastr.error(this.cc_all[index].instructions + ' has been already added!')

    }

  }

  remove(index) {
    this.cc_data = []

    this.cc_selected.splice(index, 1);

    if (this.chars != '') {
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      this.getCC(this.urlPoints.getAdv, params, this.token)

    }
    else
      this.getCCCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)

  }

  setBlock(i) {
    this.block = i

    if (this.block == 1) {
      this.cc_page = 1
      var params = {
        account_email: this.dmail,
        page_no: 1,
        alphabet: this.chars.toUpperCase().trim(),
        doctor_id: this.doc_id
      }

      if (this.chars != '') {
        this.getCC(this.urlPoints.getAdv, params, this.token)

      }
      else
        this.getCCCounter(this.urlPoints.getAdvCounter, this.counter_params, this.token)
    }

    else {
      this.cc_page = 1

      var params1 = {
        account_email: this.dmail,
        page_no: 1,
        diagnosis_id: this.id_string.toString(),
        doctor_id: this.doc_id

      }

      this.getCC(this.urlPoints.getAdv, params1, this.token)

      if (this.id_string == '') {
        this.cc_show = []
      }
    }
  }

  save() {
    if (!this.muted) {
      this.stopService()
    }
    if (Array.isArray(this.voiceNote)) {
      console.log("this.voiceNote is an array.");
  } else {
      console.log("this.voiceNote is not an array.");
  }
    console.log("this.voiceNote save::::",this.voiceNote)
    let data = this.cc_selected.concat(this.voiceNote)
    console.log("this.cc_selected::: save",this.cc_selected)
    console.log("data::: save",data)
    this.dialogRef.close(this.cc_selected.concat(this.voiceNote))
  }

  onScroll() {

    var token = this.token;
    this.cc_page++;

    var params = {
      account_email: this.dmail,
      page_no: this.cc_page,
      alphabet: this.chars.toUpperCase(),
      doctor_id: this.doc_id
    }

    this.getCC(this.urlPoints.getAdv, params, token)

  }

  onNoClick(): void {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close(this.cc_selected)
  }

  close() {
    if (!this.muted) {
      this.stopService()
    }
    this.dialogRef.close();

  }

  getCCCounter(url, params, token) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.chief_complaints = response.details;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].instruction_id == this.cc_selected[k].instruction_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {

          this.cc_show.splice(matchedArray[i], 1);
        }

      }
    });
  }

  getCC(url, params, token, voice?) {

    this.appService.getData(url, params, token).subscribe((response: any) => {
      if (response.success != 0 && !response.message) {
        this.cc_pages = response.total_page;

        if (this.cc_page > 1)
          this.cc_data = this.cc_data.concat(response.data)
        else
          this.cc_data = response.data

        this.chief_complaints = this.cc_data;
        this.cc_show = Object.assign([], this.chief_complaints);

        var matchedArray = [];

        for (var i = 0; i < this.chief_complaints.length; i++) {
          for (var k = 0; k < this.cc_selected.length; k++) {
            if (this.chief_complaints[i].instruction_id == this.cc_selected[k].instruction_id) {
              matchedArray.push(i);
            }
          }
        }

        for (var i = matchedArray.length - 1; i >= 0; i--) {
          this.cc_show.splice(matchedArray[i], 1);
        }

        var params2 = {
          doctor_id: this.doc_id,
          word_type: 5,
          reference_word: this.chars.toLowerCase(),
          account_email: this.dmail
        }

        this.appService.getData(this.urlPoints.getVoiceSearch, params2, this.token).subscribe((response: any) => {
          console.log(response)
          this.cc_show = this.cc_show.concat(response.data)
        });


        if (this.add == false && voice && this.cc_show.length == 0) {
          this.add = true
          this.chars_copy = this.chars
          console.log('here')
        }


      }
    });
  }
}

@Component({
  selector: 'follow_up',
  templateUrl: 'follow_up.html',
  styleUrls: ['follow_up.scss']

})

export class Dialog_followup {
  formulation;
  create = false;
  sos;
  type = 0;
  days = 1
  unit = 1;
  d
  selectedDate = moment(new Date());
  minDate;
  amount;
  urlPoints;
  dmail;
  patient;
  token;
  balance = 0;
  event = ''
  settingsData;
  doc_id;
  paidType = 'paid';
  video_call;
  voice_call;
  vaccination;
  consultation;
  follow_text;
  bookDetails
  follow_text_week;

  constructor(
    public dialogRef: MatDialogRef<Dialog_followup>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.dmail = this.data.dmail
    this.patient = this.data.patient
    this.token = this.data.token;
    this.doc_id = this.data.doc_id
  }
  ngOnInit(): void {
    var minCurrentDate = new Date();
    var maxNewDate = new Date();
    this.minDate = minCurrentDate;

    var payParams = {
      account_email: this.dmail,
      doctor_id: this.doc_id
    }

    this.appService.getData(this.urlPoints.getLoadStatus, payParams, this.token).subscribe((response: any) => {
    });

    this.appService.getData(this.urlPoints.paymentSetting, payParams, this.token).subscribe((response: any) => {
      this.settingsData = response

      var filter = response.filter(res => res.module === "video_call_appointment_fee" && res.status == 1);
      if (filter.length > 0) {
        this.video_call = true;
        //  this.type = 'video_call'

      }

      var filter = response.filter(res => res.module === "voice_call_appointment_fee" && res.status == 1);
      if (filter.length > 0) {
        this.voice_call = true;
        //  this.type = 'voice_call'
      }

      var filter = response.filter(res => res.module === "vaccination" && res.status == 1);
      if (filter.length > 0) {
        this.vaccination = true;
        //  this.type = 'vaccination'

      }

      var filter = response.filter(res => res.module === "consultation" && res.status == 1);
      if (filter.length > 0) {
        this.consultation = true;
        //  this.type = 'consultation'
      }
    })
  }

  changeSOS() {
    this.sos = !this.sos
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {

    if (this.type == 1) {
      this.selectedDate = moment(new Date()).add(this.days, 'days');
    }

    if (this.sos) {
      this.follow_text = 'SOS and/or ' + moment(this.selectedDate).format('DD-MM-YYYY') + ', ' + moment(this.selectedDate).format('dddd')
      this.follow_text_week = 'SOS and/or ' + moment(this.selectedDate).format('DD-MMM-YYYY') + ', ' + moment(this.selectedDate).format('dddd')
    }
    else {
      this.follow_text = moment(this.selectedDate).format('DD-MM-YYYY') + ', ' + moment(this.selectedDate).format('dddd')
      this.follow_text_week = moment(this.selectedDate).format('DD-MMM-YYYY') + ', ' + moment(this.selectedDate).format('dddd')
    }

    if (this.type == 0) {
      this.follow_text = 'SOS'
    }

    var obj = {
      follow_text: this.follow_text,
      follow_text_week: this.follow_text_week,
      bookDetails: this.bookDetails
    }

    this.dialogRef.close(obj)
  }

  setType(i) {
    this.type = i

    if (i == 1) {
      this.unit = 1;
      this.d;
      this.days = 0
    }
  }


  changeDate() {
    if (!this.d || this.d.toString() == '') {
      this.d = 0
    }

    if (this.unit == 1) {
      this.days = this.d
    }

    if (this.unit == 2) {
      this.days = this.d * 7
    }

    if (this.unit == 3) {
      this.days = this.d * 30
    }
  }

  setUnit(i) {
    this.unit = i

    if (!this.d || this.d.toString() == '') {
      this.d = 0
    }

    if (i == 1) {
      this.days = this.d
    }

    if (i == 2) {
      this.days = this.d * 7
    }

    if (i == 3) {
      this.days = this.d * 30
    }
  }

  add_d(i) {

    if (!this.d || this.d.toString() == '') {
      this.d = 0
    }

    this.d = (this.d * 10) + i

    if (this.unit == 1) {
      this.days = this.d
    }

    if (this.unit == 2) {
      this.days = this.d * 7
    }

    if (this.unit == 3) {
      this.days = this.d * 30
    }
  }

  backspace() {
    if (!this.d || this.d.toString() == '') {
      this.d = 0
    }

    this.d = Math.floor(this.d / 10)

    if (this.unit == 1) {
      this.days = this.d
    }

    if (this.unit == 2) {
      this.days = this.d * 7
    }

    if (this.unit == 3) {
      this.days = this.d * 30
    }
  }

  onDateChange(e) {
    this.event = ''
  }

  setConsultationType(i) {
    this.event = i

    if (this.type == 1) {
      this.selectedDate = moment(new Date()).add(this.days, 'days');

    }

    var params = {
      account_email: this.dmail,
      patient_email: this.patient.record_info.Record.account_email
    }

    this.appService.postData(this.urlPoints.getWalletBalance, params, this.token).subscribe((response: any) => {
      this.balance = response.wallet[0].response[0].total;

      if (this.event == 'consultation' || this.event == 'vaccination') {

        var filter = this.settingsData.filter(res => res.module === "appointment");

      }

      else if (this.event == 'video_call') {

        var filter = this.settingsData.filter(res => res.module === "video_call_appointment_fee");

      }

      else if (this.event == 'voice_call') {

        var filter = this.settingsData.filter(res => res.module === "voice_call_appointment_fee");

      }

      this.amount = filter[0].doctor_charge

      const dialogRef = this.dialog.open(Dialog_follow_book, {
        width: 'fit-content',
        data: { type: this.event, balance: this.balance, date: moment(this.selectedDate).format('YYYY-MM-DD'), demail: this.dmail, token: this.token, id: this.doc_id, email: this.patient.record_info.Record.account_email, amount: this.amount, paidType: this.paidType }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.bookDetails = result
        result.amount = this.amount,
          //   result.slots_arr = this.slots_arr
          console.log(result)
      });
    })
  }

  close() {


    this.dialogRef.close();
  }

}
@Component({
  selector:'med_description',
  templateUrl:'med_description.html',
  styleUrls:['med_description.scss']
})

export class Med_description{
  textAreaValue;
  constructor(public dialogRef: MatDialogRef<Med_description>,@Inject(MAT_DIALOG_DATA) public data: any,public dialog: MatDialog){}
  ngOnInit(): void {
    console.log("data::>",this.data)
    this.textAreaValue = this.data.description == false ? '' : this.data.description;
  }

  save() {
    console.log("textAreaValue:::",this.textAreaValue)
    this.dialogRef.close(this.textAreaValue);
    

  }

  close() {

    this.dialogRef.close();
  }
}
@Component({
  selector: 'hpi',
  templateUrl: 'hpi.html',
  styleUrls: ['hpi.scss']

})

export class Dialog_hpi {
  hpi;

  constructor(
    public dialogRef: MatDialogRef<Dialog_hpi>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
    this.hpi = this.data.hpi
  }

  save() {
    this.dialogRef.close(this.hpi);

  }

  close() {

    this.dialogRef.close();
  }

}

@Component({
  selector: 'addpacs',
  templateUrl: 'submenus/addpacs.html',
  styleUrls: ['submenus/addpacs.scss']

})

export class Dialog_addpacs {
  // hpi;
  urlPoints;
  file_no;
  list

  constructor(
    public dialogRef: MatDialogRef<Dialog_addpacs>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder) {
    this.urlPoints = AppConfig.settings.EndPoints;

  }
  ngOnInit(): void {
    // this.hpi = this.data.hpi
  }

  save() {
    // this.dialogRef.close(this.hpi);

  }

  search() {

    var params = {
      account_email: this.data.account_email,
      patient_id: this.file_no.trim()
    }

    this.appService.postData(this.urlPoints.searchPacs, params, this.data.token).subscribe((response: any) => {
      if (response.success == 1) {
        this.list = response.pac_list
      }
      else {
        this.list = []
      }
    });
  }

  setData(data) {
    this.dialogRef.close(data);

  }

  close() {

    this.dialogRef.close();
  }

}

@Component({
  selector: 'pac_attachments',
  templateUrl: 'submenus/pac_attachments.html',
  styleUrls: ['submenus/pac_attachments.scss']

})

export class Dialog_pac_attachments {
  // hpi;
  urlPoints;
  file_no;
  list

  constructor(
    public dialogRef: MatDialogRef<Dialog_pac_attachments>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder) {
    this.urlPoints = AppConfig.settings.EndPoints;

  }
  ngOnInit(): void {
    console.log(this.data)
    // this.hpi = this.data.hpi
  }

  // save() {
  //   // this.dialogRef.close(this.hpi);

  // }

  // search()
  // {

  //   var params={
  //     account_email:this.data.account_email,
  //     patient_id:this.file_no
  //   }

  //   this.appService.postData(this.urlPoints.searchPacs, params, this.data.token).subscribe((response: any) => {
  //     if(response.success == 1)
  //     {
  //       this.list = response.pac_list
  //     }
  //     else
  //     {
  //       this.list = []
  //     }
  //   });
  // }

  // setData(data)
  // {
  //   this.dialogRef.close(data);

  // }

  view(id) {
    console.log(id)

    var params = {
      account_email: this.data.account_email,
      attachment_id: id
    }

    this.appService.getData(this.urlPoints.getDICOMPath, params, this.data.token).subscribe((response: any) => {
      console.log(response)

      console.log(response.file_name)

      var url = environment.HOST + '/dicomviewer/?file=' + response.file_name

      console.log(url)

      window.open(url)

    });
  }

  add(id) {
    console.log(this.data.lab_id)

    var params = {
      account_email: this.data.account_email,
      attachment_id: id
    }

    this.appService.getData(this.urlPoints.getDICOMPath, params, this.data.token).subscribe((response: any) => {
      console.log(response)

      console.log(response.file_name)

      var url = environment.HOST + '/dicomviewer/?file=' + response.file_name

      console.log(url)

      var params_add = {
        account_email: this.data.account_email,
        patient_email: this.data.patient_email,
        lab_id: this.data.lab_id,
        attachment: response.file_name,
        file_type: 'dicom'
      }

      console.log(params)

      this.appService.postData(this.urlPoints.createLabAttachment, params_add, this.data.token).subscribe((response1: any) => {

        console.log(response1)

        this.dialogRef.close();

      });

    });



    //createLabAttachment
  }


  close() {

    this.dialogRef.close();
  }

}

@Component({
  selector: 'pmh',
  templateUrl: 'pmh.html',
  styleUrls: ['pmh.scss']

})

export class Dialog_pmh {
  pmhdata;
  urlPoints;
  disabled = false;

  constructor(
    public dialogRef: MatDialogRef<Dialog_hpi>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder) {
    this.urlPoints = AppConfig.settings.EndPoints;

  }
  ngOnInit(): void {
    this.appService.getData(this.urlPoints.getHealthSurveyPatient, this.data.questionParams, this.data.token).subscribe((response: any) => {

      this.pmhdata = response.data


      for (var i = 0; i < this.pmhdata.length; i++) {

        if (this.pmhdata[i].question_type == 'checkbox') {


          if (typeof (this.pmhdata[i].answer) == 'string')
            this.pmhdata[i].answer = JSON.parse(this.pmhdata[i].answer)

          for (var j = 0; j < this.pmhdata[i].options.length; j++) {

            for (var k = 0; k < this.pmhdata[i].answer.length; k++) {

              if (this.pmhdata[i].options[j].checkbox_title == this.pmhdata[i].answer[k]) {

                this.pmhdata[i].options[j].checkbox_value = 1

              }
            }
          }
        }
      }

      this.checkDisabled()

    });
  }

  save() {
    this.dialogRef.close(this.pmhdata);

  }

  checkDisabled() {
    var checked = false

    console.log(this.pmhdata[0].options)

    for (var i = 0; i < this.pmhdata[0].options.length; i++) {
      if (this.pmhdata[0].options[i].checkbox_value == 1) {
        checked = true
      }
    }

    if (checked) {
      this.disabled = false
    }
    else {
      this.disabled = true
    }
  }


  optionToggle(i, j) {

    this.pmhdata[i].options[j].checkbox_value = this.pmhdata[i].options[j].checkbox_value == 1 ? 0 : 1

    this.checkDisabled()

  }

  none(i, j) {


    if (this.pmhdata[i].options[j].checkbox_value == 1) {
      for (var k = 0; k < this.pmhdata[i].options.length; k++) {
        if (j != k)
          this.pmhdata[i].options[k].checkbox_value = 0
      }
    }

    this.checkDisabled()

  }

  close() {

    this.dialogRef.close();
  }

}

@Component({
  selector: 'social',
  templateUrl: 'social.html',
  styleUrls: ['social.scss']

})

export class Dialog_social {
  shdata;
  urlPoints;
  date4;

  constructor(
    public dialogRef: MatDialogRef<Dialog_hpi>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder) {

    this.urlPoints = AppConfig.settings.EndPoints;

  }
  ngOnInit(): void {

    this.date4 = new Date().toISOString().slice(0, 10);

    this.appService.getData(this.urlPoints.getHealthSurveyPatient, this.data.questionParams, this.data.token).subscribe((response: any) => {
      this.shdata = response.data

      for (var i = 0; i < this.shdata.length; i++) {

        if (this.shdata[i].question_type == 'checkbox' || this.shdata[i].question_type == 'checkbox ') {

          for (var j = 0; j < this.shdata[i].options.length; j++) {
            for (var k = 0; k < this.shdata[i].answer.length; k++) {

              if (this.shdata[i].options[j].checkbox_title == this.shdata[i].answer[k]) {
                this.shdata[i].options[j].checkbox_value = 1
              }
            }
          }
        }

        if (this.shdata[i].question_type == 'checkbox+number') {
          for (var j = 0; j < this.shdata[i].options.length; j++) {
            for (var k = 0; k < this.shdata[i].answer.length; k++) {


              if (this.shdata[i].options[j].checkbox_title == this.shdata[i].answer[k].split(' - ')[0].trim()) {
                this.shdata[i].options[j].checkbox_value = 1

                this.shdata[i].options[j].number_value = this.shdata[i].answer[k].split(' - ')[1].trim()

              }

            }
          }
        }

        //checkbox+number
      }

    });
  }

  save() {
    this.dialogRef.close(this.shdata);

  }

  optionToggle1(i, j) {
    this.shdata[i].options[j].checkbox_value = this.shdata[i].options[j].checkbox_value == 1 ? 0 : 1

  }

  none1(i, j) {

    if (this.shdata[i].options[j].checkbox_value == 1) {
      for (var k = 0; k < this.shdata[i].options.length; k++) {
        if (j != k)
          this.shdata[i].options[k].checkbox_value = 0
      }
    }
  }

  notnone1(i, j) {
    this.shdata[i].options[3].checkbox_value = 0
  }

  radioSubmit(value, i, j) {

    this.shdata[i].answer = value

  }

  close() {

    this.dialogRef.close();
  }

}

@Component({
  selector: 'current',
  templateUrl: 'current.html',
  styleUrls: ['current.scss']

})

export class Dialog_current {
  cmdata = [];
  pres_copy_cm1 = []
  urlPoints;
  prescriptions;
  pres_copy1;
  pres_page;
  chars5;
  pres_selected1;
  pres_copy;
  pres_selected;
  matMenuTimer_soap: any;
  pres_selected_soap = []
  popupOpen = false
  private dialogRef1: MatDialogRef<DialogOverviewExampleDialog>;
  medication;

  constructor(
    public dialogRef: MatDialogRef<Dialog_hpi>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, private fb: FormBuilder) {
    this.urlPoints = AppConfig.settings.EndPoints;

  }
  ngOnInit(): void {

    //   this.pres_selected = this.data.pres_selected

    this.pres_copy_cm1 = this.data.pres_copy_cm1

    this.pres_selected_soap = this.data.pres_selected_soap



    this.appService.getData(this.urlPoints.getHealthSurveyPatient, this.data.questionParams, this.data.token).subscribe((response: any) => {
      this.cmdata = response.data
      console.log(this.cmdata)
      for (var i = 0; i < this.cmdata.length; i++) {
        if (this.cmdata[i].question_type == 'text+ text') {

          this.prescriptions = [];
          this.pres_copy1 = [];
          this.pres_page = 1;
          this.pres_copy1 = [];
          this.chars5 = ''

          this.pres_selected1 = Object.assign([], this.pres_selected);

          this.getPresCounter(this.urlPoints.getPresCounter, this.data.counter_params, this.data.token)

          for (var j = 0; j < this.cmdata[i].options.length; j++) {
            for (var k = 0; k < this.cmdata[i].answer.length; k++) {

              if (this.cmdata[i].options[j].text_title == this.cmdata[i].answer[k].split(' - ')[0].trim()) {

                this.cmdata[i].options[j].text_value = this.cmdata[i].answer[k].split(' - ')[1].trim()

              }
            }
          }


        }
      }
    });

    this.pres_copy_cm1 = [];


    this.appService.getData(this.urlPoints.previousMedicines, this.data.pastParams, this.data.token).subscribe((response: any) => {

      for (var i = 0; i < response.data.length; i++) {

        var obj = {
          name: response.data[i].generic.trim(),
          manufacture: response.data[i].brand.trim(),
          category: response.data[i].formulation ? response.data[i].formulation.trim() : '',
          unit: response.data[i].unit ? response.data[i].unit : '',
          id: response.data[i].medicine_master_id,
          formulation: response.data[i].formulation.trim(),
          strength: response.data[i].strength ? response.data[i].strength : '',
          dose: response.data[i].dose ? response.data[i].dose : '',
          dose_option: response.data[i].dose_option ? response.data[i].dose_option : '',
          duration: response.data[i].duration ? response.data[i].duration : '',
          duration_type: response.data[i].duration_type ? response.data[i].duration_type : '',
          frequency: response.data[i].frequency ? response.data[i].frequency : '',
          special_instruction: response.data[i].special_instruction ? response.data[i].special_instruction : '',
          strength_unit: response.data[i].strength_unit ? response.data[i].strength_unit : '',
          minimum_buyable_qty: response.data[i].minimum_buyable_qty ? response.data[i].minimum_buyable_qty : "",
        }

        this.pres_copy_cm1.push(obj)
      }
    });

  }

  getPresCounter(url, params, token) {

    // this.appService.getData(url, params, token).subscribe((response: any) => {
    //   if (response.success != 0 && !response.message) {
    //     this.prescriptions = response.details;
    //     this.pres_copy = Object.assign([], this.prescriptions);
    //     this.pres_copy1 = Object.assign([], this.prescriptions);

    //     var matchedArray = [];

    //     for (var i = 0; i < this.prescriptions.length; i++) {
    //       for (var k = 0; k < this.pres_selected.length; k++) {
    //         if (this.prescriptions[i].name == this.pres_selected[k].medicine_id) {
    //           matchedArray.push(i);
    //         }
    //       }
    //     }

    //     for (var i = matchedArray.length - 1; i >= 0; i--) {

    //       this.pres_copy.splice(matchedArray[i], 1);
    //       this.pres_copy1.splice(matchedArray[i], 1);
    //     }
    //   }
    // });
  }

  doubleClick_soap(i) {
    clearTimeout(this.matMenuTimer_soap);
    this.matMenuTimer_soap = undefined;
    this.pres_selected_soap.splice(i, 1)
  }

  clickedMe_soap(i) {
    if (!this.matMenuTimer_soap) return;
    this.edit_soap(i, i)
  }

  edit_soap(index, id) {

    this.dialogRef1 = this.dialog.open(DialogOverviewExampleDialog, {
      width: 'fit-content',
      //  height: '90vh',

      data: { name: this.pres_selected_soap[index].brand, id: this.pres_selected_soap[index].id, mode: 1, obj: this.pres_selected_soap[index], text: '', pres_selected: this.pres_selected_soap }
    });

    const sub = this.dialogRef1.componentInstance.onRemove.subscribe(() => {

      this.pres_selected_soap.splice(Number(sessionStorage.getItem("removeindex")), 1)

      if (index > sessionStorage.getItem("removeindex"))
        index--
    });


    this.popupOpen = true

    this.dialogRef1.afterClosed().subscribe(result => {

      this.popupOpen = false

      this.pres_selected_soap[index] = result;

    });

  }

  click_soap(i) {
    this.matMenuTimer_soap = setTimeout(() => { this.clickedMe_soap(i); }, 300);
  }

  update_pres_cm1(index, i) {

    console.log('here')

    console.log(this.popupOpen)


    this.dialogRef1 = this.dialog.open(DialogOverviewExampleDialog, {
      width: 'fit-content',

      data: { name: this.pres_copy_cm1[index].name, id: this.pres_copy_cm1[index].id, mode: 0, obj: this.pres_copy_cm1[index], text: '', pres_selected: this.pres_selected_soap, addPres: 1 }
    });

    const sub = this.dialogRef1.componentInstance.onRemove.subscribe(() => {

      this.pres_selected_soap.splice(Number(sessionStorage.getItem("removeindex")), 1)
    });

    this.popupOpen = true;



    this.dialogRef1.afterClosed().subscribe(result => {
      this.popupOpen = false

      console.log(result)

      // alert(1)

      if (result) {

        //  alert(2)

        this.medication = result

        this.pres_selected_soap.push(this.medication);

        console.log(this.pres_selected_soap)
      }
    });

  }

  onScroll5() {
    var token = this.data.token;
    this.pres_page++;

  }

  save() {

    var obj = {
      cmdata: this.cmdata,
      pres_selected_soap: this.pres_selected_soap
    }

    this.dialogRef.close(obj);

  }

  close() {

    this.dialogRef.close();
  }

}

@Component({
  selector: 'speech',
  templateUrl: 'speech.html',
  styleUrls: ['speech.scss']

})

export class DialogOverviewExampleDialog_speech {
  formulation;
  create = false;
  voiceData;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog_speech>, private appService: AppService, public dialog: MatDialog, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData_icons2, public router: Router, private fb: FormBuilder) {

  }
  ngOnInit(): void {
    onWindowLoad()

    window.onmessage = function (e) {

    };
  }

  @HostListener('window:message', ['$event'])
  onMessage(event) {

  }


  @HostListener('window:message', ['$event']) onPostMessage(event) {
    // here your code
    if (event.data.message) {
      this.voiceData = event.data.message
    }

  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  onStartClick() {
    onStartClick()
  }

  onStopClick() {
    onStopClick()

  }

  close() {

    this.dialogRef.close(this.voiceData);
  }

}

@Component({
  selector: 'vitalHistory',
  templateUrl: 'submenus/history/vital_history/vital.html',
  styleUrls: ['submenus/history/vital_history/vital.scss']
})

export class DailogOverviewExampleDailog_vitalHistory {


  dataSource = new MatTableDataSource<vitalListElement>(ELEMENT_DATA);
  displayedColumns: string[] = ['position', 'time', 'weight', 'height', 'bmi', 'head', 'temperature', 'heart',
    'respiratory', 'bp_systolic', 'bp_diastolic', 'spo2', 'glucometer'];

  patient;
  urlPoints;
  getauthdetails;
  dmail;
  token;
  doc_id;
  from_date = ("2022-03-01");
  to_date = ("2022-04-01");
  vitalHistory;
  response: any;
  ELEMENT_DATA;
  vital_data: any;
  startDate = new Date;
  endDate = new Date;
  vital_array = []
  followStatus: false;
  followupstatus: false;
  TodayDate: string;
  vital;
  Vital_history;
  vitalResponseArray = [];
  datasource1 = [];
  vitaltoggle: boolean = false;
  vitallData: boolean = false;
  spinner: boolean = false;
  potchartdataseries: any = [];
  options;
  gulcochartdataseries: any = [];
  accessCode;
  mrNumber_;
  seconds = 20;
  tableData = [];
  dropdowndate = [];
  dates_;
  dropDate;
  



  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,private cdr: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DialogData_bottomdatas, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService,
  ) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;

  }



  ngOnInit(): void {
    this.accessCode = sessionStorage.getItem('accessCode');
    this.mrNumber_ = JSON.parse(sessionStorage.getItem('patientprofile'));
    this.dropdowndatesFun();
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.vitaltoggle = false;
    this.vitalHistory = '';
    // console.log(this.potchartdataseries.length);
    // console.log(this.gulcochartdataseries.length);
    this.GetVitalHistory()
    this.getVitalbpCharts()
    this.getVitalgulcoCharts()
    this.vital_array = [];
  }
getVitallDatas(){
  this.vitallData = !this.vitallData;
  this.dropdowndatesFun();
}
dropdowndatesFun(){
  var params = {
    "pid":this.mrNumber_.mr_number,
    "code":this.accessCode.toLowerCase(),
    "dtype": 0,
    "ddate":0,
    "mode":0
  } 
  this.appService.getDataVitalData(this.urlPoints.dropdowndates, params).subscribe((response: any) => {
    console.log("response::",response)
    this.dropdowndate = [];
    if (response.ivital[0].success == 1) {
      console.log(response.ivital[0].response)
      this.dropdowndate = response.ivital[0].response

      this.dropDate = this.dropdowndate[this.dropdowndate.length - 1].date

      console.log(this.dropDate)
 
      this.vitalAllDatas(this.dropDate, this.dropDate)

      var arr = this.dropDate.split('-')

      var date_str = arr[2] + ' ' + arr[1] + ' ' + arr[0]

      this.startDate = new Date(date_str)

      this.endDate = new Date(date_str)

      for (var i = 0; i < this.dropdowndate.length; i++) {
        var date_arr = this.dropdowndate[i].date.split('-')

        var date_str = date_arr[2] + ' ' + date_arr[1] + ' ' + date_arr[0]

        this.dropdowndate[i].date1 = moment(date_str).format('DD-MMM-YYYY')
      }

      console.log("dropdowndate::::",this.dropdowndate)

    }
    else {
      this.vitalAllDatas(moment(this.startDate).format('DD-MM-YYYY'), moment(this.endDate).format('DD-MM-YYYY'))
    }
  })
}
  // currentDate = new Date();

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }
  onSelectChange(e) {
    console.log(e.target.value)

    this.dropDate = e.target.value

    console.log(this.dropDate)

    this.vitalAllDatas(this.dropDate, this.dropDate)

    var arr = this.dropDate.split('-')

    var date_str = arr[2] + ' ' + arr[1] + ' ' + arr[0]

    this.startDate = new Date(date_str)

    this.endDate = new Date(date_str)

  }
  onDateChange(e: HTMLInputElement) {
    this.followStatus = false;
    this.followupstatus = false;
    this.TodayDate = moment(e.value).format('yyyy-mm-dd');
    this.GetVitalHistory()
    this.getVitalbpCharts()
    this.getVitalgulcoCharts()
  }
  vitallDate(e: HTMLInputElement){
    this.vitalAllDatas(moment(this.startDate).format('DD-MM-YYYY'), moment(this.endDate).format('DD-MM-YYYY'));
  }
  onSelectChange_() {
    this.vitalAllDatas(moment(this.startDate).format('DD-MM-YYYY'), moment(this.endDate).format('DD-MM-YYYY'))
  }
  export() {
    // var fileName = moment(this.startDate).format("DD MMM yyyy") + " to " + moment(this.endDate).format("DD MMM yyyy") + " Report.xlsx"
    // let element = document.getElementById("dataTable");
    // const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    // const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    // XLSX.writeFile(wb, fileName);
  }

vitalAllDatas(start,end){
  this.spinner = true;
  
  console.log("this.seconds::",this.seconds)
  var params = {
    code:this.accessCode.toLowerCase(),
    patientID:this.mrNumber_.mr_number,
    from_date:start,
    to_date:end,
    interval:Number(this.seconds),

  }
 
  this.appService.getDataVitalData(this.urlPoints.getallvitalsdata, params).subscribe((response: any) => {
    console.log("response::",response)
    this.spinner = false;
    this.tableData = [];
    for (var i = 0; i < response.data.length; i++) {
      this.tableData = this.tableData.concat(response.data[i].data)
      console.log("tableData:: 1",this.tableData)
    }
    this.tableData.reverse();
    this.cdr.detectChanges();
  },
);
console.log("tableData::",this.tableData)
}


  slideToggleChange(vital) {
    if (vital == true) {
      this.vitaltoggle = true
      this.getVitalbpCharts()
      this.getVitalgulcoCharts()
    } else {
      this.vitaltoggle = false

    }
  }



  StartDate = new Date(2015, 0, 1);

  EndDate = new Date(2100, 0, 1);

  panelOpenState = false;



  GetVitalHistory() {

    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email,
      from_date: moment(this.startDate).format("YYYY-MM-DD"),
      to_date: moment(this.endDate).format("YYYY-MM-DD")
    }

    this.appService.getData(this.urlPoints.vitalhistory, params, this.token).subscribe((Response: any) => {
      this.vitalHistory = Response.length;
      this.Vital_history = Response;
      ELEMENT_DATA = [];
      // console.log(Response)


      this.vital_array = [];


      for (var i = 0; i < Response.length; i++) {
        this.vitalResponseArray = [];
        for (var j = 0; j < Response[i].data.length; j++) {


          this.vitalResponseArray.push({
            postion: j + 1,
            date: Response[i].date,
            weight: Response[i].data[j].weight,
            height: Response[i].data[j].height,
            bmi: Response[i].data[j].bmi,
            head: Response[i].data[j].head_circumference,
            temperature: Response[i].data[j].temperature,
            heart: Response[i].data[j].heart_rate,
            respiratory: Response[i].data[j].respiratory_rate,
            bp_systolic: Response[i].data[j].bp_systolic,
            bp_diastolic: Response[i].data[j].bp_diastolic,
            spo2: Response[i].data[j].spo2,
            glucometer: Response[i].data[j].glucometer == null ? null : Response[i].data[j].glucometer.mmol_value,
            glucometer_array: Response[i].data[j].glucometer
          });


          // console.log(this.vital_array)
          // console.log(i+1);
        }
        this.datasource1.push(this.vitalResponseArray)
        // console.log(this.datasource1);

      }

      this.dataSource = new MatTableDataSource(this.vital_array)
      this.from_date = this.vitalHistory.from_date;
      this.to_date = this.vitalHistory.to_date;

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });


  }


  getVitalbpCharts() {
    var params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email,
      from_date: moment(this.startDate).format("YYYY-MM-DD"),
      to_date: moment(this.endDate).format("YYYY-MM-DD"),
      is_live: environment.HOST == "https://epicare.net" ? 1 : 0,
      vital: "bp"
    }

    this.appService.postDataIvital(this.urlPoints.vitalCharts, params, this.token).subscribe((response: any) => {
      this.potchartdataseries = response;
      // console.log(response);
      // console.log(response.length);
      // console.log("response",this.potchartdataseries);

      // if(response){
      //   this.potchartdataseries_data = [];
      //   for( var i=0;i<response.length;i++){
      //     for (  var j=0;j<response[i].data.length;j++){
      //       this.potchartdataseries_data.push(response[i].data[j][1])
      //     }
      //   }
      // }

      this.options = {
        chart: {
          type: 'scatter',
          width: 1190,
          height: 400,
          renderTo: 'vitalBpChart',
        },

        accessibility: {
          description: ''
        },

        title: {
          text: 'BP'
        },

        xAxis: {
          title: {
            enabled: true,
            text: 'Time'
          },
          startOnTick: true,
          endOnTick: true,
          showLastLabel: true,
          type: 'datetime',
          labels: {
            formatter: function () {
              //return moment(this.value).format('YYYY-MM-DD HH:mm');
              //return Highcharts.dateFormat("%H:%M %d %b %Y", this.value);
              return Highcharts.dateFormat("%Y-%m-%d %H:%M", this.value);
            }
          },
        },

        yAxis: {
          title: {
            text: 'mmHg'
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          x: 30,
          y: 30,
          //floating: true,
          borderWidth: 1
        },
        credits: {
          enabled: false
        },

        plotOptions: {
          scatter: {
            lineWidth: 0,
            marker: {
              radius: 5,
              states: {
                hover: {
                  enabled: true,
                  lineColor: 'rgb(100,100,100)'
                }
              }
            },

            states: {
              hover: {
                marker: {
                  enabled: false
                }
              }
            },
            tooltip: {
              headerFormat: '<b>{series.name}</b><br>',
              pointFormatter: function () {
                return 'Time : ' + Highcharts.dateFormat('%H:%M', this.x) + ',' + 'mmHg' + ' : ' + this.y
              }
            }
          }
        },
        series: this.potchartdataseries
      }
      // console.log(this.potchartdataseries);

      Highcharts.chart('vitalBpChart', this.options)
      console.log('hello');

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });
  }

  getVitalgulcoCharts() {
    let params = {
      account_email: this.dmail,
      patient_email: this.data.patientDetails.record_info.Record.account_email,
      from_date: moment(this.startDate).format("YYYY-MM-DD"),
      to_date: moment(this.endDate).format("YYYY-MM-DD"),
      is_live: environment.HOST == "https://epicare.net" ? 1 : 0,
      unit_value: "mmol",
      vital: "glucometer"
    }

    this.appService.postDataIvital(this.urlPoints.vitalCharts, params, this.token).subscribe((response: any) => {
      this.gulcochartdataseries = response;
      // console.log(response);
      // console.log(response.length);
      // console.log("response",this.gulcochartdataseries);

      this.options = {
        chart: {
          type: 'scatter',
          //zoomType: 'xy',
          width: 1190,
          height: 400,
          renderTo: 'vitalGulcometerChart',
        },
        accessibility: {
          description: '',
        },
        title: {
          text: 'Gulcometer'
        },
        xAxis: {
          title: {
            enabled: true,
            text: 'Time'
          },
          startOnTick: true,
          endOnTick: true,
          showLastLabel: true,
          type: 'datetime',
          labels: {
            //rotation:-25, 
            formatter: function () {
              //return moment(this.value).format('YYYY-MM-DD HH:mm');
              return Highcharts.dateFormat("%Y-%m-%d %H:%M", this.value);
              //return Highcharts.dateFormat("%H:%M", this.value);
            }
          }
        },
        yAxis: {
          title: {
            text: 'mg/dl'
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          x: 100,
          y: 30,
          //floating: true,
          borderWidth: 1
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          scatter: {
            lineWidth: 2,
            marker: {
              radius: 5,
              states: {
                hover: {
                  enabled: true,
                  lineColor: 'rgb(100,100,100)'
                }
              }
            },
            states: {
              hover: {
                marker: {
                  enabled: false
                }
              }
            },
            tooltip: {
              headerFormat: '<b>{series.name}</b><br>',
              pointFormatter: function () {
                return 'Time : ' + Highcharts.dateFormat('%H:%M', this.x) + ',' + 'mg/dl' + ' : ' + this.y
              }
            }
          }
        },
        series: this.gulcochartdataseries
      }

      Highcharts.chart('vitalGulcometerChart', this.options)

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });
  }

  openGlucometerPopup(getelement) {
    console.log(getelement);
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogvitalGlucometer, {
      width: '600px',
      data: {
        key: getelement
      }
    });

    dialogRef.afterClosed().subscribe();
  }

}

@Component({
  selector: 'vitalGlucometer',
  templateUrl: 'vitalGlucometer.html',
  styleUrls: ['vitalGlucometer.scss']
})
export class DialogOverviewExampleDialogvitalGlucometer {
  urlPoints: any;
  getauthdetails: any;
  dmail: any;
  token: any;
  doc_id: any;
  patientprofile: any;
  glucometer: any = [];
  glucometer_injection: any = [];
  glucometer_pills: any = [];

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialogvitalGlucometer>,
    @Inject(MAT_DIALOG_DATA) public data: vitalGlucometeData, public fb: FormBuilder, private appService: AppService, private toastr: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private router: Router) {
    this.urlPoints = AppConfig.settings.EndPoints;
    this.getauthdetails = JSON.parse(sessionStorage.getItem("authDetails"));
    this.dmail = this.getauthdetails.account_id;
    this.doc_id = this.getauthdetails.doctor_id;
    this.token = this.getauthdetails.token;
    this.patientprofile = JSON.parse(sessionStorage.getItem("patientprofile"));
  }

  ngOnInit(): void {
    console.log(this.data);
    // this.vitalGlucometer();
    this.vitalInjection();
    this.vitalPills();
    this.glucometer = this.data
    // console.log(this.glucometer);
  }

  closepopuppicture() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }




  vitalPills() {
    for (var i = 0; i < this.data.key.pills.length; i++) {
      this.glucometer_pills.push({
        position: i + 1,
        namepills: this.data.key.pills == null ? null : this.data.key.pills[i].name,
        strengthpills: this.data.key.pills == null ? null : this.data.key.pills[i].strength
      });
    }
  }

  vitalInjection() {
    for (var i = 0; i < this.data.key.injection.length; i++) {
      this.glucometer_injection.push({
        position: i + 1,
        nameInjection: this.data.key.injection == null ? null : this.data.key.injection[i].name,
        strengthInjection: this.data.key.injection == null ? null : this.data.key.injection[i].strength
      });
    }
  }
  // vitalGlucometer(){

  //   for(var i=0;i<this.data.key.length;i++){
  //     for(var j=0;j<this.data.key[i].data.length;j++){
  //       // for(var k=0;k<this.data.key[i].data[j].inje)

  //       this.glucometer.push({
  //         // position: j+1,
  //         // namepills: this.data.key[i].data[j].glucometer.pills == null?null:this.data.key[i].data[j].glucometer.pills[j].name,
  //         // strengthpills: this.data.key[i].data[j].glucometer.pills == null?null:this.data.key[i].data[j].glucometer.pills[j].strength,
  //         // nameinjection: this.data.key[i].data[j].glucometer.Injection == null?null:this.data.key[i].data[j].glucometer.Injection[j].name,
  //         // strengthinjection: this.data.key[i].data[j].glucometer.Injection == null?null:this.data.key[i].data[j].glucometer.Injection[j].strength
  //       });
  //     }
  //   }


  // }

}

@Component({
  selector: 'social',
  templateUrl: 'submenus/history/social/social.html',
  styleUrls: ['submenus/history/social/social.scss']
})

export class DialogOverviewExampleDialog_social {

  urlPoints;
  questionData;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService) {
    this.urlPoints = AppConfig.settings.EndPoints;


  }



  ngOnInit(): void {
    var questionParams = {
      patient_email: this.data.email,
      account_email: this.data.dmail,
      category: 'social_personal_history'
    }

    this.appService.getData(this.urlPoints.getHealthSurveyPatient, questionParams, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.questionData = response.data
      console.log(this.questionData)

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

}

@Component({
  selector: 'family',
  templateUrl: 'submenus/history/family/family.html',
  styleUrls: ['submenus/history/family/family.scss']
})

export class DialogOverviewExampleDialog_family {

  urlPoints;
  questionData;
  answerData;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_bottomwindow>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService) {
    this.urlPoints = AppConfig.settings.EndPoints;


  }



  ngOnInit(): void {
    var questionParams = {
      patient_email: this.data.email,
      account_email: this.data.dmail,
      category: 'family_medical_history'
    }

    this.appService.getData(this.urlPoints.getHealthSurveyPatient, questionParams, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.questionData = response.data[0].options
      this.answerData = response.data[0].answer

      console.log(this.answerData)

      for(var i=0;i<this.questionData.length;i++)
      {
        this.questionData[i].answer = 'No'

        if(this.answerData.includes(this.questionData[i].checkbox_title))
        {
          this.questionData[i].answer = 'Yes'

        }
      }

      console.log(this.questionData)

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

}

//DialogOverviewExampleDialog_threshold

@Component({
  selector: 'threshold',
  templateUrl: 'submenus/history/threshold/threshold.html',
  styleUrls: ['submenus/history/threshold/threshold.scss']
})

export class DialogOverviewExampleDialog_threshold {

  urlPoints;
  questionData;
  answerData;

  constructor(
    private fb: FormBuilder, public _bottomSheetRef: MatBottomSheetRef<DialogOverviewExampleDialog_threshold>, public dialog: MatDialog, private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public router: Router, private appService: AppService, public snackBar: MatSnackBar, private toastr: ToastrService) {
    this.urlPoints = AppConfig.settings.EndPoints;


  }



  ngOnInit(): void {
    var questionParams = {
      patient_email: this.data.email,
      account_email: this.data.dmail,
      category: 'family_medical_history'
    }

    this.appService.getData(this.urlPoints.getHealthSurveyPatient, questionParams, this.data.token).subscribe((response: any) => {
      console.log(response)
      this.questionData = response.data[0].options
      this.answerData = response.data[0].answer

      console.log(this.answerData)

      for(var i=0;i<this.questionData.length;i++)
      {
        this.questionData[i].answer = 'No'

        if(this.answerData.includes(this.questionData[i].checkbox_title))
        {
          this.questionData[i].answer = 'Yes'

        }
      }

      console.log(this.questionData)

      setTimeout(() => {
        this._changeDetectorRef.markForCheck();
      }, 500);
    });
  }

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

}